/*! dprd-semantic-analytics-framework - 5.6.8 - 2026-08-12 */
(function (window, document, location, undefined) {
  function namespace(path, defaultFinalValue = {}, base = this || window) {
    var i, prop;
    while ((i = path.indexOf('.')) > -1) {
      prop = path.substr(0, i);
      base = base[prop] || (base[prop] = {});
      path = path.substr(i + 1);
    }
    return path in base ? base[path] : base[path] = defaultFinalValue;
  }
  var Analytics = namespace('WDPRO.Analytics'); //eslint-disable-line no-unused-vars

  /* global Analytics, namespace */
  var inject = namespace('inject', function () {
    var resolutions = {};
    injectFn.resolve = store('resolve', resolve);
    injectFn.store = store('store', store);
    store('ref', ref);
    return injectFn;
    function injectFn(fn, ...injectables) {
      return fn.apply(this, injectables.map(resolve));
    }
    function resolve(str) {
      if (typeof str !== 'string') {
        return str;
      }
      return isStored(str) ? retrieve(str) : store(str, ref(str));
    }
    function key(str) {
      return str.toLowerCase();
    }
    function isStored(str) {
      return key(str) in resolutions;
    }
    function retrieve(str) {
      return resolutions[key(str)];
    }
    function store(/*...aliases, value*/
    ) {
      var aliases = Array.prototype.concat.apply([], Array.prototype.slice.call(arguments, 0, -1)),
        value = arguments[arguments.length - 1];
      if (value !== undefined) {
        aliases.forEach(alias => {
          if (typeof alias === 'string') {
            resolutions[key(alias)] = value;
          }
        });
      }
      return value;
    }
    function ref(path, base) {
      var i = path.indexOf('.');
      base = base || this || window;
      return i === -1 ? base[path] : (base = base[path.substr(0, i)]) && ref(path.substr(i + 1), base);
    }
  }(), Analytics);
  inject.store('namespace', namespace);
  inject.store('Analytics', Analytics);
  inject.store('Framework', namespace('Framework', {}, Analytics));

  /*
   * jQuery JavaScript Library v1.7.2
   * http://jquery.com/
   *
   * Copyright 2011, John Resig
   * Dual licensed under the MIT or GPL Version 2 licenses.
   * http://jquery.org/license
   *
   * Includes Sizzle.js
   * http://sizzlejs.com/
   * Copyright 2011, The Dojo Foundation
   * Released under the MIT, BSD, and GPL Licenses.
   *
   * Date: Wed Mar 21 12:46:34 2012 -0700
   */
  (function (e, t) {
    function n(e) {
      var t,
        n,
        r = H[e] = {};
      for (e = e.split(/\s+/), t = 0, n = e.length; n > t; t++) r[e[t]] = !0;
      return r;
    }
    function r(e, n, r) {
      if (r === t && 1 === e.nodeType) {
        var i = "data-" + n.replace(q, "-$1").toLowerCase();
        if (r = e.getAttribute(i), "string" == typeof r) {
          try {
            r = "true" === r ? !0 : "false" === r ? !1 : "null" === r ? null : O.isNumeric(r) ? +r : B.test(r) ? O.parseJSON(r) : r;
          } catch (o) {}
          O.data(e, n, r);
        } else r = t;
      }
      return r;
    }
    function i(e) {
      for (var t in e) if (("data" !== t || !O.isEmptyObject(e[t])) && "toJSON" !== t) return !1;
      return !0;
    }
    function o(e, t, n) {
      var r = t + "defer",
        i = t + "queue",
        o = t + "mark",
        a = O._data(e, r);
      !a || "queue" !== n && O._data(e, i) || "mark" !== n && O._data(e, o) || setTimeout(function () {
        O._data(e, i) || O._data(e, o) || (O.removeData(e, r, !0), a.fire());
      }, 0);
    }
    function a() {
      return !1;
    }
    function s() {
      return !0;
    }
    function l(e) {
      return !e || !e.parentNode || 11 === e.parentNode.nodeType;
    }
    function u(e, t, n) {
      if (t = t || 0, O.isFunction(t)) return O.grep(e, function (e, r) {
        var i = !!t.call(e, r, e);
        return i === n;
      });
      if (t.nodeType) return O.grep(e, function (e) {
        return e === t === n;
      });
      if ("string" == typeof t) {
        var r = O.grep(e, function (e) {
          return 1 === e.nodeType;
        });
        if (ct.test(t)) return O.filter(t, r, !n);
        t = O.filter(t, r);
      }
      return O.grep(e, function (e) {
        return O.inArray(e, t) >= 0 === n;
      });
    }
    function c(e) {
      var t = ht.split("|"),
        n = e.createDocumentFragment();
      if (n.createElement) for (; t.length;) n.createElement(t.pop());
      return n;
    }
    function f(e) {
      return O.nodeName(e, "table") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e;
    }
    function d(e, t) {
      if (1 === t.nodeType && O.hasData(e)) {
        var n,
          r,
          i,
          o = O._data(e),
          a = O._data(t, o),
          s = o.events;
        if (s) {
          delete a.handle, a.events = {};
          for (n in s) for (r = 0, i = s[n].length; i > r; r++) O.event.add(t, n, s[n][r]);
        }
        a.data && (a.data = O.extend({}, a.data));
      }
    }
    function p(e, t) {
      var n;
      1 === t.nodeType && (t.clearAttributes && t.clearAttributes(), t.mergeAttributes && t.mergeAttributes(e), n = t.nodeName.toLowerCase(), "object" === n ? t.outerHTML = e.outerHTML : "input" !== n || "checkbox" !== e.type && "radio" !== e.type ? "option" === n ? t.selected = e.defaultSelected : "input" === n || "textarea" === n ? t.defaultValue = e.defaultValue : "script" === n && t.text !== e.text && (t.text = e.text) : (e.checked && (t.defaultChecked = t.checked = e.checked), t.value !== e.value && (t.value = e.value)), t.removeAttribute(O.expando), t.removeAttribute("_submit_attached"), t.removeAttribute("_change_attached"));
    }
    function h(e) {
      return t !== e.getElementsByTagName ? e.getElementsByTagName("*") : t !== e.querySelectorAll ? e.querySelectorAll("*") : [];
    }
    function m(e) {
      ("checkbox" === e.type || "radio" === e.type) && (e.defaultChecked = e.checked);
    }
    function g(e) {
      var n = (e.nodeName || "").toLowerCase();
      "input" === n ? m(e) : "script" !== n && t !== e.getElementsByTagName && O.grep(e.getElementsByTagName("input"), m);
    }
    function y(e) {
      var t = j.createElement("div");
      return At.appendChild(t), t.innerHTML = e.outerHTML, t.firstChild;
    }
    function v(e, t, n) {
      var r = "width" === t ? e.offsetWidth : e.offsetHeight,
        i = "width" === t ? 1 : 0,
        o = 4;
      if (r > 0) {
        if ("border" !== n) for (; o > i; i += 2) n || (r -= parseFloat(O.css(e, "padding" + Wt[i])) || 0), "margin" === n ? r += parseFloat(O.css(e, n + Wt[i])) || 0 : r -= parseFloat(O.css(e, "border" + Wt[i] + "Width")) || 0;
        return r + "px";
      }
      if (r = Lt(e, t), (0 > r || null == r) && (r = e.style[t]), Ht.test(r)) return r;
      if (r = parseFloat(r) || 0, n) for (; o > i; i += 2) r += parseFloat(O.css(e, "padding" + Wt[i])) || 0, "padding" !== n && (r += parseFloat(O.css(e, "border" + Wt[i] + "Width")) || 0), "margin" === n && (r += parseFloat(O.css(e, n + Wt[i])) || 0);
      return r + "px";
    }
    function b(e) {
      return function (t, n) {
        if ("string" != typeof t && (n = t, t = "*"), O.isFunction(n)) for (var r, i, o, a = t.toLowerCase().split(tn), s = 0, l = a.length; l > s; s++) r = a[s], o = /^\+/.test(r), o && (r = r.substr(1) || "*"), i = e[r] = e[r] || [], i[o ? "unshift" : "push"](n);
      };
    }
    function x(e, n, r, i, o, a) {
      o = o || n.dataTypes[0], a = a || {}, a[o] = !0;
      for (var s, l = e[o], u = 0, c = l ? l.length : 0, f = e === an; c > u && (f || !s); u++) s = l[u](n, r, i), "string" == typeof s && (!f || a[s] ? s = t : (n.dataTypes.unshift(s), s = x(e, n, r, i, s, a)));
      return !f && s || a["*"] || (s = x(e, n, r, i, "*", a)), s;
    }
    function T(e, n) {
      var r,
        i,
        o = O.ajaxSettings.flatOptions || {};
      for (r in n) n[r] !== t && ((o[r] ? e : i || (i = {}))[r] = n[r]);
      i && O.extend(!0, e, i);
    }
    function w(e, t, n, r) {
      if (O.isArray(t)) O.each(t, function (t, i) {
        n || Xt.test(e) ? r(e, i) : w(e + "[" + ("object" == typeof i ? t : "") + "]", i, n, r);
      });else if (n || "object" !== O.type(t)) r(e, t);else for (var i in t) w(e + "[" + i + "]", t[i], n, r);
    }
    function N(e, n, r) {
      var i,
        o,
        a,
        s,
        l = e.contents,
        u = e.dataTypes,
        c = e.responseFields;
      for (o in c) o in r && (n[c[o]] = r[o]);
      for (; "*" === u[0];) u.shift(), i === t && (i = e.mimeType || n.getResponseHeader("content-type"));
      if (i) for (o in l) if (l[o] && l[o].test(i)) {
        u.unshift(o);
        break;
      }
      if (u[0] in r) a = u[0];else {
        for (o in r) {
          if (!u[0] || e.converters[o + " " + u[0]]) {
            a = o;
            break;
          }
          s || (s = o);
        }
        a = a || s;
      }
      return a ? (a !== u[0] && u.unshift(a), r[a]) : t;
    }
    function C(e, n) {
      e.dataFilter && (n = e.dataFilter(n, e.dataType));
      var r,
        i,
        o,
        a,
        s,
        l,
        u,
        c,
        f = e.dataTypes,
        d = {},
        p = f.length,
        h = f[0];
      for (r = 1; p > r; r++) {
        if (1 === r) for (i in e.converters) "string" == typeof i && (d[i.toLowerCase()] = e.converters[i]);
        if (a = h, h = f[r], "*" === h) h = a;else if ("*" !== a && a !== h) {
          if (s = a + " " + h, l = d[s] || d["* " + h], !l) {
            c = t;
            for (u in d) if (o = u.split(" "), (o[0] === a || "*" === o[0]) && (c = d[o[1] + " " + h])) {
              u = d[u], u === !0 ? l = c : c === !0 && (l = u);
              break;
            }
          }
          l || c || O.error("No conversion from " + s.replace(" ", " to ")), l !== !0 && (n = l ? l(n) : c(u(n)));
        }
      }
      return n;
    }
    function E() {
      try {
        return new e.XMLHttpRequest();
      } catch (t) {}
    }
    function k() {
      try {
        return new e.ActiveXObject("Microsoft.XMLHTTP");
      } catch (t) {}
    }
    function S() {
      return setTimeout(A, 0), vn = O.now();
    }
    function A() {
      vn = t;
    }
    function L(e, t) {
      var n = {};
      return O.each(wn.concat.apply([], wn.slice(0, t)), function () {
        n[this] = e;
      }), n;
    }
    function D(e) {
      if (!bn[e]) {
        var t = j.body,
          n = O("<" + e + ">").appendTo(t),
          r = n.css("display");
        n.remove(), ("none" === r || "" === r) && (mn || (mn = j.createElement("iframe"), mn.frameBorder = mn.width = mn.height = 0), t.appendChild(mn), gn && mn.createElement || (gn = (mn.contentWindow || mn.contentDocument).document, gn.write((O.support.boxModel ? "<!doctype html>" : "") + "<html><body>"), gn.close()), n = gn.createElement(e), gn.body.appendChild(n), r = O.css(n, "display"), t.removeChild(mn)), bn[e] = r;
      }
      return bn[e];
    }
    function F(e) {
      return O.isWindow(e) ? e : 9 === e.nodeType ? e.defaultView || e.parentWindow : !1;
    }
    var j = e.document,
      M = e.navigator,
      _ = e.location,
      O = function () {
        function n() {
          if (!s.isReady) {
            try {
              j.documentElement.doScroll("left");
            } catch (e) {
              return setTimeout(n, 1), t;
            }
            s.ready();
          }
        }
        var r,
          i,
          o,
          a,
          s = function (e, t) {
            return new s.fn.init(e, t, r);
          },
          l = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/,
          u = /\S/,
          c = /^\s+/,
          f = /\s+$/,
          d = /^<(\w+)\s*\/?>(?:<\/\1>)?$/,
          p = /^[\],:{}\s]*$/,
          h = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
          m = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
          g = /(?:^|:|,)(?:\s*\[)+/g,
          y = /(webkit)[ \/]([\w.]+)/,
          v = /(opera)(?:.*version)?[ \/]([\w.]+)/,
          b = /(msie) ([\w.]+)/,
          x = /(mozilla)(?:.*? rv:([\w.]+))?/,
          T = /-([a-z]|[0-9])/gi,
          w = /^-ms-/,
          N = function (e, t) {
            return (t + "").toUpperCase();
          },
          C = M.userAgent,
          E = Object.prototype.toString,
          k = Object.prototype.hasOwnProperty,
          S = Array.prototype.push,
          A = Array.prototype.slice,
          L = String.prototype.trim,
          D = Array.prototype.indexOf,
          F = {};
        return s.fn = s.prototype = {
          constructor: s,
          init: function (e, n, r) {
            var i, o, a, u;
            if (!e) return this;
            if (e.nodeType) return this.context = this[0] = e, this.length = 1, this;
            if ("body" === e && !n && j.body) return this.context = j, this[0] = j.body, this.selector = e, this.length = 1, this;
            if ("string" == typeof e) {
              if (i = "<" !== e.charAt(0) || ">" !== e.charAt(e.length - 1) || e.length < 3 ? l.exec(e) : [null, e, null], !i || !i[1] && n) return !n || n.jquery ? (n || r).find(e) : this.constructor(n).find(e);
              if (i[1]) return n = n instanceof s ? n[0] : n, u = n ? n.ownerDocument || n : j, a = d.exec(e), a ? s.isPlainObject(n) ? (e = [j.createElement(a[1])], s.fn.attr.call(e, n, !0)) : e = [u.createElement(a[1])] : (a = s.buildFragment([i[1]], [u]), e = (a.cacheable ? s.clone(a.fragment) : a.fragment).childNodes), s.merge(this, e);
              if (o = j.getElementById(i[2]), o && o.parentNode) {
                if (o.id !== i[2]) return r.find(e);
                this.length = 1, this[0] = o;
              }
              return this.context = j, this.selector = e, this;
            }
            return s.isFunction(e) ? r.ready(e) : (e.selector !== t && (this.selector = e.selector, this.context = e.context), s.makeArray(e, this));
          },
          selector: "",
          jquery: "1.7.2",
          length: 0,
          size: function () {
            return this.length;
          },
          toArray: function () {
            return A.call(this, 0);
          },
          get: function (e) {
            return null == e ? this.toArray() : 0 > e ? this[this.length + e] : this[e];
          },
          pushStack: function (e, t, n) {
            var r = this.constructor();
            return s.isArray(e) ? S.apply(r, e) : s.merge(r, e), r.prevObject = this, r.context = this.context, "find" === t ? r.selector = this.selector + (this.selector ? " " : "") + n : t && (r.selector = this.selector + "." + t + "(" + n + ")"), r;
          },
          each: function (e, t) {
            return s.each(this, e, t);
          },
          ready: function (e) {
            return s.bindReady(), o.add(e), this;
          },
          eq: function (e) {
            return e = +e, -1 === e ? this.slice(e) : this.slice(e, e + 1);
          },
          first: function () {
            return this.eq(0);
          },
          last: function () {
            return this.eq(-1);
          },
          slice: function () {
            return this.pushStack(A.apply(this, arguments), "slice", A.call(arguments).join(","));
          },
          map: function (e) {
            return this.pushStack(s.map(this, function (t, n) {
              return e.call(t, n, t);
            }));
          },
          end: function () {
            return this.prevObject || this.constructor(null);
          },
          push: S,
          sort: [].sort,
          splice: [].splice
        }, s.fn.init.prototype = s.fn, s.extend = s.fn.extend = function () {
          var e,
            n,
            r,
            i,
            o,
            a,
            l = arguments[0] || {},
            u = 1,
            c = arguments.length,
            f = !1;
          for ("boolean" == typeof l && (f = l, l = arguments[1] || {}, u = 2), "object" == typeof l || s.isFunction(l) || (l = {}), c === u && (l = this, --u); c > u; u++) if (null != (e = arguments[u])) for (n in e) r = l[n], i = e[n], l !== i && (f && i && (s.isPlainObject(i) || (o = s.isArray(i))) ? (o ? (o = !1, a = r && s.isArray(r) ? r : []) : a = r && s.isPlainObject(r) ? r : {}, l[n] = s.extend(f, a, i)) : i !== t && (l[n] = i));
          return l;
        }, s.extend({
          noConflict: function () {
            return s;
          },
          isReady: !1,
          readyWait: 1,
          holdReady: function (e) {
            e ? s.readyWait++ : s.ready(!0);
          },
          ready: function (e) {
            if (e === !0 && ! --s.readyWait || e !== !0 && !s.isReady) {
              if (!j.body) return setTimeout(s.ready, 1);
              if (s.isReady = !0, e !== !0 && --s.readyWait > 0) return;
              o.fireWith(j, [s]), s.fn.trigger && s(j).trigger("ready").off("ready");
            }
          },
          bindReady: function () {
            if (!o) {
              if (o = s.Callbacks("once memory"), "complete" === j.readyState) return setTimeout(s.ready, 1);
              if (j.addEventListener) j.addEventListener("DOMContentLoaded", a, !1), e.addEventListener("load", s.ready, !1);else if (j.attachEvent) {
                j.attachEvent("onreadystatechange", a), e.attachEvent("onload", s.ready);
                var t = !1;
                try {
                  t = null == e.frameElement;
                } catch (r) {}
                j.documentElement.doScroll && t && n();
              }
            }
          },
          isFunction: function (e) {
            return "function" === s.type(e);
          },
          isArray: Array.isArray || function (e) {
            return "array" === s.type(e);
          },
          isWindow: function (e) {
            return null != e && e == e.window;
          },
          isNumeric: function (e) {
            return !isNaN(parseFloat(e)) && isFinite(e);
          },
          type: function (e) {
            return null == e ? e + "" : F[E.call(e)] || "object";
          },
          isPlainObject: function (e) {
            if (!e || "object" !== s.type(e) || e.nodeType || s.isWindow(e)) return !1;
            try {
              if (e.constructor && !k.call(e, "constructor") && !k.call(e.constructor.prototype, "isPrototypeOf")) return !1;
            } catch (n) {
              return !1;
            }
            var r;
            for (r in e);
            return r === t || k.call(e, r);
          },
          isEmptyObject: function (e) {
            for (var t in e) return !1;
            return !0;
          },
          error: function (e) {
            throw Error(e);
          },
          parseJSON: function (n) {
            return "string" == typeof n && n ? (n = s.trim(n), e.JSON && e.JSON.parse ? e.JSON.parse(n) : p.test(n.replace(h, "@").replace(m, "]").replace(g, "")) ? Function("return " + n)() : (s.error("Invalid JSON: " + n), t)) : null;
          },
          parseXML: function (n) {
            if ("string" != typeof n || !n) return null;
            var r, i;
            try {
              e.DOMParser ? (i = new DOMParser(), r = i.parseFromString(n, "text/xml")) : (r = new ActiveXObject("Microsoft.XMLDOM"), r.async = "false", r.loadXML(n));
            } catch (o) {
              r = t;
            }
            return r && r.documentElement && !r.getElementsByTagName("parsererror").length || s.error("Invalid XML: " + n), r;
          },
          noop: function () {},
          globalEval: function (t) {
            t && u.test(t) && (e.execScript || function (t) {
              e.eval.call(e, t);
            })(t);
          },
          camelCase: function (e) {
            return e.replace(w, "ms-").replace(T, N);
          },
          nodeName: function (e, t) {
            return e.nodeName && e.nodeName.toUpperCase() === t.toUpperCase();
          },
          each: function (e, n, r) {
            var i,
              o = 0,
              a = e.length,
              l = a === t || s.isFunction(e);
            if (r) {
              if (l) {
                for (i in e) if (n.apply(e[i], r) === !1) break;
              } else for (; a > o && n.apply(e[o++], r) !== !1;);
            } else if (l) {
              for (i in e) if (n.call(e[i], i, e[i]) === !1) break;
            } else for (; a > o && n.call(e[o], o, e[o++]) !== !1;);
            return e;
          },
          trim: L ? function (e) {
            return null == e ? "" : L.call(e);
          } : function (e) {
            return null == e ? "" : ("" + e).replace(c, "").replace(f, "");
          },
          makeArray: function (e, t) {
            var n = t || [];
            if (null != e) {
              var r = s.type(e);
              null == e.length || "string" === r || "function" === r || "regexp" === r || s.isWindow(e) ? S.call(n, e) : s.merge(n, e);
            }
            return n;
          },
          inArray: function (e, t, n) {
            var r;
            if (t) {
              if (D) return D.call(t, e, n);
              for (r = t.length, n = n ? 0 > n ? Math.max(0, r + n) : n : 0; r > n; n++) if (n in t && t[n] === e) return n;
            }
            return -1;
          },
          merge: function (e, n) {
            var r = e.length,
              i = 0;
            if ("number" == typeof n.length) for (var o = n.length; o > i; i++) e[r++] = n[i];else for (; n[i] !== t;) e[r++] = n[i++];
            return e.length = r, e;
          },
          grep: function (e, t, n) {
            var r,
              i = [];
            n = !!n;
            for (var o = 0, a = e.length; a > o; o++) r = !!t(e[o], o), n !== r && i.push(e[o]);
            return i;
          },
          map: function (e, n, r) {
            var i,
              o,
              a = [],
              l = 0,
              u = e.length,
              c = e instanceof s || u !== t && "number" == typeof u && (u > 0 && e[0] && e[u - 1] || 0 === u || s.isArray(e));
            if (c) for (; u > l; l++) i = n(e[l], l, r), null != i && (a[a.length] = i);else for (o in e) i = n(e[o], o, r), null != i && (a[a.length] = i);
            return a.concat.apply([], a);
          },
          guid: 1,
          proxy: function (e, n) {
            if ("string" == typeof n) {
              var r = e[n];
              n = e, e = r;
            }
            if (!s.isFunction(e)) return t;
            var i = A.call(arguments, 2),
              o = function () {
                return e.apply(n, i.concat(A.call(arguments)));
              };
            return o.guid = e.guid = e.guid || o.guid || s.guid++, o;
          },
          access: function (e, n, r, i, o, a, l) {
            var u,
              c = null == r,
              f = 0,
              d = e.length;
            if (r && "object" == typeof r) {
              for (f in r) s.access(e, n, f, r[f], 1, a, i);
              o = 1;
            } else if (i !== t) {
              if (u = l === t && s.isFunction(i), c && (u ? (u = n, n = function (e, t, n) {
                return u.call(s(e), n);
              }) : (n.call(e, i), n = null)), n) for (; d > f; f++) n(e[f], r, u ? i.call(e[f], f, n(e[f], r)) : i, l);
              o = 1;
            }
            return o ? e : c ? n.call(e) : d ? n(e[0], r) : a;
          },
          now: function () {
            return new Date().getTime();
          },
          uaMatch: function (e) {
            e = e.toLowerCase();
            var t = y.exec(e) || v.exec(e) || b.exec(e) || e.indexOf("compatible") < 0 && x.exec(e) || [];
            return {
              browser: t[1] || "",
              version: t[2] || "0"
            };
          },
          sub: function () {
            function e(t, n) {
              return new e.fn.init(t, n);
            }
            s.extend(!0, e, this), e.superclass = this, e.fn = e.prototype = this(), e.fn.constructor = e, e.sub = this.sub, e.fn.init = function (n, r) {
              return r && r instanceof s && !(r instanceof e) && (r = e(r)), s.fn.init.call(this, n, r, t);
            }, e.fn.init.prototype = e.fn;
            var t = e(j);
            return e;
          },
          browser: {}
        }), s.each("Boolean Number String Function Array Date RegExp Object".split(" "), function (e, t) {
          F["[object " + t + "]"] = t.toLowerCase();
        }), i = s.uaMatch(C), i.browser && (s.browser[i.browser] = !0, s.browser.version = i.version), s.browser.webkit && (s.browser.safari = !0), u.test(" ") && (c = /^[\s\xA0]+/, f = /[\s\xA0]+$/), r = s(j), j.addEventListener ? a = function () {
          j.removeEventListener("DOMContentLoaded", a, !1), s.ready();
        } : j.attachEvent && (a = function () {
          "complete" === j.readyState && (j.detachEvent("onreadystatechange", a), s.ready());
        }), s;
      }(),
      H = {};
    O.Callbacks = function (e) {
      e = e ? H[e] || n(e) : {};
      var r,
        i,
        o,
        a,
        s,
        l,
        u = [],
        c = [],
        f = function (t) {
          var n, r, i, o;
          for (n = 0, r = t.length; r > n; n++) i = t[n], o = O.type(i), "array" === o ? f(i) : "function" === o && (e.unique && p.has(i) || u.push(i));
        },
        d = function (t, n) {
          for (n = n || [], r = !e.memory || [t, n], i = !0, o = !0, l = a || 0, a = 0, s = u.length; u && s > l; l++) if (u[l].apply(t, n) === !1 && e.stopOnFalse) {
            r = !0;
            break;
          }
          o = !1, u && (e.once ? r === !0 ? p.disable() : u = [] : c && c.length && (r = c.shift(), p.fireWith(r[0], r[1])));
        },
        p = {
          add: function () {
            if (u) {
              var e = u.length;
              f(arguments), o ? s = u.length : r && r !== !0 && (a = e, d(r[0], r[1]));
            }
            return this;
          },
          remove: function () {
            if (u) for (var t = arguments, n = 0, r = t.length; r > n; n++) for (var i = 0; i < u.length && (t[n] !== u[i] || (o && (i > s || (s--, i > l || l--)), u.splice(i--, 1), !e.unique)); i++);
            return this;
          },
          has: function (e) {
            if (u) for (var t = 0, n = u.length; n > t; t++) if (e === u[t]) return !0;
            return !1;
          },
          empty: function () {
            return u = [], this;
          },
          disable: function () {
            return u = c = r = t, this;
          },
          disabled: function () {
            return !u;
          },
          lock: function () {
            return c = t, r && r !== !0 || p.disable(), this;
          },
          locked: function () {
            return !c;
          },
          fireWith: function (t, n) {
            return c && (o ? e.once || c.push([t, n]) : e.once && r || d(t, n)), this;
          },
          fire: function () {
            return p.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!i;
          }
        };
      return p;
    };
    var P = [].slice;
    O.extend({
      Deferred: function (e) {
        var t,
          n = O.Callbacks("once memory"),
          r = O.Callbacks("once memory"),
          i = O.Callbacks("memory"),
          o = "pending",
          a = {
            resolve: n,
            reject: r,
            notify: i
          },
          s = {
            done: n.add,
            fail: r.add,
            progress: i.add,
            state: function () {
              return o;
            },
            isResolved: n.fired,
            isRejected: r.fired,
            then: function (e, t, n) {
              return l.done(e).fail(t).progress(n), this;
            },
            always: function () {
              return l.done.apply(l, arguments).fail.apply(l, arguments), this;
            },
            pipe: function (e, t, n) {
              return O.Deferred(function (r) {
                O.each({
                  done: [e, "resolve"],
                  fail: [t, "reject"],
                  progress: [n, "notify"]
                }, function (e, t) {
                  var n,
                    i = t[0],
                    o = t[1];
                  l[e](O.isFunction(i) ? function () {
                    n = i.apply(this, arguments), n && O.isFunction(n.promise) ? n.promise().then(r.resolve, r.reject, r.notify) : r[o + "With"](this === l ? r : this, [n]);
                  } : r[o]);
                });
              }).promise();
            },
            promise: function (e) {
              if (null == e) e = s;else for (var t in s) e[t] = s[t];
              return e;
            }
          },
          l = s.promise({});
        for (t in a) l[t] = a[t].fire, l[t + "With"] = a[t].fireWith;
        return l.done(function () {
          o = "resolved";
        }, r.disable, i.lock).fail(function () {
          o = "rejected";
        }, n.disable, i.lock), e && e.call(l, l), l;
      },
      when: function (e) {
        function t(e) {
          return function (t) {
            r[e] = arguments.length > 1 ? P.call(arguments, 0) : t, --s || l.resolveWith(l, r);
          };
        }
        function n(e) {
          return function (t) {
            a[e] = arguments.length > 1 ? P.call(arguments, 0) : t, l.notifyWith(u, a);
          };
        }
        var r = P.call(arguments, 0),
          i = 0,
          o = r.length,
          a = Array(o),
          s = o,
          l = 1 >= o && e && O.isFunction(e.promise) ? e : O.Deferred(),
          u = l.promise();
        if (o > 1) {
          for (; o > i; i++) r[i] && r[i].promise && O.isFunction(r[i].promise) ? r[i].promise().then(t(i), l.reject, n(i)) : --s;
          s || l.resolveWith(l, r);
        } else l !== e && l.resolveWith(l, o ? [e] : []);
        return u;
      }
    }), O.support = function () {
      {
        var n,
          r,
          i,
          o,
          a,
          s,
          l,
          u,
          c,
          f,
          d,
          p = j.createElement("div");
        j.documentElement;
      }
      if (p.setAttribute("className", "t"), p.innerHTML = "   <link/><table></table><a href='/a' style='top:1px;float:left;opacity:.55;'>a</a><input type='checkbox'/>", r = p.getElementsByTagName("*"), i = p.getElementsByTagName("a")[0], !r || !r.length || !i) return {};
      o = j.createElement("select"), a = o.appendChild(j.createElement("option")), s = p.getElementsByTagName("input")[0], n = {
        leadingWhitespace: 3 === p.firstChild.nodeType,
        tbody: !p.getElementsByTagName("tbody").length,
        htmlSerialize: !!p.getElementsByTagName("link").length,
        style: /top/.test(i.getAttribute("style")),
        hrefNormalized: "/a" === i.getAttribute("href"),
        opacity: /^0.55/.test(i.style.opacity),
        cssFloat: !!i.style.cssFloat,
        checkOn: "on" === s.value,
        optSelected: a.selected,
        getSetAttribute: "t" !== p.className,
        enctype: !!j.createElement("form").enctype,
        html5Clone: "<:nav></:nav>" !== j.createElement("nav").cloneNode(!0).outerHTML,
        submitBubbles: !0,
        changeBubbles: !0,
        focusinBubbles: !1,
        deleteExpando: !0,
        noCloneEvent: !0,
        inlineBlockNeedsLayout: !1,
        shrinkWrapBlocks: !1,
        reliableMarginRight: !0,
        pixelMargin: !0
      }, O.boxModel = n.boxModel = "CSS1Compat" === j.compatMode, s.checked = !0, n.noCloneChecked = s.cloneNode(!0).checked, o.disabled = !0, n.optDisabled = !a.disabled;
      try {
        delete p.test;
      } catch (h) {
        n.deleteExpando = !1;
      }
      if (!p.addEventListener && p.attachEvent && p.fireEvent && (p.attachEvent("onclick", function () {
        n.noCloneEvent = !1;
      }), p.cloneNode(!0).fireEvent("onclick")), s = j.createElement("input"), s.value = "t", s.setAttribute("type", "radio"), n.radioValue = "t" === s.value, s.setAttribute("checked", "checked"), s.setAttribute("name", "t"), p.appendChild(s), l = j.createDocumentFragment(), l.appendChild(p.lastChild), n.checkClone = l.cloneNode(!0).cloneNode(!0).lastChild.checked, n.appendChecked = s.checked, l.removeChild(s), l.appendChild(p), p.attachEvent) for (f in {
        submit: 1,
        change: 1,
        focusin: 1
      }) c = "on" + f, d = c in p, d || (p.setAttribute(c, "return;"), d = "function" == typeof p[c]), n[f + "Bubbles"] = d;
      return l.removeChild(p), l = o = a = p = s = null, O(function () {
        var r,
          i,
          o,
          a,
          s,
          l,
          c,
          f,
          h,
          m,
          g,
          y,
          v = j.getElementsByTagName("body")[0];
        v && (c = 1, y = "padding:0;margin:0;border:", m = "position:absolute;top:0;left:0;width:1px;height:1px;", g = y + "0;visibility:hidden;", f = "style='" + m + y + "5px solid #000;", h = "<div " + f + "display:block;'><div style='" + y + "0;display:block;overflow:hidden;'></div></div><table " + f + "' cellpadding='0' cellspacing='0'><tr><td></td></tr></table>", r = j.createElement("div"), r.style.cssText = g + "width:0;height:0;position:static;top:0;margin-top:" + c + "px", v.insertBefore(r, v.firstChild), p = j.createElement("div"), r.appendChild(p), p.innerHTML = "<table><tr><td style='" + y + "0;display:none'></td><td>t</td></tr></table>", u = p.getElementsByTagName("td"), d = 0 === u[0].offsetHeight, u[0].style.display = "", u[1].style.display = "none", n.reliableHiddenOffsets = d && 0 === u[0].offsetHeight, e.getComputedStyle && (p.innerHTML = "", l = j.createElement("div"), l.style.width = "0", l.style.marginRight = "0", p.style.width = "2px", p.appendChild(l), n.reliableMarginRight = 0 === (parseInt((e.getComputedStyle(l, null) || {
          marginRight: 0
        }).marginRight, 10) || 0)), t !== p.style.zoom && (p.innerHTML = "", p.style.width = p.style.padding = "1px", p.style.border = 0, p.style.overflow = "hidden", p.style.display = "inline", p.style.zoom = 1, n.inlineBlockNeedsLayout = 3 === p.offsetWidth, p.style.display = "block", p.style.overflow = "visible", p.innerHTML = "<div style='width:5px;'></div>", n.shrinkWrapBlocks = 3 !== p.offsetWidth), p.style.cssText = m + g, p.innerHTML = h, i = p.firstChild, o = i.firstChild, a = i.nextSibling.firstChild.firstChild, s = {
          doesNotAddBorder: 5 !== o.offsetTop,
          doesAddBorderForTableAndCells: 5 === a.offsetTop
        }, o.style.position = "fixed", o.style.top = "20px", s.fixedPosition = 20 === o.offsetTop || 15 === o.offsetTop, o.style.position = o.style.top = "", i.style.overflow = "hidden", i.style.position = "relative", s.subtractsBorderForOverflowNotVisible = -5 === o.offsetTop, s.doesNotIncludeMarginInBodyOffset = v.offsetTop !== c, e.getComputedStyle && (p.style.marginTop = "1%", n.pixelMargin = "1%" !== (e.getComputedStyle(p, null) || {
          marginTop: 0
        }).marginTop), t !== r.style.zoom && (r.style.zoom = 1), v.removeChild(r), l = p = r = null, O.extend(n, s));
      }), n;
    }();
    var B = /^(?:\{.*\}|\[.*\])$/,
      q = /([A-Z])/g;
    O.extend({
      cache: {},
      uuid: 0,
      expando: "jQuery" + (O.fn.jquery + Math.random()).replace(/\D/g, ""),
      noData: {
        embed: !0,
        object: "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",
        applet: !0
      },
      hasData: function (e) {
        return e = e.nodeType ? O.cache[e[O.expando]] : e[O.expando], !!e && !i(e);
      },
      data: function (e, n, r, i) {
        if (O.acceptData(e)) {
          var o,
            a,
            s,
            l = O.expando,
            u = "string" == typeof n,
            c = e.nodeType,
            f = c ? O.cache : e,
            d = c ? e[l] : e[l] && l,
            p = "events" === n;
          if (d && f[d] && (p || i || f[d].data) || !u || r !== t) return d || (c ? e[l] = d = ++O.uuid : d = l), f[d] || (f[d] = {}, c || (f[d].toJSON = O.noop)), ("object" == typeof n || "function" == typeof n) && (i ? f[d] = O.extend(f[d], n) : f[d].data = O.extend(f[d].data, n)), o = a = f[d], i || (a.data || (a.data = {}), a = a.data), r !== t && (a[O.camelCase(n)] = r), p && !a[n] ? o.events : (u ? (s = a[n], null == s && (s = a[O.camelCase(n)])) : s = a, s);
        }
      },
      removeData: function (e, t, n) {
        if (O.acceptData(e)) {
          var r,
            o,
            a,
            s = O.expando,
            l = e.nodeType,
            u = l ? O.cache : e,
            c = l ? e[s] : s;
          if (u[c]) {
            if (t && (r = n ? u[c] : u[c].data)) {
              O.isArray(t) || (t in r ? t = [t] : (t = O.camelCase(t), t = t in r ? [t] : t.split(" ")));
              for (o = 0, a = t.length; a > o; o++) delete r[t[o]];
              if (!(n ? i : O.isEmptyObject)(r)) return;
            }
            (n || (delete u[c].data, i(u[c]))) && (O.support.deleteExpando || !u.setInterval ? delete u[c] : u[c] = null, l && (O.support.deleteExpando ? delete e[s] : e.removeAttribute ? e.removeAttribute(s) : e[s] = null));
          }
        }
      },
      _data: function (e, t, n) {
        return O.data(e, t, n, !0);
      },
      acceptData: function (e) {
        if (e.nodeName) {
          var t = O.noData[e.nodeName.toLowerCase()];
          if (t) return !(t === !0 || e.getAttribute("classid") !== t);
        }
        return !0;
      }
    }), O.fn.extend({
      data: function (e, n) {
        var i,
          o,
          a,
          s,
          l,
          u = this[0],
          c = 0,
          f = null;
        if (e === t) {
          if (this.length && (f = O.data(u), 1 === u.nodeType && !O._data(u, "parsedAttrs"))) {
            for (a = u.attributes, l = a.length; l > c; c++) s = a[c].name, 0 === s.indexOf("data-") && (s = O.camelCase(s.substring(5)), r(u, s, f[s]));
            O._data(u, "parsedAttrs", !0);
          }
          return f;
        }
        return "object" == typeof e ? this.each(function () {
          O.data(this, e);
        }) : (i = e.split(".", 2), i[1] = i[1] ? "." + i[1] : "", o = i[1] + "!", O.access(this, function (n) {
          return n === t ? (f = this.triggerHandler("getData" + o, [i[0]]), f === t && u && (f = O.data(u, e), f = r(u, e, f)), f === t && i[1] ? this.data(i[0]) : f) : (i[1] = n, this.each(function () {
            var t = O(this);
            t.triggerHandler("setData" + o, i), O.data(this, e, n), t.triggerHandler("changeData" + o, i);
          }), t);
        }, null, n, arguments.length > 1, null, !1));
      },
      removeData: function (e) {
        return this.each(function () {
          O.removeData(this, e);
        });
      }
    }), O.extend({
      _mark: function (e, t) {
        e && (t = (t || "fx") + "mark", O._data(e, t, (O._data(e, t) || 0) + 1));
      },
      _unmark: function (e, t, n) {
        if (e !== !0 && (n = t, t = e, e = !1), t) {
          n = n || "fx";
          var r = n + "mark",
            i = e ? 0 : (O._data(t, r) || 1) - 1;
          i ? O._data(t, r, i) : (O.removeData(t, r, !0), o(t, n, "mark"));
        }
      },
      queue: function (e, n, r) {
        var i;
        return e ? (n = (n || "fx") + "queue", i = O._data(e, n), r && (!i || O.isArray(r) ? i = O._data(e, n, O.makeArray(r)) : i.push(r)), i || []) : t;
      },
      dequeue: function (e, t) {
        t = t || "fx";
        var n = O.queue(e, t),
          r = n.shift(),
          i = {};
        "inprogress" === r && (r = n.shift()), r && ("fx" === t && n.unshift("inprogress"), O._data(e, t + ".run", i), r.call(e, function () {
          O.dequeue(e, t);
        }, i)), n.length || (O.removeData(e, t + "queue " + t + ".run", !0), o(e, t, "queue"));
      }
    }), O.fn.extend({
      queue: function (e, n) {
        var r = 2;
        return "string" != typeof e && (n = e, e = "fx", r--), arguments.length < r ? O.queue(this[0], e) : n === t ? this : this.each(function () {
          var t = O.queue(this, e, n);
          "fx" === e && "inprogress" !== t[0] && O.dequeue(this, e);
        });
      },
      dequeue: function (e) {
        return this.each(function () {
          O.dequeue(this, e);
        });
      },
      delay: function (e, t) {
        return e = O.fx ? O.fx.speeds[e] || e : e, t = t || "fx", this.queue(t, function (t, n) {
          var r = setTimeout(t, e);
          n.stop = function () {
            clearTimeout(r);
          };
        });
      },
      clearQueue: function (e) {
        return this.queue(e || "fx", []);
      },
      promise: function (e, n) {
        function r() {
          --l || o.resolveWith(a, [a]);
        }
        "string" != typeof e && (n = e, e = t), e = e || "fx";
        for (var i, o = O.Deferred(), a = this, s = a.length, l = 1, u = e + "defer", c = e + "queue", f = e + "mark"; s--;) (i = O.data(a[s], u, t, !0) || (O.data(a[s], c, t, !0) || O.data(a[s], f, t, !0)) && O.data(a[s], u, O.Callbacks("once memory"), !0)) && (l++, i.add(r));
        return r(), o.promise(n);
      }
    });
    var W,
      I,
      R,
      $ = /[\n\t\r]/g,
      X = /\s+/,
      z = /\r/g,
      V = /^(?:button|input)$/i,
      U = /^(?:button|input|object|select|textarea)$/i,
      G = /^a(?:rea)?$/i,
      Y = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
      J = O.support.getSetAttribute;
    O.fn.extend({
      attr: function (e, t) {
        return O.access(this, O.attr, e, t, arguments.length > 1);
      },
      removeAttr: function (e) {
        return this.each(function () {
          O.removeAttr(this, e);
        });
      },
      prop: function (e, t) {
        return O.access(this, O.prop, e, t, arguments.length > 1);
      },
      removeProp: function (e) {
        return e = O.propFix[e] || e, this.each(function () {
          try {
            this[e] = t, delete this[e];
          } catch (n) {}
        });
      },
      addClass: function (e) {
        var t, n, r, i, o, a, s;
        if (O.isFunction(e)) return this.each(function (t) {
          O(this).addClass(e.call(this, t, this.className));
        });
        if (e && "string" == typeof e) for (t = e.split(X), n = 0, r = this.length; r > n; n++) if (i = this[n], 1 === i.nodeType) if (i.className || 1 !== t.length) {
          for (o = " " + i.className + " ", a = 0, s = t.length; s > a; a++) ~o.indexOf(" " + t[a] + " ") || (o += t[a] + " ");
          i.className = O.trim(o);
        } else i.className = e;
        return this;
      },
      removeClass: function (e) {
        var n, r, i, o, a, s, l;
        if (O.isFunction(e)) return this.each(function (t) {
          O(this).removeClass(e.call(this, t, this.className));
        });
        if (e && "string" == typeof e || e === t) for (n = (e || "").split(X), r = 0, i = this.length; i > r; r++) if (o = this[r], 1 === o.nodeType && o.className) if (e) {
          for (a = (" " + o.className + " ").replace($, " "), s = 0, l = n.length; l > s; s++) a = a.replace(" " + n[s] + " ", " ");
          o.className = O.trim(a);
        } else o.className = "";
        return this;
      },
      toggleClass: function (e, t) {
        var n = typeof e,
          r = "boolean" == typeof t;
        return this.each(O.isFunction(e) ? function (n) {
          O(this).toggleClass(e.call(this, n, this.className, t), t);
        } : function () {
          if ("string" === n) for (var i, o = 0, a = O(this), s = t, l = e.split(X); i = l[o++];) s = r ? s : !a.hasClass(i), a[s ? "addClass" : "removeClass"](i);else ("undefined" === n || "boolean" === n) && (this.className && O._data(this, "__className__", this.className), this.className = this.className || e === !1 ? "" : O._data(this, "__className__") || "");
        });
      },
      hasClass: function (e) {
        for (var t = " " + e + " ", n = 0, r = this.length; r > n; n++) if (1 === this[n].nodeType && (" " + this[n].className + " ").replace($, " ").indexOf(t) > -1) return !0;
        return !1;
      },
      val: function (e) {
        var n,
          r,
          i,
          o = this[0];
        {
          if (arguments.length) return i = O.isFunction(e), this.each(function (r) {
            var o,
              a = O(this);
            1 === this.nodeType && (o = i ? e.call(this, r, a.val()) : e, null == o ? o = "" : "number" == typeof o ? o += "" : O.isArray(o) && (o = O.map(o, function (e) {
              return null == e ? "" : e + "";
            })), n = O.valHooks[this.type] || O.valHooks[this.nodeName.toLowerCase()], n && "set" in n && n.set(this, o, "value") !== t || (this.value = o));
          });
          if (o) return n = O.valHooks[o.type] || O.valHooks[o.nodeName.toLowerCase()], n && "get" in n && (r = n.get(o, "value")) !== t ? r : (r = o.value, "string" == typeof r ? r.replace(z, "") : null == r ? "" : r);
        }
      }
    }), O.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = e.attributes.value;
            return !t || t.specified ? e.value : e.text;
          }
        },
        select: {
          get: function (e) {
            var t,
              n,
              r,
              i,
              o = e.selectedIndex,
              a = [],
              s = e.options,
              l = "select-one" === e.type;
            if (0 > o) return null;
            for (n = l ? o : 0, r = l ? o + 1 : s.length; r > n; n++) if (i = s[n], !(!i.selected || (O.support.optDisabled ? i.disabled : null !== i.getAttribute("disabled")) || i.parentNode.disabled && O.nodeName(i.parentNode, "optgroup"))) {
              if (t = O(i).val(), l) return t;
              a.push(t);
            }
            return l && !a.length && s.length ? O(s[o]).val() : a;
          },
          set: function (e, t) {
            var n = O.makeArray(t);
            return O(e).find("option").each(function () {
              this.selected = O.inArray(O(this).val(), n) >= 0;
            }), n.length || (e.selectedIndex = -1), n;
          }
        }
      },
      attrFn: {
        val: !0,
        css: !0,
        html: !0,
        text: !0,
        data: !0,
        width: !0,
        height: !0,
        offset: !0
      },
      attr: function (e, n, r, i) {
        var o,
          a,
          s,
          l = e.nodeType;
        if (e && 3 !== l && 8 !== l && 2 !== l) return i && n in O.attrFn ? O(e)[n](r) : t === e.getAttribute ? O.prop(e, n, r) : (s = 1 !== l || !O.isXMLDoc(e), s && (n = n.toLowerCase(), a = O.attrHooks[n] || (Y.test(n) ? I : W)), r !== t ? null === r ? (O.removeAttr(e, n), t) : a && "set" in a && s && (o = a.set(e, r, n)) !== t ? o : (e.setAttribute(n, "" + r), r) : a && "get" in a && s && null !== (o = a.get(e, n)) ? o : (o = e.getAttribute(n), null === o ? t : o));
      },
      removeAttr: function (e, t) {
        var n,
          r,
          i,
          o,
          a,
          s = 0;
        if (t && 1 === e.nodeType) for (r = t.toLowerCase().split(X), o = r.length; o > s; s++) i = r[s], i && (n = O.propFix[i] || i, a = Y.test(i), a || O.attr(e, i, ""), e.removeAttribute(J ? i : n), a && n in e && (e[n] = !1));
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (V.test(e.nodeName) && e.parentNode) O.error("type property can't be changed");else if (!O.support.radioValue && "radio" === t && O.nodeName(e, "input")) {
              var n = e.value;
              return e.setAttribute("type", t), n && (e.value = n), t;
            }
          }
        },
        value: {
          get: function (e, t) {
            return W && O.nodeName(e, "button") ? W.get(e, t) : t in e ? e.value : null;
          },
          set: function (e, n, r) {
            return W && O.nodeName(e, "button") ? W.set(e, n, r) : (e.value = n, t);
          }
        }
      },
      propFix: {
        tabindex: "tabIndex",
        readonly: "readOnly",
        "for": "htmlFor",
        "class": "className",
        maxlength: "maxLength",
        cellspacing: "cellSpacing",
        cellpadding: "cellPadding",
        rowspan: "rowSpan",
        colspan: "colSpan",
        usemap: "useMap",
        frameborder: "frameBorder",
        contenteditable: "contentEditable"
      },
      prop: function (e, n, r) {
        var i,
          o,
          a,
          s = e.nodeType;
        if (e && 3 !== s && 8 !== s && 2 !== s) return a = 1 !== s || !O.isXMLDoc(e), a && (n = O.propFix[n] || n, o = O.propHooks[n]), r !== t ? o && "set" in o && (i = o.set(e, r, n)) !== t ? i : e[n] = r : o && "get" in o && null !== (i = o.get(e, n)) ? i : e[n];
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var n = e.getAttributeNode("tabindex");
            return n && n.specified ? parseInt(n.value, 10) : U.test(e.nodeName) || G.test(e.nodeName) && e.href ? 0 : t;
          }
        }
      }
    }), O.attrHooks.tabindex = O.propHooks.tabIndex, I = {
      get: function (e, n) {
        var r,
          i = O.prop(e, n);
        return i === !0 || "boolean" != typeof i && (r = e.getAttributeNode(n)) && r.nodeValue !== !1 ? n.toLowerCase() : t;
      },
      set: function (e, t, n) {
        var r;
        return t === !1 ? O.removeAttr(e, n) : (r = O.propFix[n] || n, r in e && (e[r] = !0), e.setAttribute(n, n.toLowerCase())), n;
      }
    }, J || (R = {
      name: !0,
      id: !0,
      coords: !0
    }, W = O.valHooks.button = {
      get: function (e, n) {
        var r;
        return r = e.getAttributeNode(n), r && (R[n] ? "" !== r.nodeValue : r.specified) ? r.nodeValue : t;
      },
      set: function (e, t, n) {
        var r = e.getAttributeNode(n);
        return r || (r = j.createAttribute(n), e.setAttributeNode(r)), r.nodeValue = t + "";
      }
    }, O.attrHooks.tabindex.set = W.set, O.each(["width", "height"], function (e, n) {
      O.attrHooks[n] = O.extend(O.attrHooks[n], {
        set: function (e, r) {
          return "" === r ? (e.setAttribute(n, "auto"), r) : t;
        }
      });
    }), O.attrHooks.contenteditable = {
      get: W.get,
      set: function (e, t, n) {
        "" === t && (t = "false"), W.set(e, t, n);
      }
    }), O.support.hrefNormalized || O.each(["href", "src", "width", "height"], function (e, n) {
      O.attrHooks[n] = O.extend(O.attrHooks[n], {
        get: function (e) {
          var r = e.getAttribute(n, 2);
          return null === r ? t : r;
        }
      });
    }), O.support.style || (O.attrHooks.style = {
      get: function (e) {
        return e.style.cssText.toLowerCase() || t;
      },
      set: function (e, t) {
        return e.style.cssText = "" + t;
      }
    }), O.support.optSelected || (O.propHooks.selected = O.extend(O.propHooks.selected, {
      get: function (e) {
        var t = e.parentNode;
        return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null;
      }
    })), O.support.enctype || (O.propFix.enctype = "encoding"), O.support.checkOn || O.each(["radio", "checkbox"], function () {
      O.valHooks[this] = {
        get: function (e) {
          return null === e.getAttribute("value") ? "on" : e.value;
        }
      };
    }), O.each(["radio", "checkbox"], function () {
      O.valHooks[this] = O.extend(O.valHooks[this], {
        set: function (e, n) {
          return O.isArray(n) ? e.checked = O.inArray(O(e).val(), n) >= 0 : t;
        }
      });
    });
    var K = /^(?:textarea|input|select)$/i,
      Q = /^([^\.]*)?(?:\.(.+))?$/,
      Z = /(?:^|\s)hover(\.\S+)?\b/,
      et = /^key/,
      tt = /^(?:mouse|contextmenu)|click/,
      nt = /^(?:focusinfocus|focusoutblur)$/,
      rt = /^(\w*)(?:#([\w\-]+))?(?:\.([\w\-]+))?$/,
      it = function (e) {
        var t = rt.exec(e);
        return t && (t[1] = (t[1] || "").toLowerCase(), t[3] = t[3] && RegExp("(?:^|\\s)" + t[3] + "(?:\\s|$)")), t;
      },
      ot = function (e, t) {
        var n = e.attributes || {};
        return !(t[1] && e.nodeName.toLowerCase() !== t[1] || t[2] && (n.id || {}).value !== t[2] || t[3] && !t[3].test((n["class"] || {}).value));
      },
      at = function (e) {
        return O.event.special.hover ? e : e.replace(Z, "mouseenter$1 mouseleave$1");
      };
    O.event = {
      add: function (e, n, r, i, o) {
        var a, s, l, u, c, f, d, p, h, m, g;
        if (3 !== e.nodeType && 8 !== e.nodeType && n && r && (a = O._data(e))) {
          for (r.handler && (h = r, r = h.handler, o = h.selector), r.guid || (r.guid = O.guid++), l = a.events, l || (a.events = l = {}), s = a.handle, s || (a.handle = s = function (e) {
            return t === O || e && O.event.triggered === e.type ? t : O.event.dispatch.apply(s.elem, arguments);
          }, s.elem = e), n = O.trim(at(n)).split(" "), u = 0; u < n.length; u++) c = Q.exec(n[u]) || [], f = c[1], d = (c[2] || "").split(".").sort(), g = O.event.special[f] || {}, f = (o ? g.delegateType : g.bindType) || f, g = O.event.special[f] || {}, p = O.extend({
            type: f,
            origType: c[1],
            data: i,
            handler: r,
            guid: r.guid,
            selector: o,
            quick: o && it(o),
            namespace: d.join(".")
          }, h), m = l[f], m || (m = l[f] = [], m.delegateCount = 0, g.setup && g.setup.call(e, i, d, s) !== !1 || (e.addEventListener ? e.addEventListener(f, s, !1) : e.attachEvent && e.attachEvent("on" + f, s))), g.add && (g.add.call(e, p), p.handler.guid || (p.handler.guid = r.guid)), o ? m.splice(m.delegateCount++, 0, p) : m.push(p), O.event.global[f] = !0;
          e = null;
        }
      },
      global: {},
      remove: function (e, t, n, r, i) {
        var o,
          a,
          s,
          l,
          u,
          c,
          f,
          d,
          p,
          h,
          m,
          g,
          y = O.hasData(e) && O._data(e);
        if (y && (d = y.events)) {
          for (t = O.trim(at(t || "")).split(" "), o = 0; o < t.length; o++) if (a = Q.exec(t[o]) || [], s = l = a[1], u = a[2], s) {
            for (p = O.event.special[s] || {}, s = (r ? p.delegateType : p.bindType) || s, m = d[s] || [], c = m.length, u = u ? RegExp("(^|\\.)" + u.split(".").sort().join("\\.(?:.*\\.)?") + "(\\.|$)") : null, f = 0; f < m.length; f++) g = m[f], !i && l !== g.origType || n && n.guid !== g.guid || u && !u.test(g.namespace) || r && r !== g.selector && ("**" !== r || !g.selector) || (m.splice(f--, 1), g.selector && m.delegateCount--, p.remove && p.remove.call(e, g));
            0 === m.length && c !== m.length && (p.teardown && p.teardown.call(e, u) !== !1 || O.removeEvent(e, s, y.handle), delete d[s]);
          } else for (s in d) O.event.remove(e, s + t[o], n, r, !0);
          O.isEmptyObject(d) && (h = y.handle, h && (h.elem = null), O.removeData(e, ["events", "handle"], !0));
        }
      },
      customEvent: {
        getData: !0,
        setData: !0,
        changeData: !0
      },
      trigger: function (n, r, i, o) {
        if (!i || 3 !== i.nodeType && 8 !== i.nodeType) {
          var a,
            s,
            l,
            u,
            c,
            f,
            d,
            p,
            h,
            m,
            g = n.type || n,
            y = [];
          if (!nt.test(g + O.event.triggered) && (g.indexOf("!") < 0 || (g = g.slice(0, -1), s = !0), g.indexOf(".") < 0 || (y = g.split("."), g = y.shift(), y.sort()), i && !O.event.customEvent[g] || O.event.global[g])) if (n = "object" == typeof n ? n[O.expando] ? n : new O.Event(g, n) : new O.Event(g), n.type = g, n.isTrigger = !0, n.exclusive = s, n.namespace = y.join("."), n.namespace_re = n.namespace ? RegExp("(^|\\.)" + y.join("\\.(?:.*\\.)?") + "(\\.|$)") : null, f = g.indexOf(":") < 0 ? "on" + g : "", i) {
            if (n.result = t, n.target || (n.target = i), r = null != r ? O.makeArray(r) : [], r.unshift(n), d = O.event.special[g] || {}, !d.trigger || d.trigger.apply(i, r) !== !1) {
              if (h = [[i, d.bindType || g]], !o && !d.noBubble && !O.isWindow(i)) {
                for (m = d.delegateType || g, u = nt.test(m + g) ? i : i.parentNode, c = null; u; u = u.parentNode) h.push([u, m]), c = u;
                c && c === i.ownerDocument && h.push([c.defaultView || c.parentWindow || e, m]);
              }
              for (l = 0; l < h.length && !n.isPropagationStopped(); l++) u = h[l][0], n.type = h[l][1], p = (O._data(u, "events") || {})[n.type] && O._data(u, "handle"), p && p.apply(u, r), p = f && u[f], p && O.acceptData(u) && p.apply(u, r) === !1 && n.preventDefault();
              return n.type = g, o || n.isDefaultPrevented() || d._default && d._default.apply(i.ownerDocument, r) !== !1 || "click" === g && O.nodeName(i, "a") || !O.acceptData(i) || f && i[g] && ("focus" !== g && "blur" !== g || 0 !== n.target.offsetWidth) && !O.isWindow(i) && (c = i[f], c && (i[f] = null), O.event.triggered = g, i[g](), O.event.triggered = t, c && (i[f] = c)), n.result;
            }
          } else {
            a = O.cache;
            for (l in a) a[l].events && a[l].events[g] && O.event.trigger(n, r, a[l].handle.elem, !0);
          }
        }
      },
      dispatch: function (n) {
        n = O.event.fix(n || e.event);
        var r,
          i,
          o,
          a,
          s,
          l,
          u,
          c,
          f,
          d,
          p = (O._data(this, "events") || {})[n.type] || [],
          h = p.delegateCount,
          m = [].slice.call(arguments, 0),
          g = !n.exclusive && !n.namespace,
          y = O.event.special[n.type] || {},
          v = [];
        if (m[0] = n, n.delegateTarget = this, !y.preDispatch || y.preDispatch.call(this, n) !== !1) {
          if (h && (!n.button || "click" !== n.type)) for (a = O(this), a.context = this.ownerDocument || this, o = n.target; o != this; o = o.parentNode || this) if (o.disabled !== !0) {
            for (l = {}, c = [], a[0] = o, r = 0; h > r; r++) f = p[r], d = f.selector, l[d] === t && (l[d] = f.quick ? ot(o, f.quick) : a.is(d)), l[d] && c.push(f);
            c.length && v.push({
              elem: o,
              matches: c
            });
          }
          for (p.length > h && v.push({
            elem: this,
            matches: p.slice(h)
          }), r = 0; r < v.length && !n.isPropagationStopped(); r++) for (u = v[r], n.currentTarget = u.elem, i = 0; i < u.matches.length && !n.isImmediatePropagationStopped(); i++) f = u.matches[i], (g || !n.namespace && !f.namespace || n.namespace_re && n.namespace_re.test(f.namespace)) && (n.data = f.data, n.handleObj = f, s = ((O.event.special[f.origType] || {}).handle || f.handler).apply(u.elem, m), s !== t && (n.result = s, s === !1 && (n.preventDefault(), n.stopPropagation())));
          return y.postDispatch && y.postDispatch.call(this, n), n.result;
        }
      },
      props: "attrChange attrName relatedNode srcElement altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
      fixHooks: {},
      keyHooks: {
        props: "char charCode key keyCode".split(" "),
        filter: function (e, t) {
          return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e;
        }
      },
      mouseHooks: {
        props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
        filter: function (e, n) {
          var r,
            i,
            o,
            a = n.button,
            s = n.fromElement;
          return null == e.pageX && null != n.clientX && (r = e.target.ownerDocument || j, i = r.documentElement, o = r.body, e.pageX = n.clientX + (i && i.scrollLeft || o && o.scrollLeft || 0) - (i && i.clientLeft || o && o.clientLeft || 0), e.pageY = n.clientY + (i && i.scrollTop || o && o.scrollTop || 0) - (i && i.clientTop || o && o.clientTop || 0)), !e.relatedTarget && s && (e.relatedTarget = s === e.target ? n.toElement : s), e.which || a === t || (e.which = 1 & a ? 1 : 2 & a ? 3 : 4 & a ? 2 : 0), e;
        }
      },
      fix: function (e) {
        if (e[O.expando]) return e;
        var n,
          r,
          i = e,
          o = O.event.fixHooks[e.type] || {},
          a = o.props ? this.props.concat(o.props) : this.props;
        for (e = O.Event(i), n = a.length; n;) r = a[--n], e[r] = i[r];
        return e.target || (e.target = i.srcElement || j), 3 === e.target.nodeType && (e.target = e.target.parentNode), e.metaKey === t && (e.metaKey = e.ctrlKey), o.filter ? o.filter(e, i) : e;
      },
      special: {
        ready: {
          setup: O.bindReady
        },
        load: {
          noBubble: !0
        },
        focus: {
          delegateType: "focusin"
        },
        blur: {
          delegateType: "focusout"
        },
        beforeunload: {
          setup: function (e, t, n) {
            O.isWindow(this) && (this.onbeforeunload = n);
          },
          teardown: function (e, t) {
            this.onbeforeunload === t && (this.onbeforeunload = null);
          }
        }
      },
      simulate: function (e, t, n, r) {
        var i = O.extend(new O.Event(), n, {
          type: e,
          isSimulated: !0,
          originalEvent: {}
        });
        r ? O.event.trigger(i, null, t) : O.event.dispatch.call(t, i), i.isDefaultPrevented() && n.preventDefault();
      }
    }, O.event.handle = O.event.dispatch, O.removeEvent = j.removeEventListener ? function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n, !1);
    } : function (e, t, n) {
      e.detachEvent && e.detachEvent("on" + t, n);
    }, O.Event = function (e, n) {
      return this instanceof O.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || e.returnValue === !1 || e.getPreventDefault && e.getPreventDefault() ? s : a) : this.type = e, n && O.extend(this, n), this.timeStamp = e && e.timeStamp || O.now(), this[O.expando] = !0, t) : new O.Event(e, n);
    }, O.Event.prototype = {
      preventDefault: function () {
        this.isDefaultPrevented = s;
        var e = this.originalEvent;
        e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1);
      },
      stopPropagation: function () {
        this.isPropagationStopped = s;
        var e = this.originalEvent;
        e && (e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0);
      },
      stopImmediatePropagation: function () {
        this.isImmediatePropagationStopped = s, this.stopPropagation();
      },
      isDefaultPrevented: a,
      isPropagationStopped: a,
      isImmediatePropagationStopped: a
    }, O.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout"
    }, function (e, t) {
      O.event.special[e] = {
        delegateType: t,
        bindType: t,
        handle: function (e) {
          {
            var n,
              r = this,
              i = e.relatedTarget,
              o = e.handleObj;
            o.selector;
          }
          return (!i || i !== r && !O.contains(r, i)) && (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n;
        }
      };
    }), O.support.submitBubbles || (O.event.special.submit = {
      setup: function () {
        return O.nodeName(this, "form") ? !1 : (O.event.add(this, "click._submit keypress._submit", function (e) {
          var n = e.target,
            r = O.nodeName(n, "input") || O.nodeName(n, "button") ? n.form : t;
          r && !r._submit_attached && (O.event.add(r, "submit._submit", function (e) {
            e._submit_bubble = !0;
          }), r._submit_attached = !0);
        }), t);
      },
      postDispatch: function (e) {
        e._submit_bubble && (delete e._submit_bubble, this.parentNode && !e.isTrigger && O.event.simulate("submit", this.parentNode, e, !0));
      },
      teardown: function () {
        return O.nodeName(this, "form") ? !1 : (O.event.remove(this, "._submit"), t);
      }
    }), O.support.changeBubbles || (O.event.special.change = {
      setup: function () {
        return K.test(this.nodeName) ? (("checkbox" === this.type || "radio" === this.type) && (O.event.add(this, "propertychange._change", function (e) {
          "checked" === e.originalEvent.propertyName && (this._just_changed = !0);
        }), O.event.add(this, "click._change", function (e) {
          this._just_changed && !e.isTrigger && (this._just_changed = !1, O.event.simulate("change", this, e, !0));
        })), !1) : (O.event.add(this, "beforeactivate._change", function (e) {
          var t = e.target;
          K.test(t.nodeName) && !t._change_attached && (O.event.add(t, "change._change", function (e) {
            !this.parentNode || e.isSimulated || e.isTrigger || O.event.simulate("change", this.parentNode, e, !0);
          }), t._change_attached = !0);
        }), t);
      },
      handle: function (e) {
        var n = e.target;
        return this !== n || e.isSimulated || e.isTrigger || "radio" !== n.type && "checkbox" !== n.type ? e.handleObj.handler.apply(this, arguments) : t;
      },
      teardown: function () {
        return O.event.remove(this, "._change"), K.test(this.nodeName);
      }
    }), O.support.focusinBubbles || O.each({
      focus: "focusin",
      blur: "focusout"
    }, function (e, t) {
      var n = 0,
        r = function (e) {
          O.event.simulate(t, e.target, O.event.fix(e), !0);
        };
      O.event.special[t] = {
        setup: function () {
          0 === n++ && j.addEventListener(e, r, !0);
        },
        teardown: function () {
          0 === --n && j.removeEventListener(e, r, !0);
        }
      };
    }), O.fn.extend({
      on: function (e, n, r, i, o) {
        var s, l;
        if ("object" == typeof e) {
          "string" != typeof n && (r = r || n, n = t);
          for (l in e) this.on(l, n, r, e[l], o);
          return this;
        }
        if (null == r && null == i ? (i = n, r = n = t) : null == i && ("string" == typeof n ? (i = r, r = t) : (i = r, r = n, n = t)), i === !1) i = a;else if (!i) return this;
        return 1 === o && (s = i, i = function (e) {
          return O().off(e), s.apply(this, arguments);
        }, i.guid = s.guid || (s.guid = O.guid++)), this.each(function () {
          O.event.add(this, e, i, r, n);
        });
      },
      one: function (e, t, n, r) {
        return this.on(e, t, n, r, 1);
      },
      off: function (e, n, r) {
        if (e && e.preventDefault && e.handleObj) {
          var i = e.handleObj;
          return O(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
        }
        if ("object" == typeof e) {
          for (var o in e) this.off(o, n, e[o]);
          return this;
        }
        return (n === !1 || "function" == typeof n) && (r = n, n = t), r === !1 && (r = a), this.each(function () {
          O.event.remove(this, e, r, n);
        });
      },
      bind: function (e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      live: function (e, t, n) {
        return O(this.context).on(e, this.selector, t, n), this;
      },
      die: function (e, t) {
        return O(this.context).off(e, this.selector || "**", t), this;
      },
      delegate: function (e, t, n, r) {
        return this.on(t, e, n, r);
      },
      undelegate: function (e, t, n) {
        return 1 == arguments.length ? this.off(e, "**") : this.off(t, e, n);
      },
      trigger: function (e, t) {
        return this.each(function () {
          O.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, n) {
        return this[0] ? O.event.trigger(e, n, this[0], !0) : t;
      },
      toggle: function (e) {
        var t = arguments,
          n = e.guid || O.guid++,
          r = 0,
          i = function (n) {
            var i = (O._data(this, "lastToggle" + e.guid) || 0) % r;
            return O._data(this, "lastToggle" + e.guid, i + 1), n.preventDefault(), t[i].apply(this, arguments) || !1;
          };
        for (i.guid = n; r < t.length;) t[r++].guid = n;
        return this.click(i);
      },
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      }
    }), O.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (e, t) {
      O.fn[t] = function (e, n) {
        return null == n && (n = e, e = null), arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
      }, O.attrFn && (O.attrFn[t] = !0), et.test(t) && (O.event.fixHooks[t] = O.event.keyHooks), tt.test(t) && (O.event.fixHooks[t] = O.event.mouseHooks);
    }), function () {
      function e(e, t, n, r, o, a) {
        for (var s = 0, l = r.length; l > s; s++) {
          var u = r[s];
          if (u) {
            var c = !1;
            for (u = u[e]; u;) {
              if (u[i] === n) {
                c = r[u.sizset];
                break;
              }
              if (1 !== u.nodeType || a || (u[i] = n, u.sizset = s), u.nodeName.toLowerCase() === t) {
                c = u;
                break;
              }
              u = u[e];
            }
            r[s] = c;
          }
        }
      }
      function n(e, t, n, r, o, a) {
        for (var s = 0, l = r.length; l > s; s++) {
          var u = r[s];
          if (u) {
            var c = !1;
            for (u = u[e]; u;) {
              if (u[i] === n) {
                c = r[u.sizset];
                break;
              }
              if (1 === u.nodeType) if (a || (u[i] = n, u.sizset = s), "string" != typeof t) {
                if (u === t) {
                  c = !0;
                  break;
                }
              } else if (d.filter(t, [u]).length > 0) {
                c = u;
                break;
              }
              u = u[e];
            }
            r[s] = c;
          }
        }
      }
      var r = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g,
        i = "sizcache" + (Math.random() + "").replace(".", ""),
        o = 0,
        a = Object.prototype.toString,
        s = !1,
        l = !0,
        u = /\\/g,
        c = /\r\n/g,
        f = /\W/;
      [0, 0].sort(function () {
        return l = !1, 0;
      });
      var d = function (e, t, n, i) {
        n = n || [], t = t || j;
        var o = t;
        if (1 !== t.nodeType && 9 !== t.nodeType) return [];
        if (!e || "string" != typeof e) return n;
        var s,
          l,
          u,
          c,
          f,
          p,
          g,
          y,
          b = !0,
          x = d.isXML(t),
          T = [],
          N = e;
        do if (r.exec(""), s = r.exec(N), s && (N = s[3], T.push(s[1]), s[2])) {
          c = s[3];
          break;
        } while (s);
        if (T.length > 1 && m.exec(e)) {
          if (2 === T.length && h.relative[T[0]]) l = w(T[0] + T[1], t, i);else for (l = h.relative[T[0]] ? [t] : d(T.shift(), t); T.length;) e = T.shift(), h.relative[e] && (e += T.shift()), l = w(e, l, i);
        } else if (i || T.length <= 1 || 9 !== t.nodeType || x || !h.match.ID.test(T[0]) || h.match.ID.test(T[T.length - 1]) || (f = d.find(T.shift(), t, x), t = f.expr ? d.filter(f.expr, f.set)[0] : f.set[0]), t) for (f = i ? {
          expr: T.pop(),
          set: v(i)
        } : d.find(T.pop(), 1 !== T.length || "~" !== T[0] && "+" !== T[0] || !t.parentNode ? t : t.parentNode, x), l = f.expr ? d.filter(f.expr, f.set) : f.set, T.length > 0 ? u = v(l) : b = !1; T.length;) p = T.pop(), g = p, h.relative[p] ? g = T.pop() : p = "", null == g && (g = t), h.relative[p](u, g, x);else u = T = [];
        if (u || (u = l), u || d.error(p || e), "[object Array]" === a.call(u)) {
          if (b) {
            if (t && 1 === t.nodeType) for (y = 0; null != u[y]; y++) u[y] && (u[y] === !0 || 1 === u[y].nodeType && d.contains(t, u[y])) && n.push(l[y]);else for (y = 0; null != u[y]; y++) u[y] && 1 === u[y].nodeType && n.push(l[y]);
          } else n.push.apply(n, u);
        } else v(u, n);
        return c && (d(c, o, n, i), d.uniqueSort(n)), n;
      };
      d.uniqueSort = function (e) {
        if (x && (s = l, e.sort(x), s)) for (var t = 1; t < e.length; t++) e[t] === e[t - 1] && e.splice(t--, 1);
        return e;
      }, d.matches = function (e, t) {
        return d(e, null, null, t);
      }, d.matchesSelector = function (e, t) {
        return d(t, null, null, [e]).length > 0;
      }, d.find = function (e, n, r) {
        var i, o, a, s, l, c;
        if (!e) return [];
        for (o = 0, a = h.order.length; a > o; o++) if (l = h.order[o], (s = h.leftMatch[l].exec(e)) && (c = s[1], s.splice(1, 1), "\\" !== c.substr(c.length - 1) && (s[1] = (s[1] || "").replace(u, ""), i = h.find[l](s, n, r), null != i))) {
          e = e.replace(h.match[l], "");
          break;
        }
        return i || (i = t !== n.getElementsByTagName ? n.getElementsByTagName("*") : []), {
          set: i,
          expr: e
        };
      }, d.filter = function (e, n, r, i) {
        for (var o, a, s, l, u, c, f, p, m, g = e, y = [], v = n, b = n && n[0] && d.isXML(n[0]); e && n.length;) {
          for (s in h.filter) if (null != (o = h.leftMatch[s].exec(e)) && o[2]) {
            if (c = h.filter[s], f = o[1], a = !1, o.splice(1, 1), "\\" === f.substr(f.length - 1)) continue;
            if (v === y && (y = []), h.preFilter[s]) if (o = h.preFilter[s](o, v, r, y, i, b)) {
              if (o === !0) continue;
            } else a = l = !0;
            if (o) for (p = 0; null != (u = v[p]); p++) u && (l = c(u, o, p, v), m = i ^ l, r && null != l ? m ? a = !0 : v[p] = !1 : m && (y.push(u), a = !0));
            if (l !== t) {
              if (r || (v = y), e = e.replace(h.match[s], ""), !a) return [];
              break;
            }
          }
          if (e === g) {
            if (null != a) break;
            d.error(e);
          }
          g = e;
        }
        return v;
      }, d.error = function (e) {
        throw Error("Syntax error, unrecognized expression: " + e);
      };
      var p = d.getText = function (e) {
          var t,
            n,
            r = e.nodeType,
            i = "";
          if (r) {
            if (1 === r || 9 === r || 11 === r) {
              if ("string" == typeof e.textContent) return e.textContent;
              if ("string" == typeof e.innerText) return e.innerText.replace(c, "");
              for (e = e.firstChild; e; e = e.nextSibling) i += p(e);
            } else if (3 === r || 4 === r) return e.nodeValue;
          } else for (t = 0; n = e[t]; t++) 8 !== n.nodeType && (i += p(n));
          return i;
        },
        h = d.selectors = {
          order: ["ID", "NAME", "TAG"],
          match: {
            ID: /#((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,
            CLASS: /\.((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,
            NAME: /\[name=['"]*((?:[\w\u00c0-\uFFFF\-]|\\.)+)['"]*\]/,
            ATTR: /\[\s*((?:[\w\u00c0-\uFFFF\-]|\\.)+)\s*(?:(\S?=)\s*(?:(['"])(.*?)\3|(#?(?:[\w\u00c0-\uFFFF\-]|\\.)*)|)|)\s*\]/,
            TAG: /^((?:[\w\u00c0-\uFFFF\*\-]|\\.)+)/,
            CHILD: /:(only|nth|last|first)-child(?:\(\s*(even|odd|(?:[+\-]?\d+|(?:[+\-]?\d*)?n\s*(?:[+\-]\s*\d+)?))\s*\))?/,
            POS: /:(nth|eq|gt|lt|first|last|even|odd)(?:\((\d*)\))?(?=[^\-]|$)/,
            PSEUDO: /:((?:[\w\u00c0-\uFFFF\-]|\\.)+)(?:\((['"]?)((?:\([^\)]+\)|[^\(\)]*)+)\2\))?/
          },
          leftMatch: {},
          attrMap: {
            "class": "className",
            "for": "htmlFor"
          },
          attrHandle: {
            href: function (e) {
              return e.getAttribute("href");
            },
            type: function (e) {
              return e.getAttribute("type");
            }
          },
          relative: {
            "+": function (e, t) {
              var n = "string" == typeof t,
                r = n && !f.test(t),
                i = n && !r;
              r && (t = t.toLowerCase());
              for (var o, a = 0, s = e.length; s > a; a++) if (o = e[a]) {
                for (; (o = o.previousSibling) && 1 !== o.nodeType;);
                e[a] = i || o && o.nodeName.toLowerCase() === t ? o || !1 : o === t;
              }
              i && d.filter(t, e, !0);
            },
            ">": function (e, t) {
              var n,
                r = "string" == typeof t,
                i = 0,
                o = e.length;
              if (r && !f.test(t)) {
                for (t = t.toLowerCase(); o > i; i++) if (n = e[i]) {
                  var a = n.parentNode;
                  e[i] = a.nodeName.toLowerCase() === t ? a : !1;
                }
              } else {
                for (; o > i; i++) n = e[i], n && (e[i] = r ? n.parentNode : n.parentNode === t);
                r && d.filter(t, e, !0);
              }
            },
            "": function (t, r, i) {
              var a,
                s = o++,
                l = n;
              "string" != typeof r || f.test(r) || (r = r.toLowerCase(), a = r, l = e), l("parentNode", r, s, t, a, i);
            },
            "~": function (t, r, i) {
              var a,
                s = o++,
                l = n;
              "string" != typeof r || f.test(r) || (r = r.toLowerCase(), a = r, l = e), l("previousSibling", r, s, t, a, i);
            }
          },
          find: {
            ID: function (e, n, r) {
              if (t !== n.getElementById && !r) {
                var i = n.getElementById(e[1]);
                return i && i.parentNode ? [i] : [];
              }
            },
            NAME: function (e, n) {
              if (t !== n.getElementsByName) {
                for (var r = [], i = n.getElementsByName(e[1]), o = 0, a = i.length; a > o; o++) i[o].getAttribute("name") === e[1] && r.push(i[o]);
                return 0 === r.length ? null : r;
              }
            },
            TAG: function (e, n) {
              return t !== n.getElementsByTagName ? n.getElementsByTagName(e[1]) : t;
            }
          },
          preFilter: {
            CLASS: function (e, t, n, r, i, o) {
              if (e = " " + e[1].replace(u, "") + " ", o) return e;
              for (var a, s = 0; null != (a = t[s]); s++) a && (i ^ (a.className && (" " + a.className + " ").replace(/[\t\n\r]/g, " ").indexOf(e) >= 0) ? n || r.push(a) : n && (t[s] = !1));
              return !1;
            },
            ID: function (e) {
              return e[1].replace(u, "");
            },
            TAG: function (e) {
              return e[1].replace(u, "").toLowerCase();
            },
            CHILD: function (e) {
              if ("nth" === e[1]) {
                e[2] || d.error(e[0]), e[2] = e[2].replace(/^\+|\s*/g, "");
                var t = /(-?)(\d*)(?:n([+\-]?\d*))?/.exec("even" === e[2] && "2n" || "odd" === e[2] && "2n+1" || !/\D/.test(e[2]) && "0n+" + e[2] || e[2]);
                e[2] = t[1] + (t[2] || 1) - 0, e[3] = t[3] - 0;
              } else e[2] && d.error(e[0]);
              return e[0] = o++, e;
            },
            ATTR: function (e, t, n, r, i, o) {
              var a = e[1] = e[1].replace(u, "");
              return !o && h.attrMap[a] && (e[1] = h.attrMap[a]), e[4] = (e[4] || e[5] || "").replace(u, ""), "~=" === e[2] && (e[4] = " " + e[4] + " "), e;
            },
            PSEUDO: function (e, t, n, i, o) {
              if ("not" === e[1]) {
                if ((r.exec(e[3]) || "").length <= 1 && !/^\w/.test(e[3])) {
                  var a = d.filter(e[3], t, n, !0 ^ o);
                  return n || i.push.apply(i, a), !1;
                }
                e[3] = d(e[3], null, null, t);
              } else if (h.match.POS.test(e[0]) || h.match.CHILD.test(e[0])) return !0;
              return e;
            },
            POS: function (e) {
              return e.unshift(!0), e;
            }
          },
          filters: {
            enabled: function (e) {
              return e.disabled === !1 && "hidden" !== e.type;
            },
            disabled: function (e) {
              return e.disabled === !0;
            },
            checked: function (e) {
              return e.checked === !0;
            },
            selected: function (e) {
              return e.parentNode && e.parentNode.selectedIndex, e.selected === !0;
            },
            parent: function (e) {
              return !!e.firstChild;
            },
            empty: function (e) {
              return !e.firstChild;
            },
            has: function (e, t, n) {
              return !!d(n[3], e).length;
            },
            header: function (e) {
              return /h\d/i.test(e.nodeName);
            },
            text: function (e) {
              var t = e.getAttribute("type"),
                n = e.type;
              return "input" === e.nodeName.toLowerCase() && "text" === n && (t === n || null === t);
            },
            radio: function (e) {
              return "input" === e.nodeName.toLowerCase() && "radio" === e.type;
            },
            checkbox: function (e) {
              return "input" === e.nodeName.toLowerCase() && "checkbox" === e.type;
            },
            file: function (e) {
              return "input" === e.nodeName.toLowerCase() && "file" === e.type;
            },
            password: function (e) {
              return "input" === e.nodeName.toLowerCase() && "password" === e.type;
            },
            submit: function (e) {
              var t = e.nodeName.toLowerCase();
              return ("input" === t || "button" === t) && "submit" === e.type;
            },
            image: function (e) {
              return "input" === e.nodeName.toLowerCase() && "image" === e.type;
            },
            reset: function (e) {
              var t = e.nodeName.toLowerCase();
              return ("input" === t || "button" === t) && "reset" === e.type;
            },
            button: function (e) {
              var t = e.nodeName.toLowerCase();
              return "input" === t && "button" === e.type || "button" === t;
            },
            input: function (e) {
              return /input|select|textarea|button/i.test(e.nodeName);
            },
            focus: function (e) {
              return e === e.ownerDocument.activeElement;
            }
          },
          setFilters: {
            first: function (e, t) {
              return 0 === t;
            },
            last: function (e, t, n, r) {
              return t === r.length - 1;
            },
            even: function (e, t) {
              return t % 2 === 0;
            },
            odd: function (e, t) {
              return t % 2 === 1;
            },
            lt: function (e, t, n) {
              return t < n[3] - 0;
            },
            gt: function (e, t, n) {
              return t > n[3] - 0;
            },
            nth: function (e, t, n) {
              return n[3] - 0 === t;
            },
            eq: function (e, t, n) {
              return n[3] - 0 === t;
            }
          },
          filter: {
            PSEUDO: function (e, t, n, r) {
              var i = t[1],
                o = h.filters[i];
              if (o) return o(e, n, t, r);
              if ("contains" === i) return (e.textContent || e.innerText || p([e]) || "").indexOf(t[3]) >= 0;
              if ("not" === i) {
                for (var a = t[3], s = 0, l = a.length; l > s; s++) if (a[s] === e) return !1;
                return !0;
              }
              d.error(i);
            },
            CHILD: function (e, t) {
              var n,
                r,
                o,
                a,
                s,
                l,
                u = t[1],
                c = e;
              switch (u) {
                case "only":
                case "first":
                  for (; c = c.previousSibling;) if (1 === c.nodeType) return !1;
                  if ("first" === u) return !0;
                  c = e;
                case "last":
                  for (; c = c.nextSibling;) if (1 === c.nodeType) return !1;
                  return !0;
                case "nth":
                  if (n = t[2], r = t[3], 1 === n && 0 === r) return !0;
                  if (o = t[0], a = e.parentNode, a && (a[i] !== o || !e.nodeIndex)) {
                    for (s = 0, c = a.firstChild; c; c = c.nextSibling) 1 === c.nodeType && (c.nodeIndex = ++s);
                    a[i] = o;
                  }
                  return l = e.nodeIndex - r, 0 === n ? 0 === l : l % n === 0 && l / n >= 0;
              }
            },
            ID: function (e, t) {
              return 1 === e.nodeType && e.getAttribute("id") === t;
            },
            TAG: function (e, t) {
              return "*" === t && 1 === e.nodeType || !!e.nodeName && e.nodeName.toLowerCase() === t;
            },
            CLASS: function (e, t) {
              return (" " + (e.className || e.getAttribute("class")) + " ").indexOf(t) > -1;
            },
            ATTR: function (e, t) {
              var n = t[1],
                r = d.attr ? d.attr(e, n) : h.attrHandle[n] ? h.attrHandle[n](e) : null != e[n] ? e[n] : e.getAttribute(n),
                i = r + "",
                o = t[2],
                a = t[4];
              return null == r ? "!=" === o : !o && d.attr ? null != r : "=" === o ? i === a : "*=" === o ? i.indexOf(a) >= 0 : "~=" === o ? (" " + i + " ").indexOf(a) >= 0 : a ? "!=" === o ? i !== a : "^=" === o ? 0 === i.indexOf(a) : "$=" === o ? i.substr(i.length - a.length) === a : "|=" === o ? i === a || i.substr(0, a.length + 1) === a + "-" : !1 : i && r !== !1;
            },
            POS: function (e, n, r, i) {
              var o = n[2],
                a = h.setFilters[o];
              return a ? a(e, r, n, i) : t;
            }
          }
        },
        m = h.match.POS,
        g = function (e, t) {
          return "\\" + (t - 0 + 1);
        };
      for (var y in h.match) h.match[y] = RegExp(h.match[y].source + /(?![^\[]*\])(?![^\(]*\))/.source), h.leftMatch[y] = RegExp(/(^(?:.|\r|\n)*?)/.source + h.match[y].source.replace(/\\(\d+)/g, g));
      h.match.globalPOS = m;
      var v = function (e, t) {
        return e = Array.prototype.slice.call(e, 0), t ? (t.push.apply(t, e), t) : e;
      };
      try {
        Array.prototype.slice.call(j.documentElement.childNodes, 0)[0].nodeType;
      } catch (b) {
        v = function (e, t) {
          var n = 0,
            r = t || [];
          if ("[object Array]" === a.call(e)) Array.prototype.push.apply(r, e);else if ("number" == typeof e.length) for (var i = e.length; i > n; n++) r.push(e[n]);else for (; e[n]; n++) r.push(e[n]);
          return r;
        };
      }
      var x, T;
      j.documentElement.compareDocumentPosition ? x = function (e, t) {
        return e === t ? (s = !0, 0) : e.compareDocumentPosition && t.compareDocumentPosition ? 4 & e.compareDocumentPosition(t) ? -1 : 1 : e.compareDocumentPosition ? -1 : 1;
      } : (x = function (e, t) {
        if (e === t) return s = !0, 0;
        if (e.sourceIndex && t.sourceIndex) return e.sourceIndex - t.sourceIndex;
        var n,
          r,
          i = [],
          o = [],
          a = e.parentNode,
          l = t.parentNode,
          u = a;
        if (a === l) return T(e, t);
        if (!a) return -1;
        if (!l) return 1;
        for (; u;) i.unshift(u), u = u.parentNode;
        for (u = l; u;) o.unshift(u), u = u.parentNode;
        n = i.length, r = o.length;
        for (var c = 0; n > c && r > c; c++) if (i[c] !== o[c]) return T(i[c], o[c]);
        return c === n ? T(e, o[c], -1) : T(i[c], t, 1);
      }, T = function (e, t, n) {
        if (e === t) return n;
        for (var r = e.nextSibling; r;) {
          if (r === t) return -1;
          r = r.nextSibling;
        }
        return 1;
      }), function () {
        var e = j.createElement("div"),
          n = "script" + new Date().getTime(),
          r = j.documentElement;
        e.innerHTML = "<a name='" + n + "'/>", r.insertBefore(e, r.firstChild), j.getElementById(n) && (h.find.ID = function (e, n, r) {
          if (t !== n.getElementById && !r) {
            var i = n.getElementById(e[1]);
            return i ? i.id === e[1] || t !== i.getAttributeNode && i.getAttributeNode("id").nodeValue === e[1] ? [i] : t : [];
          }
        }, h.filter.ID = function (e, n) {
          var r = t !== e.getAttributeNode && e.getAttributeNode("id");
          return 1 === e.nodeType && r && r.nodeValue === n;
        }), r.removeChild(e), r = e = null;
      }(), function () {
        var e = j.createElement("div");
        e.appendChild(j.createComment("")), e.getElementsByTagName("*").length > 0 && (h.find.TAG = function (e, t) {
          var n = t.getElementsByTagName(e[1]);
          if ("*" === e[1]) {
            for (var r = [], i = 0; n[i]; i++) 1 === n[i].nodeType && r.push(n[i]);
            n = r;
          }
          return n;
        }), e.innerHTML = "<a href='#'></a>", e.firstChild && t !== e.firstChild.getAttribute && "#" !== e.firstChild.getAttribute("href") && (h.attrHandle.href = function (e) {
          return e.getAttribute("href", 2);
        }), e = null;
      }(), j.querySelectorAll && !function () {
        var e = d,
          t = j.createElement("div"),
          n = "__sizzle__";
        if (t.innerHTML = "<p class='TEST'></p>", !t.querySelectorAll || 0 !== t.querySelectorAll(".TEST").length) {
          d = function (t, r, i, o) {
            if (r = r || j, !o && !d.isXML(r)) {
              var a = /^(\w+$)|^\.([\w\-]+$)|^#([\w\-]+$)/.exec(t);
              if (a && (1 === r.nodeType || 9 === r.nodeType)) {
                if (a[1]) return v(r.getElementsByTagName(t), i);
                if (a[2] && h.find.CLASS && r.getElementsByClassName) return v(r.getElementsByClassName(a[2]), i);
              }
              if (9 === r.nodeType) {
                if ("body" === t && r.body) return v([r.body], i);
                if (a && a[3]) {
                  var s = r.getElementById(a[3]);
                  if (!s || !s.parentNode) return v([], i);
                  if (s.id === a[3]) return v([s], i);
                }
                try {
                  return v(r.querySelectorAll(t), i);
                } catch (l) {}
              } else if (1 === r.nodeType && "object" !== r.nodeName.toLowerCase()) {
                var u = r,
                  c = r.getAttribute("id"),
                  f = c || n,
                  p = r.parentNode,
                  m = /^\s*[+~]/.test(t);
                c ? f = f.replace(/'/g, "\\$&") : r.setAttribute("id", f), m && p && (r = r.parentNode);
                try {
                  if (!m || p) return v(r.querySelectorAll("[id='" + f + "'] " + t), i);
                } catch (g) {} finally {
                  c || u.removeAttribute("id");
                }
              }
            }
            return e(t, r, i, o);
          };
          for (var r in e) d[r] = e[r];
          t = null;
        }
      }(), function () {
        var e = j.documentElement,
          t = e.matchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || e.msMatchesSelector;
        if (t) {
          var n = !t.call(j.createElement("div"), "div"),
            r = !1;
          try {
            t.call(j.documentElement, "[test!='']:sizzle");
          } catch (i) {
            r = !0;
          }
          d.matchesSelector = function (e, i) {
            if (i = i.replace(/\=\s*([^'"\]]*)\s*\]/g, "='$1']"), !d.isXML(e)) try {
              if (r || !h.match.PSEUDO.test(i) && !/!=/.test(i)) {
                var o = t.call(e, i);
                if (o || !n || e.document && 11 !== e.document.nodeType) return o;
              }
            } catch (a) {}
            return d(i, null, null, [e]).length > 0;
          };
        }
      }(), function () {
        var e = j.createElement("div");
        e.innerHTML = "<div class='test e'></div><div class='test'></div>", e.getElementsByClassName && 0 !== e.getElementsByClassName("e").length && (e.lastChild.className = "e", 1 !== e.getElementsByClassName("e").length && (h.order.splice(1, 0, "CLASS"), h.find.CLASS = function (e, n, r) {
          return t === n.getElementsByClassName || r ? t : n.getElementsByClassName(e[1]);
        }, e = null));
      }(), d.contains = j.documentElement.contains ? function (e, t) {
        return e !== t && (e.contains ? e.contains(t) : !0);
      } : j.documentElement.compareDocumentPosition ? function (e, t) {
        return !!(16 & e.compareDocumentPosition(t));
      } : function () {
        return !1;
      }, d.isXML = function (e) {
        var t = (e ? e.ownerDocument || e : 0).documentElement;
        return t ? "HTML" !== t.nodeName : !1;
      };
      var w = function (e, t, n) {
        for (var r, i = [], o = "", a = t.nodeType ? [t] : t; r = h.match.PSEUDO.exec(e);) o += r[0], e = e.replace(h.match.PSEUDO, "");
        e = h.relative[e] ? e + "*" : e;
        for (var s = 0, l = a.length; l > s; s++) d(e, a[s], i, n);
        return d.filter(o, i);
      };
      d.attr = O.attr, d.selectors.attrMap = {}, O.find = d, O.expr = d.selectors, O.expr[":"] = O.expr.filters, O.unique = d.uniqueSort, O.text = d.getText, O.isXMLDoc = d.isXML, O.contains = d.contains;
    }();
    var st = /Until$/,
      lt = /^(?:parents|prevUntil|prevAll)/,
      ut = /,/,
      ct = /^.[^:#\[\.,]*$/,
      ft = Array.prototype.slice,
      dt = O.expr.match.globalPOS,
      pt = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
      };
    O.fn.extend({
      find: function (e) {
        var t,
          n,
          r = this;
        if ("string" != typeof e) return O(e).filter(function () {
          for (t = 0, n = r.length; n > t; t++) if (O.contains(r[t], this)) return !0;
        });
        var i,
          o,
          a,
          s = this.pushStack("", "find", e);
        for (t = 0, n = this.length; n > t; t++) if (i = s.length, O.find(e, this[t], s), t > 0) for (o = i; o < s.length; o++) for (a = 0; i > a; a++) if (s[a] === s[o]) {
          s.splice(o--, 1);
          break;
        }
        return s;
      },
      has: function (e) {
        var t = O(e);
        return this.filter(function () {
          for (var e = 0, n = t.length; n > e; e++) if (O.contains(this, t[e])) return !0;
        });
      },
      not: function (e) {
        return this.pushStack(u(this, e, !1), "not", e);
      },
      filter: function (e) {
        return this.pushStack(u(this, e, !0), "filter", e);
      },
      is: function (e) {
        return !!e && ("string" == typeof e ? dt.test(e) ? O(e, this.context).index(this[0]) >= 0 : O.filter(e, this).length > 0 : this.filter(e).length > 0);
      },
      closest: function (e, t) {
        var n,
          r,
          i = [],
          o = this[0];
        if (O.isArray(e)) {
          for (var a = 1; o && o.ownerDocument && o !== t;) {
            for (n = 0; n < e.length; n++) O(o).is(e[n]) && i.push({
              selector: e[n],
              elem: o,
              level: a
            });
            o = o.parentNode, a++;
          }
          return i;
        }
        var s = dt.test(e) || "string" != typeof e ? O(e, t || this.context) : 0;
        for (n = 0, r = this.length; r > n; n++) for (o = this[n]; o;) {
          if (s ? s.index(o) > -1 : O.find.matchesSelector(o, e)) {
            i.push(o);
            break;
          }
          if (o = o.parentNode, !o || !o.ownerDocument || o === t || 11 === o.nodeType) break;
        }
        return i = i.length > 1 ? O.unique(i) : i, this.pushStack(i, "closest", e);
      },
      index: function (e) {
        return e ? "string" == typeof e ? O.inArray(this[0], O(e)) : O.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.prevAll().length : -1;
      },
      add: function (e, t) {
        var n = "string" == typeof e ? O(e, t) : O.makeArray(e && e.nodeType ? [e] : e),
          r = O.merge(this.get(), n);
        return this.pushStack(l(n[0]) || l(r[0]) ? r : O.unique(r));
      },
      andSelf: function () {
        return this.add(this.prevObject);
      }
    }), O.each({
      parent: function (e) {
        var t = e.parentNode;
        return t && 11 !== t.nodeType ? t : null;
      },
      parents: function (e) {
        return O.dir(e, "parentNode");
      },
      parentsUntil: function (e, t, n) {
        return O.dir(e, "parentNode", n);
      },
      next: function (e) {
        return O.nth(e, 2, "nextSibling");
      },
      prev: function (e) {
        return O.nth(e, 2, "previousSibling");
      },
      nextAll: function (e) {
        return O.dir(e, "nextSibling");
      },
      prevAll: function (e) {
        return O.dir(e, "previousSibling");
      },
      nextUntil: function (e, t, n) {
        return O.dir(e, "nextSibling", n);
      },
      prevUntil: function (e, t, n) {
        return O.dir(e, "previousSibling", n);
      },
      siblings: function (e) {
        return O.sibling((e.parentNode || {}).firstChild, e);
      },
      children: function (e) {
        return O.sibling(e.firstChild);
      },
      contents: function (e) {
        return O.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : O.makeArray(e.childNodes);
      }
    }, function (e, t) {
      O.fn[e] = function (n, r) {
        var i = O.map(this, t, n);
        return st.test(e) || (r = n), r && "string" == typeof r && (i = O.filter(r, i)), i = this.length > 1 && !pt[e] ? O.unique(i) : i, (this.length > 1 || ut.test(r)) && lt.test(e) && (i = i.reverse()), this.pushStack(i, e, ft.call(arguments).join(","));
      };
    }), O.extend({
      filter: function (e, t, n) {
        return n && (e = ":not(" + e + ")"), 1 === t.length ? O.find.matchesSelector(t[0], e) ? [t[0]] : [] : O.find.matches(e, t);
      },
      dir: function (e, n, r) {
        for (var i = [], o = e[n]; o && 9 !== o.nodeType && (r === t || 1 !== o.nodeType || !O(o).is(r));) 1 === o.nodeType && i.push(o), o = o[n];
        return i;
      },
      nth: function (e, t, n) {
        t = t || 1;
        for (var r = 0; e && (1 !== e.nodeType || ++r !== t); e = e[n]);
        return e;
      },
      sibling: function (e, t) {
        for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
        return n;
      }
    });
    var ht = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
      mt = / jQuery\d+="(?:\d+|null)"/g,
      gt = /^\s+/,
      yt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
      vt = /<([\w:]+)/,
      bt = /<tbody/i,
      xt = /<|&#?\w+;/,
      Tt = /<(?:script|style)/i,
      wt = /<(?:script|object|embed|option|style)/i,
      Nt = RegExp("<(?:" + ht + ")[\\s/>]", "i"),
      Ct = /checked\s*(?:[^=]|=\s*.checked.)/i,
      Et = /\/(java|ecma)script/i,
      kt = /^\s*<!(?:\[CDATA\[|\-\-)/,
      St = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        legend: [1, "<fieldset>", "</fieldset>"],
        thead: [1, "<table>", "</table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
        area: [1, "<map>", "</map>"],
        _default: [0, "", ""]
      },
      At = c(j);
    St.optgroup = St.option, St.tbody = St.tfoot = St.colgroup = St.caption = St.thead, St.th = St.td, O.support.htmlSerialize || (St._default = [1, "div<div>", "</div>"]), O.fn.extend({
      text: function (e) {
        return O.access(this, function (e) {
          return e === t ? O.text(this) : this.empty().append((this[0] && this[0].ownerDocument || j).createTextNode(e));
        }, null, e, arguments.length);
      },
      wrapAll: function (e) {
        if (O.isFunction(e)) return this.each(function (t) {
          O(this).wrapAll(e.call(this, t));
        });
        if (this[0]) {
          var t = O(e, this[0].ownerDocument).eq(0).clone(!0);
          this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
            for (var e = this; e.firstChild && 1 === e.firstChild.nodeType;) e = e.firstChild;
            return e;
          }).append(this);
        }
        return this;
      },
      wrapInner: function (e) {
        return this.each(O.isFunction(e) ? function (t) {
          O(this).wrapInner(e.call(this, t));
        } : function () {
          var t = O(this),
            n = t.contents();
          n.length ? n.wrapAll(e) : t.append(e);
        });
      },
      wrap: function (e) {
        var t = O.isFunction(e);
        return this.each(function (n) {
          O(this).wrapAll(t ? e.call(this, n) : e);
        });
      },
      unwrap: function () {
        return this.parent().each(function () {
          O.nodeName(this, "body") || O(this).replaceWith(this.childNodes);
        }).end();
      },
      append: function () {
        return this.domManip(arguments, !0, function (e) {
          1 === this.nodeType && this.appendChild(e);
        });
      },
      prepend: function () {
        return this.domManip(arguments, !0, function (e) {
          1 === this.nodeType && this.insertBefore(e, this.firstChild);
        });
      },
      before: function () {
        if (this[0] && this[0].parentNode) return this.domManip(arguments, !1, function (e) {
          this.parentNode.insertBefore(e, this);
        });
        if (arguments.length) {
          var e = O.clean(arguments);
          return e.push.apply(e, this.toArray()), this.pushStack(e, "before", arguments);
        }
      },
      after: function () {
        if (this[0] && this[0].parentNode) return this.domManip(arguments, !1, function (e) {
          this.parentNode.insertBefore(e, this.nextSibling);
        });
        if (arguments.length) {
          var e = this.pushStack(this, "after", arguments);
          return e.push.apply(e, O.clean(arguments)), e;
        }
      },
      remove: function (e, t) {
        for (var n, r = 0; null != (n = this[r]); r++) (!e || O.filter(e, [n]).length) && (t || 1 !== n.nodeType || (O.cleanData(n.getElementsByTagName("*")), O.cleanData([n])), n.parentNode && n.parentNode.removeChild(n));
        return this;
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++) for (1 === e.nodeType && O.cleanData(e.getElementsByTagName("*")); e.firstChild;) e.removeChild(e.firstChild);
        return this;
      },
      clone: function (e, t) {
        return e = null == e ? !1 : e, t = null == t ? e : t, this.map(function () {
          return O.clone(this, e, t);
        });
      },
      html: function (e) {
        return O.access(this, function (e) {
          var n = this[0] || {},
            r = 0,
            i = this.length;
          if (e === t) return 1 === n.nodeType ? n.innerHTML.replace(mt, "") : null;
          if (!("string" != typeof e || Tt.test(e) || !O.support.leadingWhitespace && gt.test(e) || St[(vt.exec(e) || ["", ""])[1].toLowerCase()])) {
            e = e.replace(yt, "<$1></$2>");
            try {
              for (; i > r; r++) n = this[r] || {}, 1 === n.nodeType && (O.cleanData(n.getElementsByTagName("*")), n.innerHTML = e);
              n = 0;
            } catch (o) {}
          }
          n && this.empty().append(e);
        }, null, e, arguments.length);
      },
      replaceWith: function (e) {
        return this[0] && this[0].parentNode ? O.isFunction(e) ? this.each(function (t) {
          var n = O(this),
            r = n.html();
          n.replaceWith(e.call(this, t, r));
        }) : ("string" != typeof e && (e = O(e).detach()), this.each(function () {
          var t = this.nextSibling,
            n = this.parentNode;
          O(this).remove(), t ? O(t).before(e) : O(n).append(e);
        })) : this.length ? this.pushStack(O(O.isFunction(e) ? e() : e), "replaceWith", e) : this;
      },
      detach: function (e) {
        return this.remove(e, !0);
      },
      domManip: function (e, n, r) {
        var i,
          o,
          a,
          s,
          l = e[0],
          u = [];
        if (!O.support.checkClone && 3 === arguments.length && "string" == typeof l && Ct.test(l)) return this.each(function () {
          O(this).domManip(e, n, r, !0);
        });
        if (O.isFunction(l)) return this.each(function (i) {
          var o = O(this);
          e[0] = l.call(this, i, n ? o.html() : t), o.domManip(e, n, r);
        });
        if (this[0]) {
          if (s = l && l.parentNode, i = O.support.parentNode && s && 11 === s.nodeType && s.childNodes.length === this.length ? {
            fragment: s
          } : O.buildFragment(e, this, u), a = i.fragment, o = 1 === a.childNodes.length ? a = a.firstChild : a.firstChild) {
            n = n && O.nodeName(o, "tr");
            for (var c = 0, d = this.length, p = d - 1; d > c; c++) r.call(n ? f(this[c], o) : this[c], i.cacheable || d > 1 && p > c ? O.clone(a, !0, !0) : a);
          }
          u.length && O.each(u, function (e, t) {
            t.src ? O.ajax({
              type: "GET",
              global: !1,
              url: t.src,
              async: !1,
              dataType: "script"
            }) : O.globalEval((t.text || t.textContent || t.innerHTML || "").replace(kt, "/*$0*/")), t.parentNode && t.parentNode.removeChild(t);
          });
        }
        return this;
      }
    }), O.buildFragment = function (e, t, n) {
      var r,
        i,
        o,
        a,
        s = e[0];
      return t && t[0] && (a = t[0].ownerDocument || t[0]), a.createDocumentFragment || (a = j), 1 !== e.length || "string" != typeof s || s.length >= 512 || a !== j || "<" !== s.charAt(0) || wt.test(s) || !O.support.checkClone && Ct.test(s) || !O.support.html5Clone && Nt.test(s) || (i = !0, o = O.fragments[s], o && 1 !== o && (r = o)), r || (r = a.createDocumentFragment(), O.clean(e, a, r, n)), i && (O.fragments[s] = o ? r : 1), {
        fragment: r,
        cacheable: i
      };
    }, O.fragments = {}, O.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function (e, t) {
      O.fn[e] = function (n) {
        var r = [],
          i = O(n),
          o = 1 === this.length && this[0].parentNode;
        if (o && 11 === o.nodeType && 1 === o.childNodes.length && 1 === i.length) return i[t](this[0]), this;
        for (var a = 0, s = i.length; s > a; a++) {
          var l = (a > 0 ? this.clone(!0) : this).get();
          O(i[a])[t](l), r = r.concat(l);
        }
        return this.pushStack(r, e, i.selector);
      };
    }), O.extend({
      clone: function (e, t, n) {
        var r,
          i,
          o,
          a = O.support.html5Clone || O.isXMLDoc(e) || !Nt.test("<" + e.nodeName + ">") ? e.cloneNode(!0) : y(e);
        if (!(O.support.noCloneEvent && O.support.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || O.isXMLDoc(e))) for (p(e, a), r = h(e), i = h(a), o = 0; r[o]; ++o) i[o] && p(r[o], i[o]);
        if (t && (d(e, a), n)) for (r = h(e), i = h(a), o = 0; r[o]; ++o) d(r[o], i[o]);
        return r = i = null, a;
      },
      clean: function (e, n, r, i) {
        var o,
          a,
          s,
          l = [];
        n = n || j, t === n.createElement && (n = n.ownerDocument || n[0] && n[0].ownerDocument || j);
        for (var u, f = 0; null != (u = e[f]); f++) if ("number" == typeof u && (u += ""), u) {
          if ("string" == typeof u) if (xt.test(u)) {
            u = u.replace(yt, "<$1></$2>");
            var d,
              p = (vt.exec(u) || ["", ""])[1].toLowerCase(),
              h = St[p] || St._default,
              m = h[0],
              y = n.createElement("div"),
              v = At.childNodes;
            for (n === j ? At.appendChild(y) : c(n).appendChild(y), y.innerHTML = h[1] + u + h[2]; m--;) y = y.lastChild;
            if (!O.support.tbody) {
              var b = bt.test(u),
                x = "table" !== p || b ? "<table>" !== h[1] || b ? [] : y.childNodes : y.firstChild && y.firstChild.childNodes;
              for (s = x.length - 1; s >= 0; --s) O.nodeName(x[s], "tbody") && !x[s].childNodes.length && x[s].parentNode.removeChild(x[s]);
            }
            !O.support.leadingWhitespace && gt.test(u) && y.insertBefore(n.createTextNode(gt.exec(u)[0]), y.firstChild), u = y.childNodes, y && (y.parentNode.removeChild(y), v.length > 0 && (d = v[v.length - 1], d && d.parentNode && d.parentNode.removeChild(d)));
          } else u = n.createTextNode(u);
          var T;
          if (!O.support.appendChecked) if (u[0] && "number" == typeof (T = u.length)) for (s = 0; T > s; s++) g(u[s]);else g(u);
          u.nodeType ? l.push(u) : l = O.merge(l, u);
        }
        if (r) for (o = function (e) {
          return !e.type || Et.test(e.type);
        }, f = 0; l[f]; f++) if (a = l[f], i && O.nodeName(a, "script") && (!a.type || Et.test(a.type))) i.push(a.parentNode ? a.parentNode.removeChild(a) : a);else {
          if (1 === a.nodeType) {
            var w = O.grep(a.getElementsByTagName("script"), o);
            l.splice.apply(l, [f + 1, 0].concat(w));
          }
          r.appendChild(a);
        }
        return l;
      },
      cleanData: function (e) {
        for (var t, n, r, i = O.cache, o = O.event.special, a = O.support.deleteExpando, s = 0; null != (r = e[s]); s++) if ((!r.nodeName || !O.noData[r.nodeName.toLowerCase()]) && (n = r[O.expando])) {
          if (t = i[n], t && t.events) {
            for (var l in t.events) o[l] ? O.event.remove(r, l) : O.removeEvent(r, l, t.handle);
            t.handle && (t.handle.elem = null);
          }
          a ? delete r[O.expando] : r.removeAttribute && r.removeAttribute(O.expando), delete i[n];
        }
      }
    });
    var Lt,
      Dt,
      Ft,
      jt = /alpha\([^)]*\)/i,
      Mt = /opacity=([^)]*)/,
      _t = /([A-Z]|^ms)/g,
      Ot = /^[\-+]?(?:\d*\.)?\d+$/i,
      Ht = /^-?(?:\d*\.)?\d+(?!px)[^\d\s]+$/i,
      Pt = /^([\-+])=([\-+.\de]+)/,
      Bt = /^margin/,
      qt = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
      },
      Wt = ["Top", "Right", "Bottom", "Left"];
    O.fn.css = function (e, n) {
      return O.access(this, function (e, n, r) {
        return r !== t ? O.style(e, n, r) : O.css(e, n);
      }, e, n, arguments.length > 1);
    }, O.extend({
      cssHooks: {
        opacity: {
          get: function (e, t) {
            if (t) {
              var n = Lt(e, "opacity");
              return "" === n ? "1" : n;
            }
            return e.style.opacity;
          }
        }
      },
      cssNumber: {
        fillOpacity: !0,
        fontWeight: !0,
        lineHeight: !0,
        opacity: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0
      },
      cssProps: {
        "float": O.support.cssFloat ? "cssFloat" : "styleFloat"
      },
      style: function (e, n, r, i) {
        if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
          var o,
            a,
            s = O.camelCase(n),
            l = e.style,
            u = O.cssHooks[s];
          if (n = O.cssProps[s] || s, r === t) return u && "get" in u && (o = u.get(e, !1, i)) !== t ? o : l[n];
          if (a = typeof r, "string" === a && (o = Pt.exec(r)) && (r = +(o[1] + 1) * +o[2] + parseFloat(O.css(e, n)), a = "number"), !(null == r || "number" === a && isNaN(r) || ("number" !== a || O.cssNumber[s] || (r += "px"), u && "set" in u && (r = u.set(e, r)) === t))) try {
            l[n] = r;
          } catch (c) {}
        }
      },
      css: function (e, n, r) {
        var i, o;
        return n = O.camelCase(n), o = O.cssHooks[n], n = O.cssProps[n] || n, "cssFloat" === n && (n = "float"), o && "get" in o && (i = o.get(e, !0, r)) !== t ? i : Lt ? Lt(e, n) : t;
      },
      swap: function (e, t, n) {
        var r,
          i,
          o = {};
        for (i in t) o[i] = e.style[i], e.style[i] = t[i];
        r = n.call(e);
        for (i in t) e.style[i] = o[i];
        return r;
      }
    }), O.curCSS = O.css, j.defaultView && j.defaultView.getComputedStyle && (Dt = function (e, t) {
      var n,
        r,
        i,
        o,
        a = e.style;
      return t = t.replace(_t, "-$1").toLowerCase(), (r = e.ownerDocument.defaultView) && (i = r.getComputedStyle(e, null)) && (n = i.getPropertyValue(t), "" !== n || O.contains(e.ownerDocument.documentElement, e) || (n = O.style(e, t))), !O.support.pixelMargin && i && Bt.test(t) && Ht.test(n) && (o = a.width, a.width = n, n = i.width, a.width = o), n;
    }), j.documentElement.currentStyle && (Ft = function (e, t) {
      var n,
        r,
        i,
        o = e.currentStyle && e.currentStyle[t],
        a = e.style;
      return null == o && a && (i = a[t]) && (o = i), Ht.test(o) && (n = a.left, r = e.runtimeStyle && e.runtimeStyle.left, r && (e.runtimeStyle.left = e.currentStyle.left), a.left = "fontSize" === t ? "1em" : o, o = a.pixelLeft + "px", a.left = n, r && (e.runtimeStyle.left = r)), "" === o ? "auto" : o;
    }), Lt = Dt || Ft, O.each(["height", "width"], function (e, n) {
      O.cssHooks[n] = {
        get: function (e, r, i) {
          return r ? 0 !== e.offsetWidth ? v(e, n, i) : O.swap(e, qt, function () {
            return v(e, n, i);
          }) : t;
        },
        set: function (e, t) {
          return Ot.test(t) ? t + "px" : t;
        }
      };
    }), O.support.opacity || (O.cssHooks.opacity = {
      get: function (e, t) {
        return Mt.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? parseFloat(RegExp.$1) / 100 + "" : t ? "1" : "";
      },
      set: function (e, t) {
        var n = e.style,
          r = e.currentStyle,
          i = O.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
          o = r && r.filter || n.filter || "";
        n.zoom = 1, (1 > t || "" !== O.trim(o.replace(jt, "")) || (n.removeAttribute("filter"), !r || r.filter)) && (n.filter = jt.test(o) ? o.replace(jt, i) : o + " " + i);
      }
    }), O(function () {
      O.support.reliableMarginRight || (O.cssHooks.marginRight = {
        get: function (e, t) {
          return O.swap(e, {
            display: "inline-block"
          }, function () {
            return t ? Lt(e, "margin-right") : e.style.marginRight;
          });
        }
      });
    }), O.expr && O.expr.filters && (O.expr.filters.hidden = function (e) {
      var t = e.offsetWidth,
        n = e.offsetHeight;
      return 0 === t && 0 === n || !O.support.reliableHiddenOffsets && "none" === (e.style && e.style.display || O.css(e, "display"));
    }, O.expr.filters.visible = function (e) {
      return !O.expr.filters.hidden(e);
    }), O.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function (e, t) {
      O.cssHooks[e + t] = {
        expand: function (n) {
          var r,
            i = "string" == typeof n ? n.split(" ") : [n],
            o = {};
          for (r = 0; 4 > r; r++) o[e + Wt[r] + t] = i[r] || i[r - 2] || i[0];
          return o;
        }
      };
    });
    var It,
      Rt,
      $t = /%20/g,
      Xt = /\[\]$/,
      zt = /\r?\n/g,
      Vt = /#.*$/,
      Ut = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
      Gt = /^(?:color|date|datetime|datetime-local|email|hidden|month|number|password|range|search|tel|text|time|url|week)$/i,
      Yt = /^(?:about|app|app\-storage|.+\-extension|file|res|widget):$/,
      Jt = /^(?:GET|HEAD)$/,
      Kt = /^\/\//,
      Qt = /\?/,
      Zt = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
      en = /^(?:select|textarea)/i,
      tn = /\s+/,
      nn = /([?&])_=[^&]*/,
      rn = /^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+))?)?/,
      on = O.fn.load,
      an = {},
      sn = {},
      ln = ["*/"] + ["*"];
    try {
      It = _.href;
    } catch (un) {
      It = j.createElement("a"), It.href = "", It = It.href;
    }
    Rt = rn.exec(It.toLowerCase()) || [], O.fn.extend({
      load: function (e, n, r) {
        if ("string" != typeof e && on) return on.apply(this, arguments);
        if (!this.length) return this;
        var i = e.indexOf(" ");
        if (i >= 0) {
          var o = e.slice(i, e.length);
          e = e.slice(0, i);
        }
        var a = "GET";
        n && (O.isFunction(n) ? (r = n, n = t) : "object" == typeof n && (n = O.param(n, O.ajaxSettings.traditional), a = "POST"));
        var s = this;
        return O.ajax({
          url: e,
          type: a,
          dataType: "html",
          data: n,
          complete: function (e, t, n) {
            n = e.responseText, e.isResolved() && (e.done(function (e) {
              n = e;
            }), s.html(o ? O("<div>").append(n.replace(Zt, "")).find(o) : n)), r && s.each(r, [n, t, e]);
          }
        }), this;
      },
      serialize: function () {
        return O.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          return this.elements ? O.makeArray(this.elements) : this;
        }).filter(function () {
          return this.name && !this.disabled && (this.checked || en.test(this.nodeName) || Gt.test(this.type));
        }).map(function (e, t) {
          var n = O(this).val();
          return null == n ? null : O.isArray(n) ? O.map(n, function (e) {
            return {
              name: t.name,
              value: e.replace(zt, "\r\n")
            };
          }) : {
            name: t.name,
            value: n.replace(zt, "\r\n")
          };
        }).get();
      }
    }), O.each("ajaxStart ajaxStop ajaxComplete ajaxError ajaxSuccess ajaxSend".split(" "), function (e, t) {
      O.fn[t] = function (e) {
        return this.on(t, e);
      };
    }), O.each(["get", "post"], function (e, n) {
      O[n] = function (e, r, i, o) {
        return O.isFunction(r) && (o = o || i, i = r, r = t), O.ajax({
          type: n,
          url: e,
          data: r,
          success: i,
          dataType: o
        });
      };
    }), O.extend({
      getScript: function (e, n) {
        return O.get(e, t, n, "script");
      },
      getJSON: function (e, t, n) {
        return O.get(e, t, n, "json");
      },
      ajaxSetup: function (e, t) {
        return t ? T(e, O.ajaxSettings) : (t = e, e = O.ajaxSettings), T(e, t), e;
      },
      ajaxSettings: {
        url: It,
        isLocal: Yt.test(Rt[1]),
        global: !0,
        type: "GET",
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        processData: !0,
        async: !0,
        accepts: {
          xml: "application/xml, text/xml",
          html: "text/html",
          text: "text/plain",
          json: "application/json, text/javascript",
          "*": ln
        },
        contents: {
          xml: /xml/,
          html: /html/,
          json: /json/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText"
        },
        converters: {
          "* text": e.String,
          "text html": !0,
          "text json": O.parseJSON,
          "text xml": O.parseXML
        },
        flatOptions: {
          context: !0,
          url: !0
        }
      },
      ajaxPrefilter: b(an),
      ajaxTransport: b(sn),
      ajax: function (e, n) {
        function r(e, n, r, a) {
          if (2 !== T) {
            T = 2, l && clearTimeout(l), s = t, o = a || "", w.readyState = e > 0 ? 4 : 0;
            var u,
              f,
              v,
              b,
              x,
              E = n,
              k = r ? N(d, w, r) : t;
            if (e >= 200 && 300 > e || 304 === e) {
              if (d.ifModified && ((b = w.getResponseHeader("Last-Modified")) && (O.lastModified[i] = b), (x = w.getResponseHeader("Etag")) && (O.etag[i] = x)), 304 === e) E = "notmodified", u = !0;else try {
                f = C(d, k), E = "success", u = !0;
              } catch (S) {
                E = "parsererror", v = S;
              }
            } else v = E, (!E || e) && (E = "error", 0 > e && (e = 0));
            w.status = e, w.statusText = "" + (n || E), u ? m.resolveWith(p, [f, E, w]) : m.rejectWith(p, [w, E, v]), w.statusCode(y), y = t, c && h.trigger("ajax" + (u ? "Success" : "Error"), [w, d, u ? f : v]), g.fireWith(p, [w, E]), c && (h.trigger("ajaxComplete", [w, d]), --O.active || O.event.trigger("ajaxStop"));
          }
        }
        "object" == typeof e && (n = e, e = t), n = n || {};
        var i,
          o,
          a,
          s,
          l,
          u,
          c,
          f,
          d = O.ajaxSetup({}, n),
          p = d.context || d,
          h = p !== d && (p.nodeType || p instanceof O) ? O(p) : O.event,
          m = O.Deferred(),
          g = O.Callbacks("once memory"),
          y = d.statusCode || {},
          v = {},
          b = {},
          T = 0,
          w = {
            readyState: 0,
            setRequestHeader: function (e, t) {
              if (!T) {
                var n = e.toLowerCase();
                e = b[n] = b[n] || e, v[e] = t;
              }
              return this;
            },
            getAllResponseHeaders: function () {
              return 2 === T ? o : null;
            },
            getResponseHeader: function (e) {
              var n;
              if (2 === T) {
                if (!a) for (a = {}; n = Ut.exec(o);) a[n[1].toLowerCase()] = n[2];
                n = a[e.toLowerCase()];
              }
              return n === t ? null : n;
            },
            overrideMimeType: function (e) {
              return T || (d.mimeType = e), this;
            },
            abort: function (e) {
              return e = e || "abort", s && s.abort(e), r(0, e), this;
            }
          };
        if (m.promise(w), w.success = w.done, w.error = w.fail, w.complete = g.add, w.statusCode = function (e) {
          if (e) {
            var t;
            if (2 > T) for (t in e) y[t] = [y[t], e[t]];else t = e[w.status], w.then(t, t);
          }
          return this;
        }, d.url = ((e || d.url) + "").replace(Vt, "").replace(Kt, Rt[1] + "//"), d.dataTypes = O.trim(d.dataType || "*").toLowerCase().split(tn), null == d.crossDomain && (u = rn.exec(d.url.toLowerCase()), d.crossDomain = !(!u || u[1] == Rt[1] && u[2] == Rt[2] && (u[3] || ("http:" === u[1] ? 80 : 443)) == (Rt[3] || ("http:" === Rt[1] ? 80 : 443)))), d.data && d.processData && "string" != typeof d.data && (d.data = O.param(d.data, d.traditional)), x(an, d, n, w), 2 === T) return !1;
        if (c = d.global, d.type = d.type.toUpperCase(), d.hasContent = !Jt.test(d.type), c && 0 === O.active++ && O.event.trigger("ajaxStart"), !d.hasContent && (d.data && (d.url += (Qt.test(d.url) ? "&" : "?") + d.data, delete d.data), i = d.url, d.cache === !1)) {
          var E = O.now(),
            k = d.url.replace(nn, "$1_=" + E);
          d.url = k + (k === d.url ? (Qt.test(d.url) ? "&" : "?") + "_=" + E : "");
        }
        (d.data && d.hasContent && d.contentType !== !1 || n.contentType) && w.setRequestHeader("Content-Type", d.contentType), d.ifModified && (i = i || d.url, O.lastModified[i] && w.setRequestHeader("If-Modified-Since", O.lastModified[i]), O.etag[i] && w.setRequestHeader("If-None-Match", O.etag[i])), w.setRequestHeader("Accept", d.dataTypes[0] && d.accepts[d.dataTypes[0]] ? d.accepts[d.dataTypes[0]] + ("*" !== d.dataTypes[0] ? ", " + ln + "; q=0.01" : "") : d.accepts["*"]);
        for (f in d.headers) w.setRequestHeader(f, d.headers[f]);
        if (d.beforeSend && (d.beforeSend.call(p, w, d) === !1 || 2 === T)) return w.abort(), !1;
        for (f in {
          success: 1,
          error: 1,
          complete: 1
        }) w[f](d[f]);
        if (s = x(sn, d, n, w)) {
          w.readyState = 1, c && h.trigger("ajaxSend", [w, d]), d.async && d.timeout > 0 && (l = setTimeout(function () {
            w.abort("timeout");
          }, d.timeout));
          try {
            T = 1, s.send(v, r);
          } catch (S) {
            if (T >= 2) throw S;
            r(-1, S);
          }
        } else r(-1, "No Transport");
        return w;
      },
      param: function (e, n) {
        var r = [],
          i = function (e, t) {
            t = O.isFunction(t) ? t() : t, r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t);
          };
        if (n === t && (n = O.ajaxSettings.traditional), O.isArray(e) || e.jquery && !O.isPlainObject(e)) O.each(e, function () {
          i(this.name, this.value);
        });else for (var o in e) w(o, e[o], n, i);
        return r.join("&").replace($t, "+");
      }
    }), O.extend({
      active: 0,
      lastModified: {},
      etag: {}
    });
    var cn = O.now(),
      fn = /(\=)\?(&|$)|\?\?/i;
    O.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        return O.expando + "_" + cn++;
      }
    }), O.ajaxPrefilter("json jsonp", function (t, n, r) {
      var i = "string" == typeof t.data && /^application\/x\-www\-form\-urlencoded/.test(t.contentType);
      if ("jsonp" === t.dataTypes[0] || t.jsonp !== !1 && (fn.test(t.url) || i && fn.test(t.data))) {
        var o,
          a = t.jsonpCallback = O.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback,
          s = e[a],
          l = t.url,
          u = t.data,
          c = "$1" + a + "$2";
        return t.jsonp !== !1 && (l = l.replace(fn, c), t.url === l && (i && (u = u.replace(fn, c)), t.data === u && (l += (/\?/.test(l) ? "&" : "?") + t.jsonp + "=" + a))), t.url = l, t.data = u, e[a] = function (e) {
          o = [e];
        }, r.always(function () {
          e[a] = s, o && O.isFunction(s) && e[a](o[0]);
        }), t.converters["script json"] = function () {
          return o || O.error(a + " was not called"), o[0];
        }, t.dataTypes[0] = "json", "script";
      }
    }), O.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /javascript|ecmascript/
      },
      converters: {
        "text script": function (e) {
          return O.globalEval(e), e;
        }
      }
    }), O.ajaxPrefilter("script", function (e) {
      e.cache === t && (e.cache = !1), e.crossDomain && (e.type = "GET", e.global = !1);
    }), O.ajaxTransport("script", function (e) {
      if (e.crossDomain) {
        var n,
          r = j.head || j.getElementsByTagName("head")[0] || j.documentElement;
        return {
          send: function (i, o) {
            n = j.createElement("script"), n.async = "async", e.scriptCharset && (n.charset = e.scriptCharset), n.src = e.url, n.onload = n.onreadystatechange = function (e, i) {
              (i || !n.readyState || /loaded|complete/.test(n.readyState)) && (n.onload = n.onreadystatechange = null, r && n.parentNode && r.removeChild(n), n = t, i || o(200, "success"));
            }, r.insertBefore(n, r.firstChild);
          },
          abort: function () {
            n && n.onload(0, 1);
          }
        };
      }
    });
    var dn,
      pn = e.ActiveXObject ? function () {
        for (var e in dn) dn[e](0, 1);
      } : !1,
      hn = 0;
    O.ajaxSettings.xhr = e.ActiveXObject ? function () {
      return !this.isLocal && E() || k();
    } : E, function (e) {
      O.extend(O.support, {
        ajax: !!e,
        cors: !!e && "withCredentials" in e
      });
    }(O.ajaxSettings.xhr()), O.support.ajax && O.ajaxTransport(function (n) {
      if (!n.crossDomain || O.support.cors) {
        var r;
        return {
          send: function (i, o) {
            var a,
              s,
              l = n.xhr();
            if (n.username ? l.open(n.type, n.url, n.async, n.username, n.password) : l.open(n.type, n.url, n.async), n.xhrFields) for (s in n.xhrFields) l[s] = n.xhrFields[s];
            n.mimeType && l.overrideMimeType && l.overrideMimeType(n.mimeType), n.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest");
            try {
              for (s in i) l.setRequestHeader(s, i[s]);
            } catch (u) {}
            l.send(n.hasContent && n.data || null), r = function (e, i) {
              var s, u, c, f, d;
              try {
                if (r && (i || 4 === l.readyState)) if (r = t, a && (l.onreadystatechange = O.noop, pn && delete dn[a]), i) 4 !== l.readyState && l.abort();else {
                  s = l.status, c = l.getAllResponseHeaders(), f = {}, d = l.responseXML, d && d.documentElement && (f.xml = d);
                  try {
                    f.text = l.responseText;
                  } catch (e) {}
                  try {
                    u = l.statusText;
                  } catch (p) {
                    u = "";
                  }
                  s || !n.isLocal || n.crossDomain ? 1223 === s && (s = 204) : s = f.text ? 200 : 404;
                }
              } catch (h) {
                i || o(-1, h);
              }
              f && o(s, u, f, c);
            }, n.async && 4 !== l.readyState ? (a = ++hn, pn && (dn || (dn = {}, O(e).unload(pn)), dn[a] = r), l.onreadystatechange = r) : r();
          },
          abort: function () {
            r && r(0, 1);
          }
        };
      }
    });
    var mn,
      gn,
      yn,
      vn,
      bn = {},
      xn = /^(?:toggle|show|hide)$/,
      Tn = /^([+\-]=)?([\d+.\-]+)([a-z%]*)$/i,
      wn = [["height", "marginTop", "marginBottom", "paddingTop", "paddingBottom"], ["width", "marginLeft", "marginRight", "paddingLeft", "paddingRight"], ["opacity"]];
    O.fn.extend({
      show: function (e, t, n) {
        var r, i;
        if (e || 0 === e) return this.animate(L("show", 3), e, t, n);
        for (var o = 0, a = this.length; a > o; o++) r = this[o], r.style && (i = r.style.display, O._data(r, "olddisplay") || "none" !== i || (i = r.style.display = ""), ("" === i && "none" === O.css(r, "display") || !O.contains(r.ownerDocument.documentElement, r)) && O._data(r, "olddisplay", D(r.nodeName)));
        for (o = 0; a > o; o++) r = this[o], r.style && (i = r.style.display, ("" === i || "none" === i) && (r.style.display = O._data(r, "olddisplay") || ""));
        return this;
      },
      hide: function (e, t, n) {
        if (e || 0 === e) return this.animate(L("hide", 3), e, t, n);
        for (var r, i, o = 0, a = this.length; a > o; o++) r = this[o], r.style && (i = O.css(r, "display"), "none" === i || O._data(r, "olddisplay") || O._data(r, "olddisplay", i));
        for (o = 0; a > o; o++) this[o].style && (this[o].style.display = "none");
        return this;
      },
      _toggle: O.fn.toggle,
      toggle: function (e, t, n) {
        var r = "boolean" == typeof e;
        return O.isFunction(e) && O.isFunction(t) ? this._toggle.apply(this, arguments) : null == e || r ? this.each(function () {
          var t = r ? e : O(this).is(":hidden");
          O(this)[t ? "show" : "hide"]();
        }) : this.animate(L("toggle", 3), e, t, n), this;
      },
      fadeTo: function (e, t, n, r) {
        return this.filter(":hidden").css("opacity", 0).show().end().animate({
          opacity: t
        }, e, n, r);
      },
      animate: function (e, t, n, r) {
        function i() {
          o.queue === !1 && O._mark(this);
          var t,
            n,
            r,
            i,
            a,
            s,
            l,
            u,
            c,
            f,
            d,
            p = O.extend({}, o),
            h = 1 === this.nodeType,
            m = h && O(this).is(":hidden");
          p.animatedProperties = {};
          for (r in e) if (t = O.camelCase(r), r !== t && (e[t] = e[r], delete e[r]), (a = O.cssHooks[t]) && "expand" in a) {
            s = a.expand(e[t]), delete e[t];
            for (r in s) r in e || (e[r] = s[r]);
          }
          for (t in e) {
            if (n = e[t], O.isArray(n) ? (p.animatedProperties[t] = n[1], n = e[t] = n[0]) : p.animatedProperties[t] = p.specialEasing && p.specialEasing[t] || p.easing || "swing", "hide" === n && m || "show" === n && !m) return p.complete.call(this);
            !h || "height" !== t && "width" !== t || (p.overflow = [this.style.overflow, this.style.overflowX, this.style.overflowY], "inline" === O.css(this, "display") && "none" === O.css(this, "float") && (O.support.inlineBlockNeedsLayout && "inline" !== D(this.nodeName) ? this.style.zoom = 1 : this.style.display = "inline-block"));
          }
          null != p.overflow && (this.style.overflow = "hidden");
          for (r in e) i = new O.fx(this, p, r), n = e[r], xn.test(n) ? (d = O._data(this, "toggle" + r) || ("toggle" === n ? m ? "show" : "hide" : 0), d ? (O._data(this, "toggle" + r, "show" === d ? "hide" : "show"), i[d]()) : i[n]()) : (l = Tn.exec(n), u = i.cur(), l ? (c = parseFloat(l[2]), f = l[3] || (O.cssNumber[r] ? "" : "px"), "px" !== f && (O.style(this, r, (c || 1) + f), u = (c || 1) / i.cur() * u, O.style(this, r, u + f)), l[1] && (c = ("-=" === l[1] ? -1 : 1) * c + u), i.custom(u, c, f)) : i.custom(u, n, ""));
          return !0;
        }
        var o = O.speed(t, n, r);
        return O.isEmptyObject(e) ? this.each(o.complete, [!1]) : (e = O.extend({}, e), o.queue === !1 ? this.each(i) : this.queue(o.queue, i));
      },
      stop: function (e, n, r) {
        return "string" != typeof e && (r = n, n = e, e = t), n && e !== !1 && this.queue(e || "fx", []), this.each(function () {
          function t(e, t, n) {
            var i = t[n];
            O.removeData(e, n, !0), i.stop(r);
          }
          var n,
            i = !1,
            o = O.timers,
            a = O._data(this);
          if (r || O._unmark(!0, this), null == e) for (n in a) a[n] && a[n].stop && n.indexOf(".run") === n.length - 4 && t(this, a, n);else a[n = e + ".run"] && a[n].stop && t(this, a, n);
          for (n = o.length; n--;) o[n].elem !== this || null != e && o[n].queue !== e || (r ? o[n](!0) : o[n].saveState(), i = !0, o.splice(n, 1));
          r && i || O.dequeue(this, e);
        });
      }
    }), O.each({
      slideDown: L("show", 1),
      slideUp: L("hide", 1),
      slideToggle: L("toggle", 1),
      fadeIn: {
        opacity: "show"
      },
      fadeOut: {
        opacity: "hide"
      },
      fadeToggle: {
        opacity: "toggle"
      }
    }, function (e, t) {
      O.fn[e] = function (e, n, r) {
        return this.animate(t, e, n, r);
      };
    }), O.extend({
      speed: function (e, t, n) {
        var r = e && "object" == typeof e ? O.extend({}, e) : {
          complete: n || !n && t || O.isFunction(e) && e,
          duration: e,
          easing: n && t || t && !O.isFunction(t) && t
        };
        return r.duration = O.fx.off ? 0 : "number" == typeof r.duration ? r.duration : r.duration in O.fx.speeds ? O.fx.speeds[r.duration] : O.fx.speeds._default, (null == r.queue || r.queue === !0) && (r.queue = "fx"), r.old = r.complete, r.complete = function (e) {
          O.isFunction(r.old) && r.old.call(this), r.queue ? O.dequeue(this, r.queue) : e !== !1 && O._unmark(this);
        }, r;
      },
      easing: {
        linear: function (e) {
          return e;
        },
        swing: function (e) {
          return -Math.cos(e * Math.PI) / 2 + .5;
        }
      },
      timers: [],
      fx: function (e, t, n) {
        this.options = t, this.elem = e, this.prop = n, t.orig = t.orig || {};
      }
    }), O.fx.prototype = {
      update: function () {
        this.options.step && this.options.step.call(this.elem, this.now, this), (O.fx.step[this.prop] || O.fx.step._default)(this);
      },
      cur: function () {
        if (null != this.elem[this.prop] && (!this.elem.style || null == this.elem.style[this.prop])) return this.elem[this.prop];
        var e,
          t = O.css(this.elem, this.prop);
        return isNaN(e = parseFloat(t)) ? t && "auto" !== t ? t : 0 : e;
      },
      custom: function (e, n, r) {
        function i(e) {
          return o.step(e);
        }
        var o = this,
          a = O.fx;
        this.startTime = vn || S(), this.end = n, this.now = this.start = e, this.pos = this.state = 0, this.unit = r || this.unit || (O.cssNumber[this.prop] ? "" : "px"), i.queue = this.options.queue, i.elem = this.elem, i.saveState = function () {
          O._data(o.elem, "fxshow" + o.prop) === t && (o.options.hide ? O._data(o.elem, "fxshow" + o.prop, o.start) : o.options.show && O._data(o.elem, "fxshow" + o.prop, o.end));
        }, i() && O.timers.push(i) && !yn && (yn = setInterval(a.tick, a.interval));
      },
      show: function () {
        var e = O._data(this.elem, "fxshow" + this.prop);
        this.options.orig[this.prop] = e || O.style(this.elem, this.prop), this.options.show = !0, e !== t ? this.custom(this.cur(), e) : this.custom("width" === this.prop || "height" === this.prop ? 1 : 0, this.cur()), O(this.elem).show();
      },
      hide: function () {
        this.options.orig[this.prop] = O._data(this.elem, "fxshow" + this.prop) || O.style(this.elem, this.prop), this.options.hide = !0, this.custom(this.cur(), 0);
      },
      step: function (e) {
        var t,
          n,
          r,
          i = vn || S(),
          o = !0,
          a = this.elem,
          s = this.options;
        if (e || i >= s.duration + this.startTime) {
          this.now = this.end, this.pos = this.state = 1, this.update(), s.animatedProperties[this.prop] = !0;
          for (t in s.animatedProperties) s.animatedProperties[t] !== !0 && (o = !1);
          if (o) {
            if (null == s.overflow || O.support.shrinkWrapBlocks || O.each(["", "X", "Y"], function (e, t) {
              a.style["overflow" + t] = s.overflow[e];
            }), s.hide && O(a).hide(), s.hide || s.show) for (t in s.animatedProperties) O.style(a, t, s.orig[t]), O.removeData(a, "fxshow" + t, !0), O.removeData(a, "toggle" + t, !0);
            r = s.complete, r && (s.complete = !1, r.call(a));
          }
          return !1;
        }
        return 1 / 0 == s.duration ? this.now = i : (n = i - this.startTime, this.state = n / s.duration, this.pos = O.easing[s.animatedProperties[this.prop]](this.state, n, 0, 1, s.duration), this.now = this.start + (this.end - this.start) * this.pos), this.update(), !0;
      }
    }, O.extend(O.fx, {
      tick: function () {
        for (var e, t = O.timers, n = 0; n < t.length; n++) e = t[n], e() || t[n] !== e || t.splice(n--, 1);
        t.length || O.fx.stop();
      },
      interval: 13,
      stop: function () {
        clearInterval(yn), yn = null;
      },
      speeds: {
        slow: 600,
        fast: 200,
        _default: 400
      },
      step: {
        opacity: function (e) {
          O.style(e.elem, "opacity", e.now);
        },
        _default: function (e) {
          e.elem.style && null != e.elem.style[e.prop] ? e.elem.style[e.prop] = e.now + e.unit : e.elem[e.prop] = e.now;
        }
      }
    }), O.each(wn.concat.apply([], wn), function (e, t) {
      t.indexOf("margin") && (O.fx.step[t] = function (e) {
        O.style(e.elem, t, Math.max(0, e.now) + e.unit);
      });
    }), O.expr && O.expr.filters && (O.expr.filters.animated = function (e) {
      return O.grep(O.timers, function (t) {
        return e === t.elem;
      }).length;
    });
    var Nn,
      Cn = /^t(?:able|d|h)$/i,
      En = /^(?:body|html)$/i;
    Nn = "getBoundingClientRect" in j.documentElement ? function (e, t, n, r) {
      try {
        r = e.getBoundingClientRect();
      } catch (i) {}
      if (!r || !O.contains(n, e)) return r ? {
        top: r.top,
        left: r.left
      } : {
        top: 0,
        left: 0
      };
      var o = t.body,
        a = F(t),
        s = n.clientTop || o.clientTop || 0,
        l = n.clientLeft || o.clientLeft || 0,
        u = a.pageYOffset || O.support.boxModel && n.scrollTop || o.scrollTop,
        c = a.pageXOffset || O.support.boxModel && n.scrollLeft || o.scrollLeft,
        f = r.top + u - s,
        d = r.left + c - l;
      return {
        top: f,
        left: d
      };
    } : function (e, t, n) {
      for (var r, i = e.offsetParent, o = e, a = t.body, s = t.defaultView, l = s ? s.getComputedStyle(e, null) : e.currentStyle, u = e.offsetTop, c = e.offsetLeft; (e = e.parentNode) && e !== a && e !== n && (!O.support.fixedPosition || "fixed" !== l.position);) r = s ? s.getComputedStyle(e, null) : e.currentStyle, u -= e.scrollTop, c -= e.scrollLeft, e === i && (u += e.offsetTop, c += e.offsetLeft, !O.support.doesNotAddBorder || O.support.doesAddBorderForTableAndCells && Cn.test(e.nodeName) || (u += parseFloat(r.borderTopWidth) || 0, c += parseFloat(r.borderLeftWidth) || 0), o = i, i = e.offsetParent), O.support.subtractsBorderForOverflowNotVisible && "visible" !== r.overflow && (u += parseFloat(r.borderTopWidth) || 0, c += parseFloat(r.borderLeftWidth) || 0), l = r;
      return ("relative" === l.position || "static" === l.position) && (u += a.offsetTop, c += a.offsetLeft), O.support.fixedPosition && "fixed" === l.position && (u += Math.max(n.scrollTop, a.scrollTop), c += Math.max(n.scrollLeft, a.scrollLeft)), {
        top: u,
        left: c
      };
    }, O.fn.offset = function (e) {
      if (arguments.length) return e === t ? this : this.each(function (t) {
        O.offset.setOffset(this, e, t);
      });
      var n = this[0],
        r = n && n.ownerDocument;
      return r ? n === r.body ? O.offset.bodyOffset(n) : Nn(n, r, r.documentElement) : null;
    }, O.offset = {
      bodyOffset: function (e) {
        var t = e.offsetTop,
          n = e.offsetLeft;
        return O.support.doesNotIncludeMarginInBodyOffset && (t += parseFloat(O.css(e, "marginTop")) || 0, n += parseFloat(O.css(e, "marginLeft")) || 0), {
          top: t,
          left: n
        };
      },
      setOffset: function (e, t, n) {
        var r = O.css(e, "position");
        "static" === r && (e.style.position = "relative");
        var i,
          o,
          a = O(e),
          s = a.offset(),
          l = O.css(e, "top"),
          u = O.css(e, "left"),
          c = ("absolute" === r || "fixed" === r) && O.inArray("auto", [l, u]) > -1,
          f = {},
          d = {};
        c ? (d = a.position(), i = d.top, o = d.left) : (i = parseFloat(l) || 0, o = parseFloat(u) || 0), O.isFunction(t) && (t = t.call(e, n, s)), null != t.top && (f.top = t.top - s.top + i), null != t.left && (f.left = t.left - s.left + o), "using" in t ? t.using.call(e, f) : a.css(f);
      }
    }, O.fn.extend({
      position: function () {
        if (!this[0]) return null;
        var e = this[0],
          t = this.offsetParent(),
          n = this.offset(),
          r = En.test(t[0].nodeName) ? {
            top: 0,
            left: 0
          } : t.offset();
        return n.top -= parseFloat(O.css(e, "marginTop")) || 0, n.left -= parseFloat(O.css(e, "marginLeft")) || 0, r.top += parseFloat(O.css(t[0], "borderTopWidth")) || 0, r.left += parseFloat(O.css(t[0], "borderLeftWidth")) || 0, {
          top: n.top - r.top,
          left: n.left - r.left
        };
      },
      offsetParent: function () {
        return this.map(function () {
          for (var e = this.offsetParent || j.body; e && !En.test(e.nodeName) && "static" === O.css(e, "position");) e = e.offsetParent;
          return e;
        });
      }
    }), O.each({
      scrollLeft: "pageXOffset",
      scrollTop: "pageYOffset"
    }, function (e, n) {
      var r = /Y/.test(n);
      O.fn[e] = function (i) {
        return O.access(this, function (e, i, o) {
          var a = F(e);
          return o === t ? a ? n in a ? a[n] : O.support.boxModel && a.document.documentElement[i] || a.document.body[i] : e[i] : (a ? a.scrollTo(r ? O(a).scrollLeft() : o, r ? o : O(a).scrollTop()) : e[i] = o, t);
        }, e, i, arguments.length, null);
      };
    }), O.each({
      Height: "height",
      Width: "width"
    }, function (e, n) {
      var r = "client" + e,
        i = "scroll" + e,
        o = "offset" + e;
      O.fn["inner" + e] = function () {
        var e = this[0];
        return e ? e.style ? parseFloat(O.css(e, n, "padding")) : this[n]() : null;
      }, O.fn["outer" + e] = function (e) {
        var t = this[0];
        return t ? t.style ? parseFloat(O.css(t, n, e ? "margin" : "border")) : this[n]() : null;
      }, O.fn[n] = function (e) {
        return O.access(this, function (e, n, a) {
          var s, l, u, c;
          return O.isWindow(e) ? (s = e.document, l = s.documentElement[r], O.support.boxModel && l || s.body && s.body[r] || l) : 9 === e.nodeType ? (s = e.documentElement, s[r] < s[i] ? Math.max(e.body[i], s[i], e.body[o], s[o]) : s[r]) : a === t ? (u = O.css(e, n), c = parseFloat(u), O.isNumeric(c) ? c : u) : (O(e).css(n, a), t);
        }, n, e, arguments.length, null);
      };
    }), Analytics.wdwQuery = O;
  })(window);
  inject.store('jQuery', 'wdwQuery', '$', Analytics.wdwQuery);
  inject.store('extend', Analytics.wdwQuery.extend);
  if (!Array.from) {
    Array.from = function () {
      var toStr = Object.prototype.toString;
      var isCallable = function (fn) {
        return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
      };
      var toInteger = function (value) {
        var number = Number(value);
        if (isNaN(number)) {
          return 0;
        }
        if (number === 0 || !isFinite(number)) {
          return number;
        }
        return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
      };
      var maxSafeInteger = Math.pow(2, 53) - 1;
      var toLength = function (value) {
        var len = toInteger(value);
        return Math.min(Math.max(len, 0), maxSafeInteger);
      };

      // The length property of the from method is 1.
      return function from(arrayLike /*, mapFn, thisArg */) {
        // 1. Let C be the this value.
        var C = this;

        // 2. Let items be ToObject(arrayLike).
        var items = Object(arrayLike);

        // 3. ReturnIfAbrupt(items).
        if (arrayLike == null) {
          throw new TypeError('Array.from requires an array-like object - not null or undefined');
        }

        // 4. If mapfn is undefined, then let mapping be false.
        var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
        var T;
        if (typeof mapFn !== 'undefined') {
          // 5. else
          // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
          if (!isCallable(mapFn)) {
            throw new TypeError('Array.from: when provided, the second argument must be a function');
          }

          // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
          if (arguments.length > 2) {
            T = arguments[2];
          }
        }

        // 10. Let lenValue be Get(items, "length").
        // 11. Let len be ToLength(lenValue).
        var len = toLength(items.length);

        // 13. If IsConstructor(C) is true, then
        // 13. a. Let A be the result of calling the [[Construct]] internal method 
        // of C with an argument list containing the single item len.
        // 14. a. Else, Let A be ArrayCreate(len).
        var A = isCallable(C) ? Object(new C(len)) : new Array(len);

        // 16. Let k be 0.
        var k = 0;
        // 17. Repeat, while k < len… (also steps a - h)
        var kValue;
        while (k < len) {
          kValue = items[k];
          if (mapFn) {
            A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
          } else {
            A[k] = kValue;
          }
          k += 1;
        }
        // 18. Let putStatus be Put(A, "length", len, true).
        A.length = len;
        // 20. Return A.
        return A;
      };
    }();
  }
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function (predicate) {
        // 1. Let O be ? ToObject(this value).
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return kValue.
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }
          // e. Increase k by 1.
          k++;
        }

        // 7. Return undefined.
        return undefined;
      },
      configurable: true,
      writable: true
    });
  }
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
  if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
      value: function (predicate) {
        // 1. Let O be ? ToObject(this value).
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return k.
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return k;
          }
          // e. Increase k by 1.
          k++;
        }

        // 7. Return -1.
        return -1;
      },
      configurable: true,
      writable: true
    });
  }
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
  if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
      value: function (searchElement, fromIndex) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        // 1. Let O be ? ToObject(this value).
        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If len is 0, return false.
        if (len === 0) {
          return false;
        }

        // 4. Let n be ? ToInteger(fromIndex).
        //    (If fromIndex is undefined, this step produces the value 0.)
        var n = fromIndex | 0;

        // 5. If n ≥ 0, then
        //  a. Let k be n.
        // 6. Else n < 0,
        //  a. Let k be len + n.
        //  b. If k < 0, let k be 0.
        var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
        function sameValueZero(x, y) {
          return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
        }

        // 7. Repeat, while k < len
        while (k < len) {
          // a. Let elementK be the result of ? Get(O, ! ToString(k)).
          // b. If SameValueZero(searchElement, elementK) is true, return true.
          if (sameValueZero(o[k], searchElement)) {
            return true;
          }
          // c. Increase k by 1. 
          k++;
        }

        // 8. Return false
        return false;
      },
      configurable: true,
      writable: true
    });
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
  if (!String.prototype.endsWith) {
    Object.defineProperty(String.prototype, 'endsWith', {
      value: function (search, this_len) {
        if (this_len === undefined || this_len > this.length) {
          this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
      },
      configurable: true,
      writable: true
    });
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
  if (!String.prototype.includes) {
    Object.defineProperty(String.prototype, 'includes', {
      value: function (search, start) {
        if (typeof start !== 'number') {
          start = 0;
        }
        if (start + search.length > this.length) {
          return false;
        } else {
          return this.indexOf(search, start) !== -1;
        }
      },
      configurable: true,
      writable: true
    });
  }
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
  if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
      value: function (search, rawPos) {
        var pos = rawPos > 0 ? rawPos | 0 : 0;
        return this.substring(pos, pos + search.length) === search;
      },
      configurable: true,
      writable: true
    });
  }

  /* global inject */
  inject.store('objForEach', function objForEach(obj, callback, thisArg) {
    var key;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) {
        callback.call(thisArg, obj[key], key, obj);
      }
    }
  });

  /* global inject */
  inject((store, objForEach) => {
    store('storeMultiple', function storeMultiple(obj) {
      objForEach(obj, (value, key) => store(key, value));
    });
  }, 'store', 'objForEach');

  /* global inject */
  inject.store('isObject', obj => Object.prototype.toString.call(obj) === '[object Object]');

  /* global inject */
  inject((storeMultiple, resolve, isObject) => {
    const topics = {};
    let d; // Debug object is not yet availble at instantiation
    let nl; // netlog object is not yet available at instantiation

    storeMultiple({
      publish,
      subscribe,
      unsubscribe
    });

    // PUBSUB API FUNCTIONS

    /**
     * Publish an event to a topic
     * @example
     * publish({topic: 'datalayer.postnormalize', datalayer: {...}});
     * @param    {Object}  pubObj         the data object passed to subscribers
     * @property {string}  pubObj.topic   Required topic name
     * @property {*}      [pubObj.<any>]  Any other event-specific fields
     * @returns  {undefined}
     */
    function publish(pubObj) {
      if (!_isPublishPubObj(pubObj)) publish({
        topic: 'publish.precheck',
        pubObj
      });
      const pubObjIsObject = isObject(pubObj);
      const pubObjTopicIsString = pubObjIsObject && typeof pubObj.topic === 'string';
      if (!pubObjIsObject || !pubObjTopicIsString) {
        publish({
          topic: 'publish.error.signature',
          pubObj,
          errors: [...(!pubObjIsObject ? ['pubObj must be an object'] : []), ...(!pubObjTopicIsString ? ['topic must be a string'] : [])]
        });
        return;
      }
      const topicArr = _getSubscriptions(pubObj.topic);
      topicArr.forEach(subObj => {
        try {
          subObj.handler(pubObj);
        } catch (error) {
          if (!_isPublishPubObj(pubObj)) publish({
            topic: 'publish.error.handler',
            pubObj,
            subObj,
            error
          });
        }
      });
      if (!_isPublishPubObj(pubObj)) publish({
        topic: 'publish.success',
        pubObj,
        topicArr: [...topicArr],
        topics
      });
    }

    /**
     * Subscribe to events published to a topic
     * @example
     * subscribe({topic: 'datalayer.postnormalize', handler: o => console.log(o.data)});
     * @param {Object} subObj
     * @param {string} subObj.topic the topic subscribed to
     * @param {function} subObj.handler receives the published object associated with the matching topic or filter
     * @returns {(function|false)} a bound unsubscribe that allows easy unbinding without saving a reference to the subObj, truthy. Or false if the the subObj does not conform to the necessary signature.
     */
    function subscribe(subObj) {
      publish({
        topic: 'subscribe.precheck',
        subObj
      });
      const subObjIsObject = isObject(subObj);
      const subObjTopicIsString = subObjIsObject && typeof subObj.topic === 'string';
      const subObjHandlerIsFunction = subObjIsObject && typeof subObj.handler === 'function';
      if (!subObjIsObject || !subObjTopicIsString || !subObjHandlerIsFunction) {
        publish({
          topic: 'subscribe.error',
          subObj,
          errors: [...(!subObjIsObject ? ['subObj must be an object'] : []), ...(!subObjTopicIsString ? ['topic must be a string'] : []), ...(!subObjHandlerIsFunction ? ['handler must be a function'] : [])]
        });
        return false;
      }
      const topicArr = _getSubscriptions(subObj.topic);
      const newLength = topicArr.push(subObj);
      const unsubReturn = unsubscribe.bind(null, subObj);
      publish({
        topic: 'subscribe.success',
        subObj,
        topicArr: [...topicArr],
        newLength,
        unsubReturn,
        topics
      });
      return unsubReturn;
    }

    /**
     * Allows for removing the subscription to the topic
     * @param {Object} originalSubObj the original object that was used for subscription
     * @returns {undefined}
     */
    function unsubscribe(originalSubObj) {
      const {
        topic
      } = originalSubObj;
      if (typeof topic !== 'string' || !topics[topic]) return;
      topics[topic] = topics[topic].filter(subObj => subObj !== originalSubObj);
    }

    // HELPER FUNCTIONS (private to this module)

    /**
     * Get the subscriptions array for a topic
     * @param {string} topic
     * @returns the array for a specific topic that may already contain subscriptions
     */
    function _getSubscriptions(topic) {
      return topics[topic] || (topics[topic] = []);
    }

    /**
     * Check if the object is a publish object
     * @param {any} pubObj
     * @returns {boolean} true if the object is a publish object
     */
    function _isPublishPubObj(pubObj) {
      return isObject(pubObj) && typeof pubObj.topic === 'string' && pubObj.topic.startsWith('publish');
    }

    /**
     * Log to the Debug logger (lazy load the Debug object since it's instantiated after this module)
     * @param {...*} args
     * @returns {undefined}
     */
    function _log(...args) {
      if (!d) d = resolve('Debug');
      d?.log?.(...args);
    }

    /**
     * Log to the netlog (lazy load the netlog function since it's instantiated after this module)
     * @param {...*} args
     * @returns {undefined}
     */
    function _netlog(...args) {
      if (!nl) nl = resolve('netlog');
      nl?.(...args);
    }

    // Log error conditions and debugging information

    subscribe({
      topic: 'subscribe.error',
      handler: ({
        errors,
        subObj
      }) => {
        _log(`subscribe arguments error - ${errors.join(', ')}`, subObj);
        _netlog({
          app: 'JSAF',
          category: 'subscribe error',
          action: subObj?.topic || 'no topic',
          errors,
          subObj,
          sampling: 1 / 50
        });
      }
    });
    subscribe({
      topic: 'subscribe.success',
      handler: o => _log('subscribe', o)
    });
    subscribe({
      topic: 'publish.error.signature',
      handler: ({
        errors,
        pubObj
      }) => {
        _log(`publish arguments error - ${errors.join(', ')}`, pubObj);
        _netlog({
          app: 'JSAF',
          category: 'publish error',
          action: pubObj?.topic || 'no topic',
          errors,
          pubObj,
          sampling: 1 / 50
        });
      }
    });
    subscribe({
      topic: 'publish.error.handler',
      handler: ({
        error,
        pubObj,
        subObj
      }) => {
        _log(`publish handler error - ${error.message}`, pubObj, subObj, error);
        _netlog({
          app: 'JSAF',
          category: 'publish error',
          action: pubObj.topic,
          error,
          pubObj,
          subObj,
          sampling: 1 / 50
        });
      }
    });
    subscribe({
      topic: 'publish.success',
      handler: o => _log('publish', o.pubObj.topic, o)
    });
  }, 'storeMultiple', 'resolve', 'isObject');

  /* global inject */
  inject((Analytics, store, console, subscribe) => {
    const Debug = Analytics.Debug = store('Debug', {
      setDebug
    });
    Debug.setDebug(false);
    subscribe({
      topic: 'framework.start',
      handler: () => inject((toBoolean, getURLParameter, sessionStorage) => Debug.setDebug(toBoolean(getURLParameter('AnalyticsDbg')) || toBoolean(sessionStorage.getItem('AnalyticsDbg'))), 'toBoolean', 'getURLParameter', 'sessionStorage')
    });
    function setDebug(enableDbg) {
      if (this.isEnabled = Boolean(enableDbg)) {
        enable();
        this.info('Analytics Debug Enabled');
      } else {
        disable();
      }
    }
    function enable() {
      ['info', 'log', 'debug', 'warn', 'error'].forEach(lvl => {
        Debug[lvl] = logFn(lvl);
      });
    }
    function disable() {
      Debug.info = Debug.log = Debug.debug = Debug.warn = Debug.error = noop;
    }
    function logFn(type) {
      return console && console[type] ? console[type].bind(console) : noop;
    }
    function noop() {}
  }, 'Analytics', 'store', 'console', 'subscribe');

  /* global inject */
  inject((store, Debug, isObject) => {
    store('netlog', netlog);

    /* Example:
    netlog({
        app: 'JSAF',
        category: 'blank_product_error',
        action: prodStr,
        data: ['whatever', 1, 2, false],
        sampling: 0.05
    });
    */
    function netlog({
      app = 'NS',
      sampling = false,
      page = location.href,
      ...restObj
    }) {
      let logToGO4 = true;
      let _sampleWeight = 1;
      if (sampling !== false) {
        if (typeof sampling !== 'number' || isNaN(sampling) || sampling < 0 || sampling > 1) {
          Debug.warn('netlog sampling value should be a number between 0 and 1');
        } else if (sampling === 0 || Math.random() > sampling) {
          logToGO4 = false;
        } else {
          _sampleWeight = calculateSampleWeight(sampling);
        }
      }
      const logObj = {
        app,
        ...restObj,
        page,
        _sampleWeight
      };
      Debug.log(logObj);
      if (logToGO4 && typeof window.GO4?.log === 'function') {
        window.GO4.log(serializableClone(logObj));
      }
      return logToGO4;
    }
    function serializableClone(obj) {
      if (isError(obj)) {
        // If the item is an error, serialize it
        return serializableError(obj);
      } else if (Array.isArray(obj)) {
        // If it's an array, process each element
        return obj.map(serializableClone);
      } else if (isObject(obj)) {
        // If it's an object, process each key
        const processedObj = {};
        for (const key in obj) {
          processedObj[key] = serializableClone(obj[key]);
        }
        return processedObj;
      } else {
        // Non-object, non-array, non-error values are returned as is
        return obj;
      }
    }
    function isError(item) {
      return item instanceof Error;
    }
    function serializableError(error) {
      // Converts an Error object into a serializable format.
      return {
        message: error.message,
        stack: error.stack
      };
    }
    function calculateSampleWeight(sampling) {
      // returns a number rounded to 2 decimals
      return Number((1 / sampling).toFixed(2));
    }
  }, 'store', 'Debug', 'isObject');

  /* global inject */
  inject.store('dateDaysFromNow', days => new Date(Date.now() + days * 86400000));

  /* global inject */
  inject.store('safeJsonParse', function safeJsonParse(value, reviver) {
    try {
      value = JSON.parse(value, reviver);
    } catch (e) {/* ignore */}
    return value;
  });

  /* global inject */
  inject(store => {
    store('isNumber', isNumber);
    function isNumber(val) {
      return typeof val === 'number' && !Number.isNaN(val);
    }
  }, 'store');
  /* global inject */
  inject.store('objFirstProp', obj => Object.keys(obj)[0]);

  /* global inject */
  inject((store, objForEach, noop, passthrough, DONE) => {
    store('xhr', ({
      url,
      method = 'GET',
      headers = {},
      data = null,
      success = noop,
      successProp = 'responseText',
      successStatusMin = 200,
      successStatusMax = 299,
      successTransform = passthrough,
      failure = noop
    } = {}) => {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url);
      objForEach(headers, (key, val) => xhr.setRequestHeader(key, val));
      xhr.onreadystatechange = function () {
        if (xhr.readyState === DONE) {
          if (xhr.status >= successStatusMin && xhr.status <= successStatusMax) {
            success(successTransform(xhr[successProp]));
          } else {
            failure(xhr);
          }
        }
      };
      xhr.send(data);
      return xhr;
    });
  }, 'store', 'objForEach', () => {}, v => v, 4);

  /* global inject */

  /* inject */
  inject(store => {
    store('querySelector', query.bind(null, 'querySelector', null));
    store('querySelectorAll', query.bind(null, 'querySelectorAll', document.querySelectorAll('noMatchingSelectorSoAnEmptyNodeListIsReturned')));
    function query(type, defaultVal, selector, node = document) {
      if (node && typeof node[type] === 'function' && typeof selector === 'string') {
        try {
          return node[type](selector);
        } catch (e) {/* ignore */}
      }
      return defaultVal;
    }
  }, 'store');

  /**
   * Wait for an element or condition and then execute your callback
   * @param {Object} config -
   * @param {(string|function|string[]|function[])} config.location - the string reference to search for on base object or a function to execute to return a truthy value
   * @param {function} config.callback - function to receive the locations value once they're found
   * @param {number} [config.timeout=30000] - how many milliseconds after which to give up and call the failCallback
   * @param {number} [config.interval=250] - how often during the timeout period to keep looking
   * @param {Object} [config.base=window] - base object on which to find string locations
   * @param {(function|'failLogging')} [config.failCallback=noop] - function to call if locations are not found before the timeout
   * @example
   * waitFor({
   *     location: [
   *         'jQuery',
   *         ($) => $('button.checkout')
   *     ],
   *     callback: ($, $btn) => {
   *         $btn.text('Checkout').on('click', function(e){...});
   *     }
   * });
   */
  function waitFor(config) {
    if (!config._initialAttempt) config = waitForConfig(config);
    config._attempt++;
    let success = true;
    const refs = [];
    config.location.forEach(function (loc) {
      if (success) {
        success = loc.apply(null, refs);
        if (success && typeof success === 'object' && 'length' in success && typeof success.length === 'number' && success.length < 1) success = false;
        refs.push(success);
      }
    });
    if (success) {
      config.callback.apply(null, refs);
    } else if (config._attempt < config._maxAttempts) {
      setTimeout(function () {
        waitFor(config);
      }, config.interval);
    } else {
      config.failCallback(config);
    }
    function waitForConfig(obj) {
      const config = Object.assign(
      // eslint-disable-next-line no-undef
      {
        location: null,
        base: window,
        callback: null,
        failCallback: noop,
        timeout: 30000,
        interval: 250
      }, obj);
      if (!Array.isArray(config.location)) {
        config.location = [config.location];
      }
      config.location = config.location.map(function (loc) {
        const locationType = typeof loc;
        if (locationType !== 'string' && locationType !== 'function') {
          throw new TypeError('waitFor: an individual config.location must be a string or a function - got ' + locationType);
        }
        return locationType === 'function' ? loc : ref.bind(null, loc, config.base);
      });
      if (typeof config.callback !== 'function') {
        throw new TypeError('waitFor: config.callback is required and must be a function');
      }
      if (config.failCallback === 'failLogging') {
        config.failCallback = failLogging;
      }
      if (typeof config.failCallback !== 'function') {
        throw new TypeError('waitFor: config.failCallback must be either a function or "failLogging"');
      }
      return Object.assign(config, {
        _initialAttempt: new Date().getTime(),
        _attempt: 0,
        _maxAttempts: config.timeout / config.interval
      });
    }
    function failLogging(config) {
      if (typeof ref('console.log') === 'function') {
        console.log('"%s" not found after %dms (%d attempts, delaying %dms)', config.location.join(','), new Date().getTime() - config._initialAttempt, config._attempt, config.interval);
      }
    }
    function noop() {}
    function ref(path, base) {
      var i = path.indexOf('.');
      base = base || this;
      return i === -1 ? base[path] : (base = base[path.substr(0, i)]) && ref(path.substr(i + 1), base);
    }
  }

  /* global inject waitFor */
  inject.store('waitFor', waitFor);

  /* global inject */
  inject.store('addPixel', src => document.body.insertAdjacentHTML('beforeend', `<img src="${src}" width="1" height="1" alt="" style="position:absolute;bottom:0;" data-source="JSAF">`));

  /* global inject */
  inject.store('addScript', config => new Promise((resolve, reject) => {
    if (typeof config === 'string') config = {
      src: config
    };
    let {
      src,
      async,
      callback = () => {}
    } = config;
    if (!src) return err('Required src property missing');
    let script = document.createElement('script');
    script.onload = () => {
      callback(null, script);
      resolve(script);
    };
    script.onerror = () => err(`Script load error for ${src}`, script);
    if (async !== undefined) script.async = async;
    script.src = src;
    document.head.appendChild(script);
    function err(why, script) {
      const err = new Error(why);
      callback(err, script);
      reject(err);
    }
  }));

  /* global inject */
  inject((store, resolve) => {
    const registry = {};
    store('aepInstance', (name, config) => {
      if (!registry[name]) {
        const publicVar = 'da' + `${Math.random()}`.slice(2);
        if (!window[publicVar]) {
          (window.__alloyNS || (window.__alloyNS = [])).push(publicVar);
          window[publicVar] = function () {
            var args = arguments;
            return new Promise((res, rej) => {
              window[publicVar].q.push([res, rej, args]);
            });
          };
          window[publicVar].q = [];
          window[publicVar]('configure', config);
          resolve('AEPWebSDK')();
        }
        registry[name] = window[publicVar];
      }
      return registry[name];
    });
  }, 'store', 'resolve');

  /* global inject */
  inject.store('arrayGetUnique', array => {
    const valuesMap = {};
    const uniqueArray = [];
    for (let i = 0, l = array.length; i < l; i++) {
      if (valuesMap.hasOwnProperty(array[i])) continue;
      uniqueArray.push(array[i]);
      valuesMap[array[i]] = 1;
    }
    return uniqueArray;
  });

  /* global inject */
  inject((store, Debug) => {
    store('arrayIndexOfFunc', (arr, searchElement, fromIndex, compareFunc) => {
      var k;
      compareFunc = compareFunc || function (value, compareValue) {
        return value === compareValue;
      };

      // 1. Let O be the result of calling ToObject passing
      //    the this value as the argument.
      if (arr == null) {
        Debug.error('"arr" is null or not defined');
        return -1;
      }
      var O = Object(arr);

      // 2. Let lenValue be the result of calling the Get
      //    internal method of O with the argument "length".
      // 3. Let len be ToUint32(lenValue).
      var len = O.length >>> 0;

      // 4. If len is 0, return -1.
      if (len === 0) {
        return -1;
      }

      // 5. If argument fromIndex was passed let n be
      //    ToInteger(fromIndex); else let n be 0.
      var n = +fromIndex || 0;
      if (Math.abs(n) === Infinity) {
        n = 0;
      }

      // 6. If n >= len, return -1.
      if (n >= len) {
        return -1;
      }

      // 7. If n >= 0, then Let k be n.
      // 8. Else, n<0, Let k be len - abs(n).
      //    If k is less than 0, then let k be 0.
      k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      // 9. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ToString(k).
        //   This is implicit for LHS operands of the in operator
        // b. Let kPresent be the result of calling the
        //    HasProperty internal method of O with argument Pk.
        //   This step can be combined with c
        // c. If kPresent is true, then
        //    i.  Let elementK be the result of calling the Get
        //        internal method of O with the argument ToString(k).
        //   ii.  Let same be the result of applying the
        //        Strict Equality Comparison Algorithm to
        //        searchElement and elementK.
        //  iii.  If same is true, return k.
        if (k in O) {
          if (compareFunc(O[k], searchElement)) {
            return k;
          }
        }
        k++;
      }
      return -1;
    });
  }, 'store', 'Debug');

  /* global inject */
  // Array Remove - By John Resig (MIT Licensed)
  // https://johnresig.com/blog/javascript-array-remove/
  inject.store('arrayRemove', (array, from, to) => {
    var rest = array.slice((to || from) + 1 || array.length);
    array.length = from < 0 ? array.length + from : from;
    return array.push.apply(array, rest);
  });

  /* global inject */
  inject.store('asyncArrayQueue', (arr, method) => {
    var originalPush = arr.push;

    // clear backlog
    arr.forEach(v => method(v));
    arr.push = function () {
      originalPush.apply(arr, arguments);
      for (var i = 0; i < arguments.length; i++) method(arguments[i]);
    };
  });

  /* global inject */
  inject((store, asyncArrayQueue) => {
    store('asyncMethodQueue', (arr, targetObj, {
      transform
    } = {}) => {
      asyncArrayQueue(arr, cmd => {
        let method, callback, hasCallback, result;
        if (transform) cmd = transform(cmd);
        if (!Array.isArray(cmd) || typeof (method = cmd[0]) !== 'string' || typeof targetObj[method] !== 'function') return;
        callback = cmd[cmd.length - 1];
        hasCallback = typeof callback === 'function';
        result = targetObj[method].apply(targetObj, cmd.slice(1, cmd.length - (hasCallback ? 1 : 0)));
        if (hasCallback) callback(result);
      });
    });
  }, 'store', 'asyncArrayQueue');

  /* global inject */
  /*
   * Parses a DisneyDataLayer `bookingSearchResort` value (e.g.
   * `"16491822;entityType=resort"` or the sentinel `"resort;Unknown"`
   * used on the resorts listing page) into the leading entity id used
   * to filter productsDisplayed to the resort the guest actually
   * searched for. Returns `undefined` when the input is missing, not
   * a string, or begins with an empty segment. Adapters that need the
   * id should call this helper rather than reimplementing the split.
   *
   * Callers: CEAAdapter (co-located resort filter, GO4-6951),
   * DSMetasearch mapping (_ds_selected_resort_id).
   */
  inject.store('bookingSearchResortId', bookingSearchResort => {
    if (typeof bookingSearchResort !== 'string') return;
    return bookingSearchResort.split(';')[0] || undefined;
  });

  /* global inject */
  inject.store('cleanArray', function cleanArray(arr) {
    /* don't update to use .filter - this mutates the array */
    if (Array.isArray(arr)) {
      for (let i = arr.length; i >= 0; i--) {
        if (arr[i] === null) {
          arr.splice(i, 1);
        }
      }
    }
    return arr;
  });

  /* global inject */
  inject(store => {
    let lastClick = null;
    document.addEventListener('click', event => {
      const linkElement = event.target.closest('a[href]');
      if (linkElement) {
        lastClick = {
          timestamp: Date.now(),
          element: linkElement
        };
      }
    }, true); // capturing phase ensures we see clicks before stopPropagation

    store('getRecentClickedLink', function (withinMs = 100) {
      if (!lastClick) return null;
      if (Date.now() - lastClick.timestamp > withinMs) return null;
      return lastClick.element;
    });
  }, 'store');

  /* global inject */
  inject((store, extend) => {
    store('clone', obj => extend(true, Array.isArray(obj) ? [] : {}, obj));
  }, 'store', 'extend');

  /* global inject */
  inject((Analytics, store) => {
    store('consentCategoryOverrides', Analytics.Config?.consentCategoryOverrides || {});
  }, 'Analytics', 'store');

  /* global inject */
  inject(($, store) => {
    store('convertPromise', convertPromise);

    /**
     * Wraps non-jQuery promises as jQuery promises
     */
    function convertPromise(maybePromise) {
      if (maybePromise && typeof maybePromise.then === 'function' && !maybePromise.always) {
        const deferred = $.Deferred();
        maybePromise.then(deferred.resolve.bind(deferred), deferred.reject.bind(deferred));
        return deferred.promise();
      }
      return maybePromise;
    }
  }, '$', 'store');

  /* global inject */
  inject((store, resolve) => {
    store('convertStringToDate', strDate => resolve('moment')(strDate).toDate());
  }, 'store', 'resolve');

  /* global inject */
  inject((storeMultiple, dateDaysFromNow, safeJsonParse) => {
    storeMultiple({
      deleteCookie,
      setCookie,
      getCookie
    });
    function deleteCookie(name) {
      setCookie(name, '', -1);
    }
    function setCookie(name, value, exdays, jsonEncode = false, domain = '', secure = false) {
      document.cookie = `${name}=${encodeURIComponent(jsonEncode ? JSON.stringify(value) : value)}` + (exdays ? `;expires=${dateDaysFromNow(exdays).toUTCString()}` : '') + ';path=/' + (domain ? `;domain=${domain}` : '') + (secure ? ';secure' : '');
    }
    function getCookie(sName, decodeJSON = false) {
      var cookieValue,
        indicator = sName + '=',
        indicatorLength = indicator.length,
        cookie = document.cookie.split('; ').find(c => c.substr(0, indicatorLength) === indicator);
      if (!cookie) return null;
      cookieValue = decodeURIComponent(cookie.substr(indicatorLength));
      return decodeJSON ? safeJsonParse(cookieValue) : cookieValue;
    }
  }, 'storeMultiple', 'dateDaysFromNow', 'safeJsonParse');

  /* global inject */
  inject.store('debounce', function debounce(originalFunction, debounceInterval) {
    var nextEligibleCallTime = Date.now(),
      cachedReturn;
    return function () {
      var now = Date.now();
      if (now >= nextEligibleCallTime) {
        nextEligibleCallTime = now + debounceInterval;
        cachedReturn = originalFunction.apply(this, arguments);
      }
      return cachedReturn;
    };
  });

  /* global inject */
  inject.store('ensureArray', val => val === undefined ? [] : Array.isArray(val) ? val : [val]);
  /* global inject */
  inject((store, isNumber) => {
    store('ensureNumber', ensureNumber);
    function ensureNumber(val) {
      if (typeof val === 'string') {
        val = Number(val.replace(/[^\d.]/g, ''));
      }
      return isNumber(val) ? val : 0;
    }
  }, 'store', 'isNumber');

  /* global inject */
  inject((store, isObject) => {
    store('ensureObject', val => val === undefined ? {} : isObject(val) ? val : {
      val
    });
  }, 'store', 'isObject');

  /* global inject */
  inject.store('eventmap', {
    activityBooking: 'event39',
    activityCancellation: 'event27',
    activityModification: 'event28',
    activityUnits: 'event65',
    activityView: 'event105',
    additionalPayment: 'event230',
    additionalPaymentRevenue: 'event231',
    admissionBooking: 'event213',
    admissionCancellation: 'event215',
    admissionUnits: 'event214',
    aiOverviewClick: 'event352',
    aiOverviewImpression: 'event351',
    aiOverviewThumbsDown: 'event350',
    aiOverviewThumbsUp: 'event349',
    assetComplete: 'event11',
    assetImpression: 'event96',
    assetPct25: 'event97',
    assetPct50: 'event98',
    assetPct75: 'event99',
    assetStart: 'event1',
    assetStop: 'event11',
    assetTime: 'event43',
    benchListViewed: 'event35',
    bookingSearch: 'event13',
    cancellation: 'event10',
    cartCreate: 'event61',
    cartProductAdd: 'event14,scAdd',
    cartProductRemove: 'scRemove',
    cartValue: 'event87',
    cartView: 'scView',
    changeAccept: 'event325',
    changeReject: 'event326',
    changeVariant: 'event216',
    chatClose: 'event118',
    chatInteract: 'event117',
    chatInviteAccept: 'event111',
    chatInviteDecline: 'event112',
    chatInviteTimeout: 'event113',
    chatInviteView: 'event110',
    chatView: 'event116',
    checkout: 'scCheckout',
    checkoutApplyPayment: 'event33',
    checkoutDelivery: 'event31',
    checkoutExpressCheckout: 'event66',
    checkoutGuestInfo: 'event46',
    checkoutInsurance: 'event32',
    checkoutReviewQuote: 'event34',
    compareVacationModify: 'event62',
    dineSearchStart: 'event120',
    dineSearchSuccess: 'event291',
    earlyBooking: 'event133',
    failedProduct: 'event60',
    geniePlusModification: 'event266',
    geniePlusModificationRevenue: 'event268',
    geniePlusModificationUnits: 'event267',
    geniePlusPurchase: 'event263',
    geniePlusPurchaseRevenue: 'event265',
    geniePlusPurchaseUnits: 'event264',
    geniePlusUpgrade: 'event269',
    geniePlusUpgradeRevenue: 'event271',
    geniePlusUpgradeUnits: 'event270',
    guestInfoSubmit: 'event46',
    helpHubImpression: 'event114',
    internalAdClick: 'event7',
    internalSearch: 'event2',
    internalSearchAutocomplete: 'event346',
    internalSearchClick: 'event5',
    internalSearchStart: 'event344',
    internalSearchSuggested: 'event345',
    internalSearchTyped: 'event347',
    leadGenerated: 'event15',
    loggedIn: 'event58',
    mapCustomization: 'event36',
    mediaDownloads: 'event53',
    modAddDays: 'event73',
    modCheckoutApplyPayment: 'event189',
    modCheckoutDelivery: 'event188',
    modCheckoutGuestInfo: 'event187',
    modCheckoutReviewQuote: 'event190',
    modification: 'event67',
    modificationStart: 'event75',
    modRemoveDays: 'event74',
    modStart: 'event75',
    negModNights: 'event71',
    negModRevenue: 'event69',
    nonCommerceRevenue: 'event109',
    pageView: 'event3',
    personalizationClick: 'event72',
    photosClaimed: 'event186',
    pointsAdded: 'event84',
    pointsAddedPricePerPoint: 'event85',
    pointsPurchased: 'event86',
    posModNights: 'event70',
    posModRevenue: 'event68',
    postCheckoutPayment: 'event59',
    productView: 'event42,prodView',
    prodView: 'event42,prodView',
    profileSearchComplete: 'event315',
    profileSearchCompleteEmpty: 'event316',
    profileSearchConnect: 'event317',
    profileSearchOptIn: 'event312',
    profileSearchOptOut: 'event313',
    profileSearchStart: 'event314',
    promoImpression: 'event77',
    purchase: 'purchase',
    purchaseWithPoints: 'event9',
    quickQuoteSearch: 'event30',
    recommendationInteraction: 'event130',
    recommendationOffered: 'event129',
    recommendationSaved: 'event38',
    recommendationSeen: 'event37,event131',
    registration: 'event4',
    reviewQuote: 'event12',
    saveCart: 'event54',
    scCheckout: 'scCheckout',
    selfServiceCompleted: 'event49',
    selfServiceInitiated: 'event48',
    systemProductRemoval: 'event29',
    ticketOrder: 'event16',
    timerAlert: 'event80',
    timeRemaining: 'event79',
    timesDisplayed: 'event211',
    timeSelected: 'event212',
    upgrade: 'event217',
    upgradeAddDays: 'event219',
    upgradeCheckoutApplyPayment: 'event199',
    upgradeCheckoutDelivery: 'event198',
    upgradeCheckoutGuestInfo: 'event197',
    upgradeCheckoutReviewQuote: 'event200',
    upgradePositiveRevenue: 'event218',
    upgradeSelected: 'event327',
    upgradeTaken: 'event328',
    upsellImpression: 'event353',
    upsellSelected: 'event354',
    videoPct25: 'event97',
    videoPct50: 'event98',
    videoPct75: 'event99',
    videoStart: 'event1',
    videoStop: 'event11',
    videoTime: 'event43',
    videoView: 'event96',
    VPDOrder: 'event8',
    // photopass events
    assetAdd: '',
    assetAutostart: '',
    assetInteraction: '',
    assetRemove: '',
    channelCreation: '',
    channelViews: '',
    deleteAsset: '',
    discount: '',
    download: '',
    imageClaim: '',
    imageEdit: '',
    imageUpload: '',
    login: '',
    mediaLoadComplete: '',
    mediaShare: '',
    mediaTransfer: '',
    mmRedemption: '',
    order: '',
    searchResultsClicks: '',
    share: '',
    shipping: '',
    UGCAction: ''
  });
  /* global inject */

  inject((resolve, store, $, netlog, publish) => {
    store('fireEvent', fireEvent);
    function fireEvent({
      node = document,
      event,
      data
    } = {}) {
      if (arguments.length > 1) {
        node = arguments[0];
        event = arguments[1];
        data = arguments[2];
      }
      $(node).trigger(event, data || {});
      if (typeof node === 'string') {
        try {
          node = document.querySelector(node) || document;
        } catch (error) {
          netlog({
            app: 'JSAF',
            category: 'fireEvent_error',
            action: 'bad_selector',
            node,
            error,
            sampling: 0.05
          });
          node = document;
        }
      }
      try {
        (node.dispatchEvent ? node : document).dispatchEvent(new CustomEvent(`nce.${event}`, {
          bubbles: true,
          composed: true,
          detail: data
        }));
      } catch (error) {
        netlog({
          app: 'JSAF',
          category: 'fireEvent_error',
          action: 'dispatchEvent_error',
          event: `nce.${event}`,
          node,
          data,
          error,
          sampling: 0.05
        });
      }
      publish({
        topic: event,
        node,
        data
      });
    }
  }, 'resolve', 'store', '$', 'netlog', 'publish');

  /* global inject */
  inject((store, isObject) => {
    store('flattenObj', flattenObj);
    function flattenObj(obj, expandArrays = false) {
      let result = {};
      if (isObject(obj)) {
        for (const [key, value] of Object.entries(obj)) {
          if (isObject(value) || expandArrays && Array.isArray(value)) {
            for (const [deepKey, deepValue] of Object.entries(flattenObj(value, expandArrays))) {
              result[`${key}.${deepKey}`] = deepValue;
            }
          } else {
            result[key] = value;
          }
        }
      } else if (expandArrays && Array.isArray(obj)) {
        obj.forEach((value, i) => {
          if (isObject(value) || expandArrays && Array.isArray(value)) {
            for (const [deepKey, deepValue] of Object.entries(flattenObj(value, expandArrays))) {
              result[`${i}.${deepKey}`] = deepValue;
            }
          } else {
            result[`${i}`] = value;
          }
        });
      }
      return result;
    }
  }, 'store', 'isObject');

  /* global inject */
  inject.store('fnApply', function fnApply(fn, thisArg, argsArray) {
    if (typeof fn === 'function') {
      return fn.apply(thisArg, argsArray);
    }
  });

  /* global inject */
  inject.store('fnReturnValue', value => () => value);

  /* global inject */
  inject.store('getReferrer', () => document.referrer);
  /* global inject */
  inject.store('getURLParameter', paramName => {
    if (!location.search) return null;
    const indicator = paramName + '=';
    const indicatorLength = indicator.length;
    const param = location.search.substr(1).split('&').find(c => c.substr(0, indicatorLength) === indicator);
    return param ? decodeURIComponent(param.substr(indicatorLength)) : null;
  });

  /* global inject */
  inject.store('getURLProtocol', forceHttps => {
    var result = 'http://',
      protocol = location.protocol;
    if (forceHttps === true || forceHttps === 'true') {
      result = 'https://';
      //make sure this is an http protocol (for example in our tests the protocol is going to be 'file:')
    } else if (protocol.includes('http')) {
      result = `${protocol}//`;
    }
    return result;
  });
  /* global inject */
  /**
   * -- method getUTCTime(date) -> Number
   * - {Date} date: the date to convert to UTCTime.
   *
   * Returns the unix UTC timestamp for the given date.
   * The return value will disregard the milliseconds, by dividing
   * the time by 1000 (since JS also includes milliseconds) and
   * flooring the division).
   */
  inject.store('getUTCTime', (date = new Date()) => Math.floor(date.getTime() / 1000));

  /* global inject */
  inject((ref, store) => {
    store('iniBoolean', (value, defaultValue) => {
      if (value === true || value === 1 || typeof value === 'string' && /^\s*(?:true|1|on|yes)\s*$/i.test(value)) return true;
      if (value === false || value === 0 || typeof value === 'string' && /^\s*(?:false|0|off|no)\s*$/i.test(value)) return false;
      return defaultValue;
    });
  }, 'ref', 'store');
  /* global inject */
  inject((store, isObject, objFirstProp) => {
    store('isEmptyObject', o => isObject(o) && objFirstProp(o) === undefined);
  }, 'store', 'isObject', 'objFirstProp');

  /* global inject */
  inject((store, isObject, isEmptyObject) => {
    store('isNonEmptyObject', o => isObject(o) && !isEmptyObject(o));
  }, 'store', 'isObject', 'isEmptyObject');

  /* global inject */
  inject((store, resolve) => {
    // converts 'MM/DD/YYYY' strings to ISO 'YYYY-MM-DD' strings
    // also allows for other types of inputs, date, ms, etc
    // see https://momentjs.com/docs/#/parsing/
    store('isoDate', function (dt) {
      var iso = resolve('moment')(...(typeof dt === 'string' ? [dt, 'MM/DD/YYYY'] : arguments));
      return iso && iso.isValid() ? iso.format('YYYY-MM-DD') : dt;
    });
  }, 'store', 'resolve');

  /* global inject */
  inject.store('isString', obj => typeof obj === 'string');

  /* global inject */
  function limit(fn, maxCalls, resettable) {
    var calls = 0;
    if (resettable) proxy.reset = reset;
    return proxy;
    function proxy() {
      if (calls++ < maxCalls) {
        return fn.apply(this, arguments);
      }
    }
    function reset() {
      calls = 0;
    }
  }
  function once(fn, resettable) {
    return limit(fn, 1, resettable);
  }
  if (typeof inject === 'function') {
    inject.store('limit', limit);
    inject.store('once', once);
  }

  /* global inject */
  inject((store, getRecentClickedLink) => {
    store('resolveLinkInfo', function resolveLinkInfo(sam) {
      const {
        link,
        linkId
      } = sam;

      // Priority 1: Explicit link object with values
      if (link && typeof link === 'object' && !(link instanceof HTMLElement)) {
        return {
          isLinkClick: true,
          URL: link.URL,
          name: linkId || link.id || link.name,
          // linkId always takes precedence for backward compatibility
          region: link.region,
          type: link.type || 'other'
        };
      }

      // Priority 2: HTMLElement reference in link property
      if (link instanceof HTMLElement) {
        const anchor = link.closest('a[href]') || (link.tagName === 'A' ? link : null);
        if (anchor) {
          return deriveFromElement(anchor, link, linkId);
        }
      }

      // Priority 3: Fallback to recently clicked link (from clickTracker)
      const recentLink = getRecentClickedLink(100);
      if (recentLink) {
        return deriveFromElement(recentLink, recentLink, linkId);
      }

      // No link detected - this is an element click
      return {
        isLinkClick: false
      };
    });
    function determineLinkType(href) {
      if (!href) return 'other';

      // Download link detection (matches Alloy's pattern)
      if (/\.(exe|zip|wav|mp3|mov|mpg|avi|wmv|pdf|doc|docx|xls|xlsx|ppt|pptx)$/i.test(href)) {
        return 'download';
      }

      // Exit link detection (different domain)
      try {
        const linkUrl = new URL(href, location.origin);
        if (linkUrl.hostname !== location.hostname) {
          return 'exit';
        }
      } catch (e) {/* invalid URL, treat as other */}
      return 'other'; // internal link
    }
    function findRegion(element) {
      if (!element || typeof element.closest !== 'function') return undefined;
      const regionEl = element.closest('[data-region], [data-analytics-region], nav, header, footer, aside, main, [role="navigation"], [role="main"]');
      if (regionEl) {
        return regionEl.dataset?.region || regionEl.dataset?.analyticsRegion || regionEl.tagName.toLowerCase();
      }
      return undefined;
    }
    function deriveFromElement(anchor, contextElement, linkId) {
      return {
        isLinkClick: true,
        URL: anchor.href,
        name: linkId || anchor.getAttribute('analyticsLinkId') || anchor.textContent?.trim()?.slice(0, 50),
        region: findRegion(contextElement || anchor),
        type: determineLinkType(anchor.href)
      };
    }
  }, 'store', 'getRecentClickedLink');

  /* global inject */
  inject((subscribe, resolveLinkInfo) => {
    subscribe({
      topic: 'framework.trackElement',
      handler: ({
        model
      }) => {
        // Skip if link is already a resolved object (not HTMLElement)
        if (model.link && typeof model.link === 'object' && !(model.link instanceof HTMLElement)) {
          // Already an explicit object - just ensure it has isLinkClick flag
          model.link.isLinkClick = true;
        } else {
          // Resolve and replace/augment the link property
          model.link = resolveLinkInfo(model);
        }

        // BACKWARD COMPATIBILITY: Set model.linkId from resolved link.name
        // if linkId not already set. This ensures existing adapters that
        // read model.linkId continue to work when using the new link object.
        if (!model.linkId && model.link?.name) {
          model.linkId = model.link.name;
        }
      }
    });
  }, 'subscribe', 'resolveLinkInfo');

  /* global inject */
  inject((store, safeJsonParse, xhr, extend, noop) => {
    store('loadJson', config => new Promise((resolve, reject) => {
      let {
        success = noop,
        failure = noop
      } = config;
      xhr(extend({}, config, {
        successTransform: safeJsonParse,
        success: obj => {
          success(obj);
          resolve(obj);
        },
        failure: xhr => {
          let err = new Error(`Bad response: ${xhr.status}`);
          failure(err);
          reject(err);
        }
      }));
    }));
  }, 'store', 'safeJsonParse', 'xhr', 'extend', () => {});

  /* global inject */
  inject(store => {
    store('memoize', function memoize(fn, {
      cache = new Map(),
      serialize = defaultSerialize
    } = {}) {
      return function () {
        const key = serialize.apply(this, arguments);
        if (!cache.has(key)) cache.set(key, fn.apply(this, arguments));
        return cache.get(key);
      };
    });
    function defaultSerialize() {
      return JSON.stringify(arguments);
    }
  }, 'store');
  /* global inject */
  /*
  * mergeObjectsByKey
  * Because of how $.extend works we may need to loop through an array of objects and merge them if
  * a given property matches, otherwise if the orders or numbers in each array do not match the
  * data will be messed up
  */
  inject((store, extend) => {
    store('mergeObjectsByKey', function mergeObjectsByKey(key, targetArray, sourceArray, forcePush) {
      sourceArray.forEach(srcVal => {
        var found = false;
        if (srcVal[key]) {
          targetArray.forEach(targetVal => {
            if (targetVal[key] && srcVal[key] === targetVal[key] && found === false) {
              extend(true, targetVal, srcVal);
              found = true;
            }
          });
          if (!found && forcePush) {
            targetArray.push(srcVal);
          }
        }
      });
    });
  }, 'store', 'extend');

  /* global inject */
  inject((store, isObject, ensureArray) => {
    store('moveProp', (srcObj, srcProp, targetObj, targetProp = srcProp, overwrite = false) => {
      if (!isObject(srcObj)) return;
      if (typeof targetObj === 'string') {
        targetProp = targetObj;
        targetObj = srcObj;
      }
      targetProp = ensureArray(targetProp);
      ensureArray(srcProp).forEach((sProp, i) => {
        var tProp = targetProp[i] || sProp;
        if (srcObj.hasOwnProperty(sProp) && (overwrite || !targetObj.hasOwnProperty(tProp))) targetObj[tProp] = srcObj[sProp];
        delete srcObj[sProp];
      });
    });
  }, 'store', 'isObject', 'ensureArray');

  /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */

  inject(function (Analytics, store, Mustache) {
    Analytics.Mustache = store('Mustache', Mustache);
  }, 'Analytics', 'store', function () {
    var exports = {};
    exports.name = "mustache.js";
    exports.version = "0.7.2";
    exports.tags = ["{{", "}}"];
    exports.Scanner = Scanner;
    exports.Context = Context;
    exports.Writer = Writer;
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var nonSpaceRe = /\S/;
    var eqRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;

    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    function testRe(re, string) {
      return RegExp.prototype.test.call(re, string);
    }
    function isWhitespace(string) {
      return !testRe(nonSpaceRe, string);
    }
    var isArray = Array.isArray || function (obj) {
      return Object.prototype.toString.call(obj) === "[object Array]";
    };
    function escapeRe(string) {
      return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    }
    var entityMap = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': '&quot;',
      "'": '&#39;',
      "/": '&#x2F;'
    };
    function escapeHtml(string) {
      return String(string).replace(/[&<>"'\/]/g, function (s) {
        return entityMap[s];
      });
    }

    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    exports.escape = escapeHtml;
    function Scanner(string) {
      this.string = string;
      this.tail = string;
      this.pos = 0;
    }

    /**
     * Returns `true` if the tail is empty (end of string).
     */
    Scanner.prototype.eos = function () {
      return this.tail === "";
    };

    /**
     * Tries to match the given regular expression at the current position.
     * Returns the matched text if it can match, the empty string otherwise.
     */
    Scanner.prototype.scan = function (re) {
      var match = this.tail.match(re);
      if (match && match.index === 0) {
        this.tail = this.tail.substring(match[0].length);
        this.pos += match[0].length;
        return match[0];
      }
      return "";
    };

    /**
     * Skips all text until the given regular expression can be matched. Returns
     * the skipped string, which is the entire tail if no match can be made.
     */
    Scanner.prototype.scanUntil = function (re) {
      var match,
        pos = this.tail.search(re);
      switch (pos) {
        case -1:
          match = this.tail;
          this.pos += this.tail.length;
          this.tail = "";
          break;
        case 0:
          match = "";
          break;
        default:
          match = this.tail.substring(0, pos);
          this.tail = this.tail.substring(pos);
          this.pos += pos;
      }
      return match;
    };
    function Context(view, parent) {
      this.view = view;
      this.parent = parent;
      this.clearCache();
    }
    Context.make = function (view) {
      return view instanceof Context ? view : new Context(view);
    };
    Context.prototype.clearCache = function () {
      this._cache = {};
    };
    Context.prototype.push = function (view) {
      return new Context(view, this);
    };
    Context.prototype.lookup = function (name) {
      var value = this._cache[name];
      if (!value) {
        if (name === ".") {
          value = this.view;
        } else {
          var context = this;
          while (context) {
            if (name.indexOf(".") > 0) {
              var names = name.split("."),
                i = 0;
              value = context.view;
              while (value && i < names.length) {
                value = value[names[i++]];
              }
            } else {
              value = context.view[name];
            }
            if (value != null) {
              break;
            }
            context = context.parent;
          }
        }
        this._cache[name] = value;
      }
      if (typeof value === "function") {
        value = value.call(this.view);
      }
      return value;
    };
    function Writer() {
      this.clearCache();
    }
    Writer.prototype.clearCache = function () {
      this._cache = {};
      this._partialCache = {};
    };
    Writer.prototype.compile = function (template, tags) {
      var fn = this._cache[template];
      if (!fn) {
        var tokens = exports.parse(template, tags);
        fn = this._cache[template] = this.compileTokens(tokens, template);
      }
      return fn;
    };
    Writer.prototype.compilePartial = function (name, template, tags) {
      var fn = this.compile(template, tags);
      this._partialCache[name] = fn;
      return fn;
    };
    Writer.prototype.compileTokens = function (tokens, template) {
      var fn = compileTokens(tokens);
      var self = this;
      return function (view, partials) {
        if (partials) {
          if (typeof partials === "function") {
            self._loadPartial = partials;
          } else {
            for (var name in partials) {
              self.compilePartial(name, partials[name]);
            }
          }
        }
        return fn(self, Context.make(view), template);
      };
    };
    Writer.prototype.render = function (template, view, partials) {
      return this.compile(template)(view, partials);
    };
    Writer.prototype._section = function (name, context, text, callback) {
      var value = context.lookup(name);
      switch (typeof value) {
        case "object":
          if (isArray(value)) {
            var buffer = "";
            for (var i = 0, len = value.length; i < len; ++i) {
              buffer += callback(this, context.push(value[i]));
            }
            return buffer;
          }
          return value ? callback(this, context.push(value)) : "";
        case "function":
          var self = this;
          var scopedRender = function (template) {
            return self.render(template, context);
          };
          var result = value.call(context.view, text, scopedRender);
          return result != null ? result : "";
        default:
          if (value) {
            return callback(this, context);
          }
      }
      return "";
    };
    Writer.prototype._inverted = function (name, context, callback) {
      var value = context.lookup(name);

      // Use JavaScript's definition of falsy. Include empty arrays.
      // See https://github.com/janl/mustache.js/issues/186
      if (!value || isArray(value) && value.length === 0) {
        return callback(this, context);
      }
      return "";
    };
    Writer.prototype._partial = function (name, context) {
      if (!(name in this._partialCache) && this._loadPartial) {
        this.compilePartial(name, this._loadPartial(name));
      }
      var fn = this._partialCache[name];
      return fn ? fn(context) : "";
    };
    Writer.prototype._name = function (name, context) {
      var value = context.lookup(name);
      if (typeof value === "function") {
        value = value.call(context.view);
      }
      return value == null ? "" : String(value);
    };
    Writer.prototype._escaped = function (name, context) {
      return exports.escape(this._name(name, context));
    };

    /**
     * Low-level function that compiles the given `tokens` into a function
     * that accepts three arguments: a Writer, a Context, and the template.
     */
    function compileTokens(tokens) {
      var subRenders = {};
      function subRender(i, tokens, template) {
        if (!subRenders[i]) {
          var fn = compileTokens(tokens);
          subRenders[i] = function (writer, context) {
            return fn(writer, context, template);
          };
        }
        return subRenders[i];
      }
      return function (writer, context, template) {
        var buffer = "";
        var token, sectionText;
        for (var i = 0, len = tokens.length; i < len; ++i) {
          token = tokens[i];
          switch (token[0]) {
            case "#":
              sectionText = template.slice(token[3], token[5]);
              buffer += writer._section(token[1], context, sectionText, subRender(i, token[4], template));
              break;
            case "^":
              buffer += writer._inverted(token[1], context, subRender(i, token[4], template));
              break;
            case ">":
              buffer += writer._partial(token[1], context);
              break;
            case "&":
              buffer += writer._name(token[1], context);
              break;
            case "name":
              buffer += writer._escaped(token[1], context);
              break;
            case "text":
              buffer += token[1];
              break;
          }
        }
        return buffer;
      };
    }

    /**
     * Forms the given array of `tokens` into a nested tree structure where
     * tokens that represent a section have two additional items: 1) an array of
     * all tokens that appear in that section and 2) the index in the original
     * template that represents the end of that section.
     */
    function nestTokens(tokens) {
      var tree = [];
      var collector = tree;
      var sections = [];
      var token;
      for (var i = 0, len = tokens.length; i < len; ++i) {
        token = tokens[i];
        switch (token[0]) {
          case '#':
          case '^':
            sections.push(token);
            collector.push(token);
            collector = token[4] = [];
            break;
          case '/':
            var section = sections.pop();
            section[5] = token[2];
            collector = sections.length > 0 ? sections[sections.length - 1][4] : tree;
            break;
          default:
            collector.push(token);
        }
      }
      return tree;
    }

    /**
     * Combines the values of consecutive text tokens in the given `tokens` array
     * to a single token.
     */
    function squashTokens(tokens) {
      var squashedTokens = [];
      var token, lastToken;
      for (var i = 0, len = tokens.length; i < len; ++i) {
        token = tokens[i];
        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          lastToken = token;
          squashedTokens.push(token);
        }
      }
      return squashedTokens;
    }
    function escapeTags(tags) {
      return [new RegExp(escapeRe(tags[0]) + "\\s*"), new RegExp("\\s*" + escapeRe(tags[1]))];
    }

    /**
     * Breaks up the given `template` string into a tree of token objects. If
     * `tags` is given here it must be an array with two string values: the
     * opening and closing tags used in the template (e.g. ["<%", "%>"]). Of
     * course, the default is to use mustaches (i.e. Mustache.tags).
     */
    exports.parse = function (template, tags) {
      template = template || '';
      tags = tags || exports.tags;
      if (typeof tags === 'string') tags = tags.split(spaceRe);
      if (tags.length !== 2) {
        throw new Error('Invalid tags: ' + tags.join(', '));
      }
      var tagRes = escapeTags(tags);
      var scanner = new Scanner(template);
      var sections = []; // Stack to hold section tokens
      var tokens = []; // Buffer to hold the tokens
      var spaces = []; // Indices of whitespace tokens on the current line
      var hasTag = false; // Is there a {{tag}} on the current line?
      var nonSpace = false; // Is there a non-space char on the current line?

      // Strips all whitespace tokens array for the current line
      // if there was a {{#tag}} on it and otherwise only space.
      function stripSpace() {
        if (hasTag && !nonSpace) {
          while (spaces.length) {
            tokens.splice(spaces.pop(), 1);
          }
        } else {
          spaces = [];
        }
        hasTag = false;
        nonSpace = false;
      }
      var start, type, value, chr;
      while (!scanner.eos()) {
        start = scanner.pos;
        value = scanner.scanUntil(tagRes[0]);
        if (value) {
          for (var i = 0, len = value.length; i < len; ++i) {
            chr = value.charAt(i);
            if (isWhitespace(chr)) {
              spaces.push(tokens.length);
            } else {
              nonSpace = true;
            }
            tokens.push(["text", chr, start, start + 1]);
            start += 1;
            if (chr === "\n") {
              stripSpace(); // Check for whitespace on the current line.
            }
          }
        }
        start = scanner.pos;

        // Match the opening tag.
        if (!scanner.scan(tagRes[0])) {
          break;
        }
        hasTag = true;
        type = scanner.scan(tagRe) || "name";

        // Skip any whitespace between tag and value.
        scanner.scan(whiteRe);

        // Extract the tag value.
        if (type === "=") {
          value = scanner.scanUntil(eqRe);
          scanner.scan(eqRe);
          scanner.scanUntil(tagRes[1]);
        } else if (type === "{") {
          var closeRe = new RegExp("\\s*" + escapeRe("}" + tags[1]));
          value = scanner.scanUntil(closeRe);
          scanner.scan(curlyRe);
          scanner.scanUntil(tagRes[1]);
          type = "&";
        } else {
          value = scanner.scanUntil(tagRes[1]);
        }

        // Match the closing tag.
        if (!scanner.scan(tagRes[1])) {
          throw new Error('Unclosed tag at ' + scanner.pos);
        }

        // Check section nesting.
        if (type === '/') {
          if (sections.length === 0) {
            throw new Error('Unopened section "' + value + '" at ' + start);
          }
          var section = sections.pop();
          if (section[1] !== value) {
            throw new Error('Unclosed section "' + section[1] + '" at ' + start);
          }
        }
        var token = [type, value, start, scanner.pos];
        tokens.push(token);
        if (type === '#' || type === '^') {
          sections.push(token);
        } else if (type === "name" || type === "{" || type === "&") {
          nonSpace = true;
        } else if (type === "=") {
          // Set the tags for the next time around.
          tags = value.split(spaceRe);
          if (tags.length !== 2) {
            throw new Error('Invalid tags at ' + start + ': ' + tags.join(', '));
          }
          tagRes = escapeTags(tags);
        }
      }

      // Make sure there are no open sections when we're done.
      var section = sections.pop();
      if (section) {
        throw new Error('Unclosed section "' + section[1] + '" at ' + scanner.pos);
      }
      return nestTokens(squashTokens(tokens));
    };

    // The high-level clearCache, compile, compilePartial, and render functions
    // use this default writer.
    var _writer = new Writer();

    /**
     * Clears all cached templates and partials in the default writer.
     */
    exports.clearCache = function () {
      return _writer.clearCache();
    };

    /**
     * Compiles the given `template` to a reusable function using the default
     * writer.
     */
    exports.compile = function (template, tags) {
      return _writer.compile(template, tags);
    };

    /**
     * Compiles the partial with the given `name` and `template` to a reusable
     * function using the default writer.
     */
    exports.compilePartial = function (name, template, tags) {
      return _writer.compilePartial(name, template, tags);
    };

    /**
     * Compiles the given array of tokens (the output of a parse) to a reusable
     * function using the default writer.
     */
    exports.compileTokens = function (tokens, template) {
      return _writer.compileTokens(tokens, template);
    };

    /**
     * Renders the `template` with the given `view` and `partials` using the
     * default writer.
     */
    exports.render = function (template, view, partials) {
      return _writer.render(template, view, partials);
    };

    // This is here for backwards compatibility with 0.4.x.
    exports.to_html = function (template, view, partials, send) {
      var result = exports.render(template, view, partials);
      if (typeof send === "function") {
        send(result);
      } else {
        return result;
      }
    };
    return exports;
  }());
  /* global inject */
  function nonProdDomain(domain = location.hostname) {
    return /(?:\b(?:dev|lt|zend|vdi|load|uat|shadow|preview|stg|demo|sb\d|loc|mxp)|qa|staging|test|lt\d|stage|ticketslady)/i.test(domain);
  }
  if (typeof inject === 'function') inject.store('nonProdDomain', nonProdDomain);

  /* global inject */
  /**
   * pollForElement - polls every X millisecond (default 200) for a given element(s)
   * @param string selector
   * @param function callback
   * @param int maxTries
   * @param int tryNum
   * @param int interval
   */
  inject((store, querySelectorAll) => {
    store('pollForElement', function pollForElement(selector, callback, maxTries = 0, tryNum = 1, interval = 200) {
      var list = querySelectorAll(selector);
      if (list.length > 0) {
        callback(list);
      } else if (tryNum <= maxTries || maxTries === 0) {
        setTimeout(pollForElement.bind(null, selector, callback, maxTries, ++tryNum, interval), interval);
      }
    });
  }, 'store', 'querySelectorAll');

  /* global inject */
  inject.store('productTypeMap', {
    addOn: 'add',
    admission: 'adm',
    airTransportation: 'air',
    annualPass: 'tix',
    cruise: 'prod',
    datedTicket: 'dtx',
    dining: 'dine',
    enhancedExperience: 'eexp',
    event: 'evt',
    fastPassPlus: 'gxa',
    greatFoodFast: 'gxa',
    groundTransportation: 'auto',
    insurance: 'ins',
    media: 'med',
    merchandise: 'merch',
    nonDisneyTicket: 'ndt',
    preOrder: 'pre',
    product: 'prod',
    resortVacation: 'res',
    ticket: 'tix',
    trip: 'trip'
  });
  /* global inject */
  inject.store('randomInt', (min, max) => Math.floor(Math.random() * (max - min + 1)) + min);
  /* global inject */
  inject.store('ready', fn => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      setTimeout(fn, 0);
    }
  });

  /* global inject */
  inject(store => {
    store('removeArrayDuplicates', val => Array.isArray(val) ? val.filter(unique) : val);
    function unique(value, index, arr) {
      return arr.indexOf(value) === index;
    }
  }, 'store');

  /* global inject */

  inject.store('set', function set(obj, path, value) {
    var tokens = path.split('.'),
      j = tokens.length - 1,
      i = 0,
      key;
    for (; key = tokens[i], i < j; i++) {
      obj = obj[key] = obj[key] || {};
    }
    return obj[key] = value;
  });

  /* global inject */
  inject.store('sha1', (() => {
    function rotl(n, s) {
      return n << s | n >>> 32 - s;
    }
    function tohex(i) {
      return ('0000000' + (i >>> 0).toString(16)).slice(-8);
    }
    return function sha1(msg) {
      if (typeof msg !== 'string') msg = '';
      var H0 = 0x67452301,
        H1 = 0xEFCDAB89,
        H2 = 0x98BADCFE,
        H3 = 0x10325476,
        H4 = 0xC3D2E1F0,
        M = 0x0ffffffff,
        i,
        t,
        W = new Array(80),
        ml = msg.length,
        wa = new Array(),
        bo,
        A,
        B,
        C,
        D,
        E;
      msg += String.fromCharCode(0x80);
      while (msg.length % 4) msg += String.fromCharCode(0);
      for (i = 0; i < msg.length; i += 4) wa.push(msg.charCodeAt(i) << 24 | msg.charCodeAt(i + 1) << 16 | msg.charCodeAt(i + 2) << 8 | msg.charCodeAt(i + 3));
      while (wa.length % 16 != 14) wa.push(0);
      wa.push(ml >>> 29), wa.push(ml << 3 & M);
      for (bo = 0; bo < wa.length; bo += 16) {
        for (i = 0; i < 16; i++) W[i] = wa[bo + i];
        for (i = 16; i <= 79; i++) W[i] = rotl(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
        A = H0;
        B = H1;
        C = H2;
        D = H3;
        E = H4;
        for (i = 0; i <= 19; i++) t = rotl(A, 5) + (B & C | ~B & D) + E + W[i] + 0x5A827999 & M, E = D, D = C, C = rotl(B, 30), B = A, A = t;
        for (i = 20; i <= 39; i++) t = rotl(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ED9EBA1 & M, E = D, D = C, C = rotl(B, 30), B = A, A = t;
        for (i = 40; i <= 59; i++) t = rotl(A, 5) + (B & C | B & D | C & D) + E + W[i] + 0x8F1BBCDC & M, E = D, D = C, C = rotl(B, 30), B = A, A = t;
        for (i = 60; i <= 79; i++) t = rotl(A, 5) + (B ^ C ^ D) + E + W[i] + 0xCA62C1D6 & M, E = D, D = C, C = rotl(B, 30), B = A, A = t;
        H0 = H0 + A & M;
        H1 = H1 + B & M;
        H2 = H2 + C & M;
        H3 = H3 + D & M;
        H4 = H4 + E & M;
      }
      return tohex(H0) + tohex(H1) + tohex(H2) + tohex(H3) + tohex(H4);
    };
  })());
  /* global inject */
  inject((storeMultiple, safeJsonParse, dateDaysFromNow, getCookie, deleteCookie, setCookie, isObject) => {
    storeMultiple({
      sessionStorage: sessionStorageWithCookieFallback('aSess_'),
      localStorage: localStorageWithCookieFallback('aLocs_')
    });
    function validateStorage(storageKey) {
      var storage;
      var key = `__${Math.random()}`;
      try {
        storage = window[storageKey];
        storage.setItem(key, key);
        storage.removeItem(key);
      } catch (e) {
        storage = undefined;
      }
      return storage;
    }
    function sessionStorageWithCookieFallback(fallbackCookiePrefix) {
      var storage = validateStorage('sessionStorage');
      return storage ? sessionInterface(storage) : cookieSessionInterface(fallbackCookiePrefix);
    }
    function localStorageWithCookieFallback(fallbackCookiePrefix) {
      var storage = validateStorage('localStorage');
      return storage ? localInterface(storage) : cookieLocalInterface(fallbackCookiePrefix);
    }
    function sessionInterface(storage) {
      return {
        getItem: key => {
          let result = safeJsonParse(storage.getItem(key));
          if (isJsonRepresentation(result)) result = fromJsonRepresentation(result);
          return result;
        },
        removeItem: storage.removeItem.bind(storage),
        setItem: (key, value) => {
          const storeValue = toJsonRepresentation(value);
          storage.setItem(key, JSON.stringify(storeValue));
        }
      };
    }
    function cookieSessionInterface(fallbackCookiePrefix) {
      return {
        getItem: key => {
          let result = safeJsonParse(getCookie(fallbackCookiePrefix + key));
          if (isJsonRepresentation(result)) result = fromJsonRepresentation(result);
          return result;
        },
        removeItem: key => {
          deleteCookie(fallbackCookiePrefix + key);
        },
        setItem: (key, value) => {
          setCookie(fallbackCookiePrefix + key, JSON.stringify(toJsonRepresentation(value)));
        }
      };
    }
    function localInterface(storage) {
      return {
        getItem: key => {
          let result = safeJsonParse(storage.getItem(key));
          if (isJsonRepresentation(result) && typeof result.expires === 'number') {
            if (result.expires > Date.now()) {
              result = fromJsonRepresentation(result);
            } else {
              storage.removeItem(key);
              result = null;
            }
          }
          return result;
        },
        removeItem: storage.removeItem.bind(storage),
        setItem: (key, value, expiresDays = 365) => {
          const storeValue = toJsonRepresentation(value);
          storeValue.expires = dateDaysFromNow(expiresDays).getTime();
          storage.setItem(key, JSON.stringify(storeValue));
        }
      };
    }
    function cookieLocalInterface(fallbackCookiePrefix) {
      return {
        getItem: key => {
          let result = safeJsonParse(getCookie(fallbackCookiePrefix + key));
          if (isJsonRepresentation(result)) result = fromJsonRepresentation(result);
          return result;
        },
        removeItem: key => {
          deleteCookie(fallbackCookiePrefix + key);
        },
        setItem: (key, value, expiresDays = 365) => {
          setCookie(fallbackCookiePrefix + key, JSON.stringify(toJsonRepresentation(value)), expiresDays);
        }
      };
    }
    function isJsonRepresentation(rep) {
      return isObject(rep) && ('value' in rep || rep.isUndefined);
    }
    function toJsonRepresentation(value) {
      const rep = {
        value
      };
      if (typeof value === 'undefined') {
        rep.isUndefined = 1;
      } else if (value !== value) {
        rep.isNaN = 1;
      } else if (value === Infinity) {
        rep.isInfinity = 1;
      } else if (value === -Infinity) {
        rep.isInfinity = -1;
      } else if (Object.prototype.toString.call(value) === '[object Date]') {
        rep.isDate = 1;
        rep.value = value.getTime();
      }
      return rep;
    }
    function fromJsonRepresentation(rep) {
      let value;
      if (rep.isUndefined) {
        value = undefined;
      } else if (rep.isNaN) {
        value = NaN;
      } else if (rep.isInfinity) {
        value = Infinity * rep.isInfinity;
      } else if (rep.isDate) {
        let dt = new Date();
        dt.setTime(rep.value !== null ? rep.value : 'invalid date');
        value = dt;
      } else {
        value = rep.value;
      }
      return value;
    }
  }, 'storeMultiple', 'safeJsonParse', 'dateDaysFromNow', 'getCookie', 'deleteCookie', 'setCookie', 'isObject');

  /* global inject */
  /*
  Utils is being deprecated and is no longer used within the framework. But since it's been a part of the interface
  for quite a while some other applications may be using references to these utils. Logging external usage will
  allow for determining where it's being used so that the consumer can be updated prior to it being completely removed.
  */
  inject((Analytics, extend, resolve, netlog) => {
    var Utils = Analytics.Utils = Analytics.Utils || {};
    extend(Utils, {
      sessionStorage: resolve('sessionStorage'),
      Array: {
        indexOfFunc: logResolve('arrayIndexOfFunc', 'Array.indexOfFunc'),
        indexOf: logResolve((arr, elt, from) => arr.indexOf(elt, from), 'Array.indexOf'),
        getUnique: logResolve('arrayGetUnique', 'Array.getUnique'),
        remove: logResolve('arrayRemove', 'Array.remove'),
        forEach: logResolve((arr, callback, thisArg) => arr.forEach(callback, thisArg), 'Array.forEach'),
        map: logResolve((arr, callback, thisArg) => arr.map(callback, thisArg), 'Array.map')
      },
      deleteCookie: logResolve('deleteCookie'),
      setCookie: logResolve('setCookie'),
      getCookie: logResolve('getCookie'),
      getURLParameter: logResolve('getURLParameter'),
      getUTCTime: logResolve('getUTCTime'),
      getRandomInt: logResolve('randomInt', 'getRandomInt'),
      getURLProtocol: logResolve('getURLProtocol'),
      convertStringToDate: logResolve('convertStringToDate'),
      Page: {
        getWidth: logResolve(() => window.innerWidth || document.documentElement.clientWidth || null, 'Page.getWidth')
      },
      pollForElement: logResolve('pollForElement')
    });
    function logResolve(fnStr, logName = fnStr) {
      var fn = typeof fnStr === 'string' ? resolve(fnStr) : fnStr,
        logged = false;
      return function () {
        if (!logged) {
          netlog({
            app: 'JSAF',
            category: 'utils_deprecation',
            action: `Utils.${logName}`,
            error: new Error('unexpected external usage'),
            sampling: 0.01
          });
          logged = true;
        }
        return fn.apply(Utils, arguments);
      };
    }
  }, 'Analytics', 'extend', 'resolve', 'netlog');

  /* global inject */
  inject((store, netlog) => {
    let fn;
    store('uuid', () => {
      if (fn) {
        return fn();
      } else {
        let result;
        fn = modern;
        try {
          result = fn();
        } catch (error) {
          netlog({
            app: 'JSAF',
            category: 'UUID',
            action: 'Modern UUID Error',
            error,
            sampling: 1 / 100
          });
        }
        if (result) return result;
        fn = cryptoFallback;
        try {
          result = fn();
        } catch (error) {
          netlog({
            app: 'JSAF',
            category: 'UUID',
            action: 'cryptoFallback UUID Error',
            error,
            sampling: 1 / 100
          });
        }
        if (result) return result;
        fn = old;
        return fn();
      }
    });
    function modern() {
      return crypto.randomUUID();
    }
    function cryptoFallback() {
      // 1) Create an array of 16 random bytes
      const bytes = crypto.getRandomValues(new Uint8Array(16));

      // 2) Per RFC 4122: set the version (4) and variant (10xxxxxx) bits
      bytes[6] = bytes[6] & 0x0f | 0x40; // Version 4
      bytes[8] = bytes[8] & 0x3f | 0x80; // Variant 10xxxxxx

      // 3) Split into the 5 UUID segments: 8-4-4-4-12 hex chars
      const segments = [bytes.slice(0, 4), bytes.slice(4, 6), bytes.slice(6, 8), bytes.slice(8, 10), bytes.slice(10, 16)];

      // 4) Convert each byte to a two‑digit hex string and join with hyphens
      return segments.map(seg => Array.from(seg).map(b => b.toString(16).padStart(2, '0')).join('')).join('-');
    }
    function old() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }, 'store', 'netlog');

  /* global inject */
  inject((subscribe, netlog) => {
    subscribe({
      topic: 'framework.ConfigLoaded',
      handler: ({
        Config
      }) => {
        if (Config.frameworkSrc && !Config.frameworkSrc.includes?.('go4')) {
          netlog({
            app: 'JSAF',
            category: 'Loading',
            action: 'Non-GO4 Framework Location',
            Config,
            sampling: 1 / 100
          });
        }
      }
    });
  }, 'subscribe', 'netlog');

  /* global Analytics */
  Analytics.additionalModelData || (Analytics.additionalModelData = []);
  Analytics.mode = navigator.userAgent.includes('DisneyRAWebView') ? 'webview' : 'web';

  /* global inject */
  inject((asyncArrayQueue, namespace, Analytics, subscribe) => {
    asyncArrayQueue(namespace('Subscriptions', [], Analytics), subscribe);
  }, 'asyncArrayQueue', 'namespace', 'Analytics', 'subscribe');

  /* global inject */
  inject((asyncArrayQueue, namespace, Analytics, $, Debug, fireEvent) => {
    asyncArrayQueue(namespace('Handlers', [], Analytics), o => {
      $(o.element || document).on(o.events, o.selector, o.data, o.handler);
      Debug.debug('Analytics.Handlers - bound handler', o);
    });
    fireEvent({
      event: 'jQueryReady.framework',
      data: [$]
    });
  }, 'asyncArrayQueue', 'namespace', 'Analytics', '$', 'Debug', 'fireEvent');
  if (Analytics.mode === 'web') {
    inject(function (Analytics, once) {
      var loadSwdpro = once(() => {
        (function (s_wdpro) {
          /* eslint-disable no-unused-vars */
          /* global s_wdpro:true, visitor, AppMeasurement, s_gi, nonProdDomain */

          /* Needed for line inside function which checks for window.AppMeasurement.mc */
          window.AppMeasurement = AppMeasurement;

          /********** WDPRO Report Suite ID Plugin **********
          WDPRO Plugin: Pass report suite into script src
          */
          (function () {
            function getQueryParameter(name, url) {
              if (url === undefined) url = location.href;
              var indicator = encodeURIComponent(name) + '=';
              var len = indicator.length;
              return (url + '?').split('?')[1].split('#')[0].split('&').filter(function (v) {
                return v.substr(0, len) === indicator;
              }).map(function (v) {
                return decodeURIComponent(v.substr(len).replace(/\+/g, ' '));
              })[0];
            }
            function getFirstScriptMatching(regex) {
              return Array.from(document.scripts).find(s => regex.test(s.src));
            }
            var script = document.currentScript || getFirstScriptMatching(/(?:analytics.*framework|\/jsaf\/v\/).*[?&]rsid=/),
              rsid = script ? getQueryParameter('rsid', script.src) : '';

            // s_account could be set in a script block prior to calling this s_code.js file.
            // The report suite IDs passed into script via the query string trumps all.
            if (rsid) window.s_account = rsid;
          })();
          /********** End WDPRO Report Suite ID Plugin **********/

          /**************************
           * modifyAccountFromURL
           * @Description - Appends secondary report suites and ensures that non-prod environments send to dev report suites,
           * this is particularly helpful with soft launch and load testing URLS so that we do not send data to the production
           * report suites
           *
           * @param host
           * @param s_account
           */
          function modifyAccountFromURL(host, s_account) {
            var isHkdl = s_account.includes('wdprohkdl'),
              isDev = s_account.slice(-3) === 'dev' || nonProdDomain(host);
            s_account += (isHkdl ? ',wdgwdprohkdlroll' : '') + ',wdgwdprosec';
            if (isDev) {
              // ensure all report suites end in 'dev'
              s_account = s_account.split(',').map(rs => rs + (rs.slice(-3) === 'dev' ? '' : 'dev')).join(',');
            } else {
              // this report suite is only for production data, there is no dev instance
              s_account += ',wdgdsec';
            }
            return s_account;
          }

          /**************************
           * setSiteCatalystAccountVars
           * @Description - appends additional report suite ids based on initial value of s_account
           * @param s_account
           * @param s_appendIds
           */
          function setSiteCatalystAccountVar(s_account, s_appendIds) {
            if (s_account && typeof s_account === 'string' && !s_account.includes(',') && s_appendIds === true) {
              s_account = modifyAccountFromURL(location.hostname, s_account);
            }
            if (s_account === undefined) {
              s_account = '';
            }
            if (!s_wdpro) {
              window.s_wdpro = s_wdpro = s_gi(s_account || 'notset');
            } else {
              s_wdpro.un = s_account;
            }
            s_wdpro.prop44 = s_wdpro.account = window.s_account = s_account;
          }
          if (s_wdpro && s_wdpro.__afproxy__) window.s_wdpro_afproxy = s_wdpro;
          window.s_wdpro = s_wdpro = undefined;
          if (typeof window.s_appendIds === 'undefined') {
            window.s_appendIds = true;
          }
          if (!window.s_account && typeof window._satellite?.getVar === 'function') {
            var satAccountId = window._satellite.getVar('configuration.SiteCatalyst.reportSuiteId');
            if (satAccountId) window.s_account = satAccountId;
          }
          setSiteCatalystAccountVar(window.s_account, window.s_appendIds);

          // GO4-661 queue trackLink calls until at least 1 second after page tracking
          (function (s) {
            const originalTL = s.tl;
            const originalClearVars = s.clearVars; //clear vars is called upon JSAF reset (preparing for a new pageview)

            let queueActive = true;
            const mirrorProps = ['linkTrackVars', 'linkTrackEvents', 'pe', 'linkObject', 'linkType', 'linkName', 'bodyClickTarget', 'bodyClickFunction', 'blnAutomateProp9'];
            const getSnapshot = () => {
              const snapshot = {
                env: {},
                ltv: {}
              };
              mirrorProps.forEach(key => snapshot.env[key] = s[key]);
              // capture each var named in linkTrackVars
              (s.linkTrackVars || '').split(',').forEach(key => {
                if (key && key in s) snapshot.ltv[key] = s[key];
              });
              return snapshot;
            };
            const queue = s.__tl_queue__ = [];
            const completedItems = s.__tl_queue_done__ = [];
            s.tl = function () {
              if (!queueActive) return originalTL.apply(s, arguments);
              queue.push({
                snapshot: getSnapshot(),
                args: Array.from(arguments)
              });
            };
            s.clearVars = function () {
              s.__tl_start_queue();
              return originalClearVars.apply(s, arguments);
            };
            s.__tl_end_queue = function () {
              queueActive = false;
              if (queue.length === 0) return;
              const pre = getSnapshot();
              while (queue.length) {
                const queuedItem = queue.shift();
                const {
                  snapshot: {
                    env,
                    ltv
                  },
                  args
                } = queuedItem;

                // restore that call’s env
                Object.assign(s, env);
                Object.entries(ltv).forEach(([k, v]) => {
                  if (!(k in pre.ltv)) pre.ltv[k] = s[k];
                  s[k] = v;
                });

                // fire the real tl
                originalTL.apply(s, args);
                completedItems.push(queuedItem);
              }
              Object.assign(s, pre.env, pre.ltv);
            };
            s.__tl_start_queue = function () {
              queueActive = true;
            };
          })(s_wdpro);
          s_wdpro.registerPostTrackCallback(requestUrl => {
            (s_wdpro.history || (s_wdpro.history = [])).push(requestUrl);
            // if request is a pageview then clear the tl queue after 1 second
            if (/(=|%2C)event3(%2C|&)/.test(requestUrl)) setTimeout(() => s_wdpro.__tl_end_queue(), 1000);
          });
          (function (window, proxyName, queueName) {
            const proxy = window[proxyName];
            if (proxy) {
              for (var prop in proxy) {
                if (prop !== '__afproxy__' && prop !== queueName && proxy.hasOwnProperty(prop) && typeof proxy[prop] !== 'function') {
                  s_wdpro[prop] = proxy[prop];
                }
              }
              if (Array.isArray(proxy[queueName])) {
                proxy[queueName].forEach(args => {
                  s_wdpro.t(...args);
                });
              }
              delete window[proxyName];
            }
          })(window, 's_wdpro_afproxy', '__afproxyTQueue__');

          /*Config utilities*/

          /**************************
           * addLinkInternalFilter
           * @Description - ensures our defaults are always there and prevents bad or
           *     duplicated values from being added to linkInternalFilters property
           * @param domain
           */
          s_wdpro.addLinkInternalFilter = function (url) {
            var domains = s_wdpro.linkInternalFilters || 'javascript:,disney.go.com',
              hostPattern = /(?:[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?\.)+[a-z]{2,6}/i,
              match;
            if (url && typeof url === 'string' && !url.includes('file://') && (match = url.match(hostPattern))) {
              //compare domain to list before adding
              if (!domains.includes(match[0])) {
                domains += ',' + match[0];
              }
            }
            return s_wdpro.linkInternalFilters = domains;
          };

          /************************** CONFIG SECTION **************************/

          /* VisitorAPI Integration */
          if (typeof visitor !== 'undefined') {
            s_wdpro.visitor = visitor;
          }

          /* You may add or alter any code config here. */
          s_wdpro.charSet = 'UTF-8';

          // defaults to "2" for backward compatibility (go.com) if not specified.
          if (!s_wdpro.cookieDomainPeriods) {
            s_wdpro.cookieDomainPeriods = location.hostname.slice(-6, -2) === '.co.' ? '3' : '2';
          }

          /* Conversion Config */
          s_wdpro.currencyCode = 'USD';

          /* Link Tracking Config */
          s_wdpro.blnAutomateProp9 = true;
          s_wdpro.trackDownloadLinks = true;
          s_wdpro.trackExternalLinks = true;
          s_wdpro.trackInlineStats = true;
          s_wdpro.linkDownloadFileTypes = 'exe,zip,wav,mp3,mov,mpg,avi,wmv,doc,pdf,xls';
          s_wdpro.addLinkInternalFilter(location.hostname);
          s_wdpro.linkLeaveQueryString = true;
          s_wdpro.linkTrackVars = ['server', 'prop1', 'prop2', 'prop4', 'prop9', 'prop11', 'prop12', 'prop13', 'prop14', 'prop20', 'prop29', 'prop52', 'eVar10', 'prop43', 'prop44', 'eVar4', 'contextData.product.title', 'contextData.cart.value', 'contextData.cart.alert.message', 'contextData.rec.source', 'contextData.rec.num', 'contextData.user.uuid'].join(',');
          s_wdpro.linkTrackEvents = 'None';
          /* Set media prop variable */
          if (s_wdpro.eVar2) {
            s_wdpro.prop3 = s_wdpro.eVar2;
          }
          s_wdpro.channelSep = '/';
          s_wdpro.exec = 0; //toggle for page view vs custom link

          /* Plugin Config */
          s_wdpro.usePlugins = true;

          /************************** Do Plugins **************************/
          s_wdpro.doPlugins = function (s_wdpro) {
            // if there is no report suite set, or the current tracking call is set to abort, do not execute
            // (solves GO4-2386 - loss of campaign code due to attempted Onetrust CMP interaction tracking)
            if (!s_wdpro.account || s_wdpro.abort) return;
            var channelSep,
              lnkObj,
              origLinkObject,
              overwriteLinkObject,
              tmpRef = s_wdpro.c_r('HBXREF');
            if (tmpRef && tmpRef.length > 0) {
              s_wdpro.referrer = tmpRef;
              s_wdpro.c_w('HBXREF', '', 0);
            }

            /***** Add calls to plugins here *****/

            /* Tracking for Marin */
            if (!s_wdpro.eVar54) {
              s_wdpro.eVar54 = s_wdpro.Util.getQueryParam('keyword_id');
            }

            /* External Campaign Tracking */
            if (!s_wdpro.campaign) {
              s_wdpro.campaign = unescape(s_wdpro.getValOnce(s_wdpro.Util.getQueryParam('CMP'), 's_v12', 0));
            }
            if (!s_wdpro.campaign) {
              s_wdpro.campaign = unescape(s_wdpro.getValOnce(s_wdpro.Util.getQueryParam('ecid'), 's_v12', 0));
            }
            s_wdpro.pageURL = s_wdpro.manageQueryParam('CMP');
            if (!s_wdpro.prop2) {
              s_wdpro.prop2 = 'D=SWID'; // dynamically pull SWID from header
            }
            if (!s_wdpro.prop19) {
              s_wdpro.prop19 = 'not set'; // used for contentDisplayed
            }
            s_wdpro.events = s_wdpro.apl(s_wdpro.events, 'event3', ',', 1); //set page view event

            s_wdpro.prop43 = s_wdpro.getPercentPageViewed();

            /* Set Search Vars */
            if (s_wdpro.eVar4) {
              /* if no results, modify search query for pathing purposes */
              if ((!s_wdpro.prop8 || /^(?:0|zero|null)$/.test(s_wdpro.prop8)) && !s_wdpro.eVar4.includes('null:')) {
                s_wdpro.prop8 = '0'; // internalSearchNumResults
                s_wdpro.eVar4 = 'null:' + s_wdpro.eVar4; // internalSearchKeywords
              }

              /* Set de-duped onsite search event */
              if (s_wdpro.getValOnce(s_wdpro.eVar4, 's_v4', 0)) {
                s_wdpro.events = s_wdpro.apl(s_wdpro.events, 'event2', ',', 1); // event2 is for internalSearch
              }
            }
            if (s_wdpro.autoClicked) {
              s_wdpro.prop9 = '';
              s_wdpro.c_w('s_slt', '', 0);
            }
            if (s_wdpro.autoClicked && s_wdpro.clickObject && (s_wdpro.getDeclaredLinkId(s_wdpro.clickObject) || !s_wdpro.clickObject.name && s_wdpro.clickObject.id)) {
              overwriteLinkObject = true;
              origLinkObject = s_wdpro.linkObject;
              s_wdpro.linkObject = s_wdpro.clickObject;
            }
            if (s_wdpro.blnAutomateProp9) s_wdpro.setupLinkTrack();
            if (overwriteLinkObject) s_wdpro.linkObject = origLinkObject;
            if (!s_wdpro.eVar3) {
              s_wdpro.eVar3 = function (intcmp, addata) {
                //Internal Campaign Tracking
                return intcmp && addata ? intcmp + ':' + addata : intcmp || addata;
              }(s_wdpro.Util.getQueryParam('int_cmp'), s_wdpro.Util.getQueryParam('addata'));
            }
            s_wdpro.eVar3 = s_wdpro.getValOnce(s_wdpro.eVar3, 's_v3', 0); //de-duplicate consecutive instances of tracking code

            s_wdpro.gpv_pageName = s_wdpro.getPreviousValue(s_wdpro.pageName, 's_gpv_pn'); //backup method for setting previous value of pagename

            // If prop9 is not set but there is a declared linkID set we should use it
            if (s_wdpro.prop9 === '' && (lnkObj = this.P || this.linkObject)) {
              s_wdpro.prop9 = s_wdpro.getDeclaredLinkId(lnkObj) || '';
            }

            // If DISCID parameter is present in URL that that is what should be used for the linkId
            (function (DISCID) {
              if (DISCID !== '') s_wdpro.prop9 = DISCID;
            })(s_wdpro.Util.getQueryParam('DISCID'));
            if (s_wdpro.eVar3) {
              if (s_wdpro.exec < 1) {
                s_wdpro.products = s_wdpro.apl(s_wdpro.products, 'ads;' + s_wdpro.eVar3 + ';;;event7=1', ',', 2); //don't overwrite product string on page load
              } else {
                s_wdpro.products = 'ads;' + s_wdpro.eVar3 + ';;;event7=1'; //overwrite product string on all other executions to prevent old values from being included
              }
              s_wdpro.linkTrackVars = ['server', 'prop1', 'prop2', 'prop4', 'prop9', 'prop11', 'prop12', 'prop13', 'prop14', 'prop20', 'prop29', 'prop44', 'prop52', 'products', 'eVar3', 'eVar10', 'eVar4', 'events', 'contextData.product.title', 'contextData.cart.value', 'contextData.cart.alert.message', 'contextData.rec.source', 'contextData.rec.num', 'contextData.user.uuid'].join(',');
              s_wdpro.linkTrackEvents = 'event7';
              s_wdpro.events = s_wdpro.apl(s_wdpro.events, 'event7', ',', 1);
            }

            /* Set Internal Campaign Views */
            /* Don't allow function to execute more than once per page */
            if (s_wdpro.exec < 1) {
              s_wdpro.AdsT = s_wdpro.getLinkParams('addata', 'goto', '6', 'ads;', '');
              if (s_wdpro.AdsT) {
                s_wdpro.products = s_wdpro.apl(s_wdpro.products, s_wdpro.AdsT, ',', 2);
              }
              s_wdpro.exec++;
            }

            //ensure pageName and heir are always properly in sync

            // 1) pagName value must contain hier1 value
            if (s_wdpro.pageName && s_wdpro.hier1 && !s_wdpro.pageName.includes(s_wdpro.hier1)) {
              s_wdpro.pageName = s_wdpro.hier1 + s_wdpro.channelSep + s_wdpro.pageName;
            }
            // 2) pageName should be only 1 stem more than hier1 (example pageName="a/b/c" hier="a/b")
            if (s_wdpro.pageName && s_wdpro.hier1) {
              s_wdpro.hier1 = s_wdpro.pageName.split(s_wdpro.channelSep);
              s_wdpro.hier1.pop();
              s_wdpro.hier1 = s_wdpro.hier1.join(s_wdpro.channelSep);
            }

            /* channelExtract Example: 1.0 */
            if (s_wdpro.hier1) {
              s_wdpro.prevHier1 = s_wdpro.prevHier1 || '';
              if (s_wdpro.hier1 !== s_wdpro.prevHier1) {
                channelSep = s_wdpro.channelSep || '/';
                s_wdpro.channel = s_wdpro.channelExtract(channelSep, 6, s_wdpro.hier1);
                s_wdpro.prop5 = s_wdpro.channelExtract(channelSep, 7, s_wdpro.hier1);
                s_wdpro.prop6 = s_wdpro.channelExtract(channelSep, 8, s_wdpro.hier1);
                s_wdpro.prop24 = s_wdpro.channelExtract(channelSep, 9, s_wdpro.hier1);
                s_wdpro.prevHier1 = s_wdpro.hier1;
              }
            }
            if (s_wdpro.events.includes('purchase') && !s_wdpro.purchaseID) {
              s_wdpro.events = s_wdpro.repl(s_wdpro.events, 'purchase', ''); //temporary code to remove purchase event if purchaseID not set
            }

            /* Campaign Stacking */
            s_wdpro.eVar12 = s_wdpro.crossVisitParticipation(s_wdpro.campaign, 's_cpm', '90', '5', '>', 'purchase', 1);
            return 1;
          };
          s_wdpro.loadModule('Media');
          /******************** End of doPlugins ********************/

          /********** WDPRO Functions **********/
          (function () {
            var s = s_wdpro; // alias s_wdpro to "s" inside this iife

            // auto track detection
            var originalPa = s.Pa;
            s.autoClicked = false;
            s.Pa = function () {
              s.autoClicked = !s.autoClicked;
              return originalPa.apply(s, arguments);
            };

            /*********************
             * s.channelExtract()
             *
             * @Description - Built as polyfil when upgrading to AppMeasurement
             */
            s.channelExtract = function (sep, depth, hier) {
              return hier ? hier.split(sep).slice(0, depth).join(sep) : '';
            };
            (function () {
              s.getDeclaredLinkId = s.getParentLinkId = traverseParents(getExplicitLinkId);
              s.getAssociatedLinkId = getLinkId;
              s.cleanLinkId = cleanLinkId;

              /* prioritize explicit linkIds of ancestors over derived linkIds  */
              function getLinkId(element) {
                if (element && typeof element.getAttribute === 'function') {
                  return s.getDeclaredLinkId(element) || getDerivedLinkId(element);
                }
                return '';
              }
              function getExplicitLinkId(element) {
                var nameAttr, lid;
                lid = element.getAttribute('analyticsLinkId') || (nameAttr = element.getAttribute('name')) && (/(?:&(?:amp;)?)?lid=(\S+)/.exec(nameAttr) || [])[1] || '';
                return lid ? cleanLinkId(lid) : lid;
              }
              function getDerivedLinkId(element) {
                var result, link;
                if ((link = traverseParents(getAssociatedLink)(element)) && (result = getDerivedLinkIdFromAnchor(link))) return result;
                if ((result = element.id) && (result = cleanLinkId(result))) return result;
                if ((result = element.name) && (result = cleanLinkId(result))) return result;
                return function () {
                  var retVal = '';
                  var strNodeName = element.nodeName.toLowerCase();
                  switch (strNodeName) {
                    case 'input':
                      if ((element.type === 'button' || element.type === 'submit' || element.type === 'reset') && element.value) {
                        retVal = element.value;
                      } else {
                        retVal = strNodeName;
                      }
                      break;
                    case 'textarea':
                      retVal = strNodeName;
                      break;
                    default:
                      retVal = element.innerHTML || strNodeName;
                  }
                  return cleanLinkId(retVal);
                }();
              }
              function getDerivedLinkIdFromAnchor(element) {
                var result, img;
                if ((result = element.id) && (result = cleanLinkId(result))) return result;
                if ((result = element.name) && (result = cleanLinkId(result))) return result;
                if ((result = element.textContent) && (result = cleanLinkId(result))) return result;
                if ((img = element.querySelector('img')) && (result = img.src) && (result = result.slice(result.lastIndexOf('/') + 1)) && (result = cleanLinkId(result))) return result;
                if ((result = element.innerHTML) && (result = cleanLinkId(result))) return result;
              }
              function traverseParents(fn) {
                return function surrogate(element) {
                  var result = fn(element);
                  if (result) return result;
                  if (element.parentNode && element.parentNode !== element && element.parentNode.getAttribute) return surrogate(element.parentNode);
                  return result;
                };
              }
              function cleanLinkId(linkId) {
                return typeof linkId !== 'string' ? linkId : linkId.replace(/<\/?[^>]+(>|$)/g, ' ').replace(/[^a-z0-9\-+_&\s]/ig, '').replace(/\s+/g, ' ').trim().slice(0, 99).trim();
              }
              function getAssociatedLink(element) {
                if (element.nodeName && element.nodeName.toUpperCase() === 'A') return element;
              }
            })();
            s.determineProp9 = function (nodeElem, ret) {
              var retVal = '';
              //Make sure the node is included and is an object.
              if (nodeElem && typeof nodeElem == 'object') {
                retVal = s.getAssociatedLinkId(nodeElem);
                if (!ret) {
                  s.prop9 = retVal;
                } else {
                  return retVal;
                }
              }
            };

            /*********************
             * s.trackClick()
             *
             * @Author Matt Alexander, Jose Bergiste, John Marty
             * @LastModified 06/23/09
             *
             * @Description - Tracks a link via JavaScript instead of relying on automatic tracking.
             * Automatic tracking only works if the next page is also a WDPRO page with standard SiteCatalyst tracking.
             * trackClick comes in handy for exit links or links that open hidden content instead of going to the next URL.
             *
             * @param {DOM node} nodeElem The DOM element being clicked. Can be an anchor or input or any element you want.
             * @param {String} strLinkId Optional ID of the link being tracked. This is what shows up in the reports.
             *      Link IDs are provided by the site's analyst in the analytics solution design spreadsheet. The usually end in "_Link".
             *      strLinkId is here for backward compatibility. Proper implementation is to pull the LinkId from the nodeElem's id attribute.
             *      To get the id into the element, put it in the pageName property of an Analytic object referenced from a UIElement.
             *          Your renderLink.tea template may not be set up to put that link id from the CMS into the element's id attribute.
             *          In the past they went into the name atribute with &lid= prepended.
             *      If strLinkId is passed in it takes precedence over nodeElem's id attribute and over objAdditionalVariables.prop9.
             * @param {Object} objAdditionalVariables Optional object with properties that match SiteCatalyst variable names.
             *      Typically not needed since the default tracking variables satisfy 90% of links.
             *
             * @example For example implementation details using jQuery and DEWEY, visit wikipage:
             * (http://wiki.wdpro.wdig.com/display/Tech/Tracking+Link+Clicks+and+Page+Views+with+SiteCatalyst#TrackingLinkClicksandPageViewswithSiteCatalyst-ManualLinkTracking%3A)
             *
             **/
            s.trackClick = function (nodeElem, strLinkId, objAdditionalVariables) {
              var arrVariablesToRestore = {},
                strProperty;
              nodeElem = nodeElem || {};
              objAdditionalVariables = objAdditionalVariables || {};
              //Make sure the node is included and is an object.
              if (typeof nodeElem == 'object') {
                // Disable automatic setting of prop9, since we are passing in a specific value.
                s.blnAutomateProp9 = false;

                /**** Defaults ****/
                // These defaults comprise the base tracking for any link.

                // Note that s is a global object. Properties defined in it when the HTML loaded are maintained and passed in link tracking calls.
                // linkTrackVars and linkTrackEvents allow you to filter down the properties to the few you want to pass.
                s.linkTrackVars = ['prop1', 'prop2', 'prop9', 'prop12', 'prop44', 'prop52', 'eVar10', 'eVar4', 'contextData.product.title', 'contextData.cart.value', 'contextData.cart.alert.message', 'contextData.rec.source', 'contextData.rec.num', 'contextData.user.uuid'].join(',');
                // Note that linkTrackEvents is ignored unless you include "events" as a variable to track in linkTrackVars.
                s.linkTrackEvents = 'None';
                // For page views prop12 is the previous page. For link clicks it is the current page.
                s.prop12 = s.pageName;

                /**** End Defaults ****/

                // Add or overwrite variables passed in objAdditionalVariables
                if (objAdditionalVariables) {
                  for (strProperty in objAdditionalVariables) {
                    if (objAdditionalVariables.hasOwnProperty(strProperty)) {
                      // Save original value from s
                      arrVariablesToRestore[strProperty] = s[strProperty];

                      // Update value in s object
                      s[strProperty] = objAdditionalVariables[strProperty];

                      // Add this property to the list of variables to track if it is not already in there.
                      if (!(',' + s.linkTrackVars + ',').includes(',' + strProperty + ',')) {
                        s.linkTrackVars += ',' + strProperty;
                      }

                      // Now that s.events has been updated and "events" has been added to linkTrackVars,
                      // s.linkTrackEvents needs to be updated as well. The regex removes values from the events.
                      if (strProperty == 'events') {
                        s.linkTrackEvents = objAdditionalVariables.events.replace(/[=:].+?(?=,|$)/g, '');
                      }
                    }
                  }
                }

                /***** Set prop9 *****
                prop9 = LinkId.
                Priority order of inputs:
                1) strLinkId
                2) objAdditionalVariables.prop9 (set in for loop above)
                3) nodeElem's attributes
                */
                if (strLinkId) {
                  strLinkId = s.cleanLinkId(strLinkId);
                } else if (!objAdditionalVariables || !objAdditionalVariables.hasOwnProperty('prop9')) {
                  strLinkId = s.determineProp9(nodeElem, true);
                }

                /***** Report the link click to Omniture. *****/
                // "o" indicates a custom link, "d" is download, and "e" is for exit links. Download links and exit links are automated elsewhere in s_code.js.
                // trackClick is only for custom links so this is always set to "o".
                // It is redundant to pass s.prop9 here since it is in the s object, but this function doesn't work without it.

                // Passing the element in the first argument enables a 500 millisecond pause before the link href is fired
                // to give time for the tracking call to go out. Otherwise this tracking call could be aborted by the browser.
                s.prop9 = strLinkId;
                s.tl(nodeElem, 'o', strLinkId, objAdditionalVariables);
                /***** Resets *****/

                // Reset variables to prevent recounting of the values intended only for this one link tracking call.
                for (strProperty in arrVariablesToRestore) {
                  if (arrVariablesToRestore.hasOwnProperty(strProperty)) {
                    s[strProperty] = arrVariablesToRestore[strProperty];
                  }
                }
                // Re-enable automatic determination of prop9 for Exit links and others that are automatically tracked outside of this function.
                s.blnAutomateProp9 = true;
                s.prop9 = undefined;
              }
            };
            /*********************
             *  trackLink
             *  @Description - kept for backwards compatibility
             **/
            s.trackLink = s.trackClick;

            /*********************
             * s.trackPage()
             *
             * @Author Matt Alexander
             * @LastModified 06/23/09
             *
             * @Description - Reports a page view representing a previously hidden layer that replaces the main content of the page.
             *      Note: All current properties of the s object will be reported along with the new name and linkID you pass in.
             *          This is because the JS page view would usually be in the same site section and have the same values as
             *          the page view that fired when the page first loaded.
             *      Note: For AJAX responses, the analytics values are returned from the CMS and Java in the Analytics section of the model.
             *          You typically parse your JSON or XML resoponse and populate the objAdditionalVariables object and then call this function.
             * @param {String} strPageName the name of the new page to be reported. If not passed in the original page name is reported again.
             * @param {String} strLinkId Optional ID of the link being tracked. This shows up as prop9 in the reports.
             *      Link IDs are provided by the site's analyst in the analytics solution design spreadsheet. The usually end in "_Link".
             *      strLinkId is here for backward compatibility. Proper implementation is to pull the LinkId from the nodeElem's id attribute.
             *      If strLinkId is passed in it takes precedence over nodeElem's id attribute.
             * @param {DOM node} nodeElem The DOM element being clicked. Can be an anchor or input or any element you want.
             * @param {Object} objAdditionalVariables Optional object with properties that match SiteCatalyst variable names.
             *      Typically not needed since JS page views usually reuse properties previously set in the s object.
             *
             * @example
                s_wdpro.trackPage("mickeysecrets", "", document.getElementById("hiddenMickeyButton"));
             *
             * @example
                var objAdditionalVariables = {
                    pageName: "MyNewPage"
                    , hier1: "MyNewHierarchy"
                    , prop9: "MyAddtoCart_Link"
                    , events: "scAdd,event3"
                    , prop19: "myTestValue"
                    , eVar24: "myTestValue"
                }
                s_wdpro.trackPage("", "", "", objAdditionalVariables);
             *
             **/
            s.trackPage = function (strPageName, strLinkId, nodeElem, objAdditionalVariables) {
              objAdditionalVariables = objAdditionalVariables || {};
              var channelSep = s.channelSep || '/';

              // Disable automatic setting of prop9, since we are passing in a specific value.
              s.blnAutomateProp9 = false;
              if (objAdditionalVariables) {
                channelSep = objAdditionalVariables.channelSep || channelSep;
                for (var strProperty in objAdditionalVariables) {
                  if (objAdditionalVariables.hasOwnProperty(strProperty)) {
                    // Update value in s object
                    // Note that pageName and hierarchy should be lowercase to adhere to our WDPRO reporting standard.
                    if (strProperty === 'hier1') {
                      s.hier1 = objAdditionalVariables.hier1.toLowerCase();
                    }
                    if (strProperty === 'pageName') {
                      if (objAdditionalVariables.hier1) {
                        s.pageName = objAdditionalVariables.hier1 + channelSep + objAdditionalVariables.pageName;
                      } else {
                        s.pageName = s.hier1 + channelSep + objAdditionalVariables.pageName;
                      }
                      s.pageName = s.pageName.toLowerCase();
                    } else {
                      s[strProperty] = objAdditionalVariables[strProperty];
                    }
                  }
                }
              }

              /***** Set prop9 *****
              prop9 = LinkId.
              Priority order of inputs:
              1) strLinkId
              2) objAdditionalVariables.prop9 (set in for loop above)
              3) nodeElem's attributes
              */
              if (strLinkId) {
                strLinkId = s.cleanLinkId(strLinkId);
              } else if (!objAdditionalVariables || !objAdditionalVariables.hasOwnProperty('prop9')) {
                strLinkId = s.determineProp9(nodeElem, true);
              }

              /***** Set pageName *****
              Priority order of inputs:
              1) strPageName
              2) objAdditionalVariables.pageName (set in for loop above)
              3) original strPageName (would already be set)
              */
              // Note that pageName and hierarchy should be lowercase to adhere to our WDPRO reporting standard.
              if (strPageName) {
                s.pageName = s.hier1 + channelSep + strPageName.toLowerCase();
              }
              s.prop9 = strLinkId;
              /***** Report page view to Omniture. *****/
              s.t();

              /***** Resets *****/
              // Re-enable automatic determination of prop9 for Exit links and others that are automatically tracked.
              s.blnAutomateProp9 = true;
            };
            s.manageQueryParam = function (param) {
              var params = location.search.slice(1).split('&').sort(function (a, b) {
                return b.startsWith(param + '=') ? 1 : 0;
              }).map(function (v) {
                return v.replace(/%7C/ig, '|').replace(/%25/g, '%');
              }).join('&');
              return location.protocol + '//' + location.host + location.pathname + (params ? '?' + params : '');
            };

            /********** End WDPRO Functions **********/
          })();

          /************************** PLUGINS SECTION *************************/
          /* You may insert any plugins you wish to use here.                 */

          /* getPercentPageViewed v3.0 (Modified by CA) w/handlePPVevents helper function */
          s_wdpro.getPercentPageViewed = function (pid, ch) {
            var s = this,
              a = s.c_r('s_ppv'),
              handler,
              dhandler,
              ppv = '';
            a = a.includes(',') ? a.split(',') : [];
            a[0] = s.unescape(a[0]);
            pid = pid || s.pageName || location.href;
            s.ppvChange = ch === undefined ? true : ch;
            if (s.linkType === undefined || s.linkType !== 'o') {
              if (!s.ppvID || s.ppvID !== pid) {
                s.ppvID = pid;
                s.c_w('s_ppv', '');
                s.handlePPVevents();
              }
              if (window.addEventListener && s.p_fo('s_gppvLoad')) {
                handler = s.handlePPVevents.bind(s);
                dhandler = s.debounceTrailing(handler, 200);
                window.addEventListener('load', handler, false);
                window.addEventListener('click', handler, false);
                window.addEventListener('scroll', dhandler, false);
                window.addEventListener('resize', dhandler, false);
              }
              s._ppvPreviousPage = a[0] || '';
              ppv = s._ppvHighestPercentViewed = a[1] || '';
              s._ppvInitialPercentViewed = a[2] || '';
              s._ppvHighestPixelsSeen = a[3] || '';
            }
            return ppv;
          };

          /* handlePPVevents helper function (for getPercentPageViewed v3.0 Plugin) */
          s_wdpro.handlePPVevents = function () {
            var s = this;
            if (s.ppvID) {
              var f = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight),
                b = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) + (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight),
                d = Math.min(Math.round(b / f * 100), 100),
                e = '',
                c,
                g,
                h;
              if (!s.c_r('s_tp') || s.unescape(s.c_r('s_ppv').split(',')[0]) !== s.ppvID || s.ppvChange == 1 && s.c_r('s_tp') && s.c_r('s_tp') != f) {
                s.c_w('s_tp', f);
                s.c_w('s_ppv', '');
              } else {
                e = s.c_r('s_ppv');
              }
              c = e && e.includes(',') ? e.split(',', 4) : [];
              f = c.length > 0 ? c[0] : escape(s.ppvID);
              g = c.length > 1 ? parseInt(c[1]) : d;
              h = c.length > 2 ? parseInt(c[2]) : d;
              c = c.length > 3 ? parseInt(c[3]) : b;
              if (d > 0) {
                e = f + ',' + (d > g ? d : g) + ',' + h + ',' + (b > c ? b : c);
              }
              s.c_w('s_ppv', e);
            }
          };
          s_wdpro.debounceTrailing = function (originalFn, intervalMs) {
            var timer;
            return function () {
              clearTimeout(timer);
              timer = setTimeout(originalFn.apply.bind(originalFn, this, arguments), intervalMs);
            };
          };

          /* p_fo (pageFirstOnly) v2.0 */
          s_wdpro.p_fo = function (on) {
            var s = this;
            if (!s.__fo) {
              s.__fo = {};
            }
            if (!s.__fo[on]) {
              s.__fo[on] = {};
              return true;
            } else {
              return false;
            }
          };
          s_wdpro.setupLinkTrackVarsList = 'prop12,prop9,eVar11';
          s_wdpro.setupLinkTrackCookie = 's_slt';

          /* Plugin: setupLinkTrack v3.2 (Modified to expose setting the cookie as a seperate function) */
          s_wdpro.setupLinkTrack = function (vl, c) {
            this.setupLinkTrackPrevPage(vl, c);
            this.setupLinkTrackNextPage(vl, c);
          };
          s_wdpro.setupLinkTrackPrevPage = function (vl, c) {
            /* SECTION I: READS ANY EXISTING COOKIE VALUES AND SETS THE VARIABLES (contained in vl parameter) ACCORDINGLY */

            var s = this,
              cv,
              cva,
              vla;
            vl = vl || s.setupLinkTrackVarsList;
            c = c || s.setupLinkTrackCookie;

            //set cv equal to the value of the c cookie
            cv = s.c_r(c);

            // If the vl (variable list) parameter exists set vla equal to an array of the items in vl
            if (vl) vla = vl.split(',');

            //if the cookie has a value
            if (cv != '') {
              //set cva equal to an array of what's in cv (using double carat as the delimiter)
              cva = cv.split('^^');
              //if cva[1] is not blank
              if (cva[1] != '') {
                vla.forEach(function (propEvar, i) {
                  //set the s object variables contained in the vl parameter equal to their cookie value equivalent
                  s[propEvar] = cva[i];
                });
              }
            }
            //clear the c cookie and expire it once all values have been set in their respective variables
            s.c_w(c, '', 0);
          };
          s_wdpro.setupLinkTrackNextPage = function (vl, c) {
            /* SECTION II: SETS LINK VALUES IF A LINK CLICK HAS OCCURED */

            var s = this,
              vla;
            vl = vl || s.setupLinkTrackVarsList;
            c = c || s.setupLinkTrackCookie;

            // If the vl (variable list) parameter exists set vla equal to an array of the items in vl
            if (vl) vla = vl.split(',');

            //if we have a linkObject (either the first parameter in an s.tl call, or the HTML element that was clicked on)
            if (typeof s.linkObject != 'undefined') {
              //clear the link tracking array (lta)
              s.lta = [];

              //if s.pageName is set, set lta[0] equal to the pageName value or default
              s.lta[0] = typeof s.pageName != 'undefined' ? s.pageName : 'unknown page';

              //If s.linkObject is not '0' (0 = nothing was clicked on and we don't have an s.tl call)
              if (s.linkObject != 0) s.lta[1] = s.determineProp9(s.linkObject, true);

              //if s.lta[1] (the link name) has a value
              if (s.lta[1] != null) {
                //set lta[2] equal to pipe delimited values of the page name and link name
                s.lta[2] = s.lta[0] + ' | ' + s.lta[1];
              }
              try {
                //set lta[3] equal to the first id attribute encountered within the linkObject's parentNode tree
                s.lta[3] = s.trackLinkModule(s.linkObject);
                if (s.lta[3] === undefined) s.lta.length = 3;
              } catch (e) {/* ignore */}

              //if s.linkType is set (custom/download/exit link)
              if (s.linkType != 0) {
                vla.forEach(function (propEvar, i) {
                  //set the s object variables contained in the vl parameter equal to their lta equivalent
                  s[propEvar] = s.cleanStr(s.lta[i]);
                  //add the x'th item in vla to s.linkTrackVars
                  s.linkTrackVars = s.apl(s.linkTrackVars, propEvar, ',', 1);
                });
              } else if (s.lta[1]) {
                //if linkType isn't set but lta[1] is set (usually happens via a non-tracked, regular link click)
                //write the cookie (to be extracted on the next page)
                s.c_w(c, s.lta.map(s.cleanStr).join('^^'));
              }
              //Clear the link tracking array
              s.lta = null;
            }
          };

          /**
           * Allows for declaritive next page link transition tracking
           * @param {string} linkId
           */
          s_wdpro.linkTrackTransition = function (linkId) {
            var s = this,
              originalLinkObj = s.linkObject,
              originalLinkType = s.linkType;
            s.linkObject = {
              getAttribute: function (attr) {
                return attr === 'analyticsLinkId' ? linkId : '';
              }
            };
            s.linkType = 0;
            s.setupLinkTrackNextPage();
            s.linkObject = originalLinkObj;
            s.linkType = originalLinkType;
          };

          /* trackLinkModule utility */
          s_wdpro.trackLinkModule = function (l) {
            //get the linkObject's parentNode
            var t = l.parentNode;
            //as long as there is a parentNode
            while (t) {
              //if the parentNode has an id attribute
              if (t.hasAttribute('id')) {
                //return the id attribute
                return t.getAttribute('id');
                //if there is no id attribute
              } else {
                //go up to the next parentNode
                t = t.parentNode;
              }
            }
          };

          /* cleanStr utility */
          s_wdpro.cleanStr = function (a) {
            if (typeof a === 'string') {
              return a.replace(/<\/?[^>]+(>|$)/g, '') // HTML tags
              .trim() // whitespace from both sides
              .replace(/[\u2018\u2019\u201A]/g, '') // single quotation marks
              .replace(/\t+/g, '') // tabs
              .replace(/(\r\n|\n|\r)/g, ' ') // carriage return/newlines
              .replace(/\s{2,}/g, ' '); // multiple spaces
            }
          };

          /*
           * channel manager
           */
          s_wdpro.isEntry = function () {
            var s = this,
              l = s.linkInternalFilters,
              r = s.referrer || typeof s.referrer != 'undefined' ? s.referrer : document.referrer,
              p = l.indexOf(','),
              b = 0,
              v = '';
            if (!r) {
              return 1;
            }
            while (p = l.indexOf(',')) {
              v = p > -1 ? l.substring(b, p) : l;
              if (v == '.' || r.includes(v)) {
                return 0;
              }
              if (p == -1) {
                break;
              }
              b = p + 1;
              while (l.indexOf(',') + 1 == b) {
                b++;
              }
              l = l.substring(b, l.length);
            }
            return 1;
          };
          s_wdpro.fireOnce = function () {
            if (!s_wdpro.__fo) {
              s_wdpro.__fo = {};
              return 1;
            } else {
              return 0;
            }
          };
          s_wdpro.p_gpv = s_wdpro.p_gpvne = function (k, u) {
            var s = this,
              v = '',
              i = u.indexOf('?'),
              q;
            if (k && i > -1) {
              q = u.substring(i + 1);
              v = s.pt(q, '&', 'p_gvf', k);
            }
            return v;
          };
          s_wdpro.p_gvf = s_wdpro.p_gvfne = function (t, k) {
            if (t) {
              var i = t.indexOf('='),
                p = i < 0 ? t : t.substring(0, i),
                v = i < 0 ? 'True' : t.substring(i + 1);
              if (p.toLowerCase() == k.toLowerCase()) return v;
            }
            return '';
          };

          /*
          * Plugin: clickPast v1.0 - SearchCenter Bounce Rate
          */
          s_wdpro.clickPast = function (scp, ct_ev, cp_ev, cpc) {
            var s = this,
              ev;
            if (s.p_fo(ct_ev) == 1) {
              if (!cpc) {
                cpc = 's_cpc';
              }
              ev = s.events ? s.events + ',' : '';
              if (scp) {
                s.events = ev + ct_ev;
                s.c_w(cpc, 1, 0);
              } else {
                if (s.c_r(cpc) >= 1) {
                  s.events = ev + cp_ev;
                  s.c_w(cpc, 0, 0);
                }
              }
            }
          };

          /** Another polyfil needed for upgrading to AppMeasurement */
          s_wdpro.pt = function (x, d, f, a) {
            var s = this,
              t = x,
              z = 0,
              y,
              r;
            while (t) {
              y = t.indexOf(d);
              y = y < 0 ? t.length : y;
              t = t.substring(0, y);
              r = s[f](t, a);
              if (r) {
                return r;
              }
              z += y + d.length;
              t = x.substring(z, x.length);
              t = z < x.length ? t : '';
            }
            return '';
          };

          /*
           *  Plugin: crossVisitParticipation v1.7 - stacks values from
           *  specified variable in cookie and returns value
           */
          s_wdpro.crossVisitParticipation = function (v, cn, ex, ct, dl, ev, dv) {
            var s = this,
              a,
              arry,
              ay,
              c,
              ce,
              data,
              diff,
              e,
              ea,
              g,
              h,
              q,
              r,
              start,
              td,
              u,
              x,
              z;
            if (typeof dv === 'undefined') dv = 0;
            if (s.events && ev) {
              ay = s.split(ev, ',');
              ea = s.split(s.events, ',');
              for (u = 0; u < ay.length; u++) {
                for (x = 0; x < ea.length; x++) {
                  if (ay[u] == ea[x]) {
                    ce = 1;
                  }
                }
              }
            }
            if (!v || v == '') {
              if (ce) s.c_w(cn, '');
              return '';
            }
            v = escape(v);
            arry = [];
            a = [];
            c = s.c_r(cn);
            g = 0;
            h = [];
            if (c && c != '') {
              arry = s.split(c, '],[');
              for (q = 0; q < arry.length; q++) {
                z = arry[q];
                z = s.repl(z, '[', '');
                z = s.repl(z, ']', '');
                z = s.repl(z, "'", '');
                arry[q] = s.split(z, ',');
              }
            }
            e = new Date();
            e.setFullYear(e.getFullYear() + 5);
            if (dv == 0 && arry.length > 0 && arry[arry.length - 1][0] == v) arry[arry.length - 1] = [v, new Date().getTime()];else arry[arry.length] = [v, new Date().getTime()];
            start = arry.length - ct < 0 ? 0 : arry.length - ct;
            td = new Date();
            for (x = start; x < arry.length; x++) {
              diff = Math.round((td.getTime() - arry[x][1]) / 86400000);
              if (diff < ex) {
                h[g] = unescape(arry[x][0]);
                a[g] = [arry[x][0], arry[x][1]];
                g++;
              }
            }
            data = s.join(a, {
              delim: ',',
              front: '[',
              back: ']',
              wrap: "'"
            });
            s.c_w(cn, data, e);
            r = s.join(h, {
              delim: dl
            });
            if (ce) s.c_w(cn, '');
            return r;
          };

          /*
           *  Plugin: getLinkParams 1.3g
           */
          s_wdpro.getLinkParams = function (p, qp, m, q, ev) {
            var s = this,
              a = '',
              ap,
              e,
              i,
              l,
              l2,
              la,
              ll,
              r,
              t = 0;
            ev = ev ? ';;;' + ev + '=1' : '';
            if (s.d.links) {
              for (i = 0; i < s.d.links.length; i++) {
                l = s.d.links[i];
                r = l.href;
                e = l.name;
                e = !e ? '' : !e.startsWith('&') ? '&' + e : e;
                la = r.includes('?') ? r.substring(r.indexOf('?')) + e : e ? '?' + e : '';
                ll = la.toLowerCase();
                if (qp && ll.indexOf(qp.toLowerCase()) > 0) {
                  l2 = qp ? s.Util.getQueryParam(qp, '', ll) : '';
                } else {
                  l2 = '';
                }
                if (l2 && l2.indexOf(p.toLowerCase()) > 0) {
                  ap = s.Util.getQueryParam(p, '', l2 + '');
                  if (ap != '' && ap.indexOf('#') < 0) {
                    a = s.apl(a, q + ap + ev, ',', 2);
                    t = t + 1;
                  }
                } else if (ll.indexOf(p.toLowerCase()) > 0) {
                  ap = s.Util.getQueryParam(p, '', la + '');
                  if (ap != '' && ap.indexOf('#') < 0) {
                    a = s.apl(a, q + ap + ev, ',', 2);
                    t = t + 1;
                  }
                }
                if (t == m) return a;
              }
              return a;
            }
          };

          /*
           * Utility Function: getinnerHTML v1.0
           */
          s_wdpro.getinnerHTML = function (o) {
            var ih = '' + o.innerHTML,
              i = ih.toLowerCase().indexOf('<img'),
              m;
            if (ih && i > -1) {
              m = / src\s*=\s*['"]?([^'" ]+)['"]?/i.exec(ih);
              if (m) ih = m[1];
            }
            return ih;
          };

          /*
           * Plugin Utility: Replace v1.0
           */
          s_wdpro.repl = function (x, o, n) {
            var i = x.indexOf(o),
              l = n.length;
            while (x && i >= 0) {
              x = x.substring(0, i) + n + x.substring(i + o.length);
              i = x.indexOf(o, i + l);
            }
            return x;
          };
          /*
           * Plugin: getValOnce 0.2 - get a value once per session or number of days
           */
          s_wdpro.getValOnce = function (v, c, e) {
            var s = this,
              k = s.c_r(c),
              a = new Date();
            e = e || 0;
            if (v) {
              a.setTime(a.getTime() + e * 86400000);
              s.c_w(c, v, e ? a : 0);
            }
            return v == k ? '' : v;
          };

          /* Plugin: getPreviousValue 1.1 (With Comments) */
          s_wdpro.getPreviousValue = function (v, c, el) {
            var s = this,
              t = new Date(),
              i,
              j,
              r = '',
              f = 1;
            //set the c parameter equal to "s_gpv" by default
            c = c || 's_gpv';
            //set the t variable equal to 30 minutes from now
            t.setTime(t.getTime() + 18E5);
            //if the el (event list) parameter is set
            if (el) {
              //set f equal to zero
              f = 0;
              //set i equal to an array of what's in el (i.e the event list)
              i = el.split(',');
              //set j equal to an array of what's in s.events
              j = s.events ? s.events.split(',') : '';
              //loop through each item in the el array
              for (var x = 0, il = i.length; x < il; x++) {
                //loop through the s.events array
                for (var y = 0, jl = j.length; y < jl; y++)
                //if the x'th item in the el array matches the y'th item in the s.events array (i.e. an event in s.events is contained in the event list)
                if (i[x] == j[y]) {
                  //set f equal to 1
                  f = 1;
                  //break out of the loop
                  break;
                }
                //if f is equal to 1 (i.e. we have a match) break out of the loop
                if (f == 1) break;
              }
            }
            //if f is equal to 1 (*always* the case when el parameter isn't set, or if an event in s.events matches an event in el parameter)
            if (f == 1) {
              //if we can read the c cookie set r equal to the c cookie value
              if (s.c_r(c)) r = s.c_r(c);
              //if v (the variable with the value to store) is set, write the c cookie equal to the v value, to expire in 30 minutes. Otherwise, set the c cookie equal to "no value", also to expire in 30 minutes
              s.c_w(c, v || 'no value', t);
            }
            //return r (the previous value of v contained in the c cookie before the c cookie was overwritten with the new v value)
            return r;
          };

          /**
           * Plugin: appendList (apl) v1.1
           * https://marketing.adobe.com/resources/help/en_US/sc/implement/appendList.html
           *
           * The apl (or appendList) plug-in lets you append a value to any delimited lists, with the option of a case-sensitive
           * or case-insensitive check to ensure that the value does not already exist in the list. The APL plug-in is referenced
           * by several standard plug-ins but can be used directly in a variety of situations.
           *
           * @param {string} list - source list, empty list is accepted
           * @param {string} appendValue - value to append
           * @param {string} delimiter - list delimiter
           * @param {number} [uniqueValueCheck=0] - 0 = no unique check, value is always appended
           *                                        1 = case-sensitive check, append if exact value isn't already in list
           *                                        2 = case-insensitive check, append if any case variation of value isn't already in list
           */
          s_wdpro.apl = function (list, appendValue, delimiter, uniqueValueCheck) {
            var s = this,
              found = false,
              i,
              n,
              a;
            if (!list) list = '';
            if (uniqueValueCheck) {
              a = s.split(list, delimiter);
              for (i = 0; i < a.length && !found; i++) {
                n = a[i];
                found = uniqueValueCheck == 1 ? n == appendValue : n.toLowerCase() == appendValue.toLowerCase();
              }
            }
            if (!found) list = list ? list + delimiter + appendValue : appendValue;
            return list;
          };

          /*
           * Utility Function: split v¯\_(ツ)_/¯
           */
          s_wdpro.split = function (str, delimiter) {
            return typeof str === 'string' ? str.split(delimiter) : [];
          };

          /*
           * Utility Function: join v¯\_(ツ)_/¯
           */
          s_wdpro.join = function join(v, p) {
            var f,
              b,
              d,
              w,
              x,
              l = v.length,
              str = '';
            if (p) {
              f = p.front || '';
              b = p.back || '';
              d = p.delim || '';
              w = p.wrap || '';
            }
            for (x = 0; x < l; x++) {
              str += typeof v[x] === 'object' ? join(v[x], p) : w + v[x] + w;
              if (x < l - 1) str += d;
            }
            return f + str + b;
          };
          (function (s) {
            /*
            * Cookie Combining Utility v.5 (modified by CA)
            */
            if (!s.__ccu) {
              s.__ccu = true;
              s.c_rr = s.c_r; // save reference to original cookie read
              s.c_rspers = c_rspers;
              s.c_r = s.cookieRead = s.Util.cookieRead = c_r; // reroute references to combined cookie read

              s.c_wr = s.c_w; // save reference to original cookie write
              s.c_w = s.cookieWrite = s.Util.cookieWrite = c_w; // reroute references to combined cookie write
            }
            function c_r(k) {
              var s = this,
                v = s.c_rr(k),
                c = s.c_rspers(),
                i,
                m,
                e;
              if (v) return v;
              k = s.escape ? s.escape(k) : encodeURIComponent(k);
              i = c.indexOf(' ' + k + '=');
              c = i < 0 ? s.c_rr('s_sess') : c;
              i = c.indexOf(' ' + k + '=');
              m = i < 0 ? i : c.indexOf('|', i);
              e = i < 0 ? i : c.indexOf(';', i);
              m = m > 0 ? m : e;
              v = i < 0 ? '' : s.unescape ? s.unescape(c.substring(i + 2 + k.length, m < 0 ? c.length : m)) : decodeURIComponent(c.substring(i + 2 + k.length, m < 0 ? c.length : m));
              return v;
            }
            function c_rspers() {
              var s = this,
                cv = s.c_rr('s_pers'),
                date = new Date().getTime(),
                expd = null,
                cvarr = [],
                vcv = '';
              if (!cv) return vcv;
              cvarr = cv.split(';');
              for (var i = 0, l = cvarr.length; i < l; i++) {
                expd = cvarr[i].match(/\|([0-9]+)$/);
                if (expd && parseInt(expd[1]) >= date) {
                  vcv += cvarr[i] + ';';
                }
              }
              return vcv;
            }
            function c_w(k, v, e) {
              var s = this,
                d = new Date(),
                ht = 0,
                pn = 's_pers',
                sn = 's_sess',
                pc = 0,
                sc = 0,
                pv,
                sv,
                i,
                t,
                f;
              d.setTime(d.getTime() - 60000);
              if (s.c_rr(k)) s.c_wr(k, '', d);
              k = s.escape ? s.escape(k) : encodeURIComponent(k);
              pv = s.c_rspers();
              i = pv.indexOf(' ' + k + '=');
              if (i > -1) {
                pv = pv.substring(0, i) + pv.substring(pv.indexOf(';', i) + 1);
                pc = 1;
              }
              sv = s.c_rr(sn);
              i = sv.indexOf(' ' + k + '=');
              if (i > -1) {
                sv = sv.substring(0, i) + sv.substring(sv.indexOf(';', i) + 1);
                sc = 1;
              }
              d = new Date();
              if (e) {
                if (e == 1) e = new Date(), f = e.getYear(), e.setYear(f + 5 + (f < 1900 ? 1900 : 0));
                if (e.getTime() > d.getTime()) {
                  pv += ' ' + k + '=' + (s.escape ? s.escape(v) : encodeURIComponent(v)) + '|' + e.getTime() + ';';
                  pc = 1;
                }
              } else {
                sv += ' ' + k + '=' + (s.escape ? s.escape(v) : encodeURIComponent(v)) + ';';
                sc = 1;
              }
              sv = sv.replace(/%00/g, '');
              pv = pv.replace(/%00/g, '');
              if (sc) s.c_wr(sn, sv, 0);
              if (pc) {
                t = pv;
                while (t && t.includes(';')) {
                  var t1 = parseInt(t.substring(t.indexOf('|') + 1, t.indexOf(';')));
                  t = t.substring(t.indexOf(';') + 1);
                  ht = ht < t1 ? t1 : ht;
                }
                d.setTime(ht);
                s.c_wr(pn, pv, d);
              }
              return v == s.c_r(s.unescape ? s.unescape(k) : decodeURIComponent(k));
            }

            /*
            * TNT Integration Plugin v2.1AM
            */
            s.trackTNT = function (v, p, b) {
              var n = 's_tnt',
                q = 's_tntref',
                r = '',
                pm = false;
              v = v || n;
              p = p || n;
              b = b || true;
              if (s.Util.getQueryParam(q) != '') {
                s.referrer = s.Util.getQueryParam(q);
              } else if (s.c_r(q) != '') {
                s.referrer = s.c_r(q);
                document.cookie = q + '=;path=/;expires=Thu, 01-Jan-1970 00:00:01 GMT;';
              } else if (document.cookie.includes(q) && s.c_r(q) == '' || location.search.includes(q + '=') && s.Util.getQueryParam(q) == '') {
                s.referrer = 'Typed/Bookmarked';
                document.cookie = q + '=;path=/;expires=Thu, 01-Jan-1970 00:00:01 GMT;';
              }
              if (s.Util.getQueryParam(p) != '') {
                pm = s.Util.getQueryParam(p);
              } else if (s.c_r(p)) {
                pm = s.c_r(p);
                document.cookie = p + '=;path=/;expires=Thu, 01-Jan-1970 00:00:01 GMT;';
              } else if (s.c_r(p) == '' && s.Util.getQueryParam(p) == '') {
                pm = '';
              }
              if (pm) r += pm + ',';
              if (window[v] != undefined) r += window[v];
              if (b) window[v] = '';
              return r;
            };
          })(s_wdpro);
          s_wdpro.allTrafficSources = function (a, b, c, d, e, f, g, h, i) {
            var s = this,
              A,
              B,
              C,
              D,
              E,
              F,
              G,
              H,
              I,
              J,
              K,
              L,
              M,
              N,
              O,
              P,
              Q,
              R,
              T,
              U,
              V,
              W,
              X,
              Y,
              Z,
              z,
              y,
              x,
              w,
              v,
              u;
            E = s.referrer || document.referrer;
            if (!E) {
              F = '1';
            }
            G = s.split(h, '>');
            A = G[0] || 'Paid Search';
            B = G[1] || 'Natural Search';
            C = G[2] || 'Paid Non-Search';
            D = G[3] || 'Referrers';
            I = E.includes('?') ? E.indexOf('?') : E.length;
            x = E.substring(0, I);
            w = s.split(s.linkInternalFilters, ',');
            P = w.length - 1;
            for (Q = 0; Q <= P; Q++) {
              if (w[Q]) {
                v = !x.includes(w[Q]) ? '' : E;
                if (v) u = v;
              }
            }
            if (!u && !F) {
              H = E.includes('://') ? E.indexOf('://') + 3 : 0;
              J = E.includes('/', H) ? E.indexOf('/', H) : I;
              K = E.substring(H, J);
              L = K;
              L = L.toLowerCase();
              M = D;
              N = '';
              N = c ? N + '>' + c : N;
              O = s.split(N, '>');
              P = O.length - 1;
              for (Q = 0; Q <= P; Q++) {
                R = O[Q];
                R = s.split(R, '|');
                T = K.indexOf(R[0]);
                if (T > -1) {
                  U = s.Util.getQueryParam(R[1], '', E);
                  if (U) {
                    V = U;
                    L = R[2] || L;
                  }
                }
              }
            }
            if (V) V = V.toLowerCase();
            W = s.Util.getQueryParam(a, f);
            if (W) {
              L = W;
              if (V) {
                M = A;
              } else {
                M = C;
              }
            }
            if (!W && V) {
              L = b + L;
              M = B;
            }
            if (L) {
              L = s.repl(L, 'www.', '');
            }
            if (d) {
              O = s.split(d, '>');
              P = O.length;
              for (Q = 0; Q <= P; Q++) {
                if (O[Q]) {
                  R = s.split(O[Q], '|');
                  T = s.Util.getQueryParam(R[1]);
                  if (T) M = R[0];
                }
              }
            }
            if (e) {
              O = s.split(e, '>');
              P = O.length;
              for (Q = 0; Q <= P; Q++) {
                if (O[Q]) {
                  R = s.split(O[Q], '|');
                  T = W.indexOf(R[1]);
                  if (T == 0) M = R[0];
                }
              }
            }
            X = M;
            Y = L;
            if (F == '1' && !W && g) {
              Z = s.split(g, '>');
              M = Z[0];
              X = Z[1];
              L = Z[2];
              Y = Z[3];
            }
            z = V + L + Y + M + X;
            y = i || 's_ats';
            z = i != '0' ? s.getValOnce(z, y, 0) : z;
            s.atsCampaign = z ? L : '';
            s.atsCampaignStack = z ? Y : '';
            s.atsKeywords = z ? V : '';
            s.atsChannel = z ? M : '';
            s.atsChannelStack = z ? X : '';
          };

          /* WARNING: Changing any of the below variables will cause drastic
          changes to how your visitor data is collected. Changes should only be
          made when instructed to do so by your account manager.*/
          s_wdpro.visitorNamespace = 'wdpro';
          if (!s_wdpro.trackingServer) {
            s_wdpro.trackingServer = 'w88.go.com';
          }
          if (!s_wdpro.trackingServerSecure) {
            s_wdpro.trackingServerSecure = 'sw88.go.com';
          }
          s_wdpro.dc = 112;

          /*********************
           * s_wdpro.trackVideo()
           *
           * @Author Donald Organ
           * @LastModified 08/08/12
           *
           * @Description - binds play, pause and ended events for a given video element to sitecatalysts tracking
           *      Note the following evens will be sent:
           *          assetStart=>event1
           *          assetComplete=>event11
           *          videoTime=>event43
           *       Note the following properties/eVars will be set:
           *          assetID=>prop3/eVar2
           *
           * @param {object} videoElement The Video DOM element
           * @param {DOM node} videoId The ID attribute assigned to the DOM element
           *
           * @example
              s_wdpro.trackVideo($('#video1').get(0), 'video1');
           *
           *
           **/
          s_wdpro.trackVideo = function (videoElement, videoId) {
            if (videoElement && videoId) {
              s_wdpro.Media.open('vid:' + videoId, videoElement.duration, 'vid:' + videoId);
              videoElement.addEventListener('play', function () {
                s_wdpro.Media.play('vid:' + videoId, videoElement.currentTime);
              });
              videoElement.addEventListener('pause', function () {
                s_wdpro.Media.stop('vid:' + videoId, videoElement.currentTime);
              });
              videoElement.addEventListener('ended', function () {
                s_wdpro.Media.stop('vid:' + videoId, videoElement.currentTime);
                s_wdpro.Media.close('vid:' + videoId);
              });
            }
          };
          s_wdpro.untrackVideo = function (videoId) {
            s_wdpro.Media.close('vid:' + videoId);
          };

          /****************************** MODULES *****************************/

          /*
          * Module: Media
          */
          s_wdpro.Media = new AppMeasurement_Module_Media(s_wdpro);
          s_wdpro.Media.autoTrack = true;
          s_wdpro.Media.trackVars = 'events,prop3,eVar2';
          s_wdpro.Media.trackEvents = 'event1,event11,event43,event97,event98,event99';
          s_wdpro.Media.completeCloseOffsetThreshold = 10;
          s_wdpro.Media.completeByCloseOffset = true;
          s_wdpro.Media.trackUsingContextData = true;
          s_wdpro.Media.trackMilestones = '25,50,75';
          s_wdpro.Media.contextDataMapping = {
            'a.media.name': 'prop3,eVar2',
            'a.media.timePlayed': 'event43',
            'a.media.view': 'event1',
            'a.media.complete': 'event11',
            'a.media.milestones': {
              '25': 'event97',
              '50': 'event98',
              '75': 'event99'
            }
          };

          // disable media autotracking when the page is unloading - https://jira.nge.wdig.com/browse/PRO-340003
          window.addEventListener('beforeunload', function () {
            s_wdpro.Media.autoTrack = false;
          });
          function AppMeasurement_Module_Media(q) {
            var b = this;
            b.s = q;
            q = window;
            q.s_c_in || (q.s_c_il = [], q.s_c_in = 0);
            b._il = q.s_c_il;
            b._in = q.s_c_in;
            b._il[b._in] = b;
            q.s_c_in++;
            b._c = 's_m';
            b.list = [];
            b.open = function (d, c, e, k) {
              var f = {},
                a = new Date(),
                l = '',
                g;
              c || (c = -1);
              if (d && e) {
                b.list || (b.list = {});
                b.list[d] && b.close(d);
                k && k.id && (l = k.id);
                if (l) for (g in b.list) !Object.prototype[g] && b.list[g] && b.list[g].R == l && b.close(b.list[g].name);
                f.name = d;
                f.length = c;
                f.offset = 0;
                f.e = 0;
                f.playerName = b.playerName ? b.playerName : e;
                f.R = l;
                f.C = 0;
                f.a = 0;
                f.timestamp = Math.floor(a.getTime() / 1E3);
                f.k = 0;
                f.u = f.timestamp;
                f.c = -1;
                f.n = '';
                f.g = -1;
                f.D = 0;
                f.I = {};
                f.G = 0;
                f.m = 0;
                f.f = '';
                f.B = 0;
                f.L = 0;
                f.A = 0;
                f.F = 0;
                f.l = !1;
                f.v = '';
                f.J = '';
                f.K = 0;
                f.r = !1;
                f.H = '';
                f.complete = 0;
                f.Q = 0;
                f.p = 0;
                f.q = 0;
                b.list[d] = f;
              }
            };
            b.openAd = function (d, c, e, k, f, a, l, g) {
              var h = {};
              b.open(d, c, e, g);
              if (h = b.list[d]) h.l = !0, h.v = k, h.J = f, h.K = a, h.H = l;
            };
            b.M = function (d) {
              var c = b.list[d];
              b.list[d] = 0;
              c && c.monitor && clearTimeout(c.monitor.interval);
            };
            b.close = function (d) {
              b.i(d, 0, -1);
            };
            b.play = function (d, c, e, k) {
              var f = b.i(d, 1, c, e, k);
              f && !f.monitor && (f.monitor = {}, f.monitor.update = function () {
                f.k == 1 && b.i(f.name, 3, -1);
                f.monitor.interval = setTimeout(f.monitor.update, 1E3);
              }, f.monitor.update());
            };
            b.click = function (d, c) {
              b.i(d, 7, c);
            };
            b.complete = function (d, c) {
              b.i(d, 5, c);
            };
            b.stop = function (d, c) {
              b.i(d, 2, c);
            };
            b.track = function (d) {
              b.i(d, 4, -1);
            };
            b.P = function (d, c) {
              var e = 'a.media.',
                k = d.linkTrackVars,
                f = d.linkTrackEvents,
                a = 'm_i',
                l,
                g = d.contextData,
                h;
              c.l && (e += 'ad.', c.v && (g['a.media.name'] = c.v, g[e + 'pod'] = c.J, g[e + 'podPosition'] = c.K), c.G || (g[e + 'CPM'] = c.H));
              c.r && (g[e + 'clicked'] = !0, c.r = !1);
              g['a.contentType'] = 'video' + (c.l ? 'Ad' : '');
              g['a.media.channel'] = b.channel;
              g[e + 'name'] = c.name;
              g[e + 'playerName'] = c.playerName;
              c.length > 0 && (g[e + 'length'] = c.length);
              g[e + 'timePlayed'] = Math.floor(c.a);
              Math.floor(c.a) > 0 && (g[e + 'timePlayed'] = Math.floor(c.a));
              c.G || (g[e + 'view'] = !0, a = 'm_s', b.Heartbeat && b.Heartbeat.enabled && (a = c.l ? b.__primetime ? 'mspa_s' : 'msa_s' : b.__primetime ? 'msp_s' : 'ms_s'), c.G = 1);
              c.f && (g[e + 'segmentNum'] = c.m, g[e + 'segment'] = c.f, c.B > 0 && (g[e + 'segmentLength'] = c.B), c.A && c.a > 0 && (g[e + 'segmentView'] = !0));
              !c.Q && c.complete && (g[e + 'complete'] = !0, c.S = 1);
              c.p > 0 && (g[e + 'milestone'] = c.p);
              c.q > 0 && (g[e + 'offsetMilestone'] = c.q);
              if (k) for (h in g) Object.prototype[h] || (k += ',contextData.' + h);
              l = g['a.contentType'];
              d.pe = a;
              d.pev3 = l;
              var q, s;
              if (b.contextDataMapping) for (h in d.events2 || (d.events2 = ''), k && (k += ',events'), b.contextDataMapping) if (!Object.prototype[h]) {
                a = h.length > e.length && h.substring(0, e.length) == e ? h.substring(e.length) : '';
                l = b.contextDataMapping[h];
                if (typeof l == 'string') for (q = l.split(','), s = 0; s < q.length; s++) l = q[s], h == 'a.contentType' ? (k && (k += ',' + l), d[l] = g[h]) : a == 'view' || a == 'segmentView' || a == 'clicked' || a == 'complete' || a == 'timePlayed' || a == 'CPM' ? (f && (f += ',' + l), a == 'timePlayed' || a == 'CPM' ? g[h] && (d.events2 += (d.events2 ? ',' : '') + l + '=' + g[h]) : g[h] && (d.events2 += (d.events2 ? ',' : '') + l)) : a == 'segment' && g[h + 'Num'] ? (k && (k += ',' + l), d[l] = g[h + 'Num'] + ':' + g[h]) : (k && (k += ',' + l), d[l] = g[h]);else if (a == 'milestones' || a == 'offsetMilestones') h = h.substring(0, h.length - 1), g[h] && b.contextDataMapping[h + 's'][g[h]] && (f && (f += ',' + b.contextDataMapping[h + 's'][g[h]]), d.events2 += (d.events2 ? ',' : '') + b.contextDataMapping[h + 's'][g[h]]);
                g[h] && (g[h] = 0);
                a == 'segment' && g[h + 'Num'] && (g[h + 'Num'] = 0);
              }
              d.linkTrackVars = k;
              d.linkTrackEvents = f;
            };
            b.i = function (d, c, e, k, f) {
              var a = {},
                l = new Date().getTime() / 1E3,
                g,
                h,
                q = b.trackVars,
                s = b.trackEvents,
                t = b.trackSeconds,
                u = b.trackMilestones,
                v = b.trackOffsetMilestones,
                w = b.segmentByMilestones,
                x = b.segmentByOffsetMilestones,
                p,
                n,
                r = 1,
                m = {},
                y;
              b.channel || (b.channel = b.s.w.location.hostname);
              if (a = d && b.list && b.list[d] ? b.list[d] : 0) if (a.l && (t = b.adTrackSeconds, u = b.adTrackMilestones, v = b.adTrackOffsetMilestones, w = b.adSegmentByMilestones, x = b.adSegmentByOffsetMilestones), e < 0 && (e = a.k == 1 && a.u > 0 ? l - a.u + a.c : a.c), a.length > 0 && (e = e < a.length ? e : a.length), e < 0 && (e = 0), a.offset = e, a.length > 0 && (a.e = a.offset / a.length * 100, a.e = a.e > 100 ? 100 : a.e), a.c < 0 && (a.c = e), y = a.D, m.name = d, m.ad = a.l, m.length = a.length, m.openTime = new Date(), m.openTime.setTime(1E3 * a.timestamp), m.offset = a.offset, m.percent = a.e, m.playerName = a.playerName, m.mediaEvent = a.g < 0 ? 'OPEN' : c == 1 ? 'PLAY' : c == 2 ? 'STOP' : c == 3 ? 'MONITOR' : c == 4 ? 'TRACK' : c == 5 ? 'COMPLETE' : c == 7 ? 'CLICK' : 'CLOSE', c > 2 || c != a.k && (c != 2 || a.k == 1)) {
                f || (k = a.m, f = a.f);
                if (c) {
                  c == 1 && (a.c = e);
                  if ((c <= 3 || c >= 5) && a.g >= 0 && (r = !1, q = s = 'None', a.g != e)) {
                    h = a.g;
                    h > e && (h = a.c, h > e && (h = e));
                    p = u ? u.split(',') : 0;
                    if (a.length > 0 && p && e >= h) for (n = 0; n < p.length; n++) (g = p[n] ? parseFloat('' + p[n]) : 0) && h / a.length * 100 < g && a.e >= g && (r = !0, n = p.length, m.mediaEvent = 'MILESTONE', a.p = m.milestone = g);
                    if ((p = v ? v.split(',') : 0) && e >= h) for (n = 0; n < p.length; n++) (g = p[n] ? parseFloat('' + p[n]) : 0) && h < g && e >= g && (r = !0, n = p.length, m.mediaEvent = 'OFFSET_MILESTONE', a.q = m.offsetMilestone = g);
                  }
                  if (a.L || !f) {
                    if (w && u && a.length > 0) {
                      if (p = u.split(',')) for (p.push('100'), n = h = 0; n < p.length; n++) if (g = p[n] ? parseFloat('' + p[n]) : 0) a.e < g && (k = n + 1, f = 'M:' + h + '-' + g, n = p.length), h = g;
                    } else if (x && v && (p = v.split(','))) for (p.push('' + (a.length > 0 ? a.length : 'E')), n = h = 0; n < p.length; n++) if ((g = p[n] ? parseFloat('' + p[n]) : 0) || p[n] == 'E') {
                      if (e < g || p[n] == 'E') k = n + 1, f = 'O:' + h + '-' + g, n = p.length;
                      h = g;
                    }
                    f && (a.L = !0);
                  }
                  (f || a.f) && f != a.f && (a.F = !0, a.f || (a.m = k, a.f = f), a.g >= 0 && (r = !0));
                  (c >= 2 || a.e >= 100) && a.c < e && (a.C += e - a.c, a.a += e - a.c);
                  if (c <= 2 || c == 3 && !a.k) a.n += (c == 1 || c == 3 ? 'S' : 'E') + Math.floor(e), a.k = c == 3 ? 1 : c;
                  !r && a.g >= 0 && c <= 3 && (t = t ? t : 0) && a.a >= t && (r = !0, m.mediaEvent = 'SECONDS');
                  a.u = l;
                  a.c = e;
                }
                if (!c || c <= 3 && a.e >= 100) a.k != 2 && (a.n += 'E' + Math.floor(e)), c = 0, q = s = 'None', m.mediaEvent = 'CLOSE';
                c == 7 && (r = m.clicked = a.r = !0);
                if (c == 5 || b.completeByCloseOffset && (!c || a.e >= 100) && a.length > 0 && e >= a.length - b.completeCloseOffsetThreshold) r = m.complete = a.complete = !0;
                l = m.mediaEvent;
                l == 'MILESTONE' ? l += '_' + m.milestone : l == 'OFFSET_MILESTONE' && (l += '_' + m.offsetMilestone);
                a.I[l] ? m.eventFirstTime = !1 : (m.eventFirstTime = !0, a.I[l] = 1);
                m.event = m.mediaEvent;
                m.timePlayed = a.C;
                m.segmentNum = a.m;
                m.segment = a.f;
                m.segmentLength = a.B;
                b.monitor && c != 4 && b.monitor(b.s, m);
                b.Heartbeat && b.Heartbeat.enabled && a.g >= 0 && (r = !1);
                c == 0 && b.M(d);
                r && a.D == y && (d = {
                  contextData: {}
                }, d.linkTrackVars = q, d.linkTrackEvents = s, d.linkTrackVars || (d.linkTrackVars = ''), d.linkTrackEvents || (d.linkTrackEvents = ''), b.P(d, a), d.linkTrackVars || (d['!linkTrackVars'] = 1), d.linkTrackEvents || (d['!linkTrackEvents'] = 1), b.s.track(d), a.F ? (a.m = k, a.f = f, a.A = !0, a.F = !1) : a.a > 0 && (a.A = !1), a.n = '', a.p = a.q = 0, a.a -= Math.floor(a.a), a.g = e, a.D++);
              }
              return a;
            };
            b.O = function (d, c, e, k, f) {
              var a = 0;
              if (d && (!b.autoTrackMediaLengthRequired || c && c > 0)) {
                if (b.list && b.list[d]) a = 1;else if (e == 1 || e == 3) b.open(d, c, 'HTML5 Video', f), a = 1;
                a && b.i(d, e, k, -1, 0);
              }
            };
            b.attach = function (d) {
              var c, e, k;
              d && d.tagName && d.tagName.toUpperCase() == 'VIDEO' && (b.o || (b.o = function (c, a, d) {
                var e, h;
                b.autoTrack && (e = c.currentSrc, (h = c.duration) || (h = -1), d < 0 && (d = c.currentTime), b.O(e, h, a, d, c));
              }), c = function () {
                b.o(d, 1, -1);
              }, e = function () {
                b.o(d, 1, -1);
              }, b.j(d, 'play', c), b.j(d, 'pause', e), b.j(d, 'seeking', e), b.j(d, 'seeked', c), b.j(d, 'ended', function () {
                b.o(d, 0, -1);
              }), b.j(d, 'timeupdate', c), k = function () {
                d.paused || d.ended || d.seeking || b.o(d, 3, -1);
                setTimeout(k, 1E3);
              }, k());
            };
            b.j = function (b, c, e) {
              b.attachEvent ? b.attachEvent('on' + c, e) : b.addEventListener && b.addEventListener(c, e, !1);
            };
            if (b.completeByCloseOffset == undefined) b.completeByCloseOffset = 1;
            if (b.completeCloseOffsetThreshold == undefined) b.completeCloseOffsetThreshold = 1;
            b.Heartbeat = {};
            b.N = function () {
              var d, c;
              if (b.autoTrack && (d = b.s.d.querySelectorAll('video:not(.no-media-autotrack)'))) for (c = 0; c < d.length; c++) b.attach(d[c]);
            };
            b.j(q, 'load', b.N);
          }

          /*
           ============== DO NOT ALTER ANYTHING BELOW THIS LINE ! ===============
           AppMeasurement for JavaScript version: 2.25.0
           Implementation guide: https://adobe.ly/40OOIRT
          */
          function AppMeasurement(r) {
            var a = this;
            a.version = "2.25.0";
            var h = window;
            h.s_c_in || (h.s_c_il = [], h.s_c_in = 0);
            a._il = h.s_c_il;
            a._in = h.s_c_in;
            a._il[a._in] = a;
            h.s_c_in++;
            a._c = "s_c";
            var q = h.AppMeasurement.uc;
            q || (q = null);
            var p = h,
              m,
              s;
            try {
              for (m = p.parent, s = p.location; m && m.location && s && "" + m.location !== "" + s && p.location && "" + m.location !== "" + p.location && m.location.host === s.host;) p = m, m = p.parent;
            } catch (u) {}
            a.log = function (a) {
              try {
                console.log(a);
              } catch (c) {}
            };
            a.Ya = function (a) {
              return "" + parseInt(a) == "" + a;
            };
            a.replace = function (a, c, d) {
              return !a || 0 > a.indexOf(c) ? a : a.split(c).join(d);
            };
            a.escape = function (b) {
              var c, d;
              if (!b) return b;
              b = encodeURIComponent(b);
              for (c = 0; 7 > c; c++) d = "+~!*()'".substring(c, c + 1), 0 <= b.indexOf(d) && (b = a.replace(b, d, "%" + d.charCodeAt(0).toString(16).toUpperCase()));
              return b;
            };
            a.unescape = function (b) {
              if (!b) return b;
              b = 0 <= b.indexOf("+") ? a.replace(b, "+", " ") : b;
              try {
                return decodeURIComponent(b);
              } catch (c) {}
              return unescape(b);
            };
            a.ac = function () {
              var b = h.location.hostname,
                c = a.fpCookieDomainPeriods,
                d;
              c || (c = a.cookieDomainPeriods);
              if (b && !a.Ra && !/^[0-9.]+$/.test(b) && (c = c ? parseInt(c) : 2, c = 2 < c ? c : 2, d = b.lastIndexOf("."), 0 <= d)) {
                for (; 0 <= d && 1 < c;) d = b.lastIndexOf(".", d - 1), c--;
                a.Ra = 0 < d ? b.substring(d) : b;
              }
              return a.Ra;
            };
            a.c_r = a.cookieRead = function (b) {
              b = a.escape(b);
              var c = " " + a.d.cookie,
                d = c.indexOf(" " + b + "="),
                f = 0 > d ? d : c.indexOf(";", d);
              b = 0 > d ? "" : a.unescape(c.substring(d + 2 + b.length, 0 > f ? c.length : f));
              return "[[B]]" != b ? b : "";
            };
            a.c_w = a.cookieWrite = function (b, c, d) {
              var f = a.ac(),
                e = a.cookieLifetime,
                g;
              c = "" + c;
              e = e ? ("" + e).toUpperCase() : "";
              d && "SESSION" != e && "NONE" != e && ((g = "" != c ? parseInt(e ? e : 0) : -60) ? (d = new Date(), d.setTime(d.getTime() + 1E3 * g)) : 1 === d && (d = new Date(), g = d.getYear(), d.setYear(g + 2 + (1900 > g ? 1900 : 0))));
              return b && "NONE" != e ? (a.d.cookie = a.escape(b) + "=" + a.escape("" != c ? c : "[[B]]") + "; path=/;" + (d && "SESSION" != e ? " expires=" + d.toUTCString() + ";" : "") + (f ? " domain=" + f + ";" : "") + (a.writeSecureCookies ? " secure;" : ""), a.cookieRead(b) == c) : 0;
            };
            a.Yb = function () {
              var b = a.Util.getIeVersion();
              "number" === typeof b && 10 > b && (a.unsupportedBrowser = !0, a.Jb(a, function () {}));
            };
            a.Ea = function () {
              var a = navigator.userAgent;
              return "Microsoft Internet Explorer" === navigator.appName || 0 <= a.indexOf("MSIE ") || 0 <= a.indexOf("Trident/") && 0 <= a.indexOf("Windows NT 6") ? !0 : !1;
            };
            a.Jb = function (a, c) {
              for (var d in a) Object.prototype.hasOwnProperty.call(a, d) && "function" === typeof a[d] && (a[d] = c);
            };
            a.M = [];
            a.ja = function (b, c, d) {
              if (a.Sa) return 0;
              a.maxDelay || (a.maxDelay = 250);
              var f = 0,
                e = new Date().getTime() + a.maxDelay,
                g = a.d.visibilityState,
                k = ["webkitvisibilitychange", "visibilitychange"];
              g || (g = a.d.webkitVisibilityState);
              if (g && "prerender" == g) {
                if (!a.ka) for (a.ka = 1, d = 0; d < k.length; d++) a.d.addEventListener(k[d], function () {
                  var b = a.d.visibilityState;
                  b || (b = a.d.webkitVisibilityState);
                  "visible" == b && (a.ka = 0, a.delayReady());
                });
                f = 1;
                e = 0;
              } else d || a.v("_d") && (f = 1);
              f && (a.M.push({
                m: b,
                a: c,
                t: e
              }), a.ka || setTimeout(a.delayReady, a.maxDelay));
              return f;
            };
            a.delayReady = function () {
              var b = new Date().getTime(),
                c = 0,
                d;
              for (a.v("_d") ? c = 1 : a.Ga(); 0 < a.M.length;) {
                d = a.M.shift();
                if (c && !d.t && d.t > b) {
                  a.M.unshift(d);
                  setTimeout(a.delayReady, parseInt(a.maxDelay / 2));
                  break;
                }
                a.Sa = 1;
                a[d.m].apply(a, d.a);
                a.Sa = 0;
              }
            };
            a.setAccount = a.sa = function (b) {
              var c, d;
              if (!a.ja("setAccount", arguments)) if (a.account = b, a.allAccounts) for (c = a.allAccounts.concat(b.split(",")), a.allAccounts = [], c.sort(), d = 0; d < c.length; d++) 0 != d && c[d - 1] == c[d] || a.allAccounts.push(c[d]);else a.allAccounts = b.split(",");
            };
            a.foreachVar = function (b, c) {
              var d,
                f,
                e,
                g,
                k = "";
              e = f = "";
              if (a.lightProfileID) d = a.Q, (k = a.lightTrackVars) && (k = "," + k + "," + a.pa.join(",") + ",");else {
                d = a.i;
                if (a.pe || a.linkType) k = a.linkTrackVars, f = a.linkTrackEvents, a.pe && (e = a.pe.substring(0, 1).toUpperCase() + a.pe.substring(1), a[e] && (k = a[e].qc, f = a[e].pc));
                k && (k = "," + k + "," + a.F.join(",") + ",");
                f && k && (k += ",events,");
              }
              c && (c = "," + c + ",");
              for (f = 0; f < d.length; f++) e = d[f], (g = a[e]) && (!k || 0 <= k.indexOf("," + e + ",")) && (!c || 0 <= c.indexOf("," + e + ",")) && b(e, g);
            };
            a.l = function (b, c, d, f, e) {
              var g = "",
                k,
                l,
                h,
                n,
                m = 0;
              "contextData" == b && (b = "c");
              "clientHints" == b && (b = "h");
              if (c) {
                for (k in c) if (!(Object.prototype[k] || e && k.substring(0, e.length) != e) && c[k] && (!d || 0 <= d.indexOf("," + (f ? f + "." : "") + k + ","))) {
                  h = !1;
                  if (m) for (l = 0; l < m.length; l++) if (k.substring(0, m[l].length) == m[l]) {
                    h = !0;
                    break;
                  }
                  if (!h && ("" == g && (g += "&" + b + "."), l = c[k], e && (k = k.substring(e.length)), 0 < k.length)) if (h = k.indexOf("."), 0 < h) l = k.substring(0, h), h = (e ? e : "") + l + ".", m || (m = []), m.push(h), g += a.l(l, c, d, f, h);else if ("boolean" == typeof l && (l = l ? "true" : "false"), l) {
                    if ("retrieveLightData" == f && 0 > e.indexOf(".contextData.")) switch (h = k.substring(0, 4), n = k.substring(4), k) {
                      case "transactionID":
                        k = "xact";
                        break;
                      case "channel":
                        k = "ch";
                        break;
                      case "campaign":
                        k = "v0";
                        break;
                      default:
                        a.Ya(n) && ("prop" == h ? k = "c" + n : "eVar" == h ? k = "v" + n : "list" == h ? k = "l" + n : "hier" == h && (k = "h" + n, l = l.substring(0, 255)));
                    }
                    g += "&" + a.escape(k) + "=" + a.escape(l);
                  }
                }
                "" != g && (g += "&." + b);
              }
              return g;
            };
            a.usePostbacks = 0;
            a.ec = function () {
              var b = "",
                c,
                d,
                f,
                e,
                g,
                k,
                l,
                h,
                n = "",
                m = "",
                p = e = "",
                r = a.W();
              if (a.lightProfileID) c = a.Q, (n = a.lightTrackVars) && (n = "," + n + "," + a.pa.join(",") + ",");else {
                c = a.i;
                if (a.pe || a.linkType) n = a.linkTrackVars, m = a.linkTrackEvents, a.pe && (e = a.pe.substring(0, 1).toUpperCase() + a.pe.substring(1), a[e] && (n = a[e].qc, m = a[e].pc));
                n && (n = "," + n + "," + a.F.join(",") + ",");
                m && (m = "," + m + ",", n && (n += ",events,"));
                a.events2 && (p += ("" != p ? "," : "") + a.events2);
              }
              if (r && r.getCustomerIDs) {
                e = q;
                if (g = r.getCustomerIDs()) for (d in g) Object.prototype[d] || (f = g[d], "object" == typeof f && (e || (e = {}), f.id && (e[d + ".id"] = f.id), f.authState && (e[d + ".as"] = f.authState)));
                e && (b += a.l("cid", e));
              }
              a.AudienceManagement && a.AudienceManagement.isReady() && (b += a.l("d", a.AudienceManagement.getEventCallConfigParams()));
              for (d = 0; d < c.length; d++) {
                e = c[d];
                g = a[e];
                f = e.substring(0, 4);
                k = e.substring(4);
                g || ("events" == e && p ? (g = p, p = "") : "marketingCloudOrgID" == e && r && a.X("ECID") && (g = r.marketingCloudOrgID));
                if (g && (!n || 0 <= n.indexOf("," + e + ","))) {
                  switch (e) {
                    case "customerPerspective":
                      e = "cp";
                      break;
                    case "marketingCloudOrgID":
                      e = "mcorgid";
                      break;
                    case "supplementalDataID":
                      e = "sdid";
                      break;
                    case "timestamp":
                      e = "ts";
                      break;
                    case "dynamicVariablePrefix":
                      e = "D";
                      break;
                    case "visitorID":
                      e = "vid";
                      break;
                    case "marketingCloudVisitorID":
                      e = "mid";
                      break;
                    case "analyticsVisitorID":
                      e = "aid";
                      break;
                    case "audienceManagerLocationHint":
                      e = "aamlh";
                      break;
                    case "audienceManagerBlob":
                      e = "aamb";
                      break;
                    case "authState":
                      e = "as";
                      break;
                    case "pageURL":
                      e = "g";
                      255 < g.length && (a.pageURLRest = g.substring(255), g = g.substring(0, 255));
                      break;
                    case "pageURLRest":
                      e = "-g";
                      break;
                    case "referrer":
                      e = "r";
                      break;
                    case "vmk":
                    case "visitorMigrationKey":
                      e = "vmt";
                      break;
                    case "visitorMigrationServer":
                      e = "vmf";
                      a.ssl && a.visitorMigrationServerSecure && (g = "");
                      break;
                    case "visitorMigrationServerSecure":
                      e = "vmf";
                      !a.ssl && a.visitorMigrationServer && (g = "");
                      break;
                    case "charSet":
                      e = "ce";
                      break;
                    case "visitorNamespace":
                      e = "ns";
                      break;
                    case "cookieDomainPeriods":
                      e = "cdp";
                      break;
                    case "cookieLifetime":
                      e = "cl";
                      break;
                    case "variableProvider":
                      e = "vvp";
                      break;
                    case "currencyCode":
                      e = "cc";
                      break;
                    case "channel":
                      e = "ch";
                      break;
                    case "transactionID":
                      e = "xact";
                      break;
                    case "campaign":
                      e = "v0";
                      break;
                    case "latitude":
                      e = "lat";
                      break;
                    case "longitude":
                      e = "lon";
                      break;
                    case "resolution":
                      e = "s";
                      break;
                    case "colorDepth":
                      e = "c";
                      break;
                    case "javascriptVersion":
                      e = "j";
                      break;
                    case "javaEnabled":
                      e = "v";
                      break;
                    case "cookiesEnabled":
                      e = "k";
                      break;
                    case "browserWidth":
                      e = "bw";
                      break;
                    case "browserHeight":
                      e = "bh";
                      break;
                    case "connectionType":
                      e = "ct";
                      break;
                    case "homepage":
                      e = "hp";
                      break;
                    case "events":
                      p && (g += ("" != g ? "," : "") + p);
                      if (m) for (k = g.split(","), g = "", f = 0; f < k.length; f++) l = k[f], h = l.indexOf("="), 0 <= h && (l = l.substring(0, h)), h = l.indexOf(":"), 0 <= h && (l = l.substring(0, h)), 0 <= m.indexOf("," + l + ",") && (g += (g ? "," : "") + k[f]);
                      break;
                    case "events2":
                      g = "";
                      break;
                    case "contextData":
                      b += a.l("c", a[e], n, e);
                      g = "";
                      break;
                    case "clientHints":
                      b += a.l("h", a[e], n, e);
                      g = "";
                      break;
                    case "lightProfileID":
                      e = "mtp";
                      break;
                    case "lightStoreForSeconds":
                      e = "mtss";
                      a.lightProfileID || (g = "");
                      break;
                    case "lightIncrementBy":
                      e = "mti";
                      a.lightProfileID || (g = "");
                      break;
                    case "retrieveLightProfiles":
                      e = "mtsr";
                      break;
                    case "deleteLightProfiles":
                      e = "mtsd";
                      break;
                    case "retrieveLightData":
                      a.retrieveLightProfiles && (b += a.l("mts", a[e], n, e));
                      g = "";
                      break;
                    default:
                      a.Ya(k) && ("prop" == f ? e = "c" + k : "eVar" == f ? e = "v" + k : "list" == f ? e = "l" + k : "hier" == f && (e = "h" + k, g = g.substring(0, 255)));
                  }
                  g && (b += "&" + e + "=" + ("pev" != e.substring(0, 3) ? a.escape(g) : g));
                }
                "pev3" == e && a.e && (b += a.e);
              }
              a.oa && (b += "&lrt=" + a.oa, a.oa = null);
              return b;
            };
            a.C = function (a) {
              var c = a.tagName;
              if ("undefined" != "" + a.xc || "undefined" != "" + a.lc && "HTML" != ("" + a.lc).toUpperCase()) return "";
              c = c && c.toUpperCase ? c.toUpperCase() : "";
              "SHAPE" == c && (c = "");
              c && (("INPUT" == c || "BUTTON" == c) && a.type && a.type.toUpperCase ? c = a.type.toUpperCase() : !c && a.href && (c = "A"));
              return c;
            };
            a.Ua = function (a) {
              var c = h.location,
                d = a.href ? a.href : "",
                f,
                e,
                g;
              "string" !== typeof d && (d = "");
              f = d.indexOf(":");
              e = d.indexOf("?");
              g = d.indexOf("/");
              d && (0 > f || 0 <= e && f > e || 0 <= g && f > g) && (e = a.protocol && 1 < a.protocol.length ? a.protocol : c.protocol ? c.protocol : "", f = c.pathname.lastIndexOf("/"), d = (e ? e + "//" : "") + (a.host ? a.host : c.host ? c.host : "") + ("/" != d.substring(0, 1) ? c.pathname.substring(0, 0 > f ? 0 : f) + "/" : "") + d);
              return d;
            };
            a.N = function (b) {
              var c = a.C(b),
                d,
                f,
                e = "",
                g = 0;
              return c && (d = b.protocol, f = b.onclick, !b.href || "A" != c && "AREA" != c || f && d && !(0 > d.toLowerCase().indexOf("javascript")) ? f ? (e = a.replace(a.replace(a.replace(a.replace("" + f, "\r", ""), "\n", ""), "\t", ""), " ", ""), g = 2) : "INPUT" == c || "SUBMIT" == c ? (b.value ? e = b.value : b.innerText ? e = b.innerText : b.textContent && (e = b.textContent), g = 3) : "IMAGE" == c && b.src && (e = b.src) : e = a.Ua(b), e) ? {
                id: e.substring(0, 100),
                type: g
              } : 0;
            };
            a.vc = function (b) {
              for (var c = a.C(b), d = a.N(b); b && !d && "BODY" != c;) if (b = b.parentElement ? b.parentElement : b.parentNode) c = a.C(b), d = a.N(b);
              d && "BODY" != c || (b = 0);
              b && (c = b.onclick ? "" + b.onclick : "", 0 <= c.indexOf(".tl(") || 0 <= c.indexOf(".trackLink(")) && (b = 0);
              return b;
            };
            a.kc = function () {
              var b,
                c,
                d = a.linkObject,
                f = a.linkType,
                e = a.linkURL,
                g,
                k;
              a.qa = 1;
              d || (a.qa = 0, d = a.clickObject);
              if (d) {
                b = a.C(d);
                for (c = a.N(d); d && !c && "BODY" != b;) if (d = d.parentElement ? d.parentElement : d.parentNode) b = a.C(d), c = a.N(d);
                c && "BODY" != b || (d = 0);
                if (d && !a.linkObject) {
                  var l = d.onclick ? "" + d.onclick : "";
                  if (0 <= l.indexOf(".tl(") || 0 <= l.indexOf(".trackLink(")) d = 0;
                }
              } else a.qa = 1;
              !e && d && (e = a.Ua(d));
              e && !a.linkLeaveQueryString && (g = e.indexOf("?"), 0 <= g && (e = e.substring(0, g)));
              if (!f && e) {
                var m = 0,
                  n = 0,
                  p;
                if (a.trackDownloadLinks && a.linkDownloadFileTypes) for (l = e.toLowerCase(), g = l.indexOf("?"), k = l.indexOf("#"), 0 <= g ? 0 <= k && k < g && (g = k) : g = k, 0 <= g && (l = l.substring(0, g)), g = a.linkDownloadFileTypes.toLowerCase().split(","), k = 0; k < g.length; k++) (p = g[k]) && l.substring(l.length - (p.length + 1)) == "." + p && (f = "d");
                if (a.trackExternalLinks && !f && (l = e.toLowerCase(), a.Xa(l) && (a.linkInternalFilters || (a.linkInternalFilters = h.location.hostname), g = 0, a.linkExternalFilters ? (g = a.linkExternalFilters.toLowerCase().split(","), m = 1) : a.linkInternalFilters && (g = a.linkInternalFilters.toLowerCase().split(",")), g))) {
                  for (k = 0; k < g.length; k++) p = g[k], 0 <= l.indexOf(p) && (n = 1);
                  n ? m && (f = "e") : m || (f = "e");
                }
              }
              a.linkObject = d;
              a.linkURL = e;
              a.linkType = f;
              if (a.trackClickMap || a.trackInlineStats) a.e = "", d && (f = a.pageName, e = 1, d = d.sourceIndex, f || (f = a.pageURL, e = 0), h.s_objectID && (c.id = h.s_objectID, d = c.type = 1), f && c && c.id && b && (a.e = "&pid=" + a.escape(f.substring(0, 255)) + (e ? "&pidt=" + e : "") + "&oid=" + a.escape(c.id.substring(0, 100)) + (c.type ? "&oidt=" + c.type : "") + "&ot=" + b + (d ? "&oi=" + d : "")));
            };
            a.fc = function () {
              var b = a.qa,
                c = a.linkType,
                d = a.linkURL,
                f = a.linkName;
              c && (d || f) && (c = c.toLowerCase(), "d" != c && "e" != c && (c = "o"), a.pe = "lnk_" + c, a.decodeLinkParameters ? (a.pev1 = d ? a.unescape(d) : "", a.pev2 = f ? a.unescape(f) : "", a.pev1 = a.escape(a.pev1), a.pev2 = a.escape(a.pev2)) : (a.pev1 = d ? a.escape(d) : "", a.pev2 = f ? a.escape(f) : ""), b = 1);
              a.abort && (b = 0);
              if (a.trackClickMap || a.trackInlineStats || a.hc()) {
                var c = {},
                  d = 0,
                  e = a.Db(),
                  g = e ? e.split("&") : 0,
                  k,
                  l,
                  h,
                  e = 0;
                if (g) for (k = 0; k < g.length; k++) l = g[k].split("="), f = a.unescape(l[0]).split(","), l = a.unescape(l[1]), c[l] = f;
                f = a.account.split(",");
                k = {};
                for (h in a.contextData) h && !Object.prototype[h] && "a.activitymap." == h.substring(0, 14) && (k[h] = a.contextData[h], a.contextData[h] = "");
                a.e = a.l("c", k) + (a.e ? a.e : "");
                if (b || a.e) {
                  b && !a.e && (e = 1);
                  for (l in c) if (!Object.prototype[l]) for (h = 0; h < f.length; h++) for (e && (g = c[l].join(","), g == a.account && (a.e += ("&" != l.charAt(0) ? "&" : "") + l, c[l] = [], d = 1)), k = 0; k < c[l].length; k++) g = c[l][k], g == f[h] && (e && (a.e += "&u=" + a.escape(g) + ("&" != l.charAt(0) ? "&" : "") + l + "&u=0"), c[l].splice(k, 1), d = 1);
                  b || (d = 1);
                  if (d) {
                    e = "";
                    k = 2;
                    !b && a.e && (e = a.escape(f.join(",")) + "=" + a.escape(a.e), k = 1);
                    for (l in c) !Object.prototype[l] && 0 < k && 0 < c[l].length && (e += (e ? "&" : "") + a.escape(c[l].join(",")) + "=" + a.escape(l), k--);
                    a.Lb(e);
                  }
                }
              }
              return b;
            };
            a.Db = function () {
              if (a.useLinkTrackSessionStorage) {
                if (a.o(h.sessionStorage)) try {
                  return h.sessionStorage.getItem(a.R);
                } catch (b) {}
              } else return a.cookieRead(a.R);
            };
            a.Lb = function (b) {
              if (a.useLinkTrackSessionStorage) {
                if (a.o(h.sessionStorage)) try {
                  h.sessionStorage.setItem(a.R, b);
                } catch (c) {}
              } else a.cookieWrite(a.R, b);
            };
            a.gc = function () {
              if (!a.oc) {
                var b = new Date(),
                  c = p.location,
                  d,
                  f,
                  e = f = d = "",
                  g = "",
                  k = "",
                  h = "1.2",
                  m = a.cookieWrite("s_cc", "true", 0) ? "Y" : "N",
                  n = "",
                  q = "";
                if (b.setUTCDate && (h = "1.3", 0 .toPrecision && (h = "1.5", b = [], b.forEach))) {
                  h = "1.6";
                  f = 0;
                  d = {};
                  try {
                    f = new Iterator(d), f.next && (h = "1.7", b.reduce && (h = "1.8", h.trim && (h = "1.8.1", Date.parse && (h = "1.8.2", Object.create && (h = "1.8.5")))));
                  } catch (r) {}
                }
                d = screen.width + "x" + screen.height;
                e = navigator.javaEnabled() ? "Y" : "N";
                f = screen.pixelDepth ? screen.pixelDepth : screen.colorDepth;
                g = a.w.innerWidth ? a.w.innerWidth : a.d.documentElement.offsetWidth;
                k = a.w.innerHeight ? a.w.innerHeight : a.d.documentElement.offsetHeight;
                try {
                  a.b.addBehavior("#default#homePage"), n = a.b.wc(c) ? "Y" : "N";
                } catch (s) {}
                try {
                  a.b.addBehavior("#default#clientCaps"), q = a.b.connectionType;
                } catch (t) {}
                a.resolution = d;
                a.colorDepth = f;
                a.javascriptVersion = h;
                a.javaEnabled = e;
                a.cookiesEnabled = m;
                a.browserWidth = g;
                a.browserHeight = k;
                a.connectionType = q;
                a.homepage = n;
                a.oc = 1;
              }
            };
            a.ob = function () {
              if (a.collectHighEntropyUserAgentHints && !a.J && a.jb()) {
                a.J = !0;
                try {
                  navigator.userAgentData.getHighEntropyValues(a.wa).then(function (b) {
                    a.clientHints = {};
                    a.wa.forEach(function (d) {
                      Object.prototype.hasOwnProperty.call(b, d) && (a.clientHints[d] = b[d]);
                    });
                  })["catch"](function (b) {
                    a.J = !1;
                    a.clientHints = {};
                    a.debugTracking && a.log(b.message);
                  });
                } catch (b) {
                  a.J = !1, a.clientHints = {}, a.debugTracking && a.log(b.message);
                }
              } else a.clientHints = {};
            };
            a.jb = function () {
              return "undefined" !== typeof navigator.userAgentData;
            };
            a.S = {};
            a.loadModule = function (b, c) {
              var d = a.S[b];
              if (!d) {
                d = h["AppMeasurement_Module_" + b] ? new h["AppMeasurement_Module_" + b](a) : {};
                a.S[b] = a[b] = d;
                d.vb = function () {
                  return d.Gb;
                };
                d.Mb = function (c) {
                  if (d.Gb = c) a[b + "_onLoad"] = c, a.ja(b + "_onLoad", [a, d], 1) || c(a, d);
                };
                try {
                  Object.defineProperty ? Object.defineProperty(d, "onLoad", {
                    get: d.vb,
                    set: d.Mb
                  }) : d._olc = 1;
                } catch (f) {
                  d._olc = 1;
                }
              }
              c && (a[b + "_onLoad"] = c, a.ja(b + "_onLoad", [a, d], 1) || c(a, d));
            };
            a.v = function (b) {
              var c, d;
              for (c in a.S) if (!Object.prototype[c] && (d = a.S[c]) && (d._olc && d.onLoad && (d._olc = 0, d.onLoad(a, d)), d[b] && d[b]())) return 1;
              return 0;
            };
            a.hc = function () {
              return a.ActivityMap && a.ActivityMap._c ? !0 : !1;
            };
            a.ic = function () {
              var b = Math.floor(1E13 * Math.random()),
                c = a.visitorSampling,
                d = a.visitorSamplingGroup,
                d = "s_vsn_" + (a.visitorNamespace ? a.visitorNamespace : a.account) + (d ? "_" + d : ""),
                f = a.cookieRead(d);
              if (c) {
                c *= 100;
                f && (f = parseInt(f));
                if (!f) {
                  if (!a.cookieWrite(d, b)) return 0;
                  f = b;
                }
                if (f % 1E4 > c) return 0;
              }
              return 1;
            };
            a.U = function (b, c) {
              var d, f, e, g, k, h, m;
              m = {};
              for (d = 0; 2 > d; d++) for (f = 0 < d ? a.Na : a.i, e = 0; e < f.length; e++) if (g = f[e], (k = b[g]) || b["!" + g]) {
                if (k && !c && ("contextData" == g || "retrieveLightData" == g) && a[g]) for (h in a[g]) k[h] || (k[h] = a[g][h]);
                a[g] || (m["!" + g] = 1);
                m[g] = a[g];
                a[g] = k;
              }
              return m;
            };
            a.tc = function (b) {
              var c, d, f, e;
              for (c = 0; 2 > c; c++) for (d = 0 < c ? a.Na : a.i, f = 0; f < d.length; f++) e = d[f], b[e] = a[e], b[e] || "prop" !== e.substring(0, 4) && "eVar" !== e.substring(0, 4) && "hier" !== e.substring(0, 4) && "list" !== e.substring(0, 4) && "channel" !== e && "events" !== e && "eventList" !== e && "products" !== e && "productList" !== e && "purchaseID" !== e && "transactionID" !== e && "state" !== e && "zip" !== e && "campaign" !== e && "events2" !== e && "latitude" !== e && "longitude" !== e && "ms_a" !== e && "contextData" !== e && "supplementalDataID" !== e && "tnt" !== e && "timestamp" !== e && "abort" !== e && "useBeacon" !== e && "linkObject" !== e && "clickObject" !== e && "linkType" !== e && "linkName" !== e && "linkURL" !== e && "bodyClickTarget" !== e && "bodyClickFunction" !== e || (b["!" + e] = 1);
            };
            a.$b = function (a) {
              var c,
                d,
                f,
                e,
                g,
                h = 0,
                l,
                m = "",
                n = "";
              if (a && 255 < a.length && (c = "" + a, d = c.indexOf("?"), 0 < d && (l = c.substring(d + 1), c = c.substring(0, d), e = c.toLowerCase(), f = 0, "http://" == e.substring(0, 7) ? f += 7 : "https://" == e.substring(0, 8) && (f += 8), d = e.indexOf("/", f), 0 < d && (e = e.substring(f, d), g = c.substring(d), c = c.substring(0, d), 0 <= e.indexOf("google") ? h = ",q,ie,start,search_key,word,kw,cd," : 0 <= e.indexOf("yahoo.co") ? h = ",p,ei," : 0 <= e.indexOf("baidu.") && (h = ",wd,word,"), h && l)))) {
                if ((a = l.split("&")) && 1 < a.length) {
                  for (f = 0; f < a.length; f++) e = a[f], d = e.indexOf("="), 0 < d && 0 <= h.indexOf("," + e.substring(0, d) + ",") ? m += (m ? "&" : "") + e : n += (n ? "&" : "") + e;
                  m && n ? l = m + "&" + n : n = "";
                }
                d = 253 - (l.length - n.length) - c.length;
                a = c + (0 < d ? g.substring(0, d) : "") + "?" + l;
              }
              return a;
            };
            a.mb = function (b) {
              var c = a.d.visibilityState,
                d = ["webkitvisibilitychange", "visibilitychange"];
              c || (c = a.d.webkitVisibilityState);
              if (c && "prerender" == c) {
                if (b) for (c = 0; c < d.length; c++) a.d.addEventListener(d[c], function () {
                  var c = a.d.visibilityState;
                  c || (c = a.d.webkitVisibilityState);
                  "visible" == c && b();
                });
                return !1;
              }
              return !0;
            };
            a.ga = !1;
            a.H = !1;
            a.Pb = function () {
              a.H = !0;
              a.q();
            };
            a.K = !1;
            a.Qb = function (b) {
              a.marketingCloudVisitorID = b.MCMID;
              a.visitorOptedOut = b.MCOPTOUT;
              a.analyticsVisitorID = b.MCAID;
              a.audienceManagerLocationHint = b.MCAAMLH;
              a.audienceManagerBlob = b.MCAAMB;
              a.K = !1;
              a.q();
            };
            a.lb = function (b) {
              a.maxDelay || (a.maxDelay = 250);
              return a.v("_d") ? (b && setTimeout(function () {
                b();
              }, a.maxDelay), !1) : !0;
            };
            a.ea = !1;
            a.G = !1;
            a.Ga = function () {
              a.G = !0;
              a.q();
            };
            a.isReadyToTrack = function () {
              var b = !0;
              if (!a.Ab() || !a.yb()) return !1;
              a.Cb() || (b = !1);
              a.Fb() || (b = !1);
              a.nb() || (b = !1);
              return b;
            };
            a.Ab = function () {
              a.ga || a.H || (a.mb(a.Pb) ? a.H = !0 : a.ga = !0);
              return a.ga && !a.H ? !1 : !0;
            };
            a.yb = function () {
              var b = a.Ca();
              if (b) if (a.ya || a.fa) {
                if (a.ya) {
                  if (!b.isApproved(b.Categories.ANALYTICS)) return !1;
                } else return !1;
              } else return b.fetchPermissions(a.Hb, !0), a.fa = !0, !1;
              return !0;
            };
            a.X = function (b) {
              var c = a.Ca();
              return c && !c.isApproved(c.Categories[b]) ? !1 : !0;
            };
            a.Ca = function () {
              return h.adobe && h.adobe.optIn ? h.adobe.optIn : null;
            };
            a.ca = !0;
            a.Cb = function () {
              var b = a.W();
              if (!b || !b.getVisitorValues) return !0;
              a.ca && (a.ca = !1, a.K || (a.K = !0, b.getVisitorValues(a.Qb)));
              return !a.K;
            };
            a.W = function () {
              var b = a.visitor;
              b && !b.isAllowed() && (b = null);
              return b;
            };
            a.Fb = function () {
              a.ea || a.G || (a.lb(a.Ga) ? a.G = !0 : a.ea = !0);
              return a.ea && !a.G ? !1 : !0;
            };
            a.nb = function () {
              a.J || a.clientHints || a.ob();
              return a.clientHints;
            };
            a.fa = !1;
            a.Hb = function () {
              a.fa = !1;
              a.ya = !0;
            };
            a.j = q;
            a.r = 0;
            a.callbackWhenReadyToTrack = function (b, c, d) {
              var f;
              f = {};
              f.Ub = b;
              f.Tb = c;
              f.Rb = d;
              a.j == q && (a.j = []);
              a.j.push(f);
              0 == a.r && (a.r = setInterval(a.q, 100));
            };
            a.q = function () {
              var b;
              if (a.isReadyToTrack() && (a.Nb(), a.j != q)) for (; 0 < a.j.length;) b = a.j.shift(), b.Tb.apply(b.Ub, b.Rb);
            };
            a.Nb = function () {
              a.r && (clearInterval(a.r), a.r = 0);
            };
            a.za = function (b) {
              var c,
                d = {};
              a.tc(d);
              if (b != q) for (c in b) d[c] = b[c];
              a.callbackWhenReadyToTrack(a, a.Ma, [d]);
              a.Ja();
            };
            a.bc = function () {
              var b = a.cookieRead("s_fid"),
                c = "",
                d = "",
                f;
              f = 8;
              var e = 4;
              if (!b || 0 > b.indexOf("-")) {
                for (b = 0; 16 > b; b++) f = Math.floor(Math.random() * f), c += "0123456789ABCDEF".substring(f, f + 1), f = Math.floor(Math.random() * e), d += "0123456789ABCDEF".substring(f, f + 1), f = e = 16;
                b = c + "-" + d;
              }
              a.cookieWrite("s_fid", b, 1) || (b = 0);
              return b;
            };
            a.Ma = function (b) {
              var c = new Date(),
                d = "s" + Math.floor(c.getTime() / 108E5) % 10 + Math.floor(1E13 * Math.random()),
                f = c.getYear(),
                f = "t=" + a.escape(c.getDate() + "/" + c.getMonth() + "/" + (1900 > f ? f + 1900 : f) + " " + c.getHours() + ":" + c.getMinutes() + ":" + c.getSeconds() + " " + c.getDay() + " " + c.getTimezoneOffset()),
                e = a.W(),
                g;
              b && (g = a.U(b, 1));
              a.ic() && !a.visitorOptedOut && (a.Da() || (a.fid = a.bc()), a.kc(), a.usePlugins && a.doPlugins && a.doPlugins(a), a.account && (a.abort || (a.trackOffline && !a.timestamp && (a.timestamp = Math.floor(c.getTime() / 1E3)), b = h.location, a.pageURL || (a.pageURL = b.href ? b.href : b), a.referrer || a.hb || (b = a.Util.getQueryParam("adobe_mc_ref", null, null, !0), a.referrer = b || void 0 === b ? void 0 === b ? "" : b : p.document.referrer), a.hb = 1, !a.referrer && a.da && (a.referrer = a.da), a.da = 0, a.referrer = a.$b(a.referrer), a.v("_g")), a.fc() && !a.abort && (e && a.X("TARGET") && !a.supplementalDataID && e.getSupplementalDataID && (a.supplementalDataID = e.getSupplementalDataID("AppMeasurement:" + a._in, a.expectSupplementalData ? !1 : !0)), a.X("AAM") || (a.contextData["cm.ssf"] = 1), a.gc(), a.Ib(), f += a.ec(), a.Eb(d, f), a.v("_t"), a.referrer = "", a.contextData && a.contextData.excCodes && (a.contextData.excCodes = 0))));
              a.referrer && (a.da = a.referrer);
              a.Ja();
              g && a.U(g, 1);
            };
            a.t = a.track = function (b, c) {
              c && a.U(c);
              a.ca = !0;
              a.isReadyToTrack() ? null != a.j && 0 < a.j.length ? (a.za(b), a.q()) : a.Ma(b) : a.za(b);
            };
            a.Ib = function () {
              a.writeSecureCookies && !a.ssl && a.ib();
            };
            a.ib = function () {
              a.contextData.excCodes = a.contextData.excCodes || [];
              a.contextData.excCodes.push(1);
            };
            a.Ja = function () {
              a.abort = a.supplementalDataID = a.timestamp = a.pageURLRest = a.linkObject = a.clickObject = a.linkURL = a.linkName = a.linkType = h.s_objectID = a.pe = a.pev1 = a.pev2 = a.pev3 = a.e = a.lightProfileID = a.useBeacon = a.referrer = 0;
            };
            a.Ia = [];
            a.registerPreTrackCallback = function (b) {
              for (var c = [], d = 1; d < arguments.length; d++) c.push(arguments[d]);
              "function" == typeof b ? a.Ia.push([b, c]) : a.debugTracking && a.log("Warning, Non function type passed to registerPreTrackCallback");
            };
            a.sb = function (b) {
              a.Ba(a.Ia, b);
            };
            a.Ha = [];
            a.registerPostTrackCallback = function (b) {
              for (var c = [], d = 1; d < arguments.length; d++) c.push(arguments[d]);
              "function" == typeof b ? a.Ha.push([b, c]) : a.debugTracking && a.log("Warning, Non function type passed to registerPostTrackCallback");
            };
            a.rb = function (b) {
              a.Ba(a.Ha, b);
            };
            a.Ba = function (b, c) {
              if ("object" == typeof b) for (var d = 0; d < b.length; d++) {
                var f = b[d][0],
                  e = b[d][1].slice();
                e.unshift(c);
                if ("function" == typeof f) try {
                  f.apply(null, e);
                } catch (g) {
                  a.debugTracking && a.log(g.message);
                }
              }
            };
            a.tl = a.trackLink = function (b, c, d, f, e) {
              a.linkObject = b;
              a.linkType = c;
              a.linkName = d;
              e && (a.bodyClickTarget = b, a.bodyClickFunction = e);
              return a.track(f);
            };
            a.trackLight = function (b, c, d, f) {
              a.lightProfileID = b;
              a.lightStoreForSeconds = c;
              a.lightIncrementBy = d;
              return a.track(f);
            };
            a.clearVars = function () {
              var b, c;
              for (b = 0; b < a.i.length; b++) if (c = a.i[b], "prop" == c.substring(0, 4) || "eVar" == c.substring(0, 4) || "hier" == c.substring(0, 4) || "list" == c.substring(0, 4) || "channel" == c || "events" == c || "eventList" == c || "products" == c || "productList" == c || "purchaseID" == c || "transactionID" == c || "state" == c || "zip" == c || "campaign" == c) a[c] = void 0;
            };
            a.tagContainerMarker = "";
            a.Eb = function (b, c) {
              var d = a.tb() + "/" + b + "?AQB=1&ndh=1&pf=1&" + (a.Fa() ? "callback=s_c_il[" + a._in + "].doPostbacks&et=1&" : "") + c + "&AQE=1";
              a.sb(d);
              a.V ? a.Ob(h.sessionStorage, d) : (a.Ka(), a.Aa(d), a.I());
            };
            a.tb = function () {
              var b = a.ub();
              return "http" + (a.ssl ? "s" : "") + "://" + b + "/b/ss/" + a.account + "/" + (a.mobile ? "5." : "") + (a.Fa() ? "10" : "1") + "/JS-" + a.version + (a.nc ? "T" : "") + (a.tagContainerMarker ? "-" + a.tagContainerMarker : "");
            };
            a.Fa = function () {
              return a.AudienceManagement && a.AudienceManagement.isReady() || 0 != a.usePostbacks;
            };
            a.ub = function () {
              var b = a.dc,
                c = a.trackingServer;
              c ? a.trackingServerSecure && a.ssl && (c = a.trackingServerSecure) : (b = b ? ("" + b).toLowerCase() : "d1", "d1" == b ? b = "112" : "d2" == b && (b = "122"), c = a.wb() + "." + b + ".2o7.net");
              return c;
            };
            a.wb = function () {
              var b = a.visitorNamespace;
              b || (b = a.account.split(",")[0], b = b.replace(/[^0-9a-z]/gi, ""));
              return b;
            };
            a.gb = /{(%?)(.*?)(%?)}/;
            a.sc = RegExp(a.gb.source, "g");
            a.Zb = function (b) {
              if ("object" == typeof b.dests) for (var c = 0; c < b.dests.length; ++c) {
                var d = b.dests[c];
                if ("string" == typeof d.c && "aa." == d.id.substr(0, 3)) for (var f = d.c.match(a.sc), e = 0; e < f.length; ++e) {
                  var g = f[e],
                    h = g.match(a.gb),
                    l = "";
                  "%" == h[1] && "timezone_offset" == h[2] ? l = new Date().getTimezoneOffset() : "%" == h[1] && "timestampz" == h[2] && (l = a.cc());
                  d.c = d.c.replace(g, a.escape(l));
                }
              }
            };
            a.cc = function () {
              var b = new Date(),
                c = new Date(6E4 * Math.abs(b.getTimezoneOffset()));
              return a.k(4, b.getFullYear()) + "-" + a.k(2, b.getMonth() + 1) + "-" + a.k(2, b.getDate()) + "T" + a.k(2, b.getHours()) + ":" + a.k(2, b.getMinutes()) + ":" + a.k(2, b.getSeconds()) + (0 < b.getTimezoneOffset() ? "-" : "+") + a.k(2, c.getUTCHours()) + ":" + a.k(2, c.getUTCMinutes());
            };
            a.k = function (a, c) {
              return (Array(a + 1).join(0) + c).slice(-a);
            };
            a.ua = {};
            a.doPostbacks = function (b) {
              if ("object" == typeof b) if (a.Zb(b), "object" == typeof a.AudienceManagement && "function" == typeof a.AudienceManagement.isReady && a.AudienceManagement.isReady() && "function" == typeof a.AudienceManagement.passData) a.AudienceManagement.passData(b);else if ("object" == typeof b && "object" == typeof b.dests) for (var c = 0; c < b.dests.length; ++c) {
                var d = b.dests[c];
                "object" == typeof d && "string" == typeof d.c && "string" == typeof d.id && "aa." == d.id.substr(0, 3) && (a.ua[d.id] = new Image(), a.ua[d.id].alt = "", a.ua[d.id].src = d.c);
              }
            };
            a.bufferRequests = function (b) {
              b || void 0 === b ? a.qb() : a.pb();
            };
            a.qb = function () {
              a.o(a.w.sessionStorage) ? a.V = !0 : a.log("Warning, session storage is not available. Requests will not be buffered.");
            };
            a.pb = function () {
              a.V && a.Ka();
              a.V = !1;
            };
            a.o = function (a) {
              var c = !0;
              a && a.setItem && h.JSON || (c = !1);
              return c;
            };
            a.Ka = function () {
              var b = a.aa(h.sessionStorage);
              if (b) {
                for (var c = 0; c < b.length; c++) a.Aa(b[c]);
                a.xa(h.sessionStorage);
                a.I();
              }
            };
            a.Aa = function (b) {
              a.g || a.xb();
              a.g.push(b);
              a.na = a.B();
              a.fb();
            };
            a.Ob = function (b, c) {
              var d = a.aa(b) || [];
              d.push(c);
              a.La(b, d);
            };
            a.La = function (b, c) {
              try {
                b.setItem(a.ba(), h.JSON.stringify(c));
              } catch (d) {}
            };
            a.aa = function (b) {
              var c, d;
              if (a.o(b)) {
                try {
                  (d = b.getItem(a.ba())) && (c = h.JSON.parse(d));
                } catch (f) {}
                return c;
              }
            };
            a.xb = function () {
              a.ta() && (a.g = a.aa(h.localStorage));
              a.g || (a.g = []);
            };
            a.xa = function (b) {
              if (a.o(b)) try {
                b.removeItem(a.ba());
              } catch (c) {}
            };
            a.ta = function () {
              var b = !0;
              a.trackOffline && a.storageFilename && a.o(h.localStorage) || (b = !1);
              return b;
            };
            a.Va = function () {
              var b = 0;
              a.g && (b = a.g.length);
              a.p && b++;
              return b;
            };
            a.I = function () {
              if (a.p && (a.A && a.A.complete && a.A.D && a.A.T(), a.p)) return;
              a.Wa = q;
              if (a.ra) a.na > a.P && a.cb(a.g), a.va(500);else {
                var b = a.Sb();
                if (0 < b) a.va(b);else if (b = a.Ta()) a.p = 1, a.jc(b), a.mc(b);
              }
            };
            a.va = function (b) {
              a.Wa || (b || (b = 0), a.Wa = setTimeout(a.I, b));
            };
            a.Sb = function () {
              var b;
              if (!a.trackOffline || 0 >= a.offlineThrottleDelay) return 0;
              b = a.B() - a.ab;
              return a.offlineThrottleDelay < b ? 0 : a.offlineThrottleDelay - b;
            };
            a.Ta = function () {
              if (a.g && 0 < a.g.length) return a.g.shift();
            };
            a.jc = function (b) {
              if (a.debugTracking) {
                var c = "AppMeasurement Debug: " + b;
                b = b.split("&");
                var d;
                for (d = 0; d < b.length; d++) c += "\n\t" + a.unescape(b[d]);
                a.log(c);
              }
            };
            a.Da = function () {
              return a.marketingCloudVisitorID || a.analyticsVisitorID;
            };
            a.Z = !1;
            var t;
            try {
              t = JSON.parse('{"x":"y"}');
            } catch (v) {
              t = null;
            }
            t && "y" == t.x ? (a.Z = !0, a.Y = function (a) {
              return JSON.parse(a);
            }) : h.$ && h.$.parseJSON ? (a.Y = function (a) {
              return h.$.parseJSON(a);
            }, a.Z = !0) : a.Y = function () {
              return null;
            };
            a.mc = function (b) {
              var c, d, f;
              a.zb(b) && (d = 1, c = {
                send: function (b) {
                  a.useBeacon = !1;
                  navigator.sendBeacon(b) ? c.T() : c.la();
                }
              });
              !c && a.Da() && 2047 < b.length && (a.kb() && (d = 2, c = new XMLHttpRequest()), c && (a.AudienceManagement && a.AudienceManagement.isReady() || 0 != a.usePostbacks) && (a.Z ? c.Oa = !0 : c = 0));
              !c && a.rc && (b = b.substring(0, 2047));
              !c && a.d.createElement && (0 != a.usePostbacks || a.AudienceManagement && a.AudienceManagement.isReady()) && (c = a.d.createElement("SCRIPT")) && "async" in c && ((f = (f = a.d.getElementsByTagName("HEAD")) && f[0] ? f[0] : a.d.body) ? (c.type = "text/javascript", c.setAttribute("async", "async"), d = 3) : c = 0);
              c || (c = new Image(), d = 4, c.alt = "", c.abort || "undefined" === typeof h.InstallTrigger || (c.abort = function () {
                c.src = q;
              }));
              c.bb = Date.now();
              c.Qa = function () {
                try {
                  c.D && (clearTimeout(c.D), c.D = 0);
                } catch (a) {}
              };
              c.onload = c.T = function () {
                if (!0 !== c.Vb && (c.Vb = !0, c.bb && (a.oa = Date.now() - c.bb), a.rb(b), c.Qa(), a.Xb(), a.ha(), a.p = 0, a.I(), c.Oa)) {
                  c.Oa = !1;
                  try {
                    a.doPostbacks(a.Y(c.responseText));
                  } catch (d) {}
                }
              };
              c.onabort = c.onerror = c.la = function () {
                c.Qa();
                (a.trackOffline || a.ra) && a.p && a.g.unshift(a.Wb);
                a.p = 0;
                a.na > a.P && a.cb(a.g);
                a.ha();
                a.va(500);
              };
              c.onreadystatechange = function () {
                4 == c.readyState && (200 == c.status ? c.T() : c.la());
              };
              a.ab = a.B();
              if (1 === d) c.send(b);else if (2 === d) f = b.indexOf("?"), d = b.substring(0, f), f = b.substring(f + 1), f = f.replace(/&callback=[a-zA-Z0-9_.\[\]]+/, ""), c.open("POST", d, !0), c.withCredentials = !0, c.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), c.send(f);else if (c.src = b, 3 === d) {
                if (a.Za) try {
                  f.removeChild(a.Za);
                } catch (e) {}
                f.firstChild ? f.insertBefore(c, f.firstChild) : f.appendChild(c);
                a.Za = a.A;
              }
              c.D = setTimeout(function () {
                c.D && (c.complete ? c.T() : (a.trackOffline && c.abort && c.abort(), c.la()));
              }, 5E3);
              a.Wb = b;
              a.A = h["s_i_" + a.replace(a.account, ",", "_")] = c;
              if (a.useForcedLinkTracking && a.L || a.bodyClickFunction) a.forcedLinkTrackingTimeout || (a.forcedLinkTrackingTimeout = 250), a.ia = setTimeout(a.ha, a.forcedLinkTrackingTimeout);
            };
            a.zb = function (b) {
              var c = !1;
              navigator.sendBeacon && (a.Bb(b) ? c = !0 : a.useBeacon && (c = !0));
              a.Kb(b) && (c = !1);
              return c;
            };
            a.Bb = function (a) {
              return a && 0 < a.indexOf("pe=lnk_e") ? !0 : !1;
            };
            a.Kb = function (a) {
              return 64E3 <= a.length;
            };
            a.kb = function () {
              return "undefined" !== typeof XMLHttpRequest && "withCredentials" in new XMLHttpRequest() ? !0 : !1;
            };
            a.Xb = function () {
              !a.ta() || a.$a > a.P || (a.xa(h.localStorage), a.$a = a.B());
            };
            a.cb = function (b) {
              a.ta() && (a.fb(), a.La(h.localStorage, b), a.P = a.B());
            };
            a.fb = function () {
              if (a.trackOffline) {
                if (!a.offlineLimit || 0 >= a.offlineLimit) a.offlineLimit = 10;
                for (; a.g.length > a.offlineLimit;) a.Ta();
              }
            };
            a.forceOffline = function () {
              a.ra = !0;
            };
            a.forceOnline = function () {
              a.ra = !1;
            };
            a.ba = function () {
              return a.storageFilename + "-" + a.visitorNamespace + a.account;
            };
            a.B = function () {
              return new Date().getTime();
            };
            a.Xa = function (a) {
              a = a.toLowerCase();
              return 0 != a.indexOf("#") && 0 != a.indexOf("about:") && 0 != a.indexOf("opera:") && 0 != a.indexOf("javascript:") ? !0 : !1;
            };
            a.setTagContainer = function (b) {
              var c, d, f;
              a.nc = b;
              for (c = 0; c < a._il.length; c++) if ((d = a._il[c]) && "s_l" == d._c && d.tagContainerName == b) {
                a.U(d);
                if (d.lmq) for (c = 0; c < d.lmq.length; c++) f = d.lmq[c], a.loadModule(f.n);
                if (d.ml) for (f in d.ml) if (a[f]) for (c in b = a[f], f = d.ml[f], f) !Object.prototype[c] && ("function" != typeof f[c] || 0 > ("" + f[c]).indexOf("s_c_il")) && (b[c] = f[c]);
                if (d.mmq) for (c = 0; c < d.mmq.length; c++) f = d.mmq[c], a[f.m] && (b = a[f.m], b[f.f] && "function" == typeof b[f.f] && (f.a ? b[f.f].apply(b, f.a) : b[f.f].apply(b)));
                if (d.tq) for (c = 0; c < d.tq.length; c++) a.track(d.tq[c]);
                d.s = a;
                break;
              }
            };
            a.Util = {
              urlEncode: a.escape,
              urlDecode: a.unescape,
              cookieRead: a.cookieRead,
              cookieWrite: a.cookieWrite,
              getQueryParam: function (b, c, d, f) {
                var e,
                  g = "";
                c || (c = a.pageURL ? a.pageURL : h.location);
                d = d ? d : "&";
                if (!b || !c) return g;
                c = "" + c;
                e = c.indexOf("?");
                if (0 > e) return g;
                c = d + c.substring(e + 1) + d;
                if (!f || !(0 <= c.indexOf(d + b + d) || 0 <= c.indexOf(d + b + "=" + d))) {
                  e = c.indexOf("#");
                  0 <= e && (c = c.substr(0, e) + d);
                  e = c.indexOf(d + b + "=");
                  if (0 > e) return g;
                  c = c.substring(e + d.length + b.length + 1);
                  e = c.indexOf(d);
                  0 <= e && (c = c.substring(0, e));
                  0 < c.length && (g = a.unescape(c));
                  return g;
                }
              },
              getIeVersion: function () {
                return document.documentMode ? document.documentMode : a.Ea() ? 7 : null;
              }
            };
            a.F = "supplementalDataID timestamp dynamicVariablePrefix visitorID marketingCloudVisitorID analyticsVisitorID audienceManagerLocationHint authState fid vmk visitorMigrationKey visitorMigrationServer visitorMigrationServerSecure charSet visitorNamespace cookieDomainPeriods fpCookieDomainPeriods cookieLifetime pageName pageURL customerPerspective referrer contextData contextData.cm.ssf contextData.opt.dmp contextData.opt.sell clientHints currencyCode lightProfileID lightStoreForSeconds lightIncrementBy retrieveLightProfiles deleteLightProfiles retrieveLightData".split(" ");
            a.i = a.F.concat("purchaseID variableProvider channel server pageType transactionID campaign state zip events events2 products audienceManagerBlob tnt".split(" "));
            a.pa = "timestamp charSet visitorNamespace cookieDomainPeriods cookieLifetime contextData lightProfileID lightStoreForSeconds lightIncrementBy".split(" ");
            a.Q = a.pa.slice(0);
            a.Na = "account allAccounts debugTracking visitor visitorOptedOut trackOffline offlineLimit offlineThrottleDelay storageFilename usePlugins doPlugins configURL visitorSampling visitorSamplingGroup linkObject clickObject linkURL linkName linkType trackDownloadLinks trackExternalLinks trackClickMap trackInlineStats linkLeaveQueryString linkTrackVars linkTrackEvents linkDownloadFileTypes linkExternalFilters linkInternalFilters useForcedLinkTracking forcedLinkTrackingTimeout writeSecureCookies decodeLinkParameters useLinkTrackSessionStorage collectHighEntropyUserAgentHints trackingServer trackingServerSecure ssl abort mobile dc lightTrackVars maxDelay expectSupplementalData useBeacon usePostbacks registerPreTrackCallback registerPostTrackCallback bodyClickTarget bodyClickFunction bufferRequests AudienceManagement".split(" ");
            for (m = 0; 250 >= m; m++) 76 > m && (a.i.push("prop" + m), a.Q.push("prop" + m)), a.i.push("eVar" + m), a.Q.push("eVar" + m), 6 > m && a.i.push("hier" + m), 4 > m && a.i.push("list" + m);
            m = "pe pev1 pev2 pev3 latitude longitude resolution colorDepth javascriptVersion javaEnabled cookiesEnabled browserWidth browserHeight connectionType homepage pageURLRest marketingCloudOrgID ms_a".split(" ");
            a.i = a.i.concat(m);
            a.F = a.F.concat(m);
            a.ssl = 0 <= h.location.protocol.toLowerCase().indexOf("https");
            a.charSet = "UTF-8";
            a.contextData = {};
            a.wa = ["architecture", "bitness", "model", "platformVersion", "wow64"];
            a.writeSecureCookies = !1;
            a.collectHighEntropyUserAgentHints = !1;
            a.offlineThrottleDelay = 0;
            a.storageFilename = "AppMeasurement.requests";
            a.R = "s_sq";
            a.ab = 0;
            a.na = 0;
            a.P = 0;
            a.$a = 0;
            a.linkDownloadFileTypes = "exe,zip,wav,mp3,mov,mpg,avi,wmv,pdf,doc,docx,xls,xlsx,ppt,pptx";
            a.w = h;
            a.d = h.document;
            a.ha = function () {
              a.ia && (h.clearTimeout(a.ia), a.ia = q);
              a.bodyClickTarget && a.L && a.bodyClickTarget.dispatchEvent(a.L);
              a.bodyClickFunction && ("function" == typeof a.bodyClickFunction ? a.bodyClickFunction() : a.bodyClickTarget && a.bodyClickTarget.href && (a.d.location = a.bodyClickTarget.href));
              a.bodyClickTarget = a.L = a.bodyClickFunction = 0;
            };
            a.eb = function () {
              a.b = a.d.body;
              a.b ? (a.u = function (b) {
                var c, d, f, e, g;
                if (!(a.d && a.d.getElementById("cppXYctnr") || b && b["s_fe_" + a._in])) {
                  if (a.Pa) {
                    if (a.useForcedLinkTracking) a.b.removeEventListener("click", a.u, !1);else {
                      a.b.removeEventListener("click", a.u, !0);
                      a.Pa = a.useForcedLinkTracking = 0;
                      return;
                    }
                  } else a.useForcedLinkTracking = 0;
                  a.clickObject = b.srcElement ? b.srcElement : b.target;
                  try {
                    if (!a.clickObject || a.O && a.O == a.clickObject || !(a.clickObject.tagName || a.clickObject.parentElement || a.clickObject.parentNode)) a.clickObject = 0;else {
                      var k = a.O = a.clickObject;
                      a.ma && (clearTimeout(a.ma), a.ma = 0);
                      a.ma = setTimeout(function () {
                        a.O == k && (a.O = 0);
                      }, 1E4);
                      f = a.Va();
                      a.track();
                      if (f < a.Va() && a.useForcedLinkTracking && b.target) {
                        for (e = b.target; e && e != a.b && "A" != e.tagName.toUpperCase() && "AREA" != e.tagName.toUpperCase();) e = e.parentNode;
                        if (e && (g = e.href, a.Xa(g) || (g = 0), d = e.target, b.target.dispatchEvent && g && (!d || "_self" == d || "_top" == d || "_parent" == d || h.name && d == h.name))) {
                          try {
                            c = a.d.createEvent("MouseEvents");
                          } catch (l) {
                            c = new h.MouseEvent();
                          }
                          if (c) {
                            try {
                              c.initMouseEvent("click", b.bubbles, b.cancelable, b.view, b.detail, b.screenX, b.screenY, b.clientX, b.clientY, b.ctrlKey, b.altKey, b.shiftKey, b.metaKey, b.button, b.relatedTarget);
                            } catch (m) {
                              c = 0;
                            }
                            c && (c["s_fe_" + a._in] = c.s_fe = 1, b.stopPropagation(), b.stopImmediatePropagation && b.stopImmediatePropagation(), b.preventDefault(), a.bodyClickTarget = b.target, a.L = c);
                          }
                        }
                      }
                    }
                  } catch (n) {
                    a.clickObject = 0;
                  }
                }
              }, a.b && a.b.attachEvent ? a.b.attachEvent("onclick", a.u) : a.b && a.b.addEventListener && (navigator && (0 <= navigator.userAgent.indexOf("WebKit") && a.d.createEvent || 0 <= navigator.userAgent.indexOf("Firefox/2") && h.MouseEvent) && (a.Pa = 1, a.useForcedLinkTracking = 1, a.b.addEventListener("click", a.u, !0)), a.b.addEventListener("click", a.u, !1))) : setTimeout(a.eb, 30);
            };
            a.rc = a.Ea();
            a.Yb();
            a.yc || (r ? a.setAccount(r) : a.log("Error, missing Report Suite ID in AppMeasurement initialization"), a.eb(), a.loadModule("ActivityMap"));
          }
          function s_gi(r) {
            var a,
              h = window.s_c_il,
              q,
              p,
              m = r.split(","),
              s,
              u,
              t = 0;
            if (h) for (q = 0; !t && q < h.length;) {
              a = h[q];
              if ("s_c" == a._c && (a.account || a.oun)) if (a.account && a.account == r) t = 1;else for (p = a.account ? a.account : a.oun, p = a.allAccounts ? a.allAccounts : p.split(","), s = 0; s < m.length; s++) for (u = 0; u < p.length; u++) m[s] == p[u] && (t = 1);
              q++;
            }
            t ? a.setAccount && a.setAccount(r) : a = new AppMeasurement(r);
            return a;
          }
          AppMeasurement.getInstance = s_gi;
          window.s_objectID || (window.s_objectID = 0);
          function s_pgicq() {
            var r = window,
              a = r.s_giq,
              h,
              q,
              p;
            if (a) for (h = 0; h < a.length; h++) q = a[h], p = s_gi(q.oun), p.setAccount(q.un), p.setTagContainer(q.tagContainerName);
            r.s_giq = 0;
          }
          s_pgicq();
          window.AppMeasurement = AppMeasurement;
          window.AppMeasurement_Module_Media = AppMeasurement_Module_Media;
          window.modifyAccountFromURL = modifyAccountFromURL;
          window.s_gi = s_gi;
          window.s_pgicq = s_pgicq;
          window.satAccountId = satAccountId;
          window.setSiteCatalystAccountVar = setSiteCatalystAccountVar;
        })(window.s_wdpro);
      });
      if (Analytics._consentEventStream) {
        Analytics._consentEventStream.subscribe(allowedCategories => {
          if (allowedCategories.includes(Analytics.Config?.consentCategoryOverrides?.SiteCatalyst || 'targeting')) loadSwdpro();
        });
      } else {
        loadSwdpro();
      }
    }, 'Analytics', 'once');
  }

  //! moment.js
  //! version : 2.30.1
  //! authors : Tim Wood, Iskren Chernev, Moment.js contributors
  //! license : MIT
  //! momentjs.com

  ;
  (function (global, factory) {
    inject(function (Analytics, store, moment) {
      Analytics.moment = store('moment', moment);
      moment.suppressDeprecationWarnings = true;
    }, 'Analytics', 'store', factory());
  })(this, function () {
    'use strict';

    var hookCallback;
    function hooks() {
      return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
      hookCallback = callback;
    }
    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
      // IE8 will treat undefined and null as object if it wasn't for
      // input != null
      return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;
        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false;
          }
        }
        return true;
      }
    }
    function isUndefined(input) {
      return input === void 0;
    }
    function isNumber(input) {
      return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
      var res = [],
        i,
        arrLen = arr.length;
      for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
      }
      return res;
    }
    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }
      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
      }
      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
      }
      return a;
    }
    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
      // We need to deep clone this object.
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }
    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }
      return m._pf;
    }
    var some;
    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function (fun) {
        var t = Object(this),
          len = t.length >>> 0,
          i;
        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }
        return false;
      };
    }
    function isValid(m) {
      var flags = null,
        parsedParts = false,
        isNowValid = m._d && !isNaN(m._d.getTime());
      if (isNowValid) {
        flags = getParsingFlags(m);
        parsedParts = some.call(flags.parsedDateParts, function (i) {
          return i != null;
        });
        isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
      }
      if (Object.isFrozen == null || !Object.isFrozen(m)) {
        m._isValid = isNowValid;
      } else {
        return isNowValid;
      }
      return m._isValid;
    }
    function createInvalid(flags) {
      var m = createUTC(NaN);
      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }
      return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [],
      updateInProgress = false;
    function copyConfig(to, from) {
      var i,
        prop,
        val,
        momentPropertiesLen = momentProperties.length;
      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }
      if (!isUndefined(from._i)) {
        to._i = from._i;
      }
      if (!isUndefined(from._f)) {
        to._f = from._f;
      }
      if (!isUndefined(from._l)) {
        to._l = from._l;
      }
      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }
      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }
      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }
      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }
      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }
      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }
      if (momentPropertiesLen > 0) {
        for (i = 0; i < momentPropertiesLen; i++) {
          prop = momentProperties[i];
          val = from[prop];
          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }
      return to;
    }

    // Moment prototype object
    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);
      if (!this.isValid()) {
        this._d = new Date(NaN);
      }
      // Prevent infinite loop in case updateOffset creates new moment
      // objects.
      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }
    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
        console.warn('Deprecation warning: ' + msg);
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
          var args = [],
            arg,
            i,
            key,
            argLen = arguments.length;
          for (i = 0; i < argLen; i++) {
            arg = '';
            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] ';
              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ': ' + arguments[0][key] + ', ';
                }
              }
              arg = arg.slice(0, -2); // Remove trailing comma and space
            } else {
              arg = arguments[i];
            }
            args.push(arg);
          }
          warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
          firstTime = false;
        }
        return fn.apply(this, arguments);
      }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }
      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
      return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
      var prop, i;
      for (i in config) {
        if (hasOwnProp(config, i)) {
          prop = config[i];
          if (isFunction(prop)) {
            this[i] = prop;
          } else {
            this['_' + i] = prop;
          }
        }
      }
      this._config = config;
      // Lenient ordinal parsing accepts just a number in addition to
      // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
      // TODO: Remove "ordinalParse" fallback in next major release.
      this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
        prop;
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }
      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
          // make sure changes to properties don't modify parent config
          res[prop] = extend({}, res[prop]);
        }
      }
      return res;
    }
    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }
    var keys;
    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function (obj) {
        var i,
          res = [];
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }
        return res;
      };
    }
    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L'
    };
    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse'];
      return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
      return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      formatFunctions = {},
      formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;
      if (typeof callback === 'string') {
        func = function () {
          return this[callback]();
        };
      }
      if (token) {
        formatTokenFunctions[token] = func;
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }
      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
      }
      return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
        i,
        length;
      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }
      return function (mom) {
        var output = '',
          i;
        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
      };
    }

    // format date using native date object
    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }
      format = expandFormat(format, m.localeData());
      formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
      return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
      var i = 5;
      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }
      localFormattingTokens.lastIndex = 0;
      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }
      return format;
    }
    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
      var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];
      if (format || !formatUpper) {
        return format;
      }
      this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
        if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
          return tok.slice(1);
        }
        return tok;
      }).join('');
      return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
      return this._invalidDate;
    }
    var defaultOrdinal = '%d',
      defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
      return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      w: 'a week',
      ww: '%d weeks',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
      return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
      D: 'date',
      dates: 'date',
      date: 'date',
      d: 'day',
      days: 'day',
      day: 'day',
      e: 'weekday',
      weekdays: 'weekday',
      weekday: 'weekday',
      E: 'isoWeekday',
      isoweekdays: 'isoWeekday',
      isoweekday: 'isoWeekday',
      DDD: 'dayOfYear',
      dayofyears: 'dayOfYear',
      dayofyear: 'dayOfYear',
      h: 'hour',
      hours: 'hour',
      hour: 'hour',
      ms: 'millisecond',
      milliseconds: 'millisecond',
      millisecond: 'millisecond',
      m: 'minute',
      minutes: 'minute',
      minute: 'minute',
      M: 'month',
      months: 'month',
      month: 'month',
      Q: 'quarter',
      quarters: 'quarter',
      quarter: 'quarter',
      s: 'second',
      seconds: 'second',
      second: 'second',
      gg: 'weekYear',
      weekyears: 'weekYear',
      weekyear: 'weekYear',
      GG: 'isoWeekYear',
      isoweekyears: 'isoWeekYear',
      isoweekyear: 'isoWeekYear',
      w: 'week',
      weeks: 'week',
      week: 'week',
      W: 'isoWeek',
      isoweeks: 'isoWeek',
      isoweek: 'isoWeek',
      y: 'year',
      years: 'year',
      year: 'year'
    };
    function normalizeUnits(units) {
      return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
        normalizedProp,
        prop;
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }
      return normalizedInput;
    }
    var priorities = {
      date: 9,
      day: 11,
      weekday: 11,
      isoWeekday: 11,
      dayOfYear: 4,
      hour: 13,
      millisecond: 16,
      minute: 14,
      month: 8,
      quarter: 7,
      second: 15,
      weekYear: 1,
      isoWeekYear: 1,
      week: 5,
      isoWeek: 5,
      year: 1
    };
    function getPrioritizedUnits(unitsObj) {
      var units = [],
        u;
      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({
            unit: u,
            priority: priorities[u]
          });
        }
      }
      units.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return units;
    }
    var match1 = /\d/,
      //       0 - 9
      match2 = /\d\d/,
      //      00 - 99
      match3 = /\d{3}/,
      //     000 - 999
      match4 = /\d{4}/,
      //    0000 - 9999
      match6 = /[+-]?\d{6}/,
      // -999999 - 999999
      match1to2 = /\d\d?/,
      //       0 - 99
      match3to4 = /\d\d\d\d?/,
      //     999 - 9999
      match5to6 = /\d\d\d\d\d\d?/,
      //   99999 - 999999
      match1to3 = /\d{1,3}/,
      //       0 - 999
      match1to4 = /\d{1,4}/,
      //       0 - 9999
      match1to6 = /[+-]?\d{1,6}/,
      // -999999 - 999999
      matchUnsigned = /\d+/,
      //       0 - inf
      matchSigned = /[+-]?\d+/,
      //    -inf - inf
      matchOffset = /Z|[+-]\d\d:?\d\d/gi,
      // +00:00 -00:00 +0000 -0000 or Z
      matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
      // +00 -00 +00:00 -00:00 +0000 -0000 or Z
      matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
      // 123456789 123456789.123
      // any word (or two) characters or numbers including two/three word month in arabic.
      // includes scottish gaelic two word and hyphenated months
      matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      match1to2NoLeadingZero = /^[1-9]\d?/,
      //         1-99
      match1to2HasZero = /^([1-9]\d|\d)/,
      //           0-99
      regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }
    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }
      return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
      return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }));
    }
    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
      if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
        value = 0;
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }
      return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
      var i,
        func = callback,
        tokenLen;
      if (typeof token === 'string') {
        token = [token];
      }
      if (isNumber(callback)) {
        func = function (input, array) {
          array[callback] = toInt(input);
        };
      }
      tokenLen = token.length;
      for (i = 0; i < tokenLen; i++) {
        tokens[token[i]] = func;
      }
    }
    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }
    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }
    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0,
      MONTH = 1,
      DATE = 2,
      HOUR = 3,
      MINUTE = 4,
      SECOND = 5,
      MILLISECOND = 6,
      WEEK = 7,
      WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
      var y = this.year();
      return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100;
    });
    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
      return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }
    function get(mom, unit) {
      if (!mom.isValid()) {
        return NaN;
      }
      var d = mom._d,
        isUTC = mom._isUTC;
      switch (unit) {
        case 'Milliseconds':
          return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
        case 'Seconds':
          return isUTC ? d.getUTCSeconds() : d.getSeconds();
        case 'Minutes':
          return isUTC ? d.getUTCMinutes() : d.getMinutes();
        case 'Hours':
          return isUTC ? d.getUTCHours() : d.getHours();
        case 'Date':
          return isUTC ? d.getUTCDate() : d.getDate();
        case 'Day':
          return isUTC ? d.getUTCDay() : d.getDay();
        case 'Month':
          return isUTC ? d.getUTCMonth() : d.getMonth();
        case 'FullYear':
          return isUTC ? d.getUTCFullYear() : d.getFullYear();
        default:
          return NaN;
        // Just in case
      }
    }
    function set$1(mom, unit, value) {
      var d, isUTC, year, month, date;
      if (!mom.isValid() || isNaN(value)) {
        return;
      }
      d = mom._d;
      isUTC = mom._isUTC;
      switch (unit) {
        case 'Milliseconds':
          return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
        case 'Seconds':
          return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
        case 'Minutes':
          return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
        case 'Hours':
          return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
        case 'Date':
          return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
        // case 'Day': // Not real
        //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
        // case 'Month': // Not used because we need to pass two variables
        //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
        case 'FullYear':
          break;
        // See below ...
        default:
          return;
        // Just in case
      }
      year = value;
      month = mom.month();
      date = mom.date();
      date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
      void (isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units]();
      }
      return this;
    }
    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units),
          i,
          prioritizedLen = prioritized.length;
        for (i = 0; i < prioritizedLen; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
          return this[units](value);
        }
      }
      return this;
    }
    function mod(n, x) {
      return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }
        return -1;
      };
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }
      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict);
      // if we didn't find a month name, mark the date as invalid.
      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      defaultMonthsShortRegex = matchWord,
      defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone'];
      }
      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
      }
      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
      var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
      if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      }

      // TODO: add sorting
      // Sorting makes sure if one month (or abbr) is a prefix of another
      // see sorting in computeMonthsParse
      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
          this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    }

    // MOMENTS

    function setMonth(mom, value) {
      if (!mom.isValid()) {
        // No op
        return mom;
      }
      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value);
          // TODO: Another silent failure?
          if (!isNumber(value)) {
            return mom;
          }
        }
      }
      var month = value,
        date = mom.date();
      date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
      void (mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date));
      return mom;
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, 'Month');
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        shortP,
        longP;
      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortP = regexEscape(this.monthsShort(mom, ''));
        longP = regexEscape(this.months(mom, ''));
        shortPieces.push(shortP);
        longPieces.push(longP);
        mixedPieces.push(longP);
        mixedPieces.push(shortP);
      }
      // Sorting makes sure if one month (or abbr) is a prefix of another it
      // will match the longer piece.
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
      // can't just apply() to create a date:
      // https://stackoverflow.com/q/181348
      var date;
      // the date constructor remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }
      return date;
    }
    function createUTCDate(y) {
      var date, args;
      // the Date.UTC function remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        // preserve leap years using a full 400 year cycle, then reset
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }
      return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
      var
        // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;
      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;
      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }
      return {
        week: resWeek,
        year: resYear
      };
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
      week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6 // The week that contains Jan 6th is the first week of the year.
    };
    function localeFirstDayOfWeek() {
      return this._week.dow;
    }
    function localeFirstDayOfYear() {
      return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict);
      // if we didn't get a weekday name, mark the date as invalid
      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input;
      }
      if (!isNaN(input)) {
        return parseInt(input, 10);
      }
      input = locale.weekdaysParse(input);
      if (typeof input === 'number') {
        return input;
      }
      return null;
    }
    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
      }
      return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      defaultWeekdaysRegex = matchWord,
      defaultWeekdaysShortRegex = matchWord,
      defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }
      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
          this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
          this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
          regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var day = get(this, 'Day');
      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
      } else {
        return day;
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      // behaves the same as moment#day except
      // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
      // as a setter, sunday should belong to the previous week.

      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ''));
        shortp = regexEscape(this.weekdaysShort(mom, ''));
        longp = regexEscape(this.weekdays(mom, ''));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      }
      // Sorting makes sure if one weekday (or abbr) is a prefix of another it
      // will match the longer piece.
      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
      this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
      return this.hours() % 12 || 12;
    }
    function kFormat() {
      return this.hours() || 24;
    }
    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
      });
    }
    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
      // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
      // Using charAt should be more compatible.
      return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
      // Setting the hour should keep the time, because the user explicitly
      // specified which hour they want. So trying to maintain the same hour (in
      // a new timezone) makes sense. Adding/subtracting hours does not follow
      // this rule.
      getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {},
      localeFamilies = {},
      globalLocale;
    function commonPrefix(arr1, arr2) {
      var i,
        minl = Math.min(arr1.length, arr2.length);
      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i;
        }
      }
      return minl;
    }
    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
      var i = 0,
        j,
        next,
        locale,
        split;
      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'));
          if (locale) {
            return locale;
          }
          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            //the next array item is better than a shallower substring of this one
            break;
          }
          j--;
        }
        i++;
      }
      return globalLocale;
    }
    function isLocaleNameSane(name) {
      // Prevent names that look like filesystem paths, i.e contain '/' or '\'
      // Ensure name is available and function returns boolean
      return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
      var oldLocale = null,
        aliasedRequire;
      // TODO: Find a better way to register and load all the locales in Node
      if (locales[name] === undefined && typeof module !== 'undefined' && module && module.exports && isLocaleNameSane(name)) {
        try {
          oldLocale = globalLocale._abbr;
          aliasedRequire = require;
          aliasedRequire('./locale/' + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {
          // mark as not found to avoid repeating expensive file require call causing high CPU
          // when trying to find en-US, en_US, en-us for every format call
          locales[name] = null; // null means not found
        }
      }
      return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
      var data;
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }
        if (data) {
          // moment.duration._locale = moment._locale = data;
          globalLocale = data;
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
          }
        }
      }
      return globalLocale._abbr;
    }
    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
          parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
          deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);
            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }
              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));
        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
          });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);
        return locales[name];
      } else {
        // useful for testing
        delete locales[name];
        return null;
      }
    }
    function updateLocale(name, config) {
      if (config != null) {
        var locale,
          tmpLocale,
          parentConfig = baseConfig;
        if (locales[name] != null && locales[name].parentLocale != null) {
          // Update existing child locale in-place to avoid memory-leaks
          locales[name].set(mergeConfigs(locales[name]._config, config));
        } else {
          // MERGE
          tmpLocale = loadLocale(name);
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
          }
          config = mergeConfigs(parentConfig, config);
          if (tmpLocale == null) {
            // updateLocale is called for creating a new locale
            // Set abbr so it will have a name (getters return
            // undefined otherwise).
            config.abbr = name;
          }
          locale = new Locale(config);
          locale.parentLocale = locales[name];
          locales[name] = locale;
        }

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
      } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name);
            }
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }
      return locales[name];
    }

    // returns locale data
    function getLocale(key) {
      var locale;
      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }
      if (!key) {
        return globalLocale;
      }
      if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
          return locale;
        }
        key = [key];
      }
      return chooseLocale(key);
    }
    function listLocales() {
      return keys(locales);
    }
    function checkOverflow(m) {
      var overflow,
        a = m._a;
      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }
        getParsingFlags(m).overflow = overflow;
      }
      return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
      isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
      // iso time formats and regexes
      isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
      // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
      rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
      };

    // date from iso format
    function configFromISO(config) {
      var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat,
        isoDatesLen = isoDates.length,
        isoTimesLen = isoTimes.length;
      if (match) {
        getParsingFlags(config).iso = true;
        for (i = 0, l = isoDatesLen; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }
        if (dateFormat == null) {
          config._isValid = false;
          return;
        }
        if (match[3]) {
          for (i = 0, l = isoTimesLen; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              // match[2] should be 'T' or space
              timeFormat = (match[2] || ' ') + isoTimes[i][0];
              break;
            }
          }
          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z';
          } else {
            config._isValid = false;
            return;
          }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];
      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }
      return result;
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);
      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }
      return year;
    }
    function preprocessRFC2822(s) {
      // Remove comments and folding whitespace and replace multiple-spaces with a single space
      return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }
      return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
      } else {
        var hm = parseInt(numOffset, 10),
          m = hm % 100,
          h = (hm - m) / 100;
        return h * 60 + m;
      }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;
      if (match) {
        parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }
        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);
      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }
      configFromISO(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      configFromRFC2822(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      if (config._strict) {
        config._isValid = false;
      } else {
        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
      }
    }
    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
      config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }
      if (b != null) {
        return b;
      }
      return c;
    }
    function currentDateArray(config) {
      // hooks is actually the exported moment object
      var nowValue = new Date(hooks.now());
      if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
      var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;
      if (config._d) {
        return;
      }
      currentDate = currentDateArray(config);

      //compute day of the year from weeks and weekdays
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      }

      //if the day of the year is set, figure out what it is
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }
        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      }

      // Default to current date.
      // * if no year, month, day of month are given, default to today
      // * if day of month is given, default month and year
      // * if month is given, default only year
      // * if year is given, don't default anything
      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      }

      // Zero out whatever was not defaulted, including time
      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      }

      // Check for 24:00:00.000
      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }
      config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

      // Apply timezone offset from input. The actual utcOffset can be changed
      // with parseZone.
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }
      if (config._nextDay) {
        config._a[HOUR] = 24;
      }

      // check for mismatching day of week
      if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }
    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
      w = config._w;
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);
        if (w.d != null) {
          // weekday -- low day numbers are considered next week
          weekday = w.d;
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          // local weekday -- counting starts from beginning of week
          weekday = w.e + dow;
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          // default to beginning of week
          weekday = dow;
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
      // TODO: Move this to another part of the creation flow to prevent circular deps
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }
      config._a = [];
      getParsingFlags(config).empty = true;

      // This array is used to make a Date, either with `new Date` or `Date.UTC`
      var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era,
        tokenLen;
      tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
      tokenLen = tokens.length;
      for (i = 0; i < tokenLen; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }
          string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
          totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }
          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      }

      // add remaining unparsed input length to the string
      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      }

      // clear _12h flag if hour is <= 12
      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
      }
      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem;
      // handle meridiem
      config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

      // handle era
      era = getParsingFlags(config).era;
      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
      }
      configFromArray(config);
      checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;
      if (meridiem == null) {
        // nothing to do
        return hour;
      }
      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
          hour += 12;
        }
        if (!isPm && hour === 12) {
          hour = 0;
        }
        return hour;
      } else {
        // this is not supposed to happen
        return hour;
      }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
      var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false,
        configfLen = config._f.length;
      if (configfLen === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }
      for (i = 0; i < configfLen; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);
        if (isValid(tempConfig)) {
          validFormatFound = true;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (!bestFormatIsValid) {
          if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
            if (validFormatFound) {
              bestFormatIsValid = true;
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
          }
        }
      }
      extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
      if (config._d) {
        return;
      }
      var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
      config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
      });
      configFromArray(config);
    }
    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));
      if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
      }
      return res;
    }
    function prepareConfig(config) {
      var input = config._i,
        format = config._f;
      config._locale = config._locale || getLocale(config._l);
      if (input === null || format === undefined && input === '') {
        return createInvalid({
          nullInput: true
        });
      }
      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }
      if (!isValid(config)) {
        config._d = null;
      }
      return config;
    }
    function configFromInput(config) {
      var input = config._i;
      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === 'string') {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};
      if (format === true || format === false) {
        strict = format;
        format = undefined;
      }
      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }
      if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = undefined;
      }
      // object construction must be done this way.
      // https://github.com/moment/moment/issues/1423
      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;
      return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other < this ? this : other;
        } else {
          return createInvalid();
        }
      }),
      prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other > this ? this : other;
        } else {
          return createInvalid();
        }
      });

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
      var res, i;
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }
      if (!moments.length) {
        return createLocal();
      }
      res = moments[0];
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }
      return res;
    }

    // TODO: Use [].sort instead?
    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isBefore', args);
    }
    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isAfter', args);
    }
    var now = function () {
      return Date.now ? Date.now() : +new Date();
    };
    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
    function isDurationValid(m) {
      var key,
        unitHasDecimal = false,
        i,
        orderLen = ordering.length;
      for (key in m) {
        if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }
      for (i = 0; i < orderLen; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false; // only allow non-integers for smallest unit
          }
          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }
      return true;
    }
    function isValid$1() {
      return this._isValid;
    }
    function createInvalid$1() {
      return createDuration(NaN);
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput);

      // representation for dateAddRemove
      this._milliseconds = +milliseconds + seconds * 1e3 +
      // 1000
      minutes * 6e4 +
      // 1000 * 60
      hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
      // Because of dateAddRemove treats 24 hours as different from a
      // day when working around DST, we need to store them separately
      this._days = +days + weeks * 7;
      // It is impossible to translate months into days without knowing
      // which months you are are talking about, so we have to store
      // it separately.
      this._months = +months + quarters * 3 + years * 12;
      this._data = {};
      this._locale = getLocale();
      this._bubble();
    }
    function isDuration(obj) {
      return obj instanceof Duration;
    }
    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }
      return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
          sign = '+';
        if (offset < 0) {
          offset = -offset;
          sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
      });
    }
    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;
      if (matches === null) {
        return null;
      }
      chunk = matches[matches.length - 1] || [];
      parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
      minutes = +(parts[1] * 60) + toInt(parts[2]);
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
      var res, diff;
      if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }
    function getDateOffset(m) {
      // On Firefox.24 Date#getTimezoneOffset returns a floating point.
      // https://github.com/moment/moment/pull/1871
      return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
        localAdjust;
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input);
          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
          this.add(localAdjust, 'm');
        }
        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }
        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input;
        }
        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm');
        }
      }
      return this;
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }
      return this;
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }
      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }
      var c = {},
        other;
      copyConfig(c, this);
      c = prepareConfig(c);
      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }
      return this._isDSTShifted;
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
      // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
      // and further modified to allow for strings containing both week and day
      isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
      var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
          duration[key] = +input;
        } else {
          duration.milliseconds = +input;
        }
      } else if (match = aspNetRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
      } else if (match = isoRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        // checks for null or undefined
        duration = {};
      } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }
      ret = new Duration(duration);
      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
      }
      if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid;
      }
      return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
      // We'd normally use ~~inp for this, but unfortunately it also
      // converts floats to ints.
      // inp may be undefined, so careful calling replace on it.
      var res = inp && parseFloat(inp.replace(',', '.'));
      // apply sign while we're at it
      return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
      }
      res.milliseconds = +other - +base.clone().add(res.months, 'M');
      return res;
    }
    function momentsDifference(base, other) {
      var res;
      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0
        };
      }
      other = cloneWithOffset(other, base);
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }
      return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
          tmp = val;
          val = period;
          period = tmp;
        }
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);
      if (!mom.isValid()) {
        // No op
        return;
      }
      updateOffset = updateOffset == null ? true : updateOffset;
      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
      }
      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
      }
      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }
    var add = createAdder(1, 'add'),
      subtract = createAdder(-1, 'subtract');
    function isString(input) {
      return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
      return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
        i,
        property,
        propertyLen = properties.length;
      for (i = 0; i < propertyLen; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input),
        dataTypeTest = false;
      if (arrayTest) {
        dataTypeTest = input.filter(function (item) {
          return !isNumber(item) && isString(input);
        }).length === 0;
      }
      return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
        i,
        property;
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true);
      return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
      // Support for single parameter, formats only overload to the calendar function
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = undefined;
          formats = undefined;
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0];
          formats = undefined;
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0];
          time = undefined;
        }
      }
      // We want to compare the start of today, vs this.
      // Getting start-of-today depends on whether we're local/utc/offset or not.
      var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
      return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
      return new Moment(this);
    }
    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }
    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }
      inclusivity = inclusivity || '()';
      return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output;
      if (!this.isValid()) {
        return NaN;
      }
      that = cloneWithOffset(input, this);
      if (!that.isValid()) {
        return NaN;
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);
      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12;
          break;
        case 'month':
          output = monthDiff(this, that);
          break;
        case 'quarter':
          output = monthDiff(this, that) / 3;
          break;
        case 'second':
          output = (this - that) / 1e3;
          break;
        // 1000
        case 'minute':
          output = (this - that) / 6e4;
          break;
        // 1000 * 60
        case 'hour':
          output = (this - that) / 36e5;
          break;
        // 1000 * 60 * 60
        case 'day':
          output = (this - that - zoneDelta) / 864e5;
          break;
        // 1000 * 60 * 60 * 24, negate dst
        case 'week':
          output = (this - that - zoneDelta) / 6048e5;
          break;
        // 1000 * 60 * 60 * 24 * 7, negate dst
        default:
          output = this - that;
      }
      return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
      }
      // difference in months
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;
      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
      }

      //check for negative zero, return zero if negative zero
      return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
      return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }
      var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
      }
      if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
      }
      return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
      }
      var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
      }
      prefix = '[' + func + '("]';
      year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
      datetime = '-MM-DD[T]HH:mm:ss.SSS';
      suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }
      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          to: this,
          from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          from: this,
          to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
      var newLocaleData;
      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }
        return this;
      }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    });
    function localeData() {
      return this._locale;
    }
    var MS_PER_SECOND = 1000,
      MS_PER_MINUTE = 60 * MS_PER_SECOND,
      MS_PER_HOUR = 60 * MS_PER_MINUTE,
      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
      // the date constructor remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }
    function utcStartOfDate(y, m, d) {
      // Date.UTC remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }
    function startOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1);
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
          break;
        case 'month':
          time = startOfDate(this.year(), this.month(), 1);
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date());
          break;
        case 'hour':
          time = this._d.valueOf();
          time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
          break;
        case 'minute':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;
        case 'second':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function endOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;
        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case 'hour':
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
          break;
        case 'minute':
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;
        case 'second':
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
      return new Date(this.valueOf());
    }
    function toArray() {
      var m = this;
      return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }
    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }
    function toJSON() {
      // new Date(NaN).toJSON() === null
      return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
      return isValid(this);
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
      return getParsingFlags(this).overflow;
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
      var era = config._locale.erasParse(input, token, config._strict);
      if (era) {
        getParsingFlags(config).era = era;
      } else {
        getParsingFlags(config).invalidEra = input;
      }
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
      var match;
      if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
      }
      if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
      } else {
        array[YEAR] = parseInt(input, 10);
      }
    });
    function localeEras(m, format) {
      var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras;
      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case 'string':
            // truncate time
            date = hooks(eras[i].since).startOf('day');
            eras[i].since = date.valueOf();
            break;
        }
        switch (typeof eras[i].until) {
          case 'undefined':
            eras[i].until = +Infinity;
            break;
          case 'string':
            // truncate time
            date = hooks(eras[i].until).startOf('day').valueOf();
            eras[i].until = date.valueOf();
            break;
        }
      }
      return eras;
    }
    function localeErasParse(eraName, format, strict) {
      var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
      eraName = eraName.toUpperCase();
      for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();
        if (strict) {
          switch (format) {
            case 'N':
            case 'NN':
            case 'NNN':
              if (abbr === eraName) {
                return eras[i];
              }
              break;
            case 'NNNN':
              if (name === eraName) {
                return eras[i];
              }
              break;
            case 'NNNNN':
              if (narrow === eraName) {
                return eras[i];
              }
              break;
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i];
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? +1 : -1;
      if (year === undefined) {
        return hooks(era.since).year();
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
      }
    }
    function getEraName() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name;
        }
      }
      return '';
    }
    function getEraNarrow() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow;
        }
      }
      return '';
    }
    function getEraAbbr() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr;
        }
      }
      return '';
    }
    function getEraYear() {
      var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1;

        // truncate time
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
          return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
      }
      return this.year();
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
      return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
      return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
      return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
      return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
      var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        erasName,
        erasAbbr,
        erasNarrow,
        eras = this.eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        erasName = regexEscape(eras[i].name);
        erasAbbr = regexEscape(eras[i].abbr);
        erasNarrow = regexEscape(eras[i].narrow);
        namePieces.push(erasName);
        abbrPieces.push(erasAbbr);
        narrowPieces.push(erasNarrow);
        mixedPieces.push(erasName);
        mixedPieces.push(erasAbbr);
        mixedPieces.push(erasNarrow);
      }
      this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
      this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
      this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
      week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;
      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
          week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
      // TODO: Remove "ordinalParse" fallback in next major release.
      return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
      var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned);
    }
    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs);
    }
    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
      proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>';
      };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
      return createLocal(input * 1000);
    }
    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
      return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
      var locale = getLocale(),
        utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }
      format = format || '';
      if (index != null) {
        return get$1(format, index, field, 'month');
      }
      var i,
        out = [];
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
      }
      return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      }
      var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];
      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
      }
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
      }
      return out;
    }
    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
      eras: [{
        since: '0001-01-01',
        until: +Infinity,
        offset: 1,
        name: 'Anno Domini',
        narrow: 'AD',
        abbr: 'AD'
      }, {
        since: '0000-12-31',
        until: -Infinity,
        offset: 1,
        name: 'Before Christ',
        narrow: 'BC',
        abbr: 'BC'
      }],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function (number) {
        var b = number % 10,
          output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }
    function bubble() {
      var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays;

      // if we have a mix of positive and negative values, bubble down first
      // check: https://github.com/moment/moment/issues/2166
      if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      }

      // The following code bubbles up values, see the tests for
      // examples of what that means.
      data.milliseconds = milliseconds % 1000;
      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;
      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;
      hours = absFloor(minutes / 60);
      data.hours = hours % 24;
      days += absFloor(hours / 24);

      // convert days to months
      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays));

      // 12 months -> 1 year
      years = absFloor(months / 12);
      months %= 12;
      data.days = days;
      data.months = months;
      data.years = years;
      return this;
    }
    function daysToMonths(days) {
      // 400 years have 146097 days (taking into account leap year rules)
      // 400 years have 12 months === 4800
      return days * 4800 / 146097;
    }
    function monthsToDays(months) {
      // the reverse of daysToMonths
      return months * 146097 / 4800;
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }
      var days,
        months,
        milliseconds = this._milliseconds;
      units = normalizeUnits(units);
      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch (units) {
          case 'month':
            return months;
          case 'quarter':
            return months / 3;
          case 'year':
            return months / 12;
        }
      } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5;
          case 'day':
            return days + milliseconds / 864e5;
          case 'hour':
            return days * 24 + milliseconds / 36e5;
          case 'minute':
            return days * 1440 + milliseconds / 6e4;
          case 'second':
            return days * 86400 + milliseconds / 1000;
          // Math.floor prevents floating point math errors here
          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds;
          default:
            throw new Error('Unknown unit ' + units);
        }
      }
    }
    function makeAs(alias) {
      return function () {
        return this.as(alias);
      };
    }
    var asMilliseconds = makeAs('ms'),
      asSeconds = makeAs('s'),
      asMinutes = makeAs('m'),
      asHours = makeAs('h'),
      asDays = makeAs('d'),
      asWeeks = makeAs('w'),
      asMonths = makeAs('M'),
      asQuarters = makeAs('Q'),
      asYears = makeAs('y'),
      valueOf$1 = asMilliseconds;
    function clone$1() {
      return createDuration(this);
    }
    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN;
      };
    }
    var milliseconds = makeGetter('milliseconds'),
      seconds = makeGetter('seconds'),
      minutes = makeGetter('minutes'),
      hours = makeGetter('hours'),
      days = makeGetter('days'),
      months = makeGetter('months'),
      years = makeGetter('years');
    function weeks() {
      return absFloor(this.days() / 7);
    }
    var round = Math.round,
      thresholds = {
        ss: 44,
        // a few seconds to seconds
        s: 45,
        // seconds to minute
        m: 45,
        // minutes to hour
        h: 22,
        // hours to day
        d: 26,
        // days to month/week
        w: null,
        // weeks to month
        M: 11 // months to year
      };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
      var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];
      if (thresholds.w != null) {
        a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
      }
      a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }
      if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
      }
      return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }
      if (limit === undefined) {
        return thresholds[threshold];
      }
      thresholds[threshold] = limit;
      if (threshold === 's') {
        thresholds.ss = limit - 1;
      }
      return true;
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var withSuffix = false,
        th = thresholds,
        locale,
        output;
      if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
      }
      if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix;
      }
      if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1;
        }
      }
      locale = this.localeData();
      output = relativeTime$1(this, !withSuffix, th, locale);
      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }
      return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
      // for ISO strings we do not use the normal bubbling rules:
      //  * milliseconds bubble up until they become hours
      //  * days do not bubble at all
      //  * months bubble up until they become years
      // This is because there is no context-free conversion between hours and days
      // (think of clock changes)
      // and also not between days and months (28-31 days per month)
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var seconds = abs$1(this._milliseconds) / 1000,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;
      if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
      }

      // 3600 seconds -> 60 minutes -> 1 hour
      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60;

      // 12 months -> 1 year
      years = absFloor(months / 12);
      months %= 12;

      // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
      s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
      totalSign = total < 0 ? '-' : '';
      ymSign = sign(this._months) !== sign(total) ? '-' : '';
      daysSign = sign(this._days) !== sign(total) ? '-' : '';
      hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
      return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      // <input type="datetime-local" />
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      // <input type="datetime-local" step="1" />
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      // <input type="datetime-local" step="0.001" />
      DATE: 'YYYY-MM-DD',
      // <input type="date" />
      TIME: 'HH:mm',
      // <input type="time" />
      TIME_SECONDS: 'HH:mm:ss',
      // <input type="time" step="1" />
      TIME_MS: 'HH:mm:ss.SSS',
      // <input type="time" step="0.001" />
      WEEK: 'GGGG-[W]WW',
      // <input type="week" />
      MONTH: 'YYYY-MM' // <input type="month" />
    };
    return hooks;
  });

  /* global inject */
  inject((Analytics, store) => {
    Analytics.Exports = store('Exports', {});
  }, 'Analytics', 'store');

  /* global inject */
  inject((Analytics, store, namespace, extend, nonProdDomain, publish, go4EnvProd) => {
    const Config = store('Config', namespace('Config', {}, Analytics));
    const frameworkSrc = document.currentScript?.src || '';
    const envProd = typeof go4EnvProd === 'boolean' ? go4EnvProd : !nonProdDomain();
    const go4Base = frameworkSrc.includes('/jsaf/v/') ? frameworkSrc.slice(0, frameworkSrc.indexOf('/jsaf/v/')) : 'https://go4.disney.go.com';
    let {
      hostname: go4BaseHost,
      pathname: go4BasePath
    } = new URL(go4Base);
    if (go4BasePath.startsWith('/')) go4BasePath = go4BasePath.slice(1); // remove leading slash

    const defaults = {
      frameworkSrc,
      frameworkBase: (/^https?:\/\/[^/]+(?:\/.+)?(?:\/analytics\/framework|\/jsaf\/v)(?:\/[a-z][a-z0-9]+)?(?:\/latest|\/stable|\/\d+\.\d+\.\d+[^/]*)(?=\/)/i.exec(frameworkSrc) || [''])[0],
      go4Base,
      go4BaseHost,
      go4BasePath,
      products: {},
      supportedProducts: [],
      dependancies: [],
      site: location.hostname,
      envProd,
      environment: envProd ? 'prod' : 'stage',
      // load json from cfgSvc if GO4 loader sets a good site value in loaderConfig
      // can be overridden if WDPRO.Analytics.Config.configServiceLoadJson is set to false in the TMS
      configServiceLoadJson: Boolean(Analytics.loaderConfig?.site),
      configServiceDiscrepancySampling: 0.05,
      configServiceMissingFileSampling: 0.2,
      configServiceBase: `${go4Base}/jsaf/config`,
      pageKeyDomSelector: 'meta[name="pageKey"]',
      pageKeyDomProperty: 'content'
    };
    extend(Config, extend({}, defaults, Analytics.loaderConfig, Config));
    publish({
      topic: 'framework.ConfigLoaded',
      Config
    });
    store('addAdapter', addAdapter);
    function addAdapter(adapter) {
      var dependencyConfig;
      if (adapter.mode.includes(Analytics.mode)) {
        dependencyConfig = {
          product: adapter.name
        };
        if (adapter.dependants) {
          dependencyConfig.dependants = adapter.dependants;
          //need "immediate" stuff here?
        }
        Config.products[adapter.name] = adapter;
        Config.supportedProducts.push(adapter.name);
        Config.dependancies.push(dependencyConfig);
      }
      return adapter;
    }
  }, 'Analytics', 'store', 'namespace', 'extend', 'nonProdDomain', 'publish', 'GO4.envProd');

  /* global inject */
  inject((store, Analytics) => {
    store('consentAugment', function consentAugment(adapter) {
      /*
      essential (C0001) - necessary for the website to function and cannot be switched off
      performance (C0002) - to count visits and traffic sources so we can measure and improve the performance of our site
      functional (C0003) - to provide enhanced functionality and personalisation
      targeting (C0004) - set by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites
      social (C0005) - set by a range of social media services that we have added to the site to enable you to share our content with your friends and networks. They are capable of tracking your browser across other sites and building up a profile of your interests
      */
      const defaultCategory = adapter.consentCategory;
      if (adapter.name) {
        Object.defineProperty(adapter, 'consentCategory', {
          get() {
            return Analytics.Config?.consentCategoryOverrides?.[adapter.name] ?? defaultCategory;
          },
          enumerable: true,
          configurable: true
        });
      }
      adapter._consentCategories = [];
      adapter._queue = [];
      'adapter,adapt,turnOff,disable,turnOn,enable,reset,trackElement,init'.split(',').forEach(prop => {
        if (adapter[prop] && typeof adapter[prop] === 'function') {
          adapter[prop] = consent(adapter[prop]);
        }
      });
      if (Analytics._consentEventStream) {
        Analytics._consentEventStream.subscribe(_notifyConsent.bind(adapter));
      } else {
        _notifyConsent.call(adapter, ['essential', 'performance', 'functional', 'targeting', 'social']);
      }
      function consent(fn) {
        return function () {
          if (this._consentCategories.includes(this.consentCategory)) {
            return fn.apply(this, arguments);
          } else {
            this._queue.push([fn, arguments]);
          }
        };
      }
      function _notifyConsent(newConsentCategories) {
        this._consentCategories = newConsentCategories;
        if (this._consentCategories.includes(this.consentCategory)) {
          // clear queue
          let fn, args, entry;
          while (entry = this._queue.shift()) {
            [fn, args] = entry;
            fn.apply(this, args);
          }
        }
      }
    });
  }, 'store', 'Analytics');

  /* global inject */
  inject((extend, store, resolve, publish, consentAugment, addAdapter) => {
    var BACKCOMPAT = true,
      resetData = {
        normalEnabledState: {}
      };
    extend(Adapter.prototype, {
      // these are the defaults for all adapters
      // they can be overridden in the constructor config for individual adapter instances

      // PROPERTIES
      name: '',
      enabled: true,
      mapping: undefined,
      adaptOnce: false,
      adapted: false,
      mode: ['web'],
      consentCategory: 'performance',
      // METHODS
      enable: noop,
      disable: noop,
      validateEnabled: noop,
      init: noop,
      reset: noop,
      map,
      adapt: noop
    });
    store('Adapter', Adapter);

    /**
     * Adapter Class
     */
    function Adapter(config) {
      extend(this, config);
      augment(this);
      store(`Adapter:${this.name}`, this);
      if (BACKCOMPAT) {
        this.isOff = !this.enabled;
        this.turnOn = this.enable;
        this.turnOff = this.disable;
        this.adapter = this.adapt;
      }
      addAdapter(this);
      publish({
        topic: 'Adapter.constructor',
        adapter: this
      });
    }
    function enable() {
      this.enabled = true;
      if (BACKCOMPAT) {
        this.isOff = false;
      }
    }
    function disable() {
      this.enabled = false;
      if (BACKCOMPAT) {
        this.isOff = true;
      }
    }
    function isEnabled() {
      return this.enabled;
    }
    function hasAdapted() {
      return this.adapted;
    }
    function reset() {
      this[resetData.normalEnabledState[this.name] ? 'enable' : 'disable']();
      this.adapted = false;
    }
    function adapt() {
      this.adapted = true;
    }
    function noop() {}
    function pub(topic) {
      return function () {
        publish({
          topic: `Adapter:${this.name}.${topic}`,
          adapter: this,
          args: arguments
        });
      };
    }
    function storeResetData(adapter) {
      resetData.normalEnabledState[adapter.name] = adapter.enabled;
    }
    function augment(adapter) {
      storeResetData(adapter);
      adapter.reset = sequence(reset, adapter.reset, pub('reset'));
      adapter.enable = sequence(enable, adapter.enable, pub('enable'));
      adapter.disable = sequence(disable, adapter.disable, pub('disable'));
      adapter.adapt = sequence(adapter.adapt, adapt, pub('adapt'));
      if (adapter.adaptOnce) {
        adapter.adapt = conditional(not(hasAdapted), adapter.adapt);
      }
      if (adapter.trackElement) {
        adapter.trackElement = conditional(isEnabled, sequence(adapter.trackElement, pub('trackElement')));
      }
      adapter.init = conditional(isEnabled, sequence(adapter.init, pub('init')));
      consentAugment(adapter);
    }
    function sequence(...fns) {
      return function () {
        return fns.reduce((previousValue, fn) => {
          var result = previousValue === false ? false : fn.apply(this, arguments);
          return result === undefined ? previousValue : result;
        }, undefined);
      };
    }
    function conditional(conditionFn, fn) {
      return function () {
        if (conditionFn.apply(this, arguments)) {
          return fn.apply(this, arguments);
        }
      };
    }
    function not(conditionFn) {
      return function () {
        return !conditionFn.apply(this, arguments);
      };
    }
    function map(sam) {
      publish({
        topic: `Adapter:${this.name}.map`,
        adapter: this,
        sam
      });
      const mappedModel = resolve('productMap')(this, this.name, sam);
      publish({
        topic: `Adapter:${this.name}.aftermap`,
        adapter: this,
        sam,
        mappedModel
      });
      return mappedModel;
    }
  }, 'extend', 'store', 'resolve', 'publish', 'consentAugment', 'addAdapter');

  /* global inject */
  inject((Analytics, objForEach, Mustache, dbg, moment, store, isObject, extend, clone, objFirstProp, isEmptyObject, isNonEmptyObject, arrayGetUnique) => {
    Analytics.Parsers = store('Parsers', {
      isEmptyObject,
      isObject,
      isArray: Array.isArray,
      toBoolean: store('toBoolean', toBoolean),
      parseDotNotation,
      expandString,
      applyFilter,
      mergeObjects,
      parseSemanticModel: store('parseSemanticModel', parseSemanticModel)
    });
    const memory = {}; // input model values that can be used in later Mustache replacements

    // normalizes string vs boolean true values
    function toBoolean(val) {
      return val === true || val === 'true' || val === '1' || val === 1;
    }
    function parseDotNotation(parsed, address) {
      var value = address.split('.').reduce((node, prop) => {
        if (node) {
          return node[prop];
        }
      }, parsed);
      if (typeof value === 'function') {
        value = value();
      }
      return value;
    }

    // used to turn dot notation items into objects (example a.b.c=3 would become {a:{b:{c:3}}})
    function expandString(stringNotation, val) {
      var currentObj = {},
        finalObj = currentObj,
        keys,
        i,
        l;

      // blank notation fails
      if (!stringNotation) return false;
      keys = stringNotation.split('.').map(normalizeKey);
      l = keys.length - 1;

      // no dots fail
      if (l === 0) return false;

      // ok, lets parse some dots
      for (i = 0; i < l; i++) currentObj = currentObj[keys[i]] = {};
      currentObj[keys[l]] = val;
      return finalObj;
    }
    function formatDate(params, strDate) {
      if (!strDate) return;
      const inputFormat = [params.inputFormat || 'MM/DD/YYYY', 'YYYY-MM-DD'];
      const outputFormat = params.outputFormat || 'YYYY-MM-DD';
      return moment(strDate, inputFormat).format(outputFormat);
    }
    function remember(key, value) {
      if (key && value && typeof key === 'string' && typeof value === 'string' && value !== `{{${key}}}`) {
        if (key === 'site') {
          if (memory.site !== value) {
            memory.site = value;
            memory.lob = value.toLowerCase();
            memory.SITE = memory.LOB = value.toUpperCase();
            memory.Site = memory.Lob = memory.LOB[0] + memory.lob.slice(1);
          }
        } else {
          memory[key] = value;
        }
      }
    }
    function rememberObj(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          remember(prop, obj[prop]);
        }
      }
    }
    function applyFilter(applyTo, filters, result, mapping) {
      if (filters) {
        for (const [filter, params] of Object.entries(filters)) {
          switch (filter) {
            case 'type':
              switch (params) {
                case 'int':
                case 'integer':
                  applyTo = parseInt(applyTo, 10);
                  break;
                case 'float':
                  applyTo = parseFloat(applyTo).toFixed(2);
                  break;
                case 'number':
                  applyTo = Number(applyTo);
                  break;
                case 'string':
                  applyTo = String(applyTo);
                  break;
                case 'boolean':
                  applyTo = toBoolean(applyTo);
                  break;
              }
              break;
            case 'date':
              applyTo = formatDate(params, applyTo);
              break;
            case 'alpha':
              applyTo = sort(applyTo, params === 'desc');
              break;
            case 'case':
              applyTo = changeCase(applyTo, params);
              break;
            case 'length':
              applyTo = limitLength(applyTo, params);
              break;
            case 'arrlength':
              if (Array.isArray(applyTo)) {
                applyTo = applyTo.slice(0, params);
              } else if (typeof applyTo === 'string') {
                applyTo = applyTo.split(',').slice(0, params).join(',');
              }
              break;
            case 'replace':
              params.forEach(([pattern, replacement, flags = 'g']) => {
                applyTo = strReplace(applyTo, new RegExp(pattern, flags), replacement);
              });
              break;
            case 'unique':
              if (Array.isArray(applyTo)) {
                applyTo = arrayGetUnique(applyTo);
              } else if (typeof applyTo === 'string') {
                applyTo = arrayGetUnique(applyTo.split(params || ',')).join(params || ',');
              }
              break;
            case 'forceArray':
              if (isObject(applyTo)) {
                applyTo = Object.values(applyTo);
              }
              break;
            case 'decode':
              if (Array.isArray(applyTo)) {
                applyTo = applyTo.map(decodeURIComponent);
              } else if (typeof applyTo === 'string') {
                applyTo = decodeURIComponent(applyTo);
              }
              break;
            case 'removeElement':
              if (Array.isArray(applyTo) && isObject(params)) {
                let keys = params.keys || [params.key];
                let values = params.values || [params.value];
                applyTo = applyTo.filter(el => !keys.some((key, i) => {
                  return !el[key] && values[i] === '' || el[key] === values[i];
                }));
              }
              break;
            case 'list':
              applyTo = ((originalValue, possibleValues) => {
                for (let len = possibleValues.length, i = 0; i < len; i++) {
                  const testValue = possibleValues[i];
                  if (new RegExp('^\\s*' + testValue + '\\s*$', 'i').test(originalValue)) {
                    return testValue;
                  }
                }
                if (mapping && 'defaultValue' in mapping) {
                  return getValueFromFunction(mapping.defaultValue);
                }
              })(applyTo, arr(params));
              break;
            default:
              if (typeof params === 'function') {
                applyTo = params(applyTo, result, mapping);
              }
              break;
          }
        }
      }
      return applyTo;
    }
    function mergeObjects(target, source, properties, overrideTarget) {
      var i,
        l,
        prop,
        result = clone(target);
      if (Array.isArray(properties) && isObject(target) && isObject(source)) {
        l = properties.length;
        for (i = 0; i < l; i++) {
          prop = properties[i];
          if (source[prop]) {
            if (overrideTarget || !result[prop]) {
              result[prop] = source[prop];
            }
          }
        }
      }
      return result;
    }
    function templateObj(obj, configProp) {
      var o = Object.assign({}, obj || {});
      if (typeof o[configProp] === 'string' && o[configProp].includes(`{{${configProp}}}`)) delete o[configProp];
      return o;
    }
    function templateReplace({
      finalValue,
      configProp,
      result
    }) {
      var i = 0;
      if (typeof finalValue === 'string' && !configProp.includes('Template')) {
        while (i++ < 5 && finalValue.includes('{{')) {
          finalValue = Mustache.render(finalValue, Object.assign(templateObj(memory, configProp), templateObj(result.contextVars, configProp), templateObj(result, configProp)));
        }
      }
      return finalValue;
    }

    /* will return a value even if a function is used to derive that value */
    function getValueFromFunction(value, ...args) {
      return typeof value === 'function' ? value(...args) : value;
    }
    function normalizeFlexArrayInput({
      modelVal,
      mapping,
      result
    }) {
      const {
        preFilter,
        valueDelimiter,
        sourceDelimiter = ','
      } = mapping;
      if (typeof modelVal === 'string') modelVal = modelVal.split(sourceDelimiter);
      if (preFilter && Array.isArray(modelVal)) {
        modelVal = modelVal.map(str => {
          if (typeof str === 'string') {
            return applyFilter(str, preFilter, result, mapping);
          } else if (isObject(str)) {
            return Object.fromEntries(Object.entries(str).map(([key, value]) => [applyFilter(key, preFilter, result, mapping), value]));
          } else {
            return str;
          }
        });
      }
      if (!Array.isArray(modelVal)) {
        modelVal = [modelVal];
      }
      return modelVal.flatMap(item => {
        if (typeof item === 'number') {
          return {
            key: String(item)
          };
        } else if (typeof item === 'string') {
          /*
              input: 'def=2'
              output: {key: 'def', value: '2'}
          */
          let str = item.trim();
          if (!valueDelimiter) return {
            key: str
          };
          let [key, ...value] = str.split(valueDelimiter);
          key = key.trim();
          value = value.length > 0 ? value.join(valueDelimiter) : undefined;
          return {
            key,
            value
          };
        } else if (isObject(item)) {
          /*
              input: {ghi: 3, jkl: '4', mno: 24.5}
              output: [
                  {key: 'ghi', value: 3},
                  {key: 'jkl', value: '4'},
                  {key: 'mno', value: 24.5}
              ]
          */
          return Object.entries(item).map(([key, value]) => ({
            key,
            value
          }));
        } else {
          return [];
        }
      }).filter(({
        key
      }) => key);
    }
    function parseFlexArray({
      result,
      modelVal,
      parentResult,
      configProp,
      mapping,
      stack
    }) {
      if (!isValidModelValue(modelVal) && 'defaultValue' in mapping) {
        modelVal = getValueFromFunction(mapping.defaultValue, result, parentResult, {
          stack
        });
      }
      if (isValidModelValue(modelVal)) {
        /**
         * The flex-array mapping allows the following as lists
         * 1) comma separated string: "item1,item2=5,item3"
         * 2) arrays of strings. Example ["item1", "item2=5", "item3"]
         * 3) a combination of #2 and arrays of objecs when key values are needed.
         * Example: [{"item1":"value1"}, "item2", "Item3"]
         * delimiters are configurable to allow the input and output delimiters to vary
         */

        // get our delimiters if they are set in the mapping. Otherwise, the default
        // value ',' will be used
        const {
          targetDelimiter = ','
        } = mapping;

        // perform transformations if specified
        applyTransformers(mapping.transformers, result, parentResult, modelVal);
        const unmappedItems = normalizeFlexArrayInput({
          modelVal,
          mapping,
          result
        });
        if (unmappedItems.length > 0) {
          const flexValueMap = mapping.flexValueMap || mapping.mapTo;
          if (isObject(flexValueMap)) {
            let mappedItems = unmappedItems.flatMap(({
              key,
              value
            }) => {
              if (!isValidModelValue(value) && 'defaultElementValue' in mapping) {
                value = getValueFromFunction(mapping.defaultElementValue, result, parentResult, {
                  stack
                });
              }
              ({
                key,
                value
              } = eachTransformers(mapping.eachTransformers, {
                key,
                value
              }, {
                result,
                mapping,
                parentResult
              }));
              key = flexValueMap[key] ?? (mapping.flexValuePassthrough ? key : mapping.fallbackKey);
              return key ? {
                key,
                value
              } : [];
            });
            mappedItems = applyFilter(mappedItems, mapping.applyFilter, result, mapping);
            let finalValue = mappedItems.map(({
              key,
              value
            }) => `${key}${isValidToMap(value) ? `=${value}` : ''}`).join(targetDelimiter);
            finalValue = applyFilter(finalValue, mapping.postFilter, result, mapping);
            const tmpMapTo = typeof mapping.mapTo === 'string' ? mapping.mapTo : configProp;
            result = mapValues(finalValue, configProp, tmpMapTo, result, parentResult);
          } else {
            if (mapping.dataSourceMapTo) {
              const obj = Object.fromEntries(unmappedItems.filter(({
                value
              }) => isValidModelValue(value)).map(({
                key,
                value
              }) => [key, value]));
              if (isNonEmptyObject(obj)) {
                Object.assign(result[mapping.dataSourceMapTo] || (result[mapping.dataSourceMapTo] = {}), obj);
              }
            }
            let finalValue = unmappedItems.map(({
              key
            }) => key);
            if (mapping.eachFilter) finalValue = finalValue.map(v => applyFilter(v, mapping.eachFilter, result, mapping));
            finalValue = finalValue.join(targetDelimiter);
            if (mapping.valuePrefix) {
              finalValue = getValueFromFunction(mapping.valuePrefix, result, parentResult, {
                stack
              }) + finalValue;
            }
            finalValue = applyFilter(finalValue, mapping.applyFilter, result, mapping);
            finalValue = applyFilter(finalValue, mapping.postFilter, result, mapping);
            result = mapValues(finalValue, configProp, mapping.mapTo, result, parentResult);
          }
        } else {
          dbg.info(`${configProp} does not send data in the right format. It must be a string or array`);
        }
      }
      return result;
    }

    /*
     * function used to go through the mapping configuration as well as a semantic model recursively
     * to ultimately return a result that is fully mapped.
     *
     * since this function is fairly sophisticated, see framework.parsers.test.js for details of what it does
     * Params:
     * configProp - The property name in the product configuration
     * configVal - The value of the property name in the configuration
     * modelVal - The value of the property name in the model
     * result - As this function is recursivelly called, it is returning its results each step
     * parentResult - Used only in situations where an array configuarion is being parsed. It give the
     * array context to all other properties that were already mapped
     */
    function recursivelyMapProperties(configProp, configVal, modelVal, result, parentResult, stack = []) {
      var finalValue, mapping, i, l, prop, arrResult, configPropInArr, configValInArr, modelValInArr, resultInArray, retVal, tmpMapTo, foundRollUp, tpl;
      stack = [...stack, modelVal];
      remember(configProp, modelVal);

      // if we have an object that is not an array
      if (isObject(configVal)) {
        if (!configVal.mapping) {
          configVal.mapping = {
            type: 'none'
          };
        }
        applyFilter(modelVal, configVal.applyFilter);
        for (prop in configVal) {
          if (configVal.hasOwnProperty(prop)) {
            if (prop === 'mapping') {
              mapping = configVal.mapping;
              if (mapping.type === 'simple' || !mapping.type) {
                // perform transformations if specified
                applyTransformers(mapping.transformers, result, parentResult, modelVal);
                if (!isValidModelValue(modelVal)) {
                  if ('defaultValue' in mapping) {
                    finalValue = getValueFromFunction(mapping.defaultValue, result, parentResult, {
                      stack
                    });
                  }
                } else {
                  finalValue = modelVal;
                }
                finalValue = templateReplace({
                  finalValue,
                  configProp,
                  result
                });
                if (isValidModelValue(finalValue)) {
                  finalValue = applyFilter(finalValue, mapping.applyFilter, undefined, mapping);
                }
                finalValue = applyFilter(finalValue, mapping.postFilter, undefined, mapping);
                result = mapValues(finalValue, configProp, mapping.mapTo, result, parentResult, false);
              } else if (mapping.type === 'template' && mapping.template) {
                if (configProp && isValidModelValue(modelVal)) {
                  result[configProp] = modelVal;
                }

                // set defaults for template mappings
                if (configProp && 'defaultValue' in mapping && !isValidModelValue(modelVal)) {
                  result[configProp] = getValueFromFunction(mapping.defaultValue, result, parentResult, {
                    stack
                  });
                }

                // execute filters only on the value
                if (result && configProp && isValidModelValue(result[configProp])) {
                  result[configProp] = applyFilter(result[configProp], mapping.applyFilter, undefined, mapping);
                }

                // perform transformations if specified
                applyTransformers(mapping.transformers, result, parentResult, modelVal);
                tpl = typeof mapping.template === 'function' ? mapping.template(result, parentResult) : mapping.template;
                finalValue = Mustache.render(tpl, result);
                finalValue = applyFilter(finalValue, mapping.postFilter, undefined, mapping);
                result = mapValues(finalValue, configProp, mapping.mapTo, result, parentResult);
              } else if (mapping.type === 'flex-array' && mapping.mapTo) {
                result = parseFlexArray({
                  result,
                  modelVal,
                  parentResult,
                  configProp,
                  mapping,
                  stack
                });
              }
            } else if (prop !== 'applyFilter') {
              result = recursivelyMapProperties(prop, configVal[prop], modelVal && isValidModelValue(modelVal[prop]) ? modelVal[prop] : null, result, parentResult, stack);
              finalValue = undefined;
            }
          }
        }
      } else if (Array.isArray(configVal)) {
        configValInArr = configVal[0];
        mapping = configValInArr.mapping;
        modelVal = applyFilter(modelVal, mapping && mapping.applyFilter, undefined, mapping);
        if (Array.isArray(modelVal)) {
          arrResult = [];
          configPropInArr = null;
          foundRollUp = false;
          for (i = 0, l = modelVal.length; i < l; i++) {
            modelValInArr = modelVal[i];
            if (isNonEmptyObject(modelValInArr)) {
              resultInArray = {};
              if (mapping) {
                if (!mapping.rollUp) {
                  mapping.rollUp = false;
                }
                if (mapping.mapTo && mapping.rollUp === true && mapping.targetDelimiter) {
                  if (foundRollUp === false) {
                    foundRollUp = true;
                  }
                  tmpMapTo = mapping.mapTo;
                  retVal = recursivelyMapProperties(configPropInArr, configValInArr, modelValInArr, resultInArray, result, stack)[tmpMapTo];
                  if (!result[mapping.mapTo]) {
                    result[mapping.mapTo] = retVal;
                  } else {
                    result[mapping.mapTo] += mapping.targetDelimiter + retVal;
                  }
                } else {
                  arrResult.push(recursivelyMapProperties(configPropInArr, configValInArr, modelValInArr, resultInArray, result, stack));
                }
              } else {
                arrResult.push(recursivelyMapProperties(configPropInArr, configValInArr, modelValInArr, resultInArray, result, stack));
              }
            }
          }
          if (foundRollUp) {
            if (mapping.valuePrefix) {
              result[mapping.mapTo] = getValueFromFunction(mapping.valuePrefix, result, parentResult, {
                stack
              }) + result[mapping.mapTo];
            }
          } else {
            result[configProp] = arrResult;
          }
        }
      }
      return result;
    }
    function mapValues(modelVal, configProp, mapToConfig, result, parentResult, skipValidCheckWhenOverwritingResult = true) {
      var mapToString, i, mapTo, target, targetStr, dotNotationMapping;
      if (mapToConfig) {
        if (isValidToMap(modelVal)) {
          if (isObject(mapToConfig)) {
            mapToString = configProp;
            if (mapToConfig[modelVal.trim()]) {
              modelVal = mapToConfig[modelVal.trim()];
            }
          } else if (typeof mapToConfig === 'function') {
            mapToString = mapToConfig(result, parentResult, modelVal);
          } else {
            mapToString = mapToConfig;
          }
          if (mapToString) {
            mapTo = mapToString.split(',');
            for (i = 0; targetStr = mapTo[i]; i++) {
              if (targetStr.indexOf('^^') === 0) {
                targetStr = targetStr.slice(2);
                target = parentResult;
              } else {
                target = result;
              }
              /* check if we have a nested mapping notation. If so add the value within the structure
              ensure that is an existing structure is there, it is preserved */
              dotNotationMapping = expandString(targetStr, modelVal);
              if (dotNotationMapping) {
                extend(true, target, dotNotationMapping);
              } else {
                target[normalizeKey(targetStr)] = modelVal;
              }
            }
          }
        }
      } else if (configProp) {
        result[configProp] = modelVal;
      } else if (skipValidCheckWhenOverwritingResult || isValidModelValue(modelVal)) {
        result = modelVal;
      }
      return result;
    }
    function applyTransformers(transformers, result, parentResult, modelVal) {
      if (transformers) {
        for (const [key, transformer] of Object.entries(transformers)) {
          /* add a value to the result map with the name of the transformer
             as the key and the result of the transformer function as the value */
          if (typeof transformer === 'function') {
            const val = transformer(result, parentResult, modelVal);
            if (key !== 'preProcess' && isValidModelValue(val)) {
              result[key] = val;
            }
          }
        }
      }
    }
    function eachTransformers(transformers, {
      key,
      value
    }, ...args) {
      if (transformers) {
        for (const transformer of Object.values(transformers)) {
          if (typeof transformer === 'function') {
            ({
              key,
              value
            } = transformer({
              key,
              value
            }, ...args));
          }
        }
      }
      return {
        key,
        value
      };
    }

    // main parser method
    function parseSemanticModel(modelInput, config, limitToModel) {
      const model = clone(modelInput);
      let result = limitToModel ? model : {};
      rememberObj(model);
      for (const [prop, configVal] of Object.entries(config)) {
        let reprocessOnUpdate = configVal?.mapping?.reprocessOnUpdate;
        if (!limitToModel || isValidModelValue(model[prop]) || reprocessOnUpdate === true) {
          result = recursivelyMapProperties(prop, configVal, isValidModelValue(model[prop]) ? model[prop] : null, result);
        }
      }
      result = isEmptyObject(result) ? null : result;
      return result;
    }

    /* ------- Utility functions used within the parsers ------- */

    function normalizeKey(key) {
      return key.replace(/-dot-/g, '.');
    }
    function titleCase(str) {
      return typeof str === 'string' ? str.replace(/\b\w/g, match => match.toUpperCase()) : str;
    }
    function lowerCase(str) {
      return typeof str === 'string' ? str.toLowerCase() : str;
    }
    function upperCase(str) {
      return typeof str === 'string' ? str.toUpperCase() : str;
    }
    function changeCase(input, caseType) {
      const modifier = {
        upper: upperCase,
        title: titleCase
      }[caseType] || lowerCase;
      function itemCase(str, key, group) {
        group[key] = modifier(str);
      }
      if (Array.isArray(input)) {
        input.forEach(itemCase);
      } else if (isObject(input)) {
        objForEach(input, itemCase);
      } else {
        input = modifier(input);
      }
      return input;
    }
    function sort(val, desc = false) {
      const asString = typeof val === 'string';
      if (asString) val = val.split(',');
      if (Array.isArray(val)) {
        val.sort();
        if (desc) val.reverse();
      }
      return asString ? val.join(',') : val;
    }
    function limitLength(val, length) {
      function strLimit(str) {
        return typeof str === 'string' ? str.substring(0, length) : str;
      }
      function itemLimit(str, key, group) {
        group[key] = strLimit(str);
      }
      if (Array.isArray(val)) {
        val.forEach(itemLimit);
      } else if (isObject(val)) {
        objForEach(val, itemLimit);
      } else {
        val = strLimit(val);
      }
      return val;
    }
    function strReplace(val, toSearch, toReplace) {
      function replace(str) {
        return typeof str === 'string' ? str.replace(toSearch, toReplace) : str;
      }
      function itemReplace(str, key, group) {
        group[key] = replace(str);
      }
      if (Array.isArray(val)) {
        val.forEach(itemReplace);
      } else if (isObject(val)) {
        objForEach(val, itemReplace);
      } else {
        val = replace(val);
      }
      return val;
    }

    // acceptable values for model properties: no null, undefined, or NaN
    function isValidModelValue(val) {
      return val !== null && val !== undefined && val === val;
    }

    // unacceptable values to map: no null, undefined, NaN, or ''
    function isValidToMap(val) {
      return val !== '' && isValidModelValue(val);
    }
    function arr(val) {
      if (val && typeof val === 'string') val = val.split(',');
      return Array.isArray(val) ? val : [];
    }
  }, 'Analytics', 'objForEach', 'Mustache', 'Debug', 'moment', 'store', 'isObject', 'extend', 'clone', 'objFirstProp', 'isEmptyObject', 'isNonEmptyObject', 'arrayGetUnique');
  inject.store('AEPWebSDK', once(function () {
    /**
     * Copyright 2019 Adobe. All rights reserved.
     * This file is licensed to you under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License. You may obtain a copy
     * of the License at http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software distributed under
     * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
     * OF ANY KIND, either express or implied. See the License for the specific language
     * governing permissions and limitations under the License.
     */

    (function () {
      'use strict';

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createInstanceFunction = executeCommand => {
        return ([resolve, reject, [commandName, options]]) => {
          executeCommand(commandName, options).then(resolve, reject);
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns true when the value is null.
       * @param {*} value
       * @returns {boolean}
       */
      var isNil = value => value == null;

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns whether the value is an object.
       * @param {*} value
       * @returns {boolean}
       */
      var isObject = value => !isNil(value) && !Array.isArray(value) && typeof value === "object";

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var assignConcatArrayValues = (...values) => {
        if (values.length < 2) {
          // if the number of args is 0 or 1, just use the default behavior from Object.assign
          return Object.assign(...values);
        }
        return values.reduce((accumulator, currentValue) => {
          if (isObject(currentValue)) {
            Object.keys(currentValue).forEach(key => {
              if (Array.isArray(currentValue[key])) {
                if (Array.isArray(accumulator[key])) {
                  accumulator[key].push(...currentValue[key]);
                } else {
                  // clone the array so the original isn't modified.
                  accumulator[key] = [...currentValue[key]];
                }
              } else {
                accumulator[key] = currentValue[key];
              }
            });
          }
          return accumulator;
        }); // no default value to pass into reduce because we want to skip the first value
      };

      /*! js-cookie v3.0.5 | MIT */
      /* eslint-disable no-var */
      function assign(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            target[key] = source[key];
          }
        }
        return target;
      }
      /* eslint-enable no-var */

      /* eslint-disable no-var */
      var defaultConverter = {
        read: function (value) {
          if (value[0] === '"') {
            value = value.slice(1, -1);
          }
          return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function (value) {
          return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
      };
      /* eslint-enable no-var */

      /* eslint-disable no-var */

      function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
          if (typeof document === 'undefined') {
            return;
          }
          attributes = assign({}, defaultAttributes, attributes);
          if (typeof attributes.expires === 'number') {
            attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
          }
          if (attributes.expires) {
            attributes.expires = attributes.expires.toUTCString();
          }
          name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
          var stringifiedAttributes = '';
          for (var attributeName in attributes) {
            if (!attributes[attributeName]) {
              continue;
            }
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) {
              continue;
            }

            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
          }
          return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
          if (typeof document === 'undefined' || arguments.length && !name) {
            return;
          }

          // To prevent the for loop in the first place assign an empty array
          // in case there are no cookies at all.
          var cookies = document.cookie ? document.cookie.split('; ') : [];
          var jar = {};
          for (var i = 0; i < cookies.length; i++) {
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
              var found = decodeURIComponent(parts[0]);
              jar[found] = converter.read(value, found);
              if (name === found) {
                break;
              }
            } catch (e) {}
          }
          return name ? jar[name] : jar;
        }
        return Object.create({
          set,
          get,
          remove: function (name, attributes) {
            set(name, '', assign({}, attributes, {
              expires: -1
            }));
          },
          withAttributes: function (attributes) {
            return init(this.converter, assign({}, this.attributes, attributes));
          },
          withConverter: function (converter) {
            return init(assign({}, this.converter, converter), this.attributes);
          }
        }, {
          attributes: {
            value: Object.freeze(defaultAttributes)
          },
          converter: {
            value: Object.freeze(converter)
          }
        });
      }
      var api = init(defaultConverter, {
        path: '/'
      });

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var cookieJar = {
        get: api.get.bind(api),
        set: api.set.bind(api),
        remove: api.remove.bind(api),
        withConverter: api.withConverter.bind(api)
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const deepAssignObject = (target, source) => {
        Object.keys(source).forEach(key => {
          if (isObject(target[key]) && isObject(source[key])) {
            deepAssignObject(target[key], source[key]);
            return;
          }
          target[key] = source[key];
        });
      };

      /**
       * Recursively copy the values of all enumerable own properties from a source item to a target item if the both items are objects
       * @param {Object} target - a target object
       * @param {...Object} source - an array of source objects
       * @example
       * deepAssign({ a: 'a', b: 'b' }, { b: 'B', c: 'c' });
       * // { a: 'a', b: 'B', c: 'c' }
       */
      var deepAssign = (target, ...sources) => {
        if (isNil(target)) {
          throw new TypeError('deepAssign "target" cannot be null or undefined');
        }
        const result = Object(target);
        sources.forEach(source => deepAssignObject(result, Object(source)));
        return result;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Creates a function that, when passed an object of updates, will merge
       * the updates onto the current value of a payload property.
       * @param {Object} content The base object to modify
       * @param {String } key The property to merge updates into. This
       * can be a dot-notation property path.
       * @returns {Function}
       */
      var createMerger = (content, key) => updates => {
        const propertyPath = key.split(".");
        const hostObjectForUpdates = propertyPath.reduce((obj, propertyName) => {
          obj[propertyName] = obj[propertyName] || {};
          return obj[propertyName];
        }, content);
        deepAssign(hostObjectForUpdates, updates);
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Allows callbacks to be registered and then later called. When the
       * callbacks are called, their responses are combined into a single promise.
       */
      var createCallbackAggregator = () => {
        const callbacks = [];
        return {
          add(callback) {
            callbacks.push(callback);
          },
          call(...args) {
            // While this utility doesn't necessarily need to be doing the
            // Promise.all, it's currently useful everywhere this is used and
            // reduces repetitive code. We can factor it out later if we want
            // to make this utility more "pure".
            return Promise.all(callbacks.map(callback => callback(...args)));
          }
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createLoggingCookieJar = ({
        logger,
        cookieJar
      }) => {
        return {
          ...cookieJar,
          set(key, value, options) {
            logger.info("Setting cookie", {
              name: key,
              value,
              ...options
            });
            cookieJar.set(key, value, options);
          }
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Sequences tasks.
       */
      var createTaskQueue = () => {
        let queueLength = 0;
        let lastPromiseInQueue = Promise.resolve();
        return {
          /**
           * Add a task to the queue. If no task is currenty running,
           * the task will begin immediately.
           * @param {Function} task A function that will be called when
           * the task should be run. If the task it asynchronous, it should
           * return a promise.
           * @returns {Promise} A promise that will be resolved or rejected
           * with whatever value the task resolved or rejects its promise.
           */
          addTask(task) {
            queueLength += 1;
            const lastPromiseFulfilledHandler = () => {
              return task().finally(() => {
                queueLength -= 1;
              });
            };
            lastPromiseInQueue = lastPromiseInQueue.then(lastPromiseFulfilledHandler, lastPromiseFulfilledHandler);
            return lastPromiseInQueue;
          },
          /**
           * How many tasks are in the queue. This includes the task
           * that's currently running.
           * @returns {number}
           */
          get length() {
            return queueLength;
          }
        };
      };

      /* eslint-disable */

      /*
      crc32 Â· JavaScript Function to Calculate CRC32 of a String
      Description
        Below is a JavaScript function to calculate CRC32 of a string.
        The string can be either ASCII or Unicode.
        Unicode strings will be encoded in UTF-8.
        The polynomial used in calculation is 0xedb88320.
        This polynomial is used in Ethernet, Gzip, PNG, SATA and many other technologies.
      */
      const crc32 = (() => {
        const table = [];
        for (let i = 0; i < 256; i++) {
          let c = i;
          for (let j = 0; j < 8; j++) {
            c = c & 1 ? 0xedb88320 ^ c >>> 1 : c >>> 1;
          }
          table.push(c);
        }
        return function (str, crc) {
          str = unescape(encodeURIComponent(str));
          if (!crc) crc = 0;
          crc = crc ^ -1;
          for (let i = 0; i < str.length; i++) {
            const y = (crc ^ str.charCodeAt(i)) & 0xff;
            crc = crc >>> 8 ^ table[y];
          }
          crc = crc ^ -1;
          return crc >>> 0;
        };
      })();

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * A simple utility for managing a promise's state outside of
       * the promise's "executor" (the function passed into the constructor).
       */
      var defer = () => {
        const deferred = {};
        deferred.promise = new Promise((resolve, reject) => {
          deferred.resolve = resolve;
          deferred.reject = reject;
        });
        return deferred;
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const REFERENCE_EQUALITY = (a, b) => a === b;
      const findIndex = (array, item, isEqual) => {
        for (let i = 0; i < array.length; i += 1) {
          if (isEqual(array[i], item)) {
            return i;
          }
        }
        return -1;
      };
      var deduplicateArray = (array, isEqual = REFERENCE_EQUALITY) => {
        return array.filter((item, index) => findIndex(array, item, isEqual) === index);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var appendNode = (parent, node) => {
        return parent.appendChild(node);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const populateElementProperties = (element, props) => {
        Object.keys(props).forEach(key => {
          // The following is to support setting style properties to avoid CSP errors.
          if (key === "style" && isObject(props[key])) {
            const styleProps = props[key];
            Object.keys(styleProps).forEach(styleKey => {
              element.style[styleKey] = styleProps[styleKey];
            });
          } else {
            element[key] = props[key];
          }
        });
      };
      var createNode = (tag, attrs = {}, props = {}, children = [], doc = document) => {
        const result = doc.createElement(tag);
        Object.keys(attrs).forEach(key => {
          // TODO: To highlight CSP problems consider throwing a descriptive error
          //       if nonce is available and key is style.
          result.setAttribute(key, attrs[key]);
        });
        populateElementProperties(result, props);
        children.forEach(child => appendNode(result, child));
        return result;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const BODY = "BODY";
      const IFRAME = "IFRAME";
      const IMG = "IMG";
      const DIV = "DIV";
      const STYLE = "STYLE";
      const SCRIPT = "SCRIPT";
      const HEAD = "HEAD";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Fires an image pixel from the current document's window.
       * @param {object} currentDocument
       * @param {string} src
       * @returns {Promise}
       */
      var fireImageInDocument = ({
        src,
        currentDocument = document
      }) => {
        return new Promise((resolve, reject) => {
          const attrs = {
            src
          };
          const props = {
            onload: resolve,
            onerror: reject,
            onabort: reject
          };
          createNode(IMG, attrs, props, [], currentDocument);
        });
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns whether the value is a function.
       * @param {*} value
       * @returns {boolean}
       */
      var isFunction = value => typeof value === "function";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns whether the value is a non-empty array.
       * @param {*} value
       * @returns {boolean}
       */
      var isNonEmptyArray = value => Array.isArray(value) && value.length > 0;

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var toArray = value => {
        if (Array.isArray(value)) {
          return value;
        }
        if (value == null) {
          return [];
        }
        return [].slice.call(value);
      };

      /*
      Copyright 2021 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const SIBLING_PATTERN = /^\s*>/;
      var querySelectorAll = (context, selector) => {
        if (!SIBLING_PATTERN.test(selector)) {
          return toArray(context.querySelectorAll(selector));
        }
        return toArray(context.querySelectorAll(":scope " + selector));
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var SHADOW_SEPARATOR = ":shadow";

      /*
      Copyright 2021 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const splitWithShadow = selector => {
        return selector.split(SHADOW_SEPARATOR);
      };
      const transformPrefix = (parent, selector) => {
        const result = selector;
        const hasChildCombinatorPrefix = result.startsWith(">");
        if (!hasChildCombinatorPrefix) {
          return result;
        }
        const prefix = parent instanceof Element || parent instanceof Document ? ":scope" : ":host"; // see https://bugs.webkit.org/show_bug.cgi?id=233380

        return prefix + " " + result;
      };
      var selectNodesWithShadow = (context, selector) => {
        const parts = splitWithShadow(selector);
        if (parts.length < 2) {
          return querySelectorAll(context, selector);
        }

        // split the selector into parts separated by :shadow pseudo-selectors
        // find each subselector element based on the previously selected node's shadowRoot
        let parent = context;
        for (let i = 0; i < parts.length; i += 1) {
          const part = parts[i].trim();
          // if part is empty, it means there's a chained :eq:shadow selector
          if (part === "" && parent.shadowRoot) {
            parent = parent.shadowRoot;
            // eslint-disable-next-line no-continue
            continue;
          }
          const prefixed = transformPrefix(parent, part);
          const partNode = querySelectorAll(parent, prefixed);
          if (partNode.length === 0 || !partNode[0] || !partNode[0].shadowRoot) {
            return partNode;
          }
          parent = partNode[0].shadowRoot;
        }
        return undefined;
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var isShadowSelector = str => str.indexOf(SHADOW_SEPARATOR) !== -1;

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns an array of matched DOM nodes.
       * @param {String} selector
       * @param {Node} [context=document] defaults to document
       * @returns {Array} an array of DOM nodes
       */
      var selectNodes = (selector, context = document) => {
        if (!isShadowSelector(selector)) {
          return querySelectorAll(context, selector);
        }
        return selectNodesWithShadow(context, selector);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const MUTATION_OBSERVER = "MutationObserver";
      const RAF = "requestAnimationFrame";
      const MUTATION_OBSERVER_CONFIG = {
        childList: true,
        subtree: true
      };
      const VISIBILITY_STATE = "visibilityState";
      const VISIBLE = "visible";
      const DELAY = 100;
      const MAX_POLLING_TIMEOUT = 5000;
      const createError = selector => {
        return new Error("Could not find: " + selector);
      };
      const createPromise = executor => {
        return new Promise(executor);
      };
      const canUseMutationObserver = win => {
        return isFunction(win[MUTATION_OBSERVER]);
      };
      const awaitUsingMutationObserver = (win, doc, selector, timeout, selectFunc) => {
        return createPromise((resolve, reject) => {
          let timer;
          const mutationObserver = new win[MUTATION_OBSERVER](() => {
            const nodes = selectFunc(selector);
            if (isNonEmptyArray(nodes)) {
              mutationObserver.disconnect();
              if (timer) {
                clearTimeout(timer);
              }
              resolve(nodes);
            }
          });
          timer = setTimeout(() => {
            mutationObserver.disconnect();
            reject(createError(selector));
          }, timeout);
          mutationObserver.observe(doc, MUTATION_OBSERVER_CONFIG);
        });
      };
      const canUseRequestAnimationFrame = doc => {
        return doc[VISIBILITY_STATE] === VISIBLE;
      };
      const awaitUsingRequestAnimation = (win, selector, timeout, selectFunc) => {
        return createPromise((resolve, reject) => {
          const execute = () => {
            const nodes = selectFunc(selector);
            if (isNonEmptyArray(nodes)) {
              resolve(nodes);
              return;
            }
            win[RAF](execute);
          };
          execute();
          setTimeout(() => {
            reject(createError(selector));
          }, timeout);
        });
      };
      const awaitUsingTimer = (selector, timeout, selectFunc) => {
        return createPromise((resolve, reject) => {
          const execute = () => {
            const nodes = selectFunc(selector);
            if (isNonEmptyArray(nodes)) {
              resolve(nodes);
              return;
            }
            setTimeout(execute, DELAY);
          };
          execute();
          setTimeout(() => {
            reject(createError(selector));
          }, timeout);
        });
      };
      var awaitSelector = (selector, selectFunc = selectNodes, timeout = MAX_POLLING_TIMEOUT, win = window, doc = document) => {
        const nodes = selectFunc(selector);
        if (isNonEmptyArray(nodes)) {
          return Promise.resolve(nodes);
        }
        if (canUseMutationObserver(win)) {
          return awaitUsingMutationObserver(win, doc, selector, timeout, selectFunc);
        }
        if (canUseRequestAnimationFrame(doc)) {
          return awaitUsingRequestAnimation(win, selector, timeout, selectFunc);
        }
        return awaitUsingTimer(selector, timeout, selectFunc);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns true if element matches the selector.
       * @param {String} selector
       * @param {Node} [element]
       * @returns {Boolean}
       */
      var matchesSelector = (selector, element) => {
        if (element.matches) {
          return element.matches(selector);
        }

        // Making IE 11 happy
        return element.msMatchesSelector(selector);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var removeNode = node => {
        const parent = node.parentNode;
        if (parent) {
          return parent.removeChild(node);
        }
        return null;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const IFRAME_ATTRS = {
        name: "Adobe Alloy"
      };
      const IFRAME_PROPS = {
        style: {
          display: "none",
          width: 0,
          height: 0
        }
      };
      var injectFireReferrerHideableImage = ({
        appendNode: appendNode$1 = appendNode,
        awaitSelector: awaitSelector$1 = awaitSelector,
        createNode: createNode$1 = createNode,
        fireImage = fireImageInDocument
      } = {}) => {
        const fireOnPage = fireImage;
        let hiddenIframe;
        const createIframe = () => {
          return awaitSelector$1(BODY).then(([body]) => {
            if (hiddenIframe) {
              return hiddenIframe;
            }
            hiddenIframe = createNode$1(IFRAME, IFRAME_ATTRS, IFRAME_PROPS);
            return appendNode$1(body, hiddenIframe);
          });
        };
        const fireInIframe = ({
          src
        }) => {
          return createIframe().then(iframe => {
            const currentDocument = iframe.contentWindow.document;
            return fireImage({
              src,
              currentDocument
            });
          });
        };
        return request => {
          const {
            hideReferrer,
            url
          } = request;
          return hideReferrer ? fireInIframe({
            src: url
          }) : fireOnPage({
            src: url
          });
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns whether the value is an empty object.
       * @param {*} value
       * @returns {boolean}
       */
      var isEmptyObject = value => isObject(value) && Object.keys(value).length === 0;

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Given an object and a function that takes a value and returns a predicate, filter out
       * all non-object deeply nested values that do not pass the predicate.
       *
       * Example: filterObject({ a: 2, b: { c: 6 } }, (val) => val > 5) returns { b { c: 6 } }
       *
       * @param {*} obj
       * @param {* => boolean} predicate a function that takes a value and return a boolean,
       * representing if it should be included in the result object or not.
       * @returns A copy of the original object with the values that fail the predicate, filtered out.
       */
      const filterObject = (obj, predicate) => {
        if (isNil(obj) || !isObject(obj)) {
          return obj;
        }
        return Object.keys(obj).reduce((result, key) => {
          const value = obj[key];
          if (isObject(value)) {
            // value is object, go deeper
            const filteredValue = filterObject(value, predicate);
            if (isEmptyObject(filteredValue)) {
              return result;
            }
            return {
              ...result,
              [key]: filteredValue
            };
          }
          // value is not an object, test predicate
          if (predicate(value)) {
            return {
              ...result,
              [key]: value
            };
          }
          return result;
        }, {});
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var baseNamespace = "com.adobe.alloy.";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns the last N number of items from an array.
       * @param {Array} arr
       * @param {number} itemCount
       * @returns {Array}
       */
      var getLastArrayItems = (arr, itemCount) => arr.slice(-itemCount);

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const cookieName = baseNamespace + "getTld";

      /**
       * Of the current web page's hostname, this is the top-most domain that is
       * not a "public suffix" as outlined in https://publicsuffix.org/. In other
       * words, this is top-most domain that is able to accept cookies.
       * @param {Object} window
       * @param {Object} cookieJar
       * @returns {string}
       */
      var getApexDomain = (window, cookieJar) => {
        let topLevelCookieDomain = "";

        // If hostParts.length === 1, we may be on localhost.
        const hostParts = window.location.hostname.toLowerCase().split(".");
        let i = 1;
        while (i < hostParts.length && !cookieJar.get(cookieName)) {
          i += 1;
          topLevelCookieDomain = getLastArrayItems(hostParts, i).join(".");
          cookieJar.set(cookieName, cookieName, {
            domain: topLevelCookieDomain
          });
        }
        cookieJar.remove(cookieName, {
          domain: topLevelCookieDomain
        });
        return topLevelCookieDomain;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // Remember to also incorporate the org ID wherever cookies are read or written.
      var COOKIE_NAME_PREFIX = "kndctr";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var sanitizeOrgIdForCookieName = orgId => orgId.replace("@", "_");

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var getNamespacedCookieName = (orgId, key) => COOKIE_NAME_PREFIX + "_" + sanitizeOrgIdForCookieName(orgId) + "_" + key;

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Group an array by a key getter provided
       * @param {Array} arr Array to iterate over.
       * @param {Function} keyGetter The key getter by which to group.
       * @returns {Object}
       */
      var groupBy = (arr, keyGetter) => {
        const result = {};
        arr.forEach(item => {
          const key = keyGetter(item);
          if (!result[key]) {
            result[key] = [];
          }
          result[key].push(item);
        });
        return result;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const CHROME = "Chrome";
      const EDGE$1 = "Edge";
      const EDGE_CHROMIUM = "EdgeChromium";
      const FIREFOX = "Firefox";
      const IE = "IE";
      const SAFARI = "Safari";
      const UNKNOWN = "Unknown";

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var lazy = fn => {
        let called = false;
        let result;
        return () => {
          if (!called) {
            called = true;
            result = fn();
          }
          return result;
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // Users could have also disabled third-party cookies within these browsers, but
      // we don't know. We also assume "unknown" browsers support third-party cookies,
      // though we don't really know that either. We're making best guesses.
      const browsersSupportingThirdPartyCookie = [CHROME, EDGE$1, EDGE_CHROMIUM, IE, UNKNOWN];
      var injectAreThirdPartyCookiesSupportedByDefault = ({
        getBrowser
      }) => lazy(() => browsersSupportingThirdPartyCookie.includes(getBrowser()));

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const IDENTITY = "identity";
      const CONSENT = "consent";
      const CLUSTER = "cluster";

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectDoesIdentityCookieExist = ({
        orgId
      }) => {
        const identityCookieName = getNamespacedCookieName(orgId, IDENTITY);
        /**
         * Returns whether the identity cookie exists.
         */
        return () => Boolean(cookieJar.get(identityCookieName));
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const matchUserAgent = (regexs, userAgent) => {
        const keys = Object.keys(regexs);
        for (let i = 0; i < keys.length; i += 1) {
          const key = keys[i];
          const regex = regexs[key];
          if (regex.test(userAgent)) {
            return key;
          }
        }
        return UNKNOWN;
      };
      var injectGetBrowser = ({
        userAgent
      }) => {
        return lazy(() => matchUserAgent({
          /*
          The MIT License (MIT)
          Copyright (c) 2019 Damon Oehlman damon.oehlman@gmail.com
          Permission is hereby granted, free of charge, to any person obtaining a copy
          of this software and associated documentation files (the "Software"), to
          deal in the Software without restriction, including without limitation the
          rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
          sell copies of the Software, and to permit persons to whom the Software is
          furnished to do so, subject to the following conditions:
          The above copyright notice and this permission notice shall be included in
          all copies or substantial portions of the Software.
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
          FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
          DEALINGS IN THE SOFTWARE.
          */
          // Regular expression patterns were copied from
          // https://github.com/DamonOehlman/detect-browser
          // These are only the browsers that Alloy officially supports.
          /* eslint-disable */
          [EDGE$1]: /Edge\/([0-9\._]+)/,
          // Edge Chromium can dynamically change its user agent string based
          // on the host site:
          // https://winaero.com/blog/microsoft-edge-chromium-dynamically-changes-its-user-agent/
          [EDGE_CHROMIUM]: /Edg\/([0-9\.]+)/,
          [CHROME]: /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
          [FIREFOX]: /Firefox\/([0-9\.]+)(?:\s|$)/,
          // This only covers version 11 of IE, but that's all we support.
          [IE]: /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/,
          [SAFARI]: /Version\/([0-9\._]+).*Safari/
          /* eslint-enable */
        }, userAgent));
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const getStorageByType = (context, storageType, namespace) => {
        // When storage is disabled on Safari, the mere act of referencing
        // window.localStorage or window.sessionStorage throws an error.
        // For this reason, we wrap in a try-catch.
        return {
          /**
           * Reads a value from storage.
           * @param {string} name The name of the item to be read.
           * @returns {string}
           */
          getItem(name) {
            try {
              return context[storageType].getItem(namespace + name);
            } catch (e) {
              return null;
            }
          },
          /**
           * Saves a value to storage.
           * @param {string} name The name of the item to be saved.
           * @param {string} value The value of the item to be saved.
           * @returns {boolean} Whether the item was successfully saved to storage.
           */
          setItem(name, value) {
            try {
              context[storageType].setItem(namespace + name, value);
              return true;
            } catch (e) {
              return false;
            }
          },
          /**
           * Clear all values in storage that match the namespace.
           */
          clear() {
            try {
              Object.keys(context[storageType]).forEach(key => {
                if (key.startsWith(namespace)) {
                  context[storageType].removeItem(key);
                }
              });
              return true;
            } catch (e) {
              return false;
            }
          }
        };
      };
      var injectStorage = context => additionalNamespace => {
        const finalNamespace = baseNamespace + additionalNamespace;
        return {
          session: getStorageByType(context, "sessionStorage", finalNamespace),
          persistent: getStorageByType(context, "localStorage", finalNamespace)
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      /**
       * Returns items that are found within both arrays.
       * @param {Array} a
       * @param {Array} b
       * @returns {Array}
       */
      var intersection = (a, b) => a.filter(x => b.includes(x));

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns whether the value is a boolean.
       * @param {*} value
       * @returns {boolean}
       */
      var isBoolean = value => typeof value === "boolean";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns whether the value is a number.
       * @param {*} value
       * @returns {boolean}
       */
      var isNumber$1 = value => typeof value === "number" && !Number.isNaN(value);

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns whether the value is an integer.
       * @param {*} value
       * @returns {boolean}
       */
      var isInteger = value => {
        const parsed = parseInt(value, 10);
        return isNumber$1(parsed) && value === parsed;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Determines whether a cookie name is namespaced according to the contract
       * defined by the server.
       * @param {String} orgId The org ID configured for the Alloy instance.
       * @param {String} name The cookie name.
       * @returns {boolean}
       */
      var isNamespacedCookieName = (orgId, name) => name.indexOf(COOKIE_NAME_PREFIX + "_" + sanitizeOrgIdForCookieName(orgId) + "_") === 0;

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns whether the value is a string.
       * @param {*} value
       * @returns {boolean}
       */
      var isString = value => typeof value === "string";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns whether the value is a populated string.
       * @param {*} value
       * @returns {boolean}
       */
      var isNonEmptyString = value => isString(value) && value.length > 0;

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * A function that performs no operations.
       */
      var noop = () => {};
      function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
      }
      var src = (str, opts = {}) => {
        if (!str) return undefined;
        const o = {
          key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
          q: {
            name: 'queryKey',
            parser: /(?:^|&)([^&=]*)=?([^&]*)/g
          },
          parser: {
            strict: /^(?:([^:/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?))?((((?:[^?#/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
            loose: /^(?:(?![^:@]+:[^:@/]*@)([^:/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#/]*\.[^?#/.]+(?:[?#]|$)))*\/?)?([^?#/]*))(?:\?([^#]*))?(?:#(.*))?)/
          }
        };
        const m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str);
        const uri = {};
        let i = 14;
        while (i--) uri[o.key[i]] = m[i] || '';
        uri[o.q.name] = {};
        uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
          if ($1) uri[o.q.name][$1] = $2;
        });
        return uri;
      };
      var parseUri = /*@__PURE__*/getDefaultExportFromCjs(src);

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const parseDomainBasic = host => {
        const result = {};
        const domainParts = host.split(".");
        switch (domainParts.length) {
          case 1:
            result.subdomain = "";
            result.domain = host;
            result.topLevelDomain = "";
            break;
          case 2:
            result.subdomain = "";
            result.domain = host;
            result.topLevelDomain = domainParts[1];
            break;
          case 3:
            result.subdomain = domainParts[0] === "www" ? "" : domainParts[0];
            result.domain = host;
            result.topLevelDomain = domainParts[2];
            break;
          case 4:
            result.subdomain = domainParts[0] === "www" ? "" : domainParts[0];
            result.domain = host;
            result.topLevelDomain = domainParts[2] + "." + domainParts[3];
            break;
        }
        return result;
      };
      const parseUrl = (url, parseDomain = parseDomainBasic) => {
        if (!isString(url)) {
          // eslint-disable-next-line no-param-reassign
          url = "";
        }
        const parsed = parseUri(url) || {};
        const {
          host = "",
          path = "",
          query = "",
          anchor = ""
        } = parsed;
        return {
          path,
          query,
          fragment: anchor,
          ...parseDomain(host)
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // We want to avoid mapping between specific keys because we want Konductor
      // to be able to add overrides in the future without us needing to make
      // any changes to the Web SDK
      var prepareConfigOverridesForEdge = configuration => {
        if (isNil(configuration) || typeof configuration !== "object") {
          return null;
        }
        // remove entries that are empty strings or arrays
        const configOverrides = filterObject(configuration, value => {
          if (isNil(value)) {
            return false;
          }
          if (isBoolean(value)) {
            return true;
          }
          if (isNumber$1(value)) {
            return true;
          }
          if (isNonEmptyString(value)) {
            return true;
          }
          if (isNonEmptyArray(value)) {
            return true;
          }
          return false;
        });
        if (isEmptyObject(configOverrides)) {
          return null;
        }
        return configOverrides;
      };

      /***************************************************************************************
       * (c) 2017 Adobe. All rights reserved.
       * This file is licensed to you under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License. You may obtain a copy
       * of the License at http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software distributed under
       * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
       * OF ANY KIND, either express or implied. See the License for the specific language
       * governing permissions and limitations under the License.
       ****************************************************************************************/

      /**
       * Parse a query string into an object. Leading `?` or `#` are ignored, so you
       * can pass `location.search` or `location.hash` directly.
       *
       * URL components are decoded with decode-uri-component.
       *
       * Parse arrays with elements using duplicate keys, e.g. ?a=1&a=2 becomes
       * {a: ['1', '2']}.
       *
       * Query keys are sorted alphabetically.
       *
       * Numbers and booleans are NOT parsed; they are left as strings.
       * @param {string} query the query part of a url
       * @returns {{ [key: string]: string | string[] | undefined }} the parsed query string
       */
      var parseQueryString = function (query) {
        /** @type {{[key: string]: string | string[] | undefined }} */
        var result = {};
        if (!query || typeof query !== 'string') {
          return result;
        }
        var cleanQuery = query.trim().replace(/^[?#&]/, '');
        var params = new URLSearchParams(cleanQuery);
        var iter = params.keys();
        do {
          var v = iter.next();
          var key = v.value;
          if (key) {
            var values = params.getAll(key);
            if (values.length === 1) {
              result[key] = values[0];
            } else {
              result[key] = values;
            }
          }
        } while (v.done === false);
        return result;
      };

      /**
       * Transform an object into a query string.
       *
       * Keys having object values are ignored.
       *
       * @param {object} the object to transform into a query string
       * @returns {string} the parsed query string
       */

      var stringifyObject = function (object) {
        var spaceToken = '{{space}}';
        var params = new URLSearchParams();
        Object.keys(object).forEach(function (key) {
          var value = object[key];
          if (typeof object[key] === 'string') {
            value = value.replace(/ /g, spaceToken);
          } else if (['object', 'undefined'].includes(typeof value) && !Array.isArray(value)) {
            value = '';
          }
          if (Array.isArray(value)) {
            value.forEach(function (arrayValue) {
              params.append(key, arrayValue);
            });
          } else {
            params.append(key, value);
          }
        });
        return params.toString().replace(new RegExp(encodeURIComponent(spaceToken), 'g'), '%20');
      };

      // We proxy the underlying querystring module so we can limit the API we expose.
      // This allows us to more easily make changes to the underlying implementation later without
      // having to worry about breaking extensions. If extensions demand additional functionality, we
      // can make adjustments as needed.
      var reactorQueryString = {
        parse: function (string) {
          return parseQueryString(string);
        },
        stringify: function (object) {
          return stringifyObject(object);
        }
      };
      var queryString = /*@__PURE__*/getDefaultExportFromCjs(reactorQueryString);

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Creates and returns a new error using the provided value as a message.
       * If the provided value is already an Error, it will be returned unmodified.
       * @param {*} value
       * @returns {Error}
       */
      var toError = value => {
        return value instanceof Error ? value : new Error(value);
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var updateErrorMessage = ({
        error,
        message
      }) => {
        try {
          error.message = message;
        } catch (e) {
          // We'll set a new message when we can, but some errors, like DOMException,
          // have a read-only message property, which limits our options.
        }
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Augments an error's message with additional context as it bubbles up the call stack.
       * @param {String} message The message to be added to the error.
       * @param {*} error Optimally, this is an instance of Error. If it is not,
       * this is used as the basis for the message of a newly created Error instance.
       * @returns {*}
       */
      var stackError = ({
        error,
        message
      }) => {
        const errorToStack = toError(error);
        const newMessage = message + "\nCaused by: " + errorToStack.message;
        updateErrorMessage({
          error: errorToStack,
          message: newMessage
        });
        return errorToStack;
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var stringToBoolean = str => {
        return isString(str) && str.toLowerCase() === "true";
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /*
       * coerce `value` to a number or return `defaultValue` if it cannot be.
       *
       * The coersion is attempted if value is a number or string.
       */
      var toInteger = (value, defaultValue) => {
        if (isNumber$1(value) || isString(value)) {
          const n = Math.round(Number(value));
          if (!Number.isNaN(n)) {
            return n;
          }
        }
        return defaultValue;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Add padString to the start of the string until it reaches the target length
       *
       * Different from String.prototype.padStart because this function coerces the
       * input to a string before padding.
       * @param {any} string
       * @param {number} targetLength
       * @param {string} padString
       * @returns {string}
       */
      const padStart = (string, targetLength, padString) => {
        return ("" + string).padStart(targetLength, padString);
      };

      /**
       * Formats the date into an ISO date-time string in the local timezone
       * @param {Date} date
       * @returns {string}
       */
      var toISOStringLocal = date => {
        const YYYY = date.getFullYear();
        const MM = padStart(date.getMonth() + 1, 2, "0");
        const DD = padStart(date.getDate(), 2, "0");
        const hh = padStart(date.getHours(), 2, "0");
        const mm = padStart(date.getMinutes(), 2, "0");
        const ss = padStart(date.getSeconds(), 2, "0");
        const mmm = padStart(date.getMilliseconds(), 3, "0");

        // The time-zone offset is the difference, in minutes, from local time to UTC. Note that this
        // means that the offset is positive if the local timezone is behind UTC and negative if it is
        // ahead. For example, for time zone UTC+10:00, -600 will be returned.
        const timezoneOffset = toInteger(date.getTimezoneOffset(), 0);
        const ts = timezoneOffset > 0 ? "-" : "+";
        const th = padStart(Math.floor(Math.abs(timezoneOffset) / 60), 2, "0");
        const tm = padStart(Math.abs(timezoneOffset) % 60, 2, "0");
        return YYYY + "-" + MM + "-" + DD + "T" + hh + ":" + mm + ":" + ss + "." + mmm + ts + th + ":" + tm;
      };

      /**
       * Convert array of 16 byte values to UUID string format of the form:
       * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
       */
      var byteToHex = [];
      for (var i = 0; i < 256; ++i) {
        byteToHex.push((i + 0x100).toString(16).slice(1));
      }
      function unsafeStringify(arr, offset = 0) {
        // Note: Be careful editing this code!  It's been tuned for performance
        // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
        //
        // Note to future-self: No, you can't remove the `toLowerCase()` call.
        // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
        return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
      }

      // Unique ID creation requires a high quality random # generator. In the browser we therefore
      // require the crypto API and do not support built-in fallback to lower quality random number
      // generators (like Math.random()).

      var getRandomValues;
      var rnds8 = new Uint8Array(16);
      function rng() {
        // lazy load so that environments that need to polyfill have a chance to do so
        if (!getRandomValues) {
          // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
          getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
          if (!getRandomValues) {
            throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
          }
        }
        return getRandomValues(rnds8);
      }
      var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
      var native = {
        randomUUID
      };
      function v4(options, buf, offset) {
        if (native.randomUUID && !buf && !options) {
          return native.randomUUID();
        }
        options = options || {};
        var rnds = options.random || (options.rng || rng)();

        // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
        rnds[6] = rnds[6] & 0x0f | 0x40;
        rnds[8] = rnds[8] & 0x3f | 0x80;

        // Copy bytes to buffer, if provided
        if (buf) {
          offset = offset || 0;
          for (var i = 0; i < 16; ++i) {
            buf[offset + i] = rnds[i];
          }
          return buf;
        }
        return unsafeStringify(rnds);
      }

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Wraps a validator returning the value if it is null or undefined, otherwise
       * it will call the original validator and return the result.
       *
       * @param {function} validator - the validator to call if the value is not null
       */
      const skipIfNull = validator => function skipIfNullValidator(value, path) {
        return value == null ? value : validator.call(this, value, path);
      };

      /**
       * Returns a new validator that calls the first validator and then calls the second
       * validator with the result of the first validator. The result of the second validator
       * is returned.
       *
       * @param {function} firstValidator - validator to call first
       * @param {function} secondValidator - validator to call second
       * @returns {function} - a new validator that calls the first and second validators
       */
      const callSequentially = (firstValidator, secondValidator) => function callSequentiallyValidator(value, path) {
        return secondValidator.call(this, firstValidator.call(this, value, path), path);
      };

      /**
       * Just like callSequentially, but if either validator throws an error, the errors
       * are collected and thrown at the end.
       *
       * @param {function} firstValidator
       * @param {function} secondValidator
       * @returns {function}
       */
      const callSequentiallyJoinErrors = (firstValidator, secondValidator) => function callSequentiallyJoinErrorsValidator(value, path) {
        const errors = [];
        const newValue = [firstValidator, secondValidator].reduce((memo, validator) => {
          try {
            return validator.call(this, memo, path);
          } catch (e) {
            errors.push(e);
            return memo;
          }
        }, value);
        if (errors.length) {
          throw new Error(errors.join("\n"));
        }
        return newValue;
      };

      /**
       * Chains two validators together. In addition to calling the validators in
       * sequence, this will also copy over methods from the base validator to the
       * resulting validator and include any additional methods.
       *
       * @param {function} baseValidator - This validator will be called first, and its
       * methods will be copied over to the returned validator.
       * @param {function} newValidator - This validator will be called second.
       * @param {object} additionalMethods - Additional methods to include on the returned
       * validator.
       * @returns {function}
       */
      const chain = (baseValidator, newValidator, additionalMethods) => {
        return Object.assign(callSequentially(baseValidator, newValidator), baseValidator, additionalMethods);
      };

      /**
       * Chains two validators together, but skips the second validator if the value
       * is null. In addition to calling the validators in sequence, this will also
       * copy over methods from the base validator to the resulting validator and
       * include any additional methods.
       *
       * @param {function} baseValidator - This validator will be called first, and its
       * methods will be copied over to the returned validator.
       * @param {function} newValidator - This validator will be called second. If the value
       * is null after the first validator is called, this validator will not be
       * called.
       * @param {object} additionalMethods - Additional methods to include on the returned
       * validator.
       * @returns {function}
       */
      const nullSafeChain = (baseValidator, newValidator, additionalMethods) => {
        return Object.assign(callSequentially(baseValidator, skipIfNull(newValidator)), baseValidator, additionalMethods);
      };

      /**
       * Same as nullSafeChain, but calls the new validator first.
       *
       * @param {function} baseValidator - This validator will be called second, and its
       * methods will be copied over to the returned validator.
       * @param {function} newValidator - This validator will be called first. If the value
       * is null, this validator will not be called.
       * @param {function} additionalMethods - Additional methods to include on the returned
       * validator.
       * @returns {function}
       */
      const reverseNullSafeChainJoinErrors = (baseValidator, newValidator, additionalMethods) => {
        return Object.assign(callSequentiallyJoinErrors(skipIfNull(newValidator), baseValidator), baseValidator, additionalMethods);
      };

      /**
       * Throws an error if the value is not valid.
       *
       * @param {boolean} isValid - Whether or not the value is valid.
       * @param {*} value - The value to validate.
       * @param {string} path - The path to the value.
       * @param {string} message - The expected part of the error message.
       * @throws {Error} - Throws an error if the value is not valid.
       * @returns {void}
       */
      const assertValid = (isValid, value, path, message) => {
        if (!isValid) {
          throw new Error("'" + path + "': Expected " + message + ", but got " + JSON.stringify(value) + ".");
        }
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var booleanValidator = (value, path) => {
        assertValid(isBoolean(value), value, path, "true or false");
        return value;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var callbackValidator = (value, path) => {
        assertValid(isFunction(value), value, path, "a function");
        return value;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createAnyOfValidator = (validators, message) => function anyOf(value, path) {
        let newValue;
        const valid = validators.find(validator => {
          try {
            newValue = validator.call(this, value, path);
            return true;
          } catch (e) {
            return false;
          }
        });
        assertValid(valid, value, path, message);
        return newValue;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createArrayOfValidator = elementValidator => function arrayOf(value, path) {
        assertValid(Array.isArray(value), value, path, "an array");
        const errors = [];
        const validatedArray = value.map((subValue, i) => {
          try {
            return elementValidator.call(this, subValue, path + "[" + i + "]", value);
          } catch (e) {
            errors.push(e.message);
            return undefined;
          }
        });
        if (errors.length) {
          throw new Error(errors.join("\n"));
        }
        return validatedArray;
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createDefaultValidator = defaultValue => value => {
        if (value == null) {
          return defaultValue;
        }
        return value;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createDeprecatedValidator = (warning = "This field has been deprecated") => function deprecated(value, path) {
        let message = warning;
        if (value !== undefined) {
          if (path) {
            message = "'" + path + "': " + message;
          }
          if (this && this.logger) {
            this.logger.warn(message);
          }
        }
        return value;
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createLiteralValidator = literalValue => (value, path) => {
        assertValid(value === literalValue, value, path, "" + literalValue);
        return value;
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createMapOfValuesValidator = valueValidator => function mapOfValues(value, path) {
        assertValid(isObject(value), value, path, "an object");
        const errors = [];
        const validatedObject = {};
        Object.keys(value).forEach(subKey => {
          const subValue = value[subKey];
          const subPath = path ? path + "." + subKey : subKey;
          try {
            const validatedValue = valueValidator.call(this, subValue, subPath);
            if (validatedValue !== undefined) {
              validatedObject[subKey] = validatedValue;
            }
          } catch (e) {
            errors.push(e.message);
          }
        });
        if (errors.length) {
          throw new Error(errors.join("\n"));
        }
        return validatedObject;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createMinimumValidator = (typeName, minimum) => (value, path) => {
        assertValid(value >= minimum, value, path, typeName + " greater than or equal to " + minimum);
        return value;
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createMaximumValidator = (typeName, maximum) => (value, path) => {
        assertValid(value <= maximum, value, path, typeName + " less than or equal to " + maximum);
        return value;
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createNoUnknownFieldsValidator = schema => (value, path) => {
        const errors = [];
        Object.keys(value).forEach(subKey => {
          if (!schema[subKey]) {
            const subPath = path ? path + "." + subKey : subKey;
            errors.push("'" + subPath + "': Unknown field.");
          }
        });
        if (errors.length) {
          throw new Error(errors.join("\n"));
        }
        return value;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createNonEmptyValidator = message => (value, path) => {
        if (isObject(value)) {
          assertValid(!isEmptyObject(value), value, path, message);
        } else {
          assertValid(value.length > 0, value, path, message);
        }
        return value;
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createObjectOfValidator = schema => function objectOf(value, path) {
        assertValid(isObject(value), value, path, "an object");
        const errors = [];
        const validatedObject = {};
        Object.keys(schema).forEach(subKey => {
          const subValue = value[subKey];
          const subSchema = schema[subKey];
          const subPath = path ? path + "." + subKey : subKey;
          try {
            const validatedValue = subSchema.call(this, subValue, subPath);
            if (validatedValue !== undefined) {
              validatedObject[subKey] = validatedValue;
            }
          } catch (e) {
            errors.push(e.message);
          }
        });

        // copy over unknown properties
        Object.keys(value).forEach(subKey => {
          if (!Object.prototype.hasOwnProperty.call(validatedObject, subKey)) {
            validatedObject[subKey] = value[subKey];
          }
        });
        if (errors.length) {
          throw new Error(errors.join("\n"));
        }
        return validatedObject;
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createRenamedValidator = (oldField, oldSchema, newField) => function deprecated(value, path) {
        assertValid(isObject(value), value, path, "an object");
        const {
          [oldField]: oldValue,
          [newField]: newValue,
          ...otherValues
        } = value;
        const validatedOldValue = oldSchema(oldValue, path);
        if (validatedOldValue !== undefined) {
          let message = "The field '" + oldField + "' is deprecated. Use '" + newField + "' instead.";
          if (path) {
            message = "'" + path + "': " + message;
          }
          if (newValue !== undefined && newValue !== validatedOldValue) {
            throw new Error(message);
          } else if (this && this.logger) {
            this.logger.warn(message);
          }
        }
        return {
          [newField]: newValue || validatedOldValue,
          ...otherValues
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createUniqueValidator = () => {
        const values = [];
        return (value, path) => {
          assertValid(values.indexOf(value) === -1, value, path, "a unique value across instances");
          values.push(value);
          return value;
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      /**
       * Returns whether an array contains unique values.
       * @param {*} value
       * @returns {boolean}
       */
      var isUnique = values => {
        const storedVals = Object.create(null);
        for (let i = 0; i < values.length; i += 1) {
          const item = values[i];
          if (item in storedVals) {
            return false;
          }
          storedVals[item] = true;
        }
        return true;
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createUniqueItemsValidator = () => {
        return (value, path) => {
          assertValid(isUnique(value), value, path, "array values to be unique");
          return value;
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const DOMAIN_REGEX = /^[a-z0-9.-]{1,}$/i;
      var domainValidator = (value, path) => {
        assertValid(DOMAIN_REGEX.test(value), value, path, "a valid domain");
        return value;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var integerValidator = (value, path) => {
        assertValid(isInteger(value), value, path, "an integer");
        return value;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var numberValidator = (value, path) => {
        assertValid(isNumber$1(value), value, path, "a number");
        return value;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Determines whether the value is a valid regular expression.
       * @param {*} value
       * @returns {boolean}
       */
      var isValidRegExp = value => {
        try {
          return RegExp(value) !== null;
        } catch (e) {
          return false;
        }
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var regexpValidator = (value, path) => {
        assertValid(isValidRegExp(value), value, path, "a regular expression");
        return value;
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var requiredValidator = (value, path) => {
        if (value == null) {
          throw new Error("'" + path + "' is a required option");
        }
        return value;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var stringValidator = (value, path) => {
        assertValid(isString(value), value, path, "a string");
        return value;
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var matchesRegexpValidator = regexp => (value, path) => {
        assertValid(regexp.test(value), value, path, "does not match the " + regexp.toString());
        return value;
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // The base validator does no validation and just returns the value unchanged
      const base = value => value;

      // The 'default', 'required', and 'deprecated' methods are available after any
      // data-type method. Don't use the nullSafeChain on 'default' or 'required'
      // because they need to handle the null or undefined case
      base.default = function _default(defaultValue) {
        return chain(this, createDefaultValidator(defaultValue));
      };
      base.required = function required() {
        return chain(this, requiredValidator);
      };
      base.deprecated = function deprecated(message) {
        return chain(this, createDeprecatedValidator(message));
      };

      // helper validators
      const domain = function domain() {
        return nullSafeChain(this, domainValidator);
      };
      const minimumInteger = function minimumInteger(minValue) {
        return nullSafeChain(this, createMinimumValidator("an integer", minValue));
      };
      const minimumNumber = function minimumNumber(minValue) {
        return nullSafeChain(this, createMinimumValidator("a number", minValue));
      };
      const maximumNumber = function maximumNumber(maxValue) {
        return nullSafeChain(this, createMaximumValidator("a number", maxValue));
      };
      const integer = function integer() {
        return nullSafeChain(this, integerValidator, {
          minimum: minimumInteger
        });
      };
      const nonEmptyString = function nonEmptyString() {
        return nullSafeChain(this, createNonEmptyValidator("a non-empty string"));
      };
      const nonEmptyArray = function nonEmptyArray() {
        return nullSafeChain(this, createNonEmptyValidator("a non-empty array"));
      };
      const nonEmptyObject = function nonEmptyObject() {
        return nullSafeChain(this, createNonEmptyValidator("a non-empty object"));
      };
      const regexp = function regexp() {
        return nullSafeChain(this, regexpValidator);
      };
      const matches = function matches(regexpPattern) {
        return nullSafeChain(this, matchesRegexpValidator(regexpPattern));
      };
      const unique = function createUnique() {
        return nullSafeChain(this, createUniqueValidator());
      };
      const uniqueItems = function createUniqueItems() {
        return nullSafeChain(this, createUniqueItemsValidator());
      };

      // top-level validators.  These are the first functions that are called to create a validator.
      const anyOf = function anyOf(validators, message) {
        // use chain here because we don't want to accept null or undefined unless at least
        // one of the validators accept null or undefined.
        return chain(this, createAnyOfValidator(validators, message));
      };
      const anything = function anything() {
        return this;
      };
      const arrayOf = function arrayOf(elementValidator) {
        return nullSafeChain(this, createArrayOfValidator(elementValidator), {
          nonEmpty: nonEmptyArray,
          uniqueItems
        });
      };
      const boolean = function boolean() {
        return nullSafeChain(this, booleanValidator);
      };
      const callback = function callback() {
        return nullSafeChain(this, callbackValidator);
      };
      const literal = function literal(literalValue) {
        return nullSafeChain(this, createLiteralValidator(literalValue));
      };
      const number = function number() {
        return nullSafeChain(this, numberValidator, {
          minimum: minimumNumber,
          maximum: maximumNumber,
          integer,
          unique
        });
      };
      const mapOfValues = function mapOfValues(valuesValidator) {
        return nullSafeChain(this, createMapOfValuesValidator(valuesValidator), {
          nonEmpty: nonEmptyObject
        });
      };
      const createObjectOfAdditionalProperties = schema => ({
        noUnknownFields: function noUnknownFields() {
          return nullSafeChain(this, createNoUnknownFieldsValidator(schema));
        },
        nonEmpty: nonEmptyObject,
        concat: function concat(otherObjectOfValidator) {
          // combine the schema so that noUnknownFields, and concat have the combined schema
          const newSchema = {
            ...schema,
            ...otherObjectOfValidator.schema
          };
          return nullSafeChain(this, otherObjectOfValidator, createObjectOfAdditionalProperties(newSchema));
        },
        renamed: function renamed(oldField, oldSchema, newField) {
          // Run the deprecated validator first so that the deprecated field is removed
          // before the objectOf validator runs.
          return reverseNullSafeChainJoinErrors(this, createRenamedValidator(oldField, oldSchema, newField));
        },
        schema
      });
      const objectOf = function objectOf(schema) {
        return nullSafeChain(this, createObjectOfValidator(schema), createObjectOfAdditionalProperties(schema));
      };
      const string = function string() {
        return nullSafeChain(this, stringValidator, {
          regexp,
          domain,
          nonEmpty: nonEmptyString,
          unique,
          matches
        });
      };
      const boundAnyOf = anyOf.bind(base);
      const boundAnything = anything.bind(base);
      const boundArrayOf = arrayOf.bind(base);
      const boundBoolean = boolean.bind(base);
      const boundCallback = callback.bind(base);
      const boundLiteral = literal.bind(base);
      const boundNumber = number.bind(base);
      const boundMapOfValues = mapOfValues.bind(base);
      const boundObjectOf = objectOf.bind(base);
      const boundString = string.bind(base);

      // compound validators
      const boundEnumOf = function boundEnumOf(...values) {
        return boundAnyOf(values.map(boundLiteral), "one of these values: " + JSON.stringify(values));
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const AMBIGUOUS = "ambiguous";
      const AUTHENTICATED = "authenticated";
      const LOGGED_OUT = "loggedOut";

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var validateIdentityMap = boundMapOfValues(boundArrayOf(boundObjectOf({
        authenticatedState: boundEnumOf(AMBIGUOUS, AUTHENTICATED, LOGGED_OUT),
        id: boundString(),
        namespace: boundObjectOf({
          code: boundString()
        }).noUnknownFields(),
        primary: boundBoolean(),
        xid: boundString()
      }).noUnknownFields()).required());

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var validateConfigOverride = boundObjectOf({});

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var debugQueryParam = "alloy_debug";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createLogController = ({
        console,
        locationSearch,
        createLogger,
        instanceName,
        createNamespacedStorage,
        getMonitors
      }) => {
        const parsedQueryString = queryString.parse(locationSearch);
        const storage = createNamespacedStorage("instance." + instanceName + ".");
        const debugSessionValue = storage.session.getItem("debug");
        let debugEnabled = debugSessionValue === "true";
        let debugEnabledWritableFromConfig = debugSessionValue === null;
        const getDebugEnabled = () => debugEnabled;
        const setDebugEnabled = (value, {
          fromConfig
        }) => {
          if (!fromConfig || debugEnabledWritableFromConfig) {
            debugEnabled = value;
          }
          if (!fromConfig) {
            // Web storage only allows strings, so we explicitly convert to string.
            storage.session.setItem("debug", value.toString());
            debugEnabledWritableFromConfig = false;
          }
        };
        if (parsedQueryString[debugQueryParam] !== undefined) {
          setDebugEnabled(stringToBoolean(parsedQueryString[debugQueryParam]), {
            fromConfig: false
          });
        }
        return {
          setDebugEnabled,
          logger: createLogger({
            getDebugEnabled,
            context: {
              instanceName
            },
            getMonitors,
            console
          }),
          createComponentLogger(componentName) {
            return createLogger({
              getDebugEnabled,
              context: {
                instanceName,
                componentName
              },
              getMonitors,
              console
            });
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // TO-DOCUMENT: Lifecycle hooks and their params.
      const hookNames = [
      // Called after all components have been registered.
      "onComponentsRegistered",
      // Called before an event is sent on a data collection request
      "onBeforeEvent",
      // Called before each request is made to the edge.
      "onBeforeRequest",
      // Called after each response is returned from the edge with a successful
      // status code
      "onResponse",
      // Called after a network request to the edge fails. Either the request
      // didn't make it to the edge, didn't make it to Konductor, or Konductor
      // failed to return a regularly-structured response. (In this case { error }
      // is passed as the parameter)
      // Also called when the respone returns a 400 or 500 error. (In this case
      // { response } is passed as the parameter)
      "onRequestFailure",
      // A user clicked on an element.
      "onClick",
      // Called by DecisioningEngine when a ruleset is satisfied with a list of
      // propositions
      "onDecision"];
      const createHook = (componentRegistry, hookName) => {
        return (...args) => {
          return Promise.all(componentRegistry.getLifecycleCallbacks(hookName).map(callback => {
            return new Promise(resolve => {
              resolve(callback(...args));
            });
          }));
        };
      };

      /**
       * This ensures that if a component's lifecycle method X
       * attempts to execute lifecycle method Y, that all X methods on all components
       * will have been called before any of their Y methods are called. It does
       * this by kicking the call to the Y method to the next JavaScript tick.
       * @returns {function}
       */
      const guardHook = fn => {
        return (...args) => {
          return Promise.resolve().then(() => {
            return fn(...args);
          });
        };
      };
      var createLifecycle = componentRegistry => {
        return hookNames.reduce((memo, hookName) => {
          memo[hookName] = guardHook(createHook(componentRegistry, hookName));
          return memo;
        }, {});
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const wrapForErrorHandling = (fn, stackMessage) => {
        return (...args) => {
          let result;
          try {
            result = fn(...args);
          } catch (error) {
            throw stackError({
              error,
              message: stackMessage
            });
          }
          if (result instanceof Promise) {
            result = result.catch(error => {
              throw stackError({
                error,
                message: stackMessage
              });
            });
          }
          return result;
        };
      };

      // TO-DOCUMENT: All public commands and their signatures.
      var createComponentRegistry = () => {
        const componentsByNamespace = {};
        const commandsByName = {};
        const lifecycleCallbacksByName = {};
        const registerComponentCommands = (namespace, componentCommandsByName = {}) => {
          const conflictingCommandNames = intersection(Object.keys(commandsByName), Object.keys(componentCommandsByName));
          if (conflictingCommandNames.length) {
            throw new Error("[ComponentRegistry] Could not register " + namespace + " " + ("because it has existing command(s): " + conflictingCommandNames.join(",")));
          }
          Object.keys(componentCommandsByName).forEach(commandName => {
            const command = componentCommandsByName[commandName];
            command.commandName = commandName;
            command.run = wrapForErrorHandling(command.run, "[" + namespace + "] An error occurred while executing the " + commandName + " command.");
            commandsByName[commandName] = command;
          });
        };
        const registerLifecycleCallbacks = (namespace, componentLifecycleCallbacksByName = {}) => {
          Object.keys(componentLifecycleCallbacksByName).forEach(hookName => {
            lifecycleCallbacksByName[hookName] = lifecycleCallbacksByName[hookName] || [];
            lifecycleCallbacksByName[hookName].push(wrapForErrorHandling(componentLifecycleCallbacksByName[hookName], "[" + namespace + "] An error occurred while executing the " + hookName + " lifecycle hook."));
          });
        };
        return {
          register(namespace, component) {
            const {
              commands,
              lifecycle
            } = component;
            registerComponentCommands(namespace, commands);
            registerLifecycleCallbacks(namespace, lifecycle);
            componentsByNamespace[namespace] = component;
          },
          getCommand(commandName) {
            return commandsByName[commandName];
          },
          getCommandNames() {
            return Object.keys(commandsByName);
          },
          getLifecycleCallbacks(hookName) {
            return lifecycleCallbacksByName[hookName] || [];
          },
          getComponentNames() {
            return Object.keys(componentsByNamespace);
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectSendNetworkRequest = ({
        logger,
        sendFetchRequest,
        sendBeaconRequest,
        isRequestRetryable,
        getRequestRetryDelay
      }) => {
        /**
         * Send a network request and returns details about the response.
         */
        return ({
          requestId,
          url,
          payload,
          useSendBeacon
        }) => {
          // We want to log raw payload and event data rather than
          // our fancy wrapper objects. Calling payload.toJSON() is
          // insufficient to get all the nested raw data, because it's
          // not recursive (it doesn't call toJSON() on the event objects).
          // Parsing the result of JSON.stringify(), however, gives the
          // fully recursive raw data.
          const stringifiedPayload = JSON.stringify(payload);
          const parsedPayload = JSON.parse(stringifiedPayload);
          logger.logOnBeforeNetworkRequest({
            url,
            requestId,
            payload: parsedPayload
          });
          const executeRequest = (retriesAttempted = 0) => {
            const requestMethod = useSendBeacon ? sendBeaconRequest : sendFetchRequest;
            return requestMethod(url, stringifiedPayload).then(response => {
              const requestIsRetryable = isRequestRetryable({
                response,
                retriesAttempted
              });
              if (requestIsRetryable) {
                const requestRetryDelay = getRequestRetryDelay({
                  response,
                  retriesAttempted
                });
                return new Promise(resolve => {
                  setTimeout(() => {
                    resolve(executeRequest(retriesAttempted + 1));
                  }, requestRetryDelay);
                });
              }
              let parsedBody;
              try {
                parsedBody = JSON.parse(response.body);
              } catch (e) {
                // Non-JSON. Something went wrong.
              }
              logger.logOnNetworkResponse({
                requestId,
                url,
                payload: parsedPayload,
                ...response,
                parsedBody,
                retriesAttempted
              });
              return {
                statusCode: response.statusCode,
                body: response.body,
                parsedBody,
                getHeader: response.getHeader
              };
            });
          };
          return executeRequest().catch(error => {
            logger.logOnNetworkError({
              requestId,
              url,
              payload: parsedPayload,
              error
            });
            throw stackError({
              error,
              message: "Network request failed."
            });
          });
        };
      };

      /*
      Copyright 2021 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectExtractEdgeInfo = ({
        logger
      }) => adobeEdgeHeader => {
        if (adobeEdgeHeader) {
          const headerParts = adobeEdgeHeader.split(";");
          if (headerParts.length >= 2 && headerParts[1].length > 0) {
            try {
              const regionId = parseInt(headerParts[1], 10);
              if (!Number.isNaN(regionId)) {
                return {
                  regionId
                };
              }
            } catch (e) {
              // No need to do anything. The log statement below will log an error
            }
          }
          logger.warn("Invalid adobe edge: \"" + adobeEdgeHeader + "\"");
        }
        return {};
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const IN = "in";
      const OUT = "out";
      const PENDING = "pending";

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const GENERAL = "general";

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const DECLINED_CONSENT_ERROR_CODE = "declinedConsent";
      const CONSENT_SOURCE_DEFAULT = "default";
      const CONSENT_SOURCE_INITIAL = "initial";
      const CONSENT_SOURCE_NEW = "new";
      const createDeclinedConsentError = errorMessage => {
        const error = new Error(errorMessage);
        error.code = DECLINED_CONSENT_ERROR_CODE;
        error.message = errorMessage;
        return error;
      };
      var createConsentStateMachine = ({
        logger
      }) => {
        const deferreds = [];
        const runAll = () => {
          while (deferreds.length) {
            deferreds.shift().resolve();
          }
        };
        const discardAll = () => {
          while (deferreds.length) {
            deferreds.shift().reject(createDeclinedConsentError("The user declined consent."));
          }
        };
        const awaitInitial = () => Promise.reject(new Error("Consent has not been initialized."));
        const awaitInDefault = () => Promise.resolve();
        const awaitIn = () => Promise.resolve();
        const awaitOutDefault = () => Promise.reject(createDeclinedConsentError("No consent preferences have been set."));
        const awaitOut = () => Promise.reject(createDeclinedConsentError("The user declined consent."));
        const awaitPending = returnImmediately => {
          if (returnImmediately) {
            return Promise.reject(new Error("Consent is pending."));
          }
          const deferred = defer();
          deferreds.push(deferred);
          return deferred.promise;
        };
        return {
          in(source) {
            if (source === CONSENT_SOURCE_DEFAULT) {
              this.awaitConsent = awaitInDefault;
            } else {
              if (source === CONSENT_SOURCE_INITIAL) {
                logger.info("Loaded user consent preferences. The user previously consented.");
              } else if (source === CONSENT_SOURCE_NEW && this.awaitConsent !== awaitIn) {
                logger.info("User consented.");
              }
              runAll();
              this.awaitConsent = awaitIn;
            }
          },
          out(source) {
            if (source === CONSENT_SOURCE_DEFAULT) {
              logger.warn("User consent preferences not found. Default consent of out will be used.");
              this.awaitConsent = awaitOutDefault;
            } else {
              if (source === CONSENT_SOURCE_INITIAL) {
                logger.warn("Loaded user consent preferences. The user previously declined consent.");
              } else if (source === CONSENT_SOURCE_NEW && this.awaitConsent !== awaitOut) {
                logger.warn("User declined consent.");
              }
              discardAll();
              this.awaitConsent = awaitOut;
            }
          },
          pending(source) {
            if (source === CONSENT_SOURCE_DEFAULT) {
              logger.info("User consent preferences not found. Default consent of pending will be used. Some commands may be delayed.");
            }
            this.awaitConsent = awaitPending;
          },
          awaitConsent: awaitInitial,
          withConsent() {
            return this.awaitConsent(true);
          },
          current() {
            switch (this.awaitConsent) {
              case awaitInDefault:
                return {
                  state: "in",
                  wasSet: false
                };
              case awaitIn:
                return {
                  state: "in",
                  wasSet: true
                };
              case awaitOutDefault:
                return {
                  state: "out",
                  wasSet: false
                };
              case awaitOut:
                return {
                  state: "out",
                  wasSet: true
                };
              case awaitPending:
                return {
                  state: "pending",
                  wasSet: false
                };
              default:
                return {
                  state: "in",
                  wasSet: false
                };
            }
          }
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createConsent = ({
        generalConsentState,
        logger
      }) => {
        const setConsent = (consentByPurpose, source) => {
          switch (consentByPurpose[GENERAL]) {
            case IN:
              generalConsentState.in(source);
              break;
            case OUT:
              generalConsentState.out(source);
              break;
            case PENDING:
              generalConsentState.pending(source);
              break;
            default:
              logger.warn("Unknown consent value: " + consentByPurpose[GENERAL]);
              break;
          }
        };
        return {
          initializeConsent(defaultConsentByPurpose, storedConsentByPurpose) {
            if (storedConsentByPurpose[GENERAL]) {
              setConsent(storedConsentByPurpose, CONSENT_SOURCE_INITIAL);
            } else {
              setConsent(defaultConsentByPurpose, CONSENT_SOURCE_DEFAULT);
            }
          },
          setConsent(consentByPurpose) {
            setConsent(consentByPurpose, CONSENT_SOURCE_NEW);
          },
          suspend() {
            generalConsentState.pending();
          },
          awaitConsent() {
            return generalConsentState.awaitConsent();
          },
          withConsent() {
            return generalConsentState.withConsent();
          },
          current() {
            return generalConsentState.current();
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const getXdmPropositions = xdm => {
        return xdm &&
        // eslint-disable-next-line no-underscore-dangle
        xdm._experience &&
        // eslint-disable-next-line no-underscore-dangle
        xdm._experience.decisioning &&
        // eslint-disable-next-line no-underscore-dangle
        isNonEmptyArray(xdm._experience.decisioning.propositions) ?
        // eslint-disable-next-line no-underscore-dangle
        xdm._experience.decisioning.propositions : [];
      };
      var createEvent = () => {
        const content = {};
        let userXdm;
        let userData;
        let documentMayUnload = false;
        let isFinalized = false;
        let shouldSendEvent = true;
        const throwIfEventFinalized = methodName => {
          if (isFinalized) {
            throw new Error(methodName + " cannot be called after event is finalized.");
          }
        };
        const event = {
          hasQuery() {
            return Object.prototype.hasOwnProperty.call(this.getContent(), "query");
          },
          getContent() {
            const currentContent = JSON.parse(JSON.stringify(content));
            if (userXdm) {
              deepAssign(currentContent, {
                xdm: userXdm
              });
            }
            if (userData) {
              deepAssign(currentContent, {
                data: userData
              });
            }
            return currentContent;
          },
          setUserXdm(value) {
            throwIfEventFinalized("setUserXdm");
            userXdm = value;
          },
          setUserData(value) {
            throwIfEventFinalized("setUserData");
            userData = value;
          },
          mergeXdm(xdm) {
            throwIfEventFinalized("mergeXdm");
            if (xdm) {
              deepAssign(content, {
                xdm
              });
            }
          },
          mergeData(data) {
            throwIfEventFinalized("mergeData");
            if (data) {
              deepAssign(content, {
                data
              });
            }
          },
          mergeMeta(meta) {
            throwIfEventFinalized("mergeMeta");
            if (meta) {
              deepAssign(content, {
                meta
              });
            }
          },
          mergeQuery(query) {
            throwIfEventFinalized("mergeQuery");
            if (query) {
              deepAssign(content, {
                query
              });
            }
          },
          documentMayUnload() {
            documentMayUnload = true;
          },
          finalize(onBeforeEventSend) {
            if (isFinalized) {
              return;
            }
            const newPropositions = deduplicateArray([...getXdmPropositions(userXdm), ...getXdmPropositions(content.xdm)], (a, b) => a === b || a.id && b.id && a.id === b.id && a.scope && b.scope && a.scope === b.scope);
            if (userXdm) {
              this.mergeXdm(userXdm);
            }
            if (newPropositions.length > 0) {
              // eslint-disable-next-line no-underscore-dangle
              content.xdm._experience.decisioning.propositions = newPropositions;
            }
            if (userData) {
              event.mergeData(userData);
            }

            // the event should already be considered finalized in case onBeforeEventSend throws an error
            isFinalized = true;
            if (onBeforeEventSend) {
              // assume that the onBeforeEventSend callback will fail (in-case of an error)
              shouldSendEvent = false;

              // this allows the user to replace the xdm and data properties
              // on the object passed to the callback
              const tempContent = {
                xdm: content.xdm || {},
                data: content.data || {}
              };
              const result = onBeforeEventSend(tempContent);
              shouldSendEvent = result !== false;
              content.xdm = tempContent.xdm || {};
              content.data = tempContent.data || {};
              if (isEmptyObject(content.xdm)) {
                delete content.xdm;
              }
              if (isEmptyObject(content.data)) {
                delete content.data;
              }
            }
          },
          getDocumentMayUnload() {
            return documentMayUnload;
          },
          isEmpty() {
            return isEmptyObject(content) && (!userXdm || isEmptyObject(userXdm)) && (!userData || isEmptyObject(userData));
          },
          shouldSend() {
            return shouldSendEvent;
          },
          getViewName() {
            if (!userXdm || !userXdm.web || !userXdm.web.webPageDetails) {
              return undefined;
            }
            return userXdm.web.webPageDetails.viewName;
          },
          toJSON() {
            if (!isFinalized) {
              throw new Error("toJSON called before finalize");
            }
            return content;
          }
        };
        return event;
      };

      /*
      Copyright 2021 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const RETRY_AFTER = "Retry-After";
      const ADOBE_EDGE = "x-adobe-edge";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Creates a representation of a gateway response with the addition of
       * helper methods.
       * @returns Response
       */
      var injectCreateResponse = ({
        extractEdgeInfo
      }) => ({
        content = {},
        getHeader
      }) => {
        const {
          handle = [],
          errors = [],
          warnings = []
        } = content;

        /**
         * Response object.
         * @typedef {Object} Response
         */
        return {
          /**
           * Returns matching fragments of the response by type.
           * @param {String} type A string with the current format: <namespace:action>
           *
           * @example
           * getPayloadsByType("identity:persist")
           */
          getPayloadsByType(type) {
            return handle.filter(fragment => fragment.type === type).flatMap(fragment => fragment.payload);
          },
          /**
           * Returns all errors.
           */
          getErrors() {
            return errors;
          },
          /**
           * Returns all warnings.
           */
          getWarnings() {
            return warnings;
          },
          /**
           * Returns an object containing the regionId from the x-adobe-edge header
           */
          getEdge() {
            return extractEdgeInfo(getHeader(ADOBE_EDGE));
          },
          toJSON() {
            return content;
          }
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const CONFIGURE = "configure";
      const SET_DEBUG = "setDebug";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectExecuteCommand = ({
        logger,
        configureCommand,
        setDebugCommand,
        handleError,
        validateCommandOptions
      }) => {
        let configurePromise;
        const getExecutor = (commandName, options) => {
          let executor;
          if (commandName === CONFIGURE) {
            if (configurePromise) {
              throw new Error("The library has already been configured and may only be configured once.");
            }
            executor = () => {
              configurePromise = configureCommand(options);
              return configurePromise.then(() => {
                // Don't expose internals to the user.
              });
            };
          } else {
            if (!configurePromise) {
              throw new Error("The library must be configured first. Please do so by executing the configure command.");
            }
            if (commandName === SET_DEBUG) {
              executor = () => setDebugCommand(options);
            } else {
              executor = () => {
                return configurePromise.then(componentRegistry => {
                  const command = componentRegistry.getCommand(commandName);
                  if (!command || !isFunction(command.run)) {
                    const commandNames = [CONFIGURE, SET_DEBUG].concat(componentRegistry.getCommandNames()).join(", ");
                    throw new Error("The " + commandName + " command does not exist. List of available commands: " + commandNames + ".");
                  }
                  const validatedOptions = validateCommandOptions({
                    command,
                    options
                  });
                  return command.run(validatedOptions);
                }, () => {
                  logger.warn("An error during configuration is preventing the " + commandName + " command from executing.");
                  // If configuration failed, we prevent the configuration
                  // error from bubbling here because we don't want the
                  // configuration error to be reported in the console every
                  // time any command is executed. Only having it bubble
                  // once when the configure command runs is sufficient.
                  // Instead, for this command, we'll just return a promise
                  // that never gets resolved.
                  return new Promise(() => {});
                });
              };
            }
          }
          return executor;
        };
        return (commandName, options = {}) => {
          return new Promise(resolve => {
            // We have to wrap the getExecutor() call in the promise so the promise
            // will be rejected if getExecutor() throws errors.
            const executor = getExecutor(commandName, options);
            logger.logOnBeforeCommand({
              commandName,
              options
            });
            resolve(executor());
          }).catch(error => {
            return handleError(error, commandName + " command");
          }).catch(error => {
            logger.logOnCommandRejected({
              commandName,
              options,
              error
            });
            throw error;
          }).then(rawResult => {
            // We should always be returning an object from every command.
            const result = isObject(rawResult) ? rawResult : {};
            logger.logOnCommandResolved({
              commandName,
              options,
              result
            });
            return result;
          });
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const COMMAND_DOC_URI = "https://adobe.ly/3sHgQHb";
      var validateCommandOptions = ({
        command,
        options
      }) => {
        const {
          commandName,
          documentationUri = COMMAND_DOC_URI,
          optionsValidator
        } = command;
        let validatedOptions = options;
        if (optionsValidator) {
          try {
            validatedOptions = optionsValidator(options);
          } catch (validationError) {
            const invalidOptionsMessage = "Invalid " + commandName + " command options:\n\t - " + validationError + " For command documentation see: " + documentationUri;
            throw new Error(invalidOptionsMessage);
          }
        }
        return validatedOptions;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const CONFIG_DOC_URI = "https://adobe.ly/3sHh553";
      const transformOptions = ({
        combinedConfigValidator,
        options,
        logger
      }) => {
        try {
          const validator = combinedConfigValidator.noUnknownFields().required();
          return validator.call({
            logger
          }, options);
        } catch (e) {
          throw new Error("Resolve these configuration problems:\n\t - " + e.message.split("\n").join("\n\t - ") + "\nFor configuration documentation see: " + CONFIG_DOC_URI);
        }
      };
      const buildAllOnInstanceConfiguredExtraParams = (config, logger, componentCreators) => {
        return componentCreators.reduce((memo, {
          buildOnInstanceConfiguredExtraParams
        }) => {
          if (buildOnInstanceConfiguredExtraParams) {
            memo = {
              ...memo,
              ...buildOnInstanceConfiguredExtraParams({
                config,
                logger
              })
            };
          }
          return memo;
        }, {});
      };
      const wrapLoggerInQueue = logger => {
        const queue = [];
        const queuedLogger = {
          get enabled() {
            return logger.enabled;
          },
          flush() {
            queue.forEach(({
              method,
              args
            }) => logger[method](...args));
          }
        };
        Object.keys(logger).filter(key => typeof logger[key] === "function").forEach(method => {
          queuedLogger[method] = (...args) => {
            queue.push({
              method,
              args
            });
          };
        });
        return queuedLogger;
      };
      var buildAndValidateConfig = ({
        options,
        componentCreators,
        coreConfigValidators,
        createConfig,
        logger,
        setDebugEnabled
      }) => {
        // We wrap the logger in a queue in case debugEnabled is set in the config
        // but we need to log something before the config is created.
        const queuedLogger = wrapLoggerInQueue(logger);
        const combinedConfigValidator = componentCreators.map(({
          configValidators
        }) => configValidators).filter(configValidators => configValidators).reduce((validator, configValidators) => validator.concat(configValidators), coreConfigValidators);
        const config = createConfig(transformOptions({
          combinedConfigValidator,
          options,
          logger: queuedLogger
        }));
        setDebugEnabled(config.debugEnabled, {
          fromConfig: true
        });
        queuedLogger.flush();
        // eslint-disable-next-line no-underscore-dangle
        const extraParams = buildAllOnInstanceConfiguredExtraParams(config, logger, componentCreators);
        logger.logOnInstanceConfigured({
          ...extraParams,
          config
        });
        return config;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var initializeComponents = ({
        componentCreators,
        lifecycle,
        componentRegistry,
        getImmediatelyAvailableTools
      }) => {
        componentCreators.forEach(createComponent => {
          const {
            namespace
          } = createComponent;
          // TO-DOCUMENT: Helpers that we inject into factories.
          const tools = getImmediatelyAvailableTools(namespace);
          let component;
          try {
            component = createComponent(tools);
          } catch (error) {
            throw stackError({
              error,
              message: "[" + namespace + "] An error occurred during component creation."
            });
          }
          componentRegistry.register(namespace, component);
        });
        return lifecycle.onComponentsRegistered({
          lifecycle
        }).then(() => componentRegistry);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createConfig = options => {
        return {
          ...options
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const EDGE = "edge.adobedc.net";
      const ID_THIRD_PARTY = "adobedc.demdex.net";

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var EDGE_BASE_PATH = "ee";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createCoreConfigs = () => boundObjectOf({
        debugEnabled: boundBoolean().default(false),
        defaultConsent: boundEnumOf(IN, OUT, PENDING).default(IN),
        datastreamId: boundString().unique().required(),
        edgeDomain: boundString().domain().default(EDGE),
        edgeBasePath: boundString().nonEmpty().default(EDGE_BASE_PATH),
        orgId: boundString().unique().required(),
        onBeforeEventSend: boundCallback().default(noop),
        edgeConfigOverrides: validateConfigOverride
      }).renamed("edgeConfigId", boundString().unique(), "datastreamId");

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectHandleError = ({
        errorPrefix,
        logger
      }) => (error, operation) => {
        const err = toError(error);

        // In the case of declined consent, we've opted to not reject the promise
        // returned to the customer, but instead resolve the promise with an
        // empty result object.
        if (err.code === DECLINED_CONSENT_ERROR_CODE) {
          logger.warn("The " + operation + " could not fully complete. " + err.message);
          return {};
        }
        updateErrorMessage({
          error: err,
          message: errorPrefix + " " + err.message
        });
        throw err;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectSendFetchRequest = ({
        fetch
      }) => {
        return (url, body) => {
          return fetch(url, {
            method: "POST",
            cache: "no-cache",
            credentials: "include",
            // To set the cookie header in the request.
            headers: {
              "Content-Type": "text/plain; charset=UTF-8"
            },
            referrerPolicy: "no-referrer-when-downgrade",
            body
          }).then(response => {
            return response.text().then(responseBody => ({
              statusCode: response.status,
              // We expose headers through a function instead of creating an object
              // with all the headers up front largely because the native
              // request.getResponseHeader method is case-insensitive.
              getHeader(name) {
                return response.headers.get(name);
              },
              body: responseBody
            }));
          });
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectSendBeaconRequest = ({
        sendBeacon,
        sendFetchRequest,
        logger
      }) => {
        return (url, body) => {
          const blob = new Blob([body], {
            type: "text/plain; charset=UTF-8"
          });
          if (!sendBeacon(url, blob)) {
            logger.info("Unable to use `sendBeacon`; falling back to `fetch`.");
            return sendFetchRequest(url, body);
          }

          // Using sendBeacon, we technically don't get a response back from
          // the server, but we'll resolve the promise with an object to maintain
          // consistency with other network strategies.
          return Promise.resolve({
            statusCode: 204,
            getHeader() {
              return null;
            },
            body: ""
          });
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createLogger = ({
        getDebugEnabled,
        console,
        getMonitors,
        context
      }) => {
        let prefix = "[" + context.instanceName + "]";
        if (context.componentName) {
          prefix += " [" + context.componentName + "]";
        }
        const notifyMonitors = (method, data) => {
          const monitors = getMonitors();
          if (monitors.length > 0) {
            const dataWithContext = {
              ...context,
              ...data
            };
            monitors.forEach(monitor => {
              if (monitor[method]) {
                monitor[method](dataWithContext);
              }
            });
          }
        };
        const log = (level, ...rest) => {
          notifyMonitors("onBeforeLog", {
            level,
            arguments: rest
          });
          if (getDebugEnabled()) {
            console[level](prefix, ...rest);
          }
        };
        return {
          get enabled() {
            return getMonitors().length > 0 || getDebugEnabled();
          },
          logOnInstanceCreated(data) {
            notifyMonitors("onInstanceCreated", data);
            log("info", "Instance initialized.");
          },
          logOnInstanceConfigured(data) {
            notifyMonitors("onInstanceConfigured", data);
            log("info", "Instance configured. Computed configuration:", data.config);
          },
          logOnBeforeCommand(data) {
            notifyMonitors("onBeforeCommand", data);
            log("info", "Executing " + data.commandName + " command. Options:", data.options);
          },
          logOnCommandResolved(data) {
            notifyMonitors("onCommandResolved", data);
            log("info", data.commandName + " command resolved. Result:", data.result);
          },
          logOnCommandRejected(data) {
            notifyMonitors("onCommandRejected", data);
            log("error", data.commandName + " command was rejected. Error:", data.error);
          },
          logOnBeforeNetworkRequest(data) {
            notifyMonitors("onBeforeNetworkRequest", data);
            log("info", "Request " + data.requestId + ": Sending request.", data.payload);
          },
          logOnNetworkResponse(data) {
            notifyMonitors("onNetworkResponse", data);
            const messagesSuffix = data.parsedBody || data.body ? "response body:" : "no response body.";
            log("info", "Request " + data.requestId + ": Received response with status code " + data.statusCode + " and " + messagesSuffix, data.parsedBody || data.body);
          },
          logOnNetworkError(data) {
            notifyMonitors("onNetworkError", data);
            log("error", "Request " + data.requestId + ": Network request failed.", data.error);
          },
          logOnContentHiding(data) {
            notifyMonitors("onContentHiding", {
              status: data.status
            });
            log(data.logLevel, data.message);
          },
          logOnContentRendering(data) {
            notifyMonitors("onContentRendering", {
              status: data.status,
              payload: data.detail
            });
            log(data.logLevel, data.message);
          },
          /**
           * Outputs informational message to the web console. In some
           * browsers a small "i" icon is displayed next to these items
           * in the web console's log.
           * @param {...*} arg Any argument to be logged.
           */
          info: log.bind(null, "info"),
          /**
           * Outputs a warning message to the web console.
           * @param {...*} arg Any argument to be logged.
           */
          warn: log.bind(null, "warn"),
          /**
           * Outputs an error message to the web console.
           * @param {...*} arg Any argument to be logged.
           */
          error: log.bind(null, "error")
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var PAGE_WIDE_SCOPE = "__view__";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createAddIdentity = content => {
        return (namespaceCode, identity) => {
          content.xdm = content.xdm || {};
          content.xdm.identityMap = content.xdm.identityMap || {};
          content.xdm.identityMap[namespaceCode] = content.xdm.identityMap[namespaceCode] || [];
          content.xdm.identityMap[namespaceCode].push(identity);
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // This provides the base functionality that all types of requests share.
      var createRequest = options => {
        const {
          payload,
          getAction,
          getUseSendBeacon,
          datastreamIdOverride,
          edgeSubPath
        } = options;
        const id = v4();
        let shouldUseThirdPartyDomain = false;
        let isIdentityEstablished = false;
        return {
          getId() {
            return id;
          },
          getPayload() {
            return payload;
          },
          getAction() {
            return getAction({
              isIdentityEstablished
            });
          },
          getDatastreamIdOverride() {
            return datastreamIdOverride;
          },
          getUseSendBeacon() {
            return getUseSendBeacon({
              isIdentityEstablished
            });
          },
          getEdgeSubPath() {
            if (edgeSubPath) {
              return edgeSubPath;
            }
            return "";
          },
          getUseIdThirdPartyDomain() {
            return shouldUseThirdPartyDomain;
          },
          setUseIdThirdPartyDomain() {
            shouldUseThirdPartyDomain = true;
          },
          setIsIdentityEstablished() {
            isIdentityEstablished = true;
          }
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createDataCollectionRequest = ({
        payload: dataCollectionRequestPayload,
        datastreamIdOverride
      }) => {
        const getUseSendBeacon = ({
          isIdentityEstablished
        }) => {
          // When the document may be unloading, we still hit the interact endpoint
          // using fetch if an identity has not been established. If we were instead
          // to hit the collect endpoint using sendBeacon in this case, one of three
          // things would occur:
          //
          // 1. The document ultimately isn't unloaded and Alloy receives an empty
          // response back from the collect endpoint, resulting in an error being
          // thrown by Alloy because we weren't able to establish an identity.
          // This is bad.
          // 2. The document is unloaded, but Alloy receives the empty
          // response back from the collect endpoint before navigation is completed,
          // resulting in an error being thrown by Alloy because we weren't able to
          // establish an identity. This is bad.
          // 3. The document is unloaded and Alloy does not receive the empty response
          // back from the collect endpoint before navigation is completed. No error
          // will be thrown, but no identity was established either. This is okay,
          // though no identity was established.
          //
          // By hitting the interact endpoint using fetch, one of the three things
          // would occur:
          //
          // 1. The document ultimately isn't unloaded and Alloy receives a
          // response with an identity back from the interact endpoint. No
          // error will be thrown and an identity is established. This is good.
          // 2. The document is unloaded and Alloy receives a response with an
          // identity back from the interact endpoint before navigation is completed.
          // No error will be thrown and an identity is established. This is good.
          // 3. The document is unloaded and Alloy does not receive the empty response
          // back from the collect endpoint before navigation is completed. In this
          // case, no error is thrown, but no identity was established and it's
          // more likely that the request never makes it to the server because we're
          // using fetch instead of sendBeacon.
          //
          // The second approach seemed preferable.
          return dataCollectionRequestPayload.getDocumentMayUnload() && isIdentityEstablished;
        };
        return createRequest({
          payload: dataCollectionRequestPayload,
          getAction({
            isIdentityEstablished
          }) {
            return getUseSendBeacon({
              isIdentityEstablished
            }) ? "collect" : "interact";
          },
          getUseSendBeacon,
          datastreamIdOverride
        });
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // This provides the base functionality that all types of
      // request payloads share.
      var createRequestPayload = options => {
        const {
          content,
          addIdentity,
          hasIdentity
        } = options;
        const mergeConfigOverride = createMerger(content, "meta.configOverrides");
        return {
          mergeMeta: createMerger(content, "meta"),
          mergeState: createMerger(content, "meta.state"),
          mergeQuery: createMerger(content, "query"),
          mergeConfigOverride: updates => mergeConfigOverride(prepareConfigOverridesForEdge(updates)),
          addIdentity,
          hasIdentity,
          toJSON() {
            return content;
          }
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createHasIdentity = content => namespaceCode => {
        return (content.xdm && content.xdm.identityMap && content.xdm.identityMap[namespaceCode]) !== undefined;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createDataCollectionRequestPayload = () => {
        const content = {};
        const payload = createRequestPayload({
          content,
          addIdentity: createAddIdentity(content),
          hasIdentity: createHasIdentity(content)
        });
        payload.addEvent = event => {
          content.events = content.events || [];
          content.events.push(event);
        };
        payload.getDocumentMayUnload = () => {
          return (content.events || []).some(event => event.getDocumentMayUnload());
        };
        return payload;
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      /**
       * @typedef {{ datastreamId: string, [k: string]: Object }} Override
       * @typedef {Object} RequestPayload
       * @property {function(Override): void} mergeConfigOverride
       * @param {Object} params
       * @param {Override} params.localConfigOverrides
       * @param {Override} params.globalConfigOverrides
       * @param {RequestPayload} params.payload
       * @returns {{ payload: RequestPayload, datastreamIdOverride: string }}
       */
      var createRequestParams = ({
        localConfigOverrides,
        globalConfigOverrides,
        payload
      }) => {
        const requestParams = {
          payload
        };
        const {
          datastreamId,
          ...localConfigOverridesWithoutDatastreamId
        } = localConfigOverrides || {};
        if (datastreamId) {
          requestParams.datastreamIdOverride = datastreamId;
        }
        payload.mergeConfigOverride(globalConfigOverrides);
        payload.mergeConfigOverride(localConfigOverridesWithoutDatastreamId);
        return requestParams;
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const ASSURANCE_VALIDATION_SESSION_URL_PARAM = "adb_validation_sessionid";
      const ASSURANCE_VALIDATION_NAMESPACE = "validation.";
      const CLIENT_ID = "clientId";
      const getOrCreateAssuranceClientId = storage => {
        let clientId = storage.persistent.getItem(CLIENT_ID);
        if (!clientId) {
          clientId = v4();
          storage.persistent.setItem(CLIENT_ID, clientId);
        }
        return clientId;
      };
      var createGetAssuranceValidationTokenParams = ({
        window,
        createNamespacedStorage
      }) => {
        const storage = createNamespacedStorage(ASSURANCE_VALIDATION_NAMESPACE);
        return () => {
          const parsedQuery = queryString.parse(window.location.search);
          const validationSessionId = parsedQuery[ASSURANCE_VALIDATION_SESSION_URL_PARAM];
          if (!validationSessionId) {
            return "";
          }
          const clientId = getOrCreateAssuranceClientId(storage);
          const validationToken = validationSessionId + "|" + clientId;
          return "&" + queryString.stringify({
            adobeAepValidationToken: validationToken
          });
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const EVENT_CANCELLATION_MESSAGE = "Event was canceled because the onBeforeEventSend callback returned false.";
      var createEventManager = ({
        config,
        logger,
        lifecycle,
        consent,
        createEvent,
        createDataCollectionRequestPayload,
        createDataCollectionRequest,
        sendEdgeNetworkRequest,
        applyResponse
      }) => {
        const {
          onBeforeEventSend,
          edgeConfigOverrides: globalConfigOverrides
        } = config;
        return {
          createEvent,
          /**
           * Sends an event. This includes running the event and payload through the
           * appropriate lifecycle hooks, sending the request to the server, and
           * handling the response.
           * @param {Object} event This will be JSON stringified and used inside the
           * request payload.
           * @param {Object} [options] Options to pass on to the onBeforeEvent
           * lifecycle method
           * @param {Object} [options.edgeConfigOverrides] Settings that take
           * precedence over the global datastream configuration, including which
           * datastream to use.
           * @returns {*}
           */
          sendEvent(event, options = {}) {
            const {
              edgeConfigOverrides: localConfigOverrides,
              ...otherOptions
            } = options;
            const requestParams = createRequestParams({
              payload: createDataCollectionRequestPayload(),
              localConfigOverrides,
              globalConfigOverrides
            });
            const request = createDataCollectionRequest(requestParams);
            const onResponseCallbackAggregator = createCallbackAggregator();
            const onRequestFailureCallbackAggregator = createCallbackAggregator();
            return lifecycle.onBeforeEvent({
              ...otherOptions,
              event,
              onResponse: onResponseCallbackAggregator.add,
              onRequestFailure: onRequestFailureCallbackAggregator.add
            }).then(() => {
              requestParams.payload.addEvent(event);
              return consent.awaitConsent();
            }).then(() => {
              try {
                // NOTE: this calls onBeforeEventSend callback (if configured)
                event.finalize(onBeforeEventSend);
              } catch (error) {
                const throwError = () => {
                  throw error;
                };
                onRequestFailureCallbackAggregator.add(lifecycle.onRequestFailure);
                return onRequestFailureCallbackAggregator.call({
                  error
                }).then(throwError, throwError);
              }

              // if the callback returns false, the event should not be sent
              if (!event.shouldSend()) {
                onRequestFailureCallbackAggregator.add(lifecycle.onRequestFailure);
                logger.info(EVENT_CANCELLATION_MESSAGE);
                const error = new Error(EVENT_CANCELLATION_MESSAGE);
                return onRequestFailureCallbackAggregator.call({
                  error
                }).then(() => {
                  // Ensure the promise gets resolved with undefined instead
                  // of an array of return values from the callbacks.
                });
              }
              return sendEdgeNetworkRequest({
                request,
                runOnResponseCallbacks: onResponseCallbackAggregator.call,
                runOnRequestFailureCallbacks: onRequestFailureCallbackAggregator.call
              });
            });
          },
          applyResponse(event, options = {}) {
            const {
              renderDecisions = false,
              decisionContext = {},
              responseHeaders = {},
              responseBody = {
                handle: []
              },
              personalization
            } = options;
            const payload = createDataCollectionRequestPayload();
            const request = createDataCollectionRequest({
              payload
            });
            const onResponseCallbackAggregator = createCallbackAggregator();
            return lifecycle.onBeforeEvent({
              event,
              renderDecisions,
              decisionContext,
              decisionScopes: [PAGE_WIDE_SCOPE],
              personalization,
              onResponse: onResponseCallbackAggregator.add,
              onRequestFailure: noop
            }).then(() => {
              payload.addEvent(event);
              return applyResponse({
                request,
                responseHeaders,
                responseBody,
                runOnResponseCallbacks: onResponseCallbackAggregator.call
              });
            });
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const STATE_STORE_HANDLE_TYPE = "state:store";
      var createCookieTransfer = ({
        cookieJar,
        shouldTransferCookie,
        apexDomain,
        dateProvider
      }) => {
        return {
          /**
           * When sending to a third-party endpoint, the endpoint won't be able to
           * access first-party cookies, therefore we transfer cookies into
           * the request body so they can be read by the server.
           */
          cookiesToPayload(payload, endpointDomain) {
            // localhost is a special case where the apexDomain is ""
            // We want to treat localhost as a third-party domain.
            const isEndpointFirstParty = apexDomain !== "" && endpointDomain.endsWith(apexDomain);
            const state = {
              domain: apexDomain,
              cookiesEnabled: true
            };

            // If the endpoint is first-party, there's no need to transfer cookies
            // to the payload since they'll be automatically passed through cookie
            // headers.
            if (!isEndpointFirstParty) {
              const cookies = cookieJar.get();
              const entries = Object.keys(cookies).filter(shouldTransferCookie).map(qualifyingCookieName => {
                return {
                  key: qualifyingCookieName,
                  value: cookies[qualifyingCookieName]
                };
              });
              if (entries.length) {
                state.entries = entries;
              }
            }
            payload.mergeState(state);
          },
          /**
           * When receiving from a third-party endpoint, the endpoint won't be able to
           * write first-party cookies, therefore we write first-party cookies
           * as directed in the response body.
           */
          responseToCookies(response) {
            response.getPayloadsByType(STATE_STORE_HANDLE_TYPE).forEach(stateItem => {
              const options = {
                domain: apexDomain
              };
              const sameSite = stateItem.attrs && stateItem.attrs.SameSite && stateItem.attrs.SameSite.toLowerCase();
              if (stateItem.maxAge !== undefined) {
                // cookieJar expects "expires" as a date object
                options.expires = new Date(dateProvider().getTime() + stateItem.maxAge * 1000);
              }
              if (sameSite !== undefined) {
                options.sameSite = sameSite;
              }
              // When sameSite is set to none, the secure flag must be set.
              // Experience edge will not set the secure flag in these cases.
              if (sameSite === "none") {
                options.secure = true;
              }
              cookieJar.set(stateItem.key, stateItem.value, options);
            });
          }
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const MBOX_EDGE_CLUSTER = "mboxEdgeCluster";
      const AT_QA_MODE = "at_qa_mode";
      const MBOX = "mbox";

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectShouldTransferCookie = ({
        orgId,
        targetMigrationEnabled
      }) => name => {
        // We have a contract with the server that we will pass
        // all cookies whose names are namespaced according to the
        // logic in isNamespacedCookieName as well as any legacy
        // cookie names (so that the server can handle migrating
        // identities on websites previously using Visitor.js)
        return isNamespacedCookieName(orgId, name) || name === AT_QA_MODE || targetMigrationEnabled && name === MBOX;
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var apiVersion = "v1";

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var mergeLifecycleResponses = returnValues => {
        // Merges all returned objects from all `onResponse` callbacks into
        // a single object that can later be returned to the customer.
        const lifecycleOnResponseReturnValues = returnValues.shift() || [];
        const consumerOnResponseReturnValues = returnValues.shift() || [];
        const lifecycleOnBeforeRequestReturnValues = returnValues;
        return assignConcatArrayValues({}, ...lifecycleOnResponseReturnValues, ...consumerOnResponseReturnValues, ...lifecycleOnBeforeRequestReturnValues);
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var handleRequestFailure = onRequestFailureCallbackAggregator => {
        return error => {
          // Regardless of whether the network call failed, an unexpected status
          // code was returned, or the response body was malformed, we want to call
          // the onRequestFailure callbacks, but still throw the exception.
          const throwError = () => {
            throw error;
          };
          return onRequestFailureCallbackAggregator.call({
            error
          }).then(throwError, throwError);
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectSendEdgeNetworkRequest = ({
        config,
        lifecycle,
        cookieTransfer,
        sendNetworkRequest,
        createResponse,
        processWarningsAndErrors,
        getLocationHint,
        getAssuranceValidationTokenParams
      }) => {
        const {
          edgeDomain,
          edgeBasePath,
          datastreamId
        } = config;

        /**
         * Sends a network request that is aware of payload interfaces,
         * lifecycle methods, configured edge domains, response structures, etc.
         */
        return ({
          request,
          runOnResponseCallbacks = noop,
          runOnRequestFailureCallbacks = noop
        }) => {
          const onResponseCallbackAggregator = createCallbackAggregator();
          onResponseCallbackAggregator.add(lifecycle.onResponse);
          onResponseCallbackAggregator.add(runOnResponseCallbacks);
          const onRequestFailureCallbackAggregator = createCallbackAggregator();
          onRequestFailureCallbackAggregator.add(lifecycle.onRequestFailure);
          onRequestFailureCallbackAggregator.add(runOnRequestFailureCallbacks);
          return lifecycle.onBeforeRequest({
            request,
            onResponse: onResponseCallbackAggregator.add,
            onRequestFailure: onRequestFailureCallbackAggregator.add
          }).then(() => {
            const endpointDomain = request.getUseIdThirdPartyDomain() ? ID_THIRD_PARTY : edgeDomain;
            const locationHint = getLocationHint();
            const edgeBasePathWithLocationHint = locationHint ? edgeBasePath + "/" + locationHint + request.getEdgeSubPath() : "" + edgeBasePath + request.getEdgeSubPath();
            const configId = request.getDatastreamIdOverride() || datastreamId;
            const payload = request.getPayload();
            if (configId !== datastreamId) {
              payload.mergeMeta({
                sdkConfig: {
                  datastream: {
                    original: datastreamId
                  }
                }
              });
            }
            const url = "https://" + endpointDomain + "/" + edgeBasePathWithLocationHint + "/" + apiVersion + "/" + request.getAction() + "?configId=" + configId + "&requestId=" + request.getId() + getAssuranceValidationTokenParams();
            cookieTransfer.cookiesToPayload(payload, endpointDomain);
            return sendNetworkRequest({
              requestId: request.getId(),
              url,
              payload,
              useSendBeacon: request.getUseSendBeacon()
            });
          }).then(networkResponse => {
            processWarningsAndErrors(networkResponse);
            return networkResponse;
          }).catch(handleRequestFailure(onRequestFailureCallbackAggregator)).then(({
            parsedBody,
            getHeader
          }) => {
            // Note that networkResponse.parsedBody may be undefined if it was a
            // 204 No Content response. That's fine.
            const response = createResponse({
              content: parsedBody,
              getHeader
            });
            cookieTransfer.responseToCookies(response);

            // Notice we're calling the onResponse lifecycle method even if there are errors
            // inside the response body. This is because the full request didn't actually fail--
            // only portions of it that are considered non-fatal (a specific, non-critical
            // Konductor plugin, for example).
            return onResponseCallbackAggregator.call({
              response
            }).then(mergeLifecycleResponses);
          });
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const NO_CONTENT = 204;
      const TOO_MANY_REQUESTS = 429;
      const BAD_GATEWAY = 502;
      const SERVICE_UNAVAILABLE = 503;
      const GATEWAY_TIMEOUT = 504;

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const MESSAGE_PREFIX = "The server responded with a";
      var injectProcessWarningsAndErrors = ({
        logger
      }) => {
        return networkResponse => {
          const {
            statusCode,
            body,
            parsedBody
          } = networkResponse;
          if (statusCode < 200 || statusCode >= 300 || !parsedBody && statusCode !== NO_CONTENT || parsedBody && !Array.isArray(parsedBody.handle)) {
            const bodyToLog = parsedBody ? JSON.stringify(parsedBody, null, 2) : body;
            const messageSuffix = bodyToLog ? "response body:\n" + bodyToLog : "no response body.";
            throw new Error(MESSAGE_PREFIX + " status code " + statusCode + " and " + messageSuffix);
          }
          if (parsedBody) {
            const {
              warnings = [],
              errors = []
            } = parsedBody;
            warnings.forEach(warning => {
              logger.warn(MESSAGE_PREFIX + " warning:", warning);
            });
            errors.forEach(error => {
              logger.error(MESSAGE_PREFIX + " non-fatal error:", error);
            });
          }
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectGetLocationHint = ({
        orgId,
        cookieJar
      }) => {
        const clusterCookieName = getNamespacedCookieName(orgId, CLUSTER);
        const fromClusterCookie = () => cookieJar.get(clusterCookieName);
        const fromTarget = () => {
          const mboxEdgeCluster = cookieJar.get(MBOX_EDGE_CLUSTER);
          if (mboxEdgeCluster) {
            return "t" + mboxEdgeCluster;
          }
          return undefined;
        };
        return () => {
          return fromClusterCookie() || fromTarget();
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const MAX_RETRIES = 3;
      const RETRYABLE_STATUS_CODES = [TOO_MANY_REQUESTS, SERVICE_UNAVAILABLE, BAD_GATEWAY, GATEWAY_TIMEOUT];

      // These rules are in accordance with
      // https://git.corp.adobe.com/pages/experience-edge/konductor/#/apis/errors?id=handling-4xx-and-5xx-responses
      var isRequestRetryable = ({
        response,
        retriesAttempted
      }) => {
        return retriesAttempted < MAX_RETRIES && RETRYABLE_STATUS_CODES.includes(response.statusCode);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // The retry gets incrementally (but not exponentially) longer for each retry.
      const FIRST_DELAY_MILLIS = 1000;
      const INCREMENTAL_DELAY_MILLIS = 1000;

      // When the target delay is randomized, make it within the range of this percentage above or below the target delay.
      const MAX_RANDOM_VARIANCE_PERCENTAGE = 0.3;
      const calculateRetryDelay = retriesAttempted => {
        const targetDelay = FIRST_DELAY_MILLIS + retriesAttempted * INCREMENTAL_DELAY_MILLIS;
        const maxVariance = targetDelay * MAX_RANDOM_VARIANCE_PERCENTAGE;
        const minDelay = targetDelay - maxVariance;
        const maxDelay = targetDelay + maxVariance;
        const randomizedDelayWithinRange = Math.round(minDelay + Math.random() * (maxDelay - minDelay));
        return randomizedDelayWithinRange;
      };
      const getDelayFromHeader = response => {
        // According to the HTTP spec, if the header is defined, its value will be a string that
        // represents either:
        //  * An integer indicating the number of seconds to delay.
        //  * A date after which a retry may occur. The date would be in HTTP-date
        //    format (https://tools.ietf.org/html/rfc7231#section-7.1.1.1). When debugging, it can
        //    be helpful to know that this is the same format that a JavaScript date's
        //    toGMTString() returns.
        const headerValue = response.getHeader(RETRY_AFTER);
        let delayInMillis;
        if (headerValue) {
          const headerValueInt = parseInt(headerValue, 10);
          if (isInteger(headerValueInt)) {
            delayInMillis = headerValueInt * 1000;
          } else {
            delayInMillis = Math.max(0, new Date(headerValue).getTime() - new Date().getTime());
          }
        }
        return delayInMillis;
      };

      // These rules are in accordance with
      // https://git.corp.adobe.com/pages/experience-edge/konductor/#/apis/errors?id=handling-4xx-and-5xx-responses
      // For retry delays that don't come from a Retry-After response header, we try to stick with the following best
      // practices outlined in https://docs.microsoft.com/en-us/azure/architecture/best-practices/transient-faults:
      //  * Incremental retry
      //  * Random interval
      var getRequestRetryDelay = ({
        response,
        retriesAttempted
      }) => {
        // Technically, only 429 or 503 responses should have a Retry-After header, but we'll respect the
        // header if we find it on any response.
        let delayInMillis = getDelayFromHeader(response);

        // Note that the value of delay may be 0 at this point, which would be a valid delay we want to use
        // and not override, which is why we don't do:
        // if (!delay) { ... }
        if (delayInMillis === undefined) {
          delayInMillis = calculateRetryDelay(retriesAttempted);
        }
        return delayInMillis;
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const HTTP_STATUS_OK = 200;
      var injectApplyResponse = ({
        cookieTransfer,
        lifecycle,
        createResponse,
        processWarningsAndErrors
      }) => {
        return ({
          request,
          responseHeaders,
          responseBody,
          runOnResponseCallbacks = noop,
          runOnRequestFailureCallbacks = noop
        }) => {
          const onResponseCallbackAggregator = createCallbackAggregator();
          onResponseCallbackAggregator.add(lifecycle.onResponse);
          onResponseCallbackAggregator.add(runOnResponseCallbacks);
          const onRequestFailureCallbackAggregator = createCallbackAggregator();
          onRequestFailureCallbackAggregator.add(lifecycle.onRequestFailure);
          onRequestFailureCallbackAggregator.add(runOnRequestFailureCallbacks);
          const getHeader = key => responseHeaders[key];
          return lifecycle.onBeforeRequest({
            request,
            onResponse: onResponseCallbackAggregator.add,
            onRequestFailure: onRequestFailureCallbackAggregator.add
          }).then(() => processWarningsAndErrors({
            statusCode: HTTP_STATUS_OK,
            getHeader,
            body: JSON.stringify(responseBody),
            parsedBody: responseBody
          })).catch(handleRequestFailure(onRequestFailureCallbackAggregator)).then(() => {
            const response = createResponse({
              content: responseBody,
              getHeader
            });

            // This will clobber any cookies set via HTTP from the server.  So care should be given to remove any state:store handles if that is not desirable
            cookieTransfer.responseToCookies(response);
            return onResponseCallbackAggregator.call({
              response
            }).then(mergeLifecycleResponses);
          });
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Verifies user provided event options.
       * @param {*} options The user event options to validate
       * @returns {*} Validated options
       */
      var validateUserEventOptions = ({
        options
      }) => {
        const eventOptionsValidator = boundObjectOf({
          type: boundString(),
          xdm: boundObjectOf({
            eventType: boundString(),
            identityMap: validateIdentityMap
          }),
          data: boundObjectOf({}),
          documentUnloading: boundBoolean(),
          renderDecisions: boundBoolean(),
          decisionScopes: boundArrayOf(boundString()).uniqueItems(),
          personalization: boundObjectOf({
            decisionScopes: boundArrayOf(boundString()).uniqueItems(),
            surfaces: boundArrayOf(boundString()).uniqueItems(),
            sendDisplayEvent: boundBoolean().default(true),
            includeRenderedPropositions: boundBoolean().default(false),
            defaultPersonalizationEnabled: boundBoolean(),
            decisionContext: boundObjectOf({})
          }).default({
            sendDisplayEvent: true
          }),
          datasetId: boundString(),
          mergeId: boundString(),
          edgeConfigOverrides: validateConfigOverride,
          initializePersonalization: boundBoolean()
        }).required().noUnknownFields();
        return eventOptionsValidator(options);
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var validateApplyResponse = ({
        options
      }) => {
        const validator = boundObjectOf({
          renderDecisions: boundBoolean(),
          responseHeaders: boundMapOfValues(boundString().required()),
          responseBody: boundObjectOf({
            handle: boundArrayOf(boundObjectOf({
              type: boundString().required(),
              payload: boundAnything().required()
            })).required()
          }).required(),
          personalization: boundObjectOf({
            sendDisplayEvent: boundBoolean().default(true),
            decisionContext: boundObjectOf({})
          }).default({
            sendDisplayEvent: true
          })
        }).noUnknownFields();
        return validator(options);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createDataCollector = ({
        eventManager,
        logger
      }) => {
        return {
          commands: {
            sendEvent: {
              documentationUri: "https://adobe.ly/3GQ3Q7t",
              optionsValidator: options => {
                return validateUserEventOptions({
                  options
                });
              },
              run: options => {
                const {
                  xdm,
                  data,
                  documentUnloading,
                  type,
                  mergeId,
                  datasetId,
                  edgeConfigOverrides,
                  ...eventManagerOptions
                } = options;
                const event = eventManager.createEvent();
                if (documentUnloading) {
                  event.documentMayUnload();
                }
                event.setUserXdm(xdm);
                event.setUserData(data);
                if (type) {
                  event.mergeXdm({
                    eventType: type
                  });
                }
                if (mergeId) {
                  event.mergeXdm({
                    eventMergeId: mergeId
                  });
                }
                if (edgeConfigOverrides) {
                  eventManagerOptions.edgeConfigOverrides = edgeConfigOverrides;
                }
                if (datasetId) {
                  logger.warn("The 'datasetId' option has been deprecated. Please use 'edgeConfigOverrides.com_adobe_experience_platform.datasets.event.datasetId' instead.");
                  eventManagerOptions.edgeConfigOverrides = edgeConfigOverrides || {};
                  deepAssign(eventManagerOptions.edgeConfigOverrides, {
                    com_adobe_experience_platform: {
                      datasets: {
                        event: {
                          datasetId
                        }
                      }
                    }
                  });
                }
                return eventManager.sendEvent(event, eventManagerOptions);
              }
            },
            applyResponse: {
              documentationUri: "",
              optionsValidator: options => {
                return validateApplyResponse({
                  options
                });
              },
              run: options => {
                const {
                  renderDecisions = false,
                  decisionContext = {},
                  responseHeaders = {},
                  responseBody = {
                    handle: []
                  },
                  personalization
                } = options;
                const event = eventManager.createEvent();
                return eventManager.applyResponse(event, {
                  renderDecisions,
                  decisionContext,
                  responseHeaders,
                  responseBody,
                  personalization
                });
              }
            }
          }
        };
      };
      createDataCollector.namespace = "DataCollector";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const createResultLogMessage$1 = (idSync, success) => {
        return "ID sync " + (success ? "succeeded" : "failed") + ": " + idSync.spec.url;
      };
      var injectProcessIdSyncs = ({
        fireReferrerHideableImage,
        logger
      }) => idSyncs => {
        const urlIdSyncs = idSyncs.filter(idSync => idSync.type === "url");
        if (!urlIdSyncs.length) {
          return Promise.resolve();
        }
        return Promise.all(urlIdSyncs.map(idSync => {
          return fireReferrerHideableImage(idSync.spec).then(() => {
            logger.info(createResultLogMessage$1(idSync, true));
          }).catch(() => {
            // We intentionally do not throw an error if id syncs fail. We
            // consider it a non-critical failure and therefore do not want it to
            // reject the promise handed back to the customer.
            logger.error(createResultLogMessage$1(idSync, false));
          });
        })).then(noop);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const configValidators$2 = boundObjectOf({
        thirdPartyCookiesEnabled: boundBoolean().default(true),
        idMigrationEnabled: boundBoolean().default(true)
      });

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Verifies user provided event options.
       * @param {*} options The user event options to validate
       * @returns {*} Validated options
       */
      var appendIdentityToUrlOptionsValidator = boundObjectOf({
        url: boundString().required().nonEmpty(),
        edgeConfigOverrides: validateConfigOverride
      }).required().noUnknownFields();

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var ecidNamespace = "ECID";

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createComponent$4 = ({
        addEcidQueryToPayload,
        addQueryStringIdentityToPayload,
        ensureSingleIdentity,
        setLegacyEcid,
        handleResponseForIdSyncs,
        getNamespacesFromResponse,
        getIdentity,
        consent,
        appendIdentityToUrl,
        logger,
        getIdentityOptionsValidator
      }) => {
        let namespaces;
        let edge = {};
        return {
          lifecycle: {
            onBeforeRequest({
              request,
              onResponse,
              onRequestFailure
            }) {
              // Querying the ECID on every request to be able to set the legacy cookie, and make it
              // available for the `getIdentity` command.
              addEcidQueryToPayload(request.getPayload());
              addQueryStringIdentityToPayload(request.getPayload());
              return ensureSingleIdentity({
                request,
                onResponse,
                onRequestFailure
              });
            },
            onResponse({
              response
            }) {
              const newNamespaces = getNamespacesFromResponse(response);
              if ((!namespaces || !namespaces[ecidNamespace]) && newNamespaces && newNamespaces[ecidNamespace]) {
                // Only data collection calls will have an ECID in the response.
                // https://jira.corp.adobe.com/browse/EXEG-1234
                setLegacyEcid(newNamespaces[ecidNamespace]);
              }
              namespaces = newNamespaces;
              // For sendBeacon requests, getEdge() will return {}, so we are using assign here
              // so that sendBeacon requests don't override the edge info from before.
              edge = {
                ...edge,
                ...response.getEdge()
              };
              return handleResponseForIdSyncs(response);
            }
          },
          commands: {
            getIdentity: {
              optionsValidator: getIdentityOptionsValidator,
              run: options => {
                const {
                  namespaces: requestedNamespaces
                } = options;
                return consent.awaitConsent().then(() => {
                  return namespaces ? undefined : getIdentity(options);
                }).then(() => {
                  return {
                    identity: requestedNamespaces.reduce((acc, namespace) => {
                      acc[namespace] = namespaces[namespace] || null;
                      return acc;
                    }, {}),
                    edge
                  };
                });
              }
            },
            appendIdentityToUrl: {
              optionsValidator: appendIdentityToUrlOptionsValidator,
              run: options => {
                return consent.withConsent().then(() => {
                  return namespaces ? undefined : getIdentity(options);
                }).then(() => {
                  return {
                    url: appendIdentityToUrl(namespaces[ecidNamespace], options.url)
                  };
                }).catch(error => {
                  logger.warn("Unable to append identity to url. " + error.message);
                  return options;
                });
              }
            }
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Handles migration of ECID to and from Visitor.js.
       */
      var createLegacyIdentity = ({
        config,
        getEcidFromVisitor,
        apexDomain,
        isPageSsl,
        cookieJar
      }) => {
        const {
          idMigrationEnabled,
          orgId
        } = config;
        const amcvCookieName = "AMCV_" + orgId;
        const getEcidFromLegacyCookies = () => {
          let ecid = null;
          const secidCookieName = "s_ecid";
          const legacyEcidCookieValue = cookieJar.get(secidCookieName) || cookieJar.get(amcvCookieName);
          if (legacyEcidCookieValue) {
            const reg = /(^|\|)MCMID\|(\d+)($|\|)/;
            const matches = legacyEcidCookieValue.match(reg);
            if (matches) {
              // Destructuring arrays breaks in IE
              ecid = matches[2];
            }
          }
          return ecid;
        };
        return {
          getEcid() {
            if (idMigrationEnabled) {
              const ecid = getEcidFromLegacyCookies();
              if (ecid) {
                return Promise.resolve(ecid);
              }
              return getEcidFromVisitor();
            }
            return Promise.resolve();
          },
          setEcid(ecid) {
            if (idMigrationEnabled && getEcidFromLegacyCookies() !== ecid) {
              const extraOptions = isPageSsl ? {
                sameSite: "none",
                secure: true
              } : {};
              cookieJar.set(amcvCookieName, "MCMID|" + ecid, {
                domain: apexDomain,
                // Without `expires` this will be a session cookie.
                expires: 390,
                // days, or 13 months.
                ...extraOptions
              });
            }
          }
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var awaitVisitorOptIn = ({
        logger
      }) => {
        return new Promise((resolve, reject) => {
          if (isObject(window.adobe) && isObject(window.adobe.optIn)) {
            const optInOld = window.adobe.optIn;
            logger.info("Delaying request while waiting for legacy opt-in to let Visitor retrieve ECID from server.");
            optInOld.fetchPermissions(() => {
              if (optInOld.isApproved([optInOld.Categories.ECID])) {
                logger.info("Received legacy opt-in approval to let Visitor retrieve ECID from server.");
                resolve();
              } else {
                reject(new Error("Legacy opt-in was declined."));
              }
            }, true);
          } else {
            resolve();
          }
        });
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var getVisitor = window => {
        const Visitor = window.Visitor;
        return isFunction(Visitor) && isFunction(Visitor.getInstance) && Visitor;
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectGetEcidFromVisitor = ({
        logger,
        orgId,
        awaitVisitorOptIn
      }) => {
        return () => {
          const Visitor = getVisitor(window);
          if (Visitor) {
            // Need to explicitly wait for optIn because visitor will call callback
            // with invalid values prior to optIn being approved
            return awaitVisitorOptIn({
              logger
            }).then(() => {
              logger.info("Delaying request while using Visitor to retrieve ECID from server.");
              return new Promise(resolve => {
                const visitor = Visitor.getInstance(orgId, {});
                visitor.getMarketingCloudVisitorID(ecid => {
                  logger.info("Resuming previously delayed request that was waiting for ECID from Visitor.");
                  resolve(ecid);
                }, true);
              });
            }).catch(error => {
              // If consent was denied, get the ECID from experience edge. OptIn and AEP Web SDK
              // consent should operate independently, but during id migration AEP Web SDK needs
              // to wait for optIn object consent resolution so that only one ECID is generated.
              if (error) {
                logger.info(error.message + ", retrieving ECID from experience edge");
              } else {
                logger.info("An error occurred while obtaining the ECID from Visitor.");
              }
            });
          }
          return Promise.resolve();
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectHandleResponseForIdSyncs = ({
        processIdSyncs
      }) => {
        return response => {
          return processIdSyncs(response.getPayloadsByType("identity:exchange"));
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // TO-DOCUMENT: We queue subsequent requests until we have an identity cookie.
      var injectEnsureSingleIdentity = ({
        doesIdentityCookieExist,
        setDomainForInitialIdentityPayload,
        addLegacyEcidToPayload,
        awaitIdentityCookie,
        logger
      }) => {
        let obtainedIdentityPromise;
        const allowRequestToGoWithoutIdentity = request => {
          setDomainForInitialIdentityPayload(request);
          return addLegacyEcidToPayload(request.getPayload());
        };

        /**
         * Ensures that if no identity cookie exists, we only let one request at a
         * time without an identity until its response returns. In the meantime,
         * we queue all other requests, otherwise the requests could result in
         * multiple ECIDs being minted for the user. Once we get an identity
         * cookie, we can let the queued requests be sent all at once, since they
         * will have the newly minted ECID.
         *
         * Konductor should make every effort to return an identity, but in
         * certain scenarios it may not. For example, in cases where the
         * request does not match what Konductor is expecting (ie 400s).
         * In cases where Konductor does not set an identity, there should be
         * no events recorded so we don't need to worry about multiple ECIDs
         * being minted for each user.
         *
         * The reason we allow for multiple sequential requests to be sent without
         * an identity is to prevent a single malformed request causing all other
         * requests to never send.
         */
        return ({
          request,
          onResponse,
          onRequestFailure
        }) => {
          if (doesIdentityCookieExist()) {
            request.setIsIdentityEstablished();
            return Promise.resolve();
          }
          if (obtainedIdentityPromise) {
            // We don't have an identity cookie, but at least one request has
            // been sent to get it. Konductor may set the identity cookie in the
            // response. We will hold up this request until the previous request
            // returns and awaitIdentityCookie confirms the identity was set.
            logger.info("Delaying request while retrieving ECID from server.");
            const previousObtainedIdentityPromise = obtainedIdentityPromise;

            // This promise resolves when we have an identity cookie. Additional
            // requests are chained together so that only one is sent at a time
            // until we have the identity cookie.
            obtainedIdentityPromise = previousObtainedIdentityPromise.catch(() => {
              return awaitIdentityCookie({
                onResponse,
                onRequestFailure
              });
            });

            // When this returned promise resolves, the request will go out.
            return previousObtainedIdentityPromise.then(() => {
              logger.info("Resuming previously delayed request.");
              request.setIsIdentityEstablished();
            })
            // If Konductor did not set the identity cookie on the previous
            // request, then awaitIdentityCookie will reject its promise.
            // Catch the rejection here and allow this request to go out.
            .catch(() => {
              return allowRequestToGoWithoutIdentity(request);
            });
          }

          // For Alloy+Konductor communication to be as robust as possible and
          // to ensure we don't mint new ECIDs for requests that would otherwise
          // be sent in parallel, we'll let this request go out to fetch the
          // cookie
          obtainedIdentityPromise = awaitIdentityCookie({
            onResponse,
            onRequestFailure
          });
          // This prevents an un-caught promise in the console when the identity isn't set.
          obtainedIdentityPromise.catch(() => undefined);
          return allowRequestToGoWithoutIdentity(request);
        };
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var coreNamespace = "CORE";

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectAddEcidQueryToPayload = ({
        thirdPartyCookiesEnabled,
        areThirdPartyCookiesSupportedByDefault
      }) => {
        const query = {
          identity: {
            fetch: [ecidNamespace]
          }
        };
        if (thirdPartyCookiesEnabled && areThirdPartyCookiesSupportedByDefault()) {
          query.identity.fetch.push(coreNamespace);
        }
        return payload => {
          payload.mergeQuery(query);
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectSetDomainForInitialIdentityPayload = ({
        thirdPartyCookiesEnabled,
        areThirdPartyCookiesSupportedByDefault
      }) => {
        return request => {
          if (thirdPartyCookiesEnabled && areThirdPartyCookiesSupportedByDefault()) {
            // If third-party cookies are enabled by the customer and
            // supported by the browser, we will send the request to a
            // a third-party identification domain that allows for more accurate
            // identification of the user through use of a third-party cookie.
            // If we have an identity to migrate, we still want to hit the
            // third-party identification domain because the third-party identification
            // domain will use our ECID to set the third-party cookie if the third-party
            // cookie isn't already set, which provides for better cross-domain
            // identification for future requests.
            request.setUseIdThirdPartyDomain();
          }
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectAddLegacyEcidToPayload = ({
        getLegacyEcid,
        addEcidToPayload
      }) => {
        return payload => {
          if (payload.hasIdentity(ecidNamespace)) {
            // don't get the legacy identity if we already have the query string identity or if
            // the user specified it in the identity map
            return Promise.resolve();
          }
          return getLegacyEcid().then(ecidToMigrate => {
            if (ecidToMigrate) {
              addEcidToPayload(payload, ecidToMigrate);
            }
          });
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var queryStringIdentityParam = "adobe_mc";

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var decodeUriComponentSafely = v => {
        try {
          return decodeURIComponent(v);
        } catch {
          return "";
        }
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      // Example: adobe_mc=TS%3D1641432103%7CMCMID%3D77094828402023918047117570965393734545%7CMCORGID%3DFAF554945B90342F0A495E2C%40AdobeOrg
      // Decoded: adobe_mc=TS=1641432103|MCMID=77094828402023918047117570965393734545|MCORGID=FAF554945B90342F0A495E2C@AdobeOrg

      const LINK_TTL_SECONDS = 300; // 5 minute link time to live

      var injectAddQueryStringIdentityToPayload = ({
        locationSearch,
        dateProvider,
        orgId,
        logger
      }) => payload => {
        if (payload.hasIdentity(ecidNamespace)) {
          // don't overwrite a user provided ecid identity
          return;
        }
        const parsedQueryString = queryString.parse(locationSearch);
        let queryStringValue = parsedQueryString[queryStringIdentityParam];
        if (queryStringValue === undefined) {
          return;
        }
        if (Array.isArray(queryStringValue)) {
          logger.warn("Found multiple adobe_mc query string paramters, only using the last one.");
          queryStringValue = queryStringValue[queryStringValue.length - 1];
        }
        const properties = queryStringValue.split("|").reduce((memo, keyValue) => {
          const [key, value] = keyValue.split("=");
          memo[key] = value;
          return memo;
        }, {});
        // We are using MCMID and MCORGID to be compatible with Visitor.
        const ts = parseInt(properties.TS, 10);
        const mcmid = properties.MCMID;
        const mcorgid = decodeUriComponentSafely(properties.MCORGID);
        if (
        // When TS is not specified or not a number, the following inequality returns false.
        // All inequalities with NaN variables are false.
        dateProvider().getTime() / 1000 <= ts + LINK_TTL_SECONDS && mcorgid === orgId && mcmid) {
          logger.info("Found valid ECID identity " + mcmid + " from the adobe_mc query string parameter.");
          payload.addIdentity(ecidNamespace, {
            id: mcmid
          });
        } else {
          logger.info("Detected invalid or expired adobe_mc query string parameter.");
        }
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var addEcidToPayload = (payload, ecid) => {
        payload.addIdentity(ecidNamespace, {
          id: ecid
        });
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectAwaitIdentityCookie = ({
        doesIdentityCookieExist,
        orgId,
        logger
      }) => {
        /**
         * Returns a promise that will be resolved once an identity cookie exists.
         * If an identity cookie doesn't already exist, it should always exist after
         * the first response.
         */
        return ({
          onResponse,
          onRequestFailure
        }) => {
          return new Promise((resolve, reject) => {
            onResponse(() => {
              if (doesIdentityCookieExist()) {
                resolve();
              } else {
                // This logic assumes that the code setting the cookie is working as expected and that
                // the cookie was missing from the response.
                logger.warn("Identity cookie not found. This could be caused by any of the following issues:\n" + ("\t* The org ID " + orgId + " configured in Alloy doesn't match the org ID specified in the edge configuration.\n") + "\t* Experience edge was not able to set the identity cookie due to domain or cookie restrictions.\n" + "\t* The request was canceled by the browser and not fully processed.");

                // Rejecting the promise will tell queued events to still go out
                // one at a time.
                reject(new Error("Identity cookie not found."));
              }
            });
            onRequestFailure(() => {
              if (doesIdentityCookieExist()) {
                resolve();
              } else {
                // The error from the request failure will be logged separately. Rejecting this here
                // will tell ensureSingleIdentity to send the next request without identity
                reject(new Error("Identity cookie not found."));
              }
            });
          });
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var getNamespacesFromResponse = response => {
        const identityResultPayloads = response.getPayloadsByType("identity:result");
        return identityResultPayloads.reduce((acc, payload) => {
          if (payload.namespace && payload.namespace.code) {
            acc[payload.namespace.code] = payload.id;
          }
          return acc;
        }, {});
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createGetIdentity = ({
        sendEdgeNetworkRequest,
        createIdentityRequestPayload,
        createIdentityRequest,
        globalConfigOverrides
      }) => {
        return ({
          namespaces,
          edgeConfigOverrides: localConfigOverrides
        } = {}) => {
          const requestParams = createRequestParams({
            payload: createIdentityRequestPayload(namespaces),
            globalConfigOverrides,
            localConfigOverrides
          });
          const request = createIdentityRequest(requestParams);
          return sendEdgeNetworkRequest({
            request
          });
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createIdentityRequest = ({
        payload,
        datastreamIdOverride
      }) => {
        return createRequest({
          payload,
          datastreamIdOverride,
          getAction() {
            return "identity/acquire";
          },
          getUseSendBeacon() {
            return false;
          }
        });
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createIdentityRequestPayload = namespaces => {
        const content = {
          query: {
            identity: {
              fetch: namespaces
            }
          }
        };
        return createRequestPayload({
          content,
          addIdentity: createAddIdentity(content),
          hasIdentity: createHasIdentity(content)
        });
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const URL_REGEX = /^([^?#]*)(\??[^#]*)(#?.*)$/;
      const getSeparator = queryString => {
        if (queryString === "") {
          return "?";
        }
        if (queryString === "?") {
          return "";
        }
        return "&";
      };
      var injectAppendIdentityToUrl = ({
        dateProvider,
        orgId
      }) => (ecid, url) => {
        const ts = Math.round(dateProvider().getTime() / 1000);
        const adobemc = encodeURIComponent("TS=" + ts + "|MCMID=" + ecid + "|MCORGID=" + encodeURIComponent(orgId));
        const [, location, queryString, fragment] = url.match(URL_REGEX);
        const separator = getSeparator(queryString);
        return "" + location + queryString + separator + "adobe_mc=" + adobemc + fragment;
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Verifies user provided event options.
       * @param {*} options The user event options to validate
       * @returns {*} Validated options
       */

      const validator = boundObjectOf({
        namespaces: boundArrayOf(boundEnumOf(ecidNamespace, coreNamespace)).nonEmpty().uniqueItems().default([ecidNamespace]),
        edgeConfigOverrides: validateConfigOverride
      }).noUnknownFields().default({
        namespaces: [ecidNamespace]
      });
      var createGetIdentityOptionsValidator = ({
        thirdPartyCookiesEnabled
      }) => {
        return options => {
          const validatedOptions = validator(options);
          if (!thirdPartyCookiesEnabled && validatedOptions.namespaces.includes(coreNamespace)) {
            throw new Error("namespaces: The " + coreNamespace + " namespace cannot be requested when third-party cookies are disabled.");
          }
          return validatedOptions;
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createIdentity = ({
        config,
        logger,
        consent,
        fireReferrerHideableImage,
        sendEdgeNetworkRequest,
        apexDomain,
        getBrowser
      }) => {
        const {
          orgId,
          thirdPartyCookiesEnabled,
          edgeConfigOverrides: globalConfigOverrides
        } = config;
        const getEcidFromVisitor = injectGetEcidFromVisitor({
          logger,
          orgId,
          awaitVisitorOptIn
        });
        const loggingCookieJar = createLoggingCookieJar({
          logger,
          cookieJar
        });
        const legacyIdentity = createLegacyIdentity({
          config,
          getEcidFromVisitor,
          apexDomain,
          cookieJar: loggingCookieJar,
          isPageSsl: window.location.protocol === "https:"
        });
        const doesIdentityCookieExist = injectDoesIdentityCookieExist({
          orgId
        });
        const getIdentity = createGetIdentity({
          sendEdgeNetworkRequest,
          createIdentityRequestPayload,
          createIdentityRequest,
          globalConfigOverrides
        });
        const areThirdPartyCookiesSupportedByDefault = injectAreThirdPartyCookiesSupportedByDefault({
          getBrowser
        });
        const setDomainForInitialIdentityPayload = injectSetDomainForInitialIdentityPayload({
          thirdPartyCookiesEnabled,
          areThirdPartyCookiesSupportedByDefault
        });
        const addLegacyEcidToPayload = injectAddLegacyEcidToPayload({
          getLegacyEcid: legacyIdentity.getEcid,
          addEcidToPayload
        });
        const addQueryStringIdentityToPayload = injectAddQueryStringIdentityToPayload({
          locationSearch: window.document.location.search,
          dateProvider: () => new Date(),
          orgId,
          logger
        });
        const awaitIdentityCookie = injectAwaitIdentityCookie({
          doesIdentityCookieExist,
          orgId,
          logger
        });
        const ensureSingleIdentity = injectEnsureSingleIdentity({
          doesIdentityCookieExist,
          setDomainForInitialIdentityPayload,
          addLegacyEcidToPayload,
          awaitIdentityCookie,
          logger
        });
        const processIdSyncs = injectProcessIdSyncs({
          fireReferrerHideableImage,
          logger
        });
        const handleResponseForIdSyncs = injectHandleResponseForIdSyncs({
          processIdSyncs
        });
        const appendIdentityToUrl = injectAppendIdentityToUrl({
          dateProvider: () => new Date(),
          orgId,
          globalConfigOverrides
        });
        const getIdentityOptionsValidator = createGetIdentityOptionsValidator({
          thirdPartyCookiesEnabled
        });
        const addEcidQueryToPayload = injectAddEcidQueryToPayload({
          thirdPartyCookiesEnabled,
          areThirdPartyCookiesSupportedByDefault
        });
        return createComponent$4({
          addEcidQueryToPayload,
          addQueryStringIdentityToPayload,
          ensureSingleIdentity,
          setLegacyEcid: legacyIdentity.setEcid,
          handleResponseForIdSyncs,
          getNamespacesFromResponse,
          getIdentity,
          consent,
          appendIdentityToUrl,
          logger,
          config,
          getIdentityOptionsValidator
        });
      };
      createIdentity.namespace = "Identity";
      createIdentity.configValidators = configValidators$2;

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // The __VERSION__ keyword will be replace at alloy build time with the package.json version.
      // see babel-plugin-version

      var libraryVersion = "2.23.0";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const prepareLibraryInfo = ({
        config,
        componentRegistry
      }) => {
        const allCommands = [...componentRegistry.getCommandNames(), CONFIGURE, SET_DEBUG].sort();
        const resultConfig = {
          ...config
        };
        Object.keys(config).forEach(key => {
          const value = config[key];
          if (typeof value !== "function") {
            return;
          }
          resultConfig[key] = value.toString();
        });
        const components = componentRegistry.getComponentNames();
        return {
          version: libraryVersion,
          configs: resultConfig,
          commands: allCommands,
          components
        };
      };
      const createLibraryInfo = ({
        config,
        componentRegistry
      }) => {
        return {
          commands: {
            getLibraryInfo: {
              run: () => {
                return {
                  libraryInfo: prepareLibraryInfo({
                    config,
                    componentRegistry
                  })
                };
              }
            }
          }
        };
      };
      createLibraryInfo.namespace = "LibraryInfo";

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var requiredComponents = /*#__PURE__*/Object.freeze({
        __proto__: null,
        dataCollector: createDataCollector,
        identity: createIdentity,
        libraryInfo: createLibraryInfo
      });

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createNamespacedStorage = injectStorage(window);
      const {
        console,
        fetch,
        navigator: navigator$1
      } = window;

      // set this up as a function so that monitors can be added at anytime
      // eslint-disable-next-line no-underscore-dangle
      const getMonitors = () => window.__alloyMonitors || [];
      const coreConfigValidators = createCoreConfigs();
      const apexDomain = getApexDomain(window, cookieJar);
      const sendFetchRequest = injectSendFetchRequest({
        fetch
      });
      const fireReferrerHideableImage = injectFireReferrerHideableImage();
      const getAssuranceValidationTokenParams = createGetAssuranceValidationTokenParams({
        window,
        createNamespacedStorage
      });
      const getBrowser = injectGetBrowser({
        userAgent: window.navigator.userAgent
      });
      const createExecuteCommand = ({
        instanceName,
        logController: {
          setDebugEnabled,
          logger,
          createComponentLogger
        },
        components
      }) => {
        const componentRegistry = createComponentRegistry();
        const lifecycle = createLifecycle(componentRegistry);
        const componentCreators = components.concat(Object.values(requiredComponents));
        const setDebugCommand = options => {
          setDebugEnabled(options.enabled, {
            fromConfig: false
          });
        };
        const loggingCookieJar = createLoggingCookieJar({
          logger,
          cookieJar
        });
        const configureCommand = options => {
          const config = buildAndValidateConfig({
            options,
            componentCreators,
            coreConfigValidators,
            createConfig,
            logger,
            setDebugEnabled
          });
          const {
            orgId,
            targetMigrationEnabled
          } = config;
          const shouldTransferCookie = injectShouldTransferCookie({
            orgId,
            targetMigrationEnabled
          });
          const cookieTransfer = createCookieTransfer({
            cookieJar: loggingCookieJar,
            shouldTransferCookie,
            apexDomain,
            dateProvider: () => new Date()
          });
          const sendBeaconRequest = isFunction(navigator$1.sendBeacon) ? injectSendBeaconRequest({
            // Without the bind(), the browser will complain about an
            // illegal invocation.
            sendBeacon: navigator$1.sendBeacon.bind(navigator$1),
            sendFetchRequest,
            logger
          }) : sendFetchRequest;
          const sendNetworkRequest = injectSendNetworkRequest({
            logger,
            sendFetchRequest,
            sendBeaconRequest,
            isRequestRetryable,
            getRequestRetryDelay
          });
          const processWarningsAndErrors = injectProcessWarningsAndErrors({
            logger
          });
          const extractEdgeInfo = injectExtractEdgeInfo({
            logger
          });
          const createResponse = injectCreateResponse({
            extractEdgeInfo
          });
          const getLocationHint = injectGetLocationHint({
            orgId,
            cookieJar
          });
          const sendEdgeNetworkRequest = injectSendEdgeNetworkRequest({
            config,
            lifecycle,
            cookieTransfer,
            sendNetworkRequest,
            createResponse,
            processWarningsAndErrors,
            getLocationHint,
            getAssuranceValidationTokenParams
          });
          const applyResponse = injectApplyResponse({
            lifecycle,
            cookieTransfer,
            createResponse,
            processWarningsAndErrors
          });
          const generalConsentState = createConsentStateMachine({
            logger
          });
          const consent = createConsent({
            generalConsentState,
            logger
          });
          const eventManager = createEventManager({
            config,
            logger,
            lifecycle,
            consent,
            createEvent,
            createDataCollectionRequestPayload,
            createDataCollectionRequest,
            sendEdgeNetworkRequest,
            applyResponse
          });
          return initializeComponents({
            componentCreators,
            lifecycle,
            componentRegistry,
            getImmediatelyAvailableTools(componentName) {
              const componentLogger = createComponentLogger(componentName);
              return {
                config,
                componentRegistry,
                consent,
                eventManager,
                fireReferrerHideableImage,
                logger: componentLogger,
                lifecycle,
                sendEdgeNetworkRequest,
                handleError: injectHandleError({
                  errorPrefix: "[" + instanceName + "] [" + componentName + "]",
                  logger: componentLogger
                }),
                createNamespacedStorage,
                apexDomain,
                getBrowser
              };
            }
          });
        };
        const handleError = injectHandleError({
          errorPrefix: "[" + instanceName + "]",
          logger
        });
        const executeCommand = injectExecuteCommand({
          logger,
          configureCommand,
          setDebugCommand,
          handleError,
          validateCommandOptions
        });
        return executeCommand;
      };
      var core = ({
        components
      }) => {
        // eslint-disable-next-line no-underscore-dangle
        const instanceNames = window.__alloyNS;
        if (instanceNames) {
          instanceNames.forEach(instanceName => {
            const logController = createLogController({
              console,
              locationSearch: window.location.search,
              createLogger,
              instanceName,
              createNamespacedStorage,
              getMonitors
            });
            const executeCommand = createExecuteCommand({
              instanceName,
              logController,
              components
            });
            const instance = createInstanceFunction(executeCommand);
            const queue = window[instanceName].q;
            queue.push = instance;
            logController.logger.logOnInstanceCreated({
              instance
            });
            queue.forEach(instance);
          });
        }
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createClickHandler = ({
        eventManager,
        lifecycle,
        handleError
      }) => {
        return clickEvent => {
          // Ignore repropagated clicks from AppMeasurement
          if (clickEvent.s_fe) {
            return Promise.resolve();
          }
          // TODO: Consider safeguarding from the same object being clicked multiple times in rapid succession?
          const clickedElement = clickEvent.target;
          const event = eventManager.createEvent();
          // this is to make sure a exit link personalization metric use send beacon
          event.documentMayUnload();
          return lifecycle.onClick({
            event,
            clickedElement
          }).then(() => {
            if (event.isEmpty()) {
              return Promise.resolve();
            }
            return eventManager.sendEvent(event);
          })
          // eventManager.sendEvent() will return a promise resolved to an
          // object and we want to avoid returning any value to the customer
          .then(noop).catch(error => {
            handleError(error, "click collection");
          });
        };
      };
      var attachClickActivityCollector = ({
        eventManager,
        lifecycle,
        handleError
      }) => {
        const clickHandler = createClickHandler({
          eventManager,
          lifecycle,
          handleError
        });
        document.addEventListener("click", clickHandler, true);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const downloadLinkQualifier = boundString().regexp().default("\\.(exe|zip|wav|mp3|mov|mpg|avi|wmv|pdf|doc|docx|xls|xlsx|ppt|pptx)$");
      var configValidators$1 = boundObjectOf({
        clickCollectionEnabled: boundBoolean().default(true),
        clickCollection: boundObjectOf({
          internalLinkEnabled: boundBoolean().default(true),
          externalLinkEnabled: boundBoolean().default(true),
          downloadLinkEnabled: boundBoolean().default(true),
          // TODO: Consider moving downloadLinkQualifier here.
          sessionStorageEnabled: boundBoolean().default(false),
          eventGroupingEnabled: boundBoolean().default(false),
          filterClickProperties: boundCallback()
        }).default({
          internalLinkEnabled: true,
          externalLinkEnabled: true,
          downloadLinkEnabled: true,
          sessionStorageEnabled: false,
          eventGroupingEnabled: false
        }),
        downloadLinkQualifier,
        onBeforeLinkClickSend: boundCallback().deprecated('The field "onBeforeLinkClickSend" has been deprecated. Use "clickCollection.filterClickDetails" instead.')
      });

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const ACTIVITY_MAP_EXTENSION_ID = "cppXYctnr";
      var activityMapExtensionEnabled = (context = document) => context.getElementById(ACTIVITY_MAP_EXTENSION_ID) !== null;

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var extractDomain = uri => {
        let fullUrl = uri;
        if (!/^https?:\/\//i.test(fullUrl)) {
          fullUrl = window.location.protocol + "//" + uri;
        }
        const url = new URL(fullUrl);
        return url.hostname;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var isDifferentDomains = (uri1, uri2) => {
        const domain1 = extractDomain(uri1);
        const domain2 = extractDomain(uri2);
        return domain1 !== domain2;
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const isDissallowedLinkType = (clickCollection, linkType) => {
        return linkType && (linkType === "download" && !clickCollection.downloadLinkEnabled || linkType === "exit" && !clickCollection.externalLinkEnabled || linkType === "other" && !clickCollection.internalLinkEnabled);
      };
      var createInjectClickedElementProperties = ({
        config,
        logger,
        getClickedElementProperties,
        clickActivityStorage
      }) => {
        const {
          clickCollectionEnabled,
          clickCollection
        } = config;
        if (!clickCollectionEnabled) {
          return () => undefined;
        }
        return ({
          event,
          clickedElement
        }) => {
          const elementProperties = getClickedElementProperties({
            clickActivityStorage,
            clickedElement,
            config,
            logger
          });
          const linkType = elementProperties.linkType;
          // Avoid clicks to be collected for the ActivityMap interface
          if (activityMapExtensionEnabled()) {
            return;
          }
          if (elementProperties.isValidLink() && isDissallowedLinkType(clickCollection, linkType)) {
            logger.info("Cancelling link click event due to clickCollection." + linkType + "LinkEnabled = false.");
          } else if (
          // Determine if element properties should be sent with event now, or be saved
          // and grouped with a future page view event.
          // Event grouping is not supported for the deprecated onBeforeLinkClickSend callback
          // because only click properties is saved and not XDM and DATA (which could have been modified).
          // However, if the filterClickDetails callback is available we group events because it takes
          // priority over onBeforeLinkClickSend and only supports processing click properties.
          elementProperties.isInternalLink() && clickCollection.eventGroupingEnabled && (!config.onBeforeLinkClickSend || clickCollection.filterClickDetails) && !isDifferentDomains(window.location.hostname, elementProperties.linkUrl)) {
            clickActivityStorage.save(elementProperties.properties);
          } else if (elementProperties.isValidLink()) {
            // Event will be sent
            event.mergeXdm(elementProperties.xdm);
            event.mergeData(elementProperties.data);
            clickActivityStorage.save({
              pageName: elementProperties.pageName,
              pageIDType: elementProperties.pageIDType
            });
          } else if (elementProperties.isValidActivityMapData()) {
            clickActivityStorage.save(elementProperties.properties);
          }
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const buildXdmFromClickedElementProperties = props => {
        return {
          eventType: "web.webinteraction.linkClicks",
          web: {
            webInteraction: {
              name: props.linkName,
              region: props.linkRegion,
              type: props.linkType,
              URL: props.linkUrl,
              linkClicks: {
                value: 1
              }
            }
          }
        };
      };
      const buildDataFromClickedElementProperties = props => {
        return {
          __adobe: {
            analytics: {
              contextData: {
                a: {
                  activitymap: {
                    page: props.pageName,
                    link: props.linkName,
                    region: props.linkRegion,
                    pageIDType: props.pageIDType
                  }
                }
              }
            }
          }
        };
      };
      const populateClickedElementPropertiesFromOptions = (options, props) => {
        const {
          xdm,
          data,
          clickedElement
        } = options;
        props.clickedElement = clickedElement;
        if (xdm && xdm.web && xdm.web.webInteraction) {
          const {
            name,
            region,
            type,
            URL
          } = xdm.web.webInteraction;
          props.linkName = name;
          props.linkRegion = region;
          props.linkType = type;
          props.linkUrl = URL;
        }
        // DATA has priority over XDM
        /* eslint no-underscore-dangle: 0 */
        if (data && data.__adobe && data.__adobe.analytics) {
          const {
            contextData
          } = data.__adobe.analytics;
          if (contextData && contextData.a && contextData.a.activitymap) {
            // Set the properties if they exists
            const {
              page,
              link,
              region,
              pageIDType
            } = contextData.a.activitymap;
            props.pageName = page || props.pageName;
            props.linkName = link || props.linkName;
            props.linkRegion = region || props.linkRegion;
            if (pageIDType !== undefined) {
              props.pageIDType = pageIDType;
            }
          }
        }
      };
      var createClickedElementProperties = ({
        properties,
        logger
      } = {}) => {
        let props = properties || {};
        const clickedElementProperties = {
          get pageName() {
            return props.pageName;
          },
          set pageName(value) {
            props.pageName = value;
          },
          get linkName() {
            return props.linkName;
          },
          set linkName(value) {
            props.linkName = value;
          },
          get linkRegion() {
            return props.linkRegion;
          },
          set linkRegion(value) {
            props.linkRegion = value;
          },
          get linkType() {
            return props.linkType;
          },
          set linkType(value) {
            props.linkType = value;
          },
          get linkUrl() {
            return props.linkUrl;
          },
          set linkUrl(value) {
            props.linkUrl = value;
          },
          get pageIDType() {
            return props.pageIDType;
          },
          set pageIDType(value) {
            props.pageIDType = value;
          },
          get clickedElement() {
            return props.clickedElement;
          },
          set clickedElement(value) {
            props.clickedElement = value;
          },
          get properties() {
            return {
              pageName: props.pageName,
              linkName: props.linkName,
              linkRegion: props.linkRegion,
              linkType: props.linkType,
              linkUrl: props.linkUrl,
              pageIDType: props.pageIDType
            };
          },
          isValidLink() {
            return !!props.linkUrl && !!props.linkType && !!props.linkName && !!props.linkRegion;
          },
          isInternalLink() {
            return this.isValidLink() && props.linkType === "other";
          },
          isValidActivityMapData() {
            return !!props.pageName && !!props.linkName && !!props.linkRegion && props.pageIDType !== undefined;
          },
          get xdm() {
            if (props.filteredXdm) {
              return props.filteredXdm;
            }
            return buildXdmFromClickedElementProperties(this);
          },
          get data() {
            if (props.filteredData) {
              return props.filteredData;
            }
            return buildDataFromClickedElementProperties(this);
          },
          applyPropertyFilter(filter) {
            if (filter && filter(props) === false) {
              if (logger) {
                logger.info("Clicked element properties were rejected by filter function: " + JSON.stringify(this.properties, null, 2));
              }
              props = {};
            }
          },
          applyOptionsFilter(filter) {
            const opts = this.options;
            if (opts && opts.clickedElement && (opts.xdm || opts.data)) {
              // Properties are rejected if filter is explicitly false.
              if (filter && filter(opts) === false) {
                if (logger) {
                  logger.info("Clicked element properties were rejected by filter function: " + JSON.stringify(this.properties, null, 2));
                }
                this.options = undefined;
                return;
              }
              this.options = opts;
              // This is just to ensure that any fields outside clicked element properties
              // set by the user filter persists.
              props.filteredXdm = opts.xdm;
              props.filteredData = opts.data;
            }
          },
          get options() {
            const opts = {};
            if (this.isValidLink()) {
              opts.xdm = this.xdm;
            }
            if (this.isValidActivityMapData()) {
              opts.data = this.data;
            }
            if (this.clickedElement) {
              opts.clickedElement = this.clickedElement;
            }
            if (!opts.xdm && !opts.data) {
              return undefined;
            }
            return opts;
          },
          set options(value) {
            props = {};
            if (value) {
              populateClickedElementPropertiesFromOptions(value, props);
            }
          }
        };
        return clickedElementProperties;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createRecallAndInjectClickedElementProperties = ({
        clickActivityStorage
      }) => {
        return event => {
          // Avoid clicks to be collected for the ActivityMap interface
          if (activityMapExtensionEnabled()) {
            return;
          }
          const properties = clickActivityStorage.load();
          const elementProperties = createClickedElementProperties({
            properties
          });
          if (elementProperties.isValidLink() || elementProperties.isValidActivityMapData()) {
            if (elementProperties.isValidLink()) {
              const xdm = elementProperties.xdm;
              // Have to delete the eventType not to override the page view
              delete xdm.eventType;
              event.mergeXdm(xdm);
            }
            if (elementProperties.isValidActivityMapData()) {
              event.mergeData(elementProperties.data);
            }
            // NOTE: We can't clear out all the storage here because we might still need to
            // keep a page-name for multiple link-clicks (e.g. downloads) on the same page.
            clickActivityStorage.save({
              pageName: elementProperties.pageName,
              pageIDType: elementProperties.pageIDType
            });
          }
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createGetClickedElementProperties = ({
        window,
        getLinkName,
        getLinkRegion,
        getAbsoluteUrlFromAnchorElement,
        findClickableElement,
        determineLinkType
      }) => {
        return ({
          clickedElement,
          config,
          logger,
          clickActivityStorage
        }) => {
          const {
            onBeforeLinkClickSend: optionsFilter,
            // Deprecated
            clickCollection
          } = config;
          const {
            filterClickDetails: propertyFilter
          } = clickCollection;
          const elementProperties = createClickedElementProperties({
            logger
          });
          if (clickedElement) {
            const clickableElement = findClickableElement(clickedElement);
            if (clickableElement) {
              elementProperties.clickedElement = clickedElement;
              elementProperties.linkUrl = getAbsoluteUrlFromAnchorElement(window, clickableElement);
              elementProperties.linkType = determineLinkType(window, config, elementProperties.linkUrl, clickableElement);
              elementProperties.linkRegion = getLinkRegion(clickableElement);
              elementProperties.linkName = getLinkName(clickableElement);
              elementProperties.pageIDType = 0;
              elementProperties.pageName = window.location.href;
              // Check if we have a page-name stored from an earlier page view event
              const storedLinkData = clickActivityStorage.load();
              if (storedLinkData && storedLinkData.pageName) {
                elementProperties.pageName = storedLinkData.pageName;
                // Perhaps pageIDType should be established after customer filter is applied
                // Like if pageName starts with "http" then pageIDType = 0
                elementProperties.pageIDType = 1;
              }
              // If defined, run user provided filter function
              if (propertyFilter) {
                // clickCollection.filterClickDetails
                elementProperties.applyPropertyFilter(propertyFilter);
              } else if (optionsFilter) {
                // onBeforeLinkClickSend
                elementProperties.applyOptionsFilter(optionsFilter);
              }
            }
          }
          return elementProperties;
        };
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const CLICK_ACTIVITY_DATA = "clickData";

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createClickActivityStorage = ({
        storage
      }) => {
        return {
          save: data => {
            const jsonData = JSON.stringify(data);
            storage.setItem(CLICK_ACTIVITY_DATA, jsonData);
          },
          load: () => {
            let jsonData = null;
            const data = storage.getItem(CLICK_ACTIVITY_DATA);
            if (data) {
              jsonData = JSON.parse(data);
            }
            return jsonData;
          },
          remove: () => {
            storage.removeItem(CLICK_ACTIVITY_DATA);
          }
        };
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createStorePageViewProperties = ({
        clickActivityStorage
      }) => {
        return event => {
          clickActivityStorage.save({
            pageName: event.getContent().xdm.web.webPageDetails.name,
            pageIDType: 1 // 1 = name, 0 = URL
          });
        };
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Reduces repeated whitespace within a string. Whitespace surrounding the string
       * is trimmed and any occurrence of whitespace within the string is replaced with
       * a single space.
       * @param {string} str String to be formatted.
       * @returns {string} Formatted string.
       */
      var truncateWhiteSpace = str => {
        return str && str.replace(/\s+/g, " ").trim();
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const unsupportedNodeNames = /^(SCRIPT|STYLE|LINK|CANVAS|NOSCRIPT|#COMMENT)$/i;

      /**
       * Determines if a node qualifies as a supported link text node.
       * @param {*} node Node to determine support for.
       * @returns {boolean}
       */
      var isSupportedTextNode = node => {
        if (node && node.nodeName) {
          if (node.nodeName.match(unsupportedNodeNames)) {
            return false;
          }
        }
        return true;
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Orders and returns specified node and its child nodes in arrays of supported
       * and unsupported nodes.
       * @param {*} node The node to extract supported and unsupported nodes from.
       * @returns {{supportedNodes: Array, includesUnsupportedNodes: boolean}} Node support object.
       */
      const extractSupportedNodes = node => {
        let supportedNodes = [];
        let includesUnsupportedNodes = false;
        if (isSupportedTextNode(node)) {
          supportedNodes.push(node);
          if (node.childNodes) {
            const childNodes = Array.prototype.slice.call(node.childNodes);
            childNodes.forEach(childNode => {
              const nodes = extractSupportedNodes(childNode);
              supportedNodes = supportedNodes.concat(nodes.supportedNodes);
              includesUnsupportedNodes = includesUnsupportedNodes || nodes.includesUnsupportedNodes;
            });
          }
        } else {
          includesUnsupportedNodes = true;
        }
        return {
          supportedNodes,
          includesUnsupportedNodes
        };
      };

      /**
       * Returns the value of a node attribute.
       * @param {*} node The node holding the attribute.
       * @param {string} attributeName The name of the attribute.
       * @param {string} nodeName Optional node name constraint.
       * @returns {string} Attribute value or undefined.
       */
      const getNodeAttributeValue = (node, attributeName, nodeName) => {
        let attributeValue;
        if (!nodeName || nodeName === node.nodeName.toUpperCase()) {
          attributeValue = node.getAttribute(attributeName);
        }
        return attributeValue;
      };

      /**
       * Extracts the children supported nodes attributes map
       * @param {*} nodes The nodes array holding the children nodes.
       * The returned map contains the supported not empty children attributes values.
       * */
      const getChildrenAttributes = nodes => {
        const attributes = {
          texts: []
        };
        nodes.supportedNodes.forEach(supportedNode => {
          if (supportedNode.getAttribute) {
            if (!attributes.alt) {
              attributes.alt = truncateWhiteSpace(supportedNode.getAttribute("alt"));
            }
            if (!attributes.title) {
              attributes.title = truncateWhiteSpace(supportedNode.getAttribute("title"));
            }
            if (!attributes.inputValue) {
              attributes.inputValue = truncateWhiteSpace(getNodeAttributeValue(supportedNode, "value", "INPUT"));
            }
            if (!attributes.imgSrc) {
              attributes.imgSrc = truncateWhiteSpace(getNodeAttributeValue(supportedNode, "src", "IMG"));
            }
          }
          if (supportedNode.nodeValue) {
            attributes.texts.push(supportedNode.nodeValue);
          }
        });
        return attributes;
      };

      /**
       * Extracts a link-name from a given node.
       *
       * The returned link-name is set to one of the following (in order of priority):
       *
       * 1. Clicked node innerText
       * 2. Clicked node textContent
       * 3. Clicked node and its child nodes nodeValue appended together.
       * 4. Clicked node alt attribute or node descendant alt attribute.
       *    Whichever is found first.
       * 5. Clicked node text attribute or node descendant text attribute.
       *    Whichever is found first.
       * 6. Clicked node INPUT descendant value attribute.
       *    Whichever is found first.
       * 7. Clicked node IMG descendant src attribute.
       *    Whichever is found first.
       *
       * @param {*} node The node to find link text for.
       * @returns {string} link-name or an empty string if not link-name is found.
       */
      var getLinkName = node => {
        let nodeText = truncateWhiteSpace(node.innerText || node.textContent);
        const nodes = extractSupportedNodes(node);
        // if contains unsupported nodes we want children node attributes
        if (!nodeText || nodes.includesUnsupportedNodes) {
          const attributesMap = getChildrenAttributes(nodes);
          nodeText = truncateWhiteSpace(attributesMap.texts.join(""));
          if (!nodeText) {
            nodeText = attributesMap.alt || attributesMap.title || attributesMap.inputValue || attributesMap.imgSrc;
          }
        }
        return nodeText || "";
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const semanticElements = /^(HEADER|MAIN|FOOTER|NAV)$/i;
      const getAriaRegionLabel = node => {
        let regionLabel;
        if (node.role === "region" && isNonEmptyString(node["aria-label"])) {
          regionLabel = node["aria-label"];
        }
        return regionLabel;
      };
      const getSectionNodeName = node => {
        let nodeName;
        if (node && node.nodeName) {
          if (node.nodeName.match(semanticElements)) {
            nodeName = node.nodeName;
          }
        }
        return nodeName;
      };

      /**
       * Extracts a node link-region.
       *
       * The link-region is determined by traversing up the DOM
       * looking for a region that is determined in order of priority:
       *
       * 1. element.id
       * 2. Aria region label
       * 3. Semantic element name
       * 4. BODY (if no other link-region is found).
       *
       * @param {*} node The node to find link region for.
       * @returns {string} link-region.
       */
      var getLinkRegion = node => {
        let linkParentNode = node.parentNode;
        let regionName;
        while (linkParentNode) {
          regionName = truncateWhiteSpace(linkParentNode.id || getAriaRegionLabel(linkParentNode) || getSectionNodeName(linkParentNode));
          if (regionName) {
            return regionName;
          }
          linkParentNode = linkParentNode.parentNode;
        }
        return "BODY";
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var urlStartsWithScheme = url => {
        return !url ? false : /^[a-z0-9]+:\/\//i.test(url);
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var getAbsoluteUrlFromAnchorElement = (window, element) => {
        const loc = window.location;
        let href = element.href || "";
        // Some objects (like SVG animations) can contain a href object instead of a string
        if (typeof href !== "string") {
          href = "";
        }
        let {
          protocol,
          host
        } = element;
        if (href && !urlStartsWithScheme(href)) {
          if (!protocol) {
            protocol = loc.protocol ? loc.protocol : "";
          }
          protocol = protocol ? protocol + "//" : "";
          if (!host) {
            host = loc.host ? loc.host : "";
          }
          let path = "";
          if (href.substring(0, 1) !== "/") {
            let indx = loc.pathname.lastIndexOf("/");
            indx = indx < 0 ? 0 : indx;
            path = loc.pathname.substring(0, indx);
          }
          href = "" + protocol + host + path + "/" + href;
        }
        return href;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var isSupportedAnchorElement = element => {
        if (element.href && (element.tagName === "A" || element.tagName === "AREA") && (!element.onclick || !element.protocol || element.protocol.toLowerCase().indexOf("javascript") < 0)) {
          return true;
        }
        return false;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var elementHasClickHandler = element => {
        return !element ? false : !!element.onclick;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var isInputSubmitElement = element => {
        if (element.tagName === "INPUT") {
          const type = element.getAttribute("type");
          if (type === "submit") {
            return true;
          }
          // Image type input elements are considered submit elements.
          // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/image
          if (type === "image" && element.src) {
            return true;
          }
        }
        return false;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var isButtonSubmitElement = element => {
        return element.tagName === "BUTTON" && element.type === "submit";
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var findClickableElement = element => {
        let node = element;
        while (node) {
          if (isSupportedAnchorElement(node) || elementHasClickHandler(node) || isInputSubmitElement(node) || isButtonSubmitElement(node)) {
            return node;
          }
          node = node.parentNode;
        }
        return null;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var trimQueryFromUrl = url => {
        const questionMarkIndex = url.indexOf("?");
        const hashIndex = url.indexOf("#");
        if (questionMarkIndex >= 0 && (questionMarkIndex < hashIndex || hashIndex < 0)) {
          return url.substring(0, questionMarkIndex);
        }
        if (hashIndex >= 0) {
          return url.substring(0, hashIndex);
        }
        return url;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var isDownloadLink = (downloadLinkQualifier, linkUrl, clickedObj) => {
        let result = false;
        if (linkUrl) {
          if (clickedObj && clickedObj.download) {
            result = true;
          } else if (downloadLinkQualifier) {
            const re = new RegExp(downloadLinkQualifier);
            const trimmedLinkUrl = trimQueryFromUrl(linkUrl).toLowerCase();
            result = re.test(trimmedLinkUrl);
          }
        }
        return result;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var isExitLink = (window, linkUrl) => {
        let result = false;
        // window.location.hostname should always be defined, but checking just in case
        if (linkUrl && window.location.hostname) {
          const currentHostname = window.location.hostname.toLowerCase();
          const trimmedLinkUrl = trimQueryFromUrl(linkUrl).toLowerCase();
          result = trimmedLinkUrl.indexOf(currentHostname) < 0;
        }
        return result;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var determineLinkType = (window, config, linkUrl, clickedObj) => {
        let linkType = "other";
        if (isNonEmptyString(linkUrl)) {
          if (isDownloadLink(config.downloadLinkQualifier, linkUrl, clickedObj)) {
            linkType = "download";
          } else if (isExitLink(window, linkUrl)) {
            linkType = "exit";
          }
        }
        return linkType;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var hasPageName = event => {
        const content = event.getContent();
        return content.xdm !== undefined &&
        // NOTE: A page view event should "ideally" include the pageViews type
        // && event.xdm.eventType === "web.webpagedetails.pageViews"
        content.xdm.web !== undefined && content.xdm.web.webPageDetails !== undefined && content.xdm.web.webPageDetails.name !== undefined;
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createTransientStorage = () => {
        const storage = {};
        return {
          getItem: key => {
            return storage[key];
          },
          setItem: (key, value) => {
            storage[key] = value;
          },
          removeItem: key => {
            delete storage[key];
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const getClickedElementProperties = createGetClickedElementProperties({
        window,
        getLinkName,
        getLinkRegion,
        getAbsoluteUrlFromAnchorElement,
        findClickableElement,
        determineLinkType
      });
      let clickActivityStorage;
      const initClickActivityStorage = config => {
        if (!clickActivityStorage) {
          const createNamespacedStorage = injectStorage(window);
          const nameSpacedStorage = createNamespacedStorage(config.orgId || "");
          // Use transient in-memory if sessionStorage is disabled
          const transientStorage = createTransientStorage();
          const storage = config.clickCollection.sessionStorageEnabled ? nameSpacedStorage.session : transientStorage;
          clickActivityStorage = createClickActivityStorage({
            storage
          });
        }
      };
      const createActivityCollector = ({
        config,
        eventManager,
        handleError,
        logger
      }) => {
        const clickCollection = config.clickCollection;
        if (!clickActivityStorage) {
          initClickActivityStorage(config);
        }
        const injectClickedElementProperties = createInjectClickedElementProperties({
          config,
          logger,
          clickActivityStorage,
          getClickedElementProperties
        });
        const recallAndInjectClickedElementProperties = createRecallAndInjectClickedElementProperties({
          clickActivityStorage
        });
        const storePageViewProperties = createStorePageViewProperties({
          clickActivityStorage
        });
        return {
          lifecycle: {
            onComponentsRegistered(tools) {
              const {
                lifecycle
              } = tools;
              attachClickActivityCollector({
                eventManager,
                lifecycle,
                handleError
              });
              // TODO: createScrollActivityCollector ...
            },
            onClick({
              event,
              clickedElement
            }) {
              injectClickedElementProperties({
                event,
                clickedElement
              });
            },
            onBeforeEvent({
              event
            }) {
              if (hasPageName(event)) {
                if (clickCollection.eventGroupingEnabled) {
                  recallAndInjectClickedElementProperties(event);
                }
                storePageViewProperties(event, logger, clickActivityStorage);
              }
            }
          }
        };
      };
      createActivityCollector.namespace = "ActivityCollector";
      createActivityCollector.configValidators = configValidators$1;
      createActivityCollector.buildOnInstanceConfiguredExtraParams = ({
        config,
        logger
      }) => {
        if (!clickActivityStorage) {
          initClickActivityStorage(config);
        }
        return {
          getLinkDetails: targetElement => {
            return getClickedElementProperties({
              clickActivityStorage,
              clickedElement: targetElement,
              config,
              logger
            }).properties;
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createResultLogMessage = (urlDestination, success) => {
        return "URL destination " + "succeeded" + ": " + urlDestination.spec.url;
      };
      var injectProcessDestinations = ({
        fireReferrerHideableImage,
        logger,
        cookieJar,
        isPageSsl
      }) => {
        const extraCookieOptions = isPageSsl ? {
          sameSite: "none",
          secure: true
        } : {};
        const processCookies = destinations => {
          const cookieDestinations = destinations.filter(dest => dest.type === "cookie");
          cookieDestinations.forEach(dest => {
            const {
              name,
              value,
              domain,
              ttlDays
            } = dest.spec;
            cookieJar.set(name, value || "", {
              domain: domain || "",
              expires: ttlDays || 10,
              // days
              ...extraCookieOptions
            });
          });
        };
        const processUrls = destinations => {
          const urlDestinations = destinations.filter(dest => dest.type === "url");
          return Promise.all(urlDestinations.map(urlDestination => {
            return fireReferrerHideableImage(urlDestination.spec).then(() => {
              logger.info(createResultLogMessage(urlDestination));
            }).catch(() => {
              // We intentionally do not throw an error if destinations fail. We
              // consider it a non-critical failure and therefore do not want it to
              // reject the promise handed back to the customer.
            });
          })).then(noop);
        };
        return destinations => {
          processCookies(destinations);
          return processUrls(destinations);
        };
      };

      /*
      Copyright 2021 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectProcessResponse = ({
        processDestinations
      }) => {
        const processPushDestinations = ({
          response
        }) => {
          const destinations = response.getPayloadsByType("activation:push");
          return processDestinations(destinations);
        };
        const retrievePullDestinations = ({
          response
        }) => {
          return {
            destinations: response.getPayloadsByType("activation:pull")
          };
        };
        return ({
          response
        }) => {
          return processPushDestinations({
            response
          }).then(() => retrievePullDestinations({
            response
          }));
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createAudiences = ({
        logger,
        fireReferrerHideableImage
      }) => {
        // we override the js-cookie converter to encode the cookie value similar on how it is in DIL (PDCL-10238)
        const cookieJarWithEncoding = cookieJar.withConverter({
          write: value => {
            return encodeURIComponent(value);
          }
        });
        const loggingCookieJar = createLoggingCookieJar({
          logger,
          cookieJar: cookieJarWithEncoding
        });
        const processDestinations = injectProcessDestinations({
          fireReferrerHideableImage,
          logger,
          cookieJar: loggingCookieJar,
          isPageSsl: window.location.protocol === "https:"
        });
        const processResponse = injectProcessResponse({
          processDestinations
        });
        return {
          lifecycle: {
            onResponse: processResponse
          },
          commands: {}
        };
      };
      createAudiences.namespace = "Audiences";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectWeb = window => {
        return xdm => {
          const web = {
            webPageDetails: {
              URL: window.location.href || window.location
            },
            webReferrer: {
              URL: window.document.referrer
            }
          };
          deepAssign(xdm, {
            web
          });
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const getScreenOrientationViaProperty = window => {
        const {
          screen: {
            orientation
          }
        } = window;
        if (orientation == null || orientation.type == null) {
          return null;
        }
        const parts = orientation.type.split("-");
        if (parts.length === 0) {
          return null;
        }
        if (parts[0] !== "portrait" && parts[0] !== "landscape") {
          return null;
        }
        return parts[0];
      };
      const getScreenOrientationViaMediaQuery = window => {
        if (isFunction(window.matchMedia)) {
          if (window.matchMedia("(orientation: portrait)").matches) {
            return "portrait";
          }
          if (window.matchMedia("(orientation: landscape)").matches) {
            return "landscape";
          }
        }
        return null;
      };
      var injectDevice = window => {
        return xdm => {
          const {
            screen: {
              width,
              height
            }
          } = window;
          const device = {};
          const screenHeight = toInteger(height);
          if (screenHeight >= 0) {
            device.screenHeight = screenHeight;
          }
          const screenWidth = toInteger(width);
          if (screenWidth >= 0) {
            device.screenWidth = screenWidth;
          }
          const orientation = getScreenOrientationViaProperty(window) || getScreenOrientationViaMediaQuery(window);
          if (orientation) {
            device.screenOrientation = orientation;
          }
          if (Object.keys(device).length > 0) {
            deepAssign(xdm, {
              device
            });
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectEnvironment = window => {
        return xdm => {
          const {
            document: {
              documentElement: {
                clientWidth,
                clientHeight
              } = {}
            }
          } = window;
          const environment = {
            type: "browser"
          };
          const viewportWidth = toInteger(clientWidth);
          if (viewportWidth >= 0) {
            environment.browserDetails = {
              viewportWidth
            };
          }
          const viewportHeight = toInteger(clientHeight);
          if (viewportHeight >= 0) {
            environment.browserDetails = environment.browserDetails || {};
            environment.browserDetails.viewportHeight = viewportHeight;
          }
          deepAssign(xdm, {
            environment
          });
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var injectPlaceContext = dateProvider => {
        return xdm => {
          const date = dateProvider();
          const placeContext = {};
          const localTimezoneOffset = toInteger(date.getTimezoneOffset());
          if (localTimezoneOffset !== undefined) {
            placeContext.localTimezoneOffset = localTimezoneOffset;
          }
          // make sure the timezone offset only uses two digits
          if (localTimezoneOffset === undefined || Math.abs(localTimezoneOffset) < 6000) {
            placeContext.localTime = toISOStringLocal(date);
          }
          deepAssign(xdm, {
            placeContext
          });
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectTimestamp = dateProvider => {
        return xdm => {
          const timestamp = dateProvider().toISOString();
          deepAssign(xdm, {
            timestamp
          });
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var libraryName = "https://ns.adobe.com/experience/alloy";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var implementationDetails = xdm => {
        const implementationDetails = {
          name: libraryName,
          version: libraryVersion,
          environment: "browser"
        };
        deepAssign(xdm, {
          implementationDetails
        });
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createComponent$3 = (config, logger, optionalContexts, requiredContexts) => {
        const configuredContexts = config.context;
        const contexts = configuredContexts.flatMap((context, i) => {
          if (optionalContexts[context]) {
            return [optionalContexts[context]];
          }
          logger.warn("Invalid context[" + i + "]: '" + context + "' is not available.");
          return [];
        }).concat(requiredContexts);
        return {
          namespace: "Context",
          lifecycle: {
            onBeforeEvent({
              event
            }) {
              const xdm = {};
              return Promise.all(contexts.map(context => Promise.resolve(context(xdm, logger)))).then(() => event.mergeXdm(xdm));
            }
          }
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var highEntropyUserAgentHints$1 = [["architecture", "string"], ["bitness", "string"], ["model", "string"], ["platformVersion", "string"], ["wow64", "boolean"]];

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const browserSupportsUserAgentClientHints = navigator => {
        return typeof navigator.userAgentData !== "undefined";
      };
      var injectHighEntropyUserAgentHints = navigator => {
        if (!browserSupportsUserAgentClientHints(navigator)) {
          return noop;
        }
        return (xdm, logger) => {
          try {
            return navigator.userAgentData.getHighEntropyValues(highEntropyUserAgentHints$1.map(hint => hint[0])).then(hints => {
              const userAgentClientHints = {};
              highEntropyUserAgentHints$1.forEach(([hintName, hintType]) => {
                if (Object.prototype.hasOwnProperty.call(hints, hintName) && /* eslint-disable-next-line valid-typeof */
                typeof hints[hintName] === hintType) {
                  userAgentClientHints[hintName] = hints[hintName];
                }
              });
              deepAssign(xdm, {
                environment: {
                  browserDetails: {
                    userAgentClientHints
                  }
                }
              });
            });
          } catch (error) {
            logger.warn("Unable to collect user-agent client hints. " + error.message);
            return noop;
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const web = injectWeb(window);
      const device = injectDevice(window);
      const environment = injectEnvironment(window);
      const placeContext = injectPlaceContext(() => new Date());
      const timestamp = injectTimestamp(() => new Date());
      const highEntropyUserAgentHints = injectHighEntropyUserAgentHints(navigator);
      const defaultEnabledContexts = {
        web,
        device,
        environment,
        placeContext
      };
      const defaultDisabledContexts = {
        highEntropyUserAgentHints
      };
      const optionalContexts = {
        ...defaultEnabledContexts,
        ...defaultDisabledContexts
      };
      const requiredContexts = [timestamp, implementationDetails];
      const createContext = ({
        config,
        logger
      }) => {
        return createComponent$3(config, logger, optionalContexts, requiredContexts);
      };
      createContext.namespace = "Context";
      createContext.configValidators = boundObjectOf({
        context: boundArrayOf(boundString()).default(Object.keys(defaultEnabledContexts))
      });

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const PERSONALIZATION_DECISIONS_HANDLE = "personalization:decisions";

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const isPlainObject = obj => obj !== null && typeof obj === "object" && Object.getPrototypeOf(obj) === Object.prototype;
      const flattenObject = (obj, result = {}, keys = []) => {
        Object.keys(obj).forEach(key => {
          if (isPlainObject(obj[key]) || Array.isArray(obj[key])) {
            flattenObject(obj[key], result, [...keys, key]);
          } else {
            result[[...keys, key].join(".")] = obj[key];
          }
        });
        return result;
      };
      var flattenObject$1 = obj => {
        if (!isPlainObject(obj)) {
          return obj;
        }
        return flattenObject(obj);
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createOnResponseHandler = ({
        renderDecisions,
        decisionProvider,
        applyResponse,
        event,
        personalization,
        decisionContext
      }) => {
        const context = {
          ...flattenObject$1(event.getContent()),
          ...decisionContext
        };
        return ({
          response
        }) => {
          decisionProvider.addPayloads(response.getPayloadsByType(PERSONALIZATION_DECISIONS_HANDLE));

          // only evaluate events that include a personalization query
          if (!event.hasQuery()) {
            return {
              propositions: []
            };
          }
          const propositions = decisionProvider.evaluate(context);
          return applyResponse({
            renderDecisions,
            propositions,
            event,
            personalization
          });
        };
      };
      const ConditionType = {
        MATCHER: "matcher",
        GROUP: "group",
        HISTORICAL: "historical"
      };
      const MatcherType = {
        EQUALS: "eq",
        NOT_EQUALS: "ne",
        EXISTS: "ex",
        NOT_EXISTS: "nx",
        GREATER_THAN: "gt",
        GREATER_THAN_OR_EQUAL_TO: "ge",
        LESS_THAN: "lt",
        LESS_THAN_OR_EQUAL_TO: "le",
        CONTAINS: "co",
        NOT_CONTAINS: "nc",
        STARTS_WITH: "sw",
        ENDS_WITH: "ew"
      };
      const LogicType = {
        AND: "and",
        OR: "or"
      };
      const SearchType = {
        ANY: "any",
        ORDERED: "ordered"
      };
      function isObjectOrUndefined(value) {
        return typeof value === "object" || typeof value === "undefined";
      }
      function createEquals() {
        return {
          matches: (context, key, values = []) => {
            if (isObjectOrUndefined(context[key])) {
              return false;
            }
            const contextValue = String(context[key]).toLowerCase();
            for (let i = 0; i < values.length; i += 1) {
              if (!isObjectOrUndefined(values[i]) && contextValue === String(values[i]).toLowerCase()) {
                return true;
              }
            }
            return false;
          }
        };
      }
      function createNotEquals() {
        return {
          matches: (context, key, values = []) => {
            if (isObjectOrUndefined(context[key])) {
              return false;
            }
            const contextValue = String(context[key]).toLowerCase();
            for (let i = 0; i < values.length; i += 1) {
              if (!isObjectOrUndefined(values[i]) && contextValue === String(values[i]).toLowerCase()) {
                return false;
              }
            }
            return true;
          }
        };
      }
      function createExists() {
        return {
          matches: (context, key) => {
            return typeof context[key] !== "undefined" && context[key] !== null;
          }
        };
      }
      function createNotExists() {
        return {
          matches: (context, key) => {
            return typeof context[key] === "undefined" || context[key] === null;
          }
        };
      }
      function isNumber(value) {
        return typeof value === "number";
      }
      function createGreaterThan() {
        return {
          matches: (context, key, values = []) => {
            const needle = context[key];
            if (!isNumber(needle)) {
              return false;
            }
            for (let i = 0; i < values.length; i += 1) {
              if (isNumber(values[i]) && needle > values[i]) {
                return true;
              }
            }
            return false;
          }
        };
      }
      function createGreaterThanEquals() {
        return {
          matches: (context, key, values = []) => {
            const needle = context[key];
            if (!isNumber(needle)) {
              return false;
            }
            for (let i = 0; i < values.length; i += 1) {
              if (isNumber(values[i]) && needle >= values[i]) {
                return true;
              }
            }
            return false;
          }
        };
      }
      function createLessThan() {
        return {
          matches: (context, key, values = []) => {
            const needle = context[key];
            if (!isNumber(needle)) {
              return false;
            }
            for (let i = 0; i < values.length; i += 1) {
              if (isNumber(values[i]) && needle < values[i]) {
                return true;
              }
            }
            return false;
          }
        };
      }
      function createLessThanEquals() {
        return {
          matches: (context, key, values = []) => {
            const needle = context[key];
            if (!isNumber(needle)) {
              return false;
            }
            for (let i = 0; i < values.length; i += 1) {
              if (isNumber(values[i]) && needle <= values[i]) {
                return true;
              }
            }
            return false;
          }
        };
      }
      function createContains() {
        return {
          matches: (context, key, values = []) => {
            if (isObjectOrUndefined(context[key])) {
              return false;
            }
            const contextValue = String(context[key]).toLowerCase();
            for (let i = 0; i < values.length; i += 1) {
              if (!isObjectOrUndefined(values[i]) && contextValue.indexOf(String(values[i]).toLowerCase()) !== -1) {
                return true;
              }
            }
            return false;
          }
        };
      }
      function createNotContains() {
        return {
          matches: (context, key, values = []) => {
            if (isObjectOrUndefined(context[key])) {
              return false;
            }
            const contextValue = String(context[key]).toLowerCase();
            for (let i = 0; i < values.length; i += 1) {
              if (!isObjectOrUndefined(values[i]) && contextValue.indexOf(String(values[i]).toLowerCase()) !== -1) {
                return false;
              }
            }
            return true;
          }
        };
      }
      function createStartsWith() {
        return {
          matches: (context, key, values = []) => {
            if (isObjectOrUndefined(context[key])) {
              return false;
            }
            const contextValue = String(context[key]).toLowerCase();
            for (let i = 0; i < values.length; i += 1) {
              if (!isObjectOrUndefined(values[i]) && contextValue.startsWith(String(values[i]).toLowerCase())) {
                return true;
              }
            }
            return false;
          }
        };
      }
      function createEndsWith() {
        return {
          matches: (context, key, values = []) => {
            if (isObjectOrUndefined(context[key])) {
              return false;
            }
            const contextValue = String(context[key]).toLowerCase();
            for (let i = 0; i < values.length; i += 1) {
              if (!isObjectOrUndefined(values[i]) && contextValue.endsWith(values[i].toLowerCase())) {
                return true;
              }
            }
            return false;
          }
        };
      }
      const MATCHERS = {
        [MatcherType.EQUALS]: createEquals(),
        [MatcherType.NOT_EQUALS]: createNotEquals(),
        [MatcherType.EXISTS]: createExists(),
        [MatcherType.NOT_EXISTS]: createNotExists(),
        [MatcherType.GREATER_THAN]: createGreaterThan(),
        [MatcherType.GREATER_THAN_OR_EQUAL_TO]: createGreaterThanEquals(),
        [MatcherType.LESS_THAN]: createLessThan(),
        [MatcherType.LESS_THAN_OR_EQUAL_TO]: createLessThanEquals(),
        [MatcherType.CONTAINS]: createContains(),
        [MatcherType.NOT_CONTAINS]: createNotContains(),
        [MatcherType.STARTS_WITH]: createStartsWith(),
        [MatcherType.ENDS_WITH]: createEndsWith()
      };
      function getMatcher(key) {
        return MATCHERS[key];
      }
      function isUndefined(value) {
        return typeof value === "undefined";
      }
      const IAM_ID = "iam.id";
      const ID = "id";
      const IAM_EVENT_TYPE = "iam.eventType";
      const EVENT_TYPE = "eventType";
      const TYPE = "type";
      const VALID_EVENT_TYPES = [IAM_EVENT_TYPE, EVENT_TYPE, TYPE];
      const VALID_EVENT_IDS = [IAM_ID, ID];
      function checkForHistoricalMatcher(eventCount, matcherKey, value) {
        switch (matcherKey) {
          case MatcherType.GREATER_THAN:
            return eventCount > value;
          case MatcherType.GREATER_THAN_OR_EQUAL_TO:
            return eventCount >= value;
          case MatcherType.LESS_THAN:
            return eventCount < value;
          case MatcherType.LESS_THAN_OR_EQUAL_TO:
            return eventCount <= value;
          case MatcherType.EQUALS:
            return eventCount === value;
          case MatcherType.NOT_EQUALS:
            return eventCount !== value;
          default:
            return false;
        }
      }
      function oneOf(context, properties) {
        for (let i = 0; i < properties.length; i += 1) {
          if (!isUndefined(context[properties[i]])) {
            return context[properties[i]];
          }
        }
        return undefined;
      }
      function eventSatisfiesCondition(historicalEventCondition, eventContext) {
        const eventKeys = Object.keys(historicalEventCondition);
        for (let i = 0; i < eventKeys.length; i += 1) {
          const key = eventKeys[i];
          const {
            event = {}
          } = eventContext;
          if (event[eventKeys[i]] !== historicalEventCondition[key]) {
            return false;
          }
        }
        return true;
      }
      function queryAndCountAnyEvent(events, context, from, to) {
        return events.reduce((countTotal, event) => {
          const eventType = oneOf(event, VALID_EVENT_TYPES);
          if (!eventType) {
            return countTotal;
          }
          const eventsOfType = context.events[eventType];
          if (!eventsOfType) {
            return countTotal;
          }
          const eventId = oneOf(event, VALID_EVENT_IDS);
          if (!eventId) {
            return countTotal;
          }
          const contextEvent = eventsOfType[eventId];
          if (!contextEvent) {
            return countTotal;
          }
          if (!eventSatisfiesCondition(event, contextEvent)) {
            return countTotal;
          }
          const {
            count: eventCount = 1
          } = contextEvent;
          if (isUndefined(from) || isUndefined(to) || contextEvent.timestamp >= from && contextEvent.timestamp <= to) {
            return countTotal + eventCount;
          }
          return countTotal;
        }, 0);
      }
      function queryAndCountOrderedEvent(events, context, from, to) {
        let previousEventTimestamp = from;
        const sameSequence = events.every(event => {
          const eventType = oneOf(event, VALID_EVENT_TYPES);
          if (!eventType) {
            return false;
          }
          const eventsOfType = context.events[eventType];
          if (!eventsOfType) {
            return false;
          }
          const eventId = oneOf(event, VALID_EVENT_IDS);
          if (!eventId) {
            return false;
          }
          const contextEvent = eventsOfType[eventId];
          if (!eventSatisfiesCondition(event, contextEvent)) {
            return false;
          }
          if (contextEvent === null || isUndefined(contextEvent) || contextEvent.count === 0) {
            return false;
          }
          const ordered = (isUndefined(previousEventTimestamp) || contextEvent.timestamp >= previousEventTimestamp) && (isUndefined(to) || contextEvent.timestamp <= to);
          previousEventTimestamp = contextEvent.timestamp;
          return ordered;
        });
        return sameSequence ? 1 : 0;
      }
      function evaluateAnd(context, conditions) {
        let result = true;
        for (let i = 0; i < conditions.length; i += 1) {
          result = result && conditions[i].evaluate(context);
        }
        return result;
      }
      function evaluateOr(context, conditions) {
        let result = false;
        for (let i = 0; i < conditions.length; i += 1) {
          result = result || conditions[i].evaluate(context);
          if (result) {
            return true;
          }
        }
        return false;
      }
      function createRules(version, rules) {
        return {
          version,
          rules
        };
      }
      function createRule(condition, consequences) {
        return {
          execute: context => {
            if (condition.evaluate(context)) {
              return consequences;
            }
            return [];
          },
          toString: () => {
            return "Rule{condition=" + condition + ", consequences=" + consequences + "}";
          }
        };
      }
      function createCondition(type, definition) {
        return {
          evaluate: context => {
            return definition.evaluate(context);
          },
          toString() {
            return "Condition{type=" + type + ", definition=" + definition + "}";
          }
        };
      }
      function createConsequence(id, type, detail) {
        return {
          id,
          type,
          detail
        };
      }
      function createGroupDefinition(logic, conditions) {
        return {
          evaluate: context => {
            if (LogicType.AND === logic) {
              return evaluateAnd(context, conditions);
            }
            if (LogicType.OR === logic) {
              return evaluateOr(context, conditions);
            }
            return false;
          }
        };
      }
      function createMatcherDefinition(key, matcherKey, values) {
        return {
          evaluate: context => {
            const matcher = getMatcher(matcherKey);
            if (!matcher) {
              return false;
            }
            return matcher.matches(context, key, values);
          }
        };
      }
      function createHistoricalDefinition(events, matcherKey, value, from, to, searchType) {
        return {
          evaluate: context => {
            let eventCount;
            if (SearchType.ORDERED === searchType) {
              eventCount = queryAndCountOrderedEvent(events, context, from, to);
            } else {
              eventCount = queryAndCountAnyEvent(events, context, from, to);
            }
            return checkForHistoricalMatcher(eventCount, matcherKey, value);
          }
        };
      }
      function parseMatcherDefinition(definition) {
        const {
          key,
          matcher,
          values
        } = definition;
        return createMatcherDefinition(key, matcher, values);
      }
      function parseGroupDefinition(definition) {
        const {
          logic,
          conditions
        } = definition;
        return createGroupDefinition(logic, conditions.map(parseCondition));
      }
      function parseHistoricalDefinition(definition) {
        const {
          events,
          from,
          to,
          matcher,
          value,
          searchType
        } = definition;
        return createHistoricalDefinition(events, matcher, value, from, to, searchType);
      }
      function parseCondition(condition) {
        const {
          type,
          definition
        } = condition;
        if (ConditionType.MATCHER === type) {
          return createCondition(type, parseMatcherDefinition(definition));
        }
        if (ConditionType.GROUP === type) {
          return createCondition(type, parseGroupDefinition(definition));
        }
        if (ConditionType.HISTORICAL === type) {
          return createCondition(type, parseHistoricalDefinition(definition));
        }
        throw new Error("Can not parse condition");
      }
      function parseConsequence(consequence) {
        const {
          id,
          type,
          detail
        } = consequence;
        return createConsequence(id, type, detail);
      }
      function parseRule(rule) {
        const {
          condition,
          consequences
        } = rule;
        return createRule(parseCondition(condition), consequences.map(parseConsequence));
      }
      function parseRules(ruleset) {
        const {
          version,
          rules
        } = ruleset;
        return createRules(version, rules.map(parseRule));
      }
      function RulesEngine(ruleset) {
        const {
          version,
          rules
        } = parseRules(ruleset);
        return {
          execute: context => rules.map(rule => rule.execute(context)).filter(arr => arr.length > 0),
          getVersion: () => version,
          numRules: () => rules.length
        };
      }

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const DEFAULT_CONTENT_ITEM = "https://ns.adobe.com/personalization/default-content-item";
      const DOM_ACTION = "https://ns.adobe.com/personalization/dom-action";
      const HTML_CONTENT_ITEM = "https://ns.adobe.com/personalization/html-content-item";
      const JSON_CONTENT_ITEM = "https://ns.adobe.com/personalization/json-content-item";
      const RULESET_ITEM = "https://ns.adobe.com/personalization/ruleset-item";
      const REDIRECT_ITEM = "https://ns.adobe.com/personalization/redirect-item";
      const MESSAGE_IN_APP = "https://ns.adobe.com/personalization/message/in-app";
      const MESSAGE_CONTENT_CARD = "https://ns.adobe.com/personalization/message/content-card";

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const DISPLAY = "decisioning.propositionDisplay";
      const INTERACT = "decisioning.propositionInteract";
      const TRIGGER = "decisioning.propositionTrigger";
      const DISMISS = "decisioning.propositionDismiss";
      const EVENT_TYPE_TRUE = 1;

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createRestoreStorage = (storage, storageKey) => {
        return defaultValue => {
          const stored = storage.getItem(storageKey);
          if (!stored) {
            return defaultValue;
          }
          try {
            return JSON.parse(stored);
          } catch (e) {
            return defaultValue;
          }
        };
      };
      const createSaveStorage = (storage, storageKey, prepareFn = value => value) => {
        return value => {
          storage.setItem(storageKey, JSON.stringify(prepareFn(value)));
        };
      };
      const getExpirationDate = retentionPeriod => {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() - retentionPeriod);
        return expirationDate;
      };
      const getActivityId = proposition => {
        const {
          scopeDetails = {}
        } = proposition;
        const {
          activity = {}
        } = scopeDetails;
        const {
          id
        } = activity;
        return id;
      };
      const createInMemoryStorage = () => {
        const inMemoryStorage = {};
        return {
          getItem: key => {
            return key in inMemoryStorage ? inMemoryStorage[key] : null;
          },
          setItem: (key, value) => {
            inMemoryStorage[key] = value;
          }
        };
      };
      const clearLocalStorage = storage => {
        storage.clear();
      };
      const hasExperienceData = (xdm = {}) => {
        const {
          _experience
        } = xdm;
        return !(!_experience || typeof _experience !== "object");
      };
      const getDecisionProvider = proposition => {
        const {
          scopeDetails = {}
        } = proposition;
        const {
          decisionProvider
        } = scopeDetails;
        return decisionProvider;
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const flattenArray = (items = []) => {
        const flat = [];
        if (!Array.isArray(items)) {
          return items;
        }
        items.forEach(item => {
          if (Array.isArray(item)) {
            flat.push(...flattenArray(item));
          } else {
            flat.push(item);
          }
        });
        return flat;
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const TEXT_HTML = "text/html";
      const APPLICATION_JSON = "application/json";

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var inAppMessageConsequenceAdapter = (id, type, detail) => {
        const {
          html,
          mobileParameters
        } = detail;
        const webParameters = {};
        return {
          schema: MESSAGE_IN_APP,
          data: {
            mobileParameters,
            webParameters,
            content: html,
            contentType: TEXT_HTML
          },
          id
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var schemaTypeConsequenceAdapter = (id, type, detail) => {
        const {
          schema,
          data,
          id: detailId
        } = detail;
        return {
          schema,
          data,
          id: detailId || id
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const CJM_IN_APP_MESSAGE_TYPE = "cjmiam";
      const SCHEMA = "schema";
      const adapters = {
        [CJM_IN_APP_MESSAGE_TYPE]: inAppMessageConsequenceAdapter,
        [SCHEMA]: schemaTypeConsequenceAdapter
      };
      var createConsequenceAdapter = () => {
        return consequence => {
          const {
            id,
            type,
            detail
          } = consequence;
          return typeof adapters[type] === "function" ? adapters[type](id, type, detail) : detail;
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const isRulesetItem = item => {
        const {
          schema,
          data
        } = item;
        if (schema === RULESET_ITEM) {
          return true;
        }
        if (schema !== JSON_CONTENT_ITEM) {
          return false;
        }
        try {
          const content = typeof data.content === "string" ? JSON.parse(data.content) : data.content;
          return content && Object.prototype.hasOwnProperty.call(content, "version") && Object.prototype.hasOwnProperty.call(content, "rules");
        } catch (error) {
          return false;
        }
      };
      var createEvaluableRulesetPayload = (payload, eventRegistry, decisionHistory) => {
        const consequenceAdapter = createConsequenceAdapter();
        const activityId = getActivityId(payload);
        const items = [];
        const addItem = item => {
          const {
            data = {},
            schema
          } = item;
          const content = schema === RULESET_ITEM ? data : data.content;
          if (!content) {
            return;
          }
          items.push(RulesEngine(typeof content === "string" ? JSON.parse(content) : content));
        };
        const evaluate = context => {
          const displayEvent = eventRegistry.getEvent(DISPLAY, activityId);
          const displayedDate = displayEvent ? displayEvent.firstTimestamp : undefined;
          const qualifyingItems = flattenArray(items.map(item => item.execute(context))).map(consequenceAdapter).map(item => {
            const {
              firstTimestamp: qualifiedDate
            } = decisionHistory.recordQualified(activityId) || {};
            return {
              ...item,
              data: {
                ...item.data,
                qualifiedDate,
                displayedDate
              }
            };
          });
          return {
            ...payload,
            items: qualifyingItems
          };
        };
        if (Array.isArray(payload.items)) {
          payload.items.filter(isRulesetItem).forEach(addItem);
        }
        return {
          evaluate,
          isEvaluable: items.length > 0
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const PropositionEventType = {
        DISPLAY: "display",
        INTERACT: "interact",
        TRIGGER: "trigger",
        DISMISS: "dismiss"
      };
      const eventTypeToPropositionEventTypeMapping = {
        [DISPLAY]: PropositionEventType.DISPLAY,
        [INTERACT]: PropositionEventType.INTERACT,
        [TRIGGER]: PropositionEventType.TRIGGER,
        [DISMISS]: PropositionEventType.DISMISS
      };
      const propositionEventTypeToEventTypeMapping = {
        [PropositionEventType.DISPLAY]: DISPLAY,
        [PropositionEventType.INTERACT]: INTERACT,
        [PropositionEventType.TRIGGER]: TRIGGER,
        [PropositionEventType.DISMISS]: DISMISS
      };
      const getPropositionEventType = eventType => eventTypeToPropositionEventTypeMapping[eventType];
      const getEventType = propositionEventType => propositionEventTypeToEventTypeMapping[propositionEventType];

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createDecisionHistory = ({
        eventRegistry
      }) => {
        const recordQualified = id => {
          if (!id) {
            return undefined;
          }
          return eventRegistry.addEvent({}, PropositionEventType.TRIGGER, id);
        };
        return {
          recordQualified
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createDecisionProvider = ({
        eventRegistry
      }) => {
        const payloadsBasedOnActivityId = {};
        const decisionHistory = createDecisionHistory({
          eventRegistry
        });
        const addPayload = payload => {
          const activityId = getActivityId(payload);
          if (!activityId) {
            return;
          }
          const evaluableRulesetPayload = createEvaluableRulesetPayload(payload, eventRegistry, decisionHistory);
          if (evaluableRulesetPayload.isEvaluable) {
            payloadsBasedOnActivityId[activityId] = evaluableRulesetPayload;
          }
        };
        const evaluate = (context = {}) => Object.values(payloadsBasedOnActivityId).map(payload => payload.evaluate(context)).filter(payload => payload.items.length > 0);
        const addPayloads = personalizationPayloads => {
          personalizationPayloads.forEach(addPayload);
        };
        return {
          addPayload,
          addPayloads,
          evaluate
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createApplyResponse = lifecycle => {
        return ({
          renderDecisions = false,
          propositions = [],
          event,
          personalization
        }) => {
          if (lifecycle) {
            lifecycle.onDecision({
              renderDecisions,
              propositions,
              event,
              personalization
            });
          }
          return {
            propositions
          };
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const ADOBE_JOURNEY_OPTIMIZER = "AJO";
      const ADOBE_TARGET = "TGT";

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const STORAGE_KEY = "events";
      const MAX_EVENT_RECORDS = 1000;
      const RETENTION_PERIOD = 30;
      const prefixed = key => "iam." + key;
      const createEventPruner = (limit = MAX_EVENT_RECORDS, retentionPeriod = RETENTION_PERIOD) => {
        return events => {
          const pruned = {};
          Object.keys(events).forEach(eventType => {
            pruned[eventType] = {};
            Object.values(events[eventType]).filter(entry => new Date(entry.firstTimestamp) >= getExpirationDate(retentionPeriod)).sort((a, b) => a.firstTimestamp - b.firstTimestamp).slice(-1 * limit).forEach(entry => {
              pruned[eventType][entry.event[prefixed("id")]] = entry;
            });
          });
          return pruned;
        };
      };
      var createEventRegistry = ({
        storage
      }) => {
        let currentStorage = storage;
        let restore;
        let save;
        let events;
        const setStorage = newStorage => {
          currentStorage = newStorage;
          restore = createRestoreStorage(currentStorage, STORAGE_KEY);
          save = createSaveStorage(currentStorage, STORAGE_KEY, createEventPruner(MAX_EVENT_RECORDS, RETENTION_PERIOD));
          events = restore({});
        };
        setStorage(storage);
        const addEvent = (event, eventType, eventId, action) => {
          if (!eventType || !eventId) {
            return undefined;
          }
          if (!events[eventType]) {
            events[eventType] = {};
          }
          const existingEvent = events[eventType][eventId];
          const count = existingEvent ? existingEvent.count : 0;
          const timestamp = new Date().getTime();
          const firstTimestamp = existingEvent ? existingEvent.firstTimestamp || existingEvent.timestamp : timestamp;
          events[eventType][eventId] = {
            event: {
              ...event,
              [prefixed("id")]: eventId,
              [prefixed("eventType")]: eventType,
              [prefixed("action")]: action
            },
            firstTimestamp,
            timestamp,
            count: count + 1
          };
          save(events);
          return events[eventType][eventId];
        };
        const addExperienceEdgeEvent = event => {
          const {
            xdm = {}
          } = event.getContent();
          const {
            _experience
          } = xdm;
          if (!hasExperienceData(xdm)) {
            return;
          }
          const {
            decisioning = {}
          } = _experience;
          const {
            propositionEventType: propositionEventTypeObj = {},
            propositionAction = {},
            propositions = []
          } = decisioning;
          const propositionEventTypesList = Object.keys(propositionEventTypeObj);

          // https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=CJM&title=Proposition+Event+Types
          if (propositionEventTypesList.length === 0) {
            return;
          }
          const validPropositionEventType = propositionEventType => propositionEventTypeObj[propositionEventType] === EVENT_TYPE_TRUE;
          const {
            id: action
          } = propositionAction;
          propositionEventTypesList.filter(validPropositionEventType).forEach(propositionEventType => {
            propositions.forEach(proposition => {
              if (getDecisionProvider(proposition) !== ADOBE_JOURNEY_OPTIMIZER) {
                return;
              }
              addEvent({}, propositionEventType, getActivityId(proposition), action);
            });
          });
        };
        const getEvent = (eventType, eventId) => {
          if (!events[eventType]) {
            return undefined;
          }
          return events[eventType][eventId];
        };
        return {
          addExperienceEdgeEvent,
          addEvent,
          getEvent,
          toJSON: () => events,
          setStorage
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createContextProvider = ({
        eventRegistry,
        window,
        getBrowser
      }) => {
        const pageLoadTimestamp = new Date().getTime();
        const getBrowserContext = () => {
          return {
            name: getBrowser()
          };
        };
        const getPageContext = () => {
          return {
            title: window.title,
            url: window.url,
            ...parseUrl(window.url)
          };
        };
        const getReferrerContext = () => {
          return {
            url: window.referrer,
            ...parseUrl(window.referrer)
          };
        };
        const getTimeContext = () => {
          const now = new Date();
          const currentTimestamp = now.getTime();
          return {
            pageLoadTimestamp,
            currentTimestamp,
            currentDate: now.getDate(),
            // Day of the week starts on Monday as is practiced in ISO 8601, but we want it to start on Sunday to match the authoring UI rule
            "~state.com.adobe.module.lifecycle/lifecyclecontextdata.dayofweek": now.getDay() + 1,
            "~state.com.adobe.module.lifecycle/lifecyclecontextdata.hourofday": now.getHours(),
            currentMinute: now.getMinutes(),
            currentMonth: now.getMonth(),
            currentYear: now.getFullYear(),
            pageVisitDuration: currentTimestamp - pageLoadTimestamp,
            "~timestampu": currentTimestamp / 1000,
            "~timestampz": now.toISOString()
          };
        };
        const getWindowContext = () => {
          const height = window.height;
          const width = window.width;
          const scrollY = window.scrollY;
          const scrollX = window.scrollX;
          return {
            height,
            width,
            scrollY,
            scrollX
          };
        };
        const coreGlobalContext = {
          browser: getBrowserContext(),
          page: getPageContext(),
          referringPage: getReferrerContext()
        };
        const getGlobalContext = () => {
          return {
            ...coreGlobalContext,
            ...getTimeContext(),
            window: getWindowContext(),
            "~sdkver": libraryVersion
          };
        };
        const getContext = (addedContext = {}) => {
          const context = {
            ...getGlobalContext(),
            ...addedContext
          };
          return {
            ...flattenObject$1(context),
            events: eventRegistry.toJSON()
          };
        };
        return {
          getContext
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const defaultPreprocessor = (params, ...args) => {
        return args;
      };

      // eslint-disable-next-line no-unused-vars
      const defaultEmissionCondition = (params, ...args) => true;
      const createSubscription = () => {
        let preprocessor = defaultPreprocessor;
        let emissionCondition = defaultEmissionCondition;
        let counter = 0;
        const subscriptions = {};
        const createUnsubscribe = id => {
          return () => {
            delete subscriptions[id];
          };
        };
        const add = (callback, params = undefined) => {
          if (typeof callback !== "function") {
            return () => undefined;
          }
          counter += 1;
          subscriptions[counter] = {
            callback,
            params
          };
          return {
            id: counter,
            unsubscribe: createUnsubscribe(counter)
          };
        };
        const setEmissionPreprocessor = value => {
          if (typeof value === "function") {
            preprocessor = value;
          }
        };
        const setEmissionCondition = value => {
          if (typeof value === "function") {
            emissionCondition = value;
          }
        };
        const emit = (...args) => {
          Object.values(subscriptions).forEach(({
            callback,
            params
          }) => {
            const result = preprocessor(params, ...args);
            if (emissionCondition(params, ...result)) {
              callback(...result);
            }
          });
        };
        const emitOne = (subscriptionId, ...args) => {
          if (!subscriptionId || !subscriptions[subscriptionId]) {
            return;
          }
          const {
            callback,
            params
          } = subscriptions[subscriptionId];
          const result = preprocessor(params, ...args);
          if (emissionCondition(params, ...result)) {
            callback(...result);
          }
        };
        const hasSubscriptions = () => Object.keys(subscriptions).length > 0;
        return {
          add,
          emit,
          emitOne,
          hasSubscriptions,
          setEmissionPreprocessor,
          setEmissionCondition
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const validateOptions$1 = ({
        options
      }) => {
        const validator = boundObjectOf({
          surfaces: boundArrayOf(boundString()).uniqueItems(),
          schemas: boundArrayOf(boundString()).uniqueItems(),
          callback: boundCallback().required()
        }).noUnknownFields();
        return validator(options);
      };
      const getAnalyticsDetail = proposition => {
        const {
          id,
          scope,
          scopeDetails
        } = proposition;
        return {
          id,
          scope,
          scopeDetails
        };
      };
      var createSubscribeRulesetItems = ({
        collect
      }) => {
        let emitPropositions = () => undefined;
        const collectedEventsThisSession = new Set();
        const shouldAlwaysCollect = propositionEventType => [PropositionEventType.INTERACT, PropositionEventType.DISMISS].includes(propositionEventType);
        const shouldCollect = (propositionEventType, analyticsMetaId, collectedEventsThisRequest) => {
          const eventId = [propositionEventType, analyticsMetaId].join("-");
          const result = !collectedEventsThisRequest.has(eventId) && (shouldAlwaysCollect(propositionEventType) || !collectedEventsThisSession.has(eventId));
          collectedEventsThisRequest.add(eventId);
          collectedEventsThisSession.add(eventId);
          return result;
        };
        const collectEvent = (propositionEventType, propositions = []) => {
          if (!(propositions instanceof Array)) {
            return Promise.resolve();
          }
          if (!Object.values(PropositionEventType).includes(propositionEventType)) {
            return Promise.resolve();
          }
          const decisionsMeta = [];
          const collectedEventsThisRequest = new Set();
          propositions.forEach(proposition => {
            const analyticsMeta = getAnalyticsDetail(proposition);
            if (!shouldCollect(propositionEventType, analyticsMeta.id, collectedEventsThisRequest)) {
              return;
            }
            decisionsMeta.push(analyticsMeta);
          });
          return decisionsMeta.length > 0 ? collect({
            decisionsMeta,
            eventType: getEventType(propositionEventType),
            documentMayUnload: true
          }) : Promise.resolve();
        };
        const subscriptions = createSubscription();
        const emissionPreprocessor = (params, propositions) => {
          const {
            surfacesFilter,
            schemasFilter
          } = params;
          const result = {
            propositions: propositions.filter(payload => surfacesFilter ? surfacesFilter.includes(payload.scope) : true).map(payload => {
              const {
                items = []
              } = payload;
              return {
                ...payload,
                items: items.filter(item => schemasFilter ? schemasFilter.includes(item.schema) : true)
              };
            }).filter(payload => payload.items.length > 0)
          };
          return [result, collectEvent];
        };
        subscriptions.setEmissionPreprocessor(emissionPreprocessor);
        const run = ({
          surfaces,
          schemas,
          callback
        }) => {
          const {
            id,
            unsubscribe
          } = subscriptions.add(callback, {
            surfacesFilter: surfaces instanceof Array ? surfaces : undefined,
            schemasFilter: schemas instanceof Array ? schemas : undefined
          });
          emitPropositions(id);
          return Promise.resolve({
            unsubscribe
          });
        };
        const optionsValidator = options => validateOptions$1({
          options
        });
        const refresh = propositions => {
          emitPropositions = subscriptionId => {
            if (subscriptionId) {
              subscriptions.emitOne(subscriptionId, propositions);
              return;
            }
            subscriptions.emit(propositions);
          };
          emitPropositions();
        };
        return {
          refresh,
          command: {
            optionsValidator,
            run
          }
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const CONTEXT_KEY = {
        TYPE: "~type",
        SOURCE: "~source"
      };
      const CONTEXT_EVENT_TYPE = {
        LIFECYCLE: "com.adobe.eventType.lifecycle",
        TRACK: "com.adobe.eventType.generic.track",
        EDGE: "com.adobe.eventType.edge",
        RULES_ENGINE: "com.adobe.eventType.rulesEngine"
      };
      const CONTEXT_EVENT_SOURCE = {
        LAUNCH: "com.adobe.eventSource.applicationLaunch",
        REQUEST: "com.adobe.eventSource.requestContent"
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const validateOptions = ({
        options
      }) => {
        const validator = boundObjectOf({
          renderDecisions: boundBoolean(),
          personalization: boundObjectOf({
            decisionContext: boundObjectOf({})
          })
        }).noUnknownFields();
        return validator(options);
      };
      var createEvaluateRulesetsCommand = ({
        contextProvider,
        decisionProvider
      }) => {
        const run = ({
          renderDecisions,
          decisionContext,
          applyResponse
        }) => {
          return applyResponse({
            renderDecisions,
            propositions: decisionProvider.evaluate(contextProvider.getContext(decisionContext))
          });
        };
        const optionsValidator = options => validateOptions({
          options
        });
        return {
          optionsValidator,
          run
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createCollect = ({
        eventManager,
        mergeDecisionsMeta
      }) => {
        // Called when a decision is auto-rendered for the __view__ scope or a SPA view(display and empty display notification)
        return ({
          decisionsMeta = [],
          propositionAction,
          documentMayUnload = false,
          eventType = DISPLAY,
          propositionEventTypes = [getPropositionEventType(eventType)],
          viewName
        }) => {
          const event = eventManager.createEvent();
          const data = {
            eventType
          };
          if (viewName) {
            data.web = {
              webPageDetails: {
                viewName
              }
            };
          }
          if (isNonEmptyArray(decisionsMeta)) {
            mergeDecisionsMeta(event, decisionsMeta, propositionEventTypes, propositionAction);
          }
          event.mergeXdm(data);
          if (documentMayUnload) {
            event.documentMayUnload();
          }
          return eventManager.sendEvent(event);
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /* eslint-disable no-underscore-dangle */
      const mergeDecisionsMeta = (event, decisionsMeta, propositionEventTypes, propositionAction) => {
        // Do not send a display notification with no decisions. Even empty view changes
        // should include a proposition.
        if (decisionsMeta.length === 0) {
          return;
        }
        const propositionEventType = {};
        propositionEventTypes.forEach(type => {
          propositionEventType[type] = EVENT_TYPE_TRUE;
        });
        const xdm = {
          _experience: {
            decisioning: {
              propositions: decisionsMeta,
              propositionEventType
            }
          }
        };
        if (propositionAction) {
          xdm._experience.decisioning.propositionAction = propositionAction;
        }
        event.mergeXdm(xdm);
      };
      const mergeQuery = (event, details) => {
        event.mergeQuery({
          personalization: {
            ...details
          }
        });
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const createDecisioningEngine = ({
        config,
        eventManager,
        createNamespacedStorage,
        consent,
        getBrowser
      }) => {
        const {
          orgId,
          personalizationStorageEnabled
        } = config;
        const collect = createCollect({
          eventManager,
          mergeDecisionsMeta
        });
        const storage = createNamespacedStorage(sanitizeOrgIdForCookieName(orgId) + ".decisioning.");
        if (!personalizationStorageEnabled) {
          clearLocalStorage(storage.persistent);
        }
        const eventRegistry = createEventRegistry({
          storage: createInMemoryStorage()
        });
        const decisionProvider = createDecisionProvider({
          eventRegistry
        });
        const contextProvider = createContextProvider({
          eventRegistry,
          window,
          getBrowser
        });
        const evaluateRulesetsCommand = createEvaluateRulesetsCommand({
          contextProvider,
          decisionProvider
        });
        const subscribeRulesetItems = createSubscribeRulesetItems({
          collect
        });
        let applyResponse;
        return {
          lifecycle: {
            onDecision({
              propositions
            }) {
              subscribeRulesetItems.refresh(propositions);
            },
            onComponentsRegistered(tools) {
              applyResponse = createApplyResponse(tools.lifecycle);
              if (personalizationStorageEnabled) {
                consent.awaitConsent().then(() => {
                  eventRegistry.setStorage(storage.persistent);
                }).catch(() => {
                  if (storage) {
                    clearLocalStorage(storage.persistent);
                  }
                });
              }
            },
            onBeforeEvent({
              event,
              renderDecisions,
              personalization = {},
              onResponse = noop
            }) {
              const {
                decisionContext = {}
              } = personalization;
              onResponse(createOnResponseHandler({
                renderDecisions,
                decisionProvider,
                applyResponse,
                event,
                personalization,
                decisionContext: contextProvider.getContext({
                  [CONTEXT_KEY.TYPE]: CONTEXT_EVENT_TYPE.EDGE,
                  [CONTEXT_KEY.SOURCE]: CONTEXT_EVENT_SOURCE.REQUEST,
                  ...decisionContext
                })
              }));
            },
            onBeforeRequest({
              request
            }) {
              const payload = request.getPayload().toJSON();
              const {
                events = []
              } = payload;
              if (events.length === 0) {
                return;
              }
              events.forEach(event => eventRegistry.addExperienceEdgeEvent(event));
            }
          },
          commands: {
            evaluateRulesets: {
              run: ({
                renderDecisions,
                personalization = {}
              }) => {
                const {
                  decisionContext = {}
                } = personalization;
                return evaluateRulesetsCommand.run({
                  renderDecisions,
                  decisionContext: {
                    [CONTEXT_KEY.TYPE]: CONTEXT_EVENT_TYPE.RULES_ENGINE,
                    [CONTEXT_KEY.SOURCE]: CONTEXT_EVENT_SOURCE.REQUEST,
                    ...decisionContext
                  },
                  applyResponse
                });
              },
              optionsValidator: evaluateRulesetsCommand.optionsValidator
            },
            subscribeRulesetItems: subscribeRulesetItems.command
          }
        };
      };
      createDecisioningEngine.namespace = "DecisioningEngine";
      createDecisioningEngine.configValidators = boundObjectOf({
        personalizationStorageEnabled: boundBoolean().default(false)
      });

      /*
      Copyright 20219 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createEventMergeId = () => {
        return {
          eventMergeId: v4()
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createComponent$2 = ({
        createEventMergeId
      }) => {
        return {
          commands: {
            createEventMergeId: {
              run: createEventMergeId
            }
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createEventMerge = () => {
        return createComponent$2({
          createEventMergeId
        });
      };
      createEventMerge.namespace = "EventMerge";

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var EventTypes = {
        PAUSE: "media.pauseStart",
        PLAY: "media.play",
        BUFFER_START: "media.bufferStart",
        AD_START: "media.adStart",
        Ad_BREAK_START: "media.adBreakStart",
        SESSION_END: "media.sessionEnd",
        SESSION_START: "media.sessionStart",
        SESSION_COMPLETE: "media.sessionComplete",
        PING: "media.ping",
        AD_BREAK_COMPLETE: "media.adBreakComplete",
        AD_COMPLETE: "media.adComplete",
        AD_SKIP: "media.adSkip",
        BITRATE_CHANGE: "media.bitrateChange",
        CHAPTER_COMPLETE: "media.chapterComplete",
        CHAPTER_SKIP: "media.chapterSkip",
        CHAPTER_START: "media.chapterStart",
        ERROR: "media.error",
        STATES_UPDATE: "media.statesUpdate"
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createMediaRequest = ({
        mediaRequestPayload,
        action
      }) => {
        return createRequest({
          payload: mediaRequestPayload,
          edgeSubPath: "/va",
          getAction() {
            return action;
          },
          getUseSendBeacon() {
            return false;
          }
        });
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createMediaEventManager = ({
        config,
        eventManager,
        consent,
        sendEdgeNetworkRequest,
        setTimestamp
      }) => {
        return {
          createMediaEvent({
            options
          }) {
            const event = eventManager.createEvent();
            const {
              xdm
            } = options;
            setTimestamp(xdm);
            event.setUserXdm(xdm);
            if (xdm.eventType === EventTypes.AD_START) {
              const {
                advertisingDetails
              } = options.xdm.mediaCollection;
              event.mergeXdm({
                mediaCollection: {
                  advertisingDetails: {
                    playerName: advertisingDetails.playerName || config.streamingMedia.playerName
                  }
                }
              });
            }
            return event;
          },
          createMediaSession(options) {
            const {
              playerName,
              channel,
              appVersion
            } = config.streamingMedia;
            const event = eventManager.createEvent();
            const {
              sessionDetails
            } = options.xdm.mediaCollection;
            event.setUserXdm(options.xdm);
            event.mergeXdm({
              eventType: EventTypes.SESSION_START,
              mediaCollection: {
                sessionDetails: {
                  playerName: sessionDetails.playerName || playerName,
                  channel: sessionDetails.channel || channel,
                  appVersion: sessionDetails.appVersion || appVersion
                }
              }
            });
            return event;
          },
          augmentMediaEvent({
            event,
            playerId,
            getPlayerDetails,
            sessionID
          }) {
            if (!playerId || !getPlayerDetails) {
              return event;
            }
            const {
              playhead,
              qoeDataDetails
            } = getPlayerDetails({
              playerId
            });
            event.mergeXdm({
              mediaCollection: {
                playhead: toInteger(playhead),
                qoeDataDetails,
                sessionID
              }
            });
            return event;
          },
          trackMediaSession({
            event,
            mediaOptions
          }) {
            return eventManager.sendEvent(event, {
              mediaOptions
            });
          },
          trackMediaEvent({
            event,
            action
          }) {
            const mediaRequestPayload = createDataCollectionRequestPayload();
            const request = createMediaRequest({
              mediaRequestPayload,
              action
            });
            mediaRequestPayload.addEvent(event);
            event.finalize();
            return consent.awaitConsent().then(() => {
              return sendEdgeNetworkRequest({
                request
              }).then(() => {
                return {};
              });
            });
          }
        };
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var PlaybackState = {
        MAIN: "main",
        AD: "ad",
        COMPLETED: "completed"
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createMediaSessionCacheManager = () => {
        let mediaSessionCache;
        const getSession = playerId => {
          return mediaSessionCache[playerId] || {};
        };
        const savePing = ({
          playerId,
          pingId,
          playbackState
        }) => {
          if (!mediaSessionCache[playerId]) {
            return;
          }
          if (mediaSessionCache[playerId].pingId) {
            clearTimeout(mediaSessionCache[playerId].pingId);
          }
          mediaSessionCache[playerId].pingId = pingId;
          mediaSessionCache[playerId].playbackState = playbackState;
        };
        const stopPing = ({
          playerId
        }) => {
          const sessionDetails = mediaSessionCache[playerId];
          if (!sessionDetails) {
            return;
          }
          clearTimeout(sessionDetails.pingId);
          sessionDetails.pingId = null;
          sessionDetails.playbackState = PlaybackState.COMPLETED;
        };
        const storeSession = ({
          playerId,
          sessionDetails
        }) => {
          if (mediaSessionCache === undefined) {
            mediaSessionCache = {};
          }
          mediaSessionCache[playerId] = sessionDetails;
        };
        return {
          getSession,
          storeSession,
          stopPing,
          savePing
        };
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const getContentState = (eventType, sessionContentState) => {
        if (eventType === EventTypes.AD_START || eventType === EventTypes.Ad_BREAK_START || eventType === EventTypes.AD_SKIP || eventType === EventTypes.AD_COMPLETE) {
          return "ad";
        }
        if (eventType === EventTypes.AD_BREAK_COMPLETE || eventType === EventTypes.CHAPTER_COMPLETE || eventType === EventTypes.CHAPTER_START || eventType === EventTypes.CHAPTER_SKIP || eventType === EventTypes.SESSION_START) {
          return "main";
        }
        if (eventType === EventTypes.SESSION_END || eventType === EventTypes.SESSION_COMPLETE) {
          return "completed";
        }
        return sessionContentState;
      };
      var createTrackMediaEvent = ({
        mediaEventManager,
        mediaSessionCacheManager,
        config
      }) => {
        const sendMediaEvent = options => {
          const event = mediaEventManager.createMediaEvent({
            options
          });
          const {
            playerId,
            xdm
          } = options;
          const {
            eventType
          } = xdm;
          const action = eventType.split(".")[1];
          const {
            getPlayerDetails,
            sessionPromise,
            playbackState
          } = mediaSessionCacheManager.getSession(playerId);
          return sessionPromise.then(result => {
            if (!result.sessionId) {
              return Promise.reject(new Error("Failed to trigger media event: " + eventType + ". Session ID is not available for playerId: " + playerId + "."));
            }
            mediaEventManager.augmentMediaEvent({
              event,
              eventType,
              playerId,
              getPlayerDetails,
              sessionID: result.sessionId
            });
            return mediaEventManager.trackMediaEvent({
              event,
              action
            }).then(() => {
              if (playerId) {
                if (eventType === EventTypes.SESSION_COMPLETE || eventType === EventTypes.SESSION_END) {
                  mediaSessionCacheManager.stopPing({
                    playerId
                  });
                } else {
                  const sessionPlaybackState = getContentState(eventType, playbackState);
                  if (sessionPlaybackState === "completed") {
                    return;
                  }
                  const interval = sessionPlaybackState === "ad" ? config.streamingMedia.adPingInterval : config.streamingMedia.mainPingInterval;
                  const pingId = setTimeout(() => {
                    const pingOptions = {
                      playerId,
                      xdm: {
                        eventType: EventTypes.PING
                      }
                    };
                    sendMediaEvent(pingOptions);
                  }, interval * 1000);
                  mediaSessionCacheManager.savePing({
                    playerId,
                    pingId,
                    playbackState: sessionPlaybackState
                  });
                }
              }
            });
          });
        };
        return options => sendMediaEvent(options);
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createTrackMediaSession = ({
        config,
        mediaEventManager,
        mediaSessionCacheManager,
        legacy = false
      }) => {
        return options => {
          if (!config.streamingMedia) {
            return Promise.reject(new Error("Streaming media is not configured."));
          }
          const {
            playerId,
            getPlayerDetails
          } = options;
          const event = mediaEventManager.createMediaSession(options);
          mediaEventManager.augmentMediaEvent({
            event,
            playerId,
            getPlayerDetails
          });
          const sessionPromise = mediaEventManager.trackMediaSession({
            event,
            mediaOptions: {
              playerId,
              getPlayerDetails,
              legacy
            }
          });
          mediaSessionCacheManager.storeSession({
            playerId,
            sessionDetails: {
              sessionPromise,
              getPlayerDetails,
              playbackState: PlaybackState.MAIN
            }
          });
          return sessionPromise;
        };
      };

      /*
      Copyright 2021 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns whether a string value is blank. Also returns true if the value is not a string.
       * @param {*} value
       * @returns {boolean}
       */
      var isBlankString = value => isString(value) ? !value.trim() : true;

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createMediaResponseHandler = ({
        mediaSessionCacheManager,
        config,
        trackMediaEvent
      }) => {
        return ({
          response,
          playerId,
          getPlayerDetails
        }) => {
          const mediaPayload = response.getPayloadsByType("media-analytics:new-session");
          if (isNonEmptyArray(mediaPayload)) {
            const {
              sessionId
            } = mediaPayload[0];
            if (isBlankString(sessionId)) {
              return {};
            }
            if (!playerId || !getPlayerDetails) {
              return {
                sessionId
              };
            }
            const pingId = setTimeout(() => {
              trackMediaEvent({
                playerId,
                xdm: {
                  eventType: EventTypes.PING
                }
              });
            }, config.streamingMedia.mainPingInterval * 1000);
            mediaSessionCacheManager.savePing({
              playerId,
              pingId,
              playbackState: PlaybackState.MAIN
            });
            return {
              sessionId
            };
          }
          return {};
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const MEDIA_TYPE = {
        Video: "video",
        Audio: "audio"
      };
      const STREAM_TYPE = {
        VOD: "vod",
        Live: "live",
        Linear: "linear",
        Podcast: "podcast",
        Audiobook: "audiobook",
        AOD: "aod"
      };
      const PLAYER_STATE = {
        FullScreen: "fullScreen",
        ClosedCaption: "closedCaptioning",
        Mute: "mute",
        PictureInPicture: "pictureInPicture",
        InFocus: "inFocus"
      };
      const EVENT = {
        /**
         * Constant defining event type for AdBreak start
         */
        AdBreakStart: "adBreakStart",
        /**
         * Constant defining event type for AdBreak complete
         */
        AdBreakComplete: "adBreakComplete",
        /**
         * Constant defining event type for Ad start
         */
        AdStart: "adStart",
        /**
         * Constant defining event type for Ad complete
         */
        AdComplete: "adComplete",
        /**
         * Constant defining event type for Ad skip
         */
        AdSkip: "adSkip",
        /**
         * Constant defining event type for Chapter start
         */
        ChapterStart: "chapterStart",
        /**
         * Constant defining event type for Chapter complete
         */
        ChapterComplete: "chapterComplete",
        /**
         * Constant defining event type for Chapter skip
         */
        ChapterSkip: "chapterSkip",
        /**
         * Constant defining event type for Seek start
         */
        SeekStart: "seekStart",
        /**
         * Constant defining event type for Seek complete
         */
        SeekComplete: "seekComplete",
        /**
         * Constant defining event type for Buffer start
         */
        BufferStart: "bufferStart",
        /**
         * Constant defining event type for Buffer complete
         */
        BufferComplete: "bufferComplete",
        /**
         * Constant defining event type for change in Bitrate
         */
        BitrateChange: "bitrateChange",
        /**
         * Constant defining event type for Custom State Start
         */
        StateStart: "stateStart",
        /**
         * Constant defining event type for Custom State End
         */
        StateEnd: "stateEnd"
      };
      const MEDIA_EVENTS_INTERNAL = {
        SessionStart: "sessionStart",
        SessionEnd: "sessionEnd",
        SessionComplete: "sessionComplete",
        Play: "play",
        Pause: "pauseStart",
        Error: "error",
        StateUpdate: "statesUpdate"
      };
      const MEDIA_OBJECT_KEYS = {
        MediaResumed: "media.resumed",
        GranularAdTracking: "media.granularadtracking"
      };
      const VIDEO_METADATA_KEYS = {
        Show: "a.media.show",
        Season: "a.media.season",
        Episode: "a.media.episode",
        AssetId: "a.media.asset",
        Genre: "a.media.genre",
        FirstAirDate: "a.media.airDate",
        FirstDigitalDate: "a.media.digitalDate",
        Rating: "a.media.rating",
        Originator: "a.media.originator",
        Network: "a.media.network",
        ShowType: "a.media.type",
        AdLoad: "a.media.adLoad",
        MVPD: "a.media.pass.mvpd",
        Authorized: "a.media.pass.auth",
        DayPart: "a.media.dayPart",
        Feed: "a.media.feed",
        StreamFormat: "a.media.format"
      };
      const AUDIO_METADATA_KEYS = {
        Artist: "a.media.artist",
        Album: "a.media.album",
        Label: "a.media.label",
        Author: "a.media.author",
        Station: "a.media.station",
        Publisher: "a.media.publisher"
      };
      const AD_METADATA_KEYS = {
        Advertiser: "a.media.ad.advertiser",
        CampaignId: "a.media.ad.campaign",
        CreativeId: "a.media.ad.creative",
        PlacementId: "a.media.ad.placement",
        SiteId: "a.media.ad.site",
        CreativeUrl: "a.media.ad.creativeURL"
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createLegacyMediaComponent = ({
        trackMediaEvent,
        trackMediaSession,
        mediaResponseHandler,
        logger,
        createMediaHelper,
        createGetInstance,
        config
      }) => {
        return {
          lifecycle: {
            onBeforeEvent({
              mediaOptions,
              onResponse = noop
            }) {
              if (!mediaOptions) {
                return;
              }
              const {
                legacy,
                playerId,
                getPlayerDetails
              } = mediaOptions;
              if (!legacy) {
                return;
              }
              onResponse(({
                response
              }) => {
                return mediaResponseHandler({
                  playerId,
                  getPlayerDetails,
                  response
                });
              });
            }
          },
          commands: {
            getMediaAnalyticsTracker: {
              run: () => {
                if (!config.streamingMedia) {
                  return Promise.reject(new Error("Streaming media is not configured."));
                }
                logger.info("Streaming media is configured in legacy mode.");
                const mediaAnalyticsHelper = createMediaHelper({
                  logger
                });
                return Promise.resolve({
                  getInstance: () => {
                    return createGetInstance({
                      logger,
                      trackMediaEvent,
                      trackMediaSession,
                      uuid: v4
                    });
                  },
                  Event: EVENT,
                  MediaType: MEDIA_TYPE,
                  PlayerState: PLAYER_STATE,
                  StreamType: STREAM_TYPE,
                  MediaObjectKey: MEDIA_OBJECT_KEYS,
                  VideoMetadataKeys: VIDEO_METADATA_KEYS,
                  AudioMetadataKeys: AUDIO_METADATA_KEYS,
                  AdMetadataKeys: AD_METADATA_KEYS,
                  ...mediaAnalyticsHelper
                });
              }
            }
          }
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createMediaHelper = ({
        logger
      }) => {
        const createMediaObject = (friendlyName, name, length, contentType, streamType) => {
          const mediaObject = {
            friendlyName,
            name,
            length,
            streamType,
            contentType
          };
          const validate = boundObjectOf({
            friendlyName: boundString().nonEmpty(),
            name: boundString().nonEmpty(),
            length: boundNumber().required(),
            streamType: boundString().nonEmpty(),
            contentType: boundString().nonEmpty()
          });
          try {
            const result = validate(mediaObject);
            const sessionDetails = {
              name: result.name,
              friendlyName: result.friendlyName,
              length: result.length,
              streamType: result.streamType,
              contentType: result.contentType
            };
            return {
              sessionDetails
            };
          } catch (error) {
            logger.warn("An error occurred while creating the Media Object.", error);
            return {};
          }
        };
        const createAdBreakObject = (name, position, startTime) => {
          const adBreakObject = {
            friendlyName: name,
            offset: position,
            index: startTime
          };
          const validator = boundObjectOf({
            friendlyName: boundString().nonEmpty(),
            offset: boundNumber(),
            index: boundNumber()
          });
          try {
            const result = validator(adBreakObject);
            const advertisingPodDetails = {
              friendlyName: result.friendlyName,
              offset: result.offset,
              index: result.index
            };
            return {
              advertisingPodDetails
            };
          } catch (error) {
            logger.warn("An error occurred while creating the Ad Break Object.", error);
            return {};
          }
        };
        const createAdObject = (name, id, position, length) => {
          const adObject = {
            friendlyName: name,
            name: id,
            podPosition: position,
            length
          };
          const validator = boundObjectOf({
            friendlyName: boundString().nonEmpty(),
            name: boundString().nonEmpty(),
            podPosition: boundNumber(),
            length: boundNumber()
          });
          try {
            const result = validator(adObject);
            const advertisingDetails = {
              friendlyName: result.friendlyName,
              name: result.name,
              podPosition: result.podPosition,
              length: result.length
            };
            return {
              advertisingDetails
            };
          } catch (error) {
            logger.warn("An error occurred while creating the Advertising Object.", error);
            return {};
          }
        };
        const createChapterObject = (name, position, length, startTime) => {
          const chapterDetailsObject = {
            friendlyName: name,
            offset: position,
            length,
            index: startTime
          };
          const validator = boundObjectOf({
            friendlyName: boundString().nonEmpty(),
            offset: boundNumber(),
            length: boundNumber(),
            index: boundNumber()
          });
          try {
            const result = validator(chapterDetailsObject);
            const chapterDetails = {
              friendlyName: result.friendlyName,
              offset: result.offset,
              index: result.index,
              length: result.length
            };
            return {
              chapterDetails
            };
          } catch (error) {
            logger.warn("An error occurred while creating the Chapter Object.", error);
            return {};
          }
        };
        const createStateObject = stateName => {
          const STATE_NAME_REGEX = /^[a-zA-Z0-9_]{1,64}$/;
          const validator = boundString().matches(STATE_NAME_REGEX, "This is not a valid state name.");
          try {
            const result = validator(stateName);
            return {
              name: result
            };
          } catch (error) {
            logger.warn("An error occurred while creating the State Object.", error);
            return {};
          }
        };
        const createQoEObject = (bitrate, droppedFrames, fps, startupTime) => {
          const qoeObject = {
            bitrate,
            droppedFrames,
            fps,
            startupTime
          };
          const validator = boundObjectOf({
            bitrate: boundNumber(),
            droppedFrames: boundNumber(),
            fps: boundNumber(),
            startupTime: boundNumber()
          });
          try {
            const result = validator(qoeObject);
            return {
              bitrate: result.bitrate,
              droppedFrames: result.droppedFrames,
              framesPerSecond: result.fps,
              timeToStart: result.startupTime
            };
          } catch (error) {
            logger.warn("An error occurred while creating the QOE Object.", error);
            return {};
          }
        };
        return {
          createMediaObject,
          createAdBreakObject,
          createAdObject,
          createChapterObject,
          createStateObject,
          createQoEObject
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const mediaToXdmKeys = {
        "a.media.show": "show",
        "a.media.season": "season",
        "a.media.episode": "episode",
        "a.media.asset": "assetID",
        "a.media.genre": "genre",
        "a.media.airDate": "firstAirDate",
        "a.media.digitalDate": "firstDigitalDate",
        "a.media.rating": "rating",
        "a.media.originator": "originator",
        "a.media.network": "network",
        "a.media.type": "showType",
        "a.media.adLoad": "adLoad",
        "a.media.pass.mvpd": "mvpd",
        "a.media.pass.auth": "authorized",
        "a.media.dayPart": "dayPart",
        "a.media.feed": "feed",
        "a.media.format": "streamFormat",
        "a.media.artist": "artist",
        "a.media.album": "album",
        "a.media.label": "label",
        "a.media.author": "author",
        "a.media.station": "station",
        "a.media.publisher": "publisher",
        "media.resumed": "hasResume"
      };
      const adsToXdmKeys = {
        "a.media.ad.advertiser": "advertiser",
        "a.media.ad.campaign": "campaignID",
        "a.media.ad.creative": "creativeID",
        "a.media.ad.placement": "placementID",
        "a.media.ad.site": "siteID",
        "a.media.ad.creativeURL": "creativeURL"
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createGetInstance = ({
        logger,
        trackMediaSession,
        trackMediaEvent,
        uuid
      }) => {
        let trackerState = null;
        const instantiateTracker = () => {
          trackerState = {
            qoe: null,
            lastPlayhead: 0,
            playerId: uuid()
          };
        };
        const getEventType = ({
          eventType
        }) => {
          if (eventType === EVENT.BufferComplete || eventType === EVENT.SeekComplete) {
            return MEDIA_EVENTS_INTERNAL.Play;
          }
          if (eventType === EVENT.StateStart || eventType === EVENT.StateEnd) {
            return MEDIA_EVENTS_INTERNAL.StateUpdate;
          }
          if (eventType === EVENT.SeekStart) {
            return MEDIA_EVENTS_INTERNAL.Pause;
          }
          return eventType;
        };
        const createXdmObject = ({
          eventType,
          mediaDetails = {},
          contextData = []
        }) => {
          const action = getEventType({
            eventType
          });
          if (eventType === EVENT.StateStart) {
            const xdm = {
              eventType: "media." + action,
              mediaCollection: {
                statesStart: [mediaDetails]
              }
            };
            return xdm;
          }
          if (eventType === EVENT.StateEnd) {
            const xdm = {
              eventType: "media." + action,
              mediaCollection: {
                statesEnd: [mediaDetails]
              }
            };
            return xdm;
          }
          const xdm = {
            eventType: "media." + action,
            mediaCollection: {
              ...mediaDetails
            }
          };
          const customMetadata = [];
          Object.keys(contextData).forEach(key => {
            if (mediaToXdmKeys[key]) {
              xdm.mediaCollection.sessionDetails[mediaToXdmKeys[key]] = contextData[key];
            } else if (adsToXdmKeys[key]) {
              xdm.mediaCollection.advertisingDetails[adsToXdmKeys[key]] = contextData[key];
            } else {
              customMetadata.push({
                name: key,
                value: contextData[key]
              });
            }
          });
          if (isNonEmptyArray(customMetadata)) {
            xdm.mediaCollection.customMetadata = customMetadata;
          }
          return xdm;
        };
        return {
          trackSessionStart: (mediaObject, contextData = {}) => {
            if (isNil(mediaObject) || isEmptyObject(mediaObject)) {
              logger.warn("Invalid media object");
              return {};
            }
            if (trackerState === null) {
              logger.warn("The Media Session was completed. Restarting a new session.");
              instantiateTracker();
            }
            const xdm = createXdmObject({
              eventType: MEDIA_EVENTS_INTERNAL.SessionStart,
              mediaDetails: mediaObject,
              contextData
            });
            return trackMediaSession({
              playerId: trackerState.playerId,
              getPlayerDetails: () => {
                return {
                  playhead: trackerState.lastPlayhead,
                  qoeDataDetails: trackerState.qoe
                };
              },
              xdm
            });
          },
          trackPlay: () => {
            if (trackerState === null) {
              logger.warn("The Media Session was completed.");
              return {};
            }
            const xdm = createXdmObject({
              eventType: MEDIA_EVENTS_INTERNAL.Play
            });
            return trackMediaEvent({
              playerId: trackerState.playerId,
              xdm
            });
          },
          trackPause: () => {
            if (trackerState === null) {
              logger.warn("The Media Session was completed.");
              return {};
            }
            const xdm = createXdmObject({
              eventType: MEDIA_EVENTS_INTERNAL.Pause
            });
            return trackMediaEvent({
              playerId: trackerState.playerId,
              xdm
            });
          },
          trackSessionEnd: () => {
            if (trackerState === null) {
              logger.warn("The Media Session was completed.");
              return {};
            }
            const xdm = createXdmObject({
              eventType: MEDIA_EVENTS_INTERNAL.SessionEnd
            });
            return trackMediaEvent({
              playerId: trackerState.playerId,
              xdm
            });
          },
          trackComplete: () => {
            if (trackerState === null) {
              logger.warn("The Media Session was completed.");
              return {};
            }
            const xdm = createXdmObject({
              eventType: MEDIA_EVENTS_INTERNAL.SessionComplete
            });
            return trackMediaEvent({
              playerId: trackerState.playerId,
              xdm
            });
          },
          trackError: errorId => {
            logger.warn("trackError(" + errorId + ")");
            if (trackerState === null) {
              logger.warn("The Media Session was completed.");
              return {};
            }
            const errorDetails = {
              name: errorId,
              source: "player"
            };
            const xdm = createXdmObject({
              eventType: MEDIA_EVENTS_INTERNAL.Error,
              mediaDetails: {
                errorDetails
              }
            });
            return trackMediaEvent({
              playerId: trackerState.playerId,
              xdm
            });
          },
          trackEvent: (eventType, info, context) => {
            if (isEmptyObject(info)) {
              logger.warn("Invalid media object.");
              return {};
            }
            if (trackerState === null) {
              logger.warn("The Media Session was completed.");
              return {};
            }
            if (!Object.values(EVENT).includes(eventType)) {
              logger.warn("Invalid event type");
              return {};
            }
            const xdm = createXdmObject({
              eventType,
              mediaDetails: info,
              contextData: context
            });
            return trackMediaEvent({
              playerId: trackerState.playerId,
              xdm
            });
          },
          updatePlayhead: time => {
            if (trackerState === null) {
              logger.warn("The Media Session was completed.");
              return;
            }
            if (isNumber$1(time)) {
              trackerState.lastPlayhead = parseInt(time, 10);
            }
          },
          updateQoEObject: qoeObject => {
            if (trackerState === null) {
              logger.warn("The Media Session was completed.");
              return;
            }
            if (!qoeObject) {
              return;
            }
            trackerState.qoe = qoeObject;
          },
          destroy: () => {
            logger.warn("Destroy called, destroying the tracker.");
            trackerState = null;
          }
        };
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      /* eslint-disable import/no-restricted-paths */

      const createLegacyMediaAnalytics = ({
        eventManager,
        sendEdgeNetworkRequest,
        config,
        logger,
        consent
      }) => {
        const mediaSessionCacheManager = createMediaSessionCacheManager();
        const mediaEventManager = createMediaEventManager({
          sendEdgeNetworkRequest,
          config,
          consent,
          eventManager,
          setTimestamp: injectTimestamp(() => new Date())
        });
        const trackMediaEvent = createTrackMediaEvent({
          mediaSessionCacheManager,
          mediaEventManager,
          config
        });
        const trackMediaSession = createTrackMediaSession({
          config,
          mediaEventManager,
          mediaSessionCacheManager,
          legacy: true
        });
        const mediaResponseHandler = createMediaResponseHandler({
          mediaSessionCacheManager,
          config,
          trackMediaEvent
        });
        return createLegacyMediaComponent({
          mediaResponseHandler,
          trackMediaSession,
          trackMediaEvent,
          createMediaHelper,
          createGetInstance,
          logger,
          config
        });
      };
      createLegacyMediaAnalytics.namespace = "Legacy Media Analytics";

      /*
      Copyright 2021 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var processResponse = ({
        response
      }) => {
        return {
          inferences: response.getPayloadsByType("rtml:inferences")
        };
      };

      /*
      Copyright 2021 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createMachineLearning = () => {
        return {
          lifecycle: {
            onResponse: processResponse
          },
          commands: {}
        };
      };
      createMachineLearning.namespace = "MachineLearning";

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const WEB = "web";
      const WEBAPP = "webapp";
      const SURFACE_TYPE_DELIMITER = "://";
      const FRAGMENT_DELIMITER = "#";

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const SURFACE_REGEX = /^(\w+):\/\/([^/#]+)(\/[^#]*)?(#.*)?$/;
      const AUTHORITY_REGEX = /^(?:.*@)?(?:[a-z\d\u00a1-\uffff.-]+|\[[a-f\d:]+])(?::\d+)?$/;
      const PATH_REGEX = /^\/(?:[/\w\u00a1-\uffff-.~]|%[a-fA-F\d]{2})*$/;
      const FRAGMENT_REGEX = /^#(?:[/\w\u00a1-\uffff-.~]|%[a-fA-F\d]{2})+$/;
      const normalizePath = (path = "/") => {
        let end = path.length;
        while (end > 0 && "/".indexOf(path.charAt(end - 1)) !== -1) {
          end -= 1;
        }
        return path.substring(0, end) || "/";
      };
      const getSurfaceType = surfaceTypeMatch => isNonEmptyString(surfaceTypeMatch) ? surfaceTypeMatch.toLowerCase() : "";
      const getAuthority = authorityMatch => isNonEmptyString(authorityMatch) ? authorityMatch.toLowerCase() : "";
      const getPath = pathMatch => isNonEmptyString(pathMatch) ? normalizePath(pathMatch) : "/";
      const parseSurface = surfaceString => {
        const matched = surfaceString.match(SURFACE_REGEX);
        return matched ? {
          surfaceType: getSurfaceType(matched[1]),
          authority: getAuthority(matched[2]),
          path: getPath(matched[3]),
          fragment: matched[4]
        } : null;
      };
      const stringifySurface = surface => "" + surface.surfaceType + SURFACE_TYPE_DELIMITER + surface.authority + (surface.path || "") + (surface.fragment || "");
      const buildPageSurface = getPageLocation => {
        const location = getPageLocation();
        const host = location.host.toLowerCase();
        const path = location.pathname;
        return WEB + SURFACE_TYPE_DELIMITER + host + normalizePath(path);
      };
      const expandFragmentSurface = (surface, getPageLocation) => surface.startsWith(FRAGMENT_DELIMITER) ? buildPageSurface(getPageLocation) + surface : surface;
      const validateSurface = (surface, getPageLocation, logger) => {
        const invalidateSurface = validationError => {
          logger.warn(validationError);
          return null;
        };
        if (!isNonEmptyString(surface)) {
          return invalidateSurface("Invalid surface: " + surface);
        }
        const expanded = expandFragmentSurface(surface, getPageLocation);
        const parsed = parseSurface(expanded);
        if (parsed === null) {
          return invalidateSurface("Invalid surface: " + surface);
        }
        if (![WEB, WEBAPP].includes(parsed.surfaceType)) {
          return invalidateSurface("Unsupported surface type " + parsed.surfaceType + " in surface: " + surface);
        }
        if (!parsed.authority || !AUTHORITY_REGEX.test(parsed.authority)) {
          return invalidateSurface("Invalid authority " + parsed.authority + " in surface: " + surface);
        }
        if (parsed.path && !PATH_REGEX.test(parsed.path)) {
          return invalidateSurface("Invalid path " + parsed.path + " in surface: " + surface);
        }
        if (parsed.fragment && !FRAGMENT_REGEX.test(parsed.fragment)) {
          return invalidateSurface("Invalid fragment " + parsed.fragment + " in surface: " + surface);
        }
        return parsed;
      };
      const isPageWideSurface = scope => !!scope && scope.indexOf(WEB + SURFACE_TYPE_DELIMITER) === 0 && scope.indexOf(FRAGMENT_DELIMITER) === -1;

      // eslint-disable-next-line default-param-last
      const normalizeSurfaces = (surfaces = [], getPageLocation, logger) => surfaces.map(surface => validateSurface(surface, getPageLocation, logger)).filter(surface => !isNil(surface)).map(stringifySurface);

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const addPageWideScope = scopes => {
        if (!scopes.includes(PAGE_WIDE_SCOPE)) {
          scopes.push(PAGE_WIDE_SCOPE);
        }
      };
      const addPageSurface = (surfaces, getPageLocation) => {
        const pageSurface = buildPageSurface(getPageLocation);
        if (!surfaces.includes(pageSurface)) {
          surfaces.push(pageSurface);
        }
      };
      const dedupe = array => array.filter((item, pos) => array.indexOf(item) === pos);
      var createPersonalizationDetails = ({
        getPageLocation,
        renderDecisions,
        decisionScopes,
        personalization,
        event,
        isCacheInitialized,
        logger
      }) => {
        const viewName = event.getViewName();
        return {
          isRenderDecisions() {
            return renderDecisions;
          },
          isSendDisplayEvent() {
            return !!personalization.sendDisplayEvent;
          },
          shouldIncludeRenderedPropositions() {
            return !!personalization.includeRenderedPropositions;
          },
          getViewName() {
            return viewName;
          },
          hasScopes() {
            return decisionScopes.length > 0 || isNonEmptyArray(personalization.decisionScopes);
          },
          hasSurfaces() {
            return isNonEmptyArray(personalization.surfaces);
          },
          hasViewName() {
            return isNonEmptyString(viewName);
          },
          createQueryDetails() {
            const scopes = [...decisionScopes];
            if (isNonEmptyArray(personalization.decisionScopes)) {
              scopes.push(...personalization.decisionScopes);
            }
            const eventSurfaces = normalizeSurfaces(personalization.surfaces, getPageLocation, logger);
            if (this.shouldRequestDefaultPersonalization()) {
              addPageWideScope(scopes);
              addPageSurface(eventSurfaces, getPageLocation);
            }
            const schemas = [DEFAULT_CONTENT_ITEM, HTML_CONTENT_ITEM, JSON_CONTENT_ITEM, REDIRECT_ITEM, RULESET_ITEM, MESSAGE_IN_APP, MESSAGE_CONTENT_CARD];
            if (scopes.includes(PAGE_WIDE_SCOPE)) {
              schemas.push(DOM_ACTION);
            }
            return {
              schemas,
              decisionScopes: dedupe(scopes),
              surfaces: dedupe(eventSurfaces)
            };
          },
          isCacheInitialized() {
            return isCacheInitialized;
          },
          shouldFetchData() {
            return this.hasScopes() || this.hasSurfaces() || this.shouldRequestDefaultPersonalization();
          },
          shouldUseCachedData() {
            return this.hasViewName() && !this.shouldFetchData();
          },
          shouldRequestDefaultPersonalization() {
            return personalization.defaultPersonalizationEnabled || !this.isCacheInitialized() && personalization.defaultPersonalizationEnabled !== false;
          }
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const AUTHORING_ENABLED = "Rendering is disabled for authoring mode.";

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const EMPTY_PROPOSITIONS = {
        propositions: []
      };
      var validateApplyPropositionsOptions = ({
        logger,
        options
      }) => {
        const applyPropositionsOptionsValidator = boundObjectOf({
          propositions: boundArrayOf(boundObjectOf({
            id: boundString().required(),
            scope: boundString().required(),
            scopeDetails: boundObjectOf({
              decisionProvider: boundString().required()
            }).required(),
            items: boundArrayOf(boundObjectOf({
              id: boundString().required(),
              schema: boundString().required(),
              data: boundAnything().required()
            })).nonEmpty().required()
          }).required()).nonEmpty().required(),
          metadata: boundObjectOf(boundAnything()),
          viewName: boundString()
        }).required();
        try {
          return applyPropositionsOptionsValidator(options);
        } catch (e) {
          logger.warn("Invalid options for applyPropositions. No propositions will be applied.", e);
          return EMPTY_PROPOSITIONS;
        }
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createComponent$1 = ({
        getPageLocation,
        logger,
        fetchDataHandler,
        viewChangeHandler,
        onClickHandler,
        isAuthoringModeEnabled,
        mergeQuery,
        viewCache,
        showContainers,
        applyPropositions,
        setTargetMigration,
        mergeDecisionsMeta,
        renderedPropositions,
        onDecisionHandler,
        handleConsentFlicker
      }) => {
        return {
          lifecycle: {
            onComponentsRegistered() {
              handleConsentFlicker();
            },
            onDecision: onDecisionHandler,
            onBeforeRequest({
              request
            }) {
              setTargetMigration(request);
              return Promise.resolve();
            },
            onBeforeEvent({
              event,
              renderDecisions,
              decisionScopes = [],
              personalization = {},
              onResponse = noop,
              onRequestFailure = noop
            }) {
              // Include propositions on all responses, overridden with data as needed
              onResponse(() => ({
                propositions: []
              }));
              onRequestFailure(() => showContainers());
              if (isAuthoringModeEnabled()) {
                logger.warn(AUTHORING_ENABLED);

                // If we are in authoring mode we disable personalization
                mergeQuery(event, {
                  enabled: false
                });
                return Promise.resolve();
              }
              const personalizationDetails = createPersonalizationDetails({
                getPageLocation,
                renderDecisions,
                decisionScopes,
                personalization,
                event,
                isCacheInitialized: viewCache.isInitialized(),
                logger
              });
              const decisionsMetaPromises = [];
              if (personalizationDetails.shouldIncludeRenderedPropositions()) {
                decisionsMetaPromises.push(renderedPropositions.clear());
              }
              if (personalizationDetails.shouldFetchData()) {
                const cacheUpdate = viewCache.createCacheUpdate(personalizationDetails.getViewName());
                onRequestFailure(() => cacheUpdate.cancel());
                fetchDataHandler({
                  cacheUpdate,
                  personalizationDetails,
                  event,
                  onResponse
                });
              } else if (personalizationDetails.shouldUseCachedData()) {
                // eslint-disable-next-line consistent-return
                decisionsMetaPromises.push(viewChangeHandler({
                  personalizationDetails,
                  event,
                  onResponse,
                  onRequestFailure
                }));
              }

              // This promise.all waits for both the pending display notifications to be resolved
              // (i.e. the top of page call to finish rendering) and the view change handler to
              // finish rendering anything for this view.
              return Promise.all(decisionsMetaPromises).then(decisionsMetas => {
                // We only want to call mergeDecisionsMeta once, but we can get the propositions
                // from two places: the pending display notifications and the view change handler.
                const decisionsMeta = decisionsMetas.flatMap(dms => dms);
                if (isNonEmptyArray(decisionsMeta)) {
                  mergeDecisionsMeta(event, decisionsMeta, [PropositionEventType.DISPLAY]);
                }
              });
            },
            onClick({
              event,
              clickedElement
            }) {
              onClickHandler({
                event,
                clickedElement
              });
            }
          },
          commands: {
            applyPropositions: {
              optionsValidator: options => validateApplyPropositionsOptions({
                logger,
                options
              }),
              run: applyPropositions
            }
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createFragment = content => {
        return createNode(DIV, {}, {
          innerHTML: content
        });
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const EQ_START = ":eq(";
      const EQ_PATTERN = /:eq\((\d+)\)/g;
      const isNotEqSelector = str => str.indexOf(EQ_START) === -1;
      const splitWithEq = selector => {
        return selector.split(EQ_PATTERN).filter(isNonEmptyString);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // Trying to match ID or CSS class
      const CSS_IDENTIFIER_PATTERN = /(#|\.)(-?\w+)/g;
      // Here we use CSS.escape() to make sure we get
      // correct values for ID and CSS class
      // Please check:  https://www.w3.org/TR/css-syntax-3/#escaping
      const replaceIdentifier = (_, $1, $2) => "" + $1 + CSS.escape($2);
      const escapeIdentifiersInSelector = selector => {
        return selector.replace(CSS_IDENTIFIER_PATTERN, replaceIdentifier);
      };
      const parseSelector = rawSelector => {
        const result = [];
        const selector = escapeIdentifiersInSelector(rawSelector.trim());
        const parts = splitWithEq(selector);
        const {
          length
        } = parts;
        let i = 0;
        while (i < length) {
          const sel = parts[i];
          const eq = parts[i + 1];
          if (eq) {
            result.push({
              sel,
              eq: Number(eq)
            });
          } else {
            result.push({
              sel
            });
          }
          i += 2;
        }
        return result;
      };

      /**
       * Returns an array of matched DOM nodes.
       * @param {String} selector that contains Sizzle "eq(...)" pseudo selector
       * @returns {Array} an array of DOM nodes
       */
      const selectNodesWithEq = selector => {
        const doc = document;
        if (isNotEqSelector(selector)) {
          return selectNodes(selector, doc);
        }
        const parts = parseSelector(selector);
        const {
          length
        } = parts;
        let result = [];
        let context = doc;
        let i = 0;
        while (i < length) {
          const {
            sel,
            eq
          } = parts[i];
          const nodes = selectNodes(sel, context);
          const {
            length: nodesCount
          } = nodes;
          if (nodesCount === 0) {
            break;
          }
          if (eq != null && eq > nodesCount - 1) {
            break;
          }
          if (i < length - 1) {
            if (eq == null) {
              [context] = nodes;
            } else {
              context = nodes[eq];
            }
          }
          if (i === length - 1) {
            if (eq == null) {
              result = nodes;
            } else {
              result = [nodes[eq]];
            }
          }
          i += 1;
        }
        return result;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Returns an array of matched DOM nodes.
       * @param {String} id
       * @param {Node} [context=document] defaults to document
       * @returns {HTMLElement} an element of null
       */
      var getElementById = (id, context = document) => {
        return context.getElementById(id);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var setAttribute = (element, name, value) => {
        element.setAttribute(name, value);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var getAttribute = (element, name) => {
        return element.getAttribute(name);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var removeAttribute = (element, name) => {
        element.removeAttribute(name);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var setStyle = (element, name, value, priority) => {
        let css;
        if (priority) {
          css = name + ":" + value + " !" + priority + ";";
        } else {
          css = name + ":" + value + ";";
        }
        element.style.cssText += ";" + css;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var getParent = element => {
        return element.parentNode;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var getNextSibling = element => {
        return element.nextElementSibling;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var insertAfter = (container, element) => {
        if (!container) {
          return;
        }
        const parent = getParent(container);
        if (parent) {
          parent.insertBefore(element, getNextSibling(container));
        }
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var insertBefore = (container, element) => {
        if (!container) {
          return;
        }
        const parent = getParent(container);
        if (parent) {
          parent.insertBefore(element, container);
        }
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var getChildren = element => {
        const {
          children
        } = element;
        if (children) {
          return toArray(children);
        }
        return [];
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var getChildNodes = element => {
        const {
          childNodes
        } = element;
        if (childNodes) {
          return toArray(childNodes);
        }
        return [];
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var getFirstChild = element => {
        return element.firstElementChild;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      let nonce;

      /**
       * Returns the nonce if available.
       * @param {Node} [context=document] defaults to document
       * @returns {(String|undefined)} the nonce or undefined if not available
       */
      var getNonce = (context = document) => {
        if (nonce === undefined) {
          const n = context.querySelector("[nonce]");
          // NOTE: We're keeping n.getAttribute("nonce") until it is safe to remove:
          //   ref: https://github.com/whatwg/html/issues/2369#issuecomment-280853946
          nonce = n && (n.nonce || n.getAttribute("nonce"));
        }
        return nonce;
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const SRC = "src";

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const isImage = element => element.tagName === IMG;
      const loadImage = url => {
        return createNode(IMG, {
          src: url
        });
      };
      const loadImages = fragment => {
        const images = selectNodes(IMG, fragment);
        images.forEach(image => {
          const url = getAttribute(image, SRC);
          if (url) {
            loadImage(url);
          }
        });
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const is$1 = (element, tagName) => element.tagName === tagName;
      const isInlineStyleElement = element => is$1(element, STYLE) && !getAttribute(element, SRC);
      var addNonceToInlineStyleElements = fragment => {
        const styleNodes = selectNodes(STYLE, fragment);
        const {
          length
        } = styleNodes;
        const nonce = getNonce();
        if (!nonce) {
          return;
        }
        /* eslint-disable no-continue */
        for (let i = 0; i < length; i += 1) {
          const element = styleNodes[i];
          if (!isInlineStyleElement(element)) {
            continue;
          }
          element.nonce = nonce;
        }
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const getPromise = (url, script) => {
        return new Promise((resolve, reject) => {
          script.onload = () => {
            resolve(script);
          };
          script.onerror = () => {
            reject(new Error("Failed to load script: " + url));
          };
        });
      };
      const loadScript = url => {
        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        const promise = getPromise(url, script);
        document.head.appendChild(script);
        return promise;
      };
      const is = (element, tagName) => !!element && element.tagName === tagName;
      const isInlineScript = element => is(element, SCRIPT) && !getAttribute(element, SRC);
      const isRemoteScript = element => is(element, SCRIPT) && getAttribute(element, SRC);
      const getInlineScripts = fragment => {
        const scripts = selectNodes(SCRIPT, fragment);
        const result = [];
        const {
          length
        } = scripts;
        const nonce = getNonce();
        const attributes = {
          ...(nonce && {
            nonce
          })
        };

        /* eslint-disable no-continue */
        for (let i = 0; i < length; i += 1) {
          const element = scripts[i];
          if (!isInlineScript(element)) {
            continue;
          }
          const {
            textContent
          } = element;
          if (!textContent) {
            continue;
          }
          result.push(createNode(SCRIPT, attributes, {
            textContent
          }));
        }
        /* eslint-enable no-continue */

        return result;
      };
      const getRemoteScriptsUrls = fragment => {
        const scripts = selectNodes(SCRIPT, fragment);
        const result = [];
        const {
          length
        } = scripts;

        /* eslint-disable no-continue */
        for (let i = 0; i < length; i += 1) {
          const element = scripts[i];
          if (!isRemoteScript(element)) {
            continue;
          }
          const url = getAttribute(element, SRC);
          if (!url) {
            continue;
          }
          result.push(url);
        }
        /* eslint-enable no-continue */

        return result;
      };
      const executeInlineScripts = (parent, scripts) => {
        scripts.forEach(script => {
          parent.appendChild(script);
          parent.removeChild(script);
        });
      };
      const executeRemoteScripts = urls => {
        return Promise.all(urls.map(loadScript));
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var appendHtml = (container, html, decorateProposition) => {
        const fragment = createFragment(html);
        addNonceToInlineStyleElements(fragment);
        const elements = getChildNodes(fragment);
        const scripts = getInlineScripts(fragment);
        const scriptsUrls = getRemoteScriptsUrls(fragment);
        loadImages(fragment);
        elements.forEach(element => {
          appendNode(container, element);
        });
        decorateProposition(container);
        executeInlineScripts(container, scripts);
        return executeRemoteScripts(scriptsUrls);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const clear = container => {
        // We want to remove ALL nodes, text, comments etc
        const childNodes = getChildNodes(container);
        childNodes.forEach(removeNode);
      };
      var setHtml = (container, html, decorateProposition) => {
        clear(container);
        return appendHtml(container, html, decorateProposition);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var prependHtml = (container, html, decorateProposition) => {
        const fragment = createFragment(html);
        addNonceToInlineStyleElements(fragment);
        const elements = getChildNodes(fragment);
        const scripts = getInlineScripts(fragment);
        const scriptsUrls = getRemoteScriptsUrls(fragment);
        const {
          length
        } = elements;
        let i = length - 1;

        // We have to proactively load images to avoid flicker
        loadImages(fragment);

        // We are inserting elements in reverse order
        while (i >= 0) {
          const element = elements[i];
          decorateProposition(element);
          const firstChild = getFirstChild(container);
          if (firstChild) {
            insertBefore(firstChild, element);
          } else {
            appendNode(container, element);
          }
          i -= 1;
        }
        executeInlineScripts(container, scripts);
        return executeRemoteScripts(scriptsUrls);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const PREHIDING_ID = "alloy-prehiding";
      const HIDING_STYLE_DEFINITION = "{ visibility: hidden }";

      // Using global is OK since we have a single DOM
      // so storing nodes even for multiple Alloy instances is fine
      const styleNodes = {};
      const hideElements = prehidingSelector => {
        // if we have different events with the same
        // prehiding selector we don't want to recreate
        // the style tag
        if (styleNodes[prehidingSelector]) {
          return;
        }
        const nonce = getNonce();
        const attrs = {
          ...(nonce && {
            nonce
          })
        };
        const props = {
          textContent: prehidingSelector + " " + HIDING_STYLE_DEFINITION
        };
        const node = createNode(STYLE, attrs, props);
        appendNode(document.head, node);
        styleNodes[prehidingSelector] = node;
      };
      const showElements = prehidingSelector => {
        const node = styleNodes[prehidingSelector];
        if (node) {
          removeNode(node);
          delete styleNodes[prehidingSelector];
        }
      };
      const createHideContainers = logger => {
        return prehidingStyle => {
          if (!prehidingStyle) {
            return;
          }

          // If containers prehiding style has been added
          // by customer's prehiding snippet we don't
          // want to add the same node
          const node = getElementById(PREHIDING_ID);
          if (node) {
            return;
          }
          const nonce = getNonce();
          const attrs = {
            id: PREHIDING_ID,
            ...(nonce && {
              nonce
            })
          };
          const props = {
            textContent: prehidingStyle
          };
          const styleNode = createNode(STYLE, attrs, props);
          logger.logOnContentHiding({
            status: "hide-containers",
            message: "Prehiding style applied to hide containers.",
            logLevel: "info"
          });
          appendNode(document.head, styleNode);
        };
      };
      const createShowContainers = logger => {
        return () => {
          // If containers prehiding style exists
          // we will remove it
          const node = getElementById(PREHIDING_ID);
          if (!node) {
            return;
          }
          logger.logOnContentHiding({
            status: "show-containers",
            message: "Prehiding style removed to show containers.",
            logLevel: "info"
          });
          removeNode(node);
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var setText = (container, text, decorateProposition) => {
        decorateProposition(container);
        container.textContent = text;
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var insertHtmlBefore = (container, html, decorateProposition) => {
        const fragment = createFragment(html);
        addNonceToInlineStyleElements(fragment);
        const elements = getChildNodes(fragment);
        const scripts = getInlineScripts(fragment);
        const scriptsUrls = getRemoteScriptsUrls(fragment);
        loadImages(fragment);
        elements.forEach(element => {
          decorateProposition(element);
          insertBefore(container, element);
        });
        executeInlineScripts(container, scripts);
        return executeRemoteScripts(scriptsUrls);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var replaceHtml = (container, html, decorateProposition) => {
        return insertHtmlBefore(container, html, decorateProposition).then(() => {
          removeNode(container);
        });
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var insertHtmlAfter = (container, html, decorateProposition) => {
        const fragment = createFragment(html);
        addNonceToInlineStyleElements(fragment);
        const elements = getChildNodes(fragment);
        const scripts = getInlineScripts(fragment);
        const scriptsUrls = getRemoteScriptsUrls(fragment);
        loadImages(fragment);
        let insertionPoint = container;
        elements.forEach(element => {
          decorateProposition(element);
          insertAfter(insertionPoint, element);
          insertionPoint = element;
        });
        executeInlineScripts(container, scripts);
        return executeRemoteScripts(scriptsUrls);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var setStyles = (container, styles, decorateProposition) => {
        const {
          priority,
          ...style
        } = styles;
        Object.keys(style).forEach(key => {
          setStyle(container, key, style[key], priority);
        });
        decorateProposition(container);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var setAttributes = (container, attributes, decorateProposition) => {
        Object.keys(attributes).forEach(key => {
          setAttribute(container, key, attributes[key]);
        });
        decorateProposition(container);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var swapImage = (container, url, decorateProposition) => {
        if (!isImage(container)) {
          return;
        }

        // Start downloading the image
        loadImage(url);
        decorateProposition(container);

        // Remove "src" so there is no flicker
        removeAttribute(container, SRC);

        // Replace the image "src"
        setAttribute(container, SRC, url);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var rearrangeChildren = (container, {
        from,
        to
      }, decorateProposition) => {
        const children = getChildren(container);
        const elementFrom = children[from];
        const elementTo = children[to];
        if (!elementFrom || !elementTo) {
          // TODO: We will need to add logging
          // to ease troubleshooting
          return;
        }
        if (from < to) {
          insertAfter(elementTo, elementFrom);
        } else {
          insertBefore(elementTo, elementFrom);
        }
        decorateProposition(elementTo);
        decorateProposition(elementFrom);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const renderContent = (elements, content, decorateProposition, renderFunc) => {
        const executions = elements.map(element => renderFunc(element, content, decorateProposition));
        return Promise.all(executions);
      };
      const createAction = renderFunc => {
        return (itemData, decorateProposition) => {
          const {
            selector,
            prehidingSelector,
            content
          } = itemData;
          hideElements(prehidingSelector);
          return awaitSelector(selector, selectNodesWithEq).then(elements => renderContent(elements, content, decorateProposition, renderFunc)).then(() => {
            // if everything is OK, show elements
            showElements(prehidingSelector);
          }, error => {
            // in case of awaiting timing or error, we need to remove the style tag
            // hence showing the pre-hidden elements
            showElements(prehidingSelector);
            throw error;
          });
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var collectInteractions$1 = (container, content, decorateProposition) => {
        decorateProposition(container);
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const DOM_ACTION_SET_HTML = "setHtml";
      const DOM_ACTION_CUSTOM_CODE = "customCode";
      const DOM_ACTION_SET_TEXT = "setText";
      const DOM_ACTION_SET_ATTRIBUTE = "setAttribute";
      const DOM_ACTION_SET_IMAGE_SOURCE = "setImageSource";
      const DOM_ACTION_SET_STYLE = "setStyle";
      const DOM_ACTION_MOVE = "move";
      const DOM_ACTION_RESIZE = "resize";
      const DOM_ACTION_REARRANGE = "rearrange";
      const DOM_ACTION_REMOVE = "remove";
      const DOM_ACTION_INSERT_AFTER = "insertAfter";
      const DOM_ACTION_INSERT_BEFORE = "insertBefore";
      const DOM_ACTION_REPLACE_HTML = "replaceHtml";
      const DOM_ACTION_PREPEND_HTML = "prependHtml";
      const DOM_ACTION_APPEND_HTML = "appendHtml";
      const DOM_ACTION_CLICK = "click";
      const DOM_ACTION_COLLECT_INTERACTIONS = "collectInteractions";
      var initDomActionsModules = () => {
        return {
          [DOM_ACTION_SET_HTML]: createAction(setHtml),
          [DOM_ACTION_CUSTOM_CODE]: createAction(prependHtml),
          [DOM_ACTION_SET_TEXT]: createAction(setText),
          [DOM_ACTION_SET_ATTRIBUTE]: createAction(setAttributes),
          [DOM_ACTION_SET_IMAGE_SOURCE]: createAction(swapImage),
          [DOM_ACTION_SET_STYLE]: createAction(setStyles),
          [DOM_ACTION_MOVE]: createAction(setStyles),
          [DOM_ACTION_RESIZE]: createAction(setStyles),
          [DOM_ACTION_REARRANGE]: createAction(rearrangeChildren),
          [DOM_ACTION_REMOVE]: createAction(removeNode),
          [DOM_ACTION_INSERT_AFTER]: createAction(insertHtmlAfter),
          [DOM_ACTION_INSERT_BEFORE]: createAction(insertHtmlBefore),
          [DOM_ACTION_REPLACE_HTML]: createAction(replaceHtml),
          [DOM_ACTION_PREPEND_HTML]: createAction(prependHtml),
          [DOM_ACTION_APPEND_HTML]: createAction(appendHtml),
          [DOM_ACTION_COLLECT_INTERACTIONS]: createAction(collectInteractions$1)
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const DECISIONS_HANDLE = "personalization:decisions";
      var createFetchDataHandler = ({
        logger,
        prehidingStyle,
        showContainers,
        hideContainers,
        mergeQuery,
        processPropositions,
        createProposition,
        notificationHandler,
        consent
      }) => {
        return ({
          cacheUpdate,
          personalizationDetails,
          event,
          onResponse
        }) => {
          const {
            state,
            wasSet
          } = consent.current();
          if (!(state === "out" && wasSet)) {
            if (personalizationDetails.isRenderDecisions()) {
              hideContainers(prehidingStyle);
            } else {
              showContainers();
            }
          }
          mergeQuery(event, personalizationDetails.createQueryDetails());

          // This needs to be called before the response so that future sendEvent calls
          // can know to wait until this request is complete for pending display notifications.
          const handleNotifications = notificationHandler(personalizationDetails.isRenderDecisions(), personalizationDetails.isSendDisplayEvent(), personalizationDetails.getViewName());
          onResponse(({
            response
          }) => {
            const handles = response.getPayloadsByType(DECISIONS_HANDLE);
            if (!isNonEmptyArray(handles)) {
              logger.logOnContentRendering({
                status: "no-offers",
                message: "No offers were returned.",
                logLevel: "info",
                detail: {
                  query: personalizationDetails.createQueryDetails()
                }
              });
            }
            const propositions = handles.map(handle => createProposition(handle));
            const {
              page: pagePropositions = [],
              view: viewPropositions = [],
              proposition: nonRenderedPropositions = []
            } = groupBy(propositions, p => p.getScopeType());
            const currentViewPropositions = cacheUpdate.update(viewPropositions);
            let render;
            let returnedPropositions;
            let returnedDecisions;
            if (personalizationDetails.isRenderDecisions()) {
              ({
                render,
                returnedPropositions,
                returnedDecisions
              } = processPropositions([...pagePropositions, ...currentViewPropositions], nonRenderedPropositions));
              if (isNonEmptyArray(pagePropositions)) {
                logger.logOnContentRendering({
                  status: "rendering-started",
                  message: "Started rendering propositions for page-wide scope.",
                  logLevel: "info",
                  detail: {
                    scope: PAGE_WIDE_SCOPE,
                    propositions: pagePropositions.map(proposition => proposition.toJSON())
                  }
                });
              }
              if (isNonEmptyArray(currentViewPropositions)) {
                logger.logOnContentRendering({
                  status: "rendering-started",
                  message: "Rendering propositions started for view scope - " + personalizationDetails.getViewName() + ".",
                  logLevel: "info",
                  detail: {
                    scope: personalizationDetails.getViewName(),
                    propositions: currentViewPropositions.map(proposition => proposition.toJSON())
                  }
                });
              }
              render().then(handleNotifications);

              // Render could take a long time especially if one of the renders
              // is waiting for html to appear on the page. We show the containers
              // immediately, and whatever renders quickly will not have flicker.
              showContainers();
            } else {
              ({
                returnedPropositions,
                returnedDecisions
              } = processPropositions([], [...pagePropositions, ...currentViewPropositions, ...nonRenderedPropositions]));
            }
            return {
              propositions: returnedPropositions,
              decisions: returnedDecisions
            };
          });
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var matchesSelectorWithEq = (selector, element) => {
        if (isNotEqSelector(selector)) {
          return matchesSelector(selector, element);
        }

        // Using node selection vs matches selector, because of :eq()
        // Find all nodes using document as context
        const nodes = selectNodesWithEq(selector);
        let result = false;

        // Iterate through all the identified elements
        // and reference compare with element
        for (let i = 0; i < nodes.length; i += 1) {
          if (nodes[i] === element) {
            result = true;
            break;
          }
        }
        return result;
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const VIEW_SCOPE_TYPE = "view";
      const PAGE_SCOPE_TYPE = "page";
      const PROPOSITION_SCOPE_TYPE = "proposition";

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const cleanMetas = metas => metas.map(meta => {
        const {
          trackingLabel,
          scopeType,
          ...rest
        } = meta;
        return rest;
      });
      const dedupeMetas = metas => metas.filter((meta, index) => {
        const stringifiedMeta = JSON.stringify(meta);
        return index === metas.findIndex(innerMeta => JSON.stringify(innerMeta) === stringifiedMeta);
      });

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const getMetasIfMatches = (clickedElement, selector, getClickMetas) => {
        const {
          documentElement
        } = document;
        let element = clickedElement;
        let i = 0;
        while (element && element !== documentElement) {
          if (matchesSelectorWithEq(selector, element)) {
            const matchedMetas = getClickMetas(selector);
            const returnValue = {
              metas: matchedMetas
            };
            const foundMetaWithLabel = matchedMetas.find(meta => meta.trackingLabel);
            if (foundMetaWithLabel) {
              returnValue.label = foundMetaWithLabel.trackingLabel;
              returnValue.weight = i;
            }
            const foundMetaWithScopeTypeView = matchedMetas.find(meta => meta.scopeType === VIEW_SCOPE_TYPE);
            if (foundMetaWithScopeTypeView) {
              returnValue.viewName = foundMetaWithScopeTypeView.scope;
              returnValue.weight = i;
            }
            return returnValue;
          }
          element = element.parentNode;
          i += 1;
        }
        return {
          metas: null
        };
      };
      var collectClicks = (clickedElement, selectors, getClickMetas) => {
        const result = [];
        let resultLabel = "";
        let resultLabelWeight = Number.MAX_SAFE_INTEGER;
        let resultViewName;
        let resultViewNameWeight = Number.MAX_SAFE_INTEGER;

        /* eslint-disable no-continue */
        for (let i = 0; i < selectors.length; i += 1) {
          const {
            metas,
            label,
            weight,
            viewName
          } = getMetasIfMatches(clickedElement, selectors[i], getClickMetas);
          if (!metas) {
            continue;
          }
          if (label && weight <= resultLabelWeight) {
            resultLabel = label;
            resultLabelWeight = weight;
          }
          if (viewName && weight <= resultViewNameWeight) {
            resultViewName = viewName;
            resultViewNameWeight = weight;
          }
          result.push(...cleanMetas(metas));
        }
        return {
          decisionsMeta: dedupeMetas(result),
          propositionActionLabel: resultLabel,
          propositionActionToken: undefined,
          viewName: resultViewName
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var isAuthoringModeEnabled = (doc = document) => {
        return doc.location.href.indexOf("adobe_authoring_enabled") !== -1;
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createPropositionAction = (clickLabel, clickToken) => {
        if (!clickToken && !clickLabel) {
          return undefined;
        }
        const propositionAction = {};
        if (clickLabel) {
          propositionAction.label = clickLabel;
        }
        if (clickToken) {
          propositionAction.tokens = [clickToken];
        }
        return propositionAction;
      };
      var createOnClickHandler = ({
        mergeDecisionsMeta,
        collectInteractions,
        collectClicks,
        getInteractionMetas,
        getClickMetas,
        getClickSelectors,
        autoCollectPropositionInteractions
      }) => {
        // Called when an element qualifying for conversion within an offer is clicked.
        return ({
          event,
          clickedElement
        }) => {
          const decisionsMeta = [];
          let propositionActionLabel;
          let propositionActionToken;
          let viewName;
          [collectInteractions(clickedElement, getInteractionMetas, autoCollectPropositionInteractions), collectClicks(clickedElement, getClickSelectors(), getClickMetas)].forEach(({
            decisionsMeta: curDecisionsMeta,
            propositionActionLabel: curPropositionActionLabel,
            propositionActionToken: curPropositionActionToken,
            viewName: curViewName
          }) => {
            Array.prototype.push.apply(decisionsMeta, curDecisionsMeta);
            if (!propositionActionLabel && curPropositionActionLabel) {
              propositionActionLabel = curPropositionActionLabel;
            }
            if (!propositionActionToken && curPropositionActionToken) {
              propositionActionToken = curPropositionActionToken;
            }
            if (!viewName && curViewName) {
              viewName = curViewName;
            }
          });
          if (isNonEmptyArray(decisionsMeta)) {
            const xdm = {
              eventType: INTERACT
            };
            if (viewName) {
              xdm.web = {
                webPageDetails: {
                  viewName
                }
              };
            }
            event.mergeXdm(xdm);
            mergeDecisionsMeta(event, decisionsMeta, [PropositionEventType.INTERACT], createPropositionAction(propositionActionLabel, propositionActionToken));
          }
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createViewCacheManager = ({
        createProposition
      }) => {
        let cacheUpdateCreatedAtLeastOnce = false;
        let viewStoragePromise = Promise.resolve({});
        const getViewPropositions = (viewStorage, viewName) => {
          const viewPropositions = viewStorage[viewName.toLowerCase()];
          if (viewPropositions && viewPropositions.length > 0) {
            return viewPropositions;
          }
          const emptyViewProposition = createProposition({
            scope: viewName,
            scopeDetails: {
              characteristics: {
                scopeType: VIEW_SCOPE_TYPE
              }
            },
            items: [{
              schema: DEFAULT_CONTENT_ITEM
            }]
          }, false);
          return [emptyViewProposition];
        };

        // This should be called before making the request to experience edge.
        const createCacheUpdate = viewName => {
          const updateCacheDeferred = defer();
          cacheUpdateCreatedAtLeastOnce = true;

          // Additional updates will merge the new view propositions with the old.
          // i.e. if there are new "cart" view propositions they will overwrite the
          // old "cart" view propositions, but if there are no new "cart" view
          // propositions the old "cart" view propositions will remain.
          viewStoragePromise = viewStoragePromise.then(oldViewStorage => {
            return updateCacheDeferred.promise.then(newViewStorage => {
              return {
                ...oldViewStorage,
                ...newViewStorage
              };
            }).catch(() => oldViewStorage);
          });
          return {
            update(viewPropositions) {
              const viewPropositionsWithScope = viewPropositions.filter(proposition => proposition.getScope());
              const newViewStorage = groupBy(viewPropositionsWithScope, proposition => proposition.getScope().toLowerCase());
              updateCacheDeferred.resolve(newViewStorage);
              if (viewName) {
                return getViewPropositions(newViewStorage, viewName);
              }
              return [];
            },
            cancel() {
              updateCacheDeferred.reject();
            }
          };
        };
        const getView = viewName => {
          return viewStoragePromise.then(viewStorage => getViewPropositions(viewStorage, viewName));
        };
        const isInitialized = () => {
          return cacheUpdateCreatedAtLeastOnce;
        };
        return {
          createCacheUpdate,
          getView,
          isInitialized
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createViewChangeHandler = ({
        processPropositions,
        viewCache,
        logger
      }) => {
        return ({
          personalizationDetails,
          onResponse
        }) => {
          let returnedPropositions;
          let returnedDecisions;
          const viewName = personalizationDetails.getViewName();
          onResponse(() => {
            return {
              propositions: returnedPropositions,
              decisions: returnedDecisions
            };
          });
          return viewCache.getView(viewName).then(propositions => {
            let render;
            if (personalizationDetails.isRenderDecisions()) {
              ({
                render,
                returnedPropositions,
                returnedDecisions
              } = processPropositions(propositions));
              logger.logOnContentRendering({
                status: "rendering-started",
                message: "Started rendering propositions for view scope - " + viewName + ".",
                logLevel: "info",
                detail: {
                  scope: viewName,
                  propositions: propositions.map(proposition => proposition.toJSON())
                }
              });
              return render();
            }
            ({
              returnedPropositions,
              returnedDecisions
            } = processPropositions([], propositions));
            return [];
          });
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const metasToArray = metas => {
        return Object.keys(metas).map(key => {
          return {
            id: key,
            ...metas[key]
          };
        });
      };
      var createClickStorage = () => {
        const clickStorage = {};
        const storeClickMeta = ({
          selector,
          meta: {
            id,
            scope,
            scopeDetails,
            trackingLabel,
            scopeType
          }
        }) => {
          if (!clickStorage[selector]) {
            clickStorage[selector] = {};
          }
          clickStorage[selector][id] = {
            scope,
            scopeDetails,
            trackingLabel,
            scopeType
          };
        };
        const getClickSelectors = () => {
          return Object.keys(clickStorage);
        };
        const getClickMetas = selector => {
          const metas = clickStorage[selector];
          if (!metas) {
            return {};
          }
          return metasToArray(clickStorage[selector]);
        };
        return {
          storeClickMeta,
          getClickSelectors,
          getClickMetas
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createInteractionStorage = () => {
        const clickMetaStorage = {};
        /*
        clickMetaStorage example.
        `abc' and 'def' are proposition IDs.  1 is an interact id.  The object with an id, scope and scopeDetails
        is the notification.
           {
        	1: {
        	  "abc": { "id": "abc", "scope": "proposition", "scopeDetails": {} },
        	  "def": { "id": "def", "scope": "proposition", "scopeDetails": {} }
        	}
          }
        */

        const clickItemStorage = {};
        /*
        clickItemStorage example.
        `abc' and 'def' are proposition IDs.  1 is an interact id.  The sets contain proposition-item IDs which
        are used in notifications that are sent.
           {
        	1: {
        	  abc: new Set(["itemAAA", "itemCCC"]),
        	  def: new Set(["itemEEE", "itemFFF"]),
        	},
          }
        */

        const storeInteractionMeta = (propositionId, itemId, scopeType, notification, interactId) => {
          // eslint-disable-next-line no-param-reassign
          interactId = parseInt(interactId, 10);
          if (!clickMetaStorage[interactId]) {
            clickMetaStorage[interactId] = {};
            clickItemStorage[interactId] = {};
          }
          if (!clickItemStorage[interactId][propositionId]) {
            clickItemStorage[interactId][propositionId] = new Set();
          }
          clickItemStorage[interactId][propositionId].add(itemId);
          clickMetaStorage[interactId][propositionId] = {
            ...notification,
            scopeType
          };
        };
        const getInteractionMetas = interactIds => {
          if (!Array.isArray(interactIds) || interactIds.length === 0) {
            return [];
          }
          return Object.values(interactIds.map(value => parseInt(value, 10)).reduce((metaMap, interactId) => {
            Object.keys(clickMetaStorage[interactId] || {}).forEach(propositionId => {
              if (!metaMap[propositionId]) {
                metaMap[propositionId] = {
                  proposition: clickMetaStorage[interactId][propositionId],
                  items: new Set()
                };
              }
              metaMap[propositionId].items = new Set([...metaMap[propositionId].items, ...clickItemStorage[interactId][propositionId]]);
            });
            return metaMap;
          }, {})).map(({
            proposition,
            items
          }) => ({
            ...proposition,
            items: Array.from(items).map(id => ({
              id
            }))
          }));
        };
        return {
          storeInteractionMeta,
          getInteractionMetas
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const isInteractionTrackingItem = (schema, actionType) => schema === JSON_CONTENT_ITEM && actionType === DOM_ACTION_COLLECT_INTERACTIONS;
      const SUPPORTED_SCHEMAS = {
        [DOM_ACTION]: () => true,
        [HTML_CONTENT_ITEM]: () => true,
        [JSON_CONTENT_ITEM]: isInteractionTrackingItem,
        [MESSAGE_IN_APP]: () => true
      };
      const filterItemsPredicate = (schema, actionType) => typeof SUPPORTED_SCHEMAS[schema] === "function" && SUPPORTED_SCHEMAS[schema](schema, actionType);
      var createApplyPropositions = ({
        processPropositions,
        createProposition,
        renderedPropositions,
        viewCache
      }) => {
        const updatePropositionItems = ({
          items,
          metadataForScope = {}
        }) => {
          const {
            actionType,
            selector
          } = metadataForScope;
          return items.filter(item => filterItemsPredicate(item.schema, actionType)).map(item => {
            const {
              schema
            } = item;
            if (schema !== HTML_CONTENT_ITEM && !isInteractionTrackingItem(schema, actionType)) {
              return {
                ...item
              };
            }
            if (!isEmptyObject(metadataForScope)) {
              return {
                ...item,
                schema: isInteractionTrackingItem(schema, actionType) ? DOM_ACTION : schema,
                data: {
                  ...item.data,
                  selector,
                  type: actionType
                }
              };
            }
            return undefined;
          }).filter(item => item);
        };
        const filterPropositionsPredicate = proposition => {
          return !(proposition.scope === PAGE_WIDE_SCOPE && proposition.renderAttempted);
        };
        const preparePropositions = ({
          propositions,
          metadata
        }) => {
          return propositions.filter(filterPropositionsPredicate).map(proposition => {
            if (isNonEmptyArray(proposition.items)) {
              const {
                id,
                scope,
                scopeDetails
              } = proposition;
              return {
                id,
                scope,
                scopeDetails,
                items: updatePropositionItems({
                  items: proposition.items,
                  metadataForScope: metadata[proposition.scope]
                })
              };
            }
            return proposition;
          }).filter(proposition => isNonEmptyArray(proposition.items));
        };
        return ({
          propositions = [],
          metadata = {},
          viewName
        }) => {
          // We need to immediately call concat so that subsequent sendEvent
          // calls will wait for applyPropositions to complete before executing.
          const renderedPropositionsDeferred = defer();
          renderedPropositions.concat(renderedPropositionsDeferred.promise);
          const propositionsToExecute = preparePropositions({
            propositions,
            metadata
          }).map(proposition => createProposition(proposition));
          return Promise.resolve().then(() => {
            if (viewName) {
              return viewCache.getView(viewName);
            }
            return [];
          }).then(additionalPropositions => {
            const {
              render,
              returnedPropositions
            } = processPropositions([...propositionsToExecute, ...additionalPropositions]);
            render().then(renderedPropositionsDeferred.resolve);
            return {
              propositions: returnedPropositions
            };
          });
        };
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createGetPageLocation = ({
        window
      }) => () => {
        return window.location;
      };

      /*
      Copyright 2022 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createSetTargetMigration = ({
        targetMigrationEnabled
      }) => {
        if (targetMigrationEnabled) {
          return request => {
            request.getPayload().mergeMeta({
              target: {
                migration: true
              }
            });
          };
        }
        return noop;
      };

      /*
      Copyright 2021 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const TARGET_BODY_SELECTOR = "BODY > *:eq(0)";
      var remapCustomCodeOffers = action => {
        const {
          selector,
          type
        } = action;
        if (type !== DOM_ACTION_CUSTOM_CODE) {
          return action;
        }
        if (selector !== TARGET_BODY_SELECTOR) {
          return action;
        }
        return {
          ...action,
          ...{
            selector: "BODY"
          }
        };
      };

      /*
      Copyright 2021 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const HEAD_TAGS_SELECTOR = "SCRIPT,LINK,STYLE";
      const filterHeadContent = content => {
        const container = createFragment(content);
        const headNodes = selectNodes(HEAD_TAGS_SELECTOR, container);
        return headNodes.map(node => node.outerHTML).join("");
      };
      var remapHeadOffers = action => {
        const result = {
          ...action
        };
        const {
          content,
          selector
        } = result;
        if (isBlankString(content)) {
          return result;
        }
        if (selector == null) {
          return result;
        }
        const container = selectNodesWithEq(selector);
        if (!is(container[0], HEAD)) {
          return result;
        }
        result.type = DOM_ACTION_APPEND_HTML;
        result.content = filterHeadContent(content);
        return result;
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createPreprocess = preprocessors => action => {
        if (!action) {
          return action;
        }
        return preprocessors.reduce((processed, fn) => ({
          ...processed,
          ...fn(processed)
        }), action);
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectCreateProposition = ({
        preprocess,
        isPageWideSurface
      }) => {
        const createItem = (item, proposition) => {
          const {
            id,
            schema,
            data,
            characteristics: {
              trackingLabel
            } = {}
          } = item;
          const schemaType = data ? data.type : undefined;
          const processedData = preprocess(data);
          return {
            getId() {
              return id;
            },
            getSchema() {
              return schema;
            },
            getSchemaType() {
              return schemaType;
            },
            getData() {
              return processedData;
            },
            getProposition() {
              return proposition;
            },
            getTrackingLabel() {
              return trackingLabel;
            },
            getOriginalItem() {
              return item;
            },
            toString() {
              return JSON.stringify(item);
            },
            toJSON() {
              return item;
            }
          };
        };
        return (payload, visibleInReturnedItems = true) => {
          const {
            id,
            scope,
            scopeDetails,
            items = []
          } = payload;
          const {
            characteristics: {
              scopeType
            } = {}
          } = scopeDetails || {};
          return {
            getScope() {
              return scope;
            },
            getScopeType() {
              if (scope === PAGE_WIDE_SCOPE || isPageWideSurface(scope)) {
                return PAGE_SCOPE_TYPE;
              }
              if (scopeType === VIEW_SCOPE_TYPE) {
                return VIEW_SCOPE_TYPE;
              }
              return PROPOSITION_SCOPE_TYPE;
            },
            getItems() {
              return items.map(item => createItem(item, this));
            },
            getNotification() {
              return {
                id,
                scope,
                scopeDetails
              };
            },
            getId() {
              return id;
            },
            toJSON() {
              return payload;
            },
            addToReturnValues(propositions, decisions, includedItems, renderAttempted) {
              if (visibleInReturnedItems) {
                propositions.push({
                  ...payload,
                  items: includedItems.map(i => i.getOriginalItem()),
                  renderAttempted
                });
                if (!renderAttempted) {
                  decisions.push({
                    ...payload,
                    items: includedItems.map(i => i.getOriginalItem())
                  });
                }
              }
            }
          };
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createAsyncArray = () => {
        let latest = Promise.resolve([]);
        return {
          concat(promise) {
            latest = latest.then(existingPropositions => {
              return promise.then(newPropositions => {
                return existingPropositions.concat(newPropositions);
              }).catch(() => {
                return existingPropositions;
              });
            });
          },
          /**
           * Clears the saved propositions, waiting until the next propositions are resolved and available.
           *
           * @returns {Promise<Array>} A promise that resolves to the latest propositions.
           */
          clear() {
            const oldLatest = latest;
            latest = Promise.resolve([]);
            return oldLatest;
          }
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var processDefaultContent = () => {
        return {
          setRenderAttempted: true,
          includeInNotification: true
        };
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const ALWAYS = "always";
      const NEVER = "never";
      const DECORATED_ELEMENTS_ONLY = "decoratedElementsOnly";
      const PROPOSITION_INTERACTION_TYPES = [ALWAYS, NEVER, DECORATED_ELEMENTS_ONLY];

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const INTERACT_ID_DATA_ATTRIBUTE = "data-aep-interact-id";
      const CLICK_LABEL_DATA_ATTRIBUTE = "data-aep-click-label";
      const CLICK_TOKEN_DATA_ATTRIBUTE = "data-aep-click-token";
      let lastInteractId = 0;
      const getInteractId = (propositionId, existingInteractId) => {
        if (existingInteractId) {
          return parseInt(existingInteractId, 10);
        }

        // eslint-disable-next-line no-plusplus
        return ++lastInteractId;
      };
      const interactionTrackingSupported = (autoCollectPropositionInteractions, decisionProvider) => {
        if (!autoCollectPropositionInteractions) {
          return false;
        }
        if (!autoCollectPropositionInteractions[decisionProvider]) {
          return false;
        }
        return [ALWAYS, DECORATED_ELEMENTS_ONLY].includes(autoCollectPropositionInteractions[decisionProvider]);
      };
      const createDecorateProposition = (autoCollectPropositionInteractions, type, propositionId, itemId, trackingLabel, scopeType, notification, storeInteractionMeta) => {
        const {
          scopeDetails = {}
        } = notification;
        const {
          decisionProvider
        } = scopeDetails;
        if (!interactionTrackingSupported(autoCollectPropositionInteractions, decisionProvider) && type !== DOM_ACTION_CLICK) {
          return noop;
        }
        return element => {
          if (!element.tagName) {
            return;
          }
          const interactId = getInteractId(propositionId, getAttribute(element, INTERACT_ID_DATA_ATTRIBUTE));
          storeInteractionMeta(propositionId, itemId, scopeType, notification, interactId);
          setAttribute(element, INTERACT_ID_DATA_ATTRIBUTE, interactId);
          if (trackingLabel && !getAttribute(element, CLICK_LABEL_DATA_ATTRIBUTE)) {
            setAttribute(element, CLICK_LABEL_DATA_ATTRIBUTE, trackingLabel);
          }
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createProcessDomAction = ({
        modules,
        logger,
        storeInteractionMeta,
        storeClickMeta,
        autoCollectPropositionInteractions
      }) => item => {
        const {
          type,
          selector
        } = item.getData() || {};
        if (!type) {
          logger.warn("Invalid DOM action data: missing type.", item.getData());
          return {
            setRenderAttempted: false,
            includeInNotification: false
          };
        }
        if (type === DOM_ACTION_CLICK) {
          if (!selector) {
            logger.warn("Invalid DOM action data: missing selector.", item.getData());
            return {
              setRenderAttempted: false,
              includeInNotification: false
            };
          }
          storeClickMeta({
            selector,
            meta: {
              ...item.getProposition().getNotification(),
              trackingLabel: item.getTrackingLabel(),
              scopeType: item.getProposition().getScopeType()
            }
          });
          return {
            setRenderAttempted: true,
            includeInNotification: false
          };
        }
        if (!modules[type]) {
          logger.warn("Invalid DOM action data: unknown type.", item.getData());
          return {
            setRenderAttempted: false,
            includeInNotification: false
          };
        }
        const decorateProposition = createDecorateProposition(autoCollectPropositionInteractions, type, item.getProposition().getId(), item.getId(), item.getTrackingLabel(), item.getProposition().getScopeType(), item.getProposition().getNotification(), storeInteractionMeta);
        return {
          render: () => modules[type](item.getData(), decorateProposition),
          setRenderAttempted: true,
          includeInNotification: true
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createProcessHtmlContent = ({
        modules,
        logger,
        storeInteractionMeta,
        autoCollectPropositionInteractions
      }) => item => {
        const {
          type,
          selector
        } = item.getData() || {};
        if (!selector || !type) {
          return {
            setRenderAttempted: false,
            includeInNotification: false
          };
        }
        if (!modules[type]) {
          logger.warn("Invalid HTML content data", item.getData());
          return {
            setRenderAttempted: false,
            includeInNotification: false
          };
        }
        const decorateProposition = createDecorateProposition(autoCollectPropositionInteractions, type, item.getProposition().getId(), item.getId(), item.getTrackingLabel(), item.getProposition().getScopeType(), item.getProposition().getNotification(), storeInteractionMeta);
        return {
          render: () => {
            return modules[type](item.getData(), decorateProposition);
          },
          setRenderAttempted: true,
          includeInNotification: true
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createProcessRedirect = ({
        logger,
        executeRedirect,
        collect
      }) => item => {
        const {
          content
        } = item.getData() || {};
        if (!content) {
          logger.warn("Invalid Redirect data", item.getData());
          return {};
        }
        const render = () => {
          return collect({
            decisionsMeta: [item.getProposition().getNotification()],
            documentMayUnload: true
          }).then(() => {
            logger.logOnContentRendering({
              status: "rendering-redirect",
              detail: {
                propositionDetails: item.getProposition().getNotification(),
                redirect: content
              },
              message: "Redirect action " + item.toString() + " executed.",
              logLevel: "info"
            });
            return executeRedirect(content);
            // Execute redirect will never resolve. If there are bottom of page events that are waiting
            // for display notifications from this request, they will never run because this promise will
            // not resolve. This is intentional because we don't want to run bottom of page events if
            // there is a redirect.
          });
        };
        return {
          render,
          setRenderAttempted: true,
          onlyRenderThis: true
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createProcessPropositions = ({
        schemaProcessors,
        logger
      }) => {
        const wrapRenderWithLogging = (render, item) => () => {
          return Promise.resolve().then(render).then(() => {
            if (logger.enabled) {
              logger.info("Action " + item.toString() + " executed.");
            }
            return true;
          }).catch(error => {
            const {
              message,
              stack
            } = error;
            const warning = "Failed to execute action " + item.toString() + ". " + message + " " + stack;
            logger.logOnContentRendering({
              status: "rendering-failed",
              detail: {
                propositionDetails: item.getProposition().getNotification(),
                item: item.toJSON()
              },
              error,
              message: warning,
              logLevel: "warn"
            });
            return false;
          });
        };
        const renderItems = (renderers, meta) => Promise.all(renderers.map(renderer => renderer())).then(successes => {
          // as long as at least one renderer succeeds, we want to add the notification
          // to the display notifications
          if (!successes.includes(true)) {
            return undefined;
          }
          return meta;
        });
        const processItem = item => {
          const processor = schemaProcessors[item.getSchema()];
          if (!processor) {
            return {};
          }
          return processor(item);
        };
        const processItems = ({
          renderers: existingRenderers,
          returnedPropositions: existingReturnedPropositions,
          returnedDecisions: existingReturnedDecisions,
          items,
          proposition
        }) => {
          let renderers = [...existingRenderers];
          let returnedPropositions = [...existingReturnedPropositions];
          let returnedDecisions = [...existingReturnedDecisions];
          let renderedItems = [];
          let nonRenderedItems = [];
          let itemRenderers = [];
          let atLeastOneWithNotification = false;
          let render;
          let setRenderAttempted;
          let includeInNotification;
          let onlyRenderThis = false;
          let i = 0;
          let item;
          while (items.length > i) {
            item = items[i];
            ({
              render,
              setRenderAttempted,
              includeInNotification,
              onlyRenderThis
            } = processItem(item));
            if (onlyRenderThis) {
              returnedPropositions = [];
              returnedDecisions = [];
              if (setRenderAttempted) {
                renderedItems = [item];
                nonRenderedItems = [];
              } else {
                renderedItems = [];
                nonRenderedItems = [item];
              }
              renderers = [];
              itemRenderers = [render];
              atLeastOneWithNotification = includeInNotification;
              break;
            }
            if (render) {
              itemRenderers.push(wrapRenderWithLogging(render, item));
            }
            if (includeInNotification) {
              atLeastOneWithNotification = true;
            }
            if (setRenderAttempted) {
              renderedItems.push(item);
            } else {
              nonRenderedItems.push(item);
            }
            i += 1;
          }
          if (itemRenderers.length > 0) {
            const meta = atLeastOneWithNotification ? proposition.getNotification() : undefined;
            renderers.push(() => renderItems(itemRenderers, meta));
          } else if (atLeastOneWithNotification) {
            renderers.push(() => Promise.resolve(proposition.getNotification()));
          }
          if (renderedItems.length > 0) {
            proposition.addToReturnValues(returnedPropositions, returnedDecisions, renderedItems, true);
          }
          if (nonRenderedItems.length > 0) {
            proposition.addToReturnValues(returnedPropositions, returnedDecisions, nonRenderedItems, false);
          }
          return {
            renderers,
            returnedPropositions,
            returnedDecisions,
            onlyRenderThis
          };
        };
        return (renderPropositions, nonRenderPropositions = []) => {
          let renderers = [];
          let returnedPropositions = [];
          let returnedDecisions = [];
          let onlyRenderThis;
          let i = 0;
          let proposition;
          let items;
          while (renderPropositions.length > i) {
            proposition = renderPropositions[i];
            items = proposition.getItems();
            ({
              renderers,
              returnedPropositions,
              returnedDecisions,
              onlyRenderThis
            } = processItems({
              renderers,
              returnedPropositions,
              returnedDecisions,
              items,
              proposition
            }));
            if (onlyRenderThis) {
              break;
            }
            i += 1;
          }
          if (onlyRenderThis) {
            // if onlyRenderThis is true, that means returnedPropositions and returnedDecisions
            // only contains the proposition that triggered only rendering this. We need to
            // add the other propositions to the returnedPropositions and returnedDecisions.
            renderPropositions.forEach((p, index) => {
              if (index !== i) {
                p.addToReturnValues(returnedPropositions, returnedDecisions, p.getItems(), false);
              }
            });
          }
          nonRenderPropositions.forEach(p => {
            p.addToReturnValues(returnedPropositions, returnedDecisions, p.getItems(), false);
          });
          const render = () => {
            return Promise.all(renderers.map(renderer => renderer())).then(metas => {
              const renderedPropositions = metas.filter(meta => meta);
              const propsByScope = groupBy(renderedPropositions, p => p.scope);
              logger.logOnContentRendering({
                status: "rendering-succeeded",
                detail: {
                  ...propsByScope
                },
                message: "Scopes: " + JSON.stringify(propsByScope) + " successfully executed.",
                logLevel: "info"
              });
              return renderedPropositions;
            });
          };
          return {
            returnedPropositions,
            returnedDecisions,
            render
          };
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createOnDecisionHandler = ({
        processPropositions,
        createProposition,
        notificationHandler
      }) => {
        return ({
          renderDecisions,
          propositions,
          event,
          personalization = {}
        }) => {
          if (!renderDecisions) {
            return Promise.resolve();
          }
          const {
            sendDisplayEvent = true
          } = personalization;
          const viewName = event ? event.getViewName() : undefined;
          const propositionsToExecute = propositions.map(proposition => createProposition(proposition, true));
          const {
            render,
            returnedPropositions
          } = processPropositions(propositionsToExecute);
          const handleNotifications = notificationHandler(renderDecisions, sendDisplayEvent, viewName);
          render().then(handleNotifications);
          return Promise.resolve({
            propositions: returnedPropositions
          });
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const DEFAULT_CONTENT = "defaultContent";
      const expectedProps = ["content", "contentType"];
      const expectedContentProps = ["mobileParameters", "webParameters", "html"];
      const isValidInAppMessage = (data, logger) => {
        for (let i = 0; i < expectedProps.length; i += 1) {
          const prop = expectedProps[i];
          if (!Object.prototype.hasOwnProperty.call(data, prop)) {
            logger.warn("Invalid in-app message data: missing property '" + prop + "'.", data);
            return false;
          }
        }
        const {
          content,
          contentType
        } = data;
        if (contentType === APPLICATION_JSON) {
          for (let i = 0; i < expectedContentProps.length; i += 1) {
            const prop = expectedContentProps[i];
            if (!Object.prototype.hasOwnProperty.call(content, prop)) {
              logger.warn("Invalid in-app message data.content: missing property '" + prop + "'.", data);
              return false;
            }
          }
        }
        return true;
      };
      var createProcessInAppMessage = ({
        modules,
        logger
      }) => {
        return item => {
          const data = item.getData();
          const meta = {
            ...item.getProposition().getNotification()
          };
          if (!data) {
            logger.warn("Invalid in-app message data: undefined.", data);
            return {};
          }
          const {
            type = DEFAULT_CONTENT
          } = data;
          if (!modules[type]) {
            logger.warn("Invalid in-app message data: unknown type.", data);
            return {};
          }
          if (!isValidInAppMessage(data, logger)) {
            return {};
          }
          if (!meta) {
            logger.warn("Invalid in-app message meta: undefined.", meta);
            return {};
          }
          return {
            render: () => {
              return modules[type]({
                ...data,
                meta
              });
            },
            setRenderAttempted: true,
            includeInNotification: true
          };
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const removeElementById = id => {
        const element = selectNodes("#" + id, document);
        if (element && element.length > 0) {
          removeNode(element[0]);
        }
      };
      const parseAnchor = anchor => {
        const nothing = {};
        if (!anchor || anchor.tagName.toLowerCase() !== "a") {
          return nothing;
        }
        const {
          href
        } = anchor;
        if (!href || !href.startsWith("adbinapp://")) {
          return nothing;
        }
        const hrefParts = href.split("?");
        const action = hrefParts[0].split("://")[1];
        const label = anchor.innerText;
        const uuid = anchor.getAttribute("data-uuid") || "";
        let interaction;
        let link;
        if (isNonEmptyArray(hrefParts)) {
          const queryParams = queryString.parse(hrefParts[1]);
          interaction = queryParams.interaction || "";
          link = decodeUriComponentSafely(queryParams.link || "");
        }
        return {
          action,
          interaction,
          link,
          label,
          uuid
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createRedirect = window => (url, preserveHistory = false) => {
        if (preserveHistory) {
          window.location.href = url;
        } else {
          window.location.replace(url);
        }
        // Return a promise that never resolves because redirects never complete
        // within the current page.
        return new Promise(() => {});
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const MESSAGING_CONTAINER_ID = "alloy-messaging-container";
      const OVERLAY_CONTAINER_ID = "alloy-overlay-container";
      const IFRAME_ID = "alloy-content-iframe";
      const dismissMessage = () => [MESSAGING_CONTAINER_ID, OVERLAY_CONTAINER_ID].forEach(removeElementById);
      const createIframeClickHandler = (interact, navigateToUrl = createRedirect(window)) => {
        return event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          const {
            target
          } = event;
          const anchor = target.tagName.toLowerCase() === "a" ? target : target.closest("a");
          if (!anchor) {
            return;
          }
          const {
            action,
            interaction,
            link,
            label,
            uuid
          } = parseAnchor(anchor);
          interact(action, {
            label,
            id: interaction,
            uuid,
            link
          });
          if (action === "dismiss") {
            dismissMessage();
          }
          if (isNonEmptyString(link) && link.length > 0) {
            navigateToUrl(link, true);
          }
        };
      };
      const createIframe = (htmlContent, clickHandler) => {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(htmlContent, TEXT_HTML);
        const scriptTag = htmlDocument.querySelector("script");
        if (scriptTag) {
          scriptTag.setAttribute("nonce", getNonce());
        }
        const element = createNode("iframe", {
          src: URL.createObjectURL(new Blob([htmlDocument.documentElement.outerHTML], {
            type: "text/html"
          })),
          id: IFRAME_ID
        });
        element.addEventListener("load", () => {
          const {
            addEventListener
          } = element.contentDocument || element.contentWindow.document;
          addEventListener("click", clickHandler);
        });
        return element;
      };
      const renderMessage = (iframe, webParameters, container, overlay) => {
        [{
          id: OVERLAY_CONTAINER_ID,
          element: overlay
        }, {
          id: MESSAGING_CONTAINER_ID,
          element: container
        }, {
          id: IFRAME_ID,
          element: iframe
        }].forEach(({
          id,
          element
        }) => {
          const {
            style = {},
            params = {}
          } = webParameters[id];
          element.style = {
            ...element.style,
            ...style
          };
          const {
            parentElement = "body",
            insertionMethod = "appendChild",
            enabled = true
          } = params;
          const parent = document.querySelector(parentElement);
          if (enabled && parent && typeof parent[insertionMethod] === "function") {
            parent[insertionMethod](element);
          }
        });
      };
      const buildStyleFromMobileParameters = mobileParameters => {
        const {
          verticalAlign,
          width,
          horizontalAlign,
          backdropColor,
          height,
          cornerRadius,
          horizontalInset,
          verticalInset,
          uiTakeover = false
        } = mobileParameters;
        const style = {
          width: width ? width + "%" : "100%",
          backgroundColor: backdropColor || "rgba(0, 0, 0, 0.5)",
          borderRadius: cornerRadius ? cornerRadius + "px" : "0px",
          border: "none",
          position: uiTakeover ? "fixed" : "relative",
          overflow: "hidden"
        };
        if (horizontalAlign === "left") {
          style.left = horizontalInset ? horizontalInset + "%" : "0";
        } else if (horizontalAlign === "right") {
          style.right = horizontalInset ? horizontalInset + "%" : "0";
        } else if (horizontalAlign === "center") {
          style.left = "50%";
          style.transform = "translateX(-50%)";
        }
        if (verticalAlign === "top") {
          style.top = verticalInset ? verticalInset + "%" : "0";
        } else if (verticalAlign === "bottom") {
          style.position = "fixed";
          style.bottom = verticalInset ? verticalInset + "%" : "0";
        } else if (verticalAlign === "center") {
          style.top = "50%";
          style.transform = (horizontalAlign === "center" ? style.transform + " " : "") + "translateY(-50%)";
          style.display = "flex";
          style.alignItems = "center";
          style.justifyContent = "center";
        }
        if (height) {
          style.height = height + "vh";
        } else {
          style.height = "100%";
        }
        return style;
      };
      const mobileOverlay = mobileParameters => {
        const {
          backdropOpacity,
          backdropColor
        } = mobileParameters;
        const opacity = backdropOpacity || 0.5;
        const color = backdropColor || "#FFFFFF";
        const style = {
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          background: "transparent",
          opacity,
          backgroundColor: color
        };
        return style;
      };
      const REQUIRED_PARAMS = ["enabled", "parentElement", "insertionMethod"];
      const isValidWebParameters = webParameters => {
        if (!webParameters) {
          return false;
        }
        const ids = Object.keys(webParameters);
        if (!ids.includes(MESSAGING_CONTAINER_ID)) {
          return false;
        }
        if (!ids.includes(OVERLAY_CONTAINER_ID)) {
          return false;
        }
        const valuesArray = Object.values(webParameters);
        for (let i = 0; i < valuesArray.length; i += 1) {
          if (!boundObjectOf(valuesArray[i], "style")) {
            return false;
          }
          if (!boundObjectOf(valuesArray[i], "params")) {
            return false;
          }
          for (let j = 0; j < REQUIRED_PARAMS.length; j += 1) {
            if (!boundObjectOf(valuesArray[i].params, REQUIRED_PARAMS[j])) {
              return false;
            }
          }
        }
        return true;
      };
      const generateWebParameters = mobileParameters => {
        if (!mobileParameters) {
          return undefined;
        }
        const {
          uiTakeover = false
        } = mobileParameters;
        return {
          [IFRAME_ID]: {
            style: {
              border: "none",
              width: "100%",
              height: "100%"
            },
            params: {
              enabled: true,
              parentElement: "#alloy-messaging-container",
              insertionMethod: "appendChild"
            }
          },
          [MESSAGING_CONTAINER_ID]: {
            style: buildStyleFromMobileParameters(mobileParameters),
            params: {
              enabled: true,
              parentElement: "body",
              insertionMethod: "appendChild"
            }
          },
          [OVERLAY_CONTAINER_ID]: {
            style: mobileOverlay(mobileParameters),
            params: {
              enabled: uiTakeover === true,
              parentElement: "body",
              insertionMethod: "appendChild"
            }
          }
        };
      };

      // eslint-disable-next-line default-param-last
      const displayHTMLContentInIframe = (settings = {}, interact) => {
        dismissMessage();
        const {
          content,
          contentType,
          mobileParameters
        } = settings;
        let {
          webParameters
        } = settings;
        if (contentType !== TEXT_HTML) {
          return;
        }
        const container = createNode("div", {
          id: MESSAGING_CONTAINER_ID
        });
        const iframe = createIframe(content, createIframeClickHandler(interact));
        const overlay = createNode("div", {
          id: OVERLAY_CONTAINER_ID
        });
        if (!isValidWebParameters(webParameters)) {
          webParameters = generateWebParameters(mobileParameters);
        }
        if (!webParameters) {
          return;
        }
        renderMessage(iframe, webParameters, container, overlay);
      };
      var displayIframeContent = (settings, collect) => {
        return new Promise(resolve => {
          const {
            meta
          } = settings;
          displayHTMLContentInIframe(settings, (action, propositionAction) => {
            const propositionEventTypes = {};
            propositionEventTypes[PropositionEventType.INTERACT] = EVENT_TYPE_TRUE;
            if (Object.values(PropositionEventType).indexOf(action) !== -1) {
              propositionEventTypes[action] = EVENT_TYPE_TRUE;
            }
            collect({
              decisionsMeta: [meta],
              propositionAction,
              eventType: INTERACT,
              propositionEventTypes: Object.keys(propositionEventTypes)
            });
          });
          resolve({
            meta
          });
        });
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var initInAppMessageActionsModules = collect => {
        return {
          defaultContent: settings => displayIframeContent(settings, collect)
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createNotificationHandler = (collect, renderedPropositions) => {
        return (isRenderDecisions, isSendDisplayEvent, viewName) => {
          if (!isRenderDecisions) {
            // If we aren't rendering anything, then we don't need to sendDisplayEvents.
            return () => undefined;
          }
          if (!isSendDisplayEvent) {
            const renderedPropositionsDeferred = defer();
            renderedPropositions.concat(renderedPropositionsDeferred.promise);
            return renderedPropositionsDeferred.resolve;
          }
          return decisionsMeta => {
            if (decisionsMeta.length > 0) {
              collect({
                decisionsMeta,
                viewName
              });
            }
          };
        };
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createHandleConsentFlicker = ({
        showContainers,
        consent
      }) => () => {
        const {
          state,
          wasSet
        } = consent.current();
        if (state === OUT && wasSet) {
          showContainers();
        } else {
          consent.awaitConsent().catch(showContainers);
        }
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const getInteractionDetail = clickedElement => {
        const {
          documentElement
        } = document;
        let element = clickedElement;
        const interactIds = new Set();
        let clickLabel;
        let clickToken;
        while (element && element !== documentElement) {
          const interactId = getAttribute(element, INTERACT_ID_DATA_ATTRIBUTE);
          if (interactId) {
            interactIds.add(interactId);
          }
          clickLabel = clickLabel || getAttribute(element, CLICK_LABEL_DATA_ATTRIBUTE);
          clickToken = clickToken || getAttribute(element, CLICK_TOKEN_DATA_ATTRIBUTE);
          element = element.parentNode;
        }
        return {
          interactIds: [...interactIds],
          clickLabel,
          clickToken
        };
      };
      const extractViewName = metas => {
        const foundMetaWithScopeTypeView = metas.find(meta => meta.scopeType === VIEW_SCOPE_TYPE);
        return foundMetaWithScopeTypeView ? foundMetaWithScopeTypeView.scope : undefined;
      };
      const createMetaFilter = (autoCollectPropositionInteractions, clickLabel, clickToken) => meta => {
        const {
          scopeDetails = {}
        } = meta;
        const {
          decisionProvider
        } = scopeDetails;
        if (autoCollectPropositionInteractions[decisionProvider] === ALWAYS) {
          return true;
        }
        return autoCollectPropositionInteractions[decisionProvider] === DECORATED_ELEMENTS_ONLY && (clickLabel || clickToken);
      };
      var collectInteractions = (clickedElement, getInteractionMetas, autoCollectPropositionInteractions) => {
        const {
          interactIds,
          clickLabel = "",
          clickToken
        } = getInteractionDetail(clickedElement);
        const metasMatchingConfigurationOptions = createMetaFilter(autoCollectPropositionInteractions, clickLabel, clickToken);
        if (interactIds.length === 0) {
          return {};
        }
        const metas = getInteractionMetas(interactIds).filter(metasMatchingConfigurationOptions);
        return {
          decisionsMeta: cleanMetas(metas),
          propositionActionLabel: clickLabel,
          propositionActionToken: clickToken,
          viewName: extractViewName(metas)
        };
      };

      /*
      Copyright 2019 Adobe. Ackll rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createPersonalization = ({
        config,
        logger,
        eventManager,
        consent
      }) => {
        const {
          targetMigrationEnabled,
          prehidingStyle,
          autoCollectPropositionInteractions
        } = config;
        const collect = createCollect({
          eventManager,
          mergeDecisionsMeta
        });
        const showContainers = createShowContainers(logger);
        const hideContainers = createHideContainers(logger);
        const {
          storeInteractionMeta,
          getInteractionMetas
        } = createInteractionStorage();
        const {
          storeClickMeta,
          getClickSelectors,
          getClickMetas
        } = createClickStorage();
        const getPageLocation = createGetPageLocation({
          window
        });
        const domActionsModules = initDomActionsModules();
        const preprocess = createPreprocess([remapHeadOffers, remapCustomCodeOffers]);
        const createProposition = injectCreateProposition({
          preprocess,
          isPageWideSurface
        });
        const viewCache = createViewCacheManager({
          createProposition
        });
        const executeRedirect = createRedirect(window);
        const schemaProcessors = {
          [DEFAULT_CONTENT_ITEM]: processDefaultContent,
          [DOM_ACTION]: createProcessDomAction({
            modules: domActionsModules,
            logger,
            storeInteractionMeta,
            storeClickMeta,
            autoCollectPropositionInteractions
          }),
          [HTML_CONTENT_ITEM]: createProcessHtmlContent({
            modules: domActionsModules,
            logger,
            storeInteractionMeta,
            autoCollectPropositionInteractions
          }),
          [REDIRECT_ITEM]: createProcessRedirect({
            logger,
            executeRedirect,
            collect
          }),
          [MESSAGE_IN_APP]: createProcessInAppMessage({
            modules: initInAppMessageActionsModules(collect),
            logger
          })
        };
        const processPropositions = createProcessPropositions({
          schemaProcessors,
          logger
        });
        const renderedPropositions = createAsyncArray();
        const notificationHandler = createNotificationHandler(collect, renderedPropositions);
        const fetchDataHandler = createFetchDataHandler({
          prehidingStyle,
          showContainers,
          hideContainers,
          mergeQuery,
          processPropositions,
          createProposition,
          notificationHandler,
          consent,
          logger
        });
        const onClickHandler = createOnClickHandler({
          mergeDecisionsMeta,
          collectInteractions,
          collectClicks,
          getInteractionMetas,
          getClickMetas,
          getClickSelectors,
          autoCollectPropositionInteractions
        });
        const viewChangeHandler = createViewChangeHandler({
          processPropositions,
          viewCache,
          logger
        });
        const applyPropositions = createApplyPropositions({
          processPropositions,
          createProposition,
          renderedPropositions,
          viewCache
        });
        const setTargetMigration = createSetTargetMigration({
          targetMigrationEnabled
        });
        const onDecisionHandler = createOnDecisionHandler({
          processPropositions,
          createProposition,
          notificationHandler
        });
        const handleConsentFlicker = createHandleConsentFlicker({
          showContainers,
          consent
        });
        return createComponent$1({
          getPageLocation,
          logger,
          fetchDataHandler,
          viewChangeHandler,
          onClickHandler,
          isAuthoringModeEnabled,
          mergeQuery,
          viewCache,
          showContainers,
          applyPropositions,
          setTargetMigration,
          mergeDecisionsMeta,
          renderedPropositions,
          onDecisionHandler,
          handleConsentFlicker
        });
      };
      createPersonalization.namespace = "Personalization";
      const interactionConfigOptions = PROPOSITION_INTERACTION_TYPES.map(propositionInteractionType => boundLiteral(propositionInteractionType));
      createPersonalization.configValidators = boundObjectOf({
        prehidingStyle: boundString().nonEmpty(),
        targetMigrationEnabled: boundBoolean().default(false),
        autoCollectPropositionInteractions: boundObjectOf({
          [ADOBE_JOURNEY_OPTIMIZER]: boundAnyOf(interactionConfigOptions).default(ALWAYS),
          [ADOBE_TARGET]: boundAnyOf(interactionConfigOptions).default(NEVER)
        }).default({
          [ADOBE_JOURNEY_OPTIMIZER]: ALWAYS,
          [ADOBE_TARGET]: NEVER
        }).noUnknownFields()
      });

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createComponent = ({
        storedConsent,
        taskQueue,
        defaultConsent,
        consent,
        sendSetConsentRequest,
        validateSetConsentOptions,
        consentHashStore,
        doesIdentityCookieExist
      }) => {
        const defaultConsentByPurpose = {
          [GENERAL]: defaultConsent
        };
        let storedConsentByPurpose = storedConsent.read();
        const identityCookieExists = doesIdentityCookieExist();
        const consentCookieExists = storedConsentByPurpose[GENERAL] !== undefined;
        if (!identityCookieExists || !consentCookieExists) {
          consentHashStore.clear();
        }
        // If the identity cookie is gone, remove the consent cookie because the
        // consent info is tied to the identity.
        if (!identityCookieExists) {
          storedConsent.clear();
          storedConsentByPurpose = {};
        }
        consent.initializeConsent(defaultConsentByPurpose, storedConsentByPurpose);
        const readCookieIfQueueEmpty = () => {
          if (taskQueue.length === 0) {
            const storedConsentObject = storedConsent.read();
            // Only read cookies when there are no outstanding setConsent
            // requests. This helps with race conditions.
            if (storedConsentObject[GENERAL] !== undefined) {
              consent.setConsent(storedConsentObject);
            }
          }
        };
        return {
          commands: {
            setConsent: {
              optionsValidator: validateSetConsentOptions,
              run: ({
                consent: consentOptions,
                identityMap,
                edgeConfigOverrides
              }) => {
                consent.suspend();
                const consentHashes = consentHashStore.lookup(consentOptions);
                return taskQueue.addTask(() => {
                  if (consentHashes.isNew()) {
                    return sendSetConsentRequest({
                      consentOptions,
                      identityMap,
                      edgeConfigOverrides
                    });
                  }
                  return Promise.resolve();
                }).then(() => consentHashes.save()).finally(readCookieIfQueueEmpty);
              }
            }
          },
          lifecycle: {
            // Read the cookie here too because the consent cookie may change on any request
            onResponse: readCookieIfQueueEmpty,
            // Even when we get a failure HTTP status code, the consent cookie can
            // still get updated. This could happen, for example, if the user is
            // opted out in AudienceManager, but no consent cookie exists on the
            // client. The request will be sent and the server will respond with a
            // 403 Forbidden and a consent cookie.
            onRequestFailure: readCookieIfQueueEmpty
          }
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // serialize an object with a consistent ordering
      const serialize = obj => {
        if (Array.isArray(obj)) {
          return obj.map(i => serialize(i));
        }
        if (typeof obj === "object" && obj !== null) {
          return Object.keys(obj).sort().reduce((memo, key) => {
            memo[key] = serialize(obj[key]);
            return memo;
          }, {});
        }
        return obj;
      };
      var computeConsentHash = obj => {
        return crc32(JSON.stringify(serialize(obj)));
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      const getKey = ({
        standard,
        version
      }) => {
        return standard + "." + version;
      };
      var createConsentHashStore = ({
        storage
      }) => {
        return {
          clear() {
            storage.clear();
          },
          lookup(consentObjects) {
            const currentHashes = {};
            const getCurrentHash = consentObject => {
              const key = getKey(consentObject);
              const {
                standard,
                version,
                ...rest
              } = consentObject;
              if (!currentHashes[key]) {
                currentHashes[key] = computeConsentHash(rest).toString();
              }
              return currentHashes[key];
            };
            return {
              isNew() {
                return consentObjects.some(consentObject => {
                  const key = getKey(consentObject);
                  const previousHash = storage.getItem(key);
                  return previousHash === null || previousHash !== getCurrentHash(consentObject);
                });
              },
              save() {
                consentObjects.forEach(consentObject => {
                  const key = getKey(consentObject);
                  storage.setItem(key, getCurrentHash(consentObject));
                });
              }
            };
          }
        };
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createConsentRequestPayload = () => {
        const content = {};
        const payload = createRequestPayload({
          content,
          addIdentity: (namespaceCode, identity) => {
            content.identityMap = content.identityMap || {};
            content.identityMap[namespaceCode] = content.identityMap[namespaceCode] || [];
            content.identityMap[namespaceCode].push(identity);
          },
          hasIdentity: namespaceCode => {
            return (content.identityMap && content.identityMap[namespaceCode]) !== undefined;
          }
        });
        payload.setConsent = consent => {
          content.consent = consent;
        };
        return payload;
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createConsentRequest = ({
        payload,
        datastreamIdOverride
      }) => {
        return createRequest({
          payload,
          datastreamIdOverride,
          getAction() {
            return "privacy/set-consent";
          },
          getUseSendBeacon() {
            return false;
          }
        });
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var createStoredConsent = ({
        parseConsentCookie,
        orgId,
        cookieJar
      }) => {
        const consentCookieName = getNamespacedCookieName(orgId, CONSENT);
        return {
          read() {
            const cookieValue = cookieJar.get(consentCookieName);
            return cookieValue ? parseConsentCookie(cookieValue) : {};
          },
          clear() {
            cookieJar.remove(consentCookieName);
          }
        };
      };

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var injectSendSetConsentRequest = ({
        createConsentRequestPayload,
        createConsentRequest,
        sendEdgeNetworkRequest,
        edgeConfigOverrides: globalConfigOverrides
      }) => ({
        consentOptions,
        identityMap,
        edgeConfigOverrides: localConfigOverrides
      }) => {
        const requestParams = createRequestParams({
          payload: createConsentRequestPayload(),
          globalConfigOverrides,
          localConfigOverrides
        });
        requestParams.payload.setConsent(consentOptions);
        if (isObject(identityMap)) {
          Object.keys(identityMap).forEach(key => {
            identityMap[key].forEach(identity => {
              requestParams.payload.addIdentity(key, identity);
            });
          });
        }
        const request = createConsentRequest(requestParams);
        return sendEdgeNetworkRequest({
          request
        }).then(() => {
          // Don't let response data disseminate beyond this
          // point unless necessary.
        });
      };

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      /**
       * Parses a consent cookie.
       * @param {string} cookieValue Must be in the format a=b;c=d
       * @returns {Object} An object where the keys are purpose names and the values
       * are the consent status for the purpose.
       */
      var parseConsentCookie = cookieValue => {
        const categoryPairs = cookieValue.split(";");
        return categoryPairs.reduce((consentByPurpose, categoryPair) => {
          const [name, value] = categoryPair.split("=");
          consentByPurpose[name] = value;
          return consentByPurpose;
        }, {});
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var validateSetConsentOptions = boundObjectOf({
        consent: boundArrayOf(boundAnything()).required().nonEmpty(),
        identityMap: validateIdentityMap,
        edgeConfigOverrides: validateConfigOverride
      }).noUnknownFields().required();

      /*
      Copyright 2019 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      const createPrivacy = ({
        config,
        consent,
        sendEdgeNetworkRequest,
        createNamespacedStorage
      }) => {
        const {
          orgId,
          defaultConsent
        } = config;
        const storedConsent = createStoredConsent({
          parseConsentCookie,
          orgId,
          cookieJar
        });
        const taskQueue = createTaskQueue();
        const sendSetConsentRequest = injectSendSetConsentRequest({
          createConsentRequestPayload,
          createConsentRequest,
          sendEdgeNetworkRequest,
          edgeConfigOverrides: config.edgeConfigOverrides
        });
        const storage = createNamespacedStorage(sanitizeOrgIdForCookieName(orgId) + ".consentHashes.");
        const consentHashStore = createConsentHashStore({
          storage: storage.persistent
        });
        const doesIdentityCookieExist = injectDoesIdentityCookieExist({
          orgId
        });
        return createComponent({
          storedConsent,
          taskQueue,
          defaultConsent,
          consent,
          sendSetConsentRequest,
          validateSetConsentOptions,
          consentHashStore,
          doesIdentityCookieExist
        });
      };
      createPrivacy.namespace = "Privacy";

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var configValidators = boundObjectOf({
        streamingMedia: boundObjectOf({
          channel: boundString().nonEmpty().required(),
          playerName: boundString().nonEmpty().required(),
          appVersion: boundString(),
          mainPingInterval: boundNumber().minimum(10).maximum(50).default(10),
          adPingInterval: boundNumber().minimum(1).maximum(10).default(10)
        }).noUnknownFields()
      });

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var validateSessionOptions = ({
        options
      }) => {
        const sessionValidator = boundAnyOf([boundObjectOf({
          playerId: boundString().required(),
          getPlayerDetails: boundCallback().required(),
          xdm: boundObjectOf({
            mediaCollection: boundObjectOf({
              sessionDetails: boundObjectOf(boundAnything()).required()
            })
          })
        }).required(), boundObjectOf({
          xdm: boundObjectOf({
            mediaCollection: boundObjectOf({
              playhead: boundNumber().required(),
              sessionDetails: boundObjectOf(boundAnything()).required()
            })
          })
        }).required()], "Error validating the createMediaSession command options.");
        return sessionValidator(options);
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var validateMediaEventOptions = ({
        options
      }) => {
        const validator = boundAnyOf([boundObjectOf({
          playerId: boundString().required(),
          xdm: boundObjectOf({
            eventType: boundEnumOf(...Object.values(EventTypes)).required(),
            mediaCollection: boundObjectOf(boundAnything())
          }).required()
        }).required(), boundObjectOf({
          xdm: boundObjectOf({
            eventType: boundEnumOf(...Object.values(EventTypes)).required(),
            mediaCollection: boundObjectOf({
              playhead: boundNumber().integer().required(),
              sessionID: boundString().required()
            }).required()
          }).required()
        }).required()], "Error validating the sendMediaEvent command options.");
        return validator(options);
      };

      /*
      Copyright 2024 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      var createStreamingMediaComponent = ({
        config,
        trackMediaEvent,
        trackMediaSession,
        mediaResponseHandler
      }) => {
        return {
          lifecycle: {
            onBeforeEvent({
              mediaOptions,
              onResponse = noop
            }) {
              if (!mediaOptions) {
                return;
              }
              const {
                legacy,
                playerId,
                getPlayerDetails
              } = mediaOptions;
              if (legacy) {
                return;
              }
              onResponse(({
                response
              }) => {
                return mediaResponseHandler({
                  playerId,
                  getPlayerDetails,
                  response
                });
              });
            }
          },
          commands: {
            createMediaSession: {
              optionsValidator: options => validateSessionOptions({
                options
              }),
              run: trackMediaSession
            },
            sendMediaEvent: {
              optionsValidator: options => validateMediaEventOptions({
                options
              }),
              run: options => {
                if (!config.streamingMedia) {
                  return Promise.reject(new Error("Streaming media is not configured."));
                }
                return trackMediaEvent(options);
              }
            }
          }
        };
      };

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */
      /* eslint-disable import/no-restricted-paths */
      const createStreamingMedia = ({
        config,
        logger,
        eventManager,
        sendEdgeNetworkRequest,
        consent
      }) => {
        const mediaSessionCacheManager = createMediaSessionCacheManager();
        const mediaEventManager = createMediaEventManager({
          config,
          eventManager,
          logger,
          consent,
          sendEdgeNetworkRequest,
          setTimestamp: injectTimestamp(() => new Date())
        });
        const trackMediaEvent = createTrackMediaEvent({
          mediaSessionCacheManager,
          mediaEventManager,
          config
        });
        const trackMediaSession = createTrackMediaSession({
          config,
          mediaEventManager,
          mediaSessionCacheManager
        });
        const mediaResponseHandler = createMediaResponseHandler({
          mediaSessionCacheManager,
          config,
          trackMediaEvent
        });
        return createStreamingMediaComponent({
          config,
          trackMediaEvent,
          mediaEventManager,
          mediaResponseHandler,
          trackMediaSession
        });
      };
      createStreamingMedia.namespace = "Streaming media";
      createStreamingMedia.configValidators = configValidators;

      /*
      Copyright 2023 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      var components = /*#__PURE__*/Object.freeze({
        __proto__: null,
        activityCollector: createActivityCollector,
        audiences: createAudiences,
        context: createContext,
        decisioningEngine: createDecisioningEngine,
        eventMerge: createEventMerge,
        legacyMediaAnalytics: createLegacyMediaAnalytics,
        machineLearning: createMachineLearning,
        personalization: createPersonalization,
        privacy: createPrivacy,
        streamingMedia: createStreamingMedia
      });

      /*
      Copyright 2020 Adobe. All rights reserved.
      This file is licensed to you under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License. You may obtain a copy
      of the License at http://www.apache.org/licenses/LICENSE-2.0
      	Unless required by applicable law or agreed to in writing, software distributed under
      the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
      OF ANY KIND, either express or implied. See the License for the specific language
      governing permissions and limitations under the License.
      */

      // If you change this line, check if the custom build script is still working.
      // You might need to change the babel plugin in scripts/helpers/entryPointGeneratorBabelPlugin.js.
      core({
        components: Object.values(components)
      });
    })();
  }));
  /* global inject */
  inject((Analytics, Config, store) => {
    if (Analytics.mode === 'web') {
      Config.supportedProducts.push('CEA', 'SiteCatalyst', 'GoogleRemarketing');
      Config.dependancies.push({
        product: 'SiteCatalyst' /* ,
                                dependants: [
                                {
                                event: 'siteCatalystCallComplete',
                                product: 'Dart',
                                required: true
                                },
                                {
                                event: 'siteCatalystCallComplete',
                                product: 'CEA',
                                required: true
                                }
                                ],
                                // If there are dependants set and the parent product is not listed as a dependant
                                // on another product this must be set
                                immediate: true */
      }, {
        product: 'CEA'
      }, {
        product: 'GoogleRemarketing'
      });

      //Automatically create namespaces for supported products
      Config.supportedProducts.forEach(productName => {
        Config.products[productName] = store(`Adapter:${productName}`, Config.products[productName] || {});
      });
    }
  }, 'Analytics', 'Config', 'store');

  /* global inject */
  inject((Adapter, resolve, consentCategoryOverrides) => {
    const name = 'ComScore';
    new Adapter({
      name,
      enabled: true,
      consentCategory: consentCategoryOverrides[name] || 'targeting',
      adapt,
      adaptOnce: true
    });
    function adapt(sam) {
      const model = this.map(sam);
      if (!model || !this.enabled) return false;
      (window._comscore = window._comscore || []).push(model);
      resolve('addScript')('https://sb.scorecardresearch.com/beacon.js');
      resolve('Framework').fireEvent({
        event: 'ComScoreAdapterComplete',
        data: model
      });
    }
  }, 'Adapter', 'resolve', 'consentCategoryOverrides');

  /* global inject */
  inject(comScoreAdapter => {
    comScoreAdapter.mapping = {
      configuration: {
        ComScore: {
          advertiserId: {
            mapping: {
              mapTo: 'c2',
              defaultValue: '6035140'
            }
          },
          tagType: {
            mapping: {
              mapTo: 'c1',
              defaultValue: '2'
            }
          },
          triggerTimeout: {
            mapping: {
              mapTo: 'triggerTimeout'
            }
          }
        }
      }
    };
  }, 'Adapter:ComScore');

  /* global inject */
  inject((Adapter, addScript, once, extend, resolve, ref, getURLParameter, iniBoolean, subscribe, moveProp, consentCategoryOverrides) => {
    const name = 'Gtag';
    const gtagAdapter = new Adapter({
      name,
      enabled: true,
      consentCategory: consentCategoryOverrides[name] || 'targeting',
      adapt,
      adaptOnce: true,
      init,
      reset
    });
    const addScriptOnce = once(addScript);
    const groupName = 'WDAT';
    const gtagMapping = {
      dimension1: 'site',
      dimension2: 'pageName',
      dimension3: 'media',
      dimension5: 'linkId',
      dimension7: 'affiliationsAvailable',
      dimension8: 'guestAffiliations',
      dimension9: 'daysBetweenSearchAndArrival',
      dimension10: 'searchArrivalDate',
      dimension11: 'searchLengthOfStayNights',
      dimension12: 'searchParty',
      dimension13: 'facetsUtilized',
      dimension14: 'memberNumber',
      dimension15: 'errorCodes',
      dimension16: 'registrationStatus',
      dimension17: 'articleCategories',
      dimension18: 'osVersion',
      dimension19: 'productsCompared',
      dimension20: 'recommenderInfo',
      dimension21: 'localization',
      dimension24: 'currentEntitlements',
      dimension25: 'pageVariant',
      dimension26: 'articleTitle',
      dimension27: 'articleMeta',
      dimension33: 'currencyDisplayed',
      dimension35: 'internalSearchKeywords',
      dimension36: 'internalSearchNumResults',
      dimension37: 'internalSearchType',
      dimension38: 'store',
      dimension40: 'productConfirmation',
      dimension41: 'productPartyMix',
      dimension42: 'productArrivalWindow',
      dimension43: 'productArrivalDate',
      dimension44: 'productLengthOfStay',
      dimension45: 'payment',
      dimension46: 'leadType',
      dimension49: 'cart',
      dimension50: 'offerId',
      dimension51: 'selfServiceType',
      dimension52: 'partnerId',
      dimension53: 'offersShown',
      dimension55: 'socialInteractionType',
      dimension56: 'shipping',
      dimension57: 'productsAvailable',
      dimension59: 'modificationType',
      dimension64: 'cruiseDisembarkation',
      dimension65: 'packageType',
      dimension66: 'orderType',
      dimension67: 'facilityId',
      dimension68: 'customerId',
      // was metric3 but conflicted with pageView event
      dimension69: 'guestType',
      dimension71: 'client_id',
      metric1: 'e_assetStart',
      metric2: 'e_internalSearch',
      metric3: 'e_pageView',
      metric4: 'e_registration',
      metric5: 'e_internalSearchClick',
      metric6: 'socialInteractionType',
      metric7: 'e_internalAdClick',
      metric8: 'e_VPDOrder',
      metric9: 'e_purchaseWithPoints',
      metric10: 'e_cancellation',
      metric11: 'e_assetComplete',
      metric12: 'e_bookingSearch',
      metric13: 'e_cartProductAdd',
      metric14: 'e_leadGenerated',
      metric15: 'totalBookedLengthOfStayNights',
      metric16: 'e_activityCancellation',
      metric17: 'e_activityModification',
      metric18: 'e_quickQuoteSearch',
      metric19: 'e_checkoutDelivery',
      metric20: 'e_checkoutInsurance',
      metric21: 'e_checkoutApplyPayment',
      metric22: 'e_checkoutReviewQuote',
      metric23: 'e_activityBooking',
      metric24: 'e_productView',
      metric25: 'e_cartAddProduct',
      metric26: 'e_cartRemoveProduct',
      metric27: 'e_checkoutGuestInfo',
      metric28: 'e_selfServiceInitiated',
      metric29: 'e_selfServiceCompleted',
      metric31: 'e_loggedIn',
      metric32: 'e_postCheckoutPayment',
      metric36: 'e_checkoutExpressCheckout',
      metric37: 'e_modification',
      metric38: 'e_posModRevenue',
      metric39: 'e_negModRevenue',
      metric40: 'mediaViewedId'
    };
    const handlers = {
      pageView: m => sendEvent('page_view', {
        page_title: document.title,
        page_location: location.href,
        page_path: location.pathname + location.search
      }, m.params),
      purchase: m => sendEvent('purchase', m.purchase_params),
      loggedIn: () => sendEvent('login', {
        method: 'internal'
      }),
      registration: () => sendEvent('sign_up', {
        method: 'internal'
      }),
      internalSearch: m => m.params.internalSearchKeywords && sendEvent('search', {
        search_term: m.params.internalSearchKeywords
      })
    };
    let unsub;
    function adapt(sam) {
      const model = this.map(sam);
      if (!model || !this.enabled) return false;
      const events = model.gEvents || [];
      events.forEach(event => (handlers[event] || noop)(model));
      resolve('Framework').fireEvent({
        event: 'GtagAdapterComplete',
        data: model
      });
    }
    function sendEvent(eventName, ...eventObjs) {
      gtag('event', eventName, extend({
        send_to: groupName
      }, ...eventObjs));
    }
    function gtag() {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(arguments);
    }
    function configValue(config, prop) {
      return config.hasOwnProperty(prop) ? config[prop] : configDefaultValue(prop);
    }
    function configDefaultValue(prop) {
      return ref(`mapping.configuration.Gtag.${prop}.mapping.defaultValue`, gtagAdapter);
    }
    function init(config) {
      loadGtagLibrary(config);
      const commandeer = iniBoolean(configValue(config, 'floodlightHandle'), false);
      if (commandeer) addFloodlightHandler(config);
    }
    function reset() {
      if (typeof unsub === 'function') {
        unsub();
        unsub = undefined;
      }
    }
    function loadGtagLibrary(config) {
      const trackingId = config.trackingId;
      const transportType = config.transportType || configDefaultValue('transportType');
      if (trackingId) {
        const dl = window.dataLayer || (window.dataLayer = []);
        if (!window.gtag) window.gtag = gtag;
        if (!dl.find(args => args[0] === 'js')) gtag('js', new Date());
        gtag('config', trackingId, extend({
          send_page_view: false,
          custom_map: gtagMapping,
          transport_type: transportType,
          groups: groupName
        }, campaignData()));
        if (dl.push === Array.prototype.push) addScriptOnce(`https://www.googletagmanager.com/gtag/js?id=${trackingId}`);
      }
    }
    function addFloodlightHandler(config) {
      unsub = subscribe({
        topic: 'floodlight.beforefire',
        handler: pub => {
          fireGtagFloodlight(pub.data, config);
          pub.data.handled = true;
        }
      });
    }
    function fireGtagFloodlight(dartVars, config) {
      let event = configValue(config, 'floodlightEvent');
      let countingMethod = configValue(config, 'floodlightCountingMethod');
      let eventData = extend({}, dartVars, {
        allow_custom_scripts: true
      });
      if (eventData.ord === '1') delete eventData.ord;
      moveProp(eventData, 'cost', 'value');
      moveProp(eventData, 'qty', 'quantity');
      moveProp(eventData, 'ord', 'transaction_id');
      if (event === 'auto') event = eventData.hasOwnProperty('transaction_id') ? 'purchase' : 'page_view';
      if (countingMethod === 'auto') countingMethod = eventData.hasOwnProperty('transaction_id') ? 'transactions' : 'standard';
      eventData.send_to = `DC-${eventData.src}/${eventData.type}/${eventData.cat}+${countingMethod}`;
      if (!window.gtag) window.gtag = gtag;
      const dl = window.dataLayer || (window.dataLayer = []);
      if (!dl.find(args => args[0] === 'js')) gtag('js', new Date());
      gtag('config', `DC-${eventData.src}`);
      gtag('event', event, eventData);
      if (dl.push === Array.prototype.push) addScriptOnce(`https://www.googletagmanager.com/gtag/js?id=${`DC-${eventData.src}`}`);
    }
    function campaignData() {
      const campaignCode = getURLParameter('CMP');
      if (campaignCode) {
        return {
          campaign: {
            medium: campaignCode.split('-')[0],
            source: document.referrer.split('/')[2] || 'unknown',
            name: campaignCode
          }
        };
      }
    }
    function noop() {}
  }, 'Adapter', 'addScript', 'once', 'extend', 'resolve', 'ref', 'getURLParameter', 'iniBoolean', 'subscribe', 'moveProp', 'consentCategoryOverrides');

  /* global inject */
  inject((gtagAdapter, ref, isObject, objFirstProp) => {
    gtagAdapter.mapping = {
      configuration: {
        SiteCatalyst: {
          namespace: {
            mapping: {
              defaultValue: 'wdpro'
            }
          }
        },
        Gtag: {
          trackingId: {
            mapping: {
              mapTo: 'config.trackingId'
            }
          },
          transportType: {
            mapping: {
              mapTo: 'config.transportType',
              defaultValue: 'image'
            }
          },
          floodlightHandle: {
            mapping: {
              mapTo: 'config.floodlightHandle',
              defaultValue: 'false'
            }
          },
          floodlightEvent: {
            mapping: {
              mapTo: 'config.floodlightEvent',
              defaultValue: 'auto'
            }
          },
          floodlightCountingMethod: {
            mapping: {
              mapTo: 'config.floodlightCountingMethod',
              defaultValue: 'auto'
            }
          }
        }
      },
      contentLanguage: {
        mapping: {
          defaultValue: 'en',
          applyFilter: {
            case: 'lower'
          }
        }
      },
      contentLocale: {
        mapping: {
          defaultValue: 'us',
          applyFilter: {
            case: 'lower'
          }
        }
      },
      marketingRegion: {
        mapping: {
          applyFilter: {
            case: 'lower'
          }
        }
      },
      currency: {
        mapping: {
          mapTo: 'purchase_params.currency',
          defaultValue: 'USD'
        }
      },
      localization: {
        mapping: {
          type: 'template',
          mapTo: 'params.localization',
          template: '{{#marketingRegion}}{{{marketingRegion}}}|{{{contentLanguage}}}-{{{contentLocale}}}{{/marketingRegion}}{{^marketingRegion}}{{{contentLocale}}}/{{{contentLanguage}}}{{/marketingRegion}}'
        }
      },
      customerId: {
        mapping: {
          mapTo: 'params.customerId'
        }
      },
      site: {
        mapping: {
          mapTo: 'site,params.site',
          defaultValue: 'notset'
        }
      },
      storeType: {
        mapping: {}
      },
      siteSection: {
        mapping: {
          defaultValue: 'notset'
        }
      },
      pageId: {
        mapping: {
          defaultValue: 'notset'
        }
      },
      pageName: {
        mapping: {
          mapTo: 'params.pageName',
          type: 'template',
          template: '{{{namespace}}}/{{{site}}}/{{#marketingRegion}}{{{marketingRegion}}}{{/marketingRegion}}{{^marketingRegion}}{{{contentLocale}}}{{/marketingRegion}}/{{{contentLanguage}}}/{{{siteSection}}}/{{{pageId}}}',
          postFilter: {
            case: 'lower',
            replace: [['&amp;|&', 'and'], ['[^a-zA-Z0-9/]', '']]
          }
        }
      },
      events: {
        mapping: {}
      },
      gtag_events: {
        mapping: {
          mapTo: 'gtagEvents',
          transformers: {
            preProcess: model => {
              let events = model.events || [];
              model.gEvents = [];
              events.forEach(e => addEvent(getEvent(e)));
              if (!gtagAdapter.adapted && !model.gEvents.includes('pageView')) {
                addEvent({
                  event: 'pageView',
                  value: 1
                });
              }
              model.gEvents.sort((a, b) => a === 'pageView' ? -1 : b === 'pageView' ? 1 : 0);
              function addEvent(eventObj) {
                if (eventObj.event) {
                  model.gEvents.push(eventObj.event);
                  model.params[`e_${eventObj.event}`] = eventObj.value;
                }
              }
              function getEvent(e) {
                let event, value;
                if (typeof e === 'string') {
                  event = e;
                  value = 1;
                } else if (isObject(e)) {
                  event = objFirstProp(e);
                  value = e[event];
                }
                event = {
                  videoStart: 'assetStart',
                  videoStop: 'assetComplete',
                  prodView: 'productView'
                }[event] || event;
                return {
                  event,
                  value
                };
              }
            }
          }
        }
      },
      mediaType: {
        mapping: {
          applyFilter: {
            case: 'lower'
          }
        }
      },
      mediaId: {
        mapping: {
          type: 'template',
          template: '{{#mediaType}}{{{mediaType}}}:{{/mediaType}}{{{mediaId}}}',
          mapTo: 'params.media'
        }
      },
      mediaViewed: {
        id: {
          mapping: {
            mapTo: 'params.mediaViewedId'
          }
        }
      },
      linkId: {
        mapping: {
          mapTo: 'params.linkId'
        }
      },
      affiliationsAvailable: {
        mapping: {
          mapTo: 'params.affiliationsAvailable',
          applyFilter: {
            replace: [[' ', '']],
            alpha: 'asc'
          }
        }
      },
      guestAffiliations: {
        mapping: {
          type: 'flex-array',
          mapTo: 'params.guestAffiliations',
          applyFilter: {
            replace: [[' ', '']],
            alpha: 'asc'
          }
        }
      },
      bookingSearchDaysBetweenSearchAndArrival: {
        mapping: {
          mapTo: 'params.daysBetweenSearchAndArrival'
        }
      },
      bookingSearchArrivalDate: {
        mapping: {
          mapTo: 'params.searchArrivalDate',
          applyFilter: {
            date: {}
          }
        }
      },
      bookingSearchLengthOfStayNights: {
        mapping: {
          mapTo: 'params.searchLengthOfStayNights'
        }
      },
      bookingSearchPartySize: {
        mapping: {
          mapTo: 'params.searchParty'
        }
      },
      bookingSearchAdults: {
        mapping: {
          applyFilter: {
            type: 'int'
          }
        }
      },
      bookingSearchChildren: {
        mapping: {
          applyFilter: {
            type: 'int'
          }
        }
      },
      bookingSearchInfants: {
        mapping: {
          defaultValue: 0,
          applyFilter: {
            type: 'int'
          }
        }
      },
      bookingSearchSeniors: {
        mapping: {
          defaultValue: 0,
          applyFilter: {
            type: 'int'
          }
        }
      },
      bookingSearchParty: {
        mapping: {
          type: 'template',
          template: '{{#bookingSearchPartyTotal}}{{{bookingSearchPartyTotal}}}:{{{bookingSearchAdults}}}A:{{{bookingSearchChildren}}}C:{{{bookingSearchInfants}}}I:{{{bookingSearchSeniors}}}S{{/bookingSearchPartyTotal}}',
          mapTo: 'params.searchParty',
          transformers: {
            bookingSearchPartyTotal: m => [m.bookingSearchAdults, m.bookingSearchChildren, m.bookingSearchInfants, m.bookingSearchSeniors].reduce((p, c) => p + (typeof c === 'number' ? c : NaN), 0)
          }
        }
      },
      facetsUtilized: [{
        name: {
          mapping: {}
        },
        action: {
          mapping: {
            defaultValue: 'Add'
          }
        },
        mapping: {
          type: 'template',
          template: '{{#name}}{{{action}}}:{{{name}}}{{/name}}'
        }
      }],
      gtag_facetsUtilized: {
        mapping: {
          type: 'flex-array',
          defaultValue: m => m.facetsUtilized,
          mapTo: 'params.facetsUtilized'
        }
      },
      memberNumber: {
        mapping: {
          mapTo: 'params.memberNumber'
        }
      },
      errorCodes: {
        mapping: {
          mapTo: 'params.errorCodes',
          applyFilter: {
            unique: ',',
            replace: [[' ', '']]
          }
        }
      },
      registrationStatus: {
        mapping: {
          mapTo: 'params.registrationStatus'
        }
      },
      article: {
        id: {
          mapping: {
            mapTo: 'articleId'
          }
        },
        title: {
          mapping: {
            mapTo: 'articleName'
          }
        },
        publicationDate: {
          mapping: {
            mapTo: 'articlePublicationDate',
            applyFilter: {
              date: {}
            }
          }
        },
        author: {
          mapping: {
            mapTo: 'articleAuthor'
          }
        },
        categories: {
          mapping: {
            mapTo: 'params.articleCategories'
          }
        }
      },
      gtag_articleTitle: {
        mapping: {
          type: 'template',
          mapTo: 'params.articleTitle',
          template: '{{#articleId}}{{{articleId}}}:{{{articleName}}}{{/articleId}}'
        }
      },
      gtag_articleMeta: {
        mapping: {
          type: 'template',
          template: '{{#articleId}}{{{articleId}}}:{{{articlePublicationDate}}}:{{{articleAuthor}}}{{/articleId}}',
          mapTo: 'params.articleMeta'
        }
      },
      osVersion: {
        mapping: {
          mapTo: 'params.osVersion'
        }
      },
      productsCompared: [{
        productName: {
          mapping: {}
        },
        productId: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{#productId}}{{{productId}}}{{/productId}}{{^productId}}{{{productName}}}{{/productId}}'
        }
      }],
      gtag_productsCompared: {
        mapping: {
          type: 'flex-array',
          defaultValue: m => m.productsCompared,
          mapTo: 'params.productsCompared'
        }
      },
      recommenderInfo: {
        conversationId: {
          mapping: {}
        },
        messageId: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{#conversationId}}{{{conversationId}}},{{{messageId}}}{{/conversationId}}',
          mapTo: 'params.recommenderInfo'
        }
      },
      currentEntitlements: {
        mapping: {
          type: 'flex-array',
          mapTo: 'params.currentEntitlements',
          applyFilter: {
            alpha: 'asc',
            replace: [[' ', '']]
          }
        }
      },
      pageVariant: {
        mapping: {
          mapTo: 'params.pageVariant'
        }
      },
      currencyDisplayed: {
        mapping: {
          mapTo: 'params.currencyDisplayed'
        }
      },
      internalSearchKeywords: {
        mapping: {
          mapTo: 'params.internalSearchKeywords'
        }
      },
      internalSearchNumResults: {
        mapping: {
          mapTo: 'params.internalSearchNumResults',
          applyFilter: {
            type: 'int'
          }
        }
      },
      internalSearchType: {
        mapping: {
          mapTo: 'params.internalSearchType'
        }
      },
      store: {
        mapping: {
          mapTo: 'params.store'
        }
      },
      payment: {
        type: {
          mapping: {
            mapTo: 'paymentType'
          }
        },
        paymentAmount: {
          mapping: {
            applyFilter: {
              type: 'float'
            }
          }
        },
        totalPrice: {
          mapping: {
            applyFilter: {
              type: 'float'
            }
          }
        },
        mapping: {
          type: 'template',
          template: m => m.paymentType || m.paymentAmount || m.totalPrice ? '{{paymentType}}:{{paymentAmount}}:{{totalPrice}}:{{pctPaid}}' : '',
          mapTo: 'params.payment',
          transformers: {
            pctPaid: m => m.paymentAmount && m.totalPrice ? (m.paymentAmount / m.totalPrice).toFixed(2) : ''
          }
        }
      },
      orderId: {
        mapping: {
          mapTo: 'purchase_params.transaction_id'
        }
      },
      productSubTotal: {
        mapping: {
          mapTo: 'purchase_params.value'
        }
      },
      totalPrice: {
        totalTax: {
          mapping: {
            mapTo: 'purchase_params.tax'
          }
        },
        totalShipping: {
          mapping: {
            mapTo: 'purchase_params.shipping'
          }
        }
      },
      leadType: {
        mapping: {
          mapTo: 'params.leadType'
        }
      },
      carts: [{
        id: {
          mapping: {}
        },
        friendlyId: {
          mapping: {}
        },
        changeType: {
          mapping: {}
        }
      }],
      gtag_cart: {
        mapping: {
          defaultValue: m => Array.isArray(m.carts) ? m.carts[0] : '',
          type: 'template',
          template: '{{#gtag_cart.id}}{{{gtag_cart.id}}}:{{{gtag_cart.friendlyId}}}:{{{gtag_cart.changeType}}}{{/gtag_cart.id}}',
          mapTo: 'params.cart'
        }
      },
      offerId: {
        offerName: {
          mapping: {
            mapTo: 'params.offerId'
          }
        }
      },
      selfServiceType: {
        mapping: {
          type: 'flex-array',
          targetDelimiter: '|',
          mapTo: 'params.selfServiceType'
        }
      },
      partnerId: {
        mapping: {
          type: 'template',
          template: '{{#partnerId.id}}{{{partnerId.type}}};{{{partnerId.id}}};{{{partnerId.instance}}}{{/partnerId.id}}',
          mapTo: 'params.partnerId'
        }
      },
      offersShown: [{
        id: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{id}}'
        }
      }],
      _gt_offersShown: {
        mapping: {
          defaultValue: m => m.offersShown,
          mapTo: 'params.offersShown',
          type: 'flex-array'
        }
      },
      socialInteractionType: {
        mapping: {
          applyFilter: {
            replace: [[' ', '']]
          },
          mapTo: 'params.socialInteractionType'
        }
      },
      shipping: {
        mapping: {
          type: 'template',
          template: '{{#shipping.method}}{{{shipping.method}}}:{{#shipping.price}}{{{shipping.price}}}{{/shipping.price}}{{^shipping.price}}0{{/shipping.price}}:{{{shipping.time}}}{{/shipping.method}}',
          mapTo: 'params.shipping',
          postFilter: {
            replace: [[' ', '']]
          }
        }
      },
      productsDisplayed: [{
        isAvailable: {
          mapping: {
            defaultValue: 'u'
          }
        }
      }],
      gtag_productsAvailable: {
        mapping: {
          defaultValue: m => Array.isArray(m.productsDisplayed) ? m.productsDisplayed.map(p => p.isAvailable === true ? 1 : p.isAvailable === false ? 0 : 'u') : '',
          mapTo: 'params.productsAvailable',
          postFilter: {
            fmt: a => Array.isArray(a) ? `${a.filter(v => v === 1).length};${a.join(';')}` : ''
          }
        }
      },
      modificationType: {
        mapping: {
          mapTo: 'params.modificationType'
        }
      },
      guestType: {
        mapping: {
          mapTo: 'params.guestType'
        }
      },
      totalBookedLengthOfStayNights: {
        mapping: {
          mapTo: 'params.totalBookedLengthOfStayNights'
        }
      },
      products: [{
        mapping: {},
        bookedAdults: {
          mapping: {
            mapTo: 'bookedAdults',
            applyFilter: {
              type: 'int'
            }
          }
        },
        bookedChildren: {
          mapping: {
            mapTo: 'bookedChildren',
            applyFilter: {
              type: 'int'
            },
            defaultValue: 0
          }
        },
        bookedInfants: {
          mapping: {
            mapTo: 'bookedInfants',
            applyFilter: {
              type: 'int'
            },
            defaultValue: 0
          }
        },
        bookedSeniors: {
          mapping: {
            mapTo: 'bookedSeniors',
            applyFilter: {
              type: 'int'
            },
            defaultValue: 0
          }
        },
        quantity: {
          mapping: {
            mapTo: 'quantity',
            applyFilter: {
              type: 'int'
            }
          }
        }
      }],
      gtag_realProducts: {
        mapping: {
          defaultValue: m => Array.isArray(m.products) ? m.products.filter(productNotRemoved) : [],
          mapTo: 'realProducts'
        }
      },
      gtag_bookingProduct: {
        mapping: {
          defaultValue: m => m.realProducts.find(p => /^(?:resortVacation|cruise|trip)$/.test(p.productType)),
          mapTo: 'bookingProduct'
        }
      },
      gtag_ticketProducts: {
        mapping: {
          defaultValue: m => m.realProducts.filter(p => /^(?:ticket|datedTicket|annualPass)$/.test(p.productType)),
          mapTo: 'ticketProducts'
        }
      },
      gtag_purchaseProducts: {
        mapping: {
          defaultValue: m => m.realProducts.map(p => {
            let item = {
              id: p.productId,
              category: p.productType,
              brand: m.site,
              quantity: p.quantity
            };
            if (p.name) item.name = p.name;
            if (p.discountCode?.offerName) item.coupon = p.discountCode.offerName;
            if (p.price && p.price.subTotal) item.price = p.price.subTotal;
            return item;
          }),
          mapTo: 'purchase_params.items'
        }
      },
      gtag_productConfirmation: {
        mapping: {
          mapTo: 'params.productConfirmation',
          defaultValue: productProp('confirmationNumber')
        }
      },
      gtag_productPartyMix: {
        mapping: {
          mapTo: 'params.productPartyMix',
          defaultValue: model => {
            if (model.bookingProduct) {
              if ('bookedAdults' in model.bookingProduct) {
                let {
                  bookedAdults: adults,
                  bookedChildren: children,
                  bookedInfants: infants,
                  bookedSeniors: seniors
                } = model.bookingProduct;
                return `${adults + children + infants + seniors}:${adults}A:${children}C:${infants}I:${seniors}S`;
              }
            } else if (model.ticketProducts && model.ticketProducts.length) {
              let adults = model.ticketProducts.reduce((p, c) => p + (Array.isArray(c.segments) && c.segments.some(s => /adult/i.test(s)) && c.quantity) || 0, 0);
              let children = model.ticketProducts.reduce((p, c) => p + (Array.isArray(c.segments) && c.segments.some(s => /child/i.test(s)) && c.quantity) || 0, 0);
              let seniors = model.ticketProducts.reduce((p, c) => p + (Array.isArray(c.segments) && c.segments.some(s => /senior/i.test(s)) && c.quantity) || 0, 0);
              return `${adults + children + seniors}:${adults}A:${children}C:0I:${seniors}S`;
            }
          }
        }
      },
      gtag_productArrivalWindow: {
        mapping: {
          mapTo: 'params.productArrivalWindow',
          defaultValue: productProp('daysBetweenBookingAndArrival', false)
        }
      },
      gtag_productArrivalDate: {
        mapping: {
          mapTo: 'params.productArrivalDate',
          defaultValue: productProp('bookedArrivalDate'),
          applyFilter: {
            date: {}
          }
        }
      },
      gtag_productLengthOfStay: {
        mapping: {
          mapTo: 'params.productLengthOfStay',
          defaultValue: productProp('bookedLengthOfStayNights', false)
        }
      },
      gtag_cruiseDisembarkation: {
        mapping: {
          mapTo: 'params.cruiseDisembarkation',
          defaultValue: m => ref('bookingProduct.disembarkation.city', m)
        }
      },
      gtag_packageType: {
        mapping: {
          mapTo: 'params.packageType',
          defaultValue: m => ref('bookingProduct.packageType', m) || ref('ticketProducts.0', m) && 'TicketsOnly'
        }
      },
      gtag_orderType: {
        mapping: {
          mapTo: 'params.orderType',
          defaultValue: productProp('orderType', false)
        }
      },
      gtag_facilityId: {
        mapping: {
          mapTo: 'params.facilityId',
          defaultValue: productProp('facilityId', false)
        }
      },
      gtag_cartAddProductEvent: {
        mapping: {
          mapTo: 'params.e_cartAddProductEvent',
          defaultValue: model => {
            if (Array.isArray(model.products)) {
              return model.products.reduce((p, c) => p + (/cartAdd/i.test(c.events) ? c.quantity || 1 : 0), 0) || undefined;
            }
          }
        }
      },
      gtag_cartRemoveProductEvent: {
        mapping: {
          mapTo: 'params.e_cartRemoveProductEvent',
          defaultValue: model => {
            if (Array.isArray(model.products)) {
              return model.products.reduce((p, c) => p + (/cartRemove/i.test(c.events) ? c.quantity || 1 : 0), 0) || undefined;
            }
          }
        }
      }
    };
    function productProp(prop, checkTickets = true) {
      return model => (model.bookingProduct || checkTickets && model.ticketProducts && model.ticketProducts[0] || {})[prop];
    }
    function productNotRemoved(prod) {
      let events = prod.events;
      if (typeof events === 'string') {
        events = events.split(',');
      }
      if (Array.isArray(events) && events.includes('cartRemove')) {
        return false;
      }
      return true;
    }
  }, 'Adapter:Gtag', 'ref', 'isObject', 'objFirstProp');
  /* global inject */
  inject((Debug, Adapter, objForEach, resolve, isObject, extend, publish, querySelectorAll, consentCategoryOverrides) => {
    const name = 'Dart';
    new Adapter({
      name,
      enabled: true,
      consentCategory: consentCategoryOverrides[name] || 'targeting',
      adapt,
      adaptOnce: true,
      reset
    });
    function adapt(sam) {
      const model = this.map(sam);
      if (!model || !this.enabled) return false;
      var Framework = resolve('Framework');
      if (model.tags) {
        model.tags.forEach(dartConfig => {
          var parentData = {},
            newModel = extend(true, {}, model, {
              src: dartConfig.src,
              type: dartConfig.type,
              cat: dartConfig.cat
            });
          delete newModel.tags;
          extend(newModel, dartConfig.forcedValues);
          if (newModel.type && newModel.cat) {
            if (Array.isArray(newModel.defaultConditions) && !dartConfig.match) {
              if (newModel.defaultConditions.some(cTag => matchesConditions(cTag, newModel))) {
                processVarsAndCreateIframe(newModel, parentData);
              }
            } else if (!dartConfig.match || matchesConditions(dartConfig.match, newModel)) {
              processVarsAndCreateIframe(newModel, parentData);
            }
          }
        });
        Framework.fireEvent({
          event: 'DartAdapterComplete',
          data: model
        });
      }
    }
    function reset() {
      [...querySelectorAll('iframe.DoubleClickIFrame')].forEach(iframe => {
        iframe.parentNode.removeChild(iframe);
      });
    }
    function processVarsAndCreateIframe(model, parentData) {
      var dartVars = {};
      getLeafProperties(dartVars, model);
      if (typeof dartVars.u7 === 'string') dartVars.u7 = dartVars.u7.split(',')[0];
      if (parentData && parentData.visitorId) {
        // this may look a little hardcoded, but its the only way to do it since the model is already parsed
        model.visitorId = model.u19 = dartVars.u19 = parentData.visitorId;
      }
      publish({
        topic: 'floodlight.beforefire',
        data: dartVars
      });
      if (!dartVars.handled) prepareIframe(dartVars);
    }
    function matchesConditions(matches, model) {
      var match,
        hasMatched = true;
      if (isObject(matches)) {
        for (match in matches) {
          if (matches.hasOwnProperty(match)) {
            if (model[match] && typeof model[match] === 'string') {
              if (model[match].toLowerCase() !== matches[match].toLowerCase()) {
                hasMatched = false;
                break;
              }
            } else {
              hasMatched = false;
              break;
            }
          }
        }
      } else {
        hasMatched = false;
      }
      return hasMatched;
    }

    // Recursively loops through a given model and stores the variables it finds in dartVars
    function getLeafProperties(dartVars, model, propName) {
      if (Array.isArray(model)) {
        model.forEach(item => getLeafProperties(dartVars, item));
      } else if (isObject(model)) {
        objForEach(model, (value, key) => getLeafProperties(dartVars, value, key));
      } else if (/^(?:src|cat|type|ord|cost|qty|u\d+)$/.test(propName)) {
        if (dartVars.hasOwnProperty(propName)) {
          dartVars[propName] += `,${model}`;
        } else {
          dartVars[propName] = model;
        }
      }
    }
    function injectIframe(iFrameId, iframeSrc, dartVars) {
      document.body.insertAdjacentHTML('beforeend', `<iframe src="${iframeSrc}" border="0" height="0" width="0" style="display:none" id="${iFrameId}" class="DoubleClickIFrame"/>`);
      Debug.info('Dart iFrame Attached: ', dartVars);
    }
    function prepareIframe(dartVars) {
      var iFrameId = `Dart_${dartVars.src}${dartVars.type}${dartVars.cat}`,
        iframeSrc;

      // Dart Tag should be fired only once
      if (!document.getElementById(iFrameId)) {
        iframeSrc = `https://${dartVars.src}.fls.doubleclick.net/activityi;src=${dartVars.src};type=${dartVars.type};cat=${dartVars.cat}`;

        // loop the remaining attributes and place at the middle
        objForEach(dartVars, (val, key) => {
          if (!/^(?:src|type|cat|num|ord)$/.test(key)) iframeSrc += `;${key}=${val}`;
        });

        // ord has to be at the end
        if (dartVars.ord) iframeSrc += `;ord=${dartVars.ord}`;

        // only add num when ord is not present and it should be last
        if (dartVars.ord === '1') iframeSrc += `;num=${resolve('Framework').getPageGroupId()}`;

        // end with a question mark
        if (!iframeSrc.endsWith('?')) iframeSrc += '?';
        if (document.readyState === 'complete') {
          injectIframe(iFrameId, iframeSrc, dartVars);
        } else {
          window.addEventListener('load', () => injectIframe(iFrameId, iframeSrc, dartVars));
        }
      }
    }
  }, 'Debug', 'Adapter', 'objForEach', 'resolve', 'isObject', 'extend', 'publish', 'querySelectorAll', 'consentCategoryOverrides');

  /* global inject */
  inject((dartAdapter, Exports) => {
    dartAdapter.mapping = {
      configuration: {
        Dart: {
          defaultConditions: [{
            mapping: {}
          }],
          tags: [{
            advertiserId: {
              mapping: {
                mapTo: 'src',
                defaultValue: '2789293'
              }
            },
            groupTagString: {
              mapping: {
                mapTo: 'type'
              }
            },
            activityTagString: {
              mapping: {
                mapTo: 'cat'
              }
            },
            match: {
              mapping: {}
            },
            forcedValues: {
              mapping: {
                mapTo: 'forcedValues'
              }
            },
            mapping: {
              mapTo: 'tags'
            }
          }]
        },
        SiteCatalyst: {
          turnOff: {
            mapping: {
              mapTo: 'siteCatalystTurnOff'
            }
          }
        },
        environment: {
          mapping: {
            mapTo: 'u22'
          }
        }
      },
      currency: {
        mapping: {
          mapTo: 'u20',
          defaultValue: 'USD'
        }
      },
      contentLocale: {
        mapping: {
          defaultValue: 'us'
        }
      },
      contentLanguage: {
        mapping: {
          defaultValue: 'en'
        }
      },
      secureProtocol: {
        mapping: {}
      },
      customerId: {
        mapping: {
          mapTo: 'u1',
          defaultValue: 'anonymous'
        }
      },
      pageId: {
        mapping: {
          mapTo: 'pageId',
          applyFilter: {
            case: 'lower',
            replace: [['[^a-zA-Z0-9]', '']]
          }
        }
      },
      guestType: {
        mapping: {
          mapTo: 'u2'
        }
      },
      guestAffiliations: {
        mapping: {
          type: 'flex-array',
          mapTo: 'u3'
        }
      },
      events: {
        mapping: {
          type: 'flex-array',
          valueDelimiter: '=',
          dataSourceMapTo: 'eventsData',
          mapTo: 'events'
        }
      },
      products: [{
        productType: {
          mapping: {
            mapTo: 'productType,u23',
            defaultValue: 'product'
          }
        },
        events: {
          mapping: {
            mapTo: 'events'
          }
        },
        quantity: {
          mapping: {
            defaultValue: 1,
            transformers: {
              preProcess: (model, parentModel, modelVal) => {
                parentModel.qty = parseInt(parentModel.qty, 10) || 0;
                modelVal = parseInt(modelVal, 10) || 1;
                if (model.productType === 'ticket') {
                  parentModel.u11 = parseInt(parentModel.u11, 10) || 0;
                  parentModel.u11 += modelVal;
                }
                parentModel.qty += modelVal;
                if (parentModel && parentModel.events && parentModel.events.includes('purchase')) {
                  parentModel.qty = 1;
                }
              }
            }
          }
        },
        productId: {
          mapping: {
            mapTo: 'u12'
          }
        },
        facilityName: {
          mapping: {
            mapTo: 'u5'
          }
        },
        roomTypeId: {
          mapping: {
            type: 'template',
            template: '{{#roomTypeId}}{{{roomTypeId}}}{{/roomTypeId}}',
            mapTo: 'u10',
            transformers: {
              roomTypeId: (model, parentModel, val) => {
                if (model.productType === 'cruise') return val;
                delete model.roomTypeId;
              }
            }
          }
        },
        includedProducts: [{
          id: {
            mapping: {
              mapTo: 'u10'
            }
          }
        }],
        packageType: {
          mapping: {
            mapTo: 'u8',
            defaultValue: model => model.productType === 'ticket' ? 'TicketsOnly' : null
          }
        },
        orderType: {
          mapping: {
            mapTo: 'u9'
          }
        },
        bookedArrivalDate: {
          mapping: {
            mapTo: 'u4'
          }
        },
        numberRoomsBooked: {
          mapping: {
            mapTo: 'u6'
          }
        },
        bookedAdults: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedChildren: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedInfants: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedSeniors: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedParty: {
          mapping: {
            type: 'template',
            template: '{{#bookedPartyTotal}}{{{bookedPartyTotal}}}:{{{bookedAdults}}}' + 'A:{{{bookedChildren}}}C:{{{bookedInfants}}}I:' + '{{{bookedSeniors}}}S{{/bookedPartyTotal}}',
            mapTo: 'u18',
            transformers: {
              bookedPartyTotal: model => {
                if (!isNaN(model.bookedAdults) && !isNaN(model.bookedChildren) && !isNaN(model.bookedInfants) && !isNaN(model.bookedSeniors)) {
                  return Number(model.bookedAdults) + Number(model.bookedChildren) + Number(model.bookedInfants) + Number(model.bookedSeniors);
                }
              }
            }
          }
        },
        bookedPartyMix: {
          mapping: {
            mapTo: 'u18'
          }
        },
        bookedLengthOfStayNights: {
          mapping: {
            mapTo: 'u7'
          }
        },
        mapping: {
          applyFilter: {
            removeElement: {
              keys: ['productType', 'productType', 'productType'],
              values: ['groundTransportation', 'airTransportation', 'insurance']
            },
            removeCartRemove: products => {
              if (Array.isArray(products)) {
                return products.filter(product => !product.events || !product.events.includes('cartRemove'));
              }
            }
          }
        }
      }],
      visitorId: {
        mapping: {
          defaultValue: () => Exports.VisitorId,
          mapTo: 'u19'
        }
      },
      orderId: {
        mapping: {
          mapTo: 'ord',
          defaultValue: '1',
          reprocessOnUpdate: true
        }
      },
      totalPrice: {
        priceSubTotal: {
          mapping: {
            mapTo: 'u13'
          }
        },
        grandTotal: {
          mapping: {
            mapTo: 'cost'
          }
        }
      },
      productSubTotal: {
        mapping: {
          mapTo: model => !model.u13 ? 'u13' : false
        }
      },
      productTotal: {
        mapping: {
          mapTo: model => !model.cost ? 'cost' : false
        }
      },
      totalBookedLengthOfStayNights: {
        mapping: {
          mapTo: 'u7'
        }
      },
      path: {
        mapping: {
          mapTo: 'u21',
          defaultValue: location.pathname
        }
      }
    };
  }, 'Adapter:Dart', 'Exports');

  /* global inject */
  inject((GoogleRemarketing, Framework, Mustache, extend, addPixel, consentAugment, consentCategoryOverrides) => {
    if (!GoogleRemarketing) return;
    const name = 'GoogleRemarketing';
    extend(GoogleRemarketing, {
      name,
      isOff: false,
      hasFired: false,
      conversionHasFired: false,
      consentCategory: consentCategoryOverrides[name] || 'targeting',
      turnOff,
      turnOn,
      adapter,
      reset
    });
    consentAugment(GoogleRemarketing);

    /* ----------------------------------------------------------------------------------------------------------- */

    /**
     * Fires the request to GR via img tag
     * @param {object} model the model after being transformed via mapping and internal adapter processing
     * @return {undefined}
     */
    function fire(model) {
      var srcTemplate = '//googleads.g.doubleclick.net/pagead/viewthroughconversion/{{{googleConversionId}}}/?' + 'value=0&guid=ON{{#data}}&data={{{data}}}{{/data}}&script=0',
        data = createURLParam(model.data || {}),
        src = Mustache.render(srcTemplate, {
          googleConversionId: model.googleConversionId,
          data
        });
      addPixel(src);
      GoogleRemarketing.hasFired = true;
    }

    /**
     * Fires the conversion pixel via img tag
     * @param {object} model the model after being transformed via mapping and internal adapter processing
     * @return {undefined}
     */
    function fireConversion(model, conversionTagId) {
      var conversionTemplate = '//www.googleadservices.com/pagead/conversion/1070398022/?label=' + '{{googleConversionLabel}}&guid=ON{{#data}}&data={{{data}}}{{/data}}&script=0',
        src = Mustache.render(conversionTemplate, {
          googleConversionLabel: conversionTagId,
          data: createURLParam(model.data)
        });
      addPixel(src);
      GoogleRemarketing.conversionHasFired = true;
    }

    /**
     * The entry point to this adapter after the mapping has occurred
     * @param {object} model the model after mapping
     * @return {undefined}
     */
    function adapter(sam) {
      const model = inject.resolve('productMap')(this, name, sam);
      if (!model || this.isOff) return;
      if (!GoogleRemarketing.hasFired) {
        fire(reconfigure(model));
      }
      if (!GoogleRemarketing.conversionHasFired) {
        if (model.data && model.data.events && model.conversions) {
          model.data.events.split(',').forEach(event => {
            if (model.productTypes && model.conversions && model.conversions[event]) {
              model.productTypes.forEach(type => {
                var conversionTagId = model.conversions[event][type];
                if (conversionTagId) {
                  fireConversion(model, conversionTagId);
                }
              });
            }
            if (model.conversions && model.conversions[event] && model.conversions[event]['*']) {
              fireConversion(model, model.conversions[event]['*']);
            }
          });
        }
      }
      Framework.fireEvent({
        event: 'GoogleRemarketingAdapterComplete',
        data: model
      });
    }
    function reset() {
      extend(GoogleRemarketing, {
        hasFired: false,
        conversionHasFired: false
      });
    }

    /**
     * transforms the mapped model into the format that mustache template expects
     * @param {object} model the mapped model
     * @return {object} the transformed model
     */
    function reconfigure(model) {
      if (model.products) {
        model.data = model.data || {};
        model.data.products = model.products;
        delete model.products;
      }
      return model;
    }

    /**
     * Converts the object into a string suitable for use in a URL
     * @param {object} obj the object to convert
     * @return {string|undefined} the object properties in format name1=value1;name2=value2,value3,value4
     */
    function createURLParam(obj) {
      var paramArray = [],
        param,
        value,
        urlParam;
      for (param in obj) {
        if (obj.hasOwnProperty(param)) {
          value = obj[param];
          if (Array.isArray(value)) {
            value = value.join(',');
          }
          paramArray.push(`${param}=${value}`);
        }
      }
      if (paramArray.length) {
        urlParam = encodeURIComponent(paramArray.join(';'));
      }
      return urlParam;
    }

    /**
     * Turns off this adapter
     * @return {undefined}
     */
    function turnOff() {
      GoogleRemarketing.isOff = true;
    }

    /**
     * Turns on this adapter
     * @return {undefined}
     */
    function turnOn() {
      GoogleRemarketing.isOff = false;
    }
  }, 'Adapter:GoogleRemarketing', 'Framework', 'Mustache', 'extend', 'addPixel', 'consentAugment', 'consentCategoryOverrides');

  /* global inject */
  inject(GoogleRemarketing => {
    if (!GoogleRemarketing) return;
    GoogleRemarketing.mapping = {
      configuration: {
        GoogleRemarketing: {
          advertiserId: {
            mapping: {
              mapTo: 'googleConversionId',
              defaultValue: '970897162'
            }
          },
          conversions: {
            mapping: {
              mapTo: 'conversions'
            }
          }
        }
      },
      site: {
        mapping: {
          mapTo: 'data.site'
        }
      },
      bookingSearchDaysBetweenSearchAndArrival: {
        mapping: {
          mapTo: 'data.bookingSearchWindow',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookingSearchLengthOfStayNights: {
        mapping: {
          mapTo: 'data.bookingSearchLOS',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookingSearchAdults: {
        mapping: {
          mapTo: 'data.bookingSearchAdults',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookingSearchChildren: {
        mapping: {
          mapTo: 'data.bookingSearchChildren',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookingSearchInfants: {
        mapping: {
          mapTo: 'data.bookingSearchInfants',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookingSearchSeniors: {
        mapping: {
          mapTo: 'data.bookingSearchSenior',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      offerId: {
        offerName: {
          mapping: {
            mapTo: 'data.offerId'
          }
        }
      },
      products: [{
        productType: {
          mapping: {
            defaultValue: 'prod',
            mapTo: {
              addOn: 'add',
              airTransportation: 'air',
              cruise: 'cruise',
              dining: 'dine',
              enhancedExperience: 'eexp',
              fastPassPlus: 'gxa',
              greatFoodFast: 'gxa',
              groundTransportation: 'auto',
              insurance: 'ins',
              media: 'med',
              nonDisneyTicket: 'ndt',
              product: 'prod',
              resortVacation: 'res',
              ticket: 'tix',
              trip: 'trip'
            }
          }
        },
        productId: {
          mapping: {
            mapTo: 'productId'
          }
        },
        facilityId: {
          mapping: {
            mapTo: 'facilityId'
          }
        },
        roomTypeId: {
          mapping: {
            mapTo: 'roomTypeId'
          }
        },
        quantity: {
          mapping: {
            mapTo: 'quantity'
          }
        },
        packageType: {
          mapping: {
            mapTo: 'packageType'
          }
        },
        mapping: {
          type: 'template',
          template: (product, parentModel) => {
            var template = '';
            if (product.productType === 'res') {
              template = '{{{productType}}};{{{productId}}}:{{{facilityId}}}:{{{roomTypeId}}};' + '{{{quantity}}};{{{packageType}}}';
            } else if (product.productType === 'tix') {
              template = '{{{productType}}};{{{productId}}};{{{quantity}}}';
            }
            if (!parentModel.productTypes) {
              parentModel.productTypes = [];
            }
            if (!parentModel.productTypes.includes(product.productType)) {
              parentModel.productTypes.push(product.productType);
            }
            return template;
          }
        }
      }],
      events: {
        mapping: {
          type: 'flex-array',
          valueDelimiter: '=',
          mapTo: 'data.events'
        }
      },
      guestAffiliations: {
        mapping: {
          type: 'flex-array',
          mapTo: 'data.guestAffiliations',
          applyFilter: {
            alpha: 'asc',
            replace: [[' ', '']]
          }
        }
      }
    };
  }, 'Adapter:GoogleRemarketing');

  /* global inject */
  inject((CEA, Framework, Debug, extend, $, toBoolean, getCookie, sessionStorage, isObject, consentAugment, consentCategoryOverrides, bookingSearchResortId) => {
    if (!CEA) return;
    const name = 'CEA';
    extend(CEA, {
      dateTimeFormat: 'YYYY-MM-DDTHH:mm:ss',
      firstRun: true,
      isOff: true,
      decisionOn: true,
      captureOn: true,
      consentCategory: consentCategoryOverrides[name] || 'functional',
      trackElementList: {},
      callCount: 0,
      pageData: {},
      helper: {},
      reset,
      turnOff,
      turnOn,
      trackElement,
      adapter
    });
    consentAugment(CEA);
    const {
      helper
    } = CEA;
    function reset() {
      extend(CEA, {
        firstRun: true,
        isOff: true,
        decisionOn: true,
        captureOn: true,
        trackElementList: {},
        callCount: 0,
        pageData: {}
      });

      // We need to remove any CEA handlers we may have added
      $(document).off('.CEATracking');
    }
    function turnOff(parentModel) {
      CEA.isOff = true;
      CEA.captureOn = false;
      CEA.decisionOn = false;
      if (parentModel && parentModel.personalizations) {
        delete parentModel.personalizations;
      }
    }
    function turnOn() {
      CEA.isOff = false;
      CEA.captureOn = true;
      CEA.decisionOn = true;
    }
    function trackElement(event, model) {
      var interactiveElm, events, translatedEvent;
      if (event && CEA.isOff === false) {
        if (model) {
          model = extend(true, CEA.pageData, model);
        } else {
          model = CEA.pageData;
        }
        // if we are dealing with an interactive element that was predefined.
        // See framework.CEA.trackElement.preConfigured.test.js
        if (CEA.trackElementList[event]) {
          interactiveElm = CEA.trackElementList[event];
          if (interactiveElm.trackingModel) {
            extend(true, model, interactiveElm.trackingModel);
          }
          helper.mergeInteractiveElements(interactiveElm, model);
          model.trackingType = interactiveElm.trackingType;
          model.linkId = model.data['link-id'] = interactiveElm.data['link-id'];
        }
        events = normalizeEvents(model.events);
        if (events.length > 0) model.events = events.join(',');
        if (model.trackingType === 'standardPage' || model.trackingType === 'customPage' || model.trackingType === 'page') {
          helper.trackEvent('d-page', model);
        } else if (model.trackingType === 'customLink' || model.trackingType === 'pic') {
          if (model.enableTrackElementLinkTracking) {
            if (model.linkId) {
              helper.trackEvent('d-link', model);
            } else {
              Debug.info('CEA trackElement: linkId property not set');
            }
          } else {
            Debug.info('CEA trackElement: link tracking disabled');
          }
        } else if (model.trackingType === 'customEvent' && model.events) {
          translatedEvent = CEA.mapping.events.mapping.mapTo[model.events];
          helper.trackEvent(translatedEvent, model);
        }
      } else {
        Debug.info('CEA trackElement: event parameter was not set');
      }
    }
    function adapter(sam) {
      var model = inject.resolve('productMap')(this, name, sam);
      if (!model || this.isOff) return;
      var fireImpressions = [],
        disabledPossibleAffiliations = ['Agent'],
        numLocations = 0,
        captureToggleName = model.captureToggleName,
        decisionToggleName = model.decisionToggleName,
        i,
        m,
        locations,
        loc,
        numImmediateImpressions,
        numProductsDisp,
        determineStatusFromToggles,
        processInteractiveElements,
        bindLinkTracking,
        events,
        facilityDisplayed,
        distinctFacilitiesDisplayed = [],
        distinctFacilitiesDisplayedId = [],
        selectedResortId,
        listToDedupe,
        matches;
      CEA.callCount++;
      if (!CEA.isOff) {
        if (CEA.firstRun) {
          model.enableTrackElementLinkTracking = toBoolean(model.enableTrackElementLinkTracking);
          model.enableInteractiveElementLinkTracking = toBoolean(model.enableInteractiveElementLinkTracking);
          model.enableTargetIntegration = toBoolean(model.enableTargetIntegration);
          model.authToken = getCookie(model.authCookieName);
          model.conversationId = getCookie(model.webSessionIdCookieName);
        }
        determineStatusFromToggles = function () {
          if (model.releaseToggles && typeof model.releaseToggles[captureToggleName] !== 'undefined') {
            CEA.captureOn = toBoolean(model.releaseToggles[captureToggleName]);
          }
          if (model.releaseToggles && typeof model.releaseToggles[decisionToggleName] !== 'undefined') {
            CEA.decisionOn = toBoolean(model.releaseToggles[decisionToggleName]);
          }
          if (!CEA.decisionOn && !CEA.captureOn) {
            CEA.isOff = true;
          }
        };
        processInteractiveElements = function (model) {
          var l,
            i = 0,
            it,
            lt,
            inTrackElementList,
            triggerEvent,
            interactiveElement;

          //determine the type of interactive elements we are dealing with
          if (Array.isArray(model.interactiveElements)) {
            for (i, l = model.interactiveElements.length; i < l; i++) {
              interactiveElement = model.interactiveElements[i];
              if (interactiveElement) {
                /* determine if interactiveElement should go in the trackElementList
                    * this will allow it to be invoked directly using the trackElement function
                    */
                inTrackElementList = false;
                if (interactiveElement.triggerEvents && Array.isArray(interactiveElement.triggerEvents)) {
                  for (it = 0, lt = interactiveElement.triggerEvents.length; it < lt; it++) {
                    triggerEvent = interactiveElement.triggerEvents[it];
                    if (!triggerEvent.elementSelectors && triggerEvent.type) {
                      CEA.trackElementList[triggerEvent.type] = interactiveElement;
                      inTrackElementList = true;
                    }
                  }
                }
                if (!inTrackElementList) {
                  switch (interactiveElement.trackingType) {
                    case 'page':
                    case 'customPage':
                    case 'standardPage':
                    case 'pic':
                    case 'customLink':
                      if (model.enableInteractiveElementLinkTracking) {
                        helper.setupEvent(interactiveElement);
                      }
                      break;
                    case 'vid':
                    case 'video':
                      if (interactiveElement.triggerEvents) {
                        helper.trackVideo(interactiveElement);
                      }
                      break;
                    case 'customEvent':
                      helper.setupEvent(interactiveElement);
                      break;
                    default:
                      /**
                       * any elements with a tracking model or trigger event that is not
                       * specifically a page tracking type will be treated as a customLink
                       */
                      if (model.enableInteractiveElementLinkTracking) {
                        if (interactiveElement.trackingModel || interactiveElement.triggerEvents) {
                          helper.setupEvent(interactiveElement);
                        }
                      }
                  }
                }
              }
            }
          }
        };
        if (CEA.isOff) {
          return;
        }
        if (CEA.firstRun) {
          CEA.pageData = model;
          determineStatusFromToggles();
          if (model.possibleAffiliation && disabledPossibleAffiliations.includes(model.possibleAffiliation)) {
            CEA.captureOn = false;
            CEA.decisionOn = false;
            CEA.isOff = true;
          }
        }
        if (CEA.captureOn) {
          if (model.carts && model.carts[0] && model.carts[0].data) {
            $.extend(model.data, model.carts[0].data);
          }
          if (model.productsDisplayed && model.productsDisplayed.length > 0) {
            /***
             * Typically products displayed is used for the room types displayed, so in the case
             * of CEA we only need the facilityId & facilityTier from the first one.
             *
             * GO4-6951: on co-located resort rate pages, narrow productsDisplayed
             * to entries whose parentResort matches the resort the guest actually
             * searched for (derived from bookingSearchResort, mirroring
             * DSMetasearch's _ds_selected_resort_id). Falls through to the full
             * productsDisplayed when bookingSearchResort is absent or nothing
             * matches, preserving today's behavior on non-co-located pages and
             * on the resorts listing page. productsDisplayed is not mutated.
             * The final "exactly 1 distinct facilityId" gate stays intact.
             */
            selectedResortId = bookingSearchResortId(model.bookingSearchResort);
            if (selectedResortId) {
              matches = model.productsDisplayed.filter(p => p.parentResort === selectedResortId);
              listToDedupe = matches.length > 0 ? matches : model.productsDisplayed;
            } else {
              listToDedupe = model.productsDisplayed;
            }
            for (m = 0, numProductsDisp = listToDedupe.length; m < numProductsDisp; m++) {
              facilityDisplayed = listToDedupe[m];
              if (!distinctFacilitiesDisplayedId.includes(facilityDisplayed.facilityId)) {
                distinctFacilitiesDisplayed.push({
                  facilityId: facilityDisplayed.facilityId,
                  facilityTier: facilityDisplayed.facilityTier
                });
                distinctFacilitiesDisplayedId.push(facilityDisplayed.facilityId);
              }
            }
            if (distinctFacilitiesDisplayed.length === 1) {
              model.data['products-displayed-facility-id'] = distinctFacilitiesDisplayed[0].facilityId;
              model.data['products-displayed-facility-tier'] = distinctFacilitiesDisplayed[0].facilityTier;
            }
          }
          bindLinkTracking = function () {
            $(document).on('click', function (e) {
              var el = e.target,
                tagName = el.tagName,
                name,
                id,
                analyticsLinkId,
                linkId,
                linkIdObj;
              if (tagName && tagName.toLowerCase() === 'a' || tagName && tagName.toLowerCase() === 'input') {
                if (typeof el.getAttribute === 'function') {
                  name = el.getAttribute('name');
                  analyticsLinkId = el.getAttribute('analyticsLinkId');
                  id = el.id;
                  if (name && name.includes('&lid=')) {
                    linkId = name.substr(5);
                  } else if (analyticsLinkId) {
                    linkId = analyticsLinkId;
                  } else if (id) {
                    linkId = id;
                  } else {
                    linkId = $(el).text();
                  }
                }
                if (linkId) {
                  linkIdObj = {
                    prevPage: location.href,
                    linkId
                  };
                  sessionStorage.setItem('tmpAnalyticsLinkId', linkIdObj);
                } else {
                  sessionStorage.removeItem('tmpAnalyticsLinkId');
                }
              }
            });
          };
          bindLinkTracking();
          if (CEA.firstRun) {
            CEA.firstRun = false;
            events = normalizeEvents(model.events);
            if (!events.includes('d-page-view')) events.push('d-page-view');
            model.events = events.join(',');
            helper.makeClickStreamCall(model);
          }
          if (model.personalizations && Array.isArray(model.personalizations) && model.personalizations.length > 0 && CEA.decisionOn) {
            locations = model.personalizations;
            numLocations = locations.length;
            for (i = 0; i < numLocations; i++) {
              loc = locations[i];
              if (loc.linkId) {
                $(loc.clickSelector || loc.selector).attr('name', `&lid=${loc.linkId}`);
              }
              if (loc.engine) {
                helper.setupClickHandler(loc);
                switch (loc.impressionType) {
                  case 'onPage':
                    helper.setupPoll(loc);
                    break;
                  case 'visible':
                    helper.setupVisible(loc);
                    break;
                  case 'customEvent':
                    helper.setupCustomEvent(loc);
                    break;
                  default:
                    fireImpressions.push(loc);
                    break;
                }
              }
            }
            $(document).one('CEACaptureCallComplete', function () {
              for (i = 0, numImmediateImpressions = fireImpressions.length; i < numImmediateImpressions; i++) {
                helper.fireImpressionEvent(fireImpressions[i]);
              }
            });
          }
          processInteractiveElements(model);
          Framework.fireEvent({
            event: 'CEAAdapterComplete',
            data: model
          });
        }
      }
    }
    function normalizeEvents(events) {
      if (!events) events = [];
      if (typeof events === 'string') events = events.split(',');
      if (!Array.isArray(events)) events = [];
      return events.map(event => isObject(event) ? `${Object.keys(event)[0]}=${Object.values(event)[0]}` : event).filter(event => !/d-(?:pos|neg)-mod-(?:revenue|nights)-event/.test(event));
    }
  }, 'Adapter:CEA', 'Framework', 'Debug', 'extend', '$', 'toBoolean', 'getCookie', 'sessionStorage', 'isObject', 'consentAugment', 'consentCategoryOverrides', 'bookingSearchResortId');

  /* global inject, adobe */
  inject((CEA, Analytics, Framework, Debug, Exports, extend, getCookie, setCookie, $, isObject, getURLProtocol, moment, pollForElement, SiteCatalyst, parseSemanticModel, clone, netlog) => {
    if (!CEA) return;
    let trackVisibleLocationCount = 0;
    const {
      helper
    } = CEA;
    extend(helper, {
      PERSONALIZATION_COOKIE_LIFE_DAYS: 730,
      getSessionId,
      getPersonalizationId,
      setPersonalizationId,
      getServiceOverrideHeaders,
      makeAPICall,
      getAuthToken,
      sendCaptureCall,
      makeCaptureCall,
      setupClickHandler,
      isElementVisible,
      getFreshOptions,
      fireImpressionEvent,
      setupCustomEvent,
      isControl,
      setupVisible,
      setupPoll,
      checkForExistingProperty,
      breakdownEventData,
      resetArraysForMerge,
      filterDuplicateAttributes,
      makeClickStreamCall,
      mergeInteractiveElements,
      bindEvent,
      setupEvent,
      trackEvent,
      bindTrackVideo,
      trackVideo,
      getStandardTargetData,
      getDecisionImpressionForTarget,
      fireAdobeTargetDecisionCall,
      fireAdobeTargetImpressionCall,
      fireAdobeTargetClickCall
    });

    // Promote getPersonalizationId for general use
    Analytics.getPersonalizationId = getPersonalizationId;
    Object.defineProperty(Exports, 'personalizationId', {
      get: getPersonalizationId,
      enumerable: true
    });

    /* ----------------------------------------------------------------- */

    function getSessionId() {
      var id = null,
        {
          pageData
        } = CEA,
        cookieJar;
      if (pageData.sessionIdCookieJarName && pageData.sessionIdCookieName) {
        if (cookieJar = getCookie(pageData.sessionIdCookieJarName, true)) {
          id = cookieJar[pageData.sessionIdCookieName];
        }
      } else if (!pageData.sessionIdCookieJarName && pageData.sessionIdCookieName) {
        id = getCookie(pageData.sessionIdCookieName);
      }
      return id;
    }
    function setPersonalizationId(personalizationId) {
      var {
          pageData
        } = CEA,
        encodeJSON = false,
        cookieName,
        cookieVal,
        cookieJar;
      if (!pageData.cookieJarName && pageData.cookieName) {
        cookieName = pageData.cookieName;
        cookieVal = personalizationId;
      } else {
        encodeJSON = true;
        cookieName = pageData.cookieJarName || 'personalization_jar';
        cookieJar = getCookie(cookieName, true);
        cookieVal = isObject(cookieJar) ? cookieJar : {};
        cookieVal[pageData.cookieName || 'id'] = personalizationId;
      }
      setCookie(cookieName, cookieVal, helper.PERSONALIZATION_COOKIE_LIFE_DAYS, encodeJSON, undefined, location.protocol === 'https:');
      pageData.personalizationId = personalizationId;
    }
    function getPersonalizationId(model) {
      var {
          pageData
        } = CEA,
        parentModel,
        id,
        ceaConfig = model && model.configuration && model.configuration.CEA,
        cookieJar;
      if (ceaConfig) {
        if (ceaConfig.personalizationIdCookieJarName && ceaConfig.personalizationIdCookieName) {
          if (cookieJar = getCookie(ceaConfig.personalizationIdCookieJarName, true)) {
            id = cookieJar[ceaConfig.personalizationIdCookieName];
          }
        } else if (!ceaConfig.personalizationIdCookieJarName && ceaConfig.personalizationIdCookieName) {
          id = getCookie(ceaConfig.personalizationIdCookieName);
        } else {
          if (cookieJar = getCookie('personalization_jar', true)) {
            id = cookieJar.id;
          }
        }
        if (id) pageData.personalizationId = id;
        return id;
      } else if (pageData && pageData.personalizationId) {
        return pageData.personalizationId;
      } else {
        parentModel = Framework.getParentModel();
        if (model !== parentModel) {
          return getPersonalizationId(parentModel);
        }
      }
    }
    function getServiceOverrideHeaders() {
      var headers = {},
        OVERRIDES = [{
          prop: 'cea',
          header: 'X-Disney-Internal-Environment-Change-Override-PersonalizationDAO'
        }],
        apiGroups = getCookie('apiGroups', true) || {};
      OVERRIDES.forEach(pair => {
        if (apiGroups[pair.prop]) {
          headers[pair.header] = apiGroups[pair.prop];
        }
      });
      return headers;
    }
    function makeAPICall(serviceCall) {
      if (!getCookie(CEA.pageData.authCookieName)) {
        getAuthToken().then(() => {
          serviceCall();
        });
      } else {
        serviceCall();
      }
    }
    function getAuthToken() {
      var deferred = new $.Deferred();
      $.ajax({
        timeout: CEA.pageData.authTimeout,
        type: 'GET',
        dataType: 'json',
        contentType: 'application/json',
        url: CEA.pageData.authURL,
        beforeSend: request => {
          if (CEA.pageData.conversationId) {
            request.setRequestHeader('X-Conversation-Id', CEA.pageData.conversationId);
          }
        }
      }).then(data => {
        const {
          access_token,
          expires_in
        } = data;
        CEA.pageData.authToken = access_token;
        const {
          authToken,
          authCookieName,
          authCookieIncludeSubDomains
        } = CEA.pageData;
        const domain = `${authCookieIncludeSubDomains === true ? '.' : ''}${location.hostname}`;
        let expirationDays = expires_in / 86400; //convert seconds from response into days
        if (!expirationDays) {
          netlog({
            app: 'JSAF',
            category: 'CEA',
            action: 'Bad Auth Token Expiration',
            response: data,
            CEA_pageData: CEA.pageData,
            sampling: 1 / 10
          });
          expirationDays = 25 / 1440; //25 minutes in days
        }
        setCookie(authCookieName, authToken, expirationDays, false, domain, true);
        deferred.resolve(data.access_token);
      }).fail(data => {
        Debug.error('CEA, Auth Call Failed:', data);
      });
      return deferred.promise();
    }
    function sendCaptureCall(data) {
      var sessionId = getSessionId();
      data.channel = 'web';
      return $.ajax({
        timeout: CEA.pageData.captureTimeout,
        type: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        url: CEA.pageData.captureURL,
        beforeSend: request => {
          var headers = getServiceOverrideHeaders();
          if (CEA.pageData.conversationId) {
            headers['X-Conversation-Id'] = CEA.pageData.conversationId;
          }
          if (sessionId) {
            headers.CausataId = sessionId;
          }
          headers.Authorization = `BEARER ${CEA.pageData.authToken}`;
          inject.resolve('objForEach')(headers, (val, key) => {
            request.setRequestHeader(key, val);
          });
        },
        data: JSON.stringify(data),
        fullData: data
      }).done((data, status, xhr) => {
        var sessionId = xhr.getResponseHeader('CausataId'),
          expiration = 0.02083333333333,
          // 30 minutes in days
          protocol = getURLProtocol();
        if (sessionId) {
          setCookie('causata_jar', {
            id: sessionId
          }, expiration, true, undefined, protocol.includes('https'));
        }
        if (data.personalizationId) {
          setPersonalizationId(data.personalizationId);
        }
      });
    }
    function makeCaptureCall(model, data) {
      var deferred = new $.Deferred();
      if (!data.personalizationId) {
        data.personalizationId = model.personalizationId;
      }
      sendCaptureCall(data).then(resp => {
        var personalizations = model.personalizations || [],
          location,
          numP = personalizations.length,
          i;
        if (resp.personalizationId !== model.personalizationId) {
          setPersonalizationId(resp.personalizationId);
        }
        setPersonalizationId(resp.personalizationId);
        if (CEA.pageData.enableTargetIntegration && numP > 0) {
          for (i = 0; i < numP; i++) {
            location = personalizations[i];
            fireAdobeTargetDecisionCall(location);
          }
        }
        Framework.fireEvent({
          event: 'CEACaptureCallComplete',
          data: {
            model,
            data
          }
        });
        deferred.resolve(resp);
      }).fail(data => {
        Debug.error('CEA, Capture Call Failed:', data);
      });
      return deferred.promise();
    }
    function setupClickHandler(location) {
      var selector, clickHandler;
      if (CEA.captureOn) {
        selector = location.clickSelector || location.selector || false;
        clickHandler = function (event, el) {
          var getLinkId,
            location = event.data;
          getLinkId = function (el) {
            var $el = $(el);
            if ($el.attr('name') && $el.attr('name').includes('&lid=')) {
              return $el.attr('name').replace('&lid=', '');
            }
            return false;
          };
          makeAPICall(function () {
            var data = {
                events: [],
                personalizationId: getPersonalizationId()
              },
              eventTime = moment().format(CEA.dateTimeFormat) + 'Z',
              i,
              numSelections,
              optionId,
              optionName,
              position,
              selections = [],
              selectionValues,
              selectionValue;
            if (location.selectionSelector) {
              selections = $(location.selectionSelector);
              if (selections.length > 0) {
                numSelections = selections.length;
                selectionValues = [];
                for (i = 0; i < numSelections; i++) {
                  if (location.selectionOptionValueAttribute) {
                    selectionValue = $(selections[i]).attr(location.selectionOptionValueAttribute);
                    selectionValues.push(selectionValue);
                    data.events.push({
                      datetime: eventTime,
                      eventType: 'd-personalization-click',
                      attributes: [{
                        name: 'decision-location',
                        value: location.location
                      }, {
                        name: 'option-name',
                        value: selectionValue
                      }, {
                        name: 'page-name',
                        value: CEA.pageData.pageName
                      }]
                    });
                  } else {
                    Debug.error('CEA Click Handler - location.selectionOptionValueAttribute value missing');
                  }
                }
              }
            } else if (!location.selectionSelector && !location.options) {
              data.events.push({
                datetime: eventTime,
                eventType: 'd-personalization-click',
                attributes: [{
                  name: 'decision-location',
                  value: location.location
                }, {
                  name: 'option-name',
                  value: location.decision || 'DEFAULT'
                }, {
                  name: 'page-name',
                  value: CEA.pageData.pageName
                }]
              });
            } else if (!location.selectionSelector && location.options && location.options.length > 0 && !location.optionIdAttr) {
              location.options.forEach(val => {
                data.events.push({
                  datetime: eventTime,
                  eventType: 'd-personalization-click',
                  attributes: [{
                    name: 'decision-location',
                    value: location.location
                  }, {
                    name: 'option-name',
                    value: val.decision
                  }, {
                    name: 'page-name',
                    value: CEA.pageData.pageName
                  }]
                });
              });
            } else if (!location.selectionSelector && location.options && location.options.length > 0 && location.optionIdAttr) {
              optionId = $(el).attr(location.optionIdAttr);
              optionName = location.options.reduce(function (prev, option) {
                return prev || (option.optionId === optionId ? option.decision : '');
              }, '');
              if (optionName) {
                position = $(location.clickSelector).index(el) + 1;
                data.events.push({
                  datetime: eventTime,
                  eventType: 'd-personalization-click',
                  attributes: [{
                    name: 'decision-location',
                    value: location.location
                  }, {
                    name: 'option-name',
                    value: optionName
                  }, {
                    name: 'page-name',
                    value: CEA.pageData.pageName
                  }, {
                    name: 'decision-position',
                    value: position
                  }]
                });
              }
            }
            if (data.events.length > 0) {
              sendCaptureCall(data).then(function () {
                var trackingModel = {
                    linkId: location.linkId || getLinkId(el) || `Personalization_${location.locationShortName}_${optionId ? `${optionId}_` : ''}click`,
                    trackingType: 'customLink',
                    personalizationClick: {
                      locationShortName: location.locationShortName,
                      customerGroup: location.engine
                    },
                    events: 'personalizationClick'
                  },
                  target = $(el).attr('target');
                if (location.options && !optionId) {
                  trackingModel.personalizationClick.options = [];
                  if (selectionValues && selectionValues.length > 0) {
                    for (i = 0; i < numSelections; i++) {
                      trackingModel.personalizationClick.options.push({
                        optionId: selectionValues[i]
                      });
                    }
                  }
                } else if (!location.options) {
                  trackingModel.personalizationClick.optionId = location.optionId || (location.engine ? 'DEFAULT' : 'control');
                } else if (location.options && optionId) {
                  trackingModel.personalizationClick.options = [];
                  trackingModel.personalizationClick.options.push({
                    optionId
                  });
                }
                SiteCatalyst.trackElement('personalization-click', trackingModel);
                if (CEA.pageData.enableTargetIntegration) {
                  fireAdobeTargetClickCall(location, selectionValues);
                }
                if (!target || target === '_self' || target === '_top' || target === '_parent') {
                  setTimeout(function () {
                    Framework.fireEvent({
                      event: 'CEAClickCallComplete',
                      data
                    });
                    if (el && el.click) {
                      el.click();
                    }
                  }, 575);
                } else {
                  Framework.fireEvent({
                    event: 'CEAClickCallComplete',
                    data
                  });
                }
              }).fail(function () {
                Debug.error('CEA Decision Click Capture Call Failed');
                Framework.fireEvent({
                  node: el,
                  event: 'click'
                });
                if (el && el.click) el.click();
              }, 575);
            }
          });
        };
        if (selector) {
          if (location.impressionType === 'onPage') {
            $(document).one('click.CEATracking.CEAClick', selector, location, function (e) {
              clickHandler(e, this);
            });
          } else {
            $(selector).one('click', location, function (e) {
              var target = $(this).attr('target');
              if (!target || target === '_self' || target === '_top' || target === '_parent') {
                e.preventDefault();
                e.stopImmediatePropagation();
              }
              clickHandler(e, this);
            });
          }
        }
      }
    }
    function isElementVisible(el) {
      var VISIBLE_MARGIN = 25,
        margin,
        hasRects,
        result,
        rect;
      if (el) {
        result = hasRects = el.getClientRects().length > 0;
        if (hasRects) {
          rect = el.getBoundingClientRect();
          margin = Math.min(rect.height, VISIBLE_MARGIN);
          result = !(rect.top > window.innerHeight - margin || rect.bottom < margin);
        }
      }
      return result;
    }
    function getFreshOptions(locationName) {
      var locations = Framework.getParentModel().personalizations || undefined,
        options = [];
      if (locations && locations.length > 0) {
        inject.resolve('objForEach')(locations, location => {
          if (location.location === locationName && location.options) {
            options = location.options;
          }
        });
      }
      return options;
    }
    function fireImpressionEvent(location) {
      var impressionTime = moment().utc().format(CEA.dateTimeFormat) + 'Z',
        options = getFreshOptions(location.location),
        data = {
          events: []
        };
      if (options && options.length > 0) {
        options.forEach((val, idx) => {
          data.events.push({
            datetime: impressionTime,
            eventType: 'd-personalization-impression',
            attributes: [{
              name: 'decision-location',
              value: location.location
            }, {
              name: 'option-name',
              value: val.decision || val.name
            }, {
              name: 'page-name',
              value: CEA.pageData.pageName
            }, {
              name: 'decision-position',
              value: idx + 1
            }]
          });
        });
      } else {
        data.events.push({
          datetime: impressionTime,
          eventType: 'd-personalization-impression',
          attributes: [{
            name: 'decision-location',
            value: location.location
          }, {
            name: 'option-name',
            value: location.decision ? location.decision === '' ? 'DEFAULT' : location.decision : 'DEFAULT'
          }, {
            name: 'page-name',
            value: CEA.pageData.pageName
          }]
        });
      }
      if (CEA.decisionOn) {
        if (!data.personalizationId) {
          data.personalizationId = getPersonalizationId();
        }
        sendCaptureCall(data).then(function () {
          if (CEA.pageData.enableTargetIntegration) {
            fireAdobeTargetImpressionCall(location);
          }
          Framework.fireEvent({
            event: 'CEAImpressionCallComplete',
            data
          });
        });
      }
    }
    function setupCustomEvent(location) {
      var selector = isControl(location.engine) ? location.controlSelector || location.impressionSelector || location.selector : location.impressionSelector || location.selector;
      if (selector) {
        $(selector).one(location.impressionEvent, location, function (e) {
          makeAPICall(function () {
            fireImpressionEvent(e.data);
          });
        });
      }
    }
    function isControl(engine) {
      return /^(?:c|c1|c2)$/.test(engine);
    }
    function setupVisible(location) {
      var namespace = `CEAImpression${trackVisibleLocationCount++}`;
      $(document).on(`DOMContentLoaded.CEATracking.${namespace} load.CEATracking.${namespace} resize.CEATracking.${namespace} scroll.CEATracking.${namespace}`, location, function (e) {
        var elSelector = isControl(location.engine) ? location.controlSelector || location.impressionSelector || location.selector : e.data.impressionSelector || e.data.selector;
        var isVisible = isElementVisible($(elSelector).get(0));
        if (isVisible && $(elSelector).is(':visible')) {
          $(this).off(`.${namespace}`);
          fireImpressionEvent(e.data);
        }
      });
    }
    function setupPoll(location) {
      var elSelector = isControl(location.engine) ? location.controlSelector || location.impressionSelector || location.selector : location.impressionSelector || location.selector;
      if (elSelector) {
        pollForElement(elSelector, function () {
          fireImpressionEvent(location);
        });
      }
    }
    function checkForExistingProperty(existing, check) {
      var length = existing.length,
        i;
      for (i = 0; i < length; i++) {
        if (existing[i].name === check) {
          return true;
        }
      }
      return false;
    }
    function breakdownEventData(eventName, data) {
      var prop, dataElement, numItems, i, event;
      event = {
        datetime: moment().utc().format(CEA.dateTimeFormat) + 'Z',
        eventType: eventName,
        attributes: []
      };
      for (prop in data) {
        if (data.hasOwnProperty(prop)) {
          if (typeof data[prop] === 'string' || typeof data[prop] === 'number' || typeof data[prop] === 'boolean') {
            if (!checkForExistingProperty(event.attributes, prop)) {
              if (typeof data[prop] === 'string') {
                data[prop] = data[prop].replace(/^\s+|\s+$/gm, '');
              }
              if (data[prop] !== '') {
                dataElement = {
                  name: prop,
                  value: data[prop]
                };
                event.attributes.push(dataElement);
              }
            }
          } else if (Array.isArray(data[prop])) {
            numItems = data[prop].length;
            for (i = 0; i < numItems; i++) {
              if (typeof data[prop][i] === 'string') {
                data[prop][i] = data[prop][i].replace(/^\s+|\s+$/gm, '');
              }
              if (data[prop][i] !== '') {
                dataElement = {
                  name: prop,
                  value: data[prop][i]
                };
                event.attributes.push(dataElement);
              }
            }
          }
        }
      }
      return event;
    }
    function resetArraysForMerge(model, updatedModel) {
      var baseProp;
      if (model && updatedModel) {
        for (baseProp in updatedModel) {
          if (updatedModel.hasOwnProperty(baseProp)) {
            if (Array.isArray(updatedModel[baseProp])) {
              model[baseProp] = [];
            }
          }
        }
      }
    }
    function filterDuplicateAttributes(attributes) {
      var allowedDuplicates = ['booking-search-children-ages', 'products-booked-children-ages'],
        attribute,
        deleteItems = [],
        foundAttributes = [],
        i,
        numAttributes = attributes.length,
        numDeletes;
      for (i = 0; i < numAttributes; i++) {
        attribute = attributes[i];
        if (!foundAttributes.includes(attribute.name) || allowedDuplicates.includes(attribute.name)) {
          foundAttributes.push(attribute.name);
        } else if (foundAttributes.includes(attribute.name) && !allowedDuplicates.includes(attribute.name)) {
          deleteItems.push(i);
          Debug.log('Removed duplicate attribute:', attribute.name);
        }
      }
      numDeletes = deleteItems.length;
      for (i = numDeletes - 1; i >= 0; i--) {
        attributes.splice(deleteItems[i], 1);
      }
    }
    function makeClickStreamCall(model) {
      var populateEventData,
        numProducts = model.products ? model.products.length : 0,
        i,
        j,
        k,
        numItems,
        dataElement,
        numDataElements,
        products = model.products || [],
        newEvent,
        appendEvents = [],
        prop,
        eventList,
        data = {
          events: []
        };
      populateEventData = function (model) {
        var events = model.events.split(','),
          numEvents,
          // visitorId = SiteCatalyst.helper.getVisitorId(),
          data = [];
        for (i = 0, numEvents = events.length; i < numEvents; i++) {
          dataElement = breakdownEventData(events[i], model.data);
          data.push(dataElement);
          // if (visitorId) {
          //     data[i].attributes.push({
          //         name: 'omniture-cookie-id',
          //         value: visitorId
          //     });
          // }
        }
        return data;
      };
      eventList = populateEventData(model);
      if (products.length > 0) {
        for (j = 0, numDataElements = eventList.length; j < numDataElements; j++) {
          for (i = 0; i < numProducts; i++) {
            if (products[i].events === 'cart-add=1') {
              products[i]['products-cart-action'] = 'cart-add';
              delete products[i].events;
            } else if (products[i].events === 'cart-remove=1') {
              products[i]['products-cart-action'] = 'cart-remove';
              delete products[i].events;
            }
            newEvent = clone(eventList[j]);
            for (prop in products[i]) {
              if (products[i].hasOwnProperty(prop) && (prop.includes('-') || prop === 'events')) {
                if (typeof products[i][prop] === 'string' || typeof products[i][prop] === 'number' || typeof products[i][prop] === 'boolean') {
                  if (products[i][prop] && products[i][prop] !== '') {
                    newEvent.attributes.push({
                      name: prop,
                      value: products[i][prop]
                    });
                  }
                } else if (Array.isArray(products[i][prop])) {
                  numItems = products[i][prop].length;
                  for (k = 0; k < numItems; k++) {
                    newEvent.attributes.push({
                      name: prop,
                      value: products[i][prop][k]
                    });
                  }
                }
              }
            }
            filterDuplicateAttributes(newEvent.attributes);
            appendEvents.push(newEvent);
          }
        }
        data.events = appendEvents;
      } else {
        data.events = eventList;
      }
      makeAPICall(function () {
        makeCaptureCall(model, data);
      });
    }
    function mergeInteractiveElements(interactiveElement, updatedModel) {
      if (interactiveElement && updatedModel) {
        resetArraysForMerge(interactiveElement.trackingModel, updatedModel.trackingModel);
        extend(true, interactiveElement, updatedModel);
      }
    }
    function bindEvent($el, triggerEvent, triggerType, interactiveElement) {
      var translatedEvent,
        bindType = 'bind';
      if (triggerType === 'page') {
        translatedEvent = 'd-page';
      } else if (triggerType === 'customEvent') {
        if (interactiveElement.trackingModel && interactiveElement.trackingModel.events) {
          translatedEvent = CEA.mapping.events.mapping.mapTo[interactiveElement.trackingModel.events];
          bindType = 'one';
        } else {
          translatedEvent = 'd-link';
        }
      } else {
        translatedEvent = 'd-link';
      }
      $el.one(triggerEvent.type, {
        interactiveElement
      }, function (cEvent, updatedModel) {
        var me = this;
        cEvent.preventDefault();
        cEvent.stopImmediatePropagation();
        trackEvent(translatedEvent, cEvent.data.interactiveElement, updatedModel);
        setTimeout(function () {
          Framework.fireEvent({
            node: me,
            event: 'click'
          });
          if (bindType !== 'one') {
            setTimeout(function () {
              bindEvent($el, triggerEvent, triggerType, interactiveElement);
            }, 300);
          }
        }, 600);
      });
    }
    function setupEvent(interactiveElement) {
      var triggerEvent, numEvents, i;
      if (interactiveElement.triggerEvents) {
        numEvents = interactiveElement.triggerEvents.length;
        for (i = 0; i < numEvents; i++) {
          triggerEvent = interactiveElement.triggerEvents[i];
          if (triggerEvent.elementSelectors) {
            bindEvent($(triggerEvent.elementSelectors), triggerEvent, interactiveElement.trackingType, interactiveElement);
          }
        }
      }
    }
    function trackEvent(event, interactiveElement, updatedModel) {
      var parsedModel,
        model,
        pageNameKey = CEA.mapping.pageId.mapping.mapTo.replace('data.', ''),
        customerIdKey = CEA.mapping.customerId.mapping.mapTo.replace('data.', '');
      if (CEA.firstRun === false) {
        if (interactiveElement && updatedModel) {
          mergeInteractiveElements(interactiveElement, updatedModel);
        }
        mergeInteractiveElements(interactiveElement, interactiveElement.trackingModel);
        delete interactiveElement.trackingModel;
        model = interactiveElement;
        model.personalizationId = getPersonalizationId();
        parsedModel = parseSemanticModel(model, CEA.mapping);
        parsedModel.events = event;
        if ((event === 'd-link' || event === 'd-logged-out') && !model.pageId && !model.siteSection) {
          if (model.data && model.data['link-id']) {
            parsedModel.data['link-id'] = model.data['link-id'];
          }
          parsedModel.data[pageNameKey] = CEA.pageData.data[pageNameKey];
          parsedModel.data[customerIdKey] = CEA.pageData.data[customerIdKey];
        }
        makeAPICall(function () {
          makeClickStreamCall(parsedModel);
        });
      } else {
        Debug.log('CEA: trackEvent called before firstRun');
      }
    }
    function bindTrackVideo(triggerEvent, interactiveElement) {
      var events, event;
      $(triggerEvent.elementSelectors).on(triggerEvent.type, {
        interactiveElement,
        triggerEvent
      }, function (cEvent, updatedModel) {
        var triggerEvent = cEvent.data.triggerEvent,
          interactiveElement = cEvent.data.interactiveElement,
          i;
        if (!Framework.disabledEvents.includes(triggerEvent.type)) {
          mergeInteractiveElements(interactiveElement, updatedModel);
          if (updatedModel.trackingModel) {
            if (updatedModel.mediaId && updatedModel.mediaType && updatedModel.duration !== undefined && updatedModel.currentTime !== undefined && updatedModel.trackingModel.events) {
              events = updatedModel.trackingModel.events.split(',');
              for (i = 0; i < events.length; i++) {
                event = events[i];
                switch (event) {
                  case 'videoStart':
                    trackEvent('d-video-start', interactiveElement);
                    break;
                  case 'videoPause':
                    trackEvent('d-video-pause', interactiveElement);
                    break;
                  case 'videoEnd':
                    trackEvent('d-video-stop', interactiveElement);
                    break;
                }
              }
            } else {
              Debug.info('CEA: Interactive Element is missing required properties. The following properties are required:\n\tmediaId\n\tmediaType\n\tduration\n\tcurrentTime\n\ttrackingModel.events');
            }
          } else {
            Debug.info('CEA: Interactive Element is missing trackingModel');
          }
        } else {
          Debug.info('CEA: TRIGGERED EVENT DISABLED: ', triggerEvent.type);
        }
      });
    }
    function trackVideo(interactiveElement) {
      var triggerEvent, i, l;
      if (interactiveElement) {
        l = interactiveElement.triggerEvents.length;
        for (i = 0; i < l; i++) {
          triggerEvent = interactiveElement.triggerEvents[i];
          if (triggerEvent.type && triggerEvent.elementSelectors) {
            bindTrackVideo(triggerEvent, interactiveElement);
          }
        }
      }
    }
    function getStandardTargetData() {
      var pageData = CEA.pageData,
        data = {
          site: pageData.site,
          contentLocale: pageData.contentLocale,
          contentLanguage: pageData.contentLanguage,
          pageId: pageData.pageId,
          siteSection: pageData.siteSection
        };
      if (pageData.deviceInfo) {
        data.deviceInfo = pageData.deviceInfo;
      }
      return data;
    }
    function getDecisionImpressionForTarget(location, filter) {
      var decisions, decision, i, j, numFilters, numOptions, options;
      if (location.options) {
        options = location.options;
        numOptions = options.length;
        if (numOptions > 0) {
          decisions = [];
          if (filter && Array.isArray(filter)) {
            numFilters = filter.length;
            for (j = 0; j < numFilters; j++) {
              for (i = 0; i < numOptions; i++) {
                if (filter[j].indexOf()) {
                  // asked Donald about this, seems wrong
                  decisions.push(options[i].optionId);
                }
              }
            }
          } else {
            for (i = 0; i < numOptions; i++) {
              decisions.push(options[i].optionId);
            }
          }
          decision = decisions.join(',');
        } else {
          decision = location.engine ? 'DEFAULT' : 'control';
        }
      } else {
        decision = location.optionId || (location.engine ? 'DEFAULT' : 'control');
      }
      return decision;
    }
    function fireAdobeTargetDecisionCall(location) {
      var data = getStandardTargetData(),
        targetAdapter = inject.resolve('Adapter:AdobeTarget');
      extend(data, {
        personalizationEvent: 'decision',
        pDecision: getDecisionImpressionForTarget(location),
        pDecisionEngine: location.engine || 'none',
        pVPCSegment: location.vpcSegment || 'unknown'
      });
      targetAdapter.defineAndUpdateMbox('body', `${CEA.pageData.site}_Personalization_${location.locationShortName || location.location}`, 'append', data);
      if (location.additionalMBox) {
        setTimeout(function () {
          targetAdapter.defineAndUpdateMbox('body', location.additionalMBox, 'append', {});
        }, 500);
      }
      Framework.fireEvent({
        event: 'CEATargetDecisionCallComplete',
        data
      });
    }
    function fireAdobeTargetImpressionCall(location) {
      var data = getStandardTargetData();
      extend(data, {
        personalizationEvent: 'impression',
        pDecision: getDecisionImpressionForTarget(location),
        pDecisionEngine: location.engine || 'none',
        pVPCSegment: location.vpcSegment || 'unknown'
      });
      adobe.target.trackEvent({
        mbox: `${CEA.pageData.site}_Personalization_${location.locationShortName || location.location}`,
        params: data
      });
      Framework.fireEvent({
        event: 'CEATargetImpressionCallComplete',
        data
      });
    }
    function fireAdobeTargetClickCall(location, selections) {
      var data = getStandardTargetData();
      extend(data, {
        personalizationEvent: 'click',
        pDecision: getDecisionImpressionForTarget(location, selections),
        pDecisionEngine: location.engine || 'none',
        pVPCSegment: location.vpcSegment || 'unknown'
      });
      adobe.target.trackEvent({
        mbox: `${CEA.pageData.site}_Personalization_${location.locationShortName || location.location}`,
        params: data
      });
      Framework.fireEvent({
        event: 'CEATargetClickCallComplete',
        data
      });
    }
  }, 'Adapter:CEA', 'Analytics', 'Framework', 'Debug', 'Exports', 'extend', 'getCookie', 'setCookie', '$', 'isObject', 'getURLProtocol', 'moment', 'pollForElement', 'Adapter:SiteCatalyst', 'parseSemanticModel', 'clone', 'netlog');

  /* global inject */
  inject((CEA, moment, isObject, toBoolean, $, ensureArray, sessionStorage) => {
    if (!CEA) return;
    CEA.mapping = {
      userAgent: {
        mapping: {
          mapTo: 'data.user-agent',
          defaultValue: navigator.userAgent
        }
      },
      configuration: {
        CEA: {
          personalizationIdCookieName: {
            mapping: {
              mapTo: 'cookieName',
              defaultValue: 'personalizationId'
            }
          },
          personalizationIdCookieJarName: {
            mapping: {
              mapTo: 'cookieJarName'
            }
          },
          sessionIdCookieJarName: {
            mapping: {
              mapTo: 'sessionIdCookieJarName'
            }
          },
          sessionIdCookieName: {
            mapping: {
              mapTo: 'sessionIdCookieName'
            }
          },
          authCookieIncludeSubDomains: {
            mapping: {
              mapTo: 'authCookieIncludeSubDomains',
              defaultValue: true
            }
          },
          authCookieName: {
            mapping: {
              mapTo: 'authCookieName',
              defaultValue: 'pep_oauth_token'
            }
          },
          webSessionIdCookieName: {
            mapping: {
              defaultValue: 'PHPSESSID',
              mapTo: 'webSessionIdCookieName'
            }
          },
          channel: {
            mapping: {
              mapTo: 'data.channel',
              defaultValue: 'web'
            }
          },
          decisionToggleName: {
            mapping: {
              mapTo: 'decisionToggleName',
              defaultValue: 'decisionCapture'
            }
          },
          decisionTimeout: {
            mapping: {
              mapTo: 'decisionTimeout',
              defaultValue: 200
            }
          },
          decisionURL: {
            mapping: {
              mapTo: 'decisionURL',
              defaultValue: '/api/wdpro/recommendation-service/personalization-decisions'
            }
          },
          captureToggleName: {
            mapping: {
              mapTo: 'captureToggleName',
              defaultValue: 'personalizationCapture'
            }
          },
          captureTimeout: {
            mapping: {
              mapTo: 'captureTimeout',
              defaultValue: 200
            }
          },
          captureURL: {
            mapping: {
              mapTo: 'captureURL',
              defaultValue: '/api/wdpro/recommendation-service/personalization-events'
            }
          },
          authTimeout: {
            mapping: {
              mapTo: 'authTimeout',
              defaultValue: 200
            }
          },
          authURL: {
            mapping: {
              mapTo: 'authURL',
              defaultValue: '/authentication/get-client-token/'
            }
          },
          enableTargetIntegration: {
            mapping: {
              mapTo: 'enableTargetIntegration',
              defaultValue: 'false'
            }
          },
          enableInteractiveElementLinkTracking: {
            mapping: {
              mapTo: 'enableInteractiveElementLinkTracking',
              defaultValue: 'false'
            }
          },
          enableTrackElementLinkTracking: {
            mapping: {
              mapTo: 'enableTrackElementLinkTracking',
              defaultValue: 'false'
            }
          },
          rules: {
            mapping: {
              mapTo: 'rules'
            }
          }
        },
        SiteCatalyst: {
          namespace: {
            mapping: {
              defaultValue: 'wdpro'
            }
          }
        }
      },
      contentLocale: {
        mapping: {
          defaultValue: 'us',
          mapTo: 'data.content-locale,contentLocale'
        }
      },
      contentLanguage: {
        mapping: {
          defaultValue: 'en',
          mapTo: 'data.content-language,contentLanguage'
        }
      },
      marketingRegion: {
        mapping: {
          applyFilter: {
            case: 'lower'
          }
        }
      },
      currency: {
        mapping: {
          mapTo: 'data.currency-code',
          defaultValue: 'USD'
        }
      },
      site: {
        mapping: {
          mapTo: 'site,data.site'
        }
      },
      device: {
        type: {
          mapping: {}
        },
        viewType: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: model => model.type && model.viewType ? '{{type}}:{{viewType}}' : '',
          mapTo: 'deviceInfo'
        }
      },
      storeType: {
        mapping: {
          mapTo: 'storeType,data.store-type'
        }
      },
      store: {
        mapping: {
          mapTo: 'store,data.store'
        }
      },
      geo: {
        dmaCode: {
          mapping: {
            mapTo: 'data.geolocation-dma-code'
          }
        },
        country: {
          mapping: {
            mapTo: 'data.geolocation-country'
          }
        },
        region: {
          mapping: {
            mapTo: 'data.geolocation-region'
          }
        },
        zipcode: {
          mapping: {
            mapTo: 'data.geolocation-zip-code'
          }
        }
      },
      events: {
        mapping: {
          type: 'flex-array',
          valueDelimiter: '=',
          transformers: {
            preProcess: (model, parentModel, modelVal) => {
              var events = modelVal,
                event,
                i,
                numEvents,
                key,
                prop,
                modEventMap;
              modEventMap = {
                posModRevenue: 'pos-mod-revenue',
                negModRevenue: 'neg-mod-revenue',
                posModNights: 'pos-mod-nights',
                negModNights: 'neg-mod-nights'
              };
              numEvents = events.length;
              for (i = 0; i < numEvents; i++) {
                event = events[i];
                if (typeof event === 'string') {
                  if (event.includes('=')) {
                    event = event.split('=');
                    key = modEventMap[event[0]];
                    if (key) {
                      model.data[key] = event[1];
                    }
                  }
                } else {
                  for (prop in event) {
                    if (event.hasOwnProperty(prop)) {
                      key = modEventMap[prop];
                      if (key) {
                        model.data[key] = event[prop];
                      }
                    }
                  }
                }
              }
            }
          },
          mapTo: {
            pageView: 'd-page-view',
            videoPause: 'd-video-pause',
            videoStart: 'd-video-start',
            assetStart: 'd-asset-start',
            videoStop: 'd-video-stop',
            videoEnd: 'd-video-stop',
            assetComplete: 'd-asset-complete',
            registration: 'd-registration',
            leadGenerated: 'd-lead-generated',
            internalSearch: 'd-internal-search',
            productView: 'd-product-view',
            prodView: 'd-product-view',
            cartCreate: 'd-cart-create',
            cartView: 'd-cart-view',
            cartProductAdd: 'd-cart-product-add',
            cartProductRemove: 'd-cart-product-remove',
            purchase: 'd-purchase',
            internalSearchClick: 'd-internal-search-click',
            checkoutDelivery: 'd-checkout-delivery',
            checkoutInsurance: 'd-checkout-insurance',
            checkoutApplyPayment: 'd-checkout-apply-payment',
            checkoutReviewQuote: 'd-checkout-review-quote',
            checkoutGuestInfo: 'd-checkout-guest-info',
            guestInfoSubmit: 'd-checkout-guest-info',
            scCheckout: 'd-checkout',
            checkout: 'd-checkout',
            loggedIn: 'd-logged-in',
            loggedOut: 'd-logged-out',
            postCheckoutPayment: 'd-post-checkout-paymentonline',
            selfServiceInitiated: 'd-self-service-initiated',
            selfServiceCompleted: 'd-self-service-completed',
            compareVacationModify: 'd-compare-vacation-modify',
            checkoutExpressCheckout: 'd-checkout-express-checkout',
            modification: 'd-modification-event',
            posModRevenue: 'd-pos-mod-revenue-event',
            negModRevenue: 'd-neg-mod-revenue-event',
            posModNights: 'd-pos-mod-nights-event',
            negModNights: 'd-neg-mod-nights-event',
            VPDOrder: 'd-vpd-order'
          }
        }
      },
      posModNights: {
        mapping: {
          mapTo: 'data.modification-positive-nights'
        }
      },
      negModNights: {
        mapping: {
          mapTo: 'data.modification-negative-nights'
        }
      },
      posModRevenue: {
        mapping: {
          mapTo: 'data.modification-positive-revenue'
        }
      },
      negModRevenue: {
        mapping: {
          mapTo: 'data.modification-negative-revenue'
        }
      },
      claimContext: {
        mapping: {
          mapTo: 'data.claim-context'
        }
      },
      siteSection: {
        mapping: {
          mapTo: 'siteSection,data.site-section',
          defaultValue: 'notset',
          applyFilter: {
            case: 'lower',
            replace: [['&amp;', 'and'], ['&', 'and'], ['[^a-zA-Z0-9{}/]', '']]
          }
        }
      },
      // GO4-6736: _legacyHier1Site is a backcompat-only passthrough consumed
      // by the hierarchy template's lcSite transformer. Must appear before
      // `hierarchy` so the passthrough populates result._legacyHier1Site
      // before the template renders. Do not set from application code.
      _legacyHier1Site: {
        mapping: {
          mapTo: '_legacyHier1Site'
        }
      },
      hierarchy: {
        mapping: {
          type: 'template',
          reprocessOnUpdate: true,
          template: '{{#namespace}}' + '{{{namespace}}}/{{{lcSite}}}/{{#marketingRegion}}{{{marketingRegion}}}{{/marketingRegion}}' + '{{^marketingRegion}}{{{contentLocale}}}{{/marketingRegion}}/{{{contentLanguage}}}/' + '{{{siteSection}}}{{/namespace}}',
          transformers: {
            // _legacyHier1Site is a backcompat-only override populated by
            // the passthrough entry above (GO4-6736). When set, it wins
            // over site.toLowerCase() so the reverse-mapped legacy pixel
            // keeps its exact hier1 site segment.
            lcSite: result => result._legacyHier1Site || (result.site ? result.site.toLowerCase() : undefined)
          },
          mapTo: 'hierarchy'
        }
      },
      pageId: {
        mapping: {
          type: 'template',
          template: '{{#hierarchy}}{{{hierarchy}}}/{{{pageId}}}{{/hierarchy}}',
          mapTo: 'data.page-name,pageName',
          defaultValue: 'notset',
          applyFilter: {
            case: 'lower',
            replace: [['[^a-zA-Z0-9]', '']]
          }
        }
      },
      pageUrl: {
        mapping: {
          mapTo: 'data.page-url',
          defaultValue: () => location.href
        }
      },
      referrer: {
        mapping: {
          mapTo: 'data.referrer',
          defaultValue: () => document.referrer
        }
      },
      pageVariant: {
        mapping: {
          mapTo: 'data.page-variant'
        }
      },
      toggleStatus: {
        releaseToggles: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          mapTo: 'toggles',
          template: '{{#toggleStatus}}{{#ft}},{{{ft}}}{{/ft}}{{#rt}},{{{rt}}}{{/rt}}' + '{{#flt}},{{{flt}}}{{/flt}}{{/toggleStatus}}',
          transformers: {
            ft: model => {
              var toggles = [],
                toggle,
                featureToggles;
              if (model.toggleStatus && model.toggleStatus.featureToggles) {
                featureToggles = model.toggleStatus.featureToggles;
                for (toggle in featureToggles) {
                  if (featureToggles.hasOwnProperty(toggle)) {
                    toggles.push(`ft;${toggle}:${featureToggles[toggle]}`);
                  }
                }
              }
              return toggles.join(',');
            },
            rt: model => {
              var toggles = [],
                toggle,
                releaseToggles;
              if (model.toggleStatus && model.toggleStatus.releaseToggles) {
                releaseToggles = model.toggleStatus.releaseToggles;
                for (toggle in releaseToggles) {
                  if (releaseToggles.hasOwnProperty(toggle)) {
                    toggles.push(`rt;${toggle}:${releaseToggles[toggle]}`);
                  }
                }
              }
              return toggles.join(',');
            },
            flt: model => {
              var toggles = [],
                toggle,
                flowToggles;
              if (model.toggleStatus && model.toggleStatus.flowToggles) {
                flowToggles = model.toggleStatus.flowToggles;
                for (toggle in flowToggles) {
                  if (flowToggles.hasOwnProperty(toggle)) {
                    toggles.push(`flt;${toggle}:${flowToggles[toggle]}`);
                  }
                }
              }
              return toggles.join(',');
            }
          }
        }
      },
      contentDisplayed: {
        mapping: {
          type: 'template',
          template: '{{{contentDisplayed}}}{{#toggles}}{{{toggles}}}{{/toggles}}',
          mapTo: 'data.content-displayed'
        }
      },
      leadType: {
        mapping: {
          mapTo: 'data.lead-type'
        }
      },
      linkId: {
        mapping: {
          mapTo: 'data.link-id',
          defaultValue: () => {
            var getReferrer = inject.resolve('getReferrer'),
              linkIdObj = sessionStorage.getItem('tmpAnalyticsLinkId');
            if (linkIdObj && linkIdObj.prevPage && linkIdObj.linkId && linkIdObj.prevPage === getReferrer()) {
              return linkIdObj.linkId;
            }
          }
        }
      },
      regionId: {
        mapping: {
          mapTo: 'data.objectID'
        }
      },
      registrationTemplateId: {
        mapping: {
          mapTo: 'data.registration-template-id'
        }
      },
      siteType: {
        mapping: {
          mapTo: 'data.site-type'
        }
      },
      customerId: {
        mapping: {
          mapTo: 'data.swid'
        }
      },
      guestType: {
        mapping: {
          mapTo: 'data.guest-type'
        }
      },
      selfServiceType: {
        mapping: {
          type: 'flex-array',
          targetDelimiter: '|',
          mapTo: 'data.self-service-type'
        }
      },
      registrationStatus: {
        mapping: {
          mapTo: 'data.registration-status'
        }
      },
      homeCountry: {
        mapping: {
          mapTo: 'data.home-country'
        }
      },
      homeState: {
        mapping: {
          mapTo: 'data.home-state'
        }
      },
      homeCity: {
        mapping: {
          mapTo: 'data.home-city'
        }
      },
      homeZip: {
        mapping: {
          mapTo: 'data.home-zip'
        }
      },
      title: {
        mapping: {
          mapTo: 'data.title'
        }
      },
      age: {
        mapping: {
          mapTo: 'data.age'
        }
      },
      productTotal: {
        mapping: {
          mapTo: 'data.product-total'
        }
      },
      guestAffiliations: {
        mapping: {
          mapTo: 'guestAffiliations',
          type: 'flex-array',
          applyFilter: {
            alpha: 'asc',
            replace: [[' ', '']]
          },
          transformers: {
            preProcess: (model, parentModel, modelVal) => {
              if (!model.data) model.data = {};
              ensureArray(modelVal).forEach(val => {
                val = val.toLowerCase();
                if (val.includes('florida resident')) model.data['guest-affiliations-fl-res'] = true;
                if (val.includes('california resident')) model.data['guest-affiliations-cal-res'] = true;
                if (val.includes('canada resident')) model.data['guest-affiliations-canada-res'] = true;
                if (val.includes('dvc')) model.data['guest-affiliations-dvc'] = true;
                if (val.includes('passholder')) model.data['guest-affiliations-passholder'] = true;
                if (val.includes('socal')) model.data['guest-affiliations-socal-res'] = true;
                if (val.includes('united kingdom')) model.data['guest-affiliations-uk-res'] = true;
              });
            }
          }
        }
      },
      affiliationsAvailable: {
        mapping: {
          mapTo: 'data.affiliations-available',
          applyFilter: {
            alpha: 'asc',
            replace: [[' ', '']]
          }
        }
      },
      internalSearchKeywords: {
        mapping: {
          mapTo: 'data.internal-search-keywords'
        }
      },
      internalSearchNumResults: {
        mapping: {
          mapTo: 'data.internal-search-num-results'
        }
      },
      internalSearchType: {
        mapping: {
          mapTo: 'data.internal-search-type'
        }
      },
      bookingSearchNumResults: {
        mapping: {
          mapTo: 'data.booking-search-num-results'
        }
      },
      bookingSearchDaysBetweenSearchAndArrival: {
        mapping: {
          mapTo: 'data.booking-search-days-between-search-and-arrival',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookingSearchArrivalDate: {
        mapping: {
          mapTo: 'data.booking-search-arrival-date',
          applyFilter: {
            date: {}
          }
        }
      },
      bookingSearchLengthOfStayNights: {
        mapping: {
          mapTo: 'data.booking-search-length-of-stay-nights',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookingSearchDepartureDate: {
        mapping: {
          mapTo: 'data.booking-search-departure-date',
          applyFilter: {
            date: {}
          },
          defaultValue: model => model.data['booking-search-arrival-date'] && model.data['booking-search-length-of-stay-nights'] ? moment(model.data['booking-search-arrival-date'], 'YYYY-MM-DD').add(model.data['booking-search-length-of-stay-nights'], 'd').format('YYYY-MM-DD') : ''
        }
      },
      bookingSearchSeason: {
        mapping: {
          mapTo: 'data.booking-search-season'
        }
      },
      bookingSearchTweenTeens: {
        mapping: {
          mapTo: 'data.booking-search-tweenteens',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookinhSearchInfantsToddlers: {
        mapping: {
          mapTo: 'data.booking-search-infantstoddlers',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookingSearchAdults: {
        mapping: {
          mapTo: 'data.booking-search-adults,bookingSearchAdults',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookingSearchChildren: {
        mapping: {
          mapTo: 'data.booking-search-children,bookingSearchChildren',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookingSearchChildrenAges: {
        mapping: {
          mapTo: 'data.booking-search-children-ages'
        }
      },
      bookingSearchInfants: {
        mapping: {
          mapTo: 'data.booking-search-infants,bookingSearchInfants',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      bookingSearchPartySize: {
        mapping: {
          mapTo: 'data.booking-search-party-size'
        }
      },
      bookingSearchParty: {
        mapping: {
          type: 'template',
          reprocessOnUpdate: true,
          template: '{{#bookingSearchPartyTotal}}{{{bookingSearchPartyTotal}}}:' + '{{{bookingSearchAdults}}}A:{{{bookingSearchChildren}}}C:{{{bookingSearchInfants}}}I' + '{{/bookingSearchPartyTotal}}',
          mapTo: 'data.booking-search-party-size',
          transformers: {
            bookingSearchPartyTotal: model => {
              if (!isNaN(model.bookingSearchAdults) && !isNaN(model.bookingSearchChildren) && !isNaN(model.bookingSearchInfants)) {
                return Number(model.bookingSearchAdults) + Number(model.bookingSearchChildren) + Number(model.bookingSearchInfants);
              }
            }
          }
        }
      },
      bookingSearchFacilityTier: {
        mapping: {
          mapTo: 'data.booking-search-facility-tier'
        }
      },
      bookingSearchResort: {
        mapping: {
          // GO4-6951: also preserve on the mapped model so the CEA adapter's
          // co-located resort filter can read it.
          mapTo: 'data.booking-search-resort-onesource,bookingSearchResort'
        }
      },
      facetsUtilized: [{
        name: {
          mapping: {
            mapTo: 'data.facets-utilized-name',
            transformers: {
              preProcess: (model, parentModel, modelVal) => {
                parentModel.data['facets-utilized-name'] = modelVal;
              }
            }
          }
        },
        action: {
          mapping: {
            mapTo: 'data.facets-utilized-action',
            transformers: {
              preProcess: (model, parentModel, modelVal) => {
                parentModel.data['facets-utilized-action'] = modelVal;
              }
            }
          }
        }
      }],
      itineraryDay: {
        mapping: {
          mapTo: 'data.itinerary-day'
        }
      },
      itineraryLength: {
        mapping: {
          mapTo: 'data.itinerary-length'
        }
      },
      totalBookedLengthOfStayNights: {
        mapping: {
          mapTo: 'data.total-booked-length-of-stay-nights',
          applyFilter: {
            type: 'integer'
          }
        }
      },
      payment: {
        type: {
          mapping: {
            mapTo: 'data.payment-type'
          }
        },
        paymentAmount: {
          mapping: {
            mapTo: 'data.payment-amount'
          }
        },
        totalPrice: {
          mapping: {
            mapTo: 'data.payment-total-price',
            applyFilter: {
              type: 'float'
            }
          }
        },
        paymentFrequency: {
          mapping: {
            mapTo: 'data.payment-frequency'
          }
        },
        paymentMethods: {
          creditCardName: {
            mapping: {
              mapTo: 'data.payment-methods-credit-card-name'
            }
          },
          giftCardName: {
            mapping: {
              mapTo: 'data.payment-methods-gift-card-name'
            }
          },
          rewardsCardName: {
            mapping: {
              mapTo: 'data.payment-methods-rewards-card-name'
            }
          },
          pointsPaymentName: {
            mapping: {
              mapTo: 'data.payment-methods-points-payment-name'
            }
          },
          instantCreditName: {
            mapping: {
              mapTo: 'data.payment-methods-instant-credit-name'
            }
          }
        }
      },
      mediaType: {
        mapping: {
          mapTo: 'data.interactive-elements-media-type'
        }
      },
      mediaId: {
        mapping: {
          mapTo: 'data.interactive-elements-media-id'
        }
      },
      interactiveElements: [{
        trackingType: {
          mapping: {
            applyFilter: {
              replace: [['^\\s*"*\\s*|\\s*"*\\s*$', '']]
            }
          }
        },
        mediaType: {
          mapping: {
            mapTo: 'data.interactive-elements-media-type'
          }
        },
        mediaId: {
          mapping: {
            mapTo: 'data.interactive-elements-media-id'
          }
        },
        linkId: {
          mapping: {
            mapTo: 'data.link-id',
            applyFilter: {
              replace: [['^\\s*"*\\s*|\\s*"*\\s*$', '']]
            }
          }
        },
        linkIdSelectors: {
          mapping: {
            applyFilter: {
              replace: [['^\\s*"*\\s*|\\s*"*\\s*$', '']]
            }
          }
        },
        regionId: {
          mapping: {}
        },
        trackingModel: {
          mapping: {}
        },
        triggerEvents: [{
          type: {
            mapping: {}
          },
          elementSelectors: {
            mapping: {}
          },
          onCompleteEventName: {
            mapping: {}
          }
        }],
        trackPromoImpressions: {
          mapping: {
            type: 'template',
            template: 'false',
            defaultValue: false,
            transformers: {
              /* will add items that are specified in the promoImpressions list*/
              preProcess: (model, parentModel) => {
                if (model.linkId && toBoolean(model.trackPromoImpressions)) {
                  //make sure the selector is an actual item on the page
                  if ($(model.linkIdSelectors).length > 0 || Array.isArray(model.triggerEvents) && $(model.triggerEvents[0].elementSelectors).length > 0) {
                    //save this information in the parentModel as trackPromoImpressions
                    if (!parentModel.trackPromoImpressions) {
                      parentModel.trackPromoImpressions = model.linkId;
                    } else {
                      parentModel.trackPromoImpressions += `,${model.linkId}`;
                    }
                  }
                }
              }
            }
          }
        },
        mapping: {
          type: 'none',
          applyFilter: {
            forceArray: ''
          }
        }
      }],
      /*must be after interactiveElements since trackPromoImpressions will automatically add to this list*/
      promoImpressionsList: {
        mapping: {
          type: 'template',
          template: '{{#promoImpressions}}{{promoImpressions}}{{/promoImpressions}}',
          transformers: {
            promoImpressions: model => {
              // put what is in promoImpressionsList togther with what was potentially from the interactiveElements
              if (model.promoImpressionsList && model.trackPromoImpressions) {
                model.promoImpressionsList += `,${model.trackPromoImpressions}`;
              } else if (model.trackPromoImpressions) {
                model.promoImpressionsList = model.trackPromoImpressions;
              }
              return model.promoImpressionsList;
            }
          },
          mapTo: 'data.promo-impressions-list'
        }
      },
      offerId: {
        offerName: {
          mapping: {
            mapTo: 'data.offer-id'
          }
        }
      },
      offersShown: [{
        id: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{id}}'
        }
      }],
      _cea_offersShown: {
        mapping: {
          defaultValue: m => m.offersShown,
          mapTo: 'data.offer-shown',
          type: 'flex-array',
          valuePrefix: 'SoList;',
          targetDelimiter: ';'
        }
      },
      socialInteractionType: {
        mapping: {
          applyFilter: {
            replace: [[' ', '']]
          },
          mapTo: model => {
            var eventNum = 'social-interaction';
            if (!model.events) {
              model.events = eventNum;
            } else if (!model.events.includes(eventNum)) {
              model.events += `,${eventNum}`;
            }
            return 'data.social-interaction-type';
          }
        }
      },
      products: [{
        orderType: {
          mapping: {
            mapTo: 'products-order-type'
          }
        },
        productType: {
          mapping: {
            defaultValue: 'prod',
            mapTo: {
              addOn: 'add',
              airTransportation: 'air',
              cruise: 'cruise',
              dining: 'dine',
              enhancedExperience: 'eexp',
              event: 'evt',
              fastPassPlus: 'gxa',
              greatFoodFast: 'gxa',
              groundTransportation: 'auto',
              insurance: 'ins',
              media: 'med',
              nonDisneyTicket: 'ndt',
              preOrder: 'pre',
              product: 'prod',
              resortVacation: 'res',
              ticket: 'tix',
              trip: 'trip'
            }
          }
        },
        productId: {
          mapping: {
            mapTo: 'product-id'
          }
        },
        prodType: {
          mapping: {
            mapTo: 'product-type',
            type: 'template',
            template: '{{#productType}}{{{productType}}}{{/productType}}'
          }
        },
        facilityId: {
          mapping: {
            mapTo: 'products-facility-id'
          }
        },
        facilityTier: {
          mapping: {
            mapTo: 'products-facility-tier'
          }
        },
        packageType: {
          mapping: {
            mapTo: 'products-package-type'
          }
        },
        roomTypeId: {
          mapping: {
            mapTo: 'products-room-type-id'
          }
        },
        portId: {
          mapping: {
            mapTo: 'portId'
          }
        },
        includedProducts: [{
          applyFilter: {
            removeElement: {
              keys: ['type'],
              values: ['diningPlan']
            }
          },
          type: {
            mapping: {
              defaultValue: 'ticket'
            }
          },
          id: {
            mapping: {
              mapTo: 'products-included-products-id'
            }
          },
          price: {
            mapping: {
              mapTo: 'products-included-products-price',
              applyFilter: {
                type: 'float'
              }
            }
          },
          quantity: {
            mapping: {
              mapTo: 'products-included-products-quantity',
              applyFilter: {
                type: 'integer'
              }
            }
          }
        }],
        dateReservationMade: {
          mapping: {
            mapTo: 'products-date-reservation-made',
            applyFilter: {
              date: {}
            }
          }
        },
        bookingSearchDaysBetweenSearchAndArrival: {
          mapping: {
            mapTo: 'booking-search-days-between-search-and-arrival',
            applyFilter: {
              type: 'integer'
            }
          }
        },
        bookingSearchLengthOfStayNights: {
          mapping: {
            mapTo: 'booking-search-length-of-stay-nights',
            applyFilter: {
              type: 'integer'
            }
          }
        },
        bookingSearchArrivalDate: {
          mapping: {
            mapTo: 'booking-search-arrival-date',
            applyFilter: {
              date: {}
            }
          }
        },
        bookingSearchDepartureDate: {
          mapping: {
            mapTo: 'booking-search-departure-date',
            applyFilter: {
              date: {}
            },
            defaultValue: model => model['booking-search-arrival-date'] && model['booking-search-length-of-stay-nights'] ? moment(model['booking-search-arrival-date'], 'YYYY-MM-DD').add(model['booking-search-length-of-stay-nights'], 'd').format('YYYY-MM-DD') : undefined
          }
        },
        bookingSearchAdults: {
          mapping: {
            defaultValue: '0',
            mapTo: 'booking-search-adults'
          }
        },
        bookingSearchChildren: {
          mapping: {
            defaultValue: '0',
            mapTo: 'booking-search-children',
            applyFilter: {
              type: 'integer'
            }
          }
        },
        bookingSearchInfants: {
          mapping: {
            mapTo: 'booking-search-infants',
            applyFilter: {
              type: 'integer'
            }
          }
        },
        bookingSearchChildrenAges: {
          mapping: {
            mapTo: 'booking-search-children-ages'
          }
        },
        bookedAdults: {
          mapping: {
            mapTo: 'products-booked-adults',
            applyFilter: {
              type: 'integer'
            }
          }
        },
        bookedChildren: {
          mapping: {
            mapTo: 'products-booked-children',
            applyFilter: {
              type: 'integer'
            }
          }
        },
        bookedChildrenAges: {
          mapping: {
            mapTo: 'products-booked-children-ages'
          }
        },
        bookedInfants: {
          mapping: {
            mapTo: 'products-booked-infants',
            applyFilter: {
              type: 'integer'
            }
          }
        },
        bookedArrivalDate: {
          mapping: {
            mapTo: 'products-booked-arrival-date',
            applyFilter: {
              date: {}
            }
          }
        },
        bookedLengthOfStayNights: {
          mapping: {
            mapTo: 'products-booked-length-of-stay-nights',
            applyFilter: {
              type: 'integer'
            }
          }
        },
        bookedDepartureDate: {
          mapping: {
            mapTo: 'products-booked-departure-date',
            defaultValue: model => model['products-booked-arrival-date'] && model['products-booked-length-of-stay-nights'] ? moment(model['products-booked-arrival-date']).add(model['products-booked-length-of-stay-nights'], 'd').format('YYYY-MM-DD') : undefined
          }
        },
        quantity: {
          mapping: {
            mapTo: 'products-quantity',
            applyFilter: {
              type: 'integer'
            }
          }
        },
        price: {
          total: {
            mapping: {
              mapTo: 'price-total',
              applyFilter: {
                type: 'float'
              }
            }
          },
          subTotal: {
            mapping: {
              mapTo: 'price-subtotal',
              applyFilter: {
                type: 'float'
              }
            }
          },
          tax: {
            mapping: {
              mapTo: 'price-tax',
              applyFilter: {
                type: 'float'
              }
            }
          },
          shipping: {
            mapping: {
              mapTo: 'price-shipping',
              applyFilter: {
                type: 'float'
              }
            }
          }
        },
        confirmationNumber: {
          mapping: {
            mapTo: 'products-confirmation-number'
          }
        },
        daysBetweenBookingAndArrival: {
          mapping: {
            mapTo: 'products-days-between-booking-and-arrival',
            applyFilter: {
              type: 'integer'
            }
          }
        },
        events: {
          mapping: {
            type: 'flex-array',
            valueDelimiter: '=',
            defaultElementValue: '1',
            targetDelimiter: '|',
            mapTo: {
              cartAdd: 'cart-add',
              cartRemove: 'cart-remove'
            }
          }
        },
        mapping: {
          mapTo: 'products',
          applyFilter: {
            forceArray: ''
          },
          transformers: {
            // used to perform preliminary transformations without setting a particular value to the model
            preProcess: model => {
              var ip, n;
              // for now we only expect 1 item in the included products (tickets)
              if (model.includedProducts && model.includedProducts.length > 0) {
                ip = model.includedProducts[0];
                for (n in ip) {
                  if (ip.hasOwnProperty(n)) {
                    model[n] = ip[n];
                  }
                }
              }
            }
          }
        }
      }],
      productsCompared: [{
        productName: {
          mapping: {
            mapTo: 'data.products-compared-product-name'
          }
        },
        productId: {
          mapping: {}
        },
        productsCompared: {
          mapping: {
            mapTo: 'data.products-compared-facility-id'
          }
        }
      }],
      productsDisplayed: [{
        productType: {
          mapping: {
            defaultValue: 'prod',
            mapTo: {
              product: 'prod',
              ticket: 'tix'
            }
          }
        },
        prodType: {
          mapping: {
            type: 'template',
            template: '{{#productType}}{{{productType}}}{{/productType}}',
            mapTo: 'data.products-displayed-product-type'
          }
        },
        facilityId: {
          mapping: {
            mapTo: 'data.products-displayed-facility-id'
          }
        },
        facilityTier: {
          mapping: {
            mapTo: 'data.products-displayed-facility-tier'
          }
        },
        roomTypeId: {
          mapping: {
            mapTo: 'data.products-displayed-room-type-id'
          }
        },
        isAvailable: {
          mapping: {
            mapTo: 'data.products-displayed-is-available'
          }
        },
        productId: {
          mapping: {
            mapTo: 'data.products-displayed-product-id'
          }
        },
        mapping: {
          transformers: {
            preProcess: (model, parentModel) => {
              if (model.productType === 'prod') {
                if (parentModel.numAvailable === undefined) {
                  parentModel.numAvailable = 0;
                }
                if (!parentModel.availableMatrix) {
                  parentModel.availableMatrix = '';
                }
                if (model.isAvailable === true) {
                  parentModel.numAvailable++;
                  parentModel.availableMatrix += ';1';
                } else if (model.isAvailable === false) {
                  parentModel.availableMatrix += ';0';
                } else {
                  parentModel.availableMatrix += `;${model.isAvailable}`;
                }
              }
            }
          }
        }
      }],
      carts: [{
        id: {
          mapping: {
            mapTo: 'data.cart-id'
          }
        },
        status: {
          mapping: {
            mapTo: 'data.cart-status'
          }
        }
      }],
      recommenderInfo: {
        conversationId: {
          mapping: {
            mapTo: 'data.recommender-info-conversation-id'
          }
        },
        messageId: {
          mapping: {
            mapTo: 'data.recommender-info-message-id'
          }
        }
      },
      compareVacationNumber: {
        mapping: {
          mapTo: 'data.compare-vacation-number'
        }
      },
      currencyDisplayed: {
        mapping: {
          mapTo: 'data.currency-displayed'
        }
      },
      server: {
        mapping: {
          mapTo: 'server'
        }
      },
      currentEntitlements: {
        mapping: {
          type: 'flex-array',
          mapTo: 'data.current-entitlements',
          applyFilter: {
            alpha: 'asc',
            replace: [[' ', '']]
          }
        }
      },
      modificationType: {
        mapping: {
          mapTo: 'data.modification-event'
        }
      },
      personalizations: [{
        location: {
          mapping: {
            mapTo: 'location'
          }
        },
        locationShortName: {
          mapping: {
            mapTo: 'locationShortName'
          }
        },
        customerGroup: {
          mapping: {
            mapTo: 'engine'
          }
        },
        selector: {
          mapping: {
            mapTo: 'selector'
          }
        },
        // Used to bind even to element for click tracking
        clickSelector: {
          mapping: {
            mapTo: 'clickSelector'
          }
        },
        selectionSelector: {
          mapping: {
            mapTo: 'selectionSelector'
          }
        },
        selectionOptionValueAttribute: {
          mapping: {
            mapTo: 'selectionOptionValueAttribute'
          }
        },
        optionIdAttr: {
          mapping: {
            mapTo: 'optionIdAttr'
          }
        },
        /***
         * Setting this will override a linkId that is set using the name attribute method
         **/
        linkId: {
          mapping: {
            mapTo: 'linkId'
          }
        },
        type: {
          mapping: {
            mapTo: 'type',
            defaultValue: 'standard'
          }
        },
        impressionType: {
          mapping: {
            mapTo: 'impressionType',
            defaultValue: 'view'
          }
        },
        impressionEvent: {
          mapping: {
            mapTo: 'impressionEvent'
          }
        },
        impressionSelector: {
          mapping: {
            mapTo: 'impressionSelector'
          }
        },
        controlSelector: {
          mapping: {
            mapTo: 'controlSelector'
          }
        },
        additionalMBox: {
          mapping: {
            mapTo: 'additionalMBox'
          }
        },
        // name of experience delivered
        decision: {
          mapping: {
            mapTo: 'decision'
          }
        },
        // identifier passed to SiteCatalyst for decision
        optionId: {
          mapping: {
            mapTo: 'optionId'
          }
        },
        options: [{
          optionId: {
            mapping: {
              mapTo: 'optionId'
            }
          },
          decision: {
            mapping: {
              mapTo: 'decision'
            }
          },
          mapping: {
            type: 'none',
            applyFilter: {
              forceArray: ''
            }
          }
        }],
        mapping: {
          type: 'none',
          applyFilter: {
            forceArray: ''
          }
        }
      }],
      possibleAffiliation: {
        mapping: {
          mapTo: 'possibleAffiliation'
        }
      },
      personalizationId: {
        mapping: {
          mapTo: 'personalizationId'
        }
      },
      availableGuestMedia: {
        mapping: {
          mapTo: 'data.photopass-media-available',
          applyFilter: {
            type: 'string'
          }
        }
      }
    };
  }, 'Adapter:CEA', 'moment', 'isObject', 'toBoolean', '$', 'ensureArray', 'sessionStorage');

  /* global inject */
  inject((SiteCatalyst, Framework, Debug, Exports, extend, pollForElement, $, consentAugment, consentCategoryOverrides) => {
    if (!SiteCatalyst) return;
    var pageNameExport,
      helper = SiteCatalyst.helper = {},
      model,
      openVideos;
    const name = 'SiteCatalyst';
    extend(SiteCatalyst, {
      name,
      CALL_NUMBER_COUNTER: 0,
      firstCall: true,
      isOff: false,
      trackElementList: {},
      consentCategory: consentCategoryOverrides[name] || 'targeting',
      turnOff,
      turnOn,
      adapter,
      trackElement,
      reset
    });
    consentAugment(SiteCatalyst);
    Object.defineProperty(Exports, 'pageName', {
      get: () => pageNameExport,
      enumerable: true
    });
    function turnOff() {
      SiteCatalyst.isOff = true;
    }
    function turnOn() {
      SiteCatalyst.isOff = false;
    }
    function reset() {
      SiteCatalyst.CALL_NUMBER_COUNTER = 0;
      SiteCatalyst.firstCall = true;
      if (window.s_wdpro) {
        if (window.s_wdpro.clearVars) window.s_wdpro.clearVars();
        delete window.s_wdpro.pageName;
        delete window.s_wdpro.ppvID;
        delete window.s_wdpro.pageURL;
        delete window.s_wdpro.contextData;
      }
    }
    function trackElement(event, model) {
      var interactiveElm;
      if (event) {
        /* if we are dealing with an interactive element that was predefined.
           See framework.SiteCatalyst.trackElement.preConfigured.test.js */
        if (SiteCatalyst.trackElementList[event]) {
          interactiveElm = SiteCatalyst.trackElementList[event];
          if (model) {
            SiteCatalyst.helper.mergeInteractiveElements(interactiveElm, model);
          }
          model = interactiveElm.trackingModel || {};
          model.trackingType = interactiveElm.trackingType;
          model.linkId = interactiveElm.linkId;
        }
        if (model.trackingType === 'standardPage' || model.trackingType === 'customPage' || model.trackingType === 'page') {
          SiteCatalyst.helper.trackPage(event, model);
        } else if (model.trackingType === 'customLink' || model.trackingType === 'pic') {
          if (model.linkId) {
            SiteCatalyst.helper.trackClick(event, model);
          } else {
            Debug.info('linkId property not set');
          }
        } else if (model.trackingType === 'standardLink') {
          if (model.linkIdSelectors) {
            SiteCatalyst.helper.createLinkId(event, model);
          } else {
            Debug.info('linkIdSelectors not set for SiteCatalyst trackElement (standardLink) : ', event, model);
          }
        }
      } else {
        Debug.info('event parameter was not set for SiteCatalyst trackElement');
      }
    }
    function adapter(sam) {
      var i,
        l,
        it,
        lt,
        triggerEvent,
        inTrackElementList,
        parentModel,
        interactiveElement,
        mappedModel = inject.resolve('productMap')(this, name, sam);
      if (!mappedModel || this.isOff) return;
      model = mappedModel;
      openVideos = [];
      if (mappedModel.cookieDomainPeriodRules) applyCookieDomainRules(mappedModel.cookieDomainPeriodRules);

      /* fire a standard page only the first time & add click handler to anchors with linkId's */
      if (SiteCatalyst.firstCall) {
        pageNameExport = mappedModel.pageName;
        /*
        * We should not disable custom link tracking for javascript links or links within the same page.
        */
        $('a[name^="&lid="]').filter('[href]').not('a[href^="#"]').not('a[href*="javascript"]').on('click', function () {
          Debug.log('PRESET STANDARD LINK TRIGGERED: ', $(this).attr('name'));
          Debug.log('CUSTOM LINK EVENTS HAVE NOW BEEN DISABLED');
          Framework.flagDisableCustomLinks = true;
        });
        fireStandardPage(mappedModel);
        SiteCatalyst.firstCall = false;
      } else {
        parentModel = Framework.getParentModel();
        if (mappedModel.siteSection === 'notset' && parentModel.siteSection) {
          mappedModel.site = parentModel.site;
          mappedModel.siteSection = parentModel.siteSection;
          if (!mappedModel.storeType && parentModel.storeType) {
            mappedModel.storeType = parentModel.storeType;
          }
        }
      }

      //determine the type of interactive elements we are dealing with
      if (Array.isArray(mappedModel.interactiveElements)) {
        l = mappedModel.interactiveElements.length;
        if (l > 0) {
          for (i = 0; i < l; i++) {
            interactiveElement = mappedModel.interactiveElements[i];
            if (interactiveElement) {
              /*determine if interactiveElement should go in the trackElementList
              this will allow it to be invoked directly using the trackElement function
              * */
              inTrackElementList = false;
              if (interactiveElement.triggerEvents && Array.isArray(interactiveElement.triggerEvents)) {
                for (it = 0, lt = interactiveElement.triggerEvents.length; it < lt; it++) {
                  triggerEvent = interactiveElement.triggerEvents[it];
                  if (!triggerEvent.elementSelectors && triggerEvent.type) {
                    SiteCatalyst.trackElementList[triggerEvent.type] = interactiveElement;
                    inTrackElementList = true;
                  }
                }
              }
              if (!inTrackElementList) {
                switch (interactiveElement.trackingType) {
                  case 'page':
                  case 'customPage':
                  case 'standardPage':
                    fireCustomPage(interactiveElement, mappedModel);
                    break;
                  case 'pic':
                  case 'customLink':
                    setupCustomLink(interactiveElement, mappedModel);
                    break;
                  case 'standardLink':
                    createInteractiveElementLinkId(interactiveElement);
                    break;
                  case 'vid':
                  case 'video':
                    if (interactiveElement.triggerEvents) {
                      fireTrackVideo(interactiveElement, mappedModel);
                    }
                    break;
                  case 'elementExists':
                    if (interactiveElement.triggerEvents) {
                      bindElementExists(interactiveElement, mappedModel);
                    }
                    break;
                  default:
                    /**
                     * any elements with a tracking model or trigger event that is not
                     * specifically a page tracking type will be treated as a customLink
                     */
                    if (interactiveElement.trackingModel || interactiveElement.triggerEvents) {
                      setupCustomLink(interactiveElement, mappedModel);
                      /**
                       * element has a link id but no tracking model or trigger event
                       * is a standardLink
                       */
                    } else if (interactiveElement.linkId) {
                      createInteractiveElementLinkId(interactiveElement);
                    }
                }
              }
            }
          }
        }
      }
      model = undefined;
      Framework.fireEvent({
        event: 'SiteCatalystAdapterComplete',
        data: mappedModel
      });
    }
    function applyCookieDomainRules(rules) {
      var i,
        modelProp,
        numRules = rules.length,
        periods = model.cookieDomainPeriods,
        rule,
        ruleMatch = true;
      for (i = 0; i < numRules; i++) {
        rule = rules[i];
        for (modelProp in rule.match) {
          if (rule.match.hasOwnProperty(modelProp)) {
            if (model[modelProp] && model[modelProp].toLowerCase() !== rule.match[modelProp].toLowerCase()) {
              ruleMatch = false;
              break;
            }
          }
        }
        if (ruleMatch && rule.periods) {
          periods = rule.periods;
          break;
        }
      }
      model.cookieDomainPeriods = periods;
    }
    function addTriggerEventIfNeeded(interactiveElement) {
      var identifier;
      if (!interactiveElement.triggerEvents) {
        identifier = interactiveElement.linkIdSelectors ? interactiveElement.linkIdSelectors : `#${interactiveElement.linkId}`;
        interactiveElement.triggerEvents = [{
          type: 'click',
          elementSelectors: identifier
        }];
      }
      return interactiveElement;
    }

    // private functions
    function fireStandardPage(model) {
      var s_wdpro = window.s_wdpro;
      if (model && model.reportSuiteId) {
        window.setSiteCatalystAccountVar(model.reportSuiteId, model.appendReportSuiteIds);
        helper.filterModelForSiteCatalyst(model, s_wdpro);
      }
      if (window.s_account !== '') {
        s_wdpro.t();
        helper.siteCatalystCallCompleteEvent('standardPage', s_wdpro);
      }
    }
    function createInteractiveElementLinkId(interactiveElement) {
      var elem, identifier;
      if (interactiveElement.linkId) {
        identifier = interactiveElement.linkIdSelectors ? interactiveElement.linkIdSelectors : interactiveElement.linkId;
        elem = Framework.getElementByIdOrSelector(identifier);
        if (!helper.doesLinkIdExist($(elem))) {
          $(elem).attr('name', `&lid=${interactiveElement.linkId}`).on('click', {
            interactiveElement
          }, cEvent => {
            Debug.log('STANDARD LINK TRIGGERED: ', cEvent.data.interactiveElement);
            Debug.log('CUSTOM LINK EVENTS HAVE NOW BEEN DISABLED');
            Framework.flagDisableCustomLinks = true;
          });
        }
      }
    }
    function bindCustomPage(triggerEvent, interactiveElement, model) {
      var objAdditionalVariables;
      $(triggerEvent.elementSelectors).on(triggerEvent.type, {
        interactiveElement,
        triggerEvent
      }, function (cEvent, updatedModel) {
        if (!updatedModel && cEvent.originalEvent && cEvent.originalEvent.detail) return; // this fires on both jQuery events and dom events in fireEvent, ignore non-jquery events to prevent doubling
        var triggerEvent = cEvent.data.triggerEvent,
          interactiveElement = cEvent.data.interactiveElement;
        Debug.info('CUSTOM PAGE TRIGGERED: ', cEvent.data.triggerEvent.type);
        if (!Framework.disabledEvents.includes(triggerEvent.type)) {
          //extend function merges recursively two elements
          helper.mergeInteractiveElements(interactiveElement, updatedModel);
          if (interactiveElement.trackingModel) {
            objAdditionalVariables = helper.getSiteCatalystModelFromInteractiveElement(interactiveElement, model);
            window.s_wdpro.trackPage(interactiveElement.trackingModel.pageId, interactiveElement.linkId, this, objAdditionalVariables);
            helper.siteCatalystCallCompleteEvent('customPage', objAdditionalVariables, triggerEvent.onCompleteEventName);
          }
        } else {
          Debug.info('TRIGGERED EVENT DISABLED: ', triggerEvent.type);
        }
      });
    }
    function fireCustomPage(interactiveElement, model) {
      var triggerEvent, i, l;
      if (interactiveElement) {
        addTriggerEventIfNeeded(interactiveElement);
        l = interactiveElement.triggerEvents.length;
        for (i = 0; i < l; i++) {
          triggerEvent = interactiveElement.triggerEvents[i];
          if (triggerEvent.type && triggerEvent.elementSelectors) {
            bindCustomPage(triggerEvent, interactiveElement, model);
          }
        }
      }
    }
    function bindElementExists(interactiveElement, model) {
      var triggerEvents = interactiveElement.triggerEvents,
        numTriggerEvents = triggerEvents.length,
        maxTries,
        triggerEvent,
        i;
      for (i = 0; i < numTriggerEvents; i++) {
        triggerEvent = triggerEvents[i];
        maxTries = triggerEvent.pollMaxTries || 5;
        if (triggerEvent.elementSelectors) {
          $('body').on('onPage', triggerEvent.elementSelectors, {
            interactiveElement,
            model
          }, function (cData) {
            fireCustomLink('onPage', cData.data.interactiveElement, cData.data.model);
          });
          pollForElement(triggerEvent.elementSelectors, function (elm) {
            Framework.fireEvent({
              node: elm[0],
              event: 'onPage'
            });
          }, maxTries);
        }
      }
    }
    function fireCustomLink(triggerEvent, interactiveElement, updatedModel) {
      var objAdditionalVariables;
      Debug.info('CUSTOM LINK FIRED: ', interactiveElement);
      if (Framework.flagDisableCustomLinks === false) {
        if (!Framework.disabledEvents.includes(triggerEvent.type)) {
          //extend function merges recursively two elements
          helper.mergeInteractiveElements(interactiveElement, updatedModel);
          objAdditionalVariables = helper.getSiteCatalystModelFromInteractiveElement(interactiveElement, model);
          window.s_wdpro.trackClick({}, interactiveElement.linkId, objAdditionalVariables);
          helper.siteCatalystCallCompleteEvent('customLink', objAdditionalVariables, triggerEvent.onCompleteEventName);
        } else {
          Debug.info('TRIGGERED EVENT DISABLED: ', interactiveElement);
        }
      } else {
        Debug.info('CUSTOM LINK EVENTS DISABLED BY STANDARD LINK CLICK: ', interactiveElement);
      }
    }
    function bindCustomLink(triggerEvent, interactiveElement) {
      $(triggerEvent.elementSelectors).on(triggerEvent.type, {
        interactiveElement,
        triggerEvent
      }, function (cEvent, updatedModel) {
        var triggerEvent = cEvent.data.triggerEvent,
          interactiveElement = cEvent.data.interactiveElement;
        fireCustomLink(triggerEvent, interactiveElement, updatedModel);
      });
    }
    function setupCustomLink(interactiveElement, model) {
      var triggerEvent, i, l;
      if (interactiveElement) {
        addTriggerEventIfNeeded(interactiveElement);
        l = interactiveElement.triggerEvents.length;
        for (i = 0; i < l; i++) {
          triggerEvent = interactiveElement.triggerEvents[i];
          if (triggerEvent.type && triggerEvent.elementSelectors) {
            bindCustomLink(triggerEvent, interactiveElement, model);
          }
        }
      }
    }
    function isVideoOpen(mediaId) {
      return openVideos[mediaId] === true;
    }
    function openVideo(interactiveElement) {
      openVideos[interactiveElement.mediaId] = true;
      if (interactiveElement.duration === null) {
        interactiveElement.duration = 0;
      }
      window.s_wdpro.Media.open(`${interactiveElement.mediaType}:${interactiveElement.mediaId}`, interactiveElement.duration, 'Media Player');
    }
    function playVideo(interactiveElement) {
      if (isVideoOpen(interactiveElement.mediaId) === false) {
        openVideo(interactiveElement);
      }
      window.s_wdpro.Media.play(`vid:${interactiveElement.mediaId}`, interactiveElement.currentTime);
    }
    function pauseVideo(interactiveElement) {
      window.s_wdpro.Media.stop(`vid:${interactiveElement.mediaId}`, interactiveElement.currentTime);
    }
    function closeVideo(interactiveElement) {
      if (isVideoOpen(interactiveElement.mediaId)) {
        window.s_wdpro.Media.stop(`vid:${interactiveElement.mediaId}`, interactiveElement.currentTime);
        window.s_wdpro.Media.close(`vid:${interactiveElement.mediaId}`);
        delete openVideos[interactiveElement.mediaId];
      }
    }
    function endVideo(interactiveElement) {
      window.s_wdpro.Media.complete(`vid:${interactiveElement.mediaId}`, interactiveElement.currentTime);
      window.s_wdpro.Media.close(`vid:${interactiveElement.mediaId}`);
      delete openVideos[interactiveElement.mediaId];
    }
    function bindTrackVideo(triggerEvent, interactiveElement) {
      var events, event;
      $(triggerEvent.elementSelectors).on(triggerEvent.type, {
        interactiveElement,
        triggerEvent
      }, function (cEvent, updatedModel) {
        if (!updatedModel) return;
        var triggerEvent = cEvent.data.triggerEvent,
          interactiveElement = cEvent.data.interactiveElement,
          i;
        if (!Framework.disabledEvents.includes(triggerEvent.type)) {
          helper.mergeInteractiveElements(interactiveElement, updatedModel);
          if (updatedModel.trackingModel) {
            if (updatedModel.mediaId && updatedModel.mediaType && updatedModel.duration !== undefined && updatedModel.currentTime !== undefined && updatedModel.trackingModel.events) {
              events = updatedModel.trackingModel.events.split(',');
              for (i = 0; i < events.length; i++) {
                event = events[i];
                switch (event) {
                  case 'videoStart':
                    playVideo(interactiveElement);
                    break;
                  case 'videoPause':
                    pauseVideo(interactiveElement);
                    break;
                  case 'videoClose':
                    closeVideo(interactiveElement);
                    break;
                  case 'videoEnd':
                    endVideo(interactiveElement);
                    break;
                }
              }
            } else {
              Debug.info('Interactive Element is missing required properties. The following properties are required:' + '\n\tmediaId\n\tmediaType\n\tduration\n\tcurrentTime\n\ttrackingModel.events');
            }
          } else {
            Debug.info('Interactive Element is missing trackingModel');
          }
        } else {
          Debug.info('TRIGGERED EVENT DISABLED: ', triggerEvent.type);
        }
      });
    }

    /* Will make the specified calls to the s_code media plugin */
    function fireTrackVideo(interactiveElement) {
      var triggerEvent, i, l;
      if (interactiveElement) {
        l = interactiveElement.triggerEvents.length;
        for (i = 0; i < l; i++) {
          triggerEvent = interactiveElement.triggerEvents[i];
          if (triggerEvent.type && triggerEvent.elementSelectors) {
            bindTrackVideo(triggerEvent, interactiveElement);
          }
        }
      }
    }
  }, 'Adapter:SiteCatalyst', 'Framework', 'Debug', 'Exports', 'extend', 'pollForElement', '$', 'consentAugment', 'consentCategoryOverrides');

  /* global inject */
  inject((SiteCatalyst, Analytics, Framework, Debug, Exports, extend, $, isNonEmptyObject, objForEach, getCookie, resolve) => {
    if (!SiteCatalyst) return;
    extend(SiteCatalyst.helper, {
      doesLinkIdExist,
      trackClick,
      trackPage,
      createLinkId,
      filterModelForSiteCatalyst,
      siteCatalystCallCompleteEvent,
      getVisitorId,
      resetArraysForMerge,
      mergeInteractiveElements,
      getSiteCatalystModelFromSemanticModel,
      getSiteCatalystModelFromInteractiveElement
    });
    Object.defineProperty(Exports, 'VisitorId', {
      get: getVisitorId,
      enumerable: true
    });
    function doesLinkIdExist($element) {
      return !!$element.attr('name');
    }
    function trackClick(event, model) {
      var siteCatalystModel;
      if (!Framework.disabledEvents.includes(event)) {
        if (model.pageTransitionLink === true && model.trackingType === 'customLink' && model.linkId) {
          // Resolve Mustache tokens against the source-page model before the linkId
          // is stored in the s_slt cookie; otherwise tokens like {{lob}} survive to
          // the destination page where their values are no longer in context. See GO4-6358.
          model = Analytics.Parsers.parseSemanticModel(model, SiteCatalyst.mapping, true);
          window.s_wdpro.linkTrackTransition(model.linkId);
        } else {
          model = Analytics.Parsers.parseSemanticModel(model, SiteCatalyst.mapping, true);
          siteCatalystModel = filterModelForSiteCatalyst(model, {});
          window.s_wdpro.trackClick({}, model.linkId, siteCatalystModel);
          siteCatalystCallCompleteEvent('trackClick', siteCatalystModel);
        }
      } else {
        Debug.info('trackClick EVENT DISABLED: ', event, model);
      }
    }
    function trackPage(event, model) {
      var objAdditionalVariables, resolvedLinkId;
      if (!Framework.disabledEvents.includes(event)) {
        if (isNonEmptyObject(model)) {
          objAdditionalVariables = getSiteCatalystModelFromSemanticModel(model, Framework.getParentModel());
          if (!model.linkId) model.linkId = '';
          // Use the Mustache-resolved linkId (computed alongside prop9 via
          // mapTo: 'linkId,prop9') as strLinkId for Adobe's s.trackPage. Otherwise the raw
          // model.linkId is passed, runs through Adobe's cleanLinkId (which strips '{' and
          // '}' without doing the substitution), and overwrites the correctly resolved
          // prop9 in objAdditionalVariables. See GO4-6358 for the equivalent fix on
          // trackClick + pageTransitionLink.
          resolvedLinkId = objAdditionalVariables.prop9 || model.linkId;
          window.s_wdpro.trackPage(model.pageId, resolvedLinkId, {}, objAdditionalVariables);
          siteCatalystCallCompleteEvent('trackPage', objAdditionalVariables);
        }
      } else {
        Debug.info('trackPage EVENT DISABLED: ', event, model);
      }
    }
    function createLinkId(event, model) {
      var elem, identifier;
      if (!Framework.disabledEvents.includes(event)) {
        if (model.linkId) {
          identifier = model.linkIdSelectors || model.linkId;
          elem = Framework.getElementByIdOrSelector(identifier);
          if (!doesLinkIdExist($(elem))) {
            $(elem).attr('name', `&lid=${model.linkId}`).on('click', {
              model
            }, function (cEvent) {
              Debug.log('STANDARD LINK TRIGGERED: ', cEvent.data.model);
              Debug.log('CUSTOM LINK EVENTS HAVE NOW BEEN DISABLED');
              Framework.flagDisableCustomLinks = true;
            });
          }
        }
      } else {
        Debug.info('createLinkId EVENT DISABLED: ', event, model);
      }
    }
    function filterModelForSiteCatalyst(model, s) {
      objForEach(model, (val, prop) => {
        var parts, dynVar;
        if (val !== '') {
          //only add relevant items into s_wdpro
          if (prop === 'hier1' || prop === 'pageName' || prop === 'events' || prop === 'state' || prop === 'zip' || prop === 'purchaseID' || prop === 'formList' || prop === 'linkInternalFilters' || prop === 'linkExternalFilters' || prop === 'channelSep' || prop === 'cookieDomainPeriods' || prop === 'currencyCode' || prop === 'cookieLifetime' || prop === 'server' || prop.includes('prop') || prop.includes('eVar') || prop.includes('trackingServer') || /^list[123]$/.test(prop) // SiteCatalyst only supports list1, list2, list3
          ) {
            parts = prop.split('=');
            s[parts[0]] = val;
            dynVar = parts.length > 1 ? `D=${parts[0].replace('prop', 'c').replace('eVar', 'v')}` : '';
            for (var i = 1, numParts = parts.length; i < numParts; i++) {
              /* cut down on duplicate mappings using dynamic variables
                 https://marketing.adobe.com/resources/help/en_US/sc/implement/dynvars_overview.html */
              s[parts[i]] = String(val).length < dynVar.length ? val : dynVar;
            }
          } else if (prop === 'products' && Array.isArray(val)) {
            s.products = val.join(',');
          } else if (prop === 'facetsUtilized' && Array.isArray(val)) {
            s.eVar13 = val.join(',');
            s.prop20 = s.eVar13.length < 5 ? s.eVar13 : 'D=v13';
          } else if (prop === 'facetsProgress' && Array.isArray(val)) {
            s.eVar14 = val.join(',');
          } else if (prop === 'carts' && Array.isArray(val) && val.length > 0) {
            //currently only 1 cart is supported so lets grab the first one
            //map any eVar or prop in that model
            objForEach(val[0], (cVal, cProp) => {
              if (cProp.includes('prop') || cProp.includes('eVar')) s[cProp] = cVal;
            });
          } else if (prop === 'productsCompared' && Array.isArray(val)) {
            s.prop41 = val.join(',');
          }
        }
      });
      if (model.contextData) {
        if (!s.contextData) s.contextData = {};
        objForEach(model.contextData, (val, key) => {
          s.contextData[key.replace(/_/g, '.')] = val;
        });
      }
      return s;
    }
    function siteCatalystCallCompleteEvent(trackingType, dataSent, onCompleteEventName) {
      setTimeout(function () {
        var eventObj = {
          callNumber: ++SiteCatalyst.CALL_NUMBER_COUNTER,
          trackingType,
          dataSent,
          visitorId: getVisitorId()
        };

        //trigger specific call back if specified
        if (onCompleteEventName) {
          Framework.fireEvent({
            event: onCompleteEventName,
            data: eventObj
          });
        }
        //trigger general event
        Framework.fireEvent({
          event: 'siteCatalystCallComplete',
          data: eventObj
        });
        Debug.info('SiteCatalyst Call Completed: ', eventObj);
      }, 500);
    }
    function getVisitorId() {
      var result = null,
        s_vi,
        pattern,
        aVisitorId;

      /**
       * Both the Visitor API Service is present and an instance exists
       */
      if (window.Visitor && window.visitor) {
        result = window.visitor.getMarketingCloudVisitorID();
      } else {
        s_vi = getCookie('s_vi');
        /***
         * Legacy Support
         */

        // check if s_vi cookie is available before proceeding
        if (s_vi !== null && s_vi.length !== 0) {
          /**
           * example of expected value which would match this pattern:
           * "[CS]v1|2759601A85160D22-400001A660000CDD[CE]
           */
          pattern = /\[CS\]v1\|([A-Z0-9-]+)\[CE\]/;
          aVisitorId = pattern.exec(s_vi);
          /**
           * expecting 2 values:
           * aVisitorId[0] = holds matched expression
           * aVisitorId[1] = holds first back reference value which in this case would be the
           * visitor id (i.e. 2759601A85160D22-400001A660000CDD)
           */
          if (aVisitorId.length === 2) {
            result = aVisitorId[1].replace('-', '|'); //
          }
        }
      }
      Debug.info('get Visitor ID Call: ', result);
      return result;
    }
    function resetArraysForMerge(model, updatedModel) {
      var baseProp;
      if (model && updatedModel) {
        for (baseProp in updatedModel) {
          if (updatedModel.hasOwnProperty(baseProp) && Array.isArray(updatedModel[baseProp])) {
            model[baseProp] = [];
          }
        }
      }
    }
    function mergeInteractiveElements(interactiveElement, updatedModel) {
      if (interactiveElement && updatedModel) {
        resetArraysForMerge(interactiveElement.trackingModel, updatedModel.trackingModel);
        extend(true, interactiveElement, updatedModel);
      }
    }
    function getSiteCatalystModelFromSemanticModel(updatedModel, model) {
      var parsedModel;
      if (updatedModel.pageId || updatedModel.siteSection) {
        //get some existing properties that may not have been set in the interactive element
        parsedModel = Framework.mergeModel(updatedModel, model);
      } else {
        parsedModel = model;
      }

      //convert the semantic model to a siteCatalyst model
      parsedModel = Analytics.Parsers.parseSemanticModel(parsedModel, SiteCatalyst.mapping);
      return filterModelForSiteCatalyst(parsedModel, {});
    }
    function getSiteCatalystModelFromInteractiveElement(interactiveElement, model) {
      var siteCatalystModel = {},
        parsedModel;

      /* mediaType and mediaId can be in the main interactiveElement object but it really is
      part of the trackingModel. Let's add it there instead */
      if (interactiveElement.mediaType) {
        interactiveElement.trackingModel = interactiveElement.trackingModel || {};
        interactiveElement.trackingModel.mediaType = interactiveElement.mediaType;
      }
      if (interactiveElement.mediaId) {
        interactiveElement.trackingModel = interactiveElement.trackingModel || {};
        interactiveElement.trackingModel.mediaId = interactiveElement.mediaId;
      }
      if (interactiveElement.trackingModel) {
        if (interactiveElement.trackingModel.pageId || interactiveElement.trackingModel.siteSection) {
          //get some existing properties that may not have been set in the interactive element
          parsedModel = Framework.mergeModel(interactiveElement.trackingModel, model);
        } else {
          parsedModel = interactiveElement.trackingModel;
        }
        resolve('normalize')(parsedModel);
        parsedModel = Analytics.Parsers.parseSemanticModel(parsedModel, SiteCatalyst.mapping, true);
        siteCatalystModel = filterModelForSiteCatalyst(parsedModel, {});
      }
      return siteCatalystModel;
    }
  }, 'Adapter:SiteCatalyst', 'Analytics', 'Framework', 'Debug', 'Exports', 'extend', '$', 'isNonEmptyObject', 'objForEach', 'getCookie', 'resolve');

  /* global inject */
  inject((SiteCatalyst, Parsers, $, moment, sessionStorage, eventmap, productTypeMap, getCookie, getURLParameter) => {
    if (!SiteCatalyst) return;
    SiteCatalyst.mapping = {
      osVersion: {
        mapping: {
          mapTo: 'prop22'
        }
      },
      configuration: {
        formsToTrack: {
          mapping: {
            mapTo: 'formList'
          }
        },
        siteDomains: {
          mapping: {
            mapTo: 'linkInternalFilters'
          }
        },
        externalSiteDomains: {
          mapping: {
            mapTo: 'linkExternalFilters'
          }
        },
        SiteCatalyst: {
          reportSuiteId: {
            mapping: {
              defaultValue: () => window._satellite?.getVar?.('configuration.SiteCatalyst.reportSuiteId') || 'wdgwdprodev'
            }
          },
          trackingServer: {
            mapping: {
              defaultValue: 'w88.go.com'
            }
          },
          trackingServerSecure: {
            mapping: {
              defaultValue: 'sw88.go.com'
            }
          },
          namespace: {
            mapping: {
              defaultValue: 'wdpro'
            }
          },
          cookieDomainPeriods: {
            mapping: {
              defaultValue: '2'
            }
          },
          cookieDomainPeriodRules: [{
            match: {
              mapping: {}
            },
            periods: {
              mapping: {}
            },
            mapping: {
              mapTo: 'cookieDomainPeriodRules'
            }
          }],
          appendReportSuiteIds: {
            mapping: {
              defaultValue: 'true',
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          channelSeparator: {
            mapping: {
              mapTo: 'channelSep',
              defaultValue: '/'
            }
          },
          cookieLifetime: {
            mapping: {
              mapTo: 'cookieLifetime'
            }
          },
          triggerTimeout: {
            mapping: {
              mapTo: 'triggerTimeout'
            }
          },
          offersShownPrefix: {
            mapping: {
              defaultValue: 'SoList;'
            }
          }
        }
      },
      contentLocale: {
        mapping: {
          defaultValue: 'us',
          applyFilter: {
            case: 'lower'
          }
        }
      },
      contentLanguage: {
        mapping: {
          defaultValue: 'en',
          applyFilter: {
            case: 'lower'
          }
        }
      },
      marketingRegion: {
        mapping: {
          applyFilter: {
            case: 'lower'
          }
        }
      },
      currency: {
        mapping: {
          mapTo: 'currencyCode',
          defaultValue: 'USD'
        }
      },
      localization: {
        mapping: {
          type: 'template',
          mapTo: 'prop51',
          template: '{{#marketingRegion}}{{{marketingRegion}}}|{{{contentLanguage}}}-{{{contentLocale}}}' + '{{/marketingRegion}}{{^marketingRegion}}{{{contentLocale}}}/{{{contentLanguage}}}' + '{{/marketingRegion}}'
        }
      },
      site: {
        mapping: {
          mapTo: 'site,eVar10=prop1',
          defaultValue: 'notset'
        }
      },
      storeType: {
        mapping: {
          mapTo: 'storeType'
        }
      },
      store: {
        mapping: {
          mapTo: 'eVar7'
        }
      },
      sailingId: {
        mapping: {
          mapTo: 'eVar78'
        }
      },
      bookedTrips: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== null && val !== undefined) {
                model.events = `${model.events || ''}${model.events ? ',' : ''}event332=${val}`;
              }
            }
          }
        }
      },
      tripIdeas: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== null && val !== undefined) {
                model.events = `${model.events || ''}${model.events ? ',' : ''}event333=${val}`;
              }
            }
          }
        }
      },
      // GO4-5662: Trip Checklist Complete (My Trips feature)
      tripChecklistComplete: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== null && val !== undefined) {
                const eventVal = val ? 1 : 0;
                model.events = `${model.events || ''}${model.events ? ',' : ''}event341=${eventVal}`;
              }
            }
          }
        }
      },
      // GO4-5721: TxP Trip Itinerary variables
      totalPlans: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== null && val !== undefined) {
                model.events = `${model.events || ''}${model.events ? ',' : ''}event336=${val}`;
                model.eVar105 = String(val);
              }
            }
          }
        }
      },
      bookedPlans: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== null && val !== undefined) {
                model.events = `${model.events || ''}${model.events ? ',' : ''}event334=${val}`;
              }
            }
          }
        }
      },
      resortCheckinStatus: {
        mapping: {
          type: 'flex-array',
          mapTo: 'eVar159'
        }
      },
      // GO4-6659: TripID (My Trips feature)
      tripId: {
        mapping: {
          type: 'flex-array',
          mapTo: 'eVar169'
        }
      },
      parkAdmissionPresent: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== null && val !== undefined) {
                model.events = `${model.events || ''}${model.events ? ',' : ''}event337=${val}`;
              }
            }
          }
        }
      },
      parkAdmissionNoAdmission: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== null && val !== undefined) {
                model.events = `${model.events || ''}${model.events ? ',' : ''}event338=${val}`;
              }
            }
          }
        }
      },
      parkAdmissionGetTicketsReady: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== null && val !== undefined) {
                model.events = `${model.events || ''}${model.events ? ',' : ''}event339=${val}`;
              }
            }
          }
        }
      },
      parkAdmissionUseMagicband: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== null && val !== undefined) {
                model.events = `${model.events || ''}${model.events ? ',' : ''}event340=${val}`;
              }
            }
          }
        }
      },
      tripNameCustomized: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== null && val !== undefined) {
                const eventVal = val ? 1 : 0;
                model.events = `${model.events || ''}${model.events ? ',' : ''}event343=${eventVal}`;
              }
            }
          }
        }
      },
      // GO4-4968: Trip Party guest counts
      tripParty: {
        managed: {
          mapping: {}
        },
        pending: {
          mapping: {}
        },
        total: {
          mapping: {}
        },
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val && typeof val === 'object') {
                let {
                  managed,
                  pending,
                  total
                } = val;
                const [hasManaged, hasPending, hasTotal] = [hasValue(managed), hasValue(pending), hasValue(total)];

                // Only process if at least one property is defined
                if (!hasManaged && !hasPending && !hasTotal) {
                  return;
                }

                // Calculate total if not provided: managed + pending + 1 (for owner/self)
                // If total is provided, trust it
                if (!hasTotal) {
                  total = (managed || 0) + (pending || 0) + 1;
                }
                if (hasManaged) {
                  model.events = `${model.events || ''}${model.events ? ',' : ''}event329=${managed}`;
                }
                if (hasPending) {
                  model.events = `${model.events || ''}${model.events ? ',' : ''}event330=${pending}`;
                }
                model.events = `${model.events || ''}${model.events ? ',' : ''}event331=${total}`;
                model.eVar104 = String(total);
              }
              function hasValue(value) {
                return value !== undefined && value !== null;
              }
            }
          }
        }
      },
      trackingType: {
        mapping: {
          defaultValue: 'standardPage'
        }
      },
      events: {
        mapping: {
          type: 'flex-array',
          valueDelimiter: '=',
          mapTo: eventmap
        }
      },
      claimContext: {
        mapping: {}
      },
      siteSection: {
        mapping: {
          defaultValue: 'notset',
          applyFilter: {
            case: 'lower',
            replace: [['&amp;', 'and'], ['&', 'and'], ['[^a-zA-Z0-9{}/]', '']]
          }
        }
      },
      // GO4-6736: _legacyHier1Site is a backcompat-only passthrough consumed
      // by the hierarchy template's lcSite transformer. Must appear before
      // `hierarchy` so the passthrough populates result._legacyHier1Site
      // before the template renders. Do not set from application code.
      _legacyHier1Site: {
        mapping: {
          mapTo: '_legacyHier1Site'
        }
      },
      hierarchy: {
        mapping: {
          type: 'template',
          reprocessOnUpdate: true,
          template: '{{#namespace}}{{{namespace}}}/{{{lcSite}}}/{{#marketingRegion}}' + '{{{marketingRegion}}}{{/marketingRegion}}{{^marketingRegion}}{{{contentLocale}}}' + '{{/marketingRegion}}/{{{contentLanguage}}}/{{{siteSection}}}{{/namespace}}',
          transformers: {
            // _legacyHier1Site is a backcompat-only override populated by
            // the passthrough entry above (GO4-6736). When set, it wins
            // over site.toLowerCase() so the reverse-mapped legacy pixel
            // keeps its exact hier1 site segment.
            lcSite: result => {
              if (result._legacyHier1Site) return result._legacyHier1Site;
              if (result.site) return result.site.toLowerCase();
            }
          },
          mapTo: 'hierarchy,hier1'
        }
      },
      pageId: {
        mapping: {
          type: 'template',
          template: '{{#hierarchy}}{{{hierarchy}}}/{{{pageId}}}{{/hierarchy}}',
          mapTo: 'pageName',
          defaultValue: 'notset',
          applyFilter: {
            type: 'string',
            case: 'lower',
            replace: [['[^a-zA-Z0-9]', '']]
          }
        }
      },
      stepProgress: {
        current: {
          mapping: {
            mapTo: 'currentStep'
          }
        },
        total: {
          mapping: {
            mapTo: 'totalSteps'
          }
        },
        mapping: {
          transformers: {
            preProcess: model => {
              if (model.currentStep && model.totalSteps) {
                model.pageName += '/' + model.currentStep + '_' + model.totalSteps;
              }
            }
          }
        }
      },
      pageVariant: {
        mapping: {
          mapTo: 'prop56'
        }
      },
      flow: {
        mapping: {
          mapTo: 'eVar151'
        }
      },
      toggleStatus: {
        mapping: {
          type: 'template',
          mapTo: 'toggles',
          template: '{{#toggleStatus}}{{#ft}},{{{ft}}}{{/ft}}{{#rt}},{{{rt}}}{{/rt}}{{#flt}},{{{flt}}}{{/flt}}{{/toggleStatus}}',
          transformers: {
            ft: model => {
              var toggles = [],
                toggle,
                featureToggles;
              if (model.toggleStatus && model.toggleStatus.featureToggles) {
                featureToggles = model.toggleStatus.featureToggles;
                for (toggle in featureToggles) {
                  if (featureToggles.hasOwnProperty(toggle)) {
                    toggles.push('ft;' + toggle + ':' + featureToggles[toggle]);
                  }
                }
              }
              return toggles.join(',');
            },
            rt: model => {
              var toggles = [],
                toggle,
                releaseToggles;
              if (model.toggleStatus && model.toggleStatus.releaseToggles) {
                releaseToggles = model.toggleStatus.releaseToggles;
                for (toggle in releaseToggles) {
                  if (releaseToggles.hasOwnProperty(toggle)) {
                    toggles.push('rt;' + toggle + ':' + releaseToggles[toggle]);
                  }
                }
              }
              return toggles.join(',');
            },
            flt: model => {
              var toggles = [],
                toggle,
                flowToggles;
              if (model.toggleStatus && model.toggleStatus.flowToggles) {
                flowToggles = model.toggleStatus.flowToggles;
                for (toggle in flowToggles) {
                  if (flowToggles.hasOwnProperty(toggle)) {
                    toggles.push('flt;' + toggle + ':' + flowToggles[toggle]);
                  }
                }
              }
              return toggles.join(',');
            }
          }
        }
      },
      contentDisplayed: {
        mapping: {
          type: 'template',
          template: '{{{contentDisplayed}}}{{#toggles}}{{{toggles}}}{{/toggles}}',
          mapTo: 'eVar24=prop19'
        }
      },
      elementAnalyticsId: {
        mapping: {
          mapTo: 'prop9'
        }
      },
      leadType: {
        mapping: {
          mapTo: 'eVar23'
        }
      },
      errorCodes: {
        mapping: {
          mapTo: 'eVar22=prop26=prop27',
          applyFilter: {
            unique: ',',
            replace: [[' ', '']]
          }
        }
      },
      linkId: {
        mapping: {
          mapTo: 'linkId,prop9'
        }
      },
      regionId: {
        mapping: {
          mapTo: 'objectID'
        }
      },
      registrationTemplateId: {
        mapping: {
          mapTo: 'eVar40'
        }
      },
      siteType: {
        mapping: {
          mapTo: 'prop32'
        }
      },
      customerId: {
        mapping: {
          mapTo: 'prop2,customerId',
          defaultValue: 'D=SWID'
        }
      },
      guestType: {
        mapping: {
          mapTo: 'guestType'
        }
      },
      experienceId: {
        mapping: {
          type: 'template',
          template: '{{#experienceId}}{{{guestType}}}:{{{experienceId}}}:{{{customerId}}}{{/experienceId}}',
          mapTo: 'prop4'
        }
      },
      thirdPartyId: {
        mapping: {
          mapTo: 'eVar113'
        }
      },
      callCenterId: {
        mapping: {
          mapTo: 'eVar140'
        }
      },
      partnerId: {
        type: {
          mapping: {}
        },
        id: {
          mapping: {}
        },
        instance: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: model => {
            if (model.type || model.id || model.instance) {
              return '{{{type}}};{{{id}}};{{{instance}}}';
            }
            return '';
          },
          mapTo: 'eVar52',
          transformers: {
            preProcess: model => {
              if (model.storeType && model.storeType.toLowerCase().includes('travelagent')) {
                model.eVar6 = model.id;
              }
            }
          }
        }
      },
      DTALoginId: {
        mapping: {
          mapTo: 'eVar6'
        }
      },
      alternateAggregation: {
        mapping: {
          mapTo: 'prop49'
        }
      },
      selfServiceType: {
        mapping: {
          type: 'flex-array',
          targetDelimiter: '|',
          mapTo: 'eVar51'
        }
      },
      chatSessionId: {
        mapping: {
          mapTo: 'prop47'
        }
      },
      memberNumber: {
        mapping: {
          mapTo: 'prop25'
        }
      },
      registrationStatus: {
        mapping: {
          mapTo: 'prop29'
        }
      },
      /* homeCountry: {
          mapping: {
              mapTo: 'country'
          }
      }, */
      homeState: {
        mapping: {
          mapTo: 'state'
        }
      },
      homeCity: {
        mapping: {
          mapTo: 'eVar29'
        }
      },
      homeZip: {
        mapping: {
          mapTo: 'zip'
        }
      },
      departureCity: {
        mapping: {
          mapTo: 'eVar30'
        }
      },
      guestLifeStage: {
        mapping: {
          mapTo: 'prop30'
        }
      },
      guestAffiliations: {
        mapping: {
          type: 'flex-array',
          mapTo: 'eVar59=prop14',
          applyFilter: {
            replace: [[' ', '']],
            unique: ',',
            alpha: 'asc'
          }
        }
      },
      affiliationsAvailable: {
        mapping: {
          mapTo: 'prop13',
          applyFilter: {
            alpha: 'asc',
            replace: [[' ', '']]
          }
        }
      },
      internalSearchKeywords: {
        mapping: {
          mapTo: 'eVar4=prop7',
          applyFilter: {
            case: 'lower'
          }
        }
      },
      internalSearchNumResults: {
        mapping: {
          mapTo: 'prop8'
        }
      },
      internalSearchType: {
        mapping: {
          mapTo: 'eVar5'
        }
      },
      bookingSearchNumResults: {
        mapping: {
          mapTo: 'eVar35'
        }
      },
      bookingSearchDaysBetweenSearchAndArrival: {
        mapping: {
          mapTo: 'eVar31=prop15',
          applyFilter: {
            type: 'string'
          }
        }
      },
      bookingSearchArrivalDate: {
        mapping: {
          mapTo: 'eVar32=prop16',
          applyFilter: {
            date: {}
          }
        }
      },
      bookingSearchLengthOfStayNights: {
        mapping: {
          mapTo: 'eVar33=prop17'
        }
      },
      bookingSearchChildrenAges: {
        mapping: {
          type: 'flex-array',
          targetDelimiter: ':',
          mapTo: 'eVar122'
        }
      },
      bookingSearchAdults: {
        mapping: {
          defaultValue: '0'
        }
      },
      bookingSearchChildren: {
        mapping: {
          defaultValue: '0'
        }
      },
      bookingSearchInfants: {
        mapping: {
          defaultValue: '0'
        }
      },
      bookingSearchSeniors: {
        mapping: {
          defaultValue: '0',
          reprocessOnUpdate: true
        }
      },
      bookingSearchPartySize: {
        mapping: {
          mapTo: 'eVar34=prop18'
        }
      },
      bookingSearchParty: {
        mapping: {
          type: 'template',
          reprocessOnUpdate: true,
          template: '{{#bookingSearchPartyTotal}}{{{bookingSearchPartyTotal}}}:' + '{{{bookingSearchAdults}}}A:{{{bookingSearchChildren}}}C:{{{bookingSearchInfants}}}I:' + '{{{bookingSearchSeniors}}}S{{/bookingSearchPartyTotal}}',
          mapTo: 'eVar34=prop18',
          transformers: {
            bookingSearchPartyTotal: model => {
              if (!isNaN(model.bookingSearchAdults) && !isNaN(model.bookingSearchChildren) && !isNaN(model.bookingSearchInfants) && !isNaN(model.bookingSearchSeniors)) {
                return Number(model.bookingSearchAdults) + Number(model.bookingSearchChildren) + Number(model.bookingSearchInfants) + Number(model.bookingSearchSeniors);
              }
            }
          }
        }
      },
      partyEligibility: {
        mapping: {
          mapTo: 'eVar111'
        }
      },
      bookingSearchResort: {
        mapping: {
          mapTo: 'prop11'
        }
      },
      bookingSearchDeparturePort: {
        mapping: {}
      },
      bookingSearchShip: {
        mapping: {
          type: 'template',
          template: '{{#bookingSearchDeparturePort}}{{{bookingSearchDeparturePort}}}:{{{bookingSearchShip}}}{{/bookingSearchDeparturePort}}',
          mapTo: 'prop11'
        }
      },
      bookingSearchNumRooms: {
        mapping: {
          mapTo: 'eVar77'
        }
      },
      search: {
        time: {
          start: {
            mapping: {}
          },
          end: {
            mapping: {}
          },
          duration: {
            mapping: {
              mapTo: 'eVar163',
              applyFilter: {
                oneDecimal: val => Number(val).toFixed(1)
              }
            }
          },
          mapping: {
            mapTo: 'eVar168',
            type: 'template',
            template: '{{{start}}}{{#start}}{{#end}}-{{/end}}{{/start}}{{{end}}}'
          }
        }
      },
      bookedPartySize: {
        mapping: {
          mapTo: 'eVar16'
        }
      },
      facetsUtilized: [{
        name: {
          mapping: {}
        },
        action: {
          mapping: {
            defaultValue: 'Add'
          }
        },
        mapping: {
          type: 'template',
          template: '{{#name}}{{{action}}}:{{{name}}}{{/name}}'
        }
      }],
      facetsProgress: [{
        name: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{#name}}{{{name}}}{{/name}}'
        }
      }],
      orderId: {
        mapping: {
          mapTo: 'purchaseID'
        }
      },
      itineraryDay: {
        mapping: {}
      },
      itineraryLength: {
        mapping: {
          type: 'template',
          template: '{{#itineraryDay}}{{{itineraryDay}}}:{{{itineraryLength}}}{{/itineraryDay}}',
          mapTo: 'eVar58=prop34'
        }
      },
      itineraryType: {
        mapping: {
          mapTo: 'prop71'
        }
      },
      totalBookedLengthOfStayNights: {
        mapping: {}
      },
      pointsSpent: {
        mapping: {
          mapTo: 'eVar42'
        }
      },
      pointsBudget: {
        mapping: {
          mapTo: 'eVar43'
        }
      },
      carts: [{
        friendlyId: {
          mapping: {}
        },
        id: {
          mapping: {
            type: 'template',
            mapTo: 'eVar47',
            template: '{{#id}}{{{id}}}:{{{friendlyId}}}{{/id}}'
          }
        },
        age: {
          mapping: {}
        },
        status: {
          mapping: {}
        },
        changeType: {
          mapping: {}
        },
        isGift: {
          mapping: {
            transformers: {
              preProcess: (model, parentModel, val) => {
                parentModel.gift = Parsers.toBoolean(val) ? 'Gift' : '';
              }
            }
          }
        },
        mapping: {
          type: 'template',
          template: '{{#age}}{{{age}}}{{/age}}:{{#status}}{{{status}}}{{/status}}:{{#changeType}}{{{changeType}}}{{/changeType}}',
          mapTo: 'eVar45'
        }
      }],
      payment: {
        type: {
          mapping: {}
        },
        paymentAmount: {
          mapping: {}
        },
        totalPrice: {
          mapping: {}
        },
        paymentFrequency: {
          mapping: {}
        },
        paymentMethods: [{
          type: {
            mapping: {
              postFilter: {
                list: 'creditCard,giftCard,rewardsCard,pointsPayment,instantCredit,digitalWallet'
              }
            }
          },
          name: {
            mapping: {
              applyFilter: {
                case: 'lower',
                replace: [[' ', '']]
              }
            }
          },
          status: {
            mapping: {
              defaultValue: 'unknown',
              postFilter: {
                replace: [['saved', 'stored', 'i']],
                list: 'new,stored'
              }
            }
          },
          mapping: {
            transformers: {
              preProcess: ({
                type,
                name,
                status
              }, parentModel) => {
                if (parentModel && type) {
                  parentModel.paymentInfo || (parentModel.paymentInfo = {});
                  parentModel.paymentInfo[type] = {
                    name,
                    status
                  };
                }
              }
            }
          }
        }],
        mapping: {
          type: 'template',
          template: model => {
            if (model.type || model.paymentAmount || model.totalPrice || model.gift) {
              return '{{type}}:{{paymentAmount}}:{{totalPrice}}:{{pctPaid}}:{{gift}}';
            }
            return '';
          },
          mapTo: 'prop54',
          transformers: {
            pctPaid: model => {
              if (model.paymentAmount && model.totalPrice) {
                return (model.paymentAmount / model.totalPrice).toFixed(2);
              }
              return '';
            }
          }
        }
      },
      paymentInfo: {
        mapping: {
          type: 'template',
          template: '{{#paymentInfo}}' + '{{#creditCard.name}}{{{creditCard.name}}}_{{#creditCard.status}}{{{creditCard.status}}}{{/creditCard.status}}{{/creditCard.name}}' + ':{{#giftCard.name}}{{{giftCard.name}}}_{{#giftCard.status}}{{{giftCard.status}}}{{/giftCard.status}}{{/giftCard.name}}' + ':{{#rewardsCard.name}}{{{rewardsCard.name}}}_{{#rewardsCard.status}}{{{rewardsCard.status}}}{{/rewardsCard.status}}{{/rewardsCard.name}}' + ':{{#pointsPayment.name}}{{{pointsPayment.name}}}_{{#pointsPayment.status}}{{{pointsPayment.status}}}{{/pointsPayment.status}}{{/pointsPayment.name}}' + ':{{#instantCredit.name}}{{{instantCredit.name}}}_{{#instantCredit.status}}{{{instantCredit.status}}}{{/instantCredit.status}}{{/instantCredit.name}}' + ':{{#digitalWallet.name}}{{{digitalWallet.name}}}_{{#digitalWallet.status}}{{{digitalWallet.status}}}{{/digitalWallet.status}}{{/digitalWallet.name}}' + '{{/paymentInfo}}',
          mapTo: 'paymentInfo'
        }
      },
      disneyWallet: {
        mapping: {
          mapTo: 'eVar126',
          postFilter: {
            replace: [[' ', '']],
            list: 'NoThanks,AddCards,EnterOwn',
            prefix: val => val ? `wallet${val}` : undefined
          }
        }
      },
      personalizations: [{
        locationShortName: {
          mapping: {
            mapTo: 'locationShortName'
          }
        },
        // decision engine that was used to choose experience
        customerGroup: {
          mapping: {
            mapTo: 'customerGroup'
          }
        },
        optionId: {
          mapping: {
            mapTo: 'optionId'
          }
        },
        options: [{
          optionId: {
            mapping: {
              mapTo: 'multiOptionId'
            }
          },
          mapping: {
            type: 'template',
            targetDelimiter: ',',
            mapTo: 'options',
            rollUp: true,
            template: '{{{multiOptionId}}}'
          }
        }],
        mapping: {
          type: 'template',
          targetDelimiter: ';',
          mapTo: 'prop60',
          rollUp: true,
          applyFilter: {
            forceArray: ''
          },
          template: '{{#locationShortName}}{{#customerGroup}}' + '{{{customerGroup}}}:{{{locationShortName}}}:' + '{{#optionId}}{{{optionId}}}{{/optionId}}' + '{{#options}}{{{options}}}{{/options}}' + '{{/customerGroup}}{{/locationShortName}}',
          transformers: {
            preProcess: (model, parentModel) => {
              var group, prop;
              if (!parentModel.personalizationGroup) {
                prop = SiteCatalyst.mapping.personalizationGroup.mapping.mapTo;
                if (!parentModel.personalizationGroup && model.customerGroup === 'c') {
                  group = 'Control';
                } else if (!parentModel.personalizationGroup) {
                  group = 'Personalized';
                }
                parentModel.personalizationGroup = group;
                parentModel[prop] = group;
              }
            }
          }
        }
      }],
      vpcSegment: {
        mapping: {
          mapTo: 'eVar71'
        }
      },
      personalizationGroup: {
        mapping: {
          mapTo: 'prop61'
        }
      },
      personalizationClick: {
        locationShortName: {
          mapping: {
            mapTo: 'locationShortName'
          }
        },
        // decision engine that was used to choose experience
        customerGroup: {
          mapping: {
            mapTo: 'customerGroup'
          }
        },
        optionId: {
          mapping: {
            mapTo: 'optionId'
          }
        },
        options: [{
          optionId: {
            mapping: {
              mapTo: 'multiOptionId'
            }
          },
          mapping: {
            type: 'template',
            targetDelimiter: ',',
            mapTo: 'options',
            rollUp: true,
            template: '{{{multiOptionId}}}'
          }
        }],
        mapping: {
          type: 'template',
          targetDelimiter: ';',
          mapTo: 'prop62,eVar70',
          rollUp: true,
          template: '{{#locationShortName}}{{{customerGroup}}}:{{{locationShortName}}}:' + '{{#optionId}}{{{optionId}}}{{/optionId}}{{#options}}{{{options}}}{{/options}}{{/locationShortName}}'
        }
      },
      interactiveElements: [{
        trackingType: {
          mapping: {
            applyFilter: {
              replace: [['^\\s*"*\\s*|\\s*"*\\s*$', '']]
            }
          }
        },
        mediaType: {
          mapping: {}
        },
        mediaId: {
          mapping: {}
        },
        linkId: {
          mapping: {
            applyFilter: {
              replace: [['^\\s*"*\\s*|\\s*"*\\s*$', '']]
            }
          }
        },
        linkIdSelectors: {
          mapping: {
            applyFilter: {
              replace: [['^\\s*"*\\s*|\\s*"*\\s*$', '']]
            }
          }
        },
        regionId: {
          mapping: {}
        },
        trackingModel: {
          mapping: {}
        },
        triggerEvents: [{
          type: {
            mapping: {}
          },
          elementSelectors: {
            mapping: {}
          },
          onCompleteEventName: {
            mapping: {}
          }
        }],
        trackPromoImpressions: {
          mapping: {
            type: 'template',
            template: 'false',
            defaultValue: false,
            transformers: {
              /* will add items that are specified in the promoImpressions list*/
              preProcess: (model, parentModel) => {
                if (Parsers.toBoolean(model.trackPromoImpressions) && model.linkId) {
                  //make sure the selector is an actual item on the page
                  if ($(model.linkIdSelectors).length > 0 || Array.isArray(model.triggerEvents) && $(model.triggerEvents[0].elementSelectors).length > 0) {
                    //save this information in the parentModel as trackPromoImpressions
                    if (!parentModel.trackPromoImpressions) {
                      parentModel.trackPromoImpressions = model.linkId;
                    } else {
                      parentModel.trackPromoImpressions += ',' + model.linkId;
                    }
                  }
                }
              }
            }
          }
        },
        mapping: {
          type: 'none',
          applyFilter: {
            forceArray: ''
          }
        }
      }],
      /*must be after interactiveElements since trackPromoImpressions will automatically add to this list*/
      promoImpressionsList: {
        mapping: {
          type: 'template',
          template: '{{#promoImpressions}}{{promoImpressions}}{{/promoImpressions}}',
          transformers: {
            promoImpressions: model => {
              // put what is in promoImpressionsList togther with what was potentially from the
              // interactiveElements
              if (model.promoImpressionsList && model.trackPromoImpressions) {
                model.promoImpressionsList += ',' + model.trackPromoImpressions;
              } else if (model.trackPromoImpressions) {
                model.promoImpressionsList = model.trackPromoImpressions;
              }
              return model.promoImpressionsList;
            }
          },
          mapTo: 'eVar9'
        }
      },
      mediaCount: {
        mapping: {
          mapTo: 'prop73'
        }
      },
      mediaType: {
        mapping: {}
      },
      mediaId: {
        mapping: {
          type: 'template',
          template: '{{#mediaId}}{{{mediaType}}}:{{{mediaId}}}{{/mediaId}}',
          mapTo: 'eVar2=prop3'
        }
      },
      mediaViewed: {
        id: {
          mapping: {
            mapTo: 'mv.id',
            transformers: {
              preProcess: (model, parent, val) => {
                var e1, e2;
                if (val) {
                  e1 = 'event100:' + val;
                  e2 = 'event101';
                  switch (typeof model.events) {
                    case 'string':
                      model.events += (model.events ? ',' : '') + e1 + ',' + e2;
                      break;
                    case 'object':
                      model.events.push(e1, e2);
                      break;
                    case 'undefined':
                      model.events = e1 + ',' + e2;
                      break;
                  }
                }
              }
            }
          }
        },
        type: {
          mapping: {
            mapTo: 'mv.type'
          }
        },
        captureDateTime: {
          mapping: {
            mapTo: 'captureDateTime',
            transformers: {
              preProcess: (model, parentModel, val) => {
                var m;
                if (val) {
                  m = moment.utc(val);
                  model.mv = model.mv || {};
                  model.mv.captureDate = m.format('YYYY/MM/DD');
                  model.mv.captureTime = m.format('h:mmA');
                  model.mv.viewWindow = moment().diff(m, 'days');
                }
              }
            }
          }
        },
        campus: {
          mapping: {
            mapTo: 'mv.campus'
          }
        },
        venue: {
          mapping: {
            mapTo: 'mv.venue',
            applyFilter: {
              case: 'title',
              replace: [[' ', '']]
            }
          }
        },
        location: {
          mapping: {
            mapTo: 'mv.location',
            applyFilter: {
              case: 'title',
              replace: [[' ', '']]
            }
          }
        },
        subjects: {
          mapping: {
            defaultValue: 'Guest',
            type: 'flex-array',
            mapTo: 'mv.subjects',
            applyFilter: {
              case: 'title'
            }
          }
        },
        mapping: {
          type: 'template',
          mapTo: 'eVar74',
          template: '{{#mv.captureDate}}{{{mv.captureDate}}};{{{mv.captureTime}}};{{{mv.viewWindow}}};' + '{{{mv.campus}}};{{{mv.venue}}};{{{mv.location}}};{{mv.subjects}}{{/mv.captureDate}}'
        }
      },
      // GO4-4931: composite offerId → eVar49 (LOB:productSpace:productType:usageWindow:offerName)
      // Composite format used only when app provides 2+ fields; single value passes through unchanged.
      offerId: {
        lob: {
          mapping: {
            mapTo: '_offerLob'
          }
        },
        productSpace: {
          mapping: {
            mapTo: '_offerProductSpace'
          }
        },
        productType: {
          mapping: {
            mapTo: '_offerProductType'
          }
        },
        usageWindow: {
          mapping: {
            mapTo: '_offerUsageWindow'
          }
        },
        offerName: {
          mapping: {
            mapTo: '_offerName'
          }
        },
        mapping: {
          type: 'template',
          mapTo: 'eVar49,offerId',
          template: result => {
            const offer = result.offerId;
            if (!offer?.offerName) return '';
            if (Object.keys(offer).length < 2) return '{{{_offerName}}}';
            result._offerLob ||= (result.site || '').toUpperCase() || 'Null';
            result._offerProductSpace ??= offer.productSpace ?? 'Null';
            result._offerProductType ??= offer.productType ?? 'Null';
            result._offerUsageWindow ??= offer.usageWindow ?? 'Null';
            return '{{{_offerLob}}}:{{{_offerProductSpace}}}:{{{_offerProductType}}}:{{{_offerUsageWindow}}}:{{{_offerName}}}';
          }
        }
      },
      offersShownPrefix: {
        mapping: {
          mapTo: 'offersShownPrefix'
        }
      },
      offersShown: [{
        id: {
          mapping: {}
        },
        isAvailable: {
          mapping: {
            defaultValue: 'u'
          }
        },
        reason: {
          mapping: {}
        },
        price: {
          mapping: {
            defaultValue: 'NA'
          }
        },
        mapping: {
          mapTo: '_'
        }
      }],
      _sc_v53: {
        mapping: {
          type: 'template',
          template: '{{#_sc_v53}}{{offersShownPrefix}}{{_sc_v53}}{{/_sc_v53}}',
          mapTo: 'eVar53',
          defaultValue: ({
            offersShown
          }) => {
            if (Array.isArray(offersShown)) {
              const value = offersShown.map(({
                id
              }) => id).join(';');
              // if value is not only semicolons and colons, return it
              if (/[^;:]/.test(value)) return value;
            }
          },
          reprocessOnUpdate: true
        }
      },
      pinnedOffer: {
        type: {
          mapping: {}
        },
        code: {
          mapping: {}
        },
        criteria: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{#code}}{{{type}}};{{{code}}};{{{criteria}}}{{/code}}',
          mapTo: 'prop50'
        }
      },
      socialInteractionType: {
        mapping: {
          applyFilter: {
            replace: [[' ', '']]
          },
          mapTo: model => {
            //make sure event6 is set and eVar60 contains the value set in socialInteractionType
            var eventNum = 'event6';
            if (!model.events) {
              model.events = eventNum;
            } else if (!model.events.includes(eventNum)) {
              model.events += ',' + eventNum;
            }

            //now return eVar60 so that the value is mapped to it
            return 'eVar60';
          }
        }
      },
      pageType: {
        mapping: {}
      },
      _pre_products: {
        mapping: {
          mapTo: '_reservation_index',
          defaultValue: 1
        }
      },
      products: [{
        name: {
          mapping: {
            mapTo: 'name'
          }
        },
        productType: {
          mapping: {
            defaultValue: 'prod',
            mapTo: productTypeMap
          }
        },
        productId: {
          mapping: {
            mapTo: ({
              productType
            }) => isTicket(productType) ? 'ticketId' : 'productId'
          }
        },
        _sc_product_string_name: {
          mapping: {
            mapTo: ({
              productType
            }) => isTicket(productType) ? 'altTicketId' : 'altProductId',
            defaultValue: ({
              name
            }) => name,
            applyFilter: {
              replace: [['[^a-z0-9 /-]', '', 'gi'], ['^\\s+|\\s+$', ''], [' ', '_']]
            }
          }
        },
        facilityId: {
          mapping: {}
        },
        sailingId: {
          mapping: {
            mapTo: 'eVar78'
          }
        },
        packageType: {
          mapping: {}
        },
        roomTypeId: {
          mapping: {}
        },
        portId: {
          mapping: {}
        },
        themePrefix: {
          mapping: {
            defaultValue: m => m.eVar78 || m.portId ? 'CruiseTheme' : 'Theme'
          }
        },
        themeSeparator: {
          mapping: {
            defaultValue: ':'
          }
        },
        theme: {
          mapping: {
            mapTo: 'eVar37',
            type: 'template',
            template: '{{#theme}}{{#themePrefix}}{{themePrefix}}{{themeSeparator}}{{/themePrefix}}{{theme}}{{/theme}}'
          }
        },
        transactionDetail: {
          mapping: {
            mapTo: 'eVar37'
          }
        },
        includedProducts: [{
          type: {
            mapping: {
              defaultValue: 'ticket'
            }
          },
          id: {
            mapping: {
              mapTo: 'ticketId'
            }
          },
          name: {
            mapping: {
              mapTo: 'altTicketId',
              applyFilter: {
                replace: [['[^a-z0-9 /-]', '', 'gi'], ['^\\s+|\\s+$', ''], [' ', '_']]
              }
            }
          },
          price: {
            mapping: {
              mapTo: 'event17'
            }
          },
          quantity: {
            mapping: {
              mapTo: model => 'event18' + (model.type === 'ticket' ? ',ticketQuantity' : '')
            }
          },
          days: {
            mapping: {
              mapTo: model => model.type === 'ticket' ? 'ticketDays' : ''
            }
          },
          mapping: {
            mapTo: 'includedProducts',
            applyFilter: {
              removeElement: {
                keys: ['type'],
                values: ['diningPlan']
              }
            }
          }
        }],
        bookingSearchDaysBetweenSearchAndArrival: {
          mapping: {
            mapTo: 'eVar31,^^eVar31=prop15',
            applyFilter: {
              type: 'string'
            }
          }
        },
        bookingSearchArrivalDate: {
          mapping: {
            mapTo: model => canHaveUseDates(model.productType) ? 'bookingSearchArrivalDate' : '^^eVar32=prop16',
            applyFilter: {
              date: {}
            }
          }
        },
        bookingSearchLengthOfStayNights: {
          mapping: {
            mapTo: 'bookingSearchLengthOfStayNights'
          }
        },
        bookingSearchChildrenAges: {
          mapping: {
            type: 'flex-array',
            targetDelimiter: ':',
            mapTo: 'eVar122,^^eVar122'
          }
        },
        bookingSearchAdults: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookingSearchChildren: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookingSearchInfants: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookingSearchSeniors: {
          mapping: {
            defaultValue: '0',
            reprocessOnUpdate: true
          }
        },
        bookingSearchParty: {
          mapping: {
            type: 'template',
            template: '{{#bookingSearchPartyTotal}}{{{bookingSearchPartyTotal}}}:' + '{{{bookingSearchAdults}}}A:{{{bookingSearchChildren}}}C:{{{bookingSearchInfants}}}I:' + '{{{bookingSearchSeniors}}}S{{/bookingSearchPartyTotal}}',
            mapTo: 'eVar34,^^eVar34=prop18',
            transformers: {
              bookingSearchPartyTotal: model => {
                if (!isNaN(model.bookingSearchAdults) && !isNaN(model.bookingSearchChildren) && !isNaN(model.bookingSearchInfants) && !isNaN(model.bookingSearchSeniors)) {
                  return Number(model.bookingSearchAdults) + Number(model.bookingSearchChildren) + Number(model.bookingSearchInfants) + Number(model.bookingSearchSeniors);
                }
              }
            }
          }
        },
        bookingSearchNumRooms: {
          mapping: {
            mapTo: 'eVar77'
          }
        },
        bookedChildrenAges: {
          mapping: {
            type: 'flex-array',
            targetDelimiter: ':',
            mapTo: 'prop38,^^prop38'
          }
        },
        bookedAdults: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedChildren: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedInfants: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedSeniors: {
          mapping: {
            defaultValue: '0',
            reprocessOnUpdate: true
          }
        },
        bookedParty: {
          mapping: {
            type: 'template',
            template: '{{#bookedPartyTotal}}{{{bookedPartyTotal}}}:{{{bookedAdults}}}' + 'A:{{{bookedChildren}}}C:{{{bookedInfants}}}I:{{{bookedSeniors}}}S{{/bookedPartyTotal}}',
            mapTo: 'eVar16',
            transformers: {
              bookedPartyTotal: model => {
                if (!isNaN(model.bookedAdults) && !isNaN(model.bookedChildren) && !isNaN(model.bookedInfants && !isNaN(model.bookedSeniors))) {
                  return Number(model.bookedAdults) + Number(model.bookedChildren) + Number(model.bookedInfants) + Number(model.bookedSeniors);
                }
              }
            }
          }
        },
        bookedArrivalDate: {
          mapping: {
            mapTo: model => canHaveUseDates(model.productType) ? 'eVar18,bookedArrivalDate' : 'eVar18,^^eVar18',
            applyFilter: {
              date: {}
            }
          }
        },
        bookedLengthOfStayNights: {
          mapping: {
            mapTo: 'bookedLengthOfStayNights'
          }
        },
        bookedTimeOfDay: {
          mapping: {
            mapTo: 'eVar67'
          }
        },
        quantity: {
          mapping: {
            mapTo: model => 'quantity,event321' + (isTicket(model.productType) ? ',ticketQuantity' : '')
          }
        },
        price: {
          total: {
            mapping: {
              mapTo: 'totalPrice,event320'
            }
          }
        },
        previousPrice: {
          total: {
            mapping: {
              mapTo: (model, _, val) => {
                if (val !== model.totalPrice) return 'event322';
              }
            }
          }
        },
        changeStatus: {
          mapping: {
            mapTo: 'eVar136'
          }
        },
        _priceDifferential: {
          mapping: {
            defaultValue: ({
              event320,
              event322
            }) => {
              if (event320 !== undefined && event322 !== undefined) {
                const diff = event320 - event322;
                if (diff !== 0) {
                  return Number(Math.abs(diff).toFixed(2));
                }
              }
            },
            mapTo: ({
              event320,
              event322
            }) => {
              if (event320 !== undefined && event322 !== undefined) {
                return event320 >= event322 ? 'event323' : 'event324';
              }
            }
          }
        },
        _numConnections: {
          mapping: {
            mapTo: 'event319'
          }
        },
        confirmationNumber: {
          mapping: {
            mapTo: 'eVar15,confirmationNumber'
          }
        },
        daysBetweenBookingAndArrival: {
          mapping: {
            mapTo: 'eVar17,^^eVar17',
            applyFilter: {
              type: 'string'
            }
          }
        },
        discountCode: {
          mapping: {
            transformers: {
              preProcess: (result, parentResult, val) => {
                if (!val) return;
                let str;
                if (Object.keys(val).length < 2) {
                  str = val.offerName || '';
                } else {
                  const f = (v, fb) => v !== undefined ? v : fb;
                  const lob = f(val.lob, (parentResult.site || '').toUpperCase() || 'Null');
                  str = `${lob}:${f(val.productSpace, 'Null')}:${f(val.productType, 'Null')}:${f(val.usageWindow, 'Null')}:${f(val.offerName, 'Null')}`;
                }
                if (str) {
                  result.eVar21 = str;
                  parentResult.eVar49 = str;
                }
              }
            }
          }
        },
        originalChannel: {
          mapping: {
            mapTo: 'eVar65'
          }
        },
        elapsedBookingTime: {
          mapping: {
            mapTo: 'eVar66'
          }
        },
        visualId: {
          mapping: {
            mapTo: 'visualId'
          }
        },
        events: {
          mapping: {
            type: 'flex-array',
            valueDelimiter: '=',
            defaultElementValue: 1,
            targetDelimiter: '|',
            mapTo: {
              activityUnits: 'event65',
              cartAdd: 'event44',
              cartRemove: 'event45'
            }
          }
        },
        parentId: {
          mapping: {
            mapTo: 'parentId'
          }
        },
        availabilityChannel: {
          mapping: {
            mapTo: 'availChannel'
          }
        },
        inventory: {
          mapping: {
            mapTo: 'inventory'
          }
        },
        pricingCategory: {
          mapping: {
            mapTo: 'pricingCategory'
          }
        },
        useDate: {
          mapping: {
            type: 'template',
            template: '{{#useDate}}:::{{{useDate}}}:{{/useDate}}',
            mapTo: model => canHaveUseDates(model.productType) ? 'eVar36' : undefined,
            defaultValue: model => canHaveUseDates(model.productType) && (model.bookingSearchArrivalDate || model.bookedArrivalDate) || undefined,
            applyFilter: {
              date: {}
            }
          }
        },
        arrivalWindow: {
          mapping: {
            mapTo: model => canHaveUseDates(model.productType) ? 'eVar79' : undefined,
            defaultValue: model => {
              let arrival;
              if (canHaveUseDates(model.productType) && (arrival = model.useDate || model.bookingSearchArrivalDate || model.bookedArrivalDate) && (arrival = moment(arrival, ['MM/DD/YYYY', 'YYYY-MM-DD'])) && arrival.isValid()) {
                return '' + arrival.diff(moment().startOf('day'), 'days');
              }
            }
          }
        },
        useWindow: {
          mapping: {
            mapTo: model => canHaveUseDates(model.productType) ? 'useWindow' : undefined,
            defaultValue: 'notset'
          }
        },
        days: {
          mapping: {
            mapTo: model => 'days' + (isTicket(model.productType) ? ',ticketDays' : '')
          }
        },
        daysAndUseWindow: {
          mapping: {
            type: 'template',
            template: '{{#days}}' + '{{{days}}}{{#useWindow}}:{{{useWindow}}}{{/useWindow}}' + '{{/days}}' + '{{^days}}' + '{{#bookingSearchLengthOfStayNights}}' + '{{{bookingSearchLengthOfStayNights}}}{{#useWindow}}:{{{useWindow}}}{{/useWindow}}' + '{{/bookingSearchLengthOfStayNights}}' + '{{/days}}',
            mapTo: 'eVar33,^^eVar33=prop17'
          }
        },
        bookedDaysAndUseWindow: {
          mapping: {
            type: 'template',
            template: '{{#confirmationNumber}}' + '{{#days}}' + '{{{days}}}{{#useWindow}}:{{{useWindow}}}{{/useWindow}}' + '{{/days}}' + '{{^days}}' + '{{#bookedLengthOfStayNights}}' + '{{{bookedLengthOfStayNights}}}{{#useWindow}}:{{{useWindow}}}{{/useWindow}}' + '{{/bookedLengthOfStayNights}}' + '{{/days}}' + '{{/confirmationNumber}}',
            mapTo: 'eVar19,^^eVar19'
          }
        },
        productInfo: {
          mapping: {
            type: 'template',
            template: '{{{parentId}}}:{{{availChannel}}}:{{{inventory}}}::{{{pricingCategory}}}',
            mapTo: model => model.productType === 'merch' ? 'eVar36' : undefined,
            transformers: {
              preProcess: model => {
                if (!model.parentId && model.productId) {
                  model.parentId = model.productId;
                }
                if (model.inventory && model.inventory.toLowerCase() === 'out of stock') {
                  model.availChannel = 'Not Available';
                }
              }
            }
          }
        },
        venues: {
          mapping: {
            type: 'flex-array',
            mapTo: (model, parentModel) => !parentModel.eVar13 ? '^^eVar13' : ''
          }
        },
        addOnDetail: {
          mapping: {
            type: 'flex-array',
            mapTo: 'eVar130',
            targetDelimiter: ':',
            preFilter: {
              replace: [[',|;|\\||:', '']]
            },
            transformers: {
              preProcess: (r, p, modelVal) => {
                if (Array.isArray(modelVal) && modelVal.length === 0) modelVal.push('Base');
              }
            }
          }
        },
        reservationDetail: {
          position: {
            mapping: {
              mapTo: '_reservationPosition',
              defaultValue: ({
                confirmationNumber
              }, parentModel, {
                stack
              }) => {
                const {
                  productType
                } = stack[stack.length - 3];
                return confirmationNumber && isReservation(productType) ? parentModel._reservation_index++ : undefined;
              }
            }
          },
          _sc_reservation_events: {
            mapping: {
              defaultValue: ({
                _reservationPosition,
                bookedPartyTotal,
                bookingSearchPartyTotal
              }) => {
                if (_reservationPosition) return `event295=1|event296=${bookedPartyTotal || bookingSearchPartyTotal || 0}`;
              }
            }
          },
          celebrations: {
            mapping: {
              type: 'flex-array',
              mapTo: '_celebration_events',
              valueDelimiter: '=',
              defaultElementValue: 1,
              targetDelimiter: '|',
              fallbackKey: 'event306',
              flexValueMap: {
                birthday: 'event298',
                honeymoon: 'event299',
                wedding: 'event300',
                anniversary: 'event301',
                firstvisit: 'event302',
                personaltriumph: 'event303',
                graduation: 'event304',
                reunion: 'event305'
              },
              eachTransformers: {
                normalizeKeyAndNumericValue: ({
                  key,
                  value
                }, {
                  mapping: {
                    defaultElementValue
                  }
                }) => ({
                  key: key.replace(/[^a-z]/gi, '').toLowerCase(),
                  value: isNaN(value) ? defaultElementValue : +value
                })
              },
              applyFilter: {
                consolidate: arr => {
                  const obj = arr.reduce((obj, {
                    key,
                    value
                  }) => {
                    obj[key] = (obj[key] ?? 0) + value;
                    return obj;
                  }, {});
                  return Object.entries(obj).map(([key, value]) => ({
                    key,
                    value
                  })).filter(({
                    value
                  }) => value > 0);
                },
                addSumEventAndSort: arr => [{
                  key: 'event297',
                  value: arr.reduce((p, {
                    value
                  }) => p + value, 0)
                }, ...arr.sort((a, b) => a.key < b.key ? -1 : 1)]
              }
            }
          },
          options: {
            mapping: {
              type: 'flex-array',
              mapTo: '_option_events',
              valueDelimiter: '=',
              defaultElementValue: 1,
              targetDelimiter: '|',
              flexValueMap: {
                checkinnotavailable: 'cina',
                checkinavailable: 'event307',
                checkincomplete: 'event308',
                paymentavailable: 'event309',
                paymentdueatcheckin: 'pdaci',
                paymentcomplete: 'event310',
                modificationavailable: 'event311'
              },
              eachTransformers: {
                normalizeKeyAndNumericValue: ({
                  key,
                  value
                }) => ({
                  key: key.replace(/[^a-z]/gi, '').toLowerCase(),
                  value: isNaN(value) ? 1 : +value
                })
              },
              applyFilter: {
                consolidate: arr => {
                  const obj = arr.reduce((obj, {
                    key,
                    value
                  }) => {
                    obj[key] = (obj[key] ?? 0) + value;
                    return obj;
                  }, {});
                  return Object.entries(obj).map(([key, value]) => ({
                    key,
                    value
                  })).filter(({
                    value
                  }) => value > 0);
                },
                sort: arr => arr.sort((a, b) => a.key < b.key ? -1 : 1)
              }
            }
          }
        },
        _sc_v135: {
          mapping: {
            mapTo: 'eVar135',
            defaultValue: ({
              _reservationPosition,
              _celebration_events,
              _option_events,
              _sc_reservation_events
            }) => {
              if (!_reservationPosition) return;
              const events = `${_celebration_events}|${_option_events}|${_sc_reservation_events}`;
              const val = event => {
                const value = (events.match(new RegExp('\\b' + event + '=([0-9]+)\\b')) || {})[1] || '0';
                return value === '0' ? 'z' : value;
              };
              return `${_reservationPosition}:${'event296,event307,event308,cina,event309,event310,pdaci,event311,event297,event298,event299,event300,event301,event302,event303,event304,event305,event306'.split(',').map(val).join(':')}`;
            }
          }
        },
        mapping: {
          type: 'template',
          template: ({
            productType
          }) => '{{productType}};' + '{{#productId}}{{{productId}}}{{/productId}}{{^productId}}{{{altProductId}}}{{/productId}}' + (productType === 'eexp' || productType === 'merch' ? '' : ':{{{facilityId}}}' + '{{#portId}}_{{{portId}}}{{/portId}}' + ':{{{roomTypeId}}}' + '{{^portId}}:{{#ticketId}}{{{ticketId}}}{{/ticketId}}{{^ticketId}}{{{altTicketId}}}{{/ticketId}}{{/portId}}') + ';{{{quantity}}};' + '{{{totalPrice}}};' + '{{{eventsString}}};' + '{{{eVarString}}}',
          transformers: {
            //used to perform preliminary transformations without setting
            //a particular value to the model
            productDetails: (model, parentModel) => {
              if (parentModel.pageType === 'productDetails') {
                parentModel.contextData = parentModel.contextData || {};
                if (!parentModel.contextData['product.title']) {
                  parentModel.contextData['product.title'] = `${model.name}:${model.totalPrice}`;
                }
              }
            },
            preProcess: (model, parentModel) => {
              var ip, n;
              //for now we only expect 1 item in the included products (tickets)
              if (model.includedProducts && model.includedProducts.length > 0) {
                ip = model.includedProducts[0];
                for (n in ip) {
                  if (ip.hasOwnProperty(n)) {
                    model[n] = ip[n];
                  }
                }
              }
              /*there are a few variables we need outside of the product string, lets get them
                  */
              if (parentModel.paymentInfo) {
                model.eVar20 = parentModel.paymentInfo;
              }
              if (model.productType === 'tix' && model.visualId) {
                addTicketVisualIds(model, parentModel);
              }
            },
            packageTicketDelta: model => {
              if (model.productType === 'res' && model.ticketDays && (model.bookedLengthOfStayNights || model.bookingSearchLengthOfStayNights)) {
                const los = +(model.bookedLengthOfStayNights || model.bookingSearchLengthOfStayNights);
                const tixDays = +model.ticketDays;
                return tixDays - los;
              }
            },
            finalPackageTicketDelta: (model, parentModel) => {
              if (typeof model.packageTicketDelta === 'number' && (parentModel.events?.includes?.('purchase') && parentModel.purchaseID || parentModel.events?.includes?.('event67'))) {
                return model.packageTicketDelta;
              }
            },
            ticketDaysQuantity: (model, parentModel) => {
              if (model.ticketDays && model.ticketQuantity && (parentModel.events?.includes?.('purchase') && parentModel.purchaseID || parentModel?.events?.includes?.('event67'))) {
                return +model.ticketDays * +model.ticketQuantity;
              }
            },
            /**
             * transforms eVar properties in a model to a concatinated string.
             * Ex : an object with {'eVar1' : 'v12','eVar2' : 'v33' }
             * would become a string "eVar1=v12|eVar2=v33"
             */
            eVarString: (model, parentModel) => {
              var results = Object.entries(model).filter(([key, value]) => value && key.includes('eVar')).map(([key, value]) => [+key.replace(/\D/g, ''), value]);
              if (model.productType === 'res') {
                const val = typeof model.packageTicketDelta === 'number' ? model.packageTicketDelta : parentModel.offerId?.includes?.('phroom') ? 'Passholder' : 'RoomOnly';
                if (!parentModel.eVar133) parentModel.eVar133 = val;
                results.push([133, val]);
              }
              return results
              /* .sort(([akey], [bkey]) => akey - bkey) */.map(([key, value]) => `eVar${key}=${value}`).join('|');
            },
            //same concept as eVars but for events
            eventsString: (model, parentModel) => {
              const results = [],
                promoteEvent = event => {
                  //add event to main events string if it is not already there
                  if (!parentModel.events) {
                    parentModel.events = event;
                  } else if (!new RegExp('(^|,)' + event + '(,|=|$)').test(parentModel.events)) {
                    parentModel.events += ',' + event;
                  }
                  return event;
                };
              for (const [prop, val] of Object.entries(model)) {
                if (val && prop.includes('event')) {
                  // check if prop is literally 'events' this means that we have an event in the product object itself
                  if (/events$/.test(prop)) {
                    results.push(...val.split('|').filter(s => s.startsWith('event')));
                    // split the string to an array ('event44=1|event45=1' => ['event44', '1', 'event45', '1'])
                    const eventParts = val.split(/[|=]+/);
                    for (let i = 0, l = eventParts.length; i < l; i++) {
                      const part = eventParts[i];
                      if (part.includes('event')) promoteEvent(part);
                    }
                  } else {
                    results.push(prop + '=' + val);
                    promoteEvent(prop);
                  }
                }
              }
              if (parentModel.totalBookedLengthOfStayNights && (model.productType === 'prod' || model.productType === 'res')) {
                results.push(promoteEvent(parentModel.site?.toUpperCase?.() === 'DLR' ? 'event25' : 'event26') + '=' + parentModel.totalBookedLengthOfStayNights);
              }
              if (typeof model.finalPackageTicketDelta === 'number') {
                if (model.finalPackageTicketDelta < 0) {
                  results.push(promoteEvent('event89') + '=' + -model.finalPackageTicketDelta);
                } else {
                  results.push(promoteEvent('event88') + '=' + model.finalPackageTicketDelta);
                }
              }
              if (typeof model.ticketDaysQuantity === 'number') {
                results.push(promoteEvent(model.productType === 'res' ? 'event234' : 'event233') + '=' + model.ticketDaysQuantity);
              }
              return results.join('|');
            }
          }
        }
      }],
      productTotal: {
        mapping: {
          mapTo: model => {
            if (model.pageType === 'cart' || model.pageType === 'checkoutflow' || model.pageType === 'confirmation') {
              return 'contextData.cart_value';
            }
          }
        }
      },
      failedProducts: [{
        productType: {
          mapping: {
            defaultValue: 'prod',
            mapTo: {
              airTransportation: 'air',
              annualPass: 'tix',
              cruise: 'prod',
              datedTicket: 'dtx',
              dining: 'dine',
              enhancedExperience: 'eexp',
              fastPassPlus: 'gxa',
              greatFoodFast: 'gxa',
              groundTransportation: 'auto',
              insurance: 'ins',
              media: 'med',
              product: 'prod',
              resortVacation: 'res',
              ticket: 'tix',
              trip: 'trip'
            }
          }
        },
        productId: {
          mapping: {
            mapTo: model => isTicket(model.productType) ? 'ticketId' : 'productId'
          }
        },
        facilityId: {
          mapping: {}
        },
        roomTypeId: {
          mapping: {}
        },
        mapping: {
          rollUp: true,
          mapTo: 'eVar62',
          type: 'template',
          targetDelimiter: ',',
          template: model => {
            var tpl = '{{{productType}}};{{{productId}}}:{{{facilityId}}}:{{{roomTypeId}}}:{{{ticketId}}}';
            if (model.productType === 'eexp') {
              tpl = '{{{productType}}};{{{productId}}}';
            } else if (model.productType === 'merch') {
              tpl = '{{{productType}}};{{{productId}}}';
            }
            return tpl;
          },
          transformers: {
            preProcess: (model, parentModel) => {
              var evt = 'event60';
              if (model.productType && (model.productId || model.ticketId)) {
                if (parentModel.events) {
                  if (!parentModel.events.includes(evt)) {
                    parentModel.events += ',' + evt;
                  }
                } else {
                  parentModel.events = evt;
                }
              }
            }
          }
        }
      }],
      productsCompared: [{
        productName: {
          mapping: {}
        },
        productId: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{#productId}}{{{productId}}}{{/productId}}{{^productId}}{{{productName}}}{{/productId}}'
        }
      }],
      productsDisplayedEvent: {
        mapping: {
          defaultValue: 'notset'
        }
      },
      productsDisplayed: [{
        productType: {
          mapping: {
            defaultValue: 'prod',
            mapTo: {
              annualPass: 'tix',
              cruise: 'prod',
              datedTicket: 'dtx',
              product: 'prod',
              ticket: 'tix',
              trip: 'trip'
            }
          }
        },
        facilityId: {
          mapping: {}
        },
        roomTypeId: {
          mapping: {}
        },
        isAvailable: {
          mapping: {
            defaultValue: 'u'
          }
        },
        productId: {
          mapping: {}
        },
        visualId: {
          mapping: {}
        },
        price: {
          mapping: {
            defaultValue: 'NA'
          }
        },
        order: {
          mapping: {
            defaultValue: 'NS'
          }
        },
        offerId: {
          mapping: {
            defaultValue: 'NA'
          }
        },
        mapping: {
          mapTo: '_',
          transformers: {
            preProcess: (model, parentModel) => {
              if (model.productType === 'tix' && model.visualId) {
                addTicketVisualIds(model, parentModel);
              }
            }
          }
        }
      }],
      _sc_v50: {
        mapping: {
          type: 'template',
          template: '{{#_sc_v50}}{{productsDisplayedEvent}};{{_sc_v50}}{{/_sc_v50}}',
          mapTo: 'eVar50',
          defaultValue: ({
            productsDisplayed
          }) => {
            if (Array.isArray(productsDisplayed)) {
              const value = productsDisplayed.map(({
                productId,
                facilityId,
                roomTypeId
              }) => facilityId || roomTypeId ? `${facilityId || ''}:${roomTypeId || ''}` : productId || '').join(';');
              // if value is not only semicolons and colons, return it
              if (/[^;:]/.test(value)) return value;
            }
          },
          reprocessOnUpdate: true
        }
      },
      _sc_v63: {
        mapping: {
          type: 'template',
          template: '{{#_sc_v63}}{{_sc_v63.numAvailable}};{{_sc_v63.value}}{{/_sc_v63}}',
          mapTo: 'eVar63',
          defaultValue: ({
            productsDisplayed,
            offersShown
          }) => {
            const val = productsDisplayed || offersShown;
            if (Array.isArray(val)) {
              const availArr = val.map(({
                isAvailable
              }) => ({
                true: 1,
                false: 0,
                u: 'u'
              })[isAvailable] ?? '');
              if (availArr.some(v => v === 1 || v === 0)) {
                return {
                  numAvailable: availArr.filter(v => v === 1).length,
                  value: availArr.join(';')
                };
              }
            }
          },
          reprocessOnUpdate: true
        }
      },
      _sc_v124: {
        mapping: {
          type: 'template',
          template: '{{#_sc_v124}}{{productsDisplayedEvent}};{{_sc_v124}}{{/_sc_v124}}',
          mapTo: 'eVar124',
          defaultValue: ({
            productsDisplayed
          }) => {
            if (Array.isArray(productsDisplayed)) {
              const priceArr = productsDisplayed.map(({
                price
              }) => {
                if (price === 'NA') return price;
                if (typeof price === 'string') price = price.trim();
                if (typeof price === 'number' || typeof price === 'string') {
                  price = Number(price);
                  if (!Number.isNaN(price)) return Math.round(price);
                }
                return '';
              });
              if (priceArr.some(v => typeof v === 'number')) {
                return priceArr.join(';');
              }
            }
          },
          reprocessOnUpdate: true
        }
      },
      _sc_v124_2: {
        mapping: {
          type: 'template',
          template: '{{#_sc_v124_2}}{{offersShownPrefix}}{{_sc_v124_2}}{{/_sc_v124_2}}',
          mapTo: 'eVar124',
          defaultValue: ({
            offersShown,
            eVar124
          }) => {
            if (eVar124) return;
            if (Array.isArray(offersShown)) {
              const priceArr = offersShown.map(({
                price,
                reason
              }) => {
                if (price === 'NA') {
                  return reason ? `${price}_${reason}` : price;
                }
                if (typeof price === 'string') price = price.trim();
                if (typeof price === 'number' || typeof price === 'string') {
                  price = Number(price);
                  if (!Number.isNaN(price)) return Math.round(price);
                }
                return '';
              });
              if (priceArr.some(v => v !== 'NA')) {
                return priceArr.join(';');
              }
            }
          },
          reprocessOnUpdate: true
        }
      },
      _sc_v125: {
        mapping: {
          type: 'template',
          template: '{{#_sc_v125}}{{productsDisplayedEvent}};{{_sc_v125}}{{/_sc_v125}}',
          mapTo: 'eVar125',
          defaultValue: ({
            productsDisplayed
          }) => {
            if (Array.isArray(productsDisplayed)) {
              const value = productsDisplayed.map(p => p.order).join(';');
              if (/\d/.test(value)) return value;
            }
          },
          reprocessOnUpdate: true
        }
      },
      _sc_v142: {
        mapping: {
          type: 'template',
          template: '{{#_sc_v142}}{{_sc_v142.count}};{{_sc_v142.value}}{{/_sc_v142}}',
          mapTo: 'eVar142',
          defaultValue: ({
            productsDisplayed
          }) => {
            if (Array.isArray(productsDisplayed)) {
              const offerArr = productsDisplayed.map(({
                offerId
              }) => offerId);
              if (offerArr.some(v => v !== 'NA')) {
                return {
                  count: offerArr.filter(v => v !== 'NA').length,
                  value: offerArr.join(',')
                };
              }
            }
          },
          reprocessOnUpdate: true
        }
      },
      contentId: {
        mapping: {
          mapTo: 'prop35'
        }
      },
      recommenderInfo: {
        conversationId: {
          mapping: {}
        },
        messageId: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{#conversationId}}{{{conversationId}}},{{{messageId}}}{{/conversationId}}',
          mapTo: 'prop42'
        }
      },
      pageGroupId: {
        mapping: {
          type: 'template',
          mapTo: 'prop52',
          template: '{{#pageGroupIdVal}}{{{pageGroupIdVal}}}{{/pageGroupIdVal}}',
          transformers: {
            // do not set prop52 if purchaseID is set to prevent accidental deduplication
            pageGroupIdVal: ({
              purchaseID,
              pageGroupId
            }) => purchaseID ? undefined : pageGroupId
          }
        }
      },
      targusId: {
        mapping: {
          mapTo: 'eVar46'
        }
      },
      compareVacationNumber: {
        mapping: {
          mapTo: 'eVar64'
        }
      },
      currencyDisplayed: {
        mapping: {
          mapTo: 'prop70'
        }
      },
      server: {
        mapping: {
          mapTo: 'server'
        }
      },
      device: {
        type: {
          mapping: {}
        },
        viewType: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{#type}}{{#viewType}}{{type}}:{{viewType}}{{/viewType}}{{/type}}',
          mapTo: 'prop32'
        }
      },
      currentEntitlements: {
        mapping: {
          type: 'flex-array',
          mapTo: 'prop55',
          flexValueMap: productTypeMap,
          postFilter: {
            alpha: 'asc',
            unique: ','
          }
        }
      },
      modificationType: {
        mapping: {
          mapTo: 'eVar68'
        }
      },
      modificationDetail: {
        mapping: {
          mapTo: 'eVar166'
        }
      },
      article: {
        id: {
          mapping: {
            mapTo: 'articleId'
          }
        },
        title: {
          mapping: {
            mapTo: 'articleName'
          }
        },
        publicationDate: {
          mapping: {
            mapTo: 'articlePublicationDate',
            applyFilter: {
              date: {}
            }
          }
        },
        author: {
          mapping: {
            mapTo: 'articleAuthor'
          }
        },
        categories: {
          mapping: {
            mapTo: 'prop33'
          }
        }
      },
      articleMetaData: {
        mapping: {
          type: 'template',
          mapTo: 'prop57,eVar72',
          template: '{{#articleId}}{{{articleId}}}:{{{articleName}}}{{/articleId}}'
        }
      },
      articleIdentifiers: {
        mapping: {
          type: 'template',
          template: '{{#articleId}}{{{articleId}}}:{{{articlePublicationDate}}}:{{{articleAuthor}}}{{/articleId}}',
          mapTo: 'prop58,eVar73'
        }
      },
      contentType: {
        mapping: {
          mapTo: 'eVar72'
        }
      },
      contentGroup: {
        mapping: {
          mapTo: 'eVar73'
        }
      },
      geo: {
        country: {
          mapping: {
            mapTo: 'geoCountry',
            applyFilter: {
              case: 'lower'
            }
          }
        }
      },
      personalizationId: {
        mapping: {
          mapTo: 'prop63'
        }
      },
      previousPageLoadTime: {
        mapping: {
          mapTo: 'prop45',
          defaultValue: model => {
            var cookieVal, loadTime, prevLoadTime, prevPage;

            // This should only run on a base model, as we dont want subsequent parsings to trigger this
            if (model.pageName && model.reportSuiteId && !model.pageName.match(/notset/)) {
              prevLoadTime = sessionStorage.getItem('prevPageLoadTime');
              prevPage = window.s_wdpro && window.s_wdpro.c_r && window.s_wdpro.c_r('s_gpv_pn');
              if (prevLoadTime) {
                prevLoadTime = prevLoadTime.split('|');
                if (prevPage === prevLoadTime[0]) {
                  model.previousPageLoadTime = prevLoadTime[1];
                }
              }
              try {
                loadTime = (performance.timing.domContentLoadedEventStart - performance.timing.navigationStart) / 1000;
                loadTime = loadTime.toFixed(1);
                cookieVal = model.pageName + '|' + loadTime;
              } catch (e) {
                cookieVal = model.pageName + '|unknown';
              }
              sessionStorage.setItem('prevPageLoadTime', cookieVal);
              if (model.previousPageLoadTime) {
                return model.previousPageLoadTime;
              }
            }
          }
        }
      },
      shipping: {
        method: {
          mapping: {
            mapTo: 'shippingMethod',
            applyFilter: {
              replace: [[' ', '']]
            }
          }
        },
        price: {
          mapping: {
            mapTo: 'shippingPrice',
            defaultValue: () => 0
          }
        },
        time: {
          mapping: {
            mapTo: 'shippingTime',
            applyFilter: {
              replace: [[' ', '']]
            }
          }
        },
        mapping: {
          type: 'template',
          template: '{{#shippingMethod}}{{{shippingMethod}}}:{{{shippingPrice}}}:{{{shippingTime}}}{{/shippingMethod}}',
          mapTo: 'eVar61'
        }
      },
      intelligenceId: {
        test: {
          mapping: {
            mapTo: 'sc_intelTest'
          }
        },
        group: {
          mapping: {
            mapTo: 'sc_intelGroup'
          }
        },
        recipe: {
          mapping: {
            mapTo: 'sc_intelRecipe'
          }
        },
        mapping: {
          type: 'template',
          template: '{{#sc_intelRecipe}}{{{sc_intelTest}}}:{{{sc_intelGroup}}}:{{{sc_intelRecipe}}}{{/sc_intelRecipe}}',
          mapTo: 'eVar76'
        }
      },
      behavioralAnalysisConnectorId: {
        mapping: {
          mapTo: 'eVar101',
          defaultValue: () => getCookie('_cs_mk_aa')
        }
      },
      guest: {
        uuid: {
          mapping: {
            mapTo: 'contextData.user_uuid'
          }
        }
      },
      recommendations: [{
        group: {
          mapping: {}
        },
        position: {
          mapping: {}
        },
        source: {
          mapping: {}
        },
        target: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{source}}:{{position}}:{{target}}:{{group}}',
          rollUp: true,
          mapTo: 'list2',
          targetDelimiter: ','
        }
      }],
      recommendationCount: {
        mapping: {}
      },
      recommendationSource: {
        mapping: {
          mapTo: 'eVar90'
        }
      },
      _eVar93: {
        mapping: {
          mapTo: 'eVar93',
          reprocessOnUpdate: true,
          defaultValue: model => {
            if (model.list2) {
              let listItems = model.list2.split(','),
                recommendationCount = model.recommendationCount || listItems.length;
              return recommendationCount + ':' + listItems[0].split(':')[3];
            }
          }
        }
      },
      itemAvailability: {
        mapping: {
          mapTo: () => '',
          transformers: {
            preProcess: (mappedModel, _, itemAvailability) => {
              if (!itemAvailability) return;
              const {
                id,
                total,
                intervals
              } = itemAvailability;
              if (Array.isArray(intervals) && intervals.length > 0 && !mappedModel.eVar50 && !mappedModel.eVar63 && !mappedModel.eVar124) {
                const prefix = typeof id === 'string' && id !== '';
                if (prefix) intervals.unshift({
                  name: id,
                  value: valid(total) ? total : calculate(intervals),
                  price: id
                });
                mappedModel.eVar50 = intervals.map(({
                  name
                }) => name).join(';');
                mappedModel.eVar63 = intervals.map(({
                  value
                }) => valid(value) ? value : '').join(';');
                mappedModel.eVar124 = intervals.map(({
                  price
                }) => {
                  if (typeof price === 'string') {
                    price = price.trim();
                    if (/[a-z]/i.test(price)) return price;
                  }
                  if (typeof price === 'number' || typeof price === 'string') {
                    const nPrice = Number(price);
                    if (!Number.isNaN(nPrice)) return Math.round(nPrice);
                  }
                  if (typeof price === 'string' && /\d/.test(price)) return price;
                  return '';
                }).join(';');
                validate(mappedModel, 'eVar63');
                validate(mappedModel, 'eVar124');
              }
              function validate(obj, prop) {
                if (obj[prop].includes(';') && !/;[\da-z]/i.test(obj[prop])) delete obj[prop];
              }
              function valid(v) {
                return v != null;
              }
              function calculate(intervals) {
                return intervals.reduce((p, interval) => {
                  let avail = +(valid(interval.value) ? interval.value : '');
                  return p + (typeof avail === 'number' && !isNaN(avail) ? avail : 0);
                }, 0);
              }
            }
          }
        }
      },
      timesPrefix: {
        mapping: {
          mapTo: 'timesPrefix'
        }
      },
      times: {
        mapping: {
          type: 'flex-array',
          targetDelimiter: ';',
          eachFilter: {
            prefixAllValues: (value, result) => result.timesPrefix ? `${result.timesPrefix}${value}` : value
          },
          mapTo: 'list3'
        }
      },
      contentList: {
        mapping: {
          type: 'flex-array',
          mapTo: 'list1',
          preFilter: {
            replace: [[',', '']]
          }
        }
      },
      contentList2: {
        mapping: {
          type: 'flex-array',
          mapTo: ({
            list2
          }) => !list2 ? 'list2' : null,
          // don't set if list2 is already set
          preFilter: {
            replace: [[',', '']]
          }
        }
      },
      contentList3: {
        mapping: {
          type: 'flex-array',
          mapTo: ({
            list3
          }) => !list3 ? 'list3' : null,
          // don't set if list3 is already set
          preFilter: {
            replace: [[',', '']]
          }
        }
      },
      conversationId: {
        mapping: {
          mapTo: 'eVar115'
        }
      },
      serviceFailure: {
        cidCount: {
          mapping: {}
        },
        lob: {
          mapping: {
            defaultValue: '{{lob}}'
          }
        },
        type: {
          mapping: {}
        },
        category: {
          mapping: {}
        },
        detail: {
          mapping: {
            defaultValue: 'null'
          }
        },
        sfCount: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          mapTo: ({
            serviceFailure: {
              sfCount
            } = {}
          }) => sfCount ? 'eVar114' : '',
          template: '{{cidCount}}_{{lob}}_{{type}}_{{category}}_{{detail}}_{{sfCount}}'
        }
      },
      frameworkVersion: {
        mapping: {
          mapTo: 'prop75'
        }
      },
      sessionQuality: {
        total: {
          mapping: {
            mapTo: 'eVar80'
          }
        },
        increment: {
          mapping: {
            transformers: {
              preProcess: (model, _, val) => {
                if (val) {
                  model.events = `${model.events || ''}${model.events ? ',' : ''}event64=${val}`;
                }
              }
            }
          }
        }
      },
      upgradeCategory: {
        mapping: {}
      },
      upgradeSubcategory: {
        mapping: {}
      },
      _sc_v97: {
        mapping: {
          type: 'template',
          template: '{{upgradeCategory}}{{#upgradeCategory}}{{#upgradeSubcategory}}:{{/upgradeSubcategory}}{{/upgradeCategory}}{{upgradeSubcategory}}',
          mapTo: 'eVar97'
        }
      },
      _sc_utmParameters: {
        mapping: {
          mapTo: 'eVar148',
          defaultValue: () => {
            const params = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
            const values = params.map(p => getURLParameter(p) || '');
            if (values.some(Boolean)) return values.join(':');
          }
        }
      }
    };
    function addTicketVisualIds(model, parentModel) {
      var MAX_IDS = 13,
        pmcd = parentModel.contextData = parentModel.contextData || {};
      pmcd.visualId = arr(pmcd.visualId).concat(arr(model.visualId)).slice(0, MAX_IDS).join(',');
    }
    function arr(val) {
      if (val && typeof val === 'string') val = val.split(',');
      return Array.isArray(val) ? val : [];
    }
    function isTicket(productType) {
      return /^(?:tix|med|ndt|dtx)$/.test(productType);
    }
    function canHaveUseDates(productType) {
      return /^(?:tix|dtx|eexp|adm)$/.test(productType);
    }
    function isReservation(productType) {
      return /^(?:admission|annualPass|cruise|datedTicket|dining|enhancedExperience|event|resortVacation|ticket|trip)$/.test(productType);
    }
  }, 'Adapter:SiteCatalyst', 'Parsers', '$', 'moment', 'sessionStorage', 'eventmap', 'productTypeMap', 'getCookie', 'getURLParameter');

  /* global inject */
  /*
   * Reverse-map for the legacy `parseModel: false` backcompat pattern (GO4-6736).
   *
   * The legacy pattern populates window.s_wdpro.* inline and signals JSAF to
   * skip its SiteCatalyst mapping via:
   *
   *   WDPRO.Analytics.Framework.update({
   *     configuration: { SiteCatalyst: { parseModel: false } }
   *   });
   *
   * Historically this meant the incoming semantic model was near-empty, so
   * every non-SiteCatalyst adapter (Dart, CEA, AEP, contentsquare, gtag, etc.)
   * received a blank base model. This module inspects window.s_wdpro (and
   * window.s_account for the reportSuiteId) and rebuilds a semantic model
   * with the fields most other adapters depend on:
   *
   *   namespace, site, siteSection, pageId, contentLocale, contentLanguage,
   *   marketingRegion (when the locale slot is not two-char locale-like),
   *   configuration.SiteCatalyst.reportSuiteId
   *
   * When s_wdpro.hier1's site segment does not match prop1.toLowerCase()
   * (e.g. wdwgoodneighborhotels.com sends hier1='wdpro/wdwgnh/...' but
   * prop1='WDW') the reconstructed model sets `_legacyHier1Site` so the
   * hierarchy Mustache template renders the legacy segment verbatim and
   * pageName does not drift on the outgoing pixel.
   */
  inject((store, Debug) => {
    store('SiteCatalyst.reverseMap', reverseMap);

    /**
     * Inspect window.s_wdpro (+ window.s_account) and return a semantic
     * model reconstructed from the legacy properties, or null when there
     * is nothing to reverse-map.
     */
    function reverseMap() {
      const s = window.s_wdpro;
      if (!s || typeof s !== 'object') return null;
      const hier1 = typeof s.hier1 === 'string' ? s.hier1 : '';
      const pageName = typeof s.pageName === 'string' ? s.pageName : '';
      if (!hier1 && !pageName) return null;
      const model = {};

      // Split the canonical default hier1 shape:
      //   namespace/site/{contentLocale|marketingRegion}/contentLanguage/siteSection[/more]
      // Anything past index 4 is joined back into siteSection with '/'.
      // Non-canonical shapes (fewer segments, trailing slash, colon-delimited
      // photopass hier1) fall through to whatever fields we can salvage.
      const parts = hier1 ? hier1.split('/') : [];
      if (parts[0]) model.namespace = parts[0];

      // site: prefer s_wdpro.prop1 (the canonical semantic property), fall
      // back to hier1[1] uppercased. site is normalised to upper-case to
      // match how DisneyDataLayer implementations typically set it.
      const siteFromProp1 = typeof s.prop1 === 'string' && s.prop1 ? s.prop1 : '';
      if (siteFromProp1) {
        model.site = siteFromProp1;
      } else if (parts[1]) {
        model.site = parts[1].toUpperCase();
      }

      // Drift guard: only set _legacyHier1Site when hier1's site segment
      // does not match site.toLowerCase(). The transformers in
      // SiteCatalystMapping / CEAMapping prefer this value so the outgoing
      // hier1 (and by extension pageName) stays byte-for-byte identical
      // to the legacy pixel. _legacyHier1Site is intentionally ugly to
      // discourage its use from application code.
      if (parts[1] && model.site && parts[1] !== model.site.toLowerCase()) {
        model._legacyHier1Site = parts[1];
      }

      // Locale slot. In practice this is always a 2-char locale on the
      // pages we scanned (see utils/scan-parsemodel-backcompat.js). If the
      // slot is not 2-char locale-like we route it to marketingRegion
      // instead so the hierarchy template can still render it correctly.
      if (parts[2]) {
        if (/^[a-z]{2}$/i.test(parts[2])) {
          model.contentLocale = parts[2];
        } else {
          model.marketingRegion = parts[2];
        }
      }
      if (parts[3]) model.contentLanguage = parts[3];
      if (parts.length > 4) {
        model.siteSection = parts.slice(4).join('/');
      }

      // pageId: pageName is hier1 + '/' + pageId. Strip the hier1 prefix
      // when present, otherwise fall back to the last '/' segment.
      if (pageName) {
        if (hier1 && pageName.indexOf(hier1 + '/') === 0) {
          model.pageId = pageName.slice(hier1.length + 1);
        } else {
          const lastSlash = pageName.lastIndexOf('/');
          model.pageId = lastSlash >= 0 ? pageName.slice(lastSlash + 1) : pageName;
        }
      }

      // reportSuiteId from window.s_account. This is a string of
      // comma-separated report suite ids the legacy AppMeasurement bootstrap
      // uses; JSAF's SiteCatalyst mapping accepts the same shape.
      const sAccount = window.s_account;
      if (typeof sAccount === 'string' && sAccount) {
        model.configuration = {
          SiteCatalyst: {
            reportSuiteId: sAccount
          }
        };
      }
      if (Debug && typeof Debug.info === 'function') {
        Debug.info('SiteCatalyst.reverseMap reconstructed model from s_wdpro:', model);
      }
      return model;
    }
  }, 'store', 'Debug');

  /* global inject */
  inject((Adapter, aepInstance, Debug, publish, Config, Mustache, Framework) => {
    new Adapter({
      name: 'AEP',
      enabled: false,
      adapt,
      trackElement,
      settings: {}
    });
    function adapt(sam, pageView = true) {
      const eventContext = {
        adapter: this,
        sam,
        pageView
      };
      const pub = (topic, additionalContext = {}) => publish({
        topic,
        ...Object.assign(eventContext, additionalContext)
      });
      if (pageView) addEvent('pageView', sam);
      pub('AEP.adapt');
      const commerceEventType = getCommerceEventType(sam);
      const isDualEvent = commerceEventType && pageView;
      const isPropositionEvent = !!(sam._experience?.decisioning?.propositionEventType?.interact || sam._experience?.decisioning?.propositionEventType?.display);
      const model = this.map(sam);
      pub('AEP.aftermap', {
        model
      });
      if (!model || !this.enabled) return false;

      // eslint-disable-next-line no-unused-vars
      const {
        configuration,
        contentTests,
        ...disneyDataLayer
      } = sam; // ignoring deprecated property "contentTests" (removes it from the disneyDataLayer var)
      const {
        configuration: aepConfig,
        xdm = {},
        data = {},
        eventObj = {},
        settings = {}
      } = model;
      processConfiguration(aepConfig);
      if (!aepConfig?.datastreamId) return false;
      Object.assign(this.settings, model.settings);
      if (isPropositionEvent) {
        // Proposition events must not carry commerce or pageView measures
        if (xdm.commerce) delete xdm.commerce;
        if (xdm.web?.webPageDetails?.pageViews) delete xdm.web.webPageDetails.pageViews;
      }
      const alloy = aepInstance(this.name, aepConfig);
      const sendEvent = (eventXdm, eventData, eventType) => {
        const payload = Object.assign({}, eventObj, {
          data: eventData,
          type: eventType,
          xdm: eventXdm
        });
        pub('AEP.afterconfiguration', {
          configuration,
          disneyDataLayer,
          aepConfig,
          xdm: eventXdm,
          data: eventData,
          eventObj: payload,
          settings
        });
        pub('AEP.beforeSendEvent', {
          alloy
        });
        alloy('sendEvent', payload).then(result => {
          Debug.log('AEP sendEvent succeeded.', {
            result
          });
          pub('AEP.sendEventSuccess', {
            result
          });
        }).catch(error => {
          Debug.error('AEP sendEvent failed.', {
            error
          });
          pub('AEP.sendEventError', {
            error
          });
        });
        return payload;
      };
      if (isDualEvent) {
        // pageViews counter belongs on the page view, not the commerce event
        if (xdm.web?.webPageDetails?.pageViews) delete xdm.web.webPageDetails.pageViews;
        const commerceEvent = sendEvent(xdm, data, commerceEventType);
        const strippedSam = stripCommerceData(sam);
        const strippedModel = this.map(strippedSam);
        const strippedXdm = strippedModel?.xdm || {};
        const strippedData = strippedModel?.data || {};
        // Defense-in-depth: mapping defaults (currencyDisplayed='USD') can
        // reintroduce commerce.order on the stripped model. Keep page view free of commerce.
        if (strippedXdm.commerce) delete strippedXdm.commerce;
        sendEvent(strippedXdm, strippedData, 'web.webpagedetails.pageViews');
        return {
          ...commerceEvent,
          dualEvent: true
        };
      }
      return sendEvent(xdm, data, determineEventType(sam, pageView));
    }
    function trackElement(event, sam) {
      const parentModel = Framework.getParentModel() || {};
      ['pageId', 'siteSection', 'site'].forEach(key => {
        if (sam[key] == null && parentModel[key] != null) sam[key] = parentModel[key];
      });
      return this.adapt(sam, false);
    }
    function addEvent(event, sam) {
      if (!sam.events) sam.events = [];
      if (!sam.events.includes(event)) sam.events.push(event);
    }
    function getCommerceEventType(sam) {
      const events = sam.events || [];
      const hasEvent = name => events.includes(name);
      if (hasEvent('purchase')) return 'commerce.purchases';
      if (hasEvent('checkout') || hasEvent('scCheckout')) return 'commerce.checkouts';
      if (hasEvent('cartProductAdd')) return 'commerce.productListAdds';
      if (hasEvent('cartProductRemove')) return 'commerce.productListRemovals';
      if (hasEvent('productView') || hasEvent('prodView')) return 'commerce.productViews';
      return null;
    }
    const COMMERCE_EVENTS = ['purchase', 'checkout', 'scCheckout', 'cartProductAdd', 'cartProductRemove', 'productView', 'prodView'];
    function stripCommerceData(sam) {
      // eslint-disable-next-line no-unused-vars
      const {
        orderId,
        totalPrice,
        products,
        currencyDisplayed,
        payment,
        ...rest
      } = sam;
      const result = {
        ...rest
      };
      if (result.events) {
        result.events = result.events.filter(e => !COMMERCE_EVENTS.includes(e));
      }
      return result;
    }
    function determineEventType(sam, pageView) {
      const propEventType = sam._experience?.decisioning?.propositionEventType;
      if (propEventType?.interact) return 'decisioning.propositionInteract';
      if (propEventType?.display) return 'decisioning.propositionDisplay';
      const commerceEventType = getCommerceEventType(sam);
      if (commerceEventType) return commerceEventType;
      if (pageView) return 'web.webpagedetails.pageViews';
      if (sam.link?.isLinkClick) return 'web.webinteraction.linkClicks';
      return 'web.webinteraction.elementClicks';
    }
    function processConfiguration(aepConfig) {
      for (const [key, value] of Object.entries(aepConfig)) {
        if (typeof value === 'string') {
          aepConfig[key] = Mustache.render(value, Config);
        }
      }
      // remove forward slashes from the start and end of the edgeBasePath
      if (typeof aepConfig.edgeBasePath === 'string') {
        aepConfig.edgeBasePath = aepConfig.edgeBasePath.replace(/^\/|\/$/g, '');
      }
    }
  }, 'Adapter', 'aepInstance', 'Debug', 'publish', 'Config', 'Mustache', 'Framework');

  /* global inject */
  inject((AEPAdapter, uuid, getCookie) => {
    const pageNameFilter = {
      case: 'lower',
      replace: [['^\\W+|\\W+$', '']]
    };
    AEPAdapter.mapping = {
      configuration: {
        AEP: {
          config: {
            mapping: {
              mapTo: 'configuration'
            },
            orgId: {
              mapping: {
                defaultValue: 'EDA101AC512D2B230A490D4C@AdobeOrg',
                mapTo: 'configuration.orgId'
              }
            },
            datastreamId: {
              mapping: {
                defaultValue: () => AEPAdapter.settings.datastreamId,
                mapTo: 'configuration.datastreamId,settings.datastreamId'
              }
            }
          },
          eventObj: {
            mapping: {},
            renderDecisions: {
              mapping: {
                defaultValue: true,
                mapTo: 'eventObj.renderDecisions'
              }
            }
          },
          pluginAdobeAnalytics: {
            mapping: {
              defaultValue: () => AEPAdapter.settings.pluginAdobeAnalytics ?? true,
              mapTo: 'settings.pluginAdobeAnalytics'
            }
          },
          pluginHelix: {
            mapping: {
              defaultValue: () => AEPAdapter.settings.pluginHelix ?? false,
              mapTo: 'settings.pluginHelix'
            }
          }
        },
        Helix: {
          turnOff: {
            mapping: {
              mapTo: 'settings.pluginHelix',
              postFilter: {
                inv: val => typeof val === 'boolean' ? !val : undefined
              }
            }
          }
        }
      },
      // pageId and pageType are passed through to the working model so the
      // _aep_name / _aep_viewName / _aep_isHomePage / _aep_isErrorPage
      // defaultValue functions can read them. They are not sent to Alloy.
      pageId: {
        mapping: {}
      },
      pageType: {
        mapping: {}
      },
      _aep_name: {
        mapping: {
          mapTo: 'xdm.web.webPageDetails.name',
          defaultValue: ({
            pageId,
            pageType
          } = {}) => pageType || pageId || undefined,
          applyFilter: pageNameFilter
        }
      },
      _aep_viewName: {
        mapping: {
          mapTo: 'xdm.web.webPageDetails.viewName',
          defaultValue: ({
            pageType
          } = {}) => pageType || undefined,
          applyFilter: pageNameFilter
        }
      },
      _aep_isHomePage: {
        mapping: {
          mapTo: 'xdm.web.webPageDetails.isHomePage',
          defaultValue: ({
            pageType
          } = {}) => pageType ? /home/i.test(pageType) : undefined
        }
      },
      _aep_isErrorPage: {
        mapping: {
          mapTo: 'xdm.web.webPageDetails.isErrorPage',
          defaultValue: ({
            pageType
          } = {}) => pageType ? /error/i.test(pageType) : undefined
        }
      },
      siteSection: {
        mapping: {
          mapTo: 'xdm.web.webPageDetails.siteSection'
        }
      },
      site: {
        mapping: {
          mapTo: 'xdm.web.webPageDetails.server'
        }
      },
      _aep_url: {
        mapping: {
          mapTo: 'xdm.web.webPageDetails.URL',
          defaultValue: () => {
            const canonical = document.querySelector('link[rel="canonical"]');
            if (canonical?.href) return canonical.href;
            const url = new URL(location.href);
            url.search = '';
            url.hash = '';
            return url.toString();
          }
        }
      },
      link: {
        id: {
          mapping: {
            mapTo: 'xdm.web.webInteraction.name'
          }
        },
        name: {
          mapping: {
            mapTo: 'xdm.web.webInteraction.name'
          }
        },
        URL: {
          mapping: {
            mapTo: 'xdm.web.webInteraction.URL'
          }
        },
        region: {
          mapping: {
            mapTo: 'xdm.web.webInteraction.region'
          }
        },
        type: {
          mapping: {
            mapTo: 'xdm.web.webInteraction.type'
          }
        },
        isLinkClick: {
          mapping: {
            mapTo: 'xdm.web.webInteraction.linkClicks',
            postFilter: {
              toLinkClicks: val => val ? {
                value: 1
              } : undefined
            }
          }
        }
      },
      linkId: {
        mapping: {
          mapTo: 'xdm.web.webInteraction.name'
        }
      },
      _aep_linkType: {
        mapping: {
          defaultValue: ({
            xdm
          } = {}) => xdm?.web?.webInteraction?.name && !xdm?.web?.webInteraction?.type ? 'other' : undefined,
          mapTo: 'xdm.web.webInteraction.type'
        }
      },
      currencyDisplayed: {
        mapping: {
          mapTo: 'xdm.commerce.order.currencyCode',
          defaultValue: 'USD'
        }
      },
      events: {
        mapping: {}
      },
      _aep_pageViews_id: {
        mapping: {
          mapTo: 'xdm.web.webPageDetails.pageViews.id',
          defaultValue: ({
            events
          }) => events?.includes?.('pageView') ? uuid() : undefined
        }
      },
      _aep_pageViews_value: {
        mapping: {
          mapTo: 'xdm.web.webPageDetails.pageViews.value',
          defaultValue: ({
            events
          }) => events?.includes?.('pageView') ? 1 : undefined
        }
      },
      _aep_purchases_value: {
        mapping: {
          mapTo: 'xdm.commerce.purchases.value',
          defaultValue: ({
            events
          }) => events?.includes?.('purchase') ? 1 : undefined
        }
      },
      _aep_checkouts_value: {
        mapping: {
          mapTo: 'xdm.commerce.checkouts.value',
          defaultValue: ({
            events
          }) => events?.includes?.('checkout') || events?.includes?.('scCheckout') ? 1 : undefined
        }
      },
      _aep_productListAdds_value: {
        mapping: {
          mapTo: 'xdm.commerce.productListAdds.value',
          defaultValue: ({
            events
          }) => events?.includes?.('cartProductAdd') ? 1 : undefined
        }
      },
      _aep_productListRemovals_value: {
        mapping: {
          mapTo: 'xdm.commerce.productListRemovals.value',
          defaultValue: ({
            events
          }) => events?.includes?.('cartProductRemove') ? 1 : undefined
        }
      },
      _aep_productViews_value: {
        mapping: {
          mapTo: 'xdm.commerce.productViews.value',
          defaultValue: ({
            events
          }) => events?.includes?.('productView') || events?.includes?.('prodView') ? 1 : undefined
        }
      },
      orderId: {
        mapping: {
          mapTo: 'xdm.commerce.order.purchaseID'
        }
      },
      storeType: {
        mapping: {
          mapTo: 'xdm._custom.storeType'
        }
      },
      /*
      contentId: {
      mapping: {
      mapTo: 'xdm.web.webPageDetails.contentID'
      }
      }, */
      itineraryDay: {
        mapping: {
          mapTo: 'xdm._custom.itineraryDay'
        }
      },
      itineraryLength: {
        mapping: {
          mapTo: 'xdm._custom.itineraryLength'
        }
      },
      itineraryType: {
        mapping: {
          mapTo: 'xdm._custom.itineraryType'
        }
      },
      recommenderInfo: {
        conversationId: {
          mapping: {
            mapTo: 'xdm._custom.recommenderConversationId'
          }
        },
        messageId: {
          mapping: {
            mapTo: 'xdm._custom.recommenderMessageId'
          }
        }
      },
      totalPrice: {
        priceSubTotal: {
          mapping: {
            mapTo: 'xdm._custom.orderSubtotal'
          }
        },
        totalTax: {
          mapping: {
            mapTo: 'xdm.commerce.order.taxAmount'
          }
        },
        totalShipping: {
          mapping: {
            mapTo: 'xdm._custom.shippingAmount'
          }
        },
        grandTotal: {
          mapping: {
            mapTo: 'xdm.commerce.order.priceTotal'
          }
        }
      },
      products: [{
        productId: {
          mapping: {
            mapTo: 'SKU'
          }
        },
        name: {
          mapping: {
            mapTo: 'name'
          }
        },
        quantity: {
          mapping: {
            mapTo: 'quantity',
            defaultValue: 1,
            applyFilter: {
              type: 'number'
            }
          }
        },
        productType: {
          mapping: {
            mapTo: 'productCategories',
            applyFilter: {
              productCategoriesArr: val => [{
                categoryName: val
              }]
            }
          }
        },
        price: {
          total: {
            mapping: {
              mapTo: 'priceTotal',
              applyFilter: {
                twoDecimals: val => Number(Number(val).toFixed(2))
              }
            }
          }
        },
        _aep_currencyCode: {
          mapping: {
            mapTo: 'currencyCode',
            defaultValue: (_model, parentResult) => parentResult?.xdm?.commerce?.order?.currencyCode
          }
        }
      }],
      _aep_products: {
        mapping: {
          defaultValue: ({
            products
          } = {}) => {
            if (!Array.isArray(products)) return undefined;
            return products.filter(p => Number(p.quantity) >= 1);
          },
          mapTo: 'xdm.commerce.productListItems'
        }
      },
      payment: {
        paymentMethods: [{
          name: {
            mapping: {}
          },
          type: {
            mapping: {
              mapTo: {
                creditCard: 'credit_card',
                giftCard: 'gift_card',
                rewardsCard: 'rewards_card',
                pointsPayment: 'points',
                instantCredit: 'instant_credit',
                digitalWallet: 'digital_wallet'
              }
            }
          },
          status: {
            mapping: {
              defaultValue: 'unknown'
            }
          },
          currency: {
            mapping: {}
          },
          paymentAmount: {
            mapping: {}
          },
          transactionId: {
            mapping: {}
          },
          mapping: {
            transformers: {
              preProcess: (model, parentModel) => {
                if (!parentModel.xdm?.commerce?.order) return;
                parentModel.xdm.commerce.order.payments || (parentModel.xdm.commerce.order.payments = []);
                const item = {
                  paymentType: model.type,
                  name: model.name,
                  status: model.status
                };
                if (model.currency) item.currencyCode = model.currency;
                if (model.paymentAmount != null) item.paymentAmount = model.paymentAmount;
                if (model.transactionId) item.transactionID = model.transactionId;
                parentModel.xdm.commerce.order.payments.push(item);
              }
            }
          }
        }]
      },
      customerId: {
        mapping: {
          mapTo: 'xdm.identityMap.SWID',
          defaultValue: () => getCookie('SWID'),
          postFilter: {
            format: val => !val || typeof val !== 'string' ? undefined : [{
              id: val,
              authenticatedState: val.startsWith('{') ? 'authenticated' : 'ambiguous',
              primary: true
            }]
          }
        }
      },
      _experience: {
        mapping: {
          mapTo: 'xdm._experience'
        }
      }
    };
  }, 'Adapter:AEP', 'uuid', 'getCookie');
  /* global inject */
  inject((subscribe, namespace, resolve, netlog) => {
    subscribe({
      topic: 'AEP.beforeSendEvent',
      handler: ({
        sam,
        data,
        pageView,
        settings
      }) => {
        try {
          if (settings.pluginAdobeAnalytics) {
            const SiteCatalyst = resolve('Adapter:SiteCatalyst');
            const daa = namespace('__adobe.analytics', {}, data);
            const sdata = SiteCatalyst.helper.getSiteCatalystModelFromSemanticModel({}, sam);
            Object.assign(daa, sdata);
            if (!pageView) {
              Object.assign(daa, {
                linkName: sam.linkId,
                linkType: 'o'
              });
            }
          }
        } catch (error) {
          netlog({
            app: 'JSAF',
            category: 'AEP',
            action: 'AA Plugin Error',
            error
          });
        }
      }
    });
  }, 'subscribe', 'namespace', 'resolve', 'netlog');

  /* global inject */
  inject((subscribe, sessionStorage, uuid) => {
    subscribe({
      topic: 'AEP.beforeSendEvent',
      handler: ({
        disneyDataLayer,
        data,
        pageView,
        settings
      }) => {
        if (pageView && settings.pluginHelix) {
          Object.assign(data, {
            customer360: {
              session: getSessionInfo()
            },
            disneyDataLayer,
            document: {
              title: document.title
            }
          });
        }
      }
    });
    function getSessionInfo() {
      const storageKey = 'helix360';
      let sessionInfo = sessionStorage.getItem(storageKey);
      if (sessionInfo) {
        try {
          sessionInfo = JSON.parse(sessionInfo);
        } catch (e) {
          sessionInfo = null;
        }
      }
      if (!sessionInfo) {
        sessionInfo = {
          id: uuid(),
          startTime: Date.now()
        };
        sessionStorage.setItem(storageKey, JSON.stringify(sessionInfo));
      }
      return sessionInfo;
    }
  }, 'subscribe', 'sessionStorage', 'uuid');

  /* global inject */
  inject((Adapter, getURLParameter, localStorage, addPixel, objForEach, consentCategoryOverrides) => {
    const name = 'DerbySoft';
    const derbySoftAdapter = new Adapter({
      name,
      enabled: false,
      consentCategory: consentCategoryOverrides[name] || 'targeting',
      adapt,
      adaptOnce: true,
      validateEnabled,
      channelDataKey: 'afdscd',
      acquire
    });
    derbySoftAdapter.acquire();
    function adapt(sam) {
      const model = this.map(sam);
      if (!model || !this.enabled) return false;
      var params = [];
      if (!model.params || !model.params.channelCode) return;
      objForEach(model.params, (value, key) => {
        params.push(`${key}=${encodeURIComponent(value)}`);
      });
      addPixel(`https://linkcenterus.derbysoftca.com/dplatform-linkcenter/trackBooking?${params.join('&')}`);
    }
    function validateEnabled(model) {
      var events = model.events;
      if (this.enabled) {
        if (Array.isArray(events)) {
          events = events.join(',');
        }
        if (typeof events !== 'string' || !`,${events.toLowerCase()},`.includes(',purchase,') || !localStorage.getItem(this.channelDataKey)) {
          this.disable();
        }
      }
    }
    function getChannelData() {
      const cmp = getURLParameter('CMP');
      let parts;
      if (cmp && cmp.substr(0, 4) === 'MTC-') {
        parts = cmp.split('|');
        if (parts.length > 4) {
          return {
            channelCode: parts[2],
            channelSite: parts[4]
          };
        }
      }
    }
    function acquire() {
      const channelData = getChannelData();
      if (channelData) {
        localStorage.setItem(this.channelDataKey, channelData, 30);
      }
    }
  }, 'Adapter', 'getURLParameter', 'localStorage', 'addPixel', 'objForEach', 'consentCategoryOverrides');

  /* global inject */
  inject((derbySoftAdapter, ref, localStorage, getCookie, isoDate) => {
    derbySoftAdapter.mapping = {
      products: {
        mapping: {}
      },
      rrooms: {
        mapping: {
          mapTo: 'rooms',
          defaultValue: model => model.products.filter(r => r.productType === 'resortVacation')
        }
      },
      configuration: {
        DerbySoft: {
          accountCode: {
            mapping: {
              mapTo: 'params.accountCode',
              defaultValue: 'disney'
            }
          }
        }
      },
      currency: {
        mapping: {
          mapTo: 'params.currency',
          defaultValue: 'USD'
        }
      },
      orderId: {
        mapping: {
          mapTo: 'params.bookingNo',
          applyFilter: {
            length: 20
          }
        }
      },
      channelCode: {
        mapping: {
          mapTo: 'params.channelCode',
          defaultValue: () => (localStorage.getItem(derbySoftAdapter.channelDataKey) || {}).channelCode
        }
      },
      channelSite: {
        mapping: {
          mapTo: 'params.channelSite',
          defaultValue: () => (localStorage.getItem(derbySoftAdapter.channelDataKey) || {}).channelSite
        }
      },
      confirmationNo: {
        mapping: {
          mapTo: 'params.confirmationNo',
          defaultValue: firstObjProp('rooms', 'confirmationNumber')
        }
      },
      hotelCode: {
        mapping: {
          mapTo: 'params.hotelCode',
          defaultValue: firstObjProp('rooms', 'facilityId')
        }
      },
      roomTypeCode: {
        mapping: {
          mapTo: 'params.roomTypeCode',
          defaultValue: firstObjProp('rooms', 'roomTypeId')
        }
      },
      checkInDate: {
        mapping: {
          mapTo: 'params.checkInDate',
          defaultValue: isoDateFn(firstObjProp('rooms', 'bookingSearchArrivalDate'))
        }
      },
      checkOutDate: {
        mapping: {
          mapTo: 'params.checkOutDate',
          defaultValue: isoDateFn(firstObjProp('rooms', 'bookingSearchDepartureDate'))
        }
      },
      guests: {
        mapping: {
          mapTo: 'params.guests',
          defaultValue: model => model.rooms.reduce((p, c) => {
            return p + (+c.bookingSearchSeniors || 0) + (+c.bookingSearchAdults || 0) + (+c.bookingSearchChildren || 0) + (+c.bookingSearchInfants || 0);
          }, 0)
        }
      },
      rooms: {
        mapping: {
          mapTo: 'params.rooms',
          defaultValue: model => model.rooms.reduce((p, c) => {
            return p + (+c.numberRoomsBooked || +c.quantity || 0);
          }, 0)
        }
      },
      netAmount: {
        mapping: {
          mapTo: 'params.netAmount',
          defaultValue: model => model.rooms.reduce((p, c) => {
            return p + (+ref('price.subTotal', c) || 0);
          }, 0)
        }
      },
      totalAmount: {
        mapping: {
          mapTo: 'params.totalAmount',
          defaultValue: model => model.rooms.reduce((p, c) => {
            return p + (+ref('price.total', c) || 0);
          }, 0)
        }
      },
      device: {
        type: {
          mapping: {
            mapTo: 'params.device'
          }
        },
        viewType: {
          mapping: {
            mapTo: 'params.device'
          }
        }
      },
      cookiedevice: {
        mapping: {
          mapTo: 'params.device',
          defaultValue: model => {
            if (!model.params.device) {
              return ref('deviceInfo.device', getCookie('WDPROView', true));
            }
          }
        }
      }
    };
    function firstObjProp(arrRef, prop, startingValue = '') {
      return model => ref(arrRef, model).find(e => e[prop]) || startingValue;
    }
    function isoDateFn(fn) {
      return function () {
        return isoDate(fn.apply(this, arguments));
      };
    }
  }, 'Adapter:DerbySoft', 'ref', 'localStorage', 'getCookie', 'isoDate');

  /* global inject */
  inject((Adapter, consentCategoryOverrides) => {
    const name = 'DSMetasearch';
    new Adapter({
      name,
      enabled: false,
      consentCategory: consentCategoryOverrides[name] || 'performance',
      adapt,
      adaptOnce: true
    });
    function adapt(sam) {
      const model = this.map(sam);
      const {
        siteSection,
        dsclid,
        params,
        params: {
          event_type
        } = {},
        filteredProductsDisplayed
      } = model || {};
      if (!params || !event_type || !this.enabled) return;
      if (event_type === 'rate_selection' && typeof siteSection === 'string' && siteSection.includes('commerce') && filteredProductsDisplayed?.length > 0 || event_type === 'booking_complete' && dsclid) {
        const combined_params = window._bparams = Object.assign({}, params, model[event_type]?.params);
        try {
          pixel();
        } catch (error) {
          console.error('Error firing pixel', error);
        }
        return combined_params;
      }
    }

    // DS code that creates the tracking pixel - embedded from https://linkcenterus.derbysoftsec.com/pixel/v1/pixel.js because CSP
    function pixel() {
      !function (e) {
        var n = {};
        function t(r) {
          if (n[r]) return n[r].exports;
          var o = n[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
        }
        t.m = e, t.c = n, t.d = function (e, n, r) {
          t.o(e, n) || Object.defineProperty(e, n, {
            enumerable: !0,
            get: r
          });
        }, t.r = function (e) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, t.t = function (e, n) {
          if (1 & n && (e = t(e)), 8 & n) return e;
          if (4 & n && "object" == typeof e && e && e.__esModule) return e;
          var r = Object.create(null);
          if (t.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
          }), 2 & n && "string" != typeof e) for (var o in e) t.d(r, o, function (n) {
            return e[n];
          }.bind(null, o));
          return r;
        }, t.n = function (e) {
          var n = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return t.d(n, "a", n), n;
        }, t.o = function (e, n) {
          return Object.prototype.hasOwnProperty.call(e, n);
        }, t.p = "", t(t.s = 0);
      }([function (e, n, t) {
        "use strict";

        function r(e, n, t) {
          var r = new Date();
          r.setTime(r.getTime() + 24 * t * 60 * 60 * 1e3);
          var o = "expires=" + r.toGMTString();
          document.cookie = e + "=" + n + "; " + o + ";path=/";
        }
        if (t.r(n), "undefined" != typeof _bparams && null !== _bparams && _bparams.hasOwnProperty("is_landing_page") && "true" == _bparams.is_landing_page.toLowerCase()) {
          var o = function (e, n) {
            n || (n = window.location.href), e = e.replace(/[\[\]]/g, "\\$&");
            var t = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(n);
            return t ? t[2] ? decodeURIComponent(t[2].replace(/\+/g, " ")) : "" : null;
          }("dsclid");
          r("dsclid", null != o ? o : "", 30);
        }
        (function (e) {
          var n = function (e) {
              for (var n = e + "=", t = document.cookie.split(";"), r = 0; r < t.length; r++) {
                var o = t[r].trim();
                if (0 == o.indexOf(n)) return o.substring(n.length, o.length);
              }
              return "";
            }("dsclid"),
            t = window.location.href;
          null === n && (n = "");
          var r,
            o,
            i,
            a = e + "/pixelTagging?pu=" + encodeURIComponent(t);
          if ("undefined" != typeof _bparams && null !== _bparams) for (r in _bparams) _bparams.hasOwnProperty(r) && (a += "&" + r + "=" + encodeURI(_bparams[r]));
          o = a += "&dsclid=" + n, (i = document.createElement("img")).height = 1, i.width = 1, i.style = "border-style: none; display: none", i.alt = "", i.src = o, document.body.appendChild(i);
        })("https://linkcenter.derbysoftca.com/dplatform-linkcenter");
      }]); // eslint-disable-line
    }
  }, 'Adapter', 'consentCategoryOverrides');

  /* global inject */
  inject((DSMetasearchAdapter, Parsers, getURLParameter, localStorage, bookingSearchResortId) => {
    const lsKey = 'afdsaw';
    DSMetasearchAdapter.mapping = {
      configuration: {
        DSMetasearch: {
          pixelId: {
            mapping: {
              defaultValue: '10144',
              mapTo: 'params.pixel_id'
            }
          },
          accountId: {
            mapping: {
              defaultValue: 'disney',
              mapTo: 'params.account_id'
            }
          },
          colocatedRoomsEligible: {
            mapping: {
              defaultValue: false
            }
          }
        }
      },
      siteSection: {
        mapping: {}
      },
      pageType: {
        mapping: {
          defaultValue: 'unknown',
          applyFilter: {
            case: 'lower',
            replace: [['[^a-z]', '']]
          }
        }
      },
      _ds_event_type: {
        mapping: {
          mapTo: 'params.event_type',
          defaultValue: ({
            pageType
          }) => ({
            roomrates: 'rate_selection',
            confirmation: 'booking_complete'
          })[pageType]
        }
      },
      _ds_is_landing_page: {
        mapping: {
          mapTo: 'params.is_landing_page',
          defaultValue: () => {
            const dsclid = getURLParameter('dsclid');
            if (dsclid) {
              localStorage.setItem(lsKey, dsclid, 30);
              return 'TRUE';
            }
            return 'FALSE';
          }
        }
      },
      bookingSearchArrivalDate: {
        mapping: {
          mapTo: 'params.check_in_date',
          applyFilter: {
            date: {}
          }
        }
      },
      bookingSearchDepartureDate: {
        mapping: {
          mapTo: 'params.check_out_date',
          applyFilter: {
            date: {}
          }
        }
      },
      bookingSearchLengthOfStayNights: {
        mapping: {
          mapTo: 'los,params.stay_length',
          applyFilter: {
            type: 'number'
          }
        }
      },
      bookingSearchAdults: {
        mapping: {
          mapTo: 'params.adults',
          defaultValue: 0,
          applyFilter: {
            type: 'number'
          }
        }
      },
      bookingSearchChildren: {
        mapping: {
          mapTo: 'params.children',
          defaultValue: 0,
          applyFilter: {
            type: 'number'
          }
        }
      },
      _ds_total_guests: {
        mapping: {
          mapTo: 'params.total_guests',
          defaultValue: ({
            params
          }) => params.adults + params.children
        }
      },
      bookingSearchNumRooms: {
        mapping: {
          mapTo: 'params.rooms'
        }
      },
      bookingSearchResort: {
        mapping: {}
      },
      _ds_selected_resort_id: {
        mapping: {
          defaultValue: ({
            bookingSearchResort
          }) => bookingSearchResortId(bookingSearchResort)
        }
      },
      currencyDisplayed: {
        mapping: {
          mapTo: 'params.price_currency',
          defaultValue: 'USD'
        }
      },
      offerId: {
        offerName: {
          mapping: {
            mapTo: 'offerId',
            applyFilter: {
              case: 'lower',
              replace: [['[^a-z0-9]', '']]
            }
          }
        }
      },
      productsDisplayed: {
        mapping: {}
      },
      _ds_filtered_productsDisplayed: {
        mapping: {
          mapTo: 'filteredProductsDisplayed',
          defaultValue: ({
            productsDisplayed = [],
            _ds_selected_resort_id,
            offerId,
            colocatedRoomsEligible
          }) => {
            const isMetasearchEligible = productsDisplayed.some(p => 'metasearchEligible' in p) ? p => p.metasearchEligible : () => typeof offerId === 'string' && /^(roomonly|.*broad.*)$/i.test(offerId);
            return productsDisplayed.filter(p => (colocatedRoomsEligible || !_ds_selected_resort_id || p.parentResort === _ds_selected_resort_id) && isMetasearchEligible(p));
          }
        }
      },
      _ds_available_productsDisplayed: {
        mapping: {
          mapTo: 'availableProductsDisplayed',
          defaultValue: ({
            filteredProductsDisplayed = []
          }) => filteredProductsDisplayed.filter(p => p.isAvailable === true && typeof p.stayPrice?.total === 'number' && !isNaN(p.stayPrice?.total))
        }
      },
      _ds_lowest_priced_available_product_displayed: {
        mapping: {
          defaultValue: ({
            availableProductsDisplayed = [],
            filteredProductsDisplayed = []
          }) => {
            if (availableProductsDisplayed.length === 0) {
              const {
                offerId,
                packageCode
              } = filteredProductsDisplayed.find(p => p.offerId != null && p.offerId !== '') ?? {};
              return {
                offerId,
                packageCode
              };
            }
            return availableProductsDisplayed.reduce((p, c) => c.stayPrice.total < p.stayPrice.total ? c : p);
          },
          mapTo: (result, _, pd) => {
            Object.assign(result, {
              rate_selection: {
                params: {
                  hotel_id: pd.facilityId ?? getAvgFacilityId(result.filteredProductsDisplayed || result.productsDisplayed) ?? '',
                  room_type_id: pd.bookingRoomTypeId ?? pd.roomTypeId ?? '0',
                  room_type: pd.roomTypeName ?? '0',
                  price_base: strCurrency(pd.stayPrice?.subTotal ?? 0),
                  price_tax_fees: strCurrency(pd.stayPrice?.tax ?? ''),
                  price_total: strCurrency(pd.stayPrice?.total ?? ''),
                  rate_plan_id: pd.packageCode ?? '',
                  rate_plan_name: pd.offerId ?? ''
                }
              }
            });
          }
        }
      },
      products: {
        mapping: {}
      },
      _ds_res_products: {
        mapping: {
          mapTo: 'rooms',
          defaultValue: ({
            products = []
          }) => products.filter(product => product.productType === 'resortVacation' && product.confirmationNumber)
        }
      },
      _ds_purchased_room: {
        mapping: {
          defaultValue: ({
            rooms = []
          }) => rooms[0],
          mapTo: (result, _, pr) => {
            if (!pr) return;
            const adults = Number(pr.bookedAdults) || 0;
            const children = Number(pr.bookedChildren) || 0;
            const dsclid = localStorage.getItem(lsKey);
            if (dsclid) localStorage.removeItem(lsKey);
            Object.assign(result, {
              dsclid,
              booking_complete: {
                params: {
                  price_base: strCurrency(pr.price?.subTotal || 0),
                  price_tax_fees: strCurrency(pr.price?.tax || 0),
                  price_total: strCurrency(pr.price?.total || 0),
                  hotel_id: pr.facilityId,
                  room_type_id: pr.roomTypeId,
                  room_type: pr.roomTypeName,
                  rate_plan_id: pr.packageCode,
                  rate_plan_name: pr.offerId,
                  rooms: pr.bookingSearchNumRooms || 1,
                  adults,
                  children,
                  total_guests: adults + children,
                  check_in_date: dateFormat(pr.bookedArrivalDate || pr.bookingSearchArrivalDate),
                  check_out_date: dateFormat(pr.bookedDepartureDate || pr.bookingSearchDepartureDate),
                  stay_length: +pr.bookedLengthOfStayNights,
                  booking_id: pr.confirmationNumber
                }
              }
            });
          }
        }
      }
    };
    function strCurrency(num) {
      return typeof num === 'number' ? num.toFixed(2) : num;
    }
    function dateFormat(date) {
      return Parsers.applyFilter(date, {
        date: {}
      });
    }
    function getAvgFacilityId(productsDisplayed = []) {
      if (!Array.isArray(productsDisplayed) || productsDisplayed.length === 0) return;
      const facilityIdMap = productsDisplayed.reduce((acc, {
        facilityId
      }) => {
        if (facilityId) acc[facilityId] = (acc[facilityId] || 0) + 1;
        return acc;
      }, {});
      return Object.entries(facilityIdMap).reduce((a, b) => a[1] > b[1] ? a : b, ['', 0])[0];
    }
  }, 'Adapter:DSMetasearch', 'Parsers', 'getURLParameter', 'localStorage', 'bookingSearchResortId');

  /* global inject */
  inject((Adapter, addScript, once, ref, set, objForEach, ensureArray, ensureObject, removeDuplicates, resolve, consentCategoryOverrides) => {
    const name = 'Facebook';
    new Adapter({
      name,
      enabled: true,
      consentCategory: consentCategoryOverrides[name] || 'targeting',
      adapt,
      adaptOnce: true,
      init: once(loadFacebookLibrary)
    });
    const fbInit = once(pixelId => window.fbq('init', pixelId));
    const arrayProps = ['destination_ids', 'content_type', 'ticket_name'];
    function adapt(sam) {
      const model = this.map(sam);
      if (!model || !this.enabled) return false;
      if (model.config.hasOwnProperty('autoConfig')) {
        window.fbq('set', 'autoConfig', model.config.autoConfig, model.config.pixelId);
      }
      fbInit(model.config.pixelId);
      fbNormalize(model);
      promoteProductArrayProps(model);
      promoteProductProps(model);
      model.params.destination_ids = removeDuplicates(model.params.destination_ids);
      model.params.content_type = removeDuplicates(model.params.content_type);
      processUrlMappings(model);
      arrayProps.forEach(prop => {
        if (model.params[prop].length === 0) delete model.params[prop];
      });
      if (model.params.destination_ids) model.params.content_ids = model.params.destination_ids;
      if (model.event[0] === 'PageView' && model.params.destination_ids) {
        model.event = ['ViewContent'];
      }
      model.event.forEach(event => {
        const {
          params,
          eventID
        } = model;
        const args = ['track', event, params];
        if (eventID) args.push({
          eventID
        });
        window.fbq(...args);
      });
      resolve('Framework').fireEvent({
        event: 'FacebookAdapterComplete',
        data: {
          fbPixelId: model.config.pixelId,
          event: model.event.join(','),
          params: model.params,
          eventID: model.eventID
        }
      });
      return model;
    }
    function loadFacebookLibrary() {
      var fbq;
      if (window.fbq) return;
      fbq = window.fbq = function () {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, arguments);
        } else {
          fbq.queue.push(arguments);
        }
      };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      addScript('//connect.facebook.net/en_US/fbevents.js');
    }
    function fbNormalize(model) {
      normalizeParams(model);
      model.productsDisplayed = ensureArray(model.productsDisplayed);
      model.productsDisplayed.forEach(normalizeParams);
      model.products = ensureArray(model.products);
      model.products.sort(byProductType);
      model.products.forEach(prod => {
        normalizeParams(prod);
        prod.includedProducts = ensureArray(prod.includedProducts);
        prod.includedProducts.forEach(normalizeParams);
      });
    }
    function normalizeParams(obj) {
      obj.params = ensureObject(obj.params);
      arrayProps.forEach(prop => {
        obj.params[prop] = ensureArray(obj.params[prop]);
      });
    }
    function byProductType(a, b) {
      var sortValues = {
        resortVacation: 2,
        cruise: 1
      };
      return (sortValues[a.productType] || 0) - (sortValues[b.productType] || 0);
    }
    function promoteProductArrayProps(model) {
      [model.productsDisplayed, model.products, model.includedProducts].forEach(productsArr => {
        if (Array.isArray(productsArr)) productsArr.forEach(product => {
          promoteProductArrayProps(product);
          arrayProps.forEach(prop => {
            model.params[prop].push(...product.params[prop]);
            delete product.params[prop];
          });
        });
      });
    }
    function promoteProductProps(model) {
      var resort_type = ref('productsDisplayed.0.params.resort_type', model);
      if (resort_type && model.productsDisplayed.every(prod => prod.params.resort_type === resort_type)) {
        model.params.resort_type = resort_type;
      }
      model.productsDisplayed.forEach(prod => prod.params && delete prod.params.resort_type);
      [model.productsDisplayed, model.products].forEach(arr => {
        arr.forEach(prod => {
          objForEach(prod.params, moveProp);
        });
      });
      function moveProp(val, key, obj) {
        model.params[key] = val;
        delete obj[key];
      }
    }
    function processUrlMappings(model) {
      if (Array.isArray(model.config.urlMapping)) {
        model.config.urlMapping.forEach(obj => {
          var reg, match, result, currentValue;
          if (obj.to && Array.isArray(obj.regexp) && (reg = new RegExp(obj.regexp[0], obj.regexp[1])) && (match = reg.exec(location.href)) && (result = match[1] || match[0])) {
            // normalize obj.to for backwards compatibility
            if (obj.to === 'fbDestinationId' || obj.to === 'params.destination_id') {
              obj.to = 'params.destination_ids';
            }
            currentValue = ref(obj.to, model);
            if (obj.push || obj.to === 'params.destination_ids' || obj.to === 'params.content_type') {
              currentValue = ensureArray(currentValue);
              currentValue.push(result);
              set(model, obj.to, currentValue);
            } else if (obj.overwrite || currentValue === undefined) {
              set(model, obj.to, result);
            }
          }
        });
      }
    }
  }, 'Adapter', 'addScript', 'once', 'ref', 'set', 'objForEach', 'ensureArray', 'ensureObject', 'removeArrayDuplicates', 'resolve', 'consentCategoryOverrides');

  /* global inject */
  inject((facebookAdapter, moment, ref) => {
    var roomProductTypes = ['resortVacation', 'cruise'];
    facebookAdapter.mapping = {
      configuration: {
        Facebook: {
          advertiserId: {
            mapping: {
              mapTo: 'config.pixelId',
              defaultValue: '397422390408189'
            }
          },
          autoConfig: {
            mapping: {
              mapTo: 'config.autoConfig',
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          destinationId: {
            mapping: {
              mapTo: 'Search.destination_ids,ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids'
            }
          },
          urlMapping: {
            mapping: {
              mapTo: 'config.urlMapping'
            }
          },
          destination: {
            mapping: {
              mapTo: 'Search.destination,ViewContent.destination,InitiateCheckout.destination,Purchase.destination'
            }
          },
          pageType: {
            mapping: {
              mapTo: 'InitiateCheckout.page_type'
            }
          },
          separateCartCheckoutEvents: {
            mapping: {
              mapTo: 'config.separateCartCheckoutEvents',
              applyFilter: {
                type: 'boolean'
              }
            }
          }
        }
      },
      currency: {
        mapping: {
          mapTo: 'ViewContent.currency,InitiateCheckout.currency,Purchase.currency',
          defaultValue: 'USD'
        }
      },
      site: {
        mapping: {
          mapTo: 'PageView.site,Search.site,ViewContent.site,InitiateCheckout.site,Purchase.site'
        }
      },
      events: {
        mapping: {
          mapTo: 'events'
        }
      },
      pageType: {
        mapping: {
          mapTo: 'InitiateCheckout.page_type'
        }
      },
      bookingSearchSeniors: {
        mapping: {
          mapTo: 'bookingSearchSeniors',
          applyFilter: {
            type: 'int'
          }
        }
      },
      bookingSearchAdults: {
        mapping: {
          mapTo: 'bookingSearchAdults',
          applyFilter: {
            type: 'int'
          }
        }
      },
      num_adults: {
        mapping: {
          mapTo: 'Search.num_adults,ViewContent.num_adults,InitiateCheckout.num_adults,Purchase.num_adults',
          defaultValue: mappedModel => (mappedModel.bookingSearchAdults || 0) + (mappedModel.bookingSearchSeniors || 0)
        }
      },
      bookingSearchChildren: {
        mapping: {
          mapTo: 'bookingSearchChildren',
          applyFilter: {
            type: 'int'
          }
        }
      },
      bookingSearchInfants: {
        mapping: {
          mapTo: 'bookingSearchInfants',
          applyFilter: {
            type: 'int'
          }
        }
      },
      num_children: {
        mapping: {
          mapTo: 'Search.num_children,ViewContent.num_children,InitiateCheckout.num_children,Purchase.num_children',
          defaultValue: mappedModel => (mappedModel.bookingSearchInfants || 0) + (mappedModel.bookingSearchChildren || 0)
        }
      },
      bookingSearchDaysBetweenSearchAndArrival: {
        mapping: {
          mapTo: 'Search.booking_window,ViewContent.booking_window,InitiateCheckout.booking_window,Purchase.booking_window'
        }
      },
      bookingSearchArrivalDate: {
        mapping: {
          mapTo: 'Search.checkin_date,ViewContent.checkin_date,InitiateCheckout.checkin_date,Purchase.checkin_date',
          applyFilter: {
            date: {}
          }
        }
      },
      bookingSearchDepartureDate: {
        mapping: {
          mapTo: 'Search.checkout_date,ViewContent.checkout_date,InitiateCheckout.checkout_date,Purchase.checkout_date',
          applyFilter: {
            date: {}
          }
        }
      },
      bookingSearchLengthOfStayNights: {
        mapping: {
          mapTo: 'Search.num_nights,ViewContent.num_nights,InitiateCheckout.num_nights,Purchase.num_nights'
        }
      },
      bookingSearchShip: {
        mapping: {
          mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
        }
      },
      ship: {
        mapping: {
          mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
        }
      },
      device: {
        type: {
          mapping: {
            mapTo: 'Search.device_type,ViewContent.device_type,InitiateCheckout.device_type,Purchase.device_type'
          }
        }
      },
      productsDisplayed: [{
        facilityId: {
          mapping: {
            mapTo: 'Search.destination_ids,ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids'
          }
        },
        facilityTier: {
          mapping: {
            mapTo: 'Search.resort_type,ViewContent.resort_type'
          }
        },
        sailingId: {
          mapping: {
            mapTo: 'Search.destination_ids,ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids'
          }
        },
        bookingSearchShip: {
          mapping: {
            mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
          }
        },
        ship: {
          mapping: {
            mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
          }
        },
        content_type: {
          mapping: {
            mapTo: 'PageView.content_type,Search.content_type,ViewContent.content_type,InitiateCheckout.content_type,Purchase.content_type',
            defaultValue: ['hotel', 'product', 'destination']
          }
        }
      }],
      location: {
        city: {
          mapping: {
            mapTo: 'Search.city,ViewContent.city,InitiateCheckout.city,Purchase.city'
          }
        },
        region: {
          mapping: {
            mapTo: 'Search.region,ViewContent.region,InitiateCheckout.region,Purchase.region'
          }
        },
        country: {
          mapping: {
            mapTo: 'Search.country,ViewContent.country,InitiateCheckout.country,Purchase.country'
          }
        }
      },
      products: [{
        productType: {
          mapping: {
            mapTo: 'ViewContent.content_category,InitiateCheckout.content_category,Purchase.content_category,productType'
          }
        },
        packageType: {
          mapping: {}
        },
        bookingSearchChildrenAges: {
          mapping: {
            mapTo: 'kidAges',
            defaultValue: [],
            applyFilter: {
              num: arr => arr.map(Number)
            }
          }
        },
        quantity: {
          mapping: {
            applyFilter: {
              type: 'integer'
            }
          }
        },
        facilityId: {
          mapping: {
            mapTo: 'Search.destination_ids,ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids'
          }
        },
        sailingId: {
          mapping: {
            mapTo: 'Search.destination_ids,ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids'
          }
        },
        productId: {
          mapping: {
            mapTo: product => /ticket|pass/i.test(product.productType) ? 'Search.destination_ids,ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids' : ''
          }
        },
        name: {
          mapping: {
            mapTo: product => /ticket|pass/i.test(product.productType) ? 'Search.ticket_name,ViewContent.ticket_name,InitiateCheckout.ticket_name,Purchase.ticket_name' : ''
          }
        },
        destination: {
          mapping: {
            mapTo: 'Search.destination,ViewContent.destination,InitiateCheckout.destination,Purchase.destination'
          }
        },
        facilityName: {
          mapping: {
            mapTo: product => product.productType === 'cruise' ? 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship' : 'ViewContent.destination_name,InitiateCheckout.destination_name,Purchase.destination_name'
          }
        },
        bookingSearchShip: {
          mapping: {
            mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
          }
        },
        ship: {
          mapping: {
            mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
          }
        },
        stateroom: {
          location: {
            mapping: {
              mapTo: 'InitiateCheckout.ship_location,Purchase.ship_location'
            }
          },
          category: {
            mapping: {
              mapTo: 'InitiateCheckout.category,Purchase.category'
            }
          }
        },
        facilityTier: {
          mapping: {
            mapTo: 'ViewContent.resort_type,InitiateCheckout.resort_type,Purchase.resort_type'
          }
        },
        bookingSearchArrivalDate: {
          mapping: {
            mapTo: 'checkin_date,Search.checkin_date,ViewContent.checkin_date,InitiateCheckout.checkin_date,Purchase.checkin_date',
            applyFilter: {
              date: {}
            }
          }
        },
        bookedArrivalDate: {
          mapping: {
            mapTo: 'checkin_date,Search.checkin_date,ViewContent.checkin_date,InitiateCheckout.checkin_date,Purchase.checkin_date',
            applyFilter: {
              date: {}
            }
          }
        },
        arrival_window: {
          mapping: {
            mapTo: 'Purchase.arrival_window',
            defaultValue: product => product.checkin_date && moment(product.checkin_date).diff(moment().startOf('day'), 'days')
          }
        },
        month: {
          mapping: {
            mapTo: 'Search.month,ViewContent.month,InitiateCheckout.month,Purchase.month',
            defaultValue: product => product.checkin_date && moment(product.checkin_date).format('M')
          }
        },
        bookingSearchDepartureDate: {
          mapping: {
            mapTo: 'Search.checkout_date,ViewContent.checkout_date,InitiateCheckout.checkout_date,Purchase.checkout_date',
            applyFilter: {
              date: {}
            }
          }
        },
        bookingSearchDaysBetweenSearchAndArrival: {
          mapping: {
            mapTo: 'Search.booking_window,ViewContent.booking_window,InitiateCheckout.booking_window,Purchase.booking_window'
          }
        },
        daysBetweenBookingAndArrival: {
          mapping: {
            mapTo: 'Search.booking_window,ViewContent.booking_window,InitiateCheckout.booking_window,Purchase.booking_window'
          }
        },
        bookingSearchLengthOfStayNights: {
          mapping: {
            mapTo: 'Search.num_nights,ViewContent.num_nights,InitiateCheckout.num_nights,Purchase.num_nights'
          }
        },
        bookedLengthOfStayNights: {
          mapping: {
            mapTo: 'Search.num_nights,ViewContent.num_nights,InitiateCheckout.num_nights,Purchase.num_nights'
          }
        },
        bookingSearchSeniors: {
          mapping: {
            mapTo: 'partymix.seniors',
            applyFilter: {
              type: 'int'
            }
          }
        },
        bookedSeniors: {
          mapping: {
            mapTo: 'partymix.seniors',
            applyFilter: {
              type: 'int'
            }
          }
        },
        bookingSearchAdults: {
          mapping: {
            mapTo: 'partymix.adults',
            applyFilter: {
              type: 'int'
            }
          }
        },
        bookedAdults: {
          mapping: {
            mapTo: 'partymix.adults',
            applyFilter: {
              type: 'int'
            }
          }
        },
        bookingSearchChildren: {
          mapping: {
            mapTo: 'partymix.children',
            applyFilter: {
              type: 'int'
            }
          }
        },
        bookedChildren: {
          mapping: {
            mapTo: 'partymix.children',
            applyFilter: {
              type: 'int'
            }
          }
        },
        bookingSearchInfants: {
          mapping: {
            mapTo: 'partymix.infants',
            applyFilter: {
              type: 'int'
            }
          }
        },
        bookedInfants: {
          mapping: {
            mapTo: 'partymix.infants',
            applyFilter: {
              type: 'int'
            }
          }
        },
        num_adults: {
          mapping: {
            mapTo: 'num_adults,Search.num_adults,ViewContent.num_adults,InitiateCheckout.num_adults,Purchase.num_adults',
            defaultValue: product => {
              if (product.partymix) {
                return (product.partymix.adults || 0) + (product.partymix.seniors || 0);
              }
            }
          }
        },
        num_children: {
          mapping: {
            mapTo: 'Search.num_children,ViewContent.num_children,InitiateCheckout.num_children,Purchase.num_children',
            defaultValue: product => {
              if (product.partymix) {
                return (product.partymix.children || 0) + (product.partymix.infants || 0);
              }
            }
          }
        },
        numberRoomsBooked: {
          mapping: {
            mapTo: 'ViewContent.num_rooms,InitiateCheckout.num_rooms,Purchase.num_rooms',
            defaultValue: model => {
              if (roomProductTypes.includes(model.productType)) {
                return model.quantity || 1;
              }
            }
          }
        },
        content_type: {
          mapping: {
            mapTo: 'PageView.content_type,Search.content_type,ViewContent.content_type,InitiateCheckout.content_type,Purchase.content_type',
            defaultValue: ['hotel', 'product', 'destination']
          }
        },
        events: {
          mapping: {
            type: 'flex-array',
            valueDelimiter: '=',
            mapTo: {
              cartAdd: 'AddToCart'
            }
          }
        },
        price: {
          total: {
            mapping: {
              mapTo: 'product_value'
            }
          }
        },
        includedProducts: [{
          id: {
            mapping: {
              mapTo: 'ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids,Search.destination_ids'
            }
          },
          name: {
            mapping: {
              mapTo: 'ViewContent.ticket_name,InitiateCheckout.ticket_name,Purchase.ticket_name,Search.ticket_name'
            }
          }
        }],
        embarkation: {
          mapping: {}
        },
        disembarkation: {
          mapping: {}
        },
        fb_ports: {
          mapping: {
            defaultValue: model => {
              const destinations = [model.Search, model.ViewContent, model.InitiateCheckout, model.Purchase];
              [{
                src: model.embarkation,
                prefix: '',
                combined: 'departure_port'
              }, {
                src: model.disembarkation,
                prefix: 'disembarkation_',
                combined: 'disembarkation_port'
              }].forEach(config => {
                const {
                  src,
                  prefix,
                  combined
                } = config;
                if (!src) return;
                if (src.city && src.region && src.country) {
                  destinations.forEach(destination => {
                    destination[`${prefix}city`] = src.city;
                    destination[`${prefix}region`] = src.region;
                    destination[`${prefix}country`] = src.country;
                  });
                } else if (src.combined) {
                  destinations.forEach(destination => {
                    destination[combined] = src.combined;
                  });
                } else if (src.city && src.region) {
                  destinations.forEach(destination => {
                    destination[`${prefix}city`] = src.city;
                    destination[`${prefix}region`] = src.region;
                  });
                }
              });
            }
          }
        },
        mapping: {
          applyFilter: {
            removeCartRemove: products => {
              if (Array.isArray(products)) {
                return products.filter(product => !product.events || !product.events.includes('cartRemove'));
              }
            }
          }
        }
      }],
      totalBookedLengthOfStayNights: {
        mapping: {
          mapTo: 'Search.num_nights,ViewContent.num_nights,InitiateCheckout.num_nights,Purchase.num_nights'
        }
      },
      productTotal: {
        mapping: {
          mapTo: 'ViewContent.value,InitiateCheckout.value,Purchase.value',
          defaultValue: '0'
        }
      },
      themepark_tickets: {
        mapping: {
          mapTo: 'InitiateCheckout.themepark_tickets,Purchase.themepark_tickets',
          defaultValue: model => {
            return productsOfType(model.products, 'ticket').reduce((p, c) => p + c.quantity, 0) + packages(model.products).reduce((p, c) => p + packageTickets(c), 0);
          }
        }
      },
      room_value: {
        mapping: {
          mapTo: 'ViewContent.room_value,InitiateCheckout.room_value,Purchase.room_value',
          defaultValue: model => productsOfType(model.products, 'resortVacation').reduce((p, c) => p + (+c.product_value || 0), 0) || undefined
        }
      },
      pageGroupId: {
        mapping: {
          mapTo: 'eventID'
        }
      },
      orderId: {
        mapping: {
          mapTo: 'eventID'
        }
      },
      event: {
        mapping: {
          mapTo: 'event',
          defaultValue: model => {
            var event = ['PageView'],
              events = model.events || [];
            if (someMatch(events, /purchase/i)) {
              event = ['Purchase'];
            } else if (!model.config.separateCartCheckoutEvents && someMatch(events, /checkout|cart/i)) {
              event = ['InitiateCheckout', 'AddToCart'];
            } else if (someMatch(events, /checkout/i)) {
              event = ['InitiateCheckout'];
            } else if (someMatch(events, /cart/i)) {
              event = ['AddToCart'];
            } else if (someMatch(events, /search/i)) {
              event = ['Search'];
            } else if (ref('ViewContent.destination_ids', model) || ref('productsDisplayed.0.ViewContent.destination_ids', model) || someMatch(events, /prodview|productview/i)) {
              event = ['ViewContent'];
            }
            promoteEvent(event, model);
            return event;
          }
        }
      }
    };
    function packages(products) {
      return productsOfType(products, 'resortVacation').filter(p => p.packageType === 'Packages');
    }
    function packageTickets(pkg) {
      return pkg.num_adults + pkg.kidAges.filter(a => a > 2).length;
    }
    function productsOfType(products, type) {
      return Array.isArray(products) ? products.filter(product => product.productType === type) : [];
    }
    function promoteEvent(event, model) {
      var e = event[0];
      if (model) {
        if (model[e]) model.params = model[e];
        delete model.PageView;
        delete model.Search;
        delete model.ViewContent;
        delete model.InitiateCheckout;
        delete model.Purchase;
        [model.productsDisplayed, model.products, model.includedProducts].forEach(prodArr => {
          if (Array.isArray(prodArr)) prodArr.forEach(prod => {
            promoteEvent(event, prod);
          });
        });
      }
    }
    function someMatch(strArr, regex) {
      return strArr.some(str => typeof str === 'string' && regex.test(str));
    }
  }, 'Adapter:Facebook', 'moment', 'ref');
  /* global inject */
  inject((Adapter, addPixel, objForEach, consentCategoryOverrides) => {
    const name = 'GoogleHotels';
    new Adapter({
      name,
      enabled: false,
      consentCategory: consentCategoryOverrides[name] || 'targeting',
      adapt,
      adaptOnce: true,
      validateEnabled
    });
    function adapt(sam) {
      const model = this.map(sam);
      if (!model || !this.enabled) return false;
      var data = [];
      objForEach(model.data, (value, key) => data.push(`${key}=${value}`));
      addPixel(`https://www.googletraveladservices.com/travel/clk/pagead/conversion/1224626585/?label=HPA&guid=ON&script=0&ord=${String(Math.random()).substr(2)}&data=${encodeURIComponent(data.join(';'))}`);
    }
    function validateEnabled(model) {
      if (this.enabled && !(model.events || []).includes('purchase')) this.disable();
    }
  }, 'Adapter', 'addPixel', 'objForEach', 'consentCategoryOverrides');

  /* global inject */
  inject((googleHotelsAdapter, moment, ref, isoDate, sha1) => {
    googleHotelsAdapter.mapping = {
      products: {
        mapping: {}
      },
      rrooms: {
        mapping: {
          mapTo: 'rooms',
          defaultValue: model => model.products.filter(r => r.productType === 'resortVacation')
        }
      },
      hct_partner_hotel_id: {
        mapping: {
          mapTo: 'data.hct_partner_hotel_id',
          defaultValue: firstObjProp('rooms', 'facilityId')
        }
      },
      hct_base_price: {
        mapping: {
          mapTo: 'data.hct_base_price',
          defaultValue: model => model.rooms.reduce((p, c) => {
            return p + (+ref('price.subTotal', c) || 0);
          }, 0)
        }
      },
      hct_total_price: {
        mapping: {
          mapTo: 'data.hct_total_price',
          defaultValue: model => model.rooms.reduce((p, c) => {
            return p + (+ref('price.total', c) || 0);
          }, 0)
        }
      },
      currency: {
        mapping: {
          mapTo: 'data.hct_currency_code',
          defaultValue: 'USD'
        }
      },
      hct_checkin_date: {
        mapping: {
          mapTo: 'data.hct_checkin_date',
          defaultValue: isoDateFn(firstObjProp('rooms', 'bookingSearchArrivalDate'))
        }
      },
      hct_checkout_date: {
        mapping: {
          mapTo: 'data.hct_checkout_date',
          defaultValue: isoDateFn(firstObjProp('rooms', 'bookingSearchDepartureDate'))
        }
      },
      hct_length_of_stay: {
        mapping: {
          mapTo: 'data.hct_length_of_stay',
          defaultValue: firstObjProp('rooms', 'bookingSearchLengthOfStayNights')
        }
      },
      hct_date_format: {
        mapping: {
          mapTo: 'data.hct_date_format',
          defaultValue: '%Y-%m-%d'
        }
      },
      orderId: {
        mapping: {}
      },
      hct_booking_xref: {
        mapping: {
          mapTo: 'data.hct_booking_xref',
          defaultValue: model => sha1(model.orderId)
        }
      },
      hct_ver: {
        mapping: {
          mapTo: 'data.hct_ver',
          defaultValue: '1.0.i'
        }
      }
    };
    function firstObjProp(arrRef, prop, startingValue = '') {
      return model => ref(arrRef, model).find(e => e[prop]) || startingValue;
    }
    function isoDateFn(fn) {
      return function () {
        return isoDate(fn.apply(this, arguments));
      };
    }
  }, 'Adapter:GoogleHotels', 'moment', 'ref', 'isoDate', 'sha1');

  /* global inject */
  inject((Adapter, $, resolve, consentCategoryOverrides) => {
    const name = 'Omni';
    new Adapter({
      name,
      enabled: false,
      consentCategory: consentCategoryOverrides[name] || 'performance',
      adapt,
      adaptOnce: true
    });
    function adapt(sam) {
      const model = this.map(sam);
      if (!model || !this.enabled) return false;
      var Framework = resolve('Framework'),
        csrfToken = $(model.config.csrfSelector).val(),
        data = {
          analyticsId: model.visitorId
        };
      data[model.config.csrfField] = csrfToken;
      $.post(model.config.endpoint, data).done(() => {
        Framework.fireEvent({
          event: 'OmniVisitorPostSuccess.framework'
        });
      }).fail(() => {
        Framework.fireEvent({
          event: 'OmniVisitorPostFailure.framework'
        });
      }).always(() => {
        Framework.fireEvent({
          event: 'OmniAdapterComplete.framework'
        });
      });
    }
  }, 'Adapter', '$', 'resolve', 'consentCategoryOverrides');

  /* global inject */
  inject((omniAdapter, Analytics) => {
    omniAdapter.mapping = {
      configuration: {
        Omni: {
          endpoint: {
            mapping: {
              mapTo: 'config.endpoint',
              defaultValue: '/session/set-analytics-id'
            }
          },
          csrfField: {
            mapping: {
              mapTo: 'config.csrfField',
              defaultValue: 'pep_csrf'
            }
          },
          csrfSelector: {
            mapping: {
              mapTo: 'config.csrfSelector',
              defaultValue: '#csrfToken'
            }
          }
        }
      },
      visitorId: {
        mapping: {
          mapTo: 'visitorId',
          defaultValue: () => Analytics.Exports.VisitorId
        }
      }
    };
  }, 'Adapter:Omni', 'Analytics');

  /* global inject */
  inject((Framework, Adapter, netlog, objForEach, $, extend, publish, dbg, memoize, debounce, isEmptyObject, consentCategoryOverrides) => {
    const name = 'AdobeTarget';
    const targetAdapter = new Adapter({
      name,
      enabled: true,
      consentCategory: consentCategoryOverrides[name] || 'targeting',
      adapt,
      adaptOnce: false,
      mode: ['web', 'webview'],
      defineAndUpdateMbox,
      validateEnabled
    });
    const getPubFn = memoize(function () {
      return debounce(publish, 5000);
    }, {
      serialize: function (obj) {
        const experience = obj && obj.data && obj.data.experience,
          tokens = experience && experience.responseTokens,
          campaignId = tokens && tokens['activity.id'];
        return campaignId || JSON.stringify(tokens || experience || obj);
      }
    });
    $.fn.mboxTrack = function (options) {
      var settings = {},
        defaults = {
          reclick: false,
          timeout: 580,
          param: ''
        };
      netlog({
        app: 'JSAF',
        category: 'target_compat',
        action: '$.fn.mboxTrack',
        options,
        sampling: 0.1
      });
      if (!options || !options.mbox) {
        return false;
      }
      extend(true, settings, defaults, options);
      return this.one('click', function (event) {
        var el = this;
        if (settings.reclick) event.preventDefault();
        window.adobe.target.trackEvent({
          mbox: settings.mbox,
          params: convertToParamsObj(settings.param)
        });
        if (settings.reclick) setTimeout(() => el.click(), settings.timeout);
      });
    };
    function pub() {
      return getPubFn.apply(this, arguments).apply(this, arguments);
    }
    function isBookedProduct(events) {
      return events.includes('purchase');
    }
    function adapt(sam) {
      const model = this.map(sam);
      if (!model || !this.enabled) return false;
      dbg.info('Target adapter called with', model);
      var {
          contentTests: tests = [],
          params = {},
          profiles = {},
          params: {
            events = '',
            siteSection = '',
            pageId = ''
          } = {},
          site = '',
          targetGlobalMbox,
          globalMbox,
          dynamicMboxes,
          products = [],
          productsDisplayed = [],
          productsPurchased = [],
          eventsData = {},
          channelSeparator,
          order = {},
          property,
          targetContext,
          targetMode
        } = model,
        common = {
          parameters: params,
          profileParameters: profiles,
          product: {},
          order
        },
        productIds,
        regEx,
        timestamp = targetAdapter.timestamp = Date.now(),
        request = {
          execute: {
            mboxes: []
          }
        },
        index = tests.findIndex(t => t.contentTestModuleName === 'target-global-mbox');
      if (index > -1) {
        targetGlobalMbox = true;
        tests.splice(index, 1);
      }
      if (targetGlobalMbox) {
        request.execute.pageLoad = {};
      }
      if (globalMbox && site) {
        tests.push({
          contentPosition: 'append',
          contentTestHTMLTargetElement: 'body',
          contentTestModuleName: `${site.toUpperCase()}_Global_Mbox`
        });
      }
      if (dynamicMboxes && site && siteSection && pageId && channelSeparator) {
        regEx = new RegExp(channelSeparator, 'g');
        tests.push({
          contentPosition: 'append',
          contentTestHTMLTargetElement: 'body',
          contentTestModuleName: `${site.toUpperCase()}_${siteSection.replace(regEx, '_')}_${pageId}_Mbox`
        });
      }
      publish({
        topic: 'target.determinedMboxes',
        tests,
        request,
        model,
        target: window.adobe.target
      });

      // exit early if there are no mboxes
      if (tests.length === 0 && !request.execute.pageLoad) {
        dbg.info('Target adapter exiting early due to no mboxes defined');
        Framework.fireEvent({
          event: 'AdobeTargetAdapterComplete',
          data: model
        });
        return false;
      }
      dbg.info('Target adapter continuing with ', tests, request.execute.pageLoad ? 'with target-global-mbox' : 'without target-global-mbox');
      events.split(',').filter(e => e && e !== '[object Object]').forEach(event => {
        common.profileParameters[event] = eventsData[event] || timestamp;
      });
      if (Array.isArray(productsDisplayed) && productsDisplayed.length > 0) {
        extend(common.parameters, productsDisplayed[0].params);
      }
      if (productIds = pids(products, common)) {
        if (isBookedProduct(events)) {
          common.order.purchasedProductIds = productIds;
        } else {
          common.product.id = productIds.join(',').slice(0, 128);
        }
        common.parameters.productIds = productIds.join(',');
      }
      if (productIds = pids(productsPurchased, common)) {
        common.order.purchasedProductIds = common.order.purchasedProductIds ? common.order.purchasedProductIds.concat(productIds) : productIds;
      }
      if (targetContext) extend(common.parameters, targetContext);
      if (targetMode) common.parameters.mode = targetMode;
      objForEach(common, (val, key) => {
        if (isEmptyObject(val)) delete common[key];
      });
      dbg.info('Target adapter params:', common);
      if (request.execute.pageLoad) extend(request.execute.pageLoad, common);
      tests.forEach((test, i) => {
        var mboxConfig = extend({
          name: test.contentTestModuleName,
          index: i
        }, common);

        // Merging contentTestParams with general parameters
        objForEach(test.contentTestParams, (value, param) => {
          if (param.indexOf('profile.') === 0) {
            mboxConfig.profileParameters[param.substr(8)] = value;
          } else {
            mboxConfig.parameters[param] = value;
          }
        });
        request.execute.mboxes.push(mboxConfig);
      });
      if (property) request.property = property;
      dbg.info('Target adapter getOffers being called with', {
        request
      });
      publish({
        topic: 'target.beforeGetOffers',
        request,
        target: window.adobe.target
      });
      window.adobe.target.getOffers({
        request
      }).then(response => {
        dbg.info('Target adapter getOffers returned', {
          response
        });
        window.adobe.target.applyOffers({
          response
        });
        notifyOffers(response, model);
      }).catch(error => {
        dbg.error('Target adapter error in getOffers/applyOffers', {
          error
        });
        netlog({
          app: 'JSAF',
          category: 'target_adapter_error',
          action: 'getOffers/applyOffers',
          error,
          request,
          sampling: 0.05
        });
      });
      Framework.fireEvent({
        event: 'AdobeTargetAdapterComplete',
        data: model
      });
    }
    function validateEnabled() {
      if (!window.adobe || !window.adobe.target || !window.adobe.target.VERSION) this.disable();
    }
    function defineAndUpdateMbox(selector, mboxName, position, parameters) {
      netlog({
        app: 'JSAF',
        category: 'target_compat',
        action: 'targetadapter.defineAndUpdateMbox',
        selector,
        mboxName,
        position,
        parameters,
        sampling: 0.1
      });
      window.adobe.target.getOffer({
        mbox: mboxName,
        params: parameters,
        success: offer => {
          window.adobe.target.applyOffer({
            mbox: mboxName,
            selector,
            offer
          });
        },
        error: (status, err) => {
          netlog({
            app: 'JSAF',
            category: 'target_compat',
            action: 'targetadapter.defineAndUpdateMbox.error',
            status,
            err,
            selector,
            mboxName
          });
        }
      });
      Framework.fireEvent({
        event: 'mBoxCallInitiated',
        data: {
          name: mboxName,
          params: parameters
        }
      });
    }
    function convertToParamsObj(paramStr) {
      var obj = {},
        paramArr = paramStr.split('&');
      paramArr.forEach(param => {
        var i = param.indexOf('=');
        obj[i > -1 ? param.substr(0, i) : param] = i > -1 ? param.substr(i + 1) : '';
      });
      return obj;
    }
    function notifyOffers(response, model) {
      if (response && response.execute) {
        if (response.execute.pageLoad && Array.isArray(response.execute.pageLoad.options)) {
          response.execute.pageLoad.options.forEach(offer => {
            pub({
              topic: 'target.experienceDelivered',
              config: model.config,
              experience: extend({
                mbox: 'target-global-mbox'
              }, offer)
            });
          });
        }
        if (Array.isArray(response.execute.mboxes)) {
          response.execute.mboxes.forEach(mbox => {
            if (mbox && Array.isArray(mbox.options)) {
              mbox.options.forEach(offer => {
                pub({
                  topic: 'target.experienceDelivered',
                  config: model.config,
                  experience: extend({
                    mbox: mbox.name
                  }, offer)
                });
              });
            }
          });
        }
      }
    }
    function pids(products, common) {
      var ids = arr(products).map(p => pid(p, common)).filter(v => v);
      return ids.length > 0 ? ids : null;
    }
    function pid({
      productType = '',
      productId = '',
      facilityId = '',
      ticketId = '',
      roomTypeId = '',
      events,
      includedProducts,
      params,
      profiles
    }, common) {
      if ((productId || ticketId || facilityId || productType === 'ins') && (!events || !events.includes('cartRemove'))) {
        extend(common.parameters, params);
        extend(common.profileParameters, profiles);
        if (!ticketId && (productType === 'tix' || productType === 'med')) {
          ticketId = productId;
          productId = '';
        }
        if (Array.isArray(includedProducts) && includedProducts.length > 0) ticketId = includedProducts[0].id;
        return `${productType};${productId}:${facilityId}:${roomTypeId}:${ticketId}`;
      }
    }
    function arr(v) {
      return Array.isArray(v) ? v : [];
    }
  }, 'Framework', 'Adapter', 'netlog', 'objForEach', '$', 'extend', 'publish', 'Debug', 'memoize', 'debounce', 'isEmptyObject', 'consentCategoryOverrides');

  /* global inject */
  inject((targetAdapter, convertStringToDate, set, getURLParameter, safeJsonParse, sessionStorage, isObject, flattenObj, Analytics) => {
    var productTypeMapping = {
      defaultValue: 'prod',
      mapTo: {
        addOn: 'add',
        airTransportation: 'air',
        annualPass: 'tix',
        cruise: 'cruise',
        dining: 'dine',
        enhancedExperience: 'eexp',
        event: 'evt',
        fastPassPlus: 'gxa',
        greatFoodFast: 'gxa',
        groundTransportation: 'auto',
        insurance: 'ins',
        media: 'med',
        nonDisneyTicket: 'ndt',
        preOrder: 'pre',
        product: 'prod',
        resortVacation: 'res',
        ticket: 'tix',
        trip: 'trip'
      }
    };
    targetAdapter.mapping = {
      configuration: {
        AdobeTarget: {
          dynamicMboxes: {
            mapping: {
              defaultValue: 'false',
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          globalMbox: {
            mapping: {
              defaultValue: 'false',
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          targetGlobalMbox: {
            mapping: {
              defaultValue: 'true',
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          triggerTimeout: {
            mapping: {
              mapTo: 'triggerTimeout'
            }
          },
          passProductEntity: {
            mapping: {
              defaultValue: 'false',
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          propertyId: {
            mapping: {
              mapTo: 'property.token'
            }
          },
          pluginContentsquare: {
            mapping: {
              mapTo: 'config.pluginContentsquare',
              defaultValue: true,
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          pluginProfileTracking: {
            mapping: {
              mapTo: 'config.pluginProfileTracking',
              defaultValue: false,
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          pluginSeenCampaigns: {
            mapping: {
              mapTo: 'config.pluginSeenCampaigns',
              defaultValue: true,
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          pluginScTnt: {
            mapping: {
              mapTo: 'config.pluginScTnt',
              defaultValue: true,
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          pluginTntCampaigns: {
            mapping: {
              mapTo: 'config.pluginTntCampaigns',
              defaultValue: true,
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          pluginTtMeta: {
            mapping: {
              mapTo: 'config.pluginTtMeta',
              defaultValue: true,
              applyFilter: {
                type: 'boolean'
              }
            }
          },
          pluginWvA4T: {
            mapping: {
              mapTo: 'config.pluginWvA4T',
              defaultValue: () => Analytics.mode === 'webview'
            }
          }
        },
        SiteCatalyst: {
          channelSeparator: {
            mapping: {
              defaultValue: '/'
            }
          }
        }
      },
      contentLocale: {
        mapping: {
          defaultValue: 'us',
          mapTo: 'params.contentLocale'
        }
      },
      contentLanguage: {
        mapping: {
          defaultValue: 'en',
          mapTo: 'params.contentLanguage'
        }
      },
      marketingRegion: {
        mapping: {
          mapTo: 'params.marketingRegion',
          applyFilter: {
            case: 'lower'
          }
        }
      },
      device: {
        type: {
          mapping: {}
        },
        viewType: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: model => model.type && model.viewType ? '{{type}}:{{viewType}}' : '',
          mapTo: 'params.deviceInfo'
        }
      },
      site: {
        mapping: {}
      },
      targusScore: {
        mapping: {
          mapTo: 'profiles.targusScore'
        }
      },
      contentTests: {
        mapping: {
          applyFilter: {
            removeElement: {
              keys: ['contentTestType', 'contentTestModuleName', 'contentTestHTMLTargetElement'],
              values: ['inline', '', '']
            }
          }
        }
      },
      bookingSearchArrivalDate: {
        mapping: {
          mapTo: 'params.bookingSearchArrivalDate,profiles.bookingSearchArrivalDate',
          applyFilter: {
            date: {}
          }
        }
      },
      bookingSearchDepartureDate: {
        mapping: {
          mapTo: 'params.bookingSearchDepartureDate',
          applyFilter: {
            date: {}
          }
        }
      },
      bookingSearchDaysBetweenSearchAndArrival: {
        mapping: {
          mapTo: 'params.prodSearchBookingWindow',
          defaultValue: model => {
            var result,
              dateStr,
              date,
              today,
              diff,
              ONE_DAY = 1000 * 60 * 60 * 24;
            if (model.params) {
              dateStr = model.params.bookingSearchArrivalDate;
              if (dateStr) {
                date = convertStringToDate(dateStr);
                if (date) {
                  today = new Date();
                  today.setHours(0);
                  today.setMinutes(0);
                  today.setSeconds(0);
                  today.setMilliseconds(0);
                  diff = Math.abs(today.getTime() - date.getTime());
                  result = Math.round(diff / ONE_DAY);
                }
              }
            }
            return result;
          }
        }
      },
      bookingSearchLengthOfStayNights: {
        mapping: {
          mapTo: 'params.bookingSearchLOSNights'
        }
      },
      bookingSearchItinerary: {
        mapping: {
          mapTo: 'params.bookingSearchItinerary'
        }
      },
      bookingSearchFacilityTier: {
        mapping: {
          mapTo: 'params.bookingSearchFacilityTier'
        }
      },
      customerId: {
        mapping: {
          mapTo: 'params.SWID'
        }
      },
      guestType: {
        mapping: {
          mapTo: 'params.guestType'
        }
      },
      guestAffiliations: {
        mapping: {
          type: 'flex-array',
          mapTo: 'params.guestAffiliations'
        }
      },
      registrationStatus: {
        mapping: {
          mapTo: 'params.registrationStatus'
        }
      },
      homeState: {
        mapping: {
          mapTo: 'profiles.homeState'
        }
      },
      homeZip: {
        mapping: {
          mapTo: 'params.homeZip'
        }
      },
      homeCountry: {
        mapping: {
          mapTo: 'profiles.homeCountry'
        }
      },
      title: {
        mapping: {
          mapTo: 'params.title'
        }
      },
      age: {
        mapping: {
          mapTo: 'profiles.age'
        }
      },
      birthdate: {
        mapping: {
          mapTo: 'profiles.birthdate'
        }
      },
      gender: {
        mapping: {
          mapTo: 'params.gender'
        }
      },
      homeCity: {
        mapping: {
          mapTo: 'profiles.homeCity'
        }
      },
      pageId: {
        mapping: {
          mapTo: 'params.pageId',
          applyFilter: {
            case: 'lower',
            replace: [['[^a-zA-Z0-9]', '']]
          }
        }
      },
      storeType: {
        mapping: {
          mapTo: 'storeType,params.storeType'
        }
      },
      siteSection: {
        mapping: {
          mapTo: 'params.siteSection',
          applyFilter: {
            case: 'lower',
            replace: [['&amp;', 'and'], ['&', 'and'], ['[^a-zA-Z0-9{}/]', '']]
          }
        }
      },
      events: {
        mapping: {
          type: 'flex-array',
          valueDelimiter: '=',
          dataSourceMapTo: 'eventsData',
          mapTo: 'params.events'
        }
      },
      offerId: {
        offerName: {
          mapping: {
            mapTo: 'params.offerId'
          }
        }
      },
      store: {
        mapping: {
          mapTo: 'params.store'
        }
      },
      orderId: {
        mapping: {
          mapTo: 'order.id'
        }
      },
      productTotal: {
        mapping: {
          mapTo: 'order.total'
        }
      },
      totalBookedLengthOfStayNights: {
        mapping: {
          mapTo: 'params.totalBookedLengthOfStayNights'
        }
      },
      bookingSearchAdults: {
        mapping: {
          defaultValue: '0'
        }
      },
      bookingSearchChildren: {
        mapping: {
          defaultValue: '0'
        }
      },
      bookingSearchInfants: {
        mapping: {
          defaultValue: '0'
        }
      },
      bookingSearchSeniors: {
        mapping: {
          defaultValue: '0'
        }
      },
      bookingSearchParty: {
        mapping: {
          type: 'template',
          template: '{{#bookingSearchPartyTotal}}{{{bookingSearchPartyTotal}}}:{{{bookingSearchAdults}}}' + 'A:{{{bookingSearchChildren}}}C:{{{bookingSearchInfants}}}I:' + '{{{bookingSearchSeniors}}}S{{/bookingSearchPartyTotal}}',
          mapTo: 'params.bookingSearchParty,profiles.bookingSearchParty',
          transformers: {
            bookingSearchPartyTotal: model => {
              if (!isNaN(model.bookingSearchAdults) && !isNaN(model.bookingSearchChildren) && !isNaN(model.bookingSearchInfants && !isNaN(model.bookingSearchSeniors))) {
                return Number(model.bookingSearchAdults) + Number(model.bookingSearchChildren) + Number(model.bookingSearchInfants) + Number(model.bookingSearchSeniors);
              }
            }
          }
        }
      },
      payment: {
        paymentAmount: {
          mapping: {
            mapTo: 'params.paymentAmount'
          }
        },
        paymentPct: {
          mapping: {
            mapTo: 'params.paymentPct',
            defaultValue: model => {
              if (model.order?.total && model.params?.paymentAmount) {
                return (model.params.paymentAmount / model.order.total * 100).toFixed(0);
              }
            }
          }
        },
        paymentFrequency: {
          mapping: {}
        },
        paymentMethods: [{
          type: {
            mapping: {}
          },
          name: {
            mapping: {}
          },
          status: {
            mapping: {
              defaultValue: 'unknown'
            }
          },
          mapping: {
            transformers: {
              preProcess: ({
                type,
                name,
                status
              }, parentModel) => {
                set(parentModel, `paymentInfo.${type}`, {
                  name,
                  status
                });
              }
            }
          }
        }]
      },
      paymentInfo: {
        mapping: {
          type: 'template',
          template: '{{#paymentInfo}}' + '{{#creditCard.name}}{{{creditCard.name}}}_' + '{{#creditCard.status}}{{{creditCard.status}}}{{/creditCard.status}}' + '{{/creditCard.name}}:{{#giftCard.name}}{{{giftCard.name}}}_' + '{{#giftCard.status}}{{{giftCard.status}}}{{/giftCard.status}}' + '{{/giftCard.name}}:{{#rewardsCard.name}}{{{rewardsCard.name}}}_' + '{{#rewardsCard.status}}{{{rewardsCard.status}}}{{/rewardsCard.status}}' + '{{/rewardsCard.name}}:{{#pointsPayment.name}}{{{pointsPayment.name}}}_' + '{{#pointsPayment.status}}{{{pointsPayment.status}}}{{/pointsPayment.status}}' + '{{/pointsPayment.name}}:{{#instantCredit.name}}{{{instantCredit.name}}}_' + '{{#instantCredit.status}}{{{instantCredit.status}}}{{/instantCredit.status}}' + '{{/instantCredit.name}}' + '{{/paymentInfo}}',
          mapTo: 'params.payment'
        }
      },
      products: [{
        mapping: {
          applyFilter: {
            removeCartRemove: products => {
              if (Array.isArray(products)) {
                return products.filter(product => !product.events || !product.events.includes('cartRemove'));
              }
            }
          }
        },
        name: {
          mapping: {}
        },
        productType: {
          mapping: productTypeMapping
        },
        productId: {
          mapping: {
            mapTo: (_, parentModel) => `productId${parentModel.passProductEntity && parentModel.params.events.includes('prodView') ? ',^^params.entity-dot-id' : ''}`
          }
        },
        facilityTier: {
          mapping: {
            mapTo: 'params.facilityTier'
          }
        },
        facilityId: {
          mapping: {}
        },
        roomTypeId: {
          mapping: {}
        },
        portId: {
          mapping: {}
        },
        includedProducts: [{
          id: {
            mapping: {}
          },
          type: {
            mapping: {
              defaultValue: 'ticket'
            }
          },
          name: {
            mapping: {}
          },
          mapping: {
            transformers: {
              preProcess: (model, parentModel) => {
                if (model.type === 'diningPlan') {
                  set(parentModel, 'params.packageIncludesDinePlan', true);
                  set(parentModel, 'params.dinePlanType', model.name);
                }
              }
            }
          }
        }],
        bookingSearchDeparturePort: {
          mapping: {
            mapTo: 'params.bookingSearchDeparturePort'
          }
        },
        bookingSearchShip: {
          mapping: {
            mapTo: 'params.bookingSearchShip'
          }
        },
        bookingSearchDaysBetweenSearchAndArrival: {
          mapping: {
            mapTo: 'params.prodBookingWindow'
          }
        },
        bookingSearchFacilityTier: {
          mapping: {
            mapTo: 'params.bookingSearchFacilityTier'
          }
        },
        bookingSearchArrivalDate: {
          mapping: {
            mapTo: 'params.prodSearchArrivalDate,profiles.bookingSearchArrivalDate',
            applyFilter: {
              date: {}
            }
          }
        },
        bookingSearchLengthOfStayNights: {
          mapping: {
            mapTo: 'params.prodSearchLOS'
          }
        },
        bookingSearchAdults: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookingSearchChildren: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookingSearchInfants: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookingSearchSeniors: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookingSearchParty: {
          mapping: {
            type: 'template',
            template: '{{#bookingSearchPartyTotal}}{{{bookingSearchPartyTotal}}}:{{{bookingSearchAdults}}}' + 'A:{{{bookingSearchChildren}}}C:{{{bookingSearchInfants}}}I:' + '{{{bookingSearchSeniors}}}S{{/bookingSearchPartyTotal}}',
            mapTo: 'params.prodSearchParty,profiles.bookingSearchParty',
            transformers: {
              bookingSearchPartyTotal: model => {
                if (!isNaN(model.bookingSearchAdults) && !isNaN(model.bookingSearchChildren) && !isNaN(model.bookingSearchInfants) && !isNaN(model.bookingSearchSeniors)) {
                  return Number(model.bookingSearchAdults) + Number(model.bookingSearchChildren) + Number(model.bookingSearchInfants) + Number(model.bookingSearchSeniors);
                }
              }
            }
          }
        },
        bookedAdults: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedChildren: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookingSearchChildrenAges: {
          mapping: {
            type: 'flex-array',
            mapTo: 'params.bookingSearchChildrenAges'
          }
        },
        bookedInfants: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedSeniors: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedParty: {
          mapping: {
            type: 'template',
            template: '{{#bookedPartyTotal}}{{{bookedPartyTotal}}}:{{{bookedAdults}}}A:{{{bookedChildren}}}' + 'C:{{{bookedInfants}}}I:{{{bookedSeniors}}}S{{/bookedPartyTotal}}',
            mapTo: 'params.prodBookedParty',
            transformers: {
              bookedPartyTotal: model => {
                if (!isNaN(model.bookedAdults) && !isNaN(model.bookedChildren) && !isNaN(model.bookedInfants) && !isNaN(model.bookedSeniors)) {
                  return Number(model.bookedAdults) + Number(model.bookedChildren) + Number(model.bookedInfants) + Number(model.bookedSeniors);
                }
              }
            }
          }
        },
        bookedArrivalDate: {
          mapping: {
            mapTo: 'params.prodBookedArrivalDate',
            applyFilter: {
              date: {}
            }
          }
        },
        bookedLengthOfStayNights: {
          mapping: {
            mapTo: 'params.prodLOS'
          }
        },
        dateReservationMade: {
          mapping: {
            mapTo: 'params.dateReservationMade'
          }
        },
        daysBetweenBookingAndArrival: {
          mapping: {
            mapTo: 'params.daysBetweenBookingAndArrival'
          }
        },
        quantity: {
          mapping: {
            mapTo: 'params.prodQuantity'
          }
        },
        price: {
          total: {
            mapping: {
              mapTo: 'params.prodPrice'
            }
          }
        },
        packageType: {
          mapping: {
            mapTo: 'params.packageType,profiles.packageType'
          }
        },
        orderType: {
          mapping: {
            mapTo: 'params.orderType'
          }
        },
        events: {
          mapping: {
            type: 'flex-array',
            valueDelimiter: '=',
            targetDelimiter: '|',
            mapTo: {
              cartAdd: 'cartAdd',
              cartRemove: 'cartRemove'
            }
          }
        }
      }],
      productsDisplayed: [{
        facilityId: {
          mapping: {
            mapTo: 'params.productsDisplayedFacilityId'
          }
        },
        facilityTier: {
          mapping: {
            mapTo: 'params.productsDisplayedFacilityTier'
          }
        }
      }],
      productsPurchased: [{
        productType: {
          mapping: productTypeMapping
        },
        productId: {
          mapping: {}
        },
        facilityId: {
          mapping: {}
        },
        roomTypeId: {
          mapping: {}
        }
      }],
      bookingSearchDeparturePort: {
        mapping: {
          mapTo: 'params.bookingSearchDeparturePort'
        }
      },
      bookingSearchShip: {
        mapping: {
          mapTo: 'params.bookingSearchShip'
        }
      },
      bookingSearchChildrenAges: {
        mapping: {
          type: 'flex-array',
          mapTo: 'params.bookingSearchChildrenAges'
        }
      },
      seenCampaigns: {
        mapping: {
          mapTo: 'params.seenCampaigns',
          defaultValue: () => window.tnt_wdpro?.[`${window.tnt_wdpro?._prefix}getCampaigns`]?.()
        }
      },
      toggleStatus: {
        mapping: {
          type: 'template',
          mapTo: 'params.toggles',
          template: '{{#toggleStatus}}{{#ft}}{{{ft}}}{{/ft}}{{#rt}}{{#ft}},{{/ft}}{{{rt}}}{{/rt}}{{#flt}}' + '{{#rt}},{{/rt}}{{^rt}}{{#ft}},{{/ft}}{{/rt}}{{{flt}}}{{/flt}}{{/toggleStatus}}',
          transformers: {
            ft: model => {
              var toggles = [],
                toggle,
                featureToggles = model.toggleStatus?.featureToggles;
              if (featureToggles) {
                for (toggle in featureToggles) {
                  if (featureToggles.hasOwnProperty(toggle)) {
                    toggles.push(`ft;${toggle}:${featureToggles[toggle]}`);
                  }
                }
              }
              return toggles.join(',');
            },
            rt: model => {
              var toggles = [],
                toggle,
                releaseToggles = model.toggleStatus?.releaseToggles;
              if (releaseToggles) {
                for (toggle in releaseToggles) {
                  if (releaseToggles.hasOwnProperty(toggle)) {
                    toggles.push(`rt;${toggle}:${releaseToggles[toggle]}`);
                  }
                }
              }
              return toggles.join(',');
            },
            flt: model => {
              var toggles = [],
                toggle,
                flowToggles = model.toggleStatus?.flowToggles;
              if (flowToggles) {
                for (toggle in flowToggles) {
                  if (flowToggles.hasOwnProperty(toggle)) {
                    toggles.push(`flt;${toggle}:${flowToggles[toggle]}`);
                  }
                }
              }
              return toggles.join(',');
            }
          }
        }
      },
      compareVacationNumber: {
        mapping: {
          mapTo: 'params.compareVacationNum'
        }
      },
      currencyDisplayed: {
        mapping: {
          mapTo: 'params.currencyDisplayed'
        }
      },
      facility: {
        id: {
          mapping: {
            mapTo: 'params.entity-dot-id',
            applyFilter: {
              replace: [[';', '']]
            }
          }
        }
      },
      vpcSegment: {
        mapping: {
          mapTo: 'params.vpcSegment'
        }
      },
      _trgt_context: {
        mapping: {
          mapTo: 'targetContext',
          defaultValue: () => {
            var targetSession = 'targetContext',
              queryParams = getURLParameter(targetSession);
            if (queryParams) {
              var parsedParams = safeJsonParse(queryParams);
              if (isObject(parsedParams)) {
                parsedParams = flattenObj(parsedParams);
                sessionStorage.setItem(targetSession, parsedParams);
                return parsedParams;
              }
            } else {
              return sessionStorage.getItem(targetSession);
            }
          }
        }
      },
      _trgt_mode: {
        mapping: {
          mapTo: 'targetMode',
          defaultValue: () => Analytics.mode
        }
      }
    };
  }, 'Adapter:AdobeTarget', 'convertStringToDate', 'set', 'getURLParameter', 'safeJsonParse', 'sessionStorage', 'isObject', 'flattenObj', 'Analytics');

  /* global inject */
  inject(subscribe => {
    subscribe({
      topic: 'target.experienceDelivered',
      handler: ({
        config: {
          pluginContentsquare: enabled
        },
        experience: {
          responseTokens: tokens
        }
      }) => {
        if (enabled && tokens) {
          /** Contentsquare Integration **/
          window.testversion = `campaign:Exp-${tokens['experience.name']} | Test-${tokens['activity.name']},experience:${tokens['experience.name']}`;
        }
      }
    });
  }, 'subscribe');

  /* global inject */
  inject(subscribe => {
    subscribe({
      topic: 'target.experienceDelivered',
      handler: ({
        config: {
          pluginProfileTracking: enabled
        },
        experience: {
          responseTokens: tokens
        }
      }) => {
        if (enabled && tokens && window.adobe?.target?.getOffer) {
          /** ProfileTrackingPlugin **/
          var seenCampaigns = window.tnt_wdpro?.[`${window.tnt_wdpro?._prefix}getCampaigns`]?.();
          var campaignId = tokens['activity.id'];
          if (campaignId && seenCampaigns && !seenCampaigns.includes(campaignId)) {
            window.adobe.target.getOffer({
              mbox: 'ProfilePluginInformation_Mbox',
              params: {
                'profile.campaignId': campaignId
              }
            });
          }
        }
      }
    });
  }, 'subscribe');

  /* global inject */
  inject((subscribe, waitFor) => {
    subscribe({
      topic: 'target.experienceDelivered',
      handler: ({
        config: {
          pluginScTnt: enabled
        },
        experience: {
          responseTokens: tokens
        }
      }) => {
        if (enabled && tokens && window.s_wdpro) {
          /** SC-TnT **/
          window.s_tnt = window.s_tnt || '';
          window.tntVal = `${tokens['activity.id']}:${tokens['experience.id']}:${tokens['experience.trafficType'] || 0},`;
          if (!window.s_tnt.includes(window.tntVal)) window.s_tnt += window.tntVal;
          waitFor({
            location: [() => window.s_wdpro, s_wdpro => typeof s_wdpro.tl === 'function' && typeof s_wdpro.trackTNT === 'function'],
            callback: s_wdpro => {
              if (window.s_tnt !== '') {
                s_wdpro.tnt = s_wdpro.trackTNT();
                const oldLTV = s_wdpro.linkTrackVars;
                s_wdpro.linkTrackVars = 'tnt';
                s_wdpro.tl(true, 'o', 'returnTNT');
                s_wdpro.linkTrackVars = oldLTV;
              }
            },
            interval: 500,
            timeout: 5000
          });
        }
      }
    });
  }, 'subscribe', 'waitFor');

  /* global inject */
  inject(subscribe => {
    subscribe({
      topic: 'target.experienceDelivered',
      handler: ({
        config: {
          pluginSeenCampaigns: enabled
        },
        experience: {
          responseTokens: tokens
        }
      }) => {
        if (enabled && tokens && window.tnt_wdpro) {
          /** Seen Campaigns **/
          var campaignId = tokens['activity.id'];
          if (campaignId) window.tnt_wdpro[`${window.tnt_wdpro._prefix}setCampaign`]?.(campaignId);
        }
      }
    });
  }, 'subscribe');

  /* global inject */
  inject((subscribe, Analytics) => {
    subscribe({
      topic: 'target.experienceDelivered',
      handler: ({
        config: {
          pluginTntCampaigns: enabled
        },
        experience: {
          mbox,
          responseTokens: tokens
        }
      }) => {
        if (enabled && tokens && mbox && mbox !== ' ') {
          if (!Analytics.tntCampaigns) Analytics.tntCampaigns = {};
          if (!Analytics.tntCampaigns[mbox]) Analytics.tntCampaigns[mbox] = [];
          Analytics.tntCampaigns[mbox].push({
            campaignName: tokens['activity.name'],
            offerName: tokens['offer.name'],
            recipeName: tokens['experience.name']
          });
        }
      }
    });
  }, 'subscribe', 'Analytics');

  /* global inject */
  inject(subscribe => {
    subscribe({
      topic: 'target.experienceDelivered',
      handler: ({
        config: {
          pluginTtMeta: enabled
        },
        experience: {
          mbox,
          responseTokens: tokens
        }
      }) => {
        if (enabled && tokens) {
          /*T&T Metadata v3 ==>Response Plugin*/
          if (typeof window.ttMETA === 'undefined') window.ttMETA = [];
          window.ttMETA.push({
            CampaignName: tokens['activity.name'],
            CampaignId: tokens['activity.id'],
            RecipeName: tokens['experience.name'],
            RecipeId: tokens['experience.id'],
            OfferId: tokens['offer.id'],
            OfferName: tokens['offer.name'],
            MboxName: mbox
          });
        }
      }
    });
  }, 'subscribe');

  /* global inject */
  inject(subscribe => {
    let lastSDID;
    function getMid(visitor) {
      if (!visitor || typeof visitor.getMarketingCloudVisitorID !== 'function') {
        return '';
      }
      try {
        return visitor.getMarketingCloudVisitorID() || '';
      } catch {
        return '';
      }
    }
    subscribe({
      topic: 'target.experienceDelivered',
      handler: ({
        config = {}
      }) => {
        const enabled = config.pluginWvA4T;
        inject(RAnativeBridge => {
          const visitor = window.visitor;
          const sdid = visitor?._supplementalDataIDCurrent;
          if (enabled && RAnativeBridge && sdid && sdid !== lastSDID) {
            lastSDID = sdid;
            const contextData = {
              '&&sdid': sdid
            };
            const mid = getMid(visitor);
            if (mid) {
              contextData['&&mid'] = mid;
            }
            RAnativeBridge.sendCustomMessage('AnalyticsPlugin.trackAction', {
              state: 'returnTNT',
              contextData
            });
          }
        }, 'RAnativeBridge');
      }
    });
  }, 'subscribe');

  /* global inject, taq */
  inject((Adapter, once, addScript, getURLParameter, localStorage, sessionStorage, safeJsonParse, ref, isoDate, consentCategoryOverrides) => {
    const EVENT_PAGEVIEW = 'PAGEVIEW';
    const EVENT_START_BOOKING = 'START_BOOKING';
    const EVENT_BOOKING_CONFIRMATION = 'BOOKING_CONFIRMATION';
    const STATE_UNKNOWN = 1;
    const STATE_ACQUIRED = 2;
    const STATE_BOOKING = 3;
    const STATE_CONVERTED = 4;
    const KEY_STATE = 'afta_sk';
    const KEY_CLICK_ID = 'aftaci';
    const name = 'TripAdvisor';
    new Adapter({
      name,
      enabled: false,
      consentCategory: consentCategoryOverrides[name] || 'targeting',
      adapt,
      adaptOnce: true,
      loadLibrary: once(loadLibrary),
      mapping: mapping()
    });
    acquire();
    function adapt(sam) {
      const model = this.map(sam);
      if (!model || !this.enabled) return false;
      let {
        config,
        event,
        arg
      } = model;
      if (event) {
        this.loadLibrary(config);
        if (typeof taq !== 'function') return;
        taq(...['track', event, arg].filter(v => v));
        transitionState(event);
      }
    }
    function loadLibrary(config) {
      var taq;
      if (window.taq) return;
      taq = window.taq = function () {
        taq.queue.push(arguments);
      };
      taq.queue = [];
      taq('init', config.pixelId);
      if (/bot|crawler|spider|crawling/i.test(navigator.userAgent)) return;
      addScript(config.scriptSrc);
    }
    function acquire() {
      let clickId = getURLParameter('refid');
      if (clickId) {
        localStorage.setItem(KEY_STATE, {
          state: STATE_UNKNOWN,
          clickId
        }, 30);
        sessionStorage.removeItem(KEY_STATE);
        localStorage.removeItem(KEY_CLICK_ID); //migration: delete old style
      } else if (clickId = needsMigration()) {
        migrate(clickId);
      } else if (!localStorage.getItem(KEY_STATE) && !sessionStorage.getItem(KEY_STATE)) {
        sessionStorage.setItem(KEY_STATE, {
          state: STATE_UNKNOWN
        });
      }
    }
    function transitionState(event) {
      let newState, stateObj;
      if (event === EVENT_PAGEVIEW) {
        newState = STATE_ACQUIRED;
      } else if (event === EVENT_START_BOOKING) {
        newState = STATE_BOOKING;
      } else if (event === EVENT_BOOKING_CONFIRMATION) {
        newState = STATE_CONVERTED;
        localStorage.removeItem(KEY_STATE);
      }
      if (stateObj = localStorage.getItem(KEY_STATE)) {
        stateObj.state = newState;
        localStorage.setItem(KEY_STATE, stateObj, daysUntilExpiration(KEY_STATE, 30));
        sessionStorage.removeItem(KEY_STATE);
      } else {
        sessionStorage.setItem(KEY_STATE, {
          state: newState
        });
      }
    }
    function mapping() {
      return {
        configuration: {
          TripAdvisor: {
            pixelId: {
              mapping: {
                mapTo: 'config.pixelId',
                defaultValue: '198324029'
              }
            },
            scriptSrc: {
              mapping: {
                mapTo: 'config.scriptSrc',
                defaultValue: '//static.tacdn.com/js3/taevents-c.js'
              }
            },
            partnerName: {
              mapping: {
                mapTo: `${EVENT_BOOKING_CONFIRMATION}.partner`,
                defaultValue: 'Disney'
              }
            },
            pageEvent: {
              mapping: {
                mapTo: 'config.pageEvent'
              }
            }
          }
        },
        currency: {
          mapping: {
            mapTo: `${EVENT_BOOKING_CONFIRMATION}.currency`,
            defaultValue: 'USD'
          }
        },
        orderId: {
          mapping: {
            mapTo: `${EVENT_BOOKING_CONFIRMATION}.order_id`
          }
        },
        bookingSearchArrivalDate: {
          mapping: {
            mapTo: `${EVENT_START_BOOKING}.travel_start_date`,
            applyFilter: {
              date: {}
            }
          }
        },
        bookingSearchDepartureDate: {
          mapping: {
            mapTo: `${EVENT_START_BOOKING}.travel_end_date`,
            applyFilter: {
              date: {}
            }
          }
        },
        registrationStatus: {
          mapping: {}
        },
        ta_is_member: {
          mapping: {
            mapTo: `${EVENT_START_BOOKING}.is_member`,
            defaultValue: model => String(model.registrationStatus !== 'Not Registered')
          }
        },
        products: {
          mapping: {}
        },
        ta_rooms: {
          mapping: {
            mapTo: 'rooms',
            defaultValue: model => (model.products || []).filter(r => r.productType === 'resortVacation' && !/\bcartRemove\b/.test(r.events))
          }
        },
        ta_travel_start_date: {
          mapping: {
            mapTo: `${EVENT_START_BOOKING}.travel_start_date`,
            defaultValue: m => {
              if (!m[EVENT_START_BOOKING] || !m[EVENT_START_BOOKING].travel_start_date) {
                return isoDateFn(firstObjProp('rooms', 'bookingSearchArrivalDate'))(m);
              }
            }
          }
        },
        ta_travel_end_date: {
          mapping: {
            mapTo: `${EVENT_START_BOOKING}.travel_end_date`,
            defaultValue: m => {
              if (!m[EVENT_START_BOOKING] || !m[EVENT_START_BOOKING].travel_end_date) {
                return isoDateFn(firstObjProp('rooms', 'bookingSearchDepartureDate'))(m);
              }
            }
          }
        },
        ta_start_booking_key: {
          mapping: {
            mapTo: 'start_booking_key',
            defaultValue: m => `${ref(`${EVENT_START_BOOKING}.travel_start_date`, m) || ''}${ref(`${EVENT_START_BOOKING}.travel_end_date`, m) || ''}`.replace(/-/g, '')
          }
        },
        ta_state: {
          mapping: {
            mapTo: 'state',
            defaultValue: () => localStorage.getItem(KEY_STATE) || sessionStorage.getItem(KEY_STATE)
          }
        },
        ta_refid: {
          mapping: {
            mapTo: `${EVENT_BOOKING_CONFIRMATION}.refid`,
            defaultValue: m => m.state && m.state.clickId
          }
        },
        ta_gbv: {
          mapping: {
            mapTo: `${EVENT_BOOKING_CONFIRMATION}.gbv`,
            defaultValue: model => model[EVENT_BOOKING_CONFIRMATION].refid && model.rooms.reduce((p, c) => p + (+ref('price.total', c) || 0) * 100, 0)
          }
        },
        events: {
          mapping: {
            applyFilter: {
              case: 'lower'
            }
          }
        },
        ta_event: {
          mapping: {
            mapTo: 'event',
            defaultValue: model => {
              let event;
              const state = model.state && model.state.state || STATE_UNKNOWN;
              if (model.config.pageEvent === EVENT_PAGEVIEW || model.config.pageEvent === EVENT_START_BOOKING || model.config.pageEvent === EVENT_BOOKING_CONFIRMATION) {
                event = model.config.pageEvent;
              } else if (/\bpurchase\b/.test(model.events)) {
                event = EVENT_BOOKING_CONFIRMATION;
              } else if (state === STATE_ACQUIRED && (/\bcartcreate\b/.test(model.events) || /\/cart\//.test(location.pathname))) {
                event = EVENT_START_BOOKING;
              } else if (state === STATE_UNKNOWN || state === STATE_CONVERTED) {
                event = EVENT_PAGEVIEW;
              }
              return event;
            }
          }
        },
        ta_arg: {
          mapping: {
            mapTo: 'arg',
            defaultValue: model => model[model.event]
          }
        }
      };
    }
    function needsMigration() {
      return localStorage.getItem(KEY_CLICK_ID);
    }
    function migrate(clickId) {
      let expireDays = Math.min(30, Math.max(0, daysUntilExpiration(KEY_CLICK_ID, 30)));
      localStorage.setItem(KEY_STATE, {
        state: STATE_UNKNOWN,
        clickId
      }, expireDays);
      localStorage.removeItem(KEY_CLICK_ID);
      sessionStorage.removeItem(KEY_STATE);
    }
    function daysUntilExpiration(localStorageKey, defaultValue) {
      let expireDays = defaultValue;
      const msPerDay = 86400000;
      const rawValue = window.localStorage.getItem(localStorageKey);
      if (rawValue) {
        const objValue = safeJsonParse(rawValue);
        if (objValue && typeof objValue.expires === 'number') {
          expireDays = (objValue.expires - Date.now()) / msPerDay;
        }
      }
      return expireDays;
    }
    function firstObjProp(arrRef, prop, startingValue = '') {
      return model => ref(arrRef, model).find(e => e[prop]) || startingValue;
    }
    function isoDateFn(fn) {
      return function () {
        return isoDate(fn.apply(this, arguments));
      };
    }
  }, 'Adapter', 'once', 'addScript', 'getURLParameter', 'localStorage', 'sessionStorage', 'safeJsonParse', 'ref', 'isoDate', 'consentCategoryOverrides');

  /* global inject */
  inject((Analytics, Adapter, once, ref, store, consentCategoryOverrides) => {
    const name = 'AdobeAnalyticsWV';
    new Adapter({
      name,
      enabled: true,
      consentCategory: consentCategoryOverrides[name] || 'performance',
      adapt,
      adaptOnce: true,
      trackElement,
      mode: ['webview'],
      init: once(init)
    });
    let bridge;
    function init() {
      let bridgeMaker = ref('wvbwin.disney.nativeBridgeFactory.createNativeBridge', Analytics);
      if (typeof bridgeMaker === 'function') bridge = bridgeMaker();
      store('RAnativeBridge', bridge);
    }
    function adapt(sam) {
      const model = this.map(sam);
      if (!model || !this.enabled || !bridge) return false;
      const isPageTracking = /page/i.test(model.contextVars.trackingType);
      bridge.sendCustomMessage(`AnalyticsPlugin.track${isPageTracking ? 'State' : 'Action'}`, {
        state: isPageTracking ? `${model.contextVars.siteSection}/${model.contextVars.pageId}` : model.contextVars.linkId,
        contextData: model.contextVars
      });
    }
    function trackElement(event, sam) {
      adapt.call(this, sam);
    }
  }, 'Analytics', 'Adapter', 'once', 'ref', 'store', 'consentCategoryOverrides');

  /* global inject */
  inject((adapter, moment, productTypeMap, getURLParameter) => {
    adapter.mapping = {
      osVersion: {
        mapping: {
          mapTo: 'contextVars.osVersion'
        }
      },
      configuration: {
        SiteCatalyst: {
          namespace: {
            mapping: {
              defaultValue: 'wdpro',
              mapTo: 'contextVars.namespace'
            }
          }
        }
      },
      contentLocale: {
        mapping: {
          defaultValue: 'us',
          applyFilter: {
            case: 'lower'
          },
          mapTo: 'contextVars.contentLocale'
        }
      },
      contentLanguage: {
        mapping: {
          defaultValue: 'en',
          applyFilter: {
            case: 'lower'
          },
          mapTo: 'contextVars.contentLanguage'
        }
      },
      marketingRegion: {
        mapping: {
          applyFilter: {
            case: 'lower'
          },
          mapTo: 'contextVars.marketingRegion'
        }
      },
      currency: {
        mapping: {
          defaultValue: 'USD',
          mapTo: 'contextVars.currencyCode'
        }
      },
      site: {
        mapping: {
          mapTo: 'contextVars.site',
          defaultValue: 'notset'
        }
      },
      storeType: {
        mapping: {
          mapTo: 'contextVars.storeType'
        }
      },
      store: {
        mapping: {
          mapTo: 'contextVars.store'
        }
      },
      sailingId: {
        mapping: {
          mapTo: 'contextVars.sailingId'
        }
      },
      bookedTrips: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== undefined && val !== null) {
                model.contextVars = model.contextVars || {};
                model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event332=${val}`;
              }
            }
          }
        }
      },
      tripIdeas: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== undefined && val !== null) {
                model.contextVars = model.contextVars || {};
                model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event333=${val}`;
              }
            }
          }
        }
      },
      // GO4-5662: Trip Checklist Complete (My Trips feature)
      tripChecklistComplete: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== undefined && val !== null) {
                model.contextVars = model.contextVars || {};
                const eventVal = val ? 1 : 0;
                model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event341=${eventVal}`;
              }
            }
          }
        }
      },
      // GO4-5721: TxP Trip Itinerary variables
      totalPlans: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== undefined && val !== null) {
                model.contextVars = model.contextVars || {};
                model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event336=${val}`;
                model.contextVars.totalPlans = String(val);
              }
            }
          }
        }
      },
      bookedPlans: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== undefined && val !== null) {
                model.contextVars = model.contextVars || {};
                model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event334=${val}`;
              }
            }
          }
        }
      },
      resortCheckinStatus: {
        mapping: {
          type: 'flex-array',
          mapTo: 'contextVars.resortCheckinStatus'
        }
      },
      // GO4-6659: TripID (My Trips feature)
      tripId: {
        mapping: {
          type: 'flex-array',
          mapTo: 'contextVars.tripId'
        }
      },
      parkAdmissionPresent: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== undefined && val !== null) {
                model.contextVars = model.contextVars || {};
                model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event337=${val}`;
              }
            }
          }
        }
      },
      parkAdmissionNoAdmission: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== undefined && val !== null) {
                model.contextVars = model.contextVars || {};
                model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event338=${val}`;
              }
            }
          }
        }
      },
      parkAdmissionGetTicketsReady: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== undefined && val !== null) {
                model.contextVars = model.contextVars || {};
                model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event339=${val}`;
              }
            }
          }
        }
      },
      parkAdmissionUseMagicband: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== undefined && val !== null) {
                model.contextVars = model.contextVars || {};
                model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event340=${val}`;
              }
            }
          }
        }
      },
      tripNameCustomized: {
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val !== undefined && val !== null) {
                model.contextVars = model.contextVars || {};
                const eventVal = val ? 1 : 0;
                model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event343=${eventVal}`;
              }
            }
          }
        }
      },
      // GO4-4968: Trip Party guest counts
      tripParty: {
        managed: {
          mapping: {}
        },
        pending: {
          mapping: {}
        },
        total: {
          mapping: {}
        },
        mapping: {
          transformers: {
            preProcess: (model, _, val) => {
              if (val && typeof val === 'object') {
                let {
                  managed,
                  pending,
                  total
                } = val;
                const [hasManaged, hasPending, hasTotal] = [hasValue(managed), hasValue(pending), hasValue(total)];

                // Only process if at least one property is defined
                if (!hasManaged && !hasPending && !hasTotal) {
                  return;
                }
                model.contextVars = model.contextVars || {};

                // Calculate total if not provided: managed + pending + 1 (for owner/self)
                // If total is provided, trust it
                if (!hasTotal) {
                  total = (managed || 0) + (pending || 0) + 1;
                }
                if (hasManaged) {
                  model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event329=${managed}`;
                }
                if (hasPending) {
                  model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event330=${pending}`;
                }
                model.contextVars.events = `${model.contextVars.events || ''}${model.contextVars.events ? ',' : ''}event331=${total}`;
                model.contextVars.partySize = String(total);
              }
              function hasValue(value) {
                return value !== undefined && value !== null;
              }
            }
          }
        }
      },
      trackingType: {
        mapping: {
          defaultValue: 'standardPage',
          mapTo: 'contextVars.trackingType'
        }
      },
      events: {
        mapping: {
          type: 'flex-array',
          valueDelimiter: '=',
          mapTo: 'contextVars.events',
          flexValueMap: {},
          flexValuePassthrough: true
        }
      },
      _awv_separate_events: {
        mapping: {
          defaultValue: model => {
            const eventStr = model && model.contextVars && model.contextVars.events;
            if (eventStr) return eventStr.split(',').map(event => event.split('='));
          },
          mapTo: ({
            contextVars
          }, _, eventsArr) => {
            eventsArr.forEach(event => {
              contextVars[`event.${event[0]}`] = event[1] || '1';
            });
          }
        }
      },
      claimContext: {
        mapping: {
          mapTo: 'contextVars.claimContext'
        }
      },
      siteSection: {
        mapping: {
          defaultValue: 'notset',
          applyFilter: {
            case: 'lower',
            replace: [['&amp;', 'and'], ['&', 'and'], ['[^a-zA-Z0-9{}/]', '']]
          },
          mapTo: 'contextVars.siteSection'
        }
      },
      pageId: {
        mapping: {
          mapTo: 'contextVars.pageId',
          defaultValue: 'notset',
          applyFilter: {
            type: 'string',
            case: 'lower',
            replace: [['[^a-zA-Z0-9]', '']]
          }
        }
      },
      stepProgress: {
        current: {
          mapping: {
            mapTo: 'contextVars.stepProgress_current'
          }
        },
        total: {
          mapping: {
            mapTo: 'contextVars.stepProgress_total'
          }
        }
      },
      pageVariant: {
        mapping: {
          mapTo: 'contextVars.pageVariant'
        }
      },
      flow: {
        mapping: {
          mapTo: 'contextVars.flow'
        }
      },
      toggleStatus: {
        mapping: {
          type: 'template',
          mapTo: 'contextVars.toggles',
          template: '{{#toggleStatus}}{{#ft}},{{{ft}}}{{/ft}}{{#rt}},{{{rt}}}{{/rt}}{{#flt}},{{{flt}}}{{/flt}}{{/toggleStatus}}',
          transformers: {
            ft: model => {
              var toggles = [],
                toggle,
                featureToggles;
              if (model.toggleStatus && model.toggleStatus.featureToggles) {
                featureToggles = model.toggleStatus.featureToggles;
                for (toggle in featureToggles) {
                  if (featureToggles.hasOwnProperty(toggle)) {
                    toggles.push('ft;' + toggle + ':' + featureToggles[toggle]);
                  }
                }
              }
              return toggles.join(',');
            },
            rt: model => {
              var toggles = [],
                toggle,
                releaseToggles;
              if (model.toggleStatus && model.toggleStatus.releaseToggles) {
                releaseToggles = model.toggleStatus.releaseToggles;
                for (toggle in releaseToggles) {
                  if (releaseToggles.hasOwnProperty(toggle)) {
                    toggles.push('rt;' + toggle + ':' + releaseToggles[toggle]);
                  }
                }
              }
              return toggles.join(',');
            },
            flt: model => {
              var toggles = [],
                toggle,
                flowToggles;
              if (model.toggleStatus && model.toggleStatus.flowToggles) {
                flowToggles = model.toggleStatus.flowToggles;
                for (toggle in flowToggles) {
                  if (flowToggles.hasOwnProperty(toggle)) {
                    toggles.push('flt;' + toggle + ':' + flowToggles[toggle]);
                  }
                }
              }
              return toggles.join(',');
            }
          }
        }
      },
      contentDisplayed: {
        mapping: {
          mapTo: 'contextVars.contentDisplayed'
        }
      },
      leadType: {
        mapping: {
          mapTo: 'contextVars.leadType'
        }
      },
      errorCodes: {
        mapping: {
          mapTo: 'contextVars.errorCodes',
          applyFilter: {
            unique: ',',
            replace: [[' ', '']]
          }
        }
      },
      linkId: {
        mapping: {
          mapTo: 'contextVars.linkId'
        }
      },
      registrationTemplateId: {
        mapping: {
          mapTo: 'contextVars.registrationTemplateId'
        }
      },
      siteType: {
        mapping: {
          mapTo: 'contextVars.siteType'
        }
      },
      guestType: {
        mapping: {
          mapTo: 'contextVars.guestType'
        }
      },
      experienceId: {
        mapping: {
          mapTo: 'contextVars.experienceId'
        }
      },
      thirdPartyId: {
        mapping: {
          mapTo: 'contextVars.thirdPartyId'
        }
      },
      callCenterId: {
        mapping: {
          mapTo: 'contextVars.callCenterId'
        }
      },
      partnerId: {
        type: {
          mapping: {
            mapTo: 'contextVars.partnerId_type'
          }
        },
        id: {
          mapping: {
            mapTo: 'contextVars.partnerId_id'
          }
        },
        instance: {
          mapping: {
            mapTo: 'contextVars.partnerId_instance'
          }
        }
      },
      DTALoginId: {
        mapping: {
          mapTo: 'contextVars.DTALoginId'
        }
      },
      alternateAggregation: {
        mapping: {
          mapTo: 'contextVars.alternateAggregation'
        }
      },
      selfServiceType: {
        mapping: {
          type: 'flex-array',
          targetDelimiter: '|',
          mapTo: 'contextVars.selfServiceType'
        }
      },
      chatSessionId: {
        mapping: {
          mapTo: 'contextVars.chatSessionId'
        }
      },
      memberNumber: {
        mapping: {
          mapTo: 'contextVars.memberNumber'
        }
      },
      registrationStatus: {
        mapping: {
          mapTo: 'contextVars.registrationStatus'
        }
      },
      homeState: {
        mapping: {
          mapTo: 'contextVars.homeState'
        }
      },
      homeCity: {
        mapping: {
          mapTo: 'contextVars.homeCity'
        }
      },
      homeZip: {
        mapping: {
          mapTo: 'contextVars.homeZip'
        }
      },
      departureCity: {
        mapping: {
          mapTo: 'contextVars.departureCity'
        }
      },
      guestLifeStage: {
        mapping: {
          mapTo: 'contextVars.guestLifeStage'
        }
      },
      guestAffiliations: {
        mapping: {
          type: 'flex-array',
          mapTo: 'contextVars.guestAffiliations',
          applyFilter: {
            alpha: 'asc',
            replace: [[' ', '']]
          }
        }
      },
      affiliationsAvailable: {
        mapping: {
          type: 'flex-array',
          mapTo: 'contextVars.affiliationsAvailable',
          applyFilter: {
            alpha: 'asc',
            replace: [[' ', '']]
          }
        }
      },
      internalSearchKeywords: {
        mapping: {
          mapTo: 'contextVars.internalSearchKeywords'
        }
      },
      internalSearchNumResults: {
        mapping: {
          mapTo: 'contextVars.internalSearchNumResults'
        }
      },
      internalSearchType: {
        mapping: {
          mapTo: 'contextVars.internalSearchType'
        }
      },
      bookingSearchNumResults: {
        mapping: {
          mapTo: 'contextVars.bookingSearchNumResults'
        }
      },
      bookingSearchDaysBetweenSearchAndArrival: {
        mapping: {
          mapTo: 'contextVars.bookingSearchDaysBetweenSearchAndArrival'
        }
      },
      bookingSearchArrivalDate: {
        mapping: {
          mapTo: 'contextVars.bookingSearchArrivalDate'
        }
      },
      bookingSearchLengthOfStayNights: {
        mapping: {
          mapTo: 'contextVars.bookingSearchLengthOfStayNights'
        }
      },
      bookingSearchChildrenAges: {
        mapping: {
          type: 'flex-array',
          targetDelimiter: ':',
          mapTo: 'contextVars.bookingSearchChildrenAges'
        }
      },
      bookingSearchAdults: {
        mapping: {
          mapTo: 'contextVars.bookingSearchAdults'
        }
      },
      bookingSearchChildren: {
        mapping: {
          mapTo: 'contextVars.bookingSearchChildren'
        }
      },
      bookingSearchInfants: {
        mapping: {
          mapTo: 'contextVars.bookingSearchInfants'
        }
      },
      bookingSearchSeniors: {
        mapping: {
          mapTo: 'contextVars.bookingSearchSeniors'
        }
      },
      partyEligibility: {
        mapping: {
          mapTo: 'contextVars.partyEligibility'
        }
      },
      bookingSearchResort: {
        mapping: {
          mapTo: 'contextVars.bookingSearchResort'
        }
      },
      bookingSearchDeparturePort: {
        mapping: {
          mapTo: 'contextVars.bookingSearchDeparturePort'
        }
      },
      bookingSearchShip: {
        mapping: {
          mapTo: 'contextVars.bookingSearchShip'
        }
      },
      bookingSearchNumRooms: {
        mapping: {
          mapTo: 'contextVars.bookingSearchNumRooms'
        }
      },
      search: {
        time: {
          start: {
            mapping: {
              mapTo: 'contextVars.searchTimeStart'
            }
          },
          end: {
            mapping: {
              mapTo: 'contextVars.searchTimeEnd'
            }
          },
          duration: {
            mapping: {
              mapTo: 'contextVars.searchTimeDuration'
            }
          }
        }
      },
      bookedPartySize: {
        mapping: {
          mapTo: 'contextVars.bookedPartySize'
        }
      },
      facetsUtilized: [{
        name: {
          mapping: {}
        },
        action: {
          mapping: {
            defaultValue: 'Add'
          }
        },
        mapping: {
          type: 'template',
          template: '{{#name}}{{{action}}}:{{{name}}}{{/name}}'
        }
      }],
      _awv_facetsUtilized: {
        mapping: {
          defaultValue: a => a.facetsUtilized,
          mapTo: 'contextVars.facetsUtilized',
          type: 'flex-array',
          postFilter: {
            removeBlanksFromStr
          }
        }
      },
      facetsProgress: [{
        name: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{{name}}}'
        }
      }],
      _awv_facetsProgress: {
        mapping: {
          defaultValue: a => a.facetsProgress,
          mapTo: 'contextVars.facetsProgress',
          type: 'flex-array',
          postFilter: {
            removeBlanksFromStr
          }
        }
      },
      orderId: {
        mapping: {
          mapTo: 'contextVars.orderId'
        }
      },
      itineraryDay: {
        mapping: {
          mapTo: 'contextVars.itineraryDay'
        }
      },
      itineraryLength: {
        mapping: {
          mapTo: 'contextVars.itineraryLength'
        }
      },
      itineraryType: {
        mapping: {
          mapTo: 'contextVars.itineraryType'
        }
      },
      totalBookedLengthOfStayNights: {
        mapping: {
          mapTo: 'contextVars.totalBookedLengthOfStayNights'
        }
      },
      pointsSpent: {
        mapping: {
          mapTo: 'contextVars.pointsSpent'
        }
      },
      pointsBudget: {
        mapping: {
          mapTo: 'contextVars.pointsBudget'
        }
      },
      carts: [{
        friendlyId: {
          mapping: {
            mapTo: '^^contextVars.cart_friendlyId'
          }
        },
        id: {
          mapping: {
            mapTo: '^^contextVars.cart_id'
          }
        },
        age: {
          mapping: {
            mapTo: '^^contextVars.cart_age'
          }
        },
        status: {
          mapping: {
            mapTo: '^^contextVars.cart_status'
          }
        },
        changeType: {
          mapping: {
            mapTo: '^^contextVars.cart_changeType'
          }
        },
        isGift: {
          mapping: {
            mapTo: '^^contextVars.cart_isGift'
          }
        }
      }],
      payment: {
        type: {
          mapping: {
            mapTo: 'contextVars.paymentType'
          }
        },
        paymentAmount: {
          mapping: {
            mapTo: 'contextVars.paymentAmount'
          }
        },
        totalPrice: {
          mapping: {
            mapTo: 'contextVars.paymentTotalPrice'
          }
        },
        paymentFrequency: {
          mapping: {
            mapTo: 'contextVars.paymentFrequency'
          }
        },
        paymentMethods: [{
          type: {
            mapping: {
              postFilter: {
                list: 'creditCard,giftCard,rewardsCard,pointsPayment,instantCredit,digitalWallet'
              }
            }
          },
          name: {
            mapping: {
              applyFilter: {
                case: 'lower',
                replace: [[' ', '']]
              }
            }
          },
          status: {
            mapping: {
              defaultValue: 'unknown',
              postFilter: {
                replace: [['saved', 'stored', 'i']],
                list: 'new,stored'
              }
            }
          },
          mapping: {
            transformers: {
              preProcess: ({
                type,
                name,
                status
              }, parentModel) => {
                if (parentModel && type) {
                  parentModel.paymentInfo || (parentModel.paymentInfo = {});
                  parentModel.paymentInfo[type] = {
                    name,
                    status
                  };
                }
              }
            }
          }
        }],
        mapping: {
          type: 'template',
          template: model => {
            if (model.type || model.paymentAmount || model.totalPrice || model.gift) {
              return '{{type}}:{{paymentAmount}}:{{totalPrice}}:{{pctPaid}}:{{gift}}';
            }
            return '';
          },
          mapTo: 'prop54',
          transformers: {
            pctPaid: model => {
              if (model.paymentAmount && model.totalPrice) {
                return (model.paymentAmount / model.totalPrice).toFixed(2);
              }
              return '';
            }
          }
        }
      },
      paymentInfo: {
        mapping: {
          type: 'template',
          template: '{{#paymentInfo}}' + '{{#creditCard.name}}{{{creditCard.name}}}_{{#creditCard.status}}{{{creditCard.status}}}{{/creditCard.status}}{{/creditCard.name}}' + ':{{#giftCard.name}}{{{giftCard.name}}}_{{#giftCard.status}}{{{giftCard.status}}}{{/giftCard.status}}{{/giftCard.name}}' + ':{{#rewardsCard.name}}{{{rewardsCard.name}}}_{{#rewardsCard.status}}{{{rewardsCard.status}}}{{/rewardsCard.status}}{{/rewardsCard.name}}' + ':{{#pointsPayment.name}}{{{pointsPayment.name}}}_{{#pointsPayment.status}}{{{pointsPayment.status}}}{{/pointsPayment.status}}{{/pointsPayment.name}}' + ':{{#instantCredit.name}}{{{instantCredit.name}}}_{{#instantCredit.status}}{{{instantCredit.status}}}{{/instantCredit.status}}{{/instantCredit.name}}' + ':{{#digitalWallet.name}}{{{digitalWallet.name}}}_{{#digitalWallet.status}}{{{digitalWallet.status}}}{{/digitalWallet.status}}{{/digitalWallet.name}}' + '{{/paymentInfo}}',
          mapTo: 'contextVars.paymentInfo'
        }
      },
      disneyWallet: {
        mapping: {
          mapTo: 'contextVars.disneyWallet',
          postFilter: {
            replace: [[' ', '']],
            list: 'NoThanks,AddCards,EnterOwn',
            prefix: val => val ? `wallet${val}` : undefined
          }
        }
      },
      mediaCount: {
        mapping: {
          mapTo: 'contextVars.mediaCount'
        }
      },
      mediaType: {
        mapping: {
          mapTo: 'contextVars.mediaType'
        }
      },
      mediaId: {
        mapping: {
          mapTo: 'contextVars.mediaId'
        }
      },
      // GO4-4931: composite offerId (LOB:productSpace:productType:usageWindow:offerName)
      offerId: {
        lob: {
          mapping: {
            mapTo: '_offerLob'
          }
        },
        productSpace: {
          mapping: {
            mapTo: '_offerProductSpace'
          }
        },
        productType: {
          mapping: {
            mapTo: '_offerProductType'
          }
        },
        usageWindow: {
          mapping: {
            mapTo: '_offerUsageWindow'
          }
        },
        offerName: {
          mapping: {
            mapTo: '_offerName'
          }
        },
        mapping: {
          type: 'template',
          mapTo: 'contextVars.offerId',
          template: result => {
            const offer = result.offerId;
            if (!offer?.offerName) return '';
            if (Object.keys(offer).length < 2) return '{{{_offerName}}}';
            result._offerLob ||= (result.contextVars?.site || '').toUpperCase() || 'Null';
            result._offerProductSpace ??= offer.productSpace ?? 'Null';
            result._offerProductType ??= offer.productType ?? 'Null';
            result._offerUsageWindow ??= offer.usageWindow ?? 'Null';
            return '{{{_offerLob}}}:{{{_offerProductSpace}}}:{{{_offerProductType}}}:{{{_offerUsageWindow}}}:{{{_offerName}}}';
          }
        }
      },
      offersShownPrefix: {
        mapping: {
          mapTo: 'contextVars.offersShownPrefix'
        }
      },
      offersShown: [{
        id: {
          mapping: {}
        },
        isAvailable: {
          mapping: {
            postFilter: {
              fmt: a => ({
                true: 'A',
                false: 'U'
              })[a] ?? ''
            }
          }
        },
        price: {
          mapping: {
            postFilter: {
              round: v => {
                if (typeof v === 'string') v = Number(v);
                if (typeof v === 'number' && !Number.isNaN(v)) return Math.round(v);
                return '';
              }
            }
          }
        },
        reason: {
          mapping: {
            defaultValue: ''
          }
        },
        mapping: {
          mapTo: '_'
        }
      }],
      _awv_offersShown: {
        mapping: {
          defaultValue: a => a.offersShown?.map?.(o => o.id),
          mapTo: 'contextVars.offersShown',
          type: 'flex-array'
        }
      },
      _awv_offersShown_2: {
        mapping: {
          defaultValue: a => a.offersShown?.map?.(o => `${o.id}:${o.isAvailable}:${o.price}:${o.reason}`),
          mapTo: (a, b, val) => val.split(',').every(v => /:::$/.test(v)) ? undefined : 'contextVars.offersShownAvail',
          type: 'flex-array'
        }
      },
      pinnedOffer: {
        type: {
          mapping: {
            mapTo: 'contextVars.pinnedOffer_type'
          }
        },
        code: {
          mapping: {
            mapTo: 'contextVars.pinnedOffer_code'
          }
        },
        criteria: {
          mapping: {
            mapTo: 'contextVars.pinnedOffer_criteria'
          }
        }
      },
      socialInteractionType: {
        mapping: {
          applyFilter: {
            replace: [[' ', '']]
          },
          mapTo: 'contextVars.socialInteractionType'
        }
      },
      pageType: {
        mapping: {}
      },
      _pre_products: {
        mapping: {
          mapTo: '_reservation_index',
          defaultValue: 1
        }
      },
      products: [{
        name: {
          mapping: {}
        },
        productType: {
          mapping: {
            defaultValue: 'prod',
            mapTo: productTypeMap
          }
        },
        productId: {
          mapping: {
            mapTo: model => isTicket(model.productType) ? 'ticketId' : 'productId'
          }
        },
        facilityId: {
          mapping: {}
        },
        sailingId: {
          mapping: {
            mapTo: 'eVar78,^^contextVars.sailingId'
          }
        },
        packageType: {
          mapping: {}
        },
        roomTypeId: {
          mapping: {}
        },
        portId: {
          mapping: {}
        },
        themePrefix: {
          mapping: {
            defaultValue: m => m.eVar78 || m.portId ? 'CruiseTheme' : 'Theme'
          }
        },
        themeSeparator: {
          mapping: {
            defaultValue: ':'
          }
        },
        theme: {
          mapping: {
            mapTo: 'eVar37',
            type: 'template',
            template: '{{#theme}}{{#themePrefix}}{{themePrefix}}{{themeSeparator}}{{/themePrefix}}{{theme}}{{/theme}}'
          }
        },
        transactionDetail: {
          mapping: {
            mapTo: 'eVar37'
          }
        },
        includedProducts: [{
          type: {
            mapping: {
              defaultValue: 'ticket'
            }
          },
          id: {
            mapping: {
              mapTo: 'ticketId'
            }
          },
          price: {
            mapping: {
              mapTo: 'event17'
            }
          },
          quantity: {
            mapping: {
              mapTo: model => 'event18' + (model.type === 'ticket' ? ',ticketQuantity' : '')
            }
          },
          days: {
            mapping: {
              mapTo: model => model.type === 'ticket' ? 'ticketDays' : ''
            }
          },
          mapping: {
            mapTo: 'includedProducts',
            applyFilter: {
              removeElement: {
                keys: ['type'],
                values: ['diningPlan']
              }
            }
          }
        }],
        bookingSearchDaysBetweenSearchAndArrival: {
          mapping: {
            mapTo: 'eVar31,^^contextVars.bookingSearchDaysBetweenSearchAndArrival',
            applyFilter: {
              type: 'string'
            }
          }
        },
        bookingSearchArrivalDate: {
          mapping: {
            mapTo: 'bookingSearchArrivalDate,^^contextVars.bookingSearchArrivalDate'
          }
        },
        bookingSearchLengthOfStayNights: {
          mapping: {
            mapTo: 'bookingSearchLengthOfStayNights,^^contextVars.bookingSearchLengthOfStayNights'
          }
        },
        bookingSearchChildrenAges: {
          mapping: {
            type: 'flex-array',
            targetDelimiter: ':',
            mapTo: 'eVar122,^^contextVars.bookingSearchChildrenAges'
          }
        },
        bookingSearchAdults: {
          mapping: {
            defaultValue: '0',
            mapTo: 'bookingSearchAdults,^^contextVars.bookingSearchAdults'
          }
        },
        bookingSearchChildren: {
          mapping: {
            defaultValue: '0',
            mapTo: 'bookingSearchChildren,^^contextVars.bookingSearchChildren'
          }
        },
        bookingSearchInfants: {
          mapping: {
            defaultValue: '0',
            mapTo: 'bookingSearchInfants,^^contextVars.bookingSearchInfants'
          }
        },
        bookingSearchSeniors: {
          mapping: {
            defaultValue: '0',
            mapTo: 'bookingSearchSeniors,^^contextVars.bookingSearchSeniors'
          }
        },
        _awv_bookingSearchPartySize: {
          mapping: {
            defaultValue: model => {
              if (!isNaN(model.bookingSearchAdults) && !isNaN(model.bookingSearchChildren) && !isNaN(model.bookingSearchInfants) && !isNaN(model.bookingSearchSeniors)) {
                return Number(model.bookingSearchAdults) + Number(model.bookingSearchChildren) + Number(model.bookingSearchInfants) + Number(model.bookingSearchSeniors);
              }
            },
            mapTo: 'bookingSearchPartyTotal,^^contextVars.bookingSearchPartySize'
          }
        },
        bookingSearchParty: {
          mapping: {
            type: 'template',
            template: '{{#bookingSearchPartyTotal}}{{{bookingSearchPartyTotal}}}:' + '{{{bookingSearchAdults}}}A:{{{bookingSearchChildren}}}C:{{{bookingSearchInfants}}}I:' + '{{{bookingSearchSeniors}}}S{{/bookingSearchPartyTotal}}',
            mapTo: 'eVar34'
          }
        },
        bookingSearchNumRooms: {
          mapping: {
            mapTo: 'eVar77'
          }
        },
        bookedChildrenAges: {
          mapping: {
            type: 'flex-array',
            targetDelimiter: ':',
            mapTo: '^^contextVars.bookedChildrenAges'
          }
        },
        bookedAdults: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedChildren: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedInfants: {
          mapping: {
            defaultValue: '0'
          }
        },
        bookedSeniors: {
          mapping: {
            defaultValue: '0',
            reprocessOnUpdate: true
          }
        },
        bookedParty: {
          mapping: {
            type: 'template',
            template: '{{#bookedPartyTotal}}{{{bookedPartyTotal}}}:{{{bookedAdults}}}' + 'A:{{{bookedChildren}}}C:{{{bookedInfants}}}I:{{{bookedSeniors}}}S{{/bookedPartyTotal}}',
            mapTo: 'eVar16,^^tbi_eVar16',
            transformers: {
              bookedPartyTotal: model => {
                if (!isNaN(model.bookedAdults) && !isNaN(model.bookedChildren) && !isNaN(model.bookedInfants && !isNaN(model.bookedSeniors))) {
                  return Number(model.bookedAdults) + Number(model.bookedChildren) + Number(model.bookedInfants) + Number(model.bookedSeniors);
                }
              }
            }
          }
        },
        bookedArrivalDate: {
          mapping: {
            mapTo: model => canHaveUseDates(model.productType) ? 'eVar18,bookedArrivalDate,^^tbi_eVar18' : 'eVar18,^^contextVars.bookedArrivalDate,^^tbi_eVar18',
            applyFilter: {
              date: {}
            }
          }
        },
        bookedLengthOfStayNights: {
          mapping: {
            mapTo: 'bookedLengthOfStayNights,^^contextVars.bookedLengthOfStayNights'
          }
        },
        bookedTimeOfDay: {
          mapping: {
            mapTo: 'eVar67,^^contextVars.bookedTimeOfDay'
          }
        },
        quantity: {
          mapping: {
            mapTo: model => 'quantity,event321' + (isTicket(model.productType) ? ',ticketQuantity' : '')
          }
        },
        price: {
          total: {
            mapping: {
              mapTo: 'totalPrice,event320'
            }
          }
        },
        previousPrice: {
          total: {
            mapping: {
              mapTo: (model, _, val) => {
                if (val !== model.totalPrice) return 'event322';
              }
            }
          }
        },
        changeStatus: {
          mapping: {
            mapTo: 'eVar136'
          }
        },
        _priceDifferential: {
          mapping: {
            defaultValue: ({
              event320,
              event322
            }) => {
              if (event320 !== undefined && event322 !== undefined) {
                const diff = event320 - event322;
                if (diff !== 0) {
                  return Number(Math.abs(diff).toFixed(2));
                }
              }
            },
            mapTo: ({
              event320,
              event322
            }) => {
              if (event320 !== undefined && event322 !== undefined) {
                return event320 >= event322 ? 'event323' : 'event324';
              }
            }
          }
        },
        _numConnections: {
          mapping: {
            mapTo: 'event319'
          }
        },
        confirmationNumber: {
          mapping: {
            mapTo: 'eVar15,confirmationNumber'
          }
        },
        daysBetweenBookingAndArrival: {
          mapping: {
            mapTo: 'eVar17,^^contextVars.daysBetweenBookingAndArrival,^^tbi_eVar17',
            applyFilter: {
              type: 'string'
            }
          }
        },
        discountCode: {
          mapping: {
            transformers: {
              preProcess: (result, parentResult, val) => {
                if (!val) return;
                let str;
                if (Object.keys(val).length < 2) {
                  str = val.offerName || '';
                } else {
                  const f = (v, fb) => v !== undefined ? v : fb;
                  parentResult.contextVars = parentResult.contextVars || {};
                  const lob = f(val.lob, (parentResult.contextVars.site || '').toUpperCase() || 'Null');
                  str = `${lob}:${f(val.productSpace, 'Null')}:${f(val.productType, 'Null')}:${f(val.usageWindow, 'Null')}:${f(val.offerName, 'Null')}`;
                }
                if (str) {
                  result.eVar21 = str;
                  parentResult.contextVars = parentResult.contextVars || {};
                  parentResult.contextVars.offerId = str;
                }
              }
            }
          }
        },
        originalChannel: {
          mapping: {
            mapTo: 'eVar65'
          }
        },
        elapsedBookingTime: {
          mapping: {
            mapTo: 'eVar66'
          }
        },
        visualId: {
          mapping: {}
        },
        events: {
          mapping: {
            type: 'flex-array',
            valueDelimiter: '=',
            defaultElementValue: 1,
            targetDelimiter: '|',
            mapTo: {
              activityUnits: 'event65',
              cartAdd: 'event44',
              cartRemove: 'event45'
            }
          }
        },
        parentId: {
          mapping: {}
        },
        availabilityChannel: {
          mapping: {
            mapTo: 'availChannel'
          }
        },
        inventory: {
          mapping: {}
        },
        pricingCategory: {
          mapping: {}
        },
        useDate: {
          mapping: {
            type: 'template',
            template: '{{#useDate}}:::{{{useDate}}}:{{/useDate}}',
            mapTo: model => canHaveUseDates(model.productType) ? 'eVar36' : undefined,
            defaultValue: model => canHaveUseDates(model.productType) && (model.bookingSearchArrivalDate || model.bookedArrivalDate) || undefined,
            applyFilter: {
              date: {}
            }
          }
        },
        arrivalWindow: {
          mapping: {
            mapTo: model => canHaveUseDates(model.productType) ? 'eVar79' : undefined,
            defaultValue: model => {
              let arrival;
              if (canHaveUseDates(model.productType) && (arrival = model.useDate || model.bookingSearchArrivalDate || model.bookedArrivalDate) && (arrival = moment(arrival, ['MM/DD/YYYY', 'YYYY-MM-DD'])) && arrival.isValid()) {
                return '' + arrival.diff(moment().startOf('day'), 'days');
              }
            }
          }
        },
        useWindow: {
          mapping: {
            mapTo: model => canHaveUseDates(model.productType) ? 'useWindow' : undefined,
            defaultValue: 'notset'
          }
        },
        days: {
          mapping: {
            mapTo: model => 'days' + (isTicket(model.productType) ? ',ticketDays' : '')
          }
        },
        daysAndUseWindow: {
          mapping: {
            type: 'template',
            template: '{{#days}}{{{days}}}{{#useWindow}}:{{{useWindow}}}{{/useWindow}}{{/days}}{{^days}}{{#bookingSearchLengthOfStayNights}}{{{bookingSearchLengthOfStayNights}}}{{#useWindow}}:{{{useWindow}}}{{/useWindow}}{{/bookingSearchLengthOfStayNights}}{{/days}}',
            mapTo: 'eVar33,^^contextVars.daysAndUseWindow'
          }
        },
        bookedDaysAndUseWindow: {
          mapping: {
            type: 'template',
            template: '{{#confirmationNumber}}{{#days}}{{{days}}}{{#useWindow}}:{{{useWindow}}}{{/useWindow}}{{/days}}{{^days}}{{#bookedLengthOfStayNights}}{{{bookedLengthOfStayNights}}}{{#useWindow}}:{{{useWindow}}}{{/useWindow}}{{/bookedLengthOfStayNights}}{{/days}}{{/confirmationNumber}}',
            mapTo: 'eVar19,^^contextVars.bookedDaysAndUseWindow,^^tbi_eVar19'
          }
        },
        productInfo: {
          mapping: {
            type: 'template',
            template: '{{{parentId}}}:{{{availChannel}}}:{{{inventory}}}::{{{pricingCategory}}}',
            mapTo: model => model.productType === 'merch' ? 'eVar36' : undefined,
            transformers: {
              preProcess: model => {
                if (!model.parentId && model.productId) {
                  model.parentId = model.productId;
                }
                if (model.inventory && model.inventory.toLowerCase() === 'out of stock') {
                  model.availChannel = 'Not Available';
                }
              }
            }
          }
        },
        venues: {
          mapping: {
            type: 'flex-array',
            mapTo: '^^contextVars.venues'
          }
        },
        addOnDetail: {
          mapping: {
            type: 'flex-array',
            mapTo: 'eVar130',
            targetDelimiter: ':',
            preFilter: {
              replace: [[',|;|\\||:', '']]
            },
            transformers: {
              preProcess: (r, p, modelVal) => {
                if (Array.isArray(modelVal) && modelVal.length === 0) modelVal.push('Base');
              }
            }
          }
        },
        reservationDetail: {
          position: {
            mapping: {
              mapTo: '_reservationPosition',
              defaultValue: ({
                confirmationNumber
              }, parentModel, {
                stack
              }) => {
                const {
                  productType
                } = stack[stack.length - 3];
                return confirmationNumber && isReservation(productType) ? parentModel._reservation_index++ : undefined;
              }
            }
          },
          _sc_reservation_events: {
            mapping: {
              defaultValue: ({
                _reservationPosition,
                bookedPartyTotal,
                bookingSearchPartyTotal
              }) => {
                if (_reservationPosition) return `event295=1|event296=${bookedPartyTotal || bookingSearchPartyTotal || 0}`;
              }
            }
          },
          celebrations: {
            mapping: {
              type: 'flex-array',
              mapTo: '_celebration_events',
              valueDelimiter: '=',
              defaultElementValue: 1,
              targetDelimiter: '|',
              fallbackKey: 'event306',
              flexValueMap: {
                birthday: 'event298',
                honeymoon: 'event299',
                wedding: 'event300',
                anniversary: 'event301',
                firstvisit: 'event302',
                personaltriumph: 'event303',
                graduation: 'event304',
                reunion: 'event305'
              },
              eachTransformers: {
                normalizeKeyAndNumericValue: ({
                  key,
                  value
                }, {
                  mapping: {
                    defaultElementValue
                  }
                }) => ({
                  key: key.replace(/[^a-z]/gi, '').toLowerCase(),
                  value: isNaN(value) ? defaultElementValue : +value
                })
              },
              applyFilter: {
                consolidate: arr => {
                  const obj = arr.reduce((obj, {
                    key,
                    value
                  }) => {
                    obj[key] = (obj[key] ?? 0) + value;
                    return obj;
                  }, {});
                  return Object.entries(obj).map(([key, value]) => ({
                    key,
                    value
                  })).filter(({
                    value
                  }) => value > 0);
                },
                addSumEventAndSort: arr => [{
                  key: 'event297',
                  value: arr.reduce((p, {
                    value
                  }) => p + value, 0)
                }, ...arr.sort((a, b) => a.key < b.key ? -1 : 1)]
              }
            }
          },
          options: {
            mapping: {
              type: 'flex-array',
              mapTo: '_option_events',
              valueDelimiter: '=',
              defaultElementValue: 1,
              targetDelimiter: '|',
              flexValueMap: {
                checkinnotavailable: 'cina',
                checkinavailable: 'event307',
                checkincomplete: 'event308',
                paymentavailable: 'event309',
                paymentdueatcheckin: 'pdaci',
                paymentcomplete: 'event310',
                modificationavailable: 'event311'
              },
              eachTransformers: {
                normalizeKeyAndNumericValue: ({
                  key,
                  value
                }) => ({
                  key: key.replace(/[^a-z]/gi, '').toLowerCase(),
                  value: isNaN(value) ? 1 : +value
                })
              },
              applyFilter: {
                consolidate: arr => {
                  const obj = arr.reduce((obj, {
                    key,
                    value
                  }) => {
                    obj[key] = (obj[key] ?? 0) + value;
                    return obj;
                  }, {});
                  return Object.entries(obj).map(([key, value]) => ({
                    key,
                    value
                  })).filter(({
                    value
                  }) => value > 0);
                },
                sort: arr => arr.sort((a, b) => a.key < b.key ? -1 : 1)
              }
            }
          }
        },
        _sc_v135: {
          mapping: {
            mapTo: 'eVar135',
            defaultValue: ({
              _reservationPosition,
              _celebration_events,
              _option_events,
              _sc_reservation_events
            }) => {
              if (!_reservationPosition) return;
              const events = `${_celebration_events}|${_option_events}|${_sc_reservation_events}`;
              const val = event => {
                const value = (events.match(new RegExp('\\b' + event + '=([0-9]+)\\b')) || {})[1] || '0';
                return value === '0' ? 'z' : value;
              };
              return `${_reservationPosition}:${'event296,event307,event308,cina,event309,event310,pdaci,event311,event297,event298,event299,event300,event301,event302,event303,event304,event305,event306'.split(',').map(val).join(':')}`;
            }
          }
        },
        mapping: {
          type: 'template',
          template: model => {
            var tpl = '{{productType}};{{{productId}}}';
            if (model.productType !== 'eexp' && model.productType !== 'merch') {
              tpl += ':{{{facilityId}}}{{#portId}}_{{{portId}}}{{/portId}}:' + '{{{roomTypeId}}}{{^portId}}:{{{ticketId}}}{{/portId}}';
            }
            tpl += ';{{{quantity}}};' + '{{{totalPrice}}};' + '{{{eventsString}}};' + '{{{eVarString}}}';
            return tpl;
          },
          transformers: {
            //used to perform preliminary transformations without setting
            //a particular value to the model
            productDetails: (model, parentModel) => {
              if (parentModel.pageType === 'productDetails') {
                parentModel.contextData = parentModel.contextData || {};
                if (!parentModel.contextData['product.title']) {
                  parentModel.contextData['product.title'] = `${model.name}:${model.totalPrice}`;
                }
              }
            },
            preProcess: (model, parentModel) => {
              var ip, n /* , prop */;
              //for now we only expect 1 item in the included products (tickets)
              if (model.includedProducts && model.includedProducts.length > 0) {
                ip = model.includedProducts[0];
                for (n in ip) {
                  if (ip.hasOwnProperty(n)) {
                    model[n] = ip[n];
                  }
                }
              }
              /* there are a few variables we need outside of the product string, lets get them */
              if (parentModel.contextVars && parentModel.contextVars.paymentInfo) {
                model.eVar20 = parentModel.contextVars.paymentInfo;
              }

              /*
              if (model.productType === 'tix' && model.visualId) {
                  addTicketVisualIds(model, parentModel);
              }
              */
            },
            packageTicketDelta: model => {
              if (model.productType === 'res' && model.ticketDays && (model.bookedLengthOfStayNights || model.bookingSearchLengthOfStayNights)) {
                const los = +(model.bookedLengthOfStayNights || model.bookingSearchLengthOfStayNights);
                const tixDays = +model.ticketDays;
                return tixDays - los;
              }
            },
            finalPackageTicketDelta: (model, parentModel) => {
              if (typeof model.packageTicketDelta === 'number' && (parentModel.contextVars?.events?.includes?.('purchase') && parentModel.contextVars?.orderId || parentModel.contextVars?.events?.includes?.('modification'))) {
                return model.packageTicketDelta;
              }
            },
            ticketDaysQuantity: (model, parentModel) => {
              if (model.ticketDays && model.ticketQuantity && (parentModel.contextVars?.events?.includes?.('purchase') && parentModel.contextVars?.orderId || parentModel.contextVars?.events?.includes?.('modification'))) {
                return +model.ticketDays * +model.ticketQuantity;
              }
            },
            /**
             * transforms eVar properties in a model to a concatinated string.
             * Ex : an object with {'eVar1' : 'v12','eVar2' : 'v33' }
             * would become a string "eVar1=v12|eVar2=v33"
             */
            eVarString: (model, parentModel) => {
              var results = Object.entries(model).filter(([key, value]) => value && key.includes('eVar')).map(([key, value]) => [+key.replace(/\D/g, ''), value]);
              if (model.productType === 'res') {
                const val = typeof model.packageTicketDelta === 'number' ? model.packageTicketDelta : parentModel.contextVars?.offerId?.includes?.('phroom') ? 'Passholder' : 'RoomOnly';
                if (!parentModel.eVar133) parentModel.eVar133 = val;
                results.push([133, val]);
              }
              return results
              /* .sort(([akey], [bkey]) => akey - bkey) */.map(([key, value]) => `eVar${key}=${value}`).join('|');
            },
            //same concept as eVars but for events
            eventsString: (model, parentModel) => {
              const results = [],
                promoteEvent = event => {
                  //add event to main events string if it is not already there
                  if (!parentModel.events) {
                    parentModel.events = event;
                  } else if (!new RegExp('(^|,)' + event + '(,|=|$)').test(parentModel.events)) {
                    parentModel.events += ',' + event;
                  }
                  return event;
                };
              for (const [prop, val] of Object.entries(model)) {
                if (val && prop.includes('event')) {
                  // check if prop is literally 'events' this means that we have an event in the product object itself
                  if (/events$/.test(prop)) {
                    results.push(...val.split('|').filter(s => s.startsWith('event')));
                    // split the string to an array ('event44=1|event45=1' => ['event44', '1', 'event45', '1'])
                    const eventParts = val.split(/[|=]+/);
                    for (let i = 0, l = eventParts.length; i < l; i++) {
                      const part = eventParts[i];
                      if (part.includes('event')) promoteEvent(part);
                    }
                  } else {
                    results.push(prop + '=' + val);
                    promoteEvent(prop);
                  }
                }
              }
              if (parentModel.totalBookedLengthOfStayNights && (model.productType === 'prod' || model.productType === 'res')) {
                results.push(promoteEvent(parentModel.site?.toUpperCase?.() === 'DLR' ? 'event25' : 'event26') + '=' + parentModel.totalBookedLengthOfStayNights);
              }
              if (typeof model.finalPackageTicketDelta === 'number') {
                if (model.finalPackageTicketDelta < 0) {
                  results.push(promoteEvent('event89') + '=' + -model.finalPackageTicketDelta);
                } else {
                  results.push(promoteEvent('event88') + '=' + model.finalPackageTicketDelta);
                }
              }
              if (typeof model.ticketDaysQuantity === 'number') {
                results.push(promoteEvent(model.productType === 'res' ? 'event234' : 'event233') + '=' + model.ticketDaysQuantity);
              }
              return results.join('|');
            }
          }
        }
      }],
      _awv_products: {
        mapping: {
          defaultValue: a => a.products,
          mapTo: 'contextVars.&&products',
          type: 'flex-array',
          postFilter: {
            removeBlanksFromStr
          }
        }
      },
      productTotal: {
        mapping: {
          mapTo: 'contextVars.productTotal'
        }
      },
      productsDisplayedEvent: {
        mapping: {
          mapTo: 'contextVars.productsDisplayedEvent'
        }
      },
      productsDisplayed: [{
        productType: {
          mapping: {}
        },
        facilityId: {
          mapping: {}
        },
        roomTypeId: {
          mapping: {}
        },
        isAvailable: {
          mapping: {
            postFilter: {
              fmt: a => ({
                true: 'A',
                false: 'U'
              })[a]
            }
          }
        },
        productId: {
          mapping: {}
        },
        visualId: {
          mapping: {}
        },
        price: {
          mapping: {
            postFilter: {
              round: v => {
                if (typeof v === 'string') v = Number(v);
                if (typeof v === 'number' && !Number.isNaN(v)) return Math.round(v);
              }
            }
          }
        },
        order: {
          mapping: {}
        },
        offerId: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{productType}}:{{productId}}:{{facilityId}}:{{roomTypeId}}:{{visualId}}:{{isAvailable}}:{{price}}:{{order}}:{{offerId}}'
        }
      }],
      _awv_productsDisplayed: {
        mapping: {
          defaultValue: a => a.productsDisplayed,
          mapTo: 'contextVars.productsDisplayed',
          type: 'flex-array'
        }
      },
      _awv_productsDisplayedAvailable: {
        mapping: {
          mapTo: 'contextVars.productsDisplayedAvailable',
          defaultValue: m => {
            if (Array.isArray(m.productsDisplayed) && m.productsDisplayed.length > 0) {
              return m.productsDisplayed.filter(p => /:A:[^:]*:[^:]*:[^:]*$/.test(p)).length;
            }
          }
        }
      },
      _awv_productsDisplayedOffers: {
        mapping: {
          mapTo: 'contextVars.productsDisplayedOffers',
          defaultValue: m => {
            if (Array.isArray(m.productsDisplayed) && m.productsDisplayed.length > 0) {
              const count = m.productsDisplayed.filter(p => {
                const offerId = p.split(':')[8];
                return offerId && offerId !== 'NA';
              }).length;
              if (count > 0) return count;
            }
          }
        }
      },
      contentId: {
        mapping: {
          mapTo: 'contextVars.contentId'
        }
      },
      recommenderInfo: {
        conversationId: {
          mapping: {
            mapTo: 'contextVars.recommenderInfo_conversationId'
          }
        },
        messageId: {
          mapping: {
            mapTo: 'contextVars.recommenderInfo_messageId'
          }
        }
      },
      pageGroupId: {
        mapping: {
          mapTo: 'contextVars.pageGroupId'
        }
      },
      compareVacationNumber: {
        mapping: {
          mapTo: 'contextVars.compareVacationNumber'
        }
      },
      currencyDisplayed: {
        mapping: {
          mapTo: 'contextVars.currencyDisplayed'
        }
      },
      server: {
        mapping: {
          mapTo: 'contextVars.server'
        }
      },
      device: {
        type: {
          mapping: {
            mapTo: 'contextVars.device_type'
          }
        },
        viewType: {
          mapping: {
            mapTo: 'contextVars.device_viewType'
          }
        }
      },
      currentEntitlements: {
        mapping: {
          type: 'flex-array',
          mapTo: 'contextVars.currentEntitlements',
          flexValueMap: productTypeMap,
          postFilter: {
            alpha: 'asc',
            unique: ','
          }
        }
      },
      modificationType: {
        mapping: {
          mapTo: 'contextVars.modificationType'
        }
      },
      modificationDetail: {
        mapping: {
          mapTo: 'contextVars.modificationDetail'
        }
      },
      contentType: {
        mapping: {
          mapTo: 'contextVars.contentType'
        }
      },
      contentGroup: {
        mapping: {
          mapTo: 'contextVars.contentGroup'
        }
      },
      geo: {
        country: {
          mapping: {
            mapTo: 'contextVars.geo_country',
            applyFilter: {
              case: 'lower'
            }
          }
        }
      },
      personalizationId: {
        mapping: {
          mapTo: 'contextVars.personalizationId'
        }
      },
      shipping: {
        method: {
          mapping: {
            mapTo: 'contextVars.shipping_method',
            applyFilter: {
              replace: [[' ', '']]
            }
          }
        },
        price: {
          mapping: {
            mapTo: 'contextVars.shipping_price'
          }
        },
        time: {
          mapping: {
            mapTo: 'contextVars.shipping_time',
            applyFilter: {
              replace: [[' ', '']]
            }
          }
        }
      },
      intelligenceId: {
        test: {
          mapping: {
            mapTo: 'contextVars.intelligenceId_test'
          }
        },
        group: {
          mapping: {
            mapTo: 'contextVars.intelligenceId_group'
          }
        },
        recipe: {
          mapping: {
            mapTo: 'contextVars.intelligenceId_recipe'
          }
        }
      },
      guest: {
        uuid: {
          mapping: {
            mapTo: 'contextVars.guest_uuid'
          }
        }
      },
      recommendations: [{
        group: {
          mapping: {}
        },
        position: {
          mapping: {}
        },
        source: {
          mapping: {}
        },
        target: {
          mapping: {}
        },
        mapping: {
          type: 'template',
          template: '{{source}}:{{position}}:{{target}}:{{group}}'
        }
      }],
      _awv_recommendations: {
        mapping: {
          defaultValue: model => model.recommendations,
          mapTo: 'contextVars.recommendations',
          type: 'flex-array',
          postFilter: {
            removeBlanksFromStr
          }
        }
      },
      recommendationCount: {
        mapping: {
          mapTo: 'contextVars.recommendationCount',
          defaultValue: model => model.contextVars && model.contextVars.recommendations ? model.contextVars.recommendations.split(',').length : null
        }
      },
      _recommendationGroup: {
        mapping: {
          mapTo: 'contextVars.recommendationGroup',
          defaultValue: model => {
            if (model && model.contextVars && model.contextVars.recommendations) {
              return model.contextVars.recommendations.split(',')[0].split(':')[3];
            }
          }
        }
      },
      recommendationSource: {
        mapping: {
          mapTo: 'contextVars.recommendationSource'
        }
      },
      itemAvailability: {
        id: {
          mapping: {
            mapTo: '_itemAvail0,contextVars.itemAvailabilityName'
          }
        },
        total: {
          mapping: {
            mapTo: '_itemAvail2'
          }
        },
        intervals: [{
          name: {
            mapping: {}
          },
          value: {
            mapping: {}
          },
          mapping: {
            type: 'template',
            template: '{{name}}{{#value}}:{{value}}{{/value}}',
            rollUp: true,
            mapTo: '_itemAvail1',
            targetDelimiter: ';',
            transformers: {
              preProcess: result => {
                if (result && result.value === 0) result.value = '0'; // number 0 is falsey
              }
            }
          }
        }]
      },
      _awv_itemAvail: {
        mapping: {
          defaultValue: a => a._itemAvail1,
          mapTo: a => a._itemAvail0 && a._itemAvail1 ? 'contextVars.itemAvailability' : ''
        }
      },
      _awv_itemTotal: {
        mapping: {
          defaultValue: a => a._itemAvail2 || (a._itemAvail1 ? a._itemAvail1.split(';').reduce((p, c) => {
            let num = +c.split(':')[1];
            return p + (typeof num === 'number' && !isNaN(num) ? num : 0);
          }, 0) : null),
          mapTo: a => a._itemAvail0 && a._itemAvail1 ? 'contextVars.itemAvailabilityTotal' : ''
        }
      },
      _awv_temp_bookingInfo: {
        /* PRO-431031 */
        mapping: {
          mapTo: 'contextVars.bookingInfo',
          type: 'template',
          template: model => model.tbi_eVar16 || model.tbi_eVar17 || model.tbi_eVar18 || model.tbi_eVar19 ? '{{{tbi_eVar16}}}|{{{tbi_eVar17}}}|{{{tbi_eVar18}}}|{{{tbi_eVar19}}}' : ''
        }
      },
      timesPrefix: {
        mapping: {
          mapTo: 'contextVars.timesPrefix'
        }
      },
      times: {
        mapping: {
          type: 'flex-array',
          mapTo: 'contextVars.times'
        }
      },
      contentList: {
        mapping: {
          type: 'flex-array',
          mapTo: 'contextVars.contentList',
          preFilter: {
            replace: [[',', '']]
          }
        }
      },
      contentList2: {
        mapping: {
          type: 'flex-array',
          mapTo: 'contextVars.contentList2',
          preFilter: {
            replace: [[',', '']]
          }
        }
      },
      contentList3: {
        mapping: {
          type: 'flex-array',
          mapTo: 'contextVars.contentList3',
          preFilter: {
            replace: [[',', '']]
          }
        }
      },
      conversationId: {
        mapping: {
          mapTo: 'contextVars.conversationId'
        }
      },
      serviceFailure: {
        cidCount: {
          mapping: {
            mapTo: 'contextVars.serviceFailure_conversationIdCount'
          }
        },
        type: {
          mapping: {
            mapTo: 'contextVars.serviceFailure_type'
          }
        },
        category: {
          mapping: {
            mapTo: 'contextVars.serviceFailure_category'
          }
        },
        detail: {
          mapping: {
            mapTo: 'contextVars.serviceFailure_detail'
          }
        },
        sfCount: {
          mapping: {
            mapTo: 'contextVars.serviceFailure_count'
          }
        }
      },
      frameworkVersion: {
        mapping: {
          mapTo: 'contextVars.frameworkVersion'
        }
      },
      sessionQuality: {
        total: {
          mapping: {
            mapTo: 'contextVars.sessionQuality_total'
          }
        },
        increment: {
          mapping: {
            mapTo: 'contextVars.sessionQuality_increment'
          }
        }
      },
      upgradeCategory: {
        mapping: {}
      },
      upgradeSubcategory: {
        mapping: {}
      },
      _sc_v97: {
        mapping: {
          type: 'template',
          template: '{{upgradeCategory}}{{#upgradeCategory}}{{#upgradeSubcategory}}:{{/upgradeSubcategory}}{{/upgradeCategory}}{{upgradeSubcategory}}',
          mapTo: 'contextVars.upgradeCategorySubcategory'
        }
      },
      _awv_utmParameters: {
        mapping: {
          mapTo: 'contextVars.utmParameters',
          defaultValue: () => {
            const params = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
            const values = params.map(p => getURLParameter(p) || '');
            if (values.some(Boolean)) return values.join(':');
          }
        }
      }
    };
    function removeBlanksFromStr(val) {
      return typeof val !== 'string' ? val : val.split(',').filter(v => v).join(',');
    }
    function isTicket(productType) {
      return /^(?:tix|med|ndt|dtx)$/.test(productType);
    }
    function canHaveUseDates(productType) {
      return /^(?:tix|dtx|eexp|adm)$/.test(productType);
    }
    function isReservation(productType) {
      return /^(?:admission|annualPass|cruise|datedTicket|dining|enhancedExperience|event|resortVacation|ticket|trip)$/.test(productType);
    }
  }, 'Adapter:AdobeAnalyticsWV', 'moment', 'productTypeMap', 'getURLParameter');

  /* global Analytics */
  if (Analytics.mode === 'webview') {
    Analytics.wvbwin = {
      webkit: window.webkit,
      disneyRAWebViewBridge: window.disneyRAWebViewBridge,
      navigator: window.navigator,
      console: window.console
    };
    (function (window) {
      /*
      Responsible for communication between the web page and a native app
      To create an instance of the native bridge:
      var nativeBridge = window.disney.nativeBridgeFactory.createNativeBridge();
      */
      window.disney = window.disney || {};
      window.disney.util = function () {
        function getCookie(cookieName) {
          var COOKIE_PARSE_ERROR_MESSAGE = 'Error parsing cookie string: ';
          var name = cookieName + '=';
          var decodedCookie;
          var cookiesArray;
          try {
            decodedCookie = decodeURIComponent(document.cookie);
            cookiesArray = decodedCookie.split(';');
          } catch (error) {
            console.logRAError && console.logRAError(COOKIE_PARSE_ERROR_MESSAGE + error);
            return '';
          }
          for (var i = 0; i < cookiesArray.length; i++) {
            var cookie = cookiesArray[i];
            while (cookie.charAt(0) === ' ') {
              cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
              return cookie.substring(name.length, cookie.length);
            }
          }
          return '';
        }
        var service = {
          getCookie: getCookie
        };
        return service;
      }();
      window.disney.nativeBridge = function (options) {
        var READY_COMMAND_NAME = 'disneyRAWebViewBridgeReady';
        var ERROR_COMMAND_NAME = 'disneyRAWebViewBridgeError';
        var CLOSE_COMMAND_NAME = 'disneyRAWebViewBridgeClose';
        var platform = options.platform;

        // Exposed interface of this module
        var service = {
          sendCustomMessage: sendCustomMessage,
          sendReadyMessage: sendReadyMessage,
          sendErrorMessage: sendErrorMessage,
          sendCloseMessage: sendCloseMessage
        };
        return service;

        // ------------------------------------------------------------

        function constructMessage(commandName, params, sendFailedCallback) {
          var jsonMessage = {
            commandName: commandName,
            params: params,
            sendFailedCallback: sendFailedCallback
          };
          return jsonMessage;
        }
        function sendMessage(message) {
          if (message) {
            console.logRADebug && console.logRADebug('nativeBridge::sendMessage - message', message);

            // Pull out the failed callback so it doesn't get sent to the native app
            var sendFailedCallback = message.sendFailedCallback || function () {};
            delete message.sendFailedCallback;
            if (platform === 'ios') {
              // iOS - looking for WKWebview injected handler
              if (typeof window.webkit !== 'undefined') {
                try {
                  window.webkit.messageHandlers.disneyRAWebViewBridge.postMessage(message);
                } catch (e) {
                  console.logRAError && console.logRAError('iOS disneyRAWebViewBridge send failed: ', message);
                  sendFailedCallback(message.commandName, message.params, e);
                }
              } else {
                var error = new Error('Could not find window.webkit');
                sendFailedCallback(message.commandName, message.params, error);
              }
            } else if (platform === 'android') {
              // Android
              try {
                window.disneyRAWebViewBridge.postMessage(message.commandName, JSON.stringify(message.params), null);
              } catch (e) {
                console.logRAError && console.logRAError('Android disneyRAWebViewBridge send failed', message);
                sendFailedCallback(message.commandName, message.params, e);
              }
            } else if (platform === 'flutter') {
              // Flutter
              try {
                window.disneyRAWebViewBridge.postMessage(JSON.stringify(message));
              } catch (e) {
                console.logRAError && console.logRAError('Flutter disneyRAWebViewBridge send failed: ', message);
                sendFailedCallback(message.commandName, message.params, e);
              }
            }
          }
        }

        // Public Methods
        /*
        	Sends a custom message to the native app.
        		Parameter:
        		commandName: The identifier for the message
        		params: A JSON object of keys and values
        		sendFailedCallback: A closure that will be invoked if he message fails to send.
        			It will have 3 parameters: commandName, params, error
        */
        function sendCustomMessage(commandName, params, sendFailedCallback) {
          var message = constructMessage(commandName, params, sendFailedCallback);
          sendMessage(message);
        }

        /*
        	Sends a ready message to the native app.
        	This message is used to inform the native app that the web page is ready to receive commands
        		Parameter:
        		params: A JSON object of keys and values
        		sendFailedCallback: A closure that will be invoked if he message fails to send.
        			It will have 3 parameters: commandName, params, error
        */
        function sendReadyMessage(params, sendFailedCallback) {
          var message = constructMessage(READY_COMMAND_NAME, params, sendFailedCallback);
          sendMessage(message);
        }

        /*
        	Sends an error message to the native app.
        	This message is used to inform the native app that an error occurred on the web page.
        		Parameter:
        		params: A JSON object of keys and values
        		sendFailedCallback: A closure that will be invoked if he message fails to send.
        			It will have 3 parameters: commandName, params, error
        */
        function sendErrorMessage(params, sendFailedCallback) {
          var message = constructMessage(ERROR_COMMAND_NAME, params, sendFailedCallback);
          sendMessage(message);
        }

        /*
        	Sends a close message to the native app.
        	This message is used to inform the native app that the web page should be closed.
        		Parameter:
        		params: A JSON object of keys and values
        		sendFailedCallback: A closure that will be invoked if he message fails to send.
        			It will have 3 parameters: commandName, params, error
        */
        function sendCloseMessage(params, sendFailedCallback) {
          var message = constructMessage(CLOSE_COMMAND_NAME, params, sendFailedCallback);
          sendMessage(message);
        }
      };

      // User agent and client detection
      (function () {
        var DISNEY_USER_AGENT_PREFIX = 'DisneyRAWebView';
        var DISNEY_IOS_USER_AGENT = DISNEY_USER_AGENT_PREFIX + '/iOS';
        var DISNEY_ANDROID_USER_AGENT = DISNEY_USER_AGENT_PREFIX + '/Android';
        var DISNEY_FLUTTER_USER_AGENT = DISNEY_USER_AGENT_PREFIX + '/Flutter';
        function getUserAgent() {
          return window.navigator.userAgent;
        }
        window.disney.getUserAgent = getUserAgent;
        var userAgent = getUserAgent();
        window.disney.device = {
          platform: {
            ios: userAgent.indexOf(DISNEY_IOS_USER_AGENT) !== -1,
            android: userAgent.indexOf(DISNEY_ANDROID_USER_AGENT) !== -1,
            flutter: userAgent.indexOf(DISNEY_FLUTTER_USER_AGENT) !== -1
          },
          embedded: userAgent.indexOf(DISNEY_USER_AGENT_PREFIX) !== -1
        };
      })();
      window.disney.nativeBridgeFactory = function () {
        var USER_AGENT_MATCH = 'DisneyRAWebView\/([^\s]+)';
        var __originalConsole = window.console;
        function createNativeBridge() {
          var matches = window.disney.getUserAgent().match(USER_AGENT_MATCH);
          var platform;
          if (matches && matches.length > 1) {
            platform = matches[1].trim().toLowerCase();
          }
          var nativeBridge = new window.disney.nativeBridge({
            platform: platform
          });

          //Core plugins
          window.disney.plugins.logger(nativeBridge, __originalConsole);
          window.disney.plugins.webErrorLogger(nativeBridge, window);
          return nativeBridge;
        }
        return {
          createNativeBridge: createNativeBridge
        };
      }();

      // Load of environment data from static JSON file
      window.disney.loadEnvironmentData = function () {
        var ENV_COOKIE_NAME = 'envName';
        var DEFAULT_ENV_TO_LOAD = 'prd';
        var ENV_FILES_FOLDER_NAME = '/environments/';
        var ENV_FILES_EXTENSION = '.json';
        var LOAD_ERROR_MESSAGE = 'Error loading the environment JSON file: ';
        var PARSE_ERROR_MESSAGE = 'Error parsing the environment JSON file: ';
        var xhr;
        return function () {
          // Read env value from cookie, or default to production if not provided
          var envName = window.disney.util.getCookie(ENV_COOKIE_NAME) || DEFAULT_ENV_TO_LOAD;
          var envJsonFilePath = ENV_FILES_FOLDER_NAME + envName + ENV_FILES_EXTENSION;

          // Load the environment specific JSON file
          var response = {};
          xhr = new XMLHttpRequest();
          xhr.onload = handleLoadSuccess;
          xhr.onerror = handleLoadError;

          // Synchronous network call to make sure the env data is ready to be used when the web app's JS starts, and
          // not in the next event loop
          xhr.open('GET', envJsonFilePath, false);
          xhr.send();
          return response;
          function handleLoadSuccess() {
            if (xhr.readyState === 4 && xhr.status === 200) {
              try {
                response = JSON.parse(xhr.responseText);
              } catch (parsingError) {
                handleParseError(parsingError);
              }
            } else {
              handleLoadError();
            }
          }
          function handleLoadError() {
            console.logRAError && console.logRAError(LOAD_ERROR_MESSAGE + xhr.statusText);
          }
          function handleParseError(error) {
            console.logRAError && console.logRAError(PARSE_ERROR_MESSAGE + error);
          }
        };
      }();

      // Logger Plugin Overrides the console

      (function () {
        window.disney = window.disney || {};
        window.disney.plugins = window.disney.plugins || {};
        window.disney.plugins.logger = function (nativeBridge, console) {
          var DEBUG_COOKIE_NAME = 'enableNativeBridgeDebug';

          // Internal flags used for logging
          console._enableNativeLog = window.disney.device.embedded;
          console._enableDebugLog = window.disney.util.getCookie && !!window.disney.util.getCookie(DEBUG_COOKIE_NAME);

          // Enables native logging
          console.enableNativeLog = function (value) {
            console._enableNativeLog = value;
          };

          // Enables debug logging
          console.enableDebugLog = function (value) {
            console._enableDebugLog = value;
          };

          // Log RA JS Native Bridge errors to prevent calling bridge again.
          console.logRAError = function () {
            var nativeLoggingStatus = console._enableNativeLog;
            if (nativeLoggingStatus) {
              console._enableNativeLog = false;
            }
            var args = Array.prototype.slice.call(arguments);
            console.error.apply(console, args);
            console._enableNativeLog = nativeLoggingStatus;
          };

          // Log RA JS Native Bridge debug messages to prevent calling bridge again.
          console.logRADebug = function () {
            var nativeLoggingStatus = console._enableNativeLog;
            if (!console._enableDebugLog) {
              return;
            }
            if (nativeLoggingStatus) {
              console._enableNativeLog = false;
            }
            var args = Array.prototype.slice.call(arguments);
            console.debug.apply(console, args);
            console._enableNativeLog = nativeLoggingStatus;
          };

          // Intercepts the console methods and if native logger is enabled,
          // send the custom message using native bridge
          // LoggerPlugin is the plugin id and log is the handler registered in the native app.
          function intercept(method) {
            var original = console[method];
            console[method] = function () {
              var args = [].slice.call(arguments);
              if (console._enableNativeLog) {
                nativeBridge.sendCustomMessage('LoggerPlugin.log', {
                  level: method,
                  args: args
                });
              }
              original.apply(console, args);
            };
          }
          // Iterate through all the methods in console except custom Functions
          // and intercepts the method
          for (var method in console) {
            if (console.hasOwnProperty(method)) {
              if (method !== 'enableNativeLog' && method !== 'logRADebug' && method !== 'logRAError' && typeof console[method] === 'function') {
                intercept(method);
              }
            }
          }
        };
      })();

      // Intercepts https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror
      // and passes them to native bridge so the native app can collect errors thrown by
      // third - party JavaScript libraries.
      (function () {
        window.disney = window.disney || {};
        window.disney.plugins = window.disney.plugins || {};
        window.disney.plugins.webErrorLogger = function (nativeBridge, targetWindow) {
          var COOKIE_NAME = 'enableNativeBridgeDebug';
          var PLUGIN_ID = 'WebErrorLoggerPlugin';
          var PLUGIN_METHOD = 'log';
          var enableNativeWebErrorLogging = window.disney.util.getCookie && !!window.disney.util.getCookie(COOKIE_NAME);
          targetWindow.enableNativeWebErrorLogging = function (value) {
            enableNativeWebErrorLogging = value;
          };
          function intercept() {
            var original = targetWindow.onerror;
            targetWindow.onerror = function () {
              var args = Array.prototype.slice.call(arguments);
              if (enableNativeWebErrorLogging) {
                nativeBridge.sendCustomMessage(PLUGIN_ID + '.' + PLUGIN_METHOD, {
                  args: args
                });
              }
              if (original) {
                original.apply(targetWindow, args);
              }
            };
          }
          intercept();
        };
      })();
    })(Analytics.wvbwin);
  }

  /* global inject */
  /*
  Async resolver for customerId and registrationStatus.
  Inserted into the processUpdate Promise chain before processModel.
  
  Resolution priority (highest to lowest):
    1. Opt-out (usePageProvided) — skips entirely, keeps app-provided values
    2. Config.overrides.identity functions (sync or async)
    3. PEP Authenticator Universal Interface (window.PEP.PROFILE_AUTH)
    4. Cookie fallback (SWID + configurable high-trust cookie)
  
  Results are cached for the sync normalizer (customerIdentity) to use
  on trackElement/turnOn paths that don't go through processUpdate.
  */
  inject((store, getCookie, Config, iniBoolean) => {
    let cache = null;
    store('resolveCustomerIdentity', async model => {
      const identityConfig = model.configuration?.identity ?? {};
      if (await shouldUsePageProvided(identityConfig)) return model;
      let swid, highTrust, source;
      const overrides = Config.overrides?.identity;
      if (typeof overrides?.getCustomerId === 'function' || typeof overrides?.isHighTrust === 'function') {
        swid = typeof overrides.getCustomerId === 'function' ? await overrides.getCustomerId() : getCookie('SWID');
        highTrust = typeof overrides.isHighTrust === 'function' ? await overrides.isHighTrust() : resolveHighTrustCookie(identityConfig);
        source = 'o';
      } else if (window.PEP?.PROFILE_AUTH) {
        try {
          const [swidData, ht] = await Promise.all([window.PEP.PROFILE_AUTH.getSWIDAndToken(), window.PEP.PROFILE_AUTH.isHighTrust()]);
          swid = swidData?.swid;
          highTrust = ht;
          source = 'p';
        } catch {
          swid = getCookie('SWID');
          highTrust = resolveHighTrustCookie(identityConfig);
          source = 'c';
        }
      } else {
        swid = getCookie('SWID');
        highTrust = resolveHighTrustCookie(identityConfig);
        source = 'c';
      }
      model.customerId = swid || null;
      model.registrationStatus = highTrust ? 'Registered - Logged In' : typeof swid === 'string' && swid.startsWith('{') ? 'Registered - Not Logged In' : 'Not Registered';
      cache = {
        customerId: model.customerId,
        registrationStatus: model.registrationStatus,
        source
      };
      return model;
    });
    store('customerIdentityCache', () => cache);
    store('resetCustomerIdentityCache', () => {
      cache = null;
    });
    async function shouldUsePageProvided(identityConfig) {
      if ('usePageProvided' in identityConfig) return iniBoolean(identityConfig.usePageProvided, false);
      const val = Config.overrides?.identity?.usePageProvided;
      if (val !== undefined) return iniBoolean(typeof val === 'function' ? await val() : val, false);
      return Config.envProd;
    }
    function resolveHighTrustCookie(identityConfig) {
      const cookieName = identityConfig.highTrustCookie ?? Config.overrides?.identity?.highTrustCookie ?? 'authenticationSecure';
      return Boolean(getCookie(cookieName));
    }
  }, 'store', 'getCookie', 'Config', 'iniBoolean', 'Boolean');

  /* global inject */
  inject((store, Framework) => {
    store('addFrameworkVersion', model => {
      if (model.trackingType !== 'customLink') model.frameworkVersion = Framework.getVersion();
    });
  }, 'store', 'Framework');

  /* global inject */

  inject((isObject, store) => {
    store('complexToggles', ({
      toggleStatus: toggles
    }) => {
      /* converts complex toggles to string - example:
      {toggleStatus: {releaseToggles: {toggle1: {decision: true}}}}
      to
      {toggleStatus: {releaseToggles: {toggle1: 'true'}}}
      */
      if (isObject(toggles)) {
        for (const toggleTypeObj of Object.values(toggles)) {
          for (const [toggleKey, toggle] of Object.entries(toggleTypeObj)) {
            if (isObject(toggle) && typeof toggle.decision !== 'undefined') {
              toggleTypeObj[toggleKey] = toggle.decision.toString();
            }
          }
        }
      }
    });
  }, 'isObject', 'store');

  /* global inject */
  /*
  Lightweight sync normalizer that applies cached identity from the async resolver.
  Covers trackElement/turnOn paths that call normalize() directly without
  going through the processUpdate Promise chain.
  */
  inject((store, resolve, iniBoolean) => {
    store('customerIdentity', model => {
      if (iniBoolean(model.configuration?.identity?.usePageProvided)) return;
      const cache = resolve('customerIdentityCache')?.();
      if (cache) {
        model.customerId = cache.customerId;
        model.registrationStatus = cache.registrationStatus;
      }
    });
  }, 'store', 'resolve', 'iniBoolean');

  /* global inject */
  inject((store, ensureArray, moment) => {
    store('deriveDepartureDate', model => {
      makeDepartureDate(model);
      ensureArray(model.products).forEach(makeDepartureDate);
    });
    function makeDepartureDate(obj) {
      var arrival = obj.bookingSearchArrivalDate;
      var numNights = +obj.bookingSearchLengthOfStayNights;
      if (!obj.bookingSearchDepartureDate && arrival && numNights && (arrival = moment(arrival, ['MM/DD/YYYY', 'YYYY-MM-DD'])) && arrival.isValid()) {
        obj.bookingSearchDepartureDate = arrival.add(numNights, 'days').format('YYYY-MM-DD');
      }
    }
  }, 'store', 'ensureArray', 'moment');

  /* global inject */
  inject((store, netlog) => {
    store('DPIConfirmationPageFix', model => {
      if (model.configuration?.modelSpec === 'photopass' && model.pageId === 'Confirmation' && model.siteSection === 'Commerce') {
        model.events = 'purchase,pageView';
        netlog({
          app: 'JSAF',
          category: 'Normalize',
          action: 'DPIConfirmationPageEventsFix',
          sampling: 1 / 10
        });
      }
    });
  }, 'store', 'netlog');

  /* global inject */
  inject((store, isObject, objFirstProp, eventmap) => {
    store('events_n', model => {
      let {
        events
      } = model;
      const validEvents = Object.keys(eventmap);
      if (events) {
        if (typeof events === 'string') events = events.split(',');
        if (!Array.isArray(events)) events = [events];
        events = [].concat(...events.map(event => {
          if (isObject(event) && Object.keys(event).length > 1) {
            event = Object.keys(event).map(name => ({
              [name]: event[name]
            }));
          } else if (typeof event === 'string' && event.includes('=')) {
            const arr = event.split('=');
            event = {
              [arr[0]]: arr[1]
            };
          }
          return event;
        }));
        events = events.map(event => {
          const removeRedundancy = str => str.replace(/Event$/, '');
          const valid = prop => validEvents.includes(prop) ? prop : '';
          if (typeof event === 'string') {
            return valid(removeRedundancy(event));
          } else if (isObject(event)) {
            let prop = objFirstProp(event);
            let val = event[prop];
            prop = valid(removeRedundancy(prop));
            return prop ? {
              [prop]: val
            } : 0;
          } else {
            return 0;
          }
        }).filter(v => v);
        if (events.length === 0) {
          delete model.events;
        } else {
          model.events = events;
        }
      }
    });
  }, 'store', 'isObject', 'objFirstProp', 'eventmap');

  /* global inject */
  inject((isObject, Parsers, cleanArray, store) => {
    store('forceContentTestsArray', model => {
      if (model.contentTests) {
        if (isObject(model.contentTests)) {
          model.contentTests = Parsers.applyFilter(model.contentTests, {
            forceArray: ''
          });
        }
        model.contentTests = cleanArray(model.contentTests);
      }
    });
  }, 'isObject', 'Parsers', 'cleanArray', 'store');

  /* global inject */
  inject.store('getGenderfromTitle', model => {
    var genders = {
      'Mr.': 'M',
      'Ms.': 'F',
      'Miss.': 'F',
      'Mrs.': 'F',
      'Mstr.': 'M'
    };
    if (!model.gender && model.title && genders[model.title]) {
      model.gender = genders[model.title];
    }
  });

  /* global inject */
  inject.store('getOSfromUserAgent', model => {
    const userAgent = model.userAgent || window.navigator.userAgent;
    if (userAgent) {
      let result = '';
      const start = userAgent.indexOf('(');
      const end = userAgent.indexOf(')', start);
      if (start > -1 && end > -1) {
        result = userAgent.substring(start + 1, end);
      } else {
        result = userAgent;
      }
      if (result) model.osVersion = result;
    }
  });

  /* global inject */
  inject.store('itemAvailabilityValue', ({
    itemAvailability: {
      intervals = []
    } = {}
  } = {}) => {
    intervals.forEach(interval => {
      if (interval.available != null) {
        if (interval.value == null) interval.value = interval.available;
        delete interval.available;
      }
    });
  });

  /* global inject */
  /*
  Converts legacy paymentMethods object to current array style. Legacy:
      payment: {
          paymentAmount: '1234.98',
          paymentFrequency: 'Monthly',
          paymentMethods: {
              creditCardName: 'Visa',
              giftCardName: 'Gift Card',
              rewardsCardName: 'Disney Rewards Card',
              pointsPaymentName: 'DVC Points',
              instantCreditName: 'DVIC',
              digitalWalletName: 'Apple Pay'
          }
      }
  
  Converted to array style:
      payment: {
          paymentAmount: '1234.98',
          paymentFrequency: 'Monthly',
          paymentMethods: [{
              name: 'Visa',
              type: 'creditCard'
          }, {
              name: 'Gift Card',
              type: 'giftCard'
          }, {
              name: 'Disney Rewards Card',
              type: 'rewardsCard'
          }, {
              name: 'DVC Points',
              type: 'pointsPayment'
          }, {
              name: 'DVIC',
              type: 'instantCredit'
          }, {
              name: 'Apple Pay',
              type: 'digitalWallet'
          }]
      },
  */
  inject((store, isObject) => {
    store('legacyPaymentMethods', ({
      payment
    }) => {
      if (isObject(payment?.paymentMethods)) {
        const types = ['creditCard', 'giftCard', 'rewardsCard', 'pointsPayment', 'instantCredit', 'digitalWallet'];
        const oldMethods = payment.paymentMethods;
        payment.paymentMethods = [];
        types.forEach(type => {
          const name = oldMethods[`${type}Name`];
          if (name) payment.paymentMethods.push({
            name,
            type
          });
        });
      }
    });
  }, 'store', 'isObject');

  /* global inject */
  inject((store, moveProp, Config) => {
    store('moveNonConfig', model => {
      let props = ['contentLanguage', 'contentLocale', 'marketingRegion', 'currency'];
      if (model.configuration) {
        // move non-config properties to root if in config
        moveProp(model.configuration, props, model);

        // move corresponding product rules
        Object.keys(Config.products).forEach(product => {
          const rules = model.configuration[product] && model.configuration[product].rules;
          if (rules) {
            moveProp(rules, props.map(p => `configuration.${p}`), rules, props);
          }
        });
      }
    });
  }, 'store', 'moveProp', 'Config');

  /* global inject */
  // GO4-4931: Normalize offer structures to consistent object shape {offerName, ...}
  inject((store, isString) => {
    store('offerIdObject', model => {
      if (isString(model.offerId)) {
        model.offerId = {
          offerName: model.offerId
        };
      }
      if (model.products) {
        model.products.forEach(product => {
          if (isString(product.discountCode)) {
            product.discountCode = {
              offerName: product.discountCode
            };
          }
        });
      }
    });
  }, 'store', 'isString');

  /* global inject */
  inject((store, isObject, isString) => {
    store('offersShown_n', model => {
      let {
        offersShown
      } = model;
      if (isString(offersShown)) {
        offersShown = offersShown.split(',');
      } else if (isObject(offersShown)) {
        offersShown = [offersShown];
      }
      if (!Array.isArray(offersShown)) {
        delete model.offersShown;
        return;
      }
      model.offersShown = offersShown.map(offer => isString(offer) ? {
        id: offer
      } : offer);
    });
  }, 'store', 'isObject', 'isString');

  /* global inject */

  // Used to convert old Dart config format to the new one which utilizes an array of tags inside configuration.Dart.tags

  inject.store('oldFormatDartTagConversion', model => {
    const {
      Dart
    } = model.configuration || {};
    if (Dart) {
      const {
        advertiserId,
        groupTagString,
        activityTagString
      } = Dart;
      if (!Dart.tags && activityTagString && groupTagString) {
        Dart.tags = [{
          advertiserId,
          groupTagString,
          activityTagString
        }];
      }
      if (Array.isArray(Dart.conditionalTags)) {
        if (!Dart.tags) Dart.tags = [];
        Dart.conditionalTags.forEach(ctag => {
          Dart.tags.push(Object.assign({
            advertiserId,
            groupTagString,
            activityTagString
          }, ctag));
        });
      }
      delete Dart.conditionalTags;
    }
  });

  /* global inject */
  inject((isObject, Analytics, Parsers, cleanArray, store) => {
    store('p13nObject_n', model => {
      var personalizationId;
      if (model.personalizations) {
        if (isObject(model.personalizations)) {
          model.personalizations = Parsers.applyFilter(model.personalizations, {
            forceArray: ''
          });
        }
        model.personalizations = cleanArray(model.personalizations);
        model.personalizations.forEach(location => {
          if (location.vpcSegment) {
            model.vpcSegment = location.vpcSegment;
          }
        });
      }
      if (Analytics.getPersonalizationId) personalizationId = Analytics.getPersonalizationId(model);
      if (personalizationId) {
        model.personalizationId = personalizationId;
      }
    });
  }, 'isObject', 'Analytics', 'Parsers', 'cleanArray', 'store');

  /* global inject */
  /*
  Keeps `payment.paymentAmount` / `payment.paymentMethods[].paymentAmount` (and
  `currencyDisplayed` / `payment.paymentMethods[].currency`) in sync across the
  legacy and new data layer shapes so adapters that read either side work
  consistently.
  
  Legacy → new (so AEP and future adapters can rely on per-method values):
    - If no per-method `paymentAmount` is set and `payment.paymentAmount` is,
      copy the root total onto the first method.
    - If no per-method `currency` is set and `currencyDisplayed` is, copy the
      root currency onto the first method.
  
  New → legacy (so SiteCatalyst, CEA, etc. keep computing prop54 / pctPaid /
  data.payment-amount when teams adopt per-method values and stop emitting
  the legacy total):
    - If `payment.paymentAmount` is missing, sum the per-method numeric
      `paymentAmount` values and assign the total to the root.
    - Only fires when the root value is missing; if both sides are supplied
      we trust the data layer and do not validate the sum matches.
  */
  inject(store => {
    store('paymentMethodAmounts', model => {
      const methods = model?.payment?.paymentMethods;
      if (!Array.isArray(methods) || methods.length === 0) return;

      // Legacy → new
      if (methods.every(m => m.paymentAmount == null) && model.payment.paymentAmount != null) {
        methods[0].paymentAmount = model.payment.paymentAmount;
      }
      if (methods.every(m => m.currency == null) && model.currencyDisplayed) {
        methods[0].currency = model.currencyDisplayed;
      }

      // New → legacy
      if (model.payment.paymentAmount == null) {
        let total = 0;
        let hasAny = false;
        for (const m of methods) {
          const n = Number(m.paymentAmount);
          if (Number.isFinite(n)) {
            total += n;
            hasAny = true;
          }
        }
        if (hasAny) {
          model.payment.paymentAmount = total;
        }
      }
    });
  }, 'store');

  /* global inject */
  inject.store('populateAdditionalDataFromProducts', model => {
    let productTotal = 0;
    let productSubTotal = 0;
    let foundOfferId = model.offerId;
    if (Array.isArray(model.products)) {
      model.products.forEach(product => {
        if (!product || product.events?.includes?.('cartRemove')) return; // skip removed products

        if (product.price) {
          productTotal += product.price.total;
          productSubTotal += product.price.subTotal;
        }

        /* offerId can easily be confused as being part of a product so if its set for a resortVacation product and
           a top level offerId is not set then we'll set the top level offerId to the first offerId found in a
           resortVacation product. */
        if (!foundOfferId && product.productType === 'resortVacation' && product.offerId) {
          foundOfferId = model.offerId = product.offerId;
        }
      });
      model.productTotal = +productTotal.toFixed(2);
      model.productSubTotal = +productSubTotal.toFixed(2);
    }
  });

  /* global inject */
  inject((store, ensureArray, isObject, ensureNumber, isNumber) => {
    store('products_n', model => {
      let {
        products,
        productsDisplayed,
        failedProducts
      } = model;
      [products, productsDisplayed, failedProducts] = [products, productsDisplayed, failedProducts].map(arr => ensureArray(arr).filter(isObject));
      products.forEach(product => {
        fixPrice(product, 'price');
        fixPrice(product, 'previousPrice');
      });
      setPriceChangeStatus(products);
      connections(products);
      productsDisplayed.forEach(product => {
        fixPrice(product, 'stayPrice');
        flattenPriceObjectToTotal(product, 'price');
      });
      [products, productsDisplayed, failedProducts].forEach(propArr => {
        propArr.forEach(transitionCruisesToCruiseType);
      });
      function fixPrice(obj, propName) {
        const priceObj = obj[propName];
        if (isObject(priceObj)) {
          let {
            subTotal,
            tax,
            shipping,
            total
          } = priceObj;
          if ([subTotal, tax, shipping, total].some(v => v !== undefined)) {
            [subTotal, tax, shipping, total] = [subTotal, tax, shipping, total].map(ensureNumber);
            if (total > 0) {
              if (subTotal === 0) {
                subTotal = total - tax - shipping;
              } else {
                tax = total - shipping - subTotal;
              }
            } else if (subTotal > 0) {
              if (total === 0) {
                total = subTotal + tax + shipping;
              } else {
                tax = total - shipping - subTotal;
              }
            }
            obj[propName] = {
              subTotal,
              tax,
              shipping,
              total
            };
            return;
          }
        }
        delete obj[propName];
      }

      // productsDisplayed[].price is canonically a flat number; some apps send a
      // products[]-style price object (e.g. {total: 418} or {subTotal: 514.55}).
      // Run it through fixPrice to compute a full price object, then collapse to total.
      function flattenPriceObjectToTotal(obj, propName) {
        if (isObject(obj[propName])) {
          fixPrice(obj, propName);
          const fixed = obj[propName];
          if (isObject(fixed) && isNumber(fixed.total)) {
            obj[propName] = fixed.total;
          }
        }
      }
      function setPriceChangeStatus(products) {
        const changedProducts = products.filter(p => isNumber(p.previousPrice?.total) && isNumber(p.price?.total) && p.previousPrice.total !== p.price.total);
        if (changedProducts.length > 0) {
          const statusStr = changedProducts.find(product => product.changeStatus)?.changeStatus || 'PriceChange';
          setProductChangeStatus(changedProducts, statusStr);
          setProductChangeStatus(products, `No${statusStr}`);
        }
        function setProductChangeStatus(products, statusStr) {
          products.forEach(product => {
            if (!product.changeStatus) {
              product.changeStatus = statusStr;
            }
          });
        }
      }
      function transitionCruisesToCruiseType(product) {
        const {
          portId,
          bookingSearchDeparturePort,
          ship,
          sailingId
        } = product;
        if (portId || bookingSearchDeparturePort || ship || sailingId) {
          product.productType = 'cruise';
        }
      }
      function connections(products) {
        products.forEach(product => {
          product._numConnections = ensureArray(product.connectedRooms).filter(roomNumber => products.find(testProduct => testProduct.roomNumber === roomNumber)).length;
        });
        if (products.every(product => product._numConnections === 0)) {
          products.forEach(product => delete product._numConnections);
        }
      }
    });
  }, 'store', 'ensureArray', 'isObject', 'ensureNumber', 'isNumber');

  /* global inject */
  inject((isObject, store) => {
    store('removeExtraPersonalizationLocations', model => {
      const {
        personalizations
      } = model;
      if (!personalizations) return;
      if (Array.isArray(personalizations)) {
        model.personalizations = personalizations.map(setDefaultLocation).filter(shouldKeep);
      } else if (isObject(personalizations)) {
        model.personalizations = Object.fromEntries(Object.entries(personalizations).map(([key, p13n]) => [key, setDefaultLocation(p13n)]).filter(([, p13n]) => shouldKeep(p13n)));
      }
    });

    /**
     * Helper function to ensure each personalization object has
     * a locationType, defaulting to "default" if not set.
     */
    function setDefaultLocation(p13n) {
      p13n.locationType = p13n.locationType || 'default';
      return p13n;
    }

    /**
     * Helper function to determine if a personalization should be kept.
     * Instead of deciding when to remove, we decide what is worth keeping:
     * A personalization is kept if it does NOT have both:
     *   - locationType === "default"
     *   - no customerGroup
     *
     * So if it does have a `customerGroup`, or its `locationType` is
     * something other than "default", it is kept.
     */
    function shouldKeep({
      locationType,
      customerGroup
    }) {
      return locationType !== 'default' || customerGroup;
    }
  }, 'isObject', 'store');

  /* global inject */
  inject.store('removeLeadingTrailingSlashes', model => {
    if (model.pageId) model.pageId = rlts(String(model.pageId));
    if (model.siteSection) model.siteSection = rlts(model.siteSection);
    function rlts(val) {
      if (typeof val === 'string') {
        while (val[0] === '/') val = val.substr(1);
        while (val[val.length - 1] === '/') val = val.slice(0, -1);
      }
      return val;
    }
  });

  /* global inject */

  // Since the Analytics Post Processor for Configulator messes up outputing objects that use brackets we
  // decided to use dashes in place of dots (in products rules)
  // Example: foo.bar[baz.boo]=1 outputs to foo.bar[]=1 which is not what we want
  // so we went with the following: foo.bar.baz-boo=1

  inject((Config, store, moveProp) => {
    store('restoreProductRuleDots', model => {
      if (model.configuration) {
        Object.keys(Config.products).forEach(product => {
          const {
            rules
          } = model.configuration[product] || {};
          if (rules) {
            Object.keys(rules).forEach(rule => {
              if (rule.includes('-')) {
                moveProp(rules, rule, rules, rule.replace('-', '.'), true);
              }
            });
          }
        });
      }
    });
  }, 'Config', 'store', 'moveProp');

  /* global inject */
  inject.store('search_n', model => {
    let {
      search: {
        time: {
          start,
          end,
          duration
        } = {}
      } = {}
    } = model;
    [start, end, duration] = deriveTimesAndDuration(start, end, duration);
    if ([start, end, duration].some(v => v !== null)) {
      model.search.time = {
        start,
        end,
        duration
      };
    }

    /**
     * Simple time calculation function with no DST logic or mismatch validation.
     *
     * - If only 2 fields are provided, derive the 3rd:
     *    1) (startTime, endTime) => compute numHours
     *    2) (startTime, numHours) => compute endTime
     *    3) (endTime, numHours) => compute startTime
     * - If all 3 fields are provided, we trust the user’s input. No checks or overrides.
     * - If only 1 or 0 fields are provided, there's nothing to derive.
     *
     * @param {string|null} startTime - "HH:mm" or "HHmm" format, 24-hour
     * @param {string|null} endTime - "HH:mm" or "HHmm" format, 24-hour
     * @param {number|null} durationHours - numeric hours (can be fractional)
     * @returns [ string|null, string|null, number|null ]
     */
    function deriveTimesAndDuration(startTime, endTime, durationHours) {
      const MINUTES_PER_HOUR = 60;
      const HOURS_PER_DAY = 24;
      const MINUTES_PER_DAY = MINUTES_PER_HOUR * HOURS_PER_DAY;
      let startMinutes = toMinutesNum(startTime);
      let endMinutes = toMinutesNum(endTime);
      const hasStart = startMinutes !== null;
      const hasEnd = endMinutes !== null;
      let hasHours = typeof durationHours === 'number' && durationHours >= 0 && durationHours <= 24;

      // 1) If startTime and endTime are provided, compute numHours
      if (hasStart && hasEnd && !hasHours) {
        let diff = endMinutes - startMinutes;
        if (diff < 0) {
          // crossing midnight
          diff += MINUTES_PER_DAY;
        }
        durationHours = diff / MINUTES_PER_HOUR;
        hasHours = true;
      }

      // 2) If startTime and numHours are provided, compute endTime
      else if (hasStart && !hasEnd && hasHours) {
        endMinutes = startMinutes + Math.round(durationHours * MINUTES_PER_HOUR);
      }

      // 3) If endTime and numHours are provided, compute startTime
      else if (!hasStart && hasEnd && hasHours) {
        startMinutes = endMinutes - Math.round(durationHours * MINUTES_PER_HOUR);
      }
      return [toMilitaryTimeStr(startMinutes), toMilitaryTimeStr(endMinutes), hasHours ? durationHours : null];

      // Helper: parse "HH:mm" or "HHmm" into total minutes since midnight
      function toMinutesNum(timeStr) {
        if (!timeStr || typeof timeStr !== 'string') return null;
        const timeRegex = /^\s*(?<hours>[01][0-9]|2[0-3]):?(?<minutes>[0-5][0-9])\s*$/;
        const {
          hours,
          minutes
        } = timeRegex.exec(timeStr)?.groups || {};
        if (!hours || !minutes) return null;
        return Number(hours) * MINUTES_PER_HOUR + Number(minutes);
      }

      // Helper: convert total minutes back to "HHmm"
      function toMilitaryTimeStr(totalMinutes) {
        if (totalMinutes === null) return null;

        // Normalize so result is in [0..1439)
        totalMinutes = (totalMinutes % MINUTES_PER_DAY + MINUTES_PER_DAY) % MINUTES_PER_DAY;
        const hh = String(Math.floor(totalMinutes / MINUTES_PER_HOUR)).padStart(2, '0');
        const mm = String(totalMinutes % MINUTES_PER_HOUR).padStart(2, '0');
        return `${hh}${mm}`;
      }
    }
  });
  /* global inject */
  inject((store, sessionStorage) => {
    store('serviceFailureState', ({
      conversationId,
      serviceFailure
    }) => {
      if (conversationId && serviceFailure) {
        const key = 'af_sfstate';
        let state = sessionStorage.getItem(key) || {
          cidCount: 0
        };
        if (state.conversationId !== conversationId) {
          state.conversationId = conversationId;
          state.cidCount++;
          state.sfCount = 0;
        }
        state.sfCount++;
        serviceFailure.cidCount = state.cidCount;
        serviceFailure.sfCount = state.sfCount;
        sessionStorage.setItem(key, state);
      }
    });
  }, 'store', 'sessionStorage');

  /* global inject */
  inject((store, moveProp) => {
    store('updateConfigNames', ({
      configuration
    }) => {
      moveProp(configuration, 'WebsiteCustomAudiences', 'Facebook');
      moveProp(configuration, 'TestAndTarget', 'AdobeTarget');
      moveProp(configuration?.AdobeTarget, 'pluginClicktale', 'pluginContentsquare');
    });
  }, 'store', 'moveProp');

  /* global inject */
  /*
  Normalization of the data layer is good for:
    😀 populating computed values that apply across all sites
    😀 converting multiple allowed input formats into the canonical version (delimited string > array)
    😀 changing the model structure while maintaining backwards compatibility
  
  Normalization is 𝙉𝙊𝙏 for:
    😡 site-specific logic and fixes
    😡 DOM-based data (since that's unlikely to be future-proof nor consistent across all sites)
  */

  inject((resolve, store, publish) => {
    var normalizeFns;
    store('normalize', function normalize(model) {
      if (model) {
        publish({
          topic: 'model.beforeNormalize',
          model
        });
        normalizeFunctions().forEach(fn => fn(model));
        publish({
          topic: 'model.afterNormalize',
          model
        });
      }
    });
    function normalizeFunctions() {
      return normalizeFns || (normalizeFns = ['updateConfigNames', 'customerIdentity', 'events_n', 'products_n', 'oldFormatDartTagConversion', 'forceContentTestsArray', 'p13nObject_n', 'restoreProductRuleDots', 'moveNonConfig', 'getOSfromUserAgent', 'deriveDepartureDate', 'populateAdditionalDataFromProducts', 'getGenderfromTitle', 'DPIConfirmationPageFix', 'removeExtraPersonalizationLocations', 'complexToggles', 'removeLeadingTrailingSlashes', 'legacyPaymentMethods', 'paymentMethodAmounts', 'serviceFailureState', 'addFrameworkVersion', 'itemAvailabilityValue', 'offerIdObject', 'offersShown_n', 'search_n'].map(resolve));
    }
  }, 'resolve', 'store', 'publish');

  /* global inject */
  inject((Analytics, Framework, Config, $, Debug, Parsers, objForEach, store, resolve, normalize, convertPromise, mergeObjectsByKey, iniBoolean, fnApply, extend, clone, publish, asyncMethodQueue, namespace, isObject, ready, addScript, netlog, loadJson, fireEvent, querySelector, ref, flattenObj, passthrough) => {
    var parentModelRef;

    // GO4-6865: one-shot guard so the s_code + Disney Data Layer hybrid
    // deprecation warn fires at most once per page load, even across multiple
    // update() calls or SPA re-inits. Module-scoped on purpose (not on
    // Framework) so Framework.reset() does not clear it. Detection sentinel:
    // configuration.SiteCatalyst.parseModel === false.
    let parseModelFalseWarned = false;
    const pksrckey = '_pageKeySource';
    const twoCharRegionRegex = /^\/(au|ca|cn|de|en|es|fr|jp|kr|pt|sg)\//i;
    const fourCharRegionRegex = /^\/([a-z]{2})[-_]([a-z]{2})\//i;
    extend(Framework, {
      environment: 'PROD',
      modelQueue: [],
      mergeObjParams: ['namespace', 'storeType', 'site', 'contentLocale', 'contentLanguage', 'siteSection', 'pageId'],
      defaultProductIsOff: {},
      fireEvent,
      mergeModel,
      checkForAnalyticsData,
      reset,
      processModelQueue,
      update,
      getModels,
      resetModels,
      getParentModel,
      updateElement,
      trackPage,
      trackElement,
      addListener: deprecated('addListener'),
      genPageGroupId,
      getPageGroupId,
      disableEvent,
      enableEvent,
      isEventEnabled,
      getLibrary,
      getVersion,
      getAnalyticsModel,
      checkForModelSpec: deprecated('checkForModelSpec'),
      getPackageURL,
      loadModelSpec: deprecated('loadModelSpec'),
      processModel,
      start,
      getElementByIdOrSelector,
      turnOn
    });
    Framework.reset();
    store('productMap', productMap);
    publish({
      topic: 'framework.loaded',
      data: Framework,
      Framework
    });

    /* Generate a Random ID that can be used for SiteCatalyst & Dart Requests on this instance of the page */
    Framework.genPageGroupId();

    /* Save the default isOff state so it can be restored during reset() */
    objForEach(Config.products, (product, productName) => {
      if ('isOff' in product) {
        Framework.defaultProductIsOff[productName] = product.isOff;
      }
    });
    Framework.start();

    // ------------------------------------------------------------------- //

    // Do a deep merge of two model objects
    function mergeModel(updatedObj, existingObj) {
      var parsedModel = Parsers.mergeObjects(updatedObj, existingObj, Framework.mergeObjParams, false);
      return parsedModel;
    }
    function checkForAnalyticsData() {
      if (!Framework.pageHasAnalytics && document.querySelectorAll('[data-analytics]').length > 0) {
        Framework.pageHasAnalytics = true;
      }
      return Framework.pageHasAnalytics;
    }
    function reset() {
      publish({
        topic: 'framework.reset',
        Framework
      });
      if (Framework.baseModelPromise && Framework.baseModelPromise.state() === 'pending') Framework.baseModelPromise.reject();
      extend(Framework, {
        pageGroupId: false,
        analyticsModel: [],
        base64DecodedModel: false,
        baseModelProcessed: false,
        baseModelPromise: $.Deferred(),
        disabledEvents: [],
        flagDisableCustomLinks: false,
        modelSpec: Analytics.mode === 'web' ? false : 'default',
        pageHasAnalytics: false
      });
      parentModelRef = {};

      /* reset isOff to default state for all products */
      objForEach(Framework.defaultProductIsOff, (offState, productName) => {
        var product = Config.products[productName];
        if (product) {
          product.isOff = offState;
          fnApply(product.reset, product);
        }
      });
      setupBaseModelResolution();
    }
    function processModelQueue() {
      var model;
      publish({
        topic: 'framework.processModelQueue',
        Framework
      });
      if (Framework.modelQueue.length > 0) {
        model = extend(true, {}, ...Framework.modelQueue);
        Framework.modelQueue.length = 0;
        Framework.processModel(model);
      }
    }
    function isInteractiveElementsOnlyModel(model) {
      // Determines if the model is an interactiveElements model
      const keys = Object.keys(model);
      return keys.length === 1 && keys[0] === 'interactiveElements';
    }
    function isPartialModel(model) {
      // Determines if the model should be queued and bundled with the next page

      // definite partial model scenarios
      if (isInteractiveElementsOnlyModel(model)) return true;
      if (model.trackingType === 'partial') return true;

      // definite complete model scenarios
      if (model.configuration) return false;
      if (Config.configServiceLoadJson && model.pageKey) return false;

      // not definitely complete so partial
      return true;
    }

    /* Used for dynamicaly passing semantic models to the framework for processing */
    function update(model) {
      publish({
        topic: 'framework.update',
        model,
        Framework
      });
      if (!model) return false;

      // Clone the object to avoid changes to the model causing issues if the site maintains references
      model = clone(model);

      // Legacy backcompat: sites that pre-date the semantic datalayer still populate
      // window.s_wdpro.* inline and signal JSAF to skip its SiteCatalyst mapping via
      // { configuration: { SiteCatalyst: { parseModel: false } } }. Reverse-map the
      // legacy globals into a semantic model so non-SiteCatalyst adapters get a
      // populated base model, then strip parseModel so normal mapping runs on the
      // reconstructed model. See GO4-6736 and src/config/products/packages/default/SiteCatalystReverseMap.js.
      if (model.configuration && model.configuration.SiteCatalyst && model.configuration.SiteCatalyst.parseModel === false) {
        // GO4-6865: encourage teams to finish migrating off the legacy
        // s_code + Disney Data Layer hybrid pattern that this update()
        // call is a signature of (window.s_wdpro.* populated directly
        // against the Adobe s_code, then Framework.update({...parseModel:
        // false}) in place of s_wdpro.t()). Non-prod: one-shot console.warn
        // pointing at the migration guide. All envs (incl. prod, which
        // suppresses the warn): sample netlog so adoption of the migration
        // can be charted over time. Detection sentinel:
        // configuration.SiteCatalyst.parseModel === false.
        if (!parseModelFalseWarned && Config.envProd === false) {
          parseModelFalseWarned = true;
          // eslint-disable-next-line no-console
          console.warn('[JSAF] Deprecation: this page still ships the transitional s_code + ' + 'Disney Data Layer hybrid setup (window.s_wdpro.* populated directly, ' + 'followed by Framework.update({configuration:{SiteCatalyst:{parseModel:false}}}) ' + 'in place of s_wdpro.t()). That bridge was a short-term affordance more ' + 'than a decade ago for sites deferring the Data Layer migration; please ' + 'finish the migration to the semantic Disney Data Layer. ' + 'See https://disneyexperiences.atlassian.net/wiki/spaces/GO4/pages/455482531 (GO4-6865).');
        }
        netlog({
          app: 'JSAF',
          category: 'legacy_scode_hybrid_usage',
          action: 'update_called',
          error: new Error('legacy s_code + Data Layer hybrid usage (detected via configuration.SiteCatalyst.parseModel:false)'),
          sampling: 0.05
        });
        const reverseMap = resolve('SiteCatalyst.reverseMap');
        const reverseMapped = typeof reverseMap === 'function' ? reverseMap() : null;
        if (reverseMapped) {
          model = extend(true, {}, reverseMapped, model);
          delete model.configuration.SiteCatalyst.parseModel;
          publish({
            topic: 'framework.reverseMap',
            model,
            reverseMapped,
            Framework
          });
        }
      }
      if (Config.configServiceLoadJson && !isInteractiveElementsOnlyModel(model)) setPageKey(model);
      if (!Framework.baseModelProcessed && isPartialModel(model)) {
        // there is not a full model coming in. we'll add this to a queue
        Framework.modelQueue.push(model);
        return false;
      }
      if (Framework.baseModelPromise.state() === 'pending') {
        Framework.baseModelPromise.resolve(model);
      } else {
        processUpdate(model);
      }
      Debug.debug('update method called with semantic model: ', model);
    }

    /* Used to get an array of semantic models that were set. The first item in the array is always the main model */
    function getModels() {
      return Framework.analyticsModel;
    }
    function resetModels() {
      Framework.analyticsModel = [];
    }

    /* get the parent model */
    function getParentModel() {
      return parentModelRef;
    }
    function updateElement(selector, event, model) {
      publish({
        topic: 'framework.updateElement',
        selector,
        event,
        model,
        Framework
      });
      fireEvent({
        node: selector,
        event,
        data: model
      });
    }
    function trackElement(event, model) {
      if (arguments.length === 1 && typeof event !== 'string') {
        model = event;
        event = model.linkId || 'notset';
      }
      if (model && !model.trackingModel && !model.trackingType) model.trackingType = 'customLink';
      publish({
        topic: 'framework.trackElement',
        event,
        model,
        Framework
      });
      if (event === 'notset' && model.linkId) event = model.linkId;
      normalize(model);
      objForEach(Config.products, product => {
        if (product.trackElement) product.trackElement(event, clone(model));
      });
    }
    function trackPage(model = {}) {
      if (!model || !isObject(model)) return Debug.log('trackPage: model provided must an object');
      if (Framework.baseModelProcessed) Framework.reset();
      Framework.update(model);
    }
    function genPageGroupId(force) {
      if (force || !Framework.pageGroupId) {
        Framework.pageGroupId = `${resolve('getUTCTime')()}${resolve('randomInt')(100000, 999999)}`;
      }
      return Framework.pageGroupId;
    }
    function getPageGroupId() {
      return Framework.genPageGroupId();
    }

    /*
    * This should realy only be used for customEvents and not for a generic click event as unbind without a handler
    * reference will unbind all of that type of events, thus this is why this method is hard coded to not disable clicks
    *
    * Example of usage would be:
    * WDPRO.Analytics.Framework.disableEvent('facetTrack');
    */
    function disableEvent(event) {
      publish({
        topic: 'framework.disableEvent',
        event,
        Framework
      });
      if (event !== 'click' && isEventEnabled(event)) {
        Debug.info(`Adding ${event} to disabled events`);
        Framework.disabledEvents.push(event);
      }
    }
    function enableEvent(event) {
      publish({
        topic: 'framework.enableEvent',
        event,
        Framework
      });
      if (!isEventEnabled(event)) {
        Debug.info(`Removing ${event} from disabled events`);
        Framework.disabledEvents.splice(Framework.disabledEvents.indexOf(event), 1);
      }
    }
    function isEventEnabled(event) {
      publish({
        topic: 'framework.isEventEnabled',
        event,
        Framework
      });
      return !Framework.disabledEvents.includes(event);
    }
    function getLibrary() {
      publish({
        topic: 'framework.getLibrary',
        $,
        Framework
      });
      return {
        name: 'jQuery',
        version: $.jquery,
        ref: $
      };
    }
    function getVersion(includeTags = true) {
      const flags = [];
      if (includeTags) {
        if (document.querySelector('script[src*="go4.disney.go.com"],script[src$="/go4/"]')) flags.push('GO');
        if (document.querySelector('script[src*="otSDKStub.js"]')) flags.push(window.OneTrust || window.OneTrustStub || window.OnetrustActiveGroups ? '1T' : '1TB');
        const idSource = resolve('customerIdentityCache')?.()?.source;
        if (idSource) flags.push(`ID${idSource}`);
      }
      return `5.6.8${flags.sort().map(f => `-${f}`).join('')}`;
    }

    /**
     * getAnalyticsModel
     * Gets model from data-analytics attribute on an items on the page, parses it and stores it on Analytics.Framework.analyticsModel
     *
     * @return boolean true on success
     */
    function getAnalyticsModel() {
      var decodedModels,
        encodedModel,
        b64EncodedPattern = /^[a-z0-9/+]+[=]{0,2}$/i,
        decodedModel,
        parsedModel;
      publish({
        topic: 'framework.getAnalyticsModel',
        Framework
      });
      decodedModels = $('[data-analytics]').map(function () {
        try {
          encodedModel = $(this).attr('data-analytics');
          if (encodedModel) {
            if (b64EncodedPattern.test(encodedModel)) {
              decodedModel = atob(encodedModel);
              parsedModel = $.parseJSON(decodedModel);
            } else {
              Debug.error('Encoded analytics model contains invalid characters');
              if (encodedModel.length % 3 !== 0) {
                Debug.error('Encoded analytics model is not proper length, length should be divisible by 3');
              }
            }
            if (parsedModel) {
              return parsedModel;
            }
          }
        } catch (err) {
          Debug.log(encodedModel);
          Debug.error(`There was a problem while trying to decode the analytics model: ${err.toString()}`);
          Debug.log(decodedModel);
        }
      });
      if (!encodedModel) {
        return false;
      }
      // There should only ever be one encoded model on the page
      Framework.base64DecodedModel = decodedModels[0];
      return true;
    }
    function getPackageURL(packageName) {
      var basePath = Framework.modelSpecPathOverride && location.hostname === 'localhost' ? Framework.modelSpecPathOverride : Config.frameworkBase,
        data = {
          basePath,
          packageUrl: basePath ? `${basePath}/packages/${packageName}/${packageName}${Debug.isEnabled ? '' : '.min'}.js` : ''
        };
      publish({
        topic: 'framework.getPackageURL',
        data,
        Framework
      });
      return data.packageUrl;
    }
    function loadModelSpecScripts(model) {
      let packages;
      if (!Framework.modelSpec && (packages = model?.configuration?.modelSpec) && typeof packages === 'string' && (Framework.modelSpec = packages) && (packages = packages.split(',')) && packages.length > 0) {
        return Promise.allSettled(packages.map(getPackageURL).map(addScript)).then(() => model);
      } else {
        return Promise.resolve(model);
      }
    }

    /**
     * processModel
     * Processes model passed as param
     *
     * @return boolean true on success
     */
    function processModel(model) {
      Debug.log('processModel', model);
      var timeoutFire = [];
      publish({
        topic: 'framework.processModel',
        model,
        Framework
      });
      if (!isObject(model)) return false;
      Framework.analyticsModel.push(extend(Framework.analyticsModel.length === 0 ? parentModelRef : {}, model));
      normalize(model);
      model.pageGroupId = Framework.getPageGroupId();

      //Lets make sure the framework is not off
      publish({
        topic: 'model.checkEnabled',
        model
      });
      if (model.configuration && Parsers.toBoolean(model.configuration.turnOff)) return;

      /**
       * Populate the disabled events via disableEvents property in configuration object
       */
      if (model.configuration && Array.isArray(model.configuration.disabledEvents)) {
        model.configuration.disabledEvents.forEach(disableEvent);
      }
      Config.supportedProducts.forEach(pName => processProductRules(pName, model));
      publish({
        topic: 'model.beforeMapping',
        model
      });
      clone(Config.dependancies).forEach(dependency => {
        if (dependency.dependants) {
          dependency.dependants.forEach(child => {
            if (child.event) {
              if (Config.products[dependency.product].isOff === false || Config.products[child.product].isOff === false) {
                child.model = clone(model);
                if (Config.products[dependency.product].isOff === true && child.required === true && !child.timeout) {
                  child.event = 'parseModelComplete.framework';
                } else if (Config.products[dependency.product].isOff === true && child.required === true && child.timeout) {
                  child.event = `${child.product}_TimedEvent.framework`;
                  timeoutFire.push(child);
                }
                createBoundEvent(child);
              }
            }
          });
          if (dependency.immediate && !Config.products[dependency.product].isOff) {
            dependency.event = 'parseModelComplete.framework';
            dependency.model = clone(model);
            const ttimeout = ref(`model.configuration.${dependency.product}.triggerTimeout`, dependency);
            if (ttimeout) {
              dependency.timeout = parseInt(ttimeout, 10);
              dependency.event = `${dependency.product}_TimedEvent.framework`;
              timeoutFire.push(dependency);
            }
            createBoundEvent(dependency);
          }
        } else {
          dependency.event = 'parseModelComplete.framework';
          dependency.model = clone(model);
          const ttimeout = ref(`model.configuration.${dependency.product}.triggerTimeout`, dependency);
          if (ttimeout) {
            dependency.timeout = parseInt(ttimeout, 10);
            dependency.event = `${dependency.product}_TimedEvent.framework`;
            timeoutFire.push(dependency);
          }
          createBoundEvent(dependency);
        }
      });
      timeoutFire.forEach(tof => {
        createTimeout(tof.timeout, tof.event);
      });
      Framework.baseModelProcessed = true;
      fireEvent({
        event: 'parseModelComplete.framework',
        data: model
      });
      Framework.processModelQueue();
    }
    function createBoundEvent(child) {
      var newChild = clone(child);
      publish({
        topic: 'framework.createBoundEvent',
        child,
        newChild,
        Framework
      });
      $(document).one(newChild.event, newChild, function (event) {
        var product;
        publish({
          topic: 'product.boundEventTriggered',
          event
        });
        product = Config.products[event.data.product];
        if (product && typeof product.adapter === 'function') {
          product.adapter(event.data.model);
        }
      });
    }
    function createTimeout(timeout, event) {
      publish({
        topic: 'framework.createTimeout',
        timeout,
        event,
        Framework
      });
      setTimeout(function () {
        fireEvent({
          event
        });
      }, timeout);
    }

    /*
    * start
    * Parses and maps the semantic model received to the configurations for
    * each product and calls the adapters for each product
    */
    function start() {
      publish({
        topic: 'framework.start',
        Framework
      });
      asyncMethodQueue(namespace('DisneyDataLayer', []), Framework, {
        transform: cmd => isObject(cmd) ? ['trackPage', cmd] : cmd
      });
      ready(() => {
        if (Framework.getAnalyticsModel() === true) {
          Framework.update(Framework.base64DecodedModel);
        }
      });
    }

    // used to allow framework to accept either an id or a selector for elements
    function getElementByIdOrSelector(idOrSelector) {
      var element = document.getElementById(idOrSelector) || querySelector(idOrSelector);
      if (!element && (element = $(idOrSelector)[0])) {
        netlog({
          app: 'JSAF',
          category: 'jq_reduction',
          action: 'jq-specific selector',
          error: new Error(`unexpected jq selector: ${idOrSelector}`),
          sampling: 0.05
        });
      }
      return element;
    }
    function turnOn(productName, model) {
      var product = Config.products[productName] || {};
      model = model || Framework.getParentModel();
      publish({
        topic: 'framework.turnOn',
        model,
        productName,
        product,
        Framework
      });
      if (model && product.adapter) {
        normalize(model);
        fnApply(product.turnOn, product);

        // remove turnOff in the model product config
        if (model.configuration && model.configuration[productName]) {
          delete model.configuration[productName].turnOff;
        }
        product.adapter(model);
      }
    }
    function processUpdate(model) {
      publish({
        topic: 'framework.processUpdate',
        model,
        Framework
      });
      Promise.resolve(model).then(augmentWithConfigServiceData).then(loadModelSpecScripts).then(resolve('resolveCustomerIdentity')).then(processModel).catch(error => netlog({
        app: 'JSAF',
        category: 'framework.processUpdate',
        action: 'promise catch',
        error,
        model
      }));
    }
    function getRegionFromUrl(url = location) {
      const customRegion = window._satellite?.getVar?.('configServiceSplitRegionFromURL')?.(url);
      if (customRegion) return customRegion.region.toLowerCase();

      // Check if url contains four characer lang-locale code or two character country code
      const fourCharMatch = fourCharRegionRegex.exec(url.pathname);
      if (fourCharMatch) return `${fourCharMatch[1]}-${fourCharMatch[2]}`.toLowerCase();
      const twoCharMatch = twoCharRegionRegex.exec(url.pathname);
      if (twoCharMatch) return twoCharMatch[1].toLowerCase();
      return 'en';
    }
    function derivePageKeyFromPath(url = location) {
      let path = url.pathname;
      const customRegion = window._satellite?.getVar?.('configServiceSplitRegionFromURL')?.(url);
      if (customRegion) {
        path = customRegion.path;
      } else if (fourCharRegionRegex.test(path)) {
        // check for four character lang-locale
        path = path.slice(6);
      } else if (twoCharRegionRegex.test(path)) {
        // check for two character country code
        path = path.slice(3);
      }
      if (path === '/') return 'homepage';
      return replaceDynamicPathData(path.toLowerCase()).replace(/^\/{1,}|\/{1,}$/g, '') // remove leading and trailing forward slash
      .replace(/[^a-z0-9_./-]/g, '') // remove special characters
      .replace(/\/{1,}/g, '.'); // replace slashes with dots
    }
    function replaceDynamicPathData(path) {
      // removes most dynamic data from urls
      // set site-specific replacement fn in a TMS data element named 'customPageKeyReplaceDynamicPathData'
      const siteReplace = window._satellite?.getVar?.('customPageKeyReplaceDynamicPathData') ?? passthrough;
      return siteReplace(path).replace(/(\/blog\/)\d{4}\/\d\d\/.*/, '$1yyyy/mm/title').replace(/\/(?:\d{8,}|dd\d{18})(?=\/)/g, '/id').replace(/\/[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}(?=\/)/g, '/guid').replace(/\/\d\d\d\d-\d\d-\d\d(?=\/)/g, '/yyyy-mm-dd').replace(/(\/(?:min|emb)-)\d{10,}\/sites.*/, '$1id/sites-description').replace(/(\/reservation-)\d{8,}/, '$1id').replace(/(\/unsubscribe\/)[0-9a-f]{20,}/, '$1id').replace(/(\/news\/)\d+/, '$1id').replace(/\/[\d-]{6,}/, '/id').replace(/\/[dw][dfmw]\d{4,5}/g, '/sailing-id').replace(/\/mbdw\d{8}(?=\/)/g, '/mb-id').replace(/(\/question\/)[a-z-]*\d+/, '$1title').replace(/(\/swid\/)%7b[a-f0-9-]{20,}%7d/, '$1swid').replace(/(\/deck-plans\/)[a-z]+\/\d+\//, '$1ship/id/').replace(/(\/park-access\/)[a-z]{4}\d{10,}\/[0-9a-f]{20,}/, '$1id/id').replace(/(\/(?:dining|shopping|metaquest)_)\d{6,}\//, '$1id/').replace(/20\d\d[01]\d[0-3]\d-[012]\d[0-5]\d/g, 'yyyymmdd-hhmm');
    }
    function getPageKey(model) {
      return model.pageKey || setPageKey(model);
    }
    function setPageKey(model) {
      let pageKey;
      if (pageKey = model.pageKey) model[pksrckey] = 'model.pageKey';
      if (!pageKey && (pageKey = model.id)) model[pksrckey] = 'model.id';
      if (!pageKey && Config.pageKeyDomSelector && Config.pageKeyDomProperty && (pageKey = (querySelector(Config.pageKeyDomSelector) || {})[Config.pageKeyDomProperty])) model[pksrckey] = `dom (${Config.pageKeyDomSelector}|${Config.pageKeyDomProperty})`;
      if (!pageKey && (pageKey = derivePageKeyFromPath())) model[pksrckey] = 'derived-from-path';
      if (pageKey) model.pageKey = pageKey;
      return pageKey;
    }
    function getConfigSvcUrl({
      model
    }) {
      const pageKey = getPageKey(model);
      if (pageKey) return `${Config.configServiceBase}/${Config.site}/${Config.environment}/${Config.region || getRegionFromUrl()}/${pageKey}.json`;
    }
    function augmentWithConfigServiceData(model) {
      if (!Config.configServiceLoadJson) return model;
      const pageKey = model?.pageKey;
      return new Promise(resolve => {
        let url = getConfigSvcUrl({
          model
        });
        if (url) {
          const region = getRegionFromUrl();
          const missingFileLogs = [];
          loadJson({
            url
          }).then(baseModel => ({
            url,
            baseModel
          })).catch(error => {
            missingFileLogs.push({
              app: 'JSAF',
              category: 'CFGSVC',
              action: 'missing file',
              url,
              error,
              model,
              pageKey,
              region
            });
            const defaultUrl = getConfigSvcUrl({
              model: {
                pageKey: 'default'
              }
            });
            return loadJson({
              url: defaultUrl
            }).then(defaultBaseModel => ({
              url,
              defaultUrl,
              defaultBaseModel
            })).catch(error => {
              missingFileLogs.push({
                app: 'JSAF',
                category: 'CFGSVC',
                action: 'missing default file',
                url: defaultUrl,
                error,
                model,
                pageKey,
                region
              });
              return {
                url,
                defaultUrl
              };
            });
          }).then(({
            url,
            baseModel,
            defaultUrl,
            defaultBaseModel
          }) => {
            const {
              configuration: {
                configService: {
                  reportDiscrepancies = false,
                  usePageProvided = false,
                  discrepancySampling = Config.configServiceDiscrepancySampling,
                  missingFileSampling = Config.configServiceMissingFileSampling
                } = {}
              } = {}
            } = baseModel ?? defaultBaseModel ?? {};
            Config.configServiceDiscrepancySampling = discrepancySampling;
            Config.configServiceMissingFileSampling = missingFileSampling;
            missingFileLogs.forEach(log => netlog(Object.assign(log, {
              sampling: missingFileSampling
            })));
            if (reportDiscrepancies) {
              compareAndReport({
                model,
                url,
                baseModel,
                defaultUrl,
                defaultBaseModel
              });
            }
            return usePageProvided ? model : preferConfigServiceData(model, baseModel, defaultBaseModel);
          }).then(resolve);
        } else {
          netlog({
            app: 'JSAF',
            category: 'CFGSVC',
            action: 'no config service url',
            cfgSvcUrl: url,
            model,
            sampling: Config.configServiceMissingFileSampling
          });
          resolve(model);
        }
      });
    }
    function compareAndReport({
      model,
      url,
      baseModel,
      defaultUrl,
      defaultBaseModel
    }) {
      const report = [];
      const cfgSvcModel = baseModel || defaultBaseModel;
      const cfgSvcModelName = baseModel ? 'cfgPageModel' : 'cfgDefaultModel';
      const ignoreKeys = ['updatedAt', 'configuration.configService.reportDiscrepancies', 'configuration.configService.usePageProvided'];
      if (cfgSvcModel) {
        const cfgSvcModelProps = flattenObj(cfgSvcModel, true);
        const modelProps = flattenObj(model, true);
        for (const [key, cfgSvcValue] of Object.entries(cfgSvcModelProps)) {
          if (!ignoreKeys.includes(key)) {
            const pageValue = modelProps[key];
            if (!modelProps.hasOwnProperty(key)) {
              report.push({
                discrepancy: 'cfgSvc value not present in page model',
                action: 'delete',
                key,
                cfgSvcValue,
                cfgSvcValueType: typeof cfgSvcValue
              });
            } else if (pageValue !== cfgSvcValue) {
              report.push({
                discrepancy: 'value mismatch',
                action: 'update',
                key,
                pageValue,
                pageValueType: typeof pageValue,
                cfgSvcValue,
                cfgSvcValueType: typeof cfgSvcValue
              });
            }
          }
        }
        for (const [key, pageValue] of Object.entries(modelProps)) {
          if (key.startsWith('configuration.') && !cfgSvcModelProps.hasOwnProperty(key)) {
            report.push({
              discrepancy: 'cfgSvc missing entry present in page model',
              action: 'create',
              key,
              pageValue,
              pageValueType: typeof pageValue
            });
          }
        }
        if (report.length > 0) netlog({
          app: 'JSAF',
          category: 'CFGSVC',
          action: 'discrepancy report',
          site: Config.site,
          pageKey: model.pageKey,
          pageKeySrc: model[pksrckey],
          ...(url ? {
            url
          } : {}),
          ...(defaultUrl ? {
            defaultUrl
          } : {}),
          region: getRegionFromUrl(),
          discrepancies: report,
          cfgSvcModelName,
          sampling: Config.configServiceDiscrepancySampling
        });
      }
    }
    function preferConfigServiceData(model, baseModel, defaultBaseModel) {
      return Object.assign(model, baseModel || defaultBaseModel);
    }
    function setupBaseModelResolution(baseModel = Framework.baseModelPromise) {
      var dfds;
      publish({
        topic: 'framework.setupBaseModelResolution',
        baseModel,
        Framework
      });
      dfds = [baseModel].concat(Analytics.additionalModelData.map(convertPromise));
      Analytics.additionalModelData.length = 0;
      /* If Analytics.additionalModelData contains any promises this will wait until those
         promises are resolved before proceeding, if the array doesnt contain any promises it will
         just see those as all being resolved and proceed */
      return Framework.when = $.when.apply($, dfds).then(function (baseModel) {
        extendDataLayer(...arguments);
        if (Analytics.additionalModelData.length > 0) {
          // more data may have been added since
          return setupBaseModelResolution(baseModel);
        } else {
          processUpdate(baseModel);
          Debug.debug('Additional Data Promise Resolved');
        }
      }, function () {
        $.when(baseModel).then(function (baseModel) {
          processUpdate(baseModel);
          Debug.debug('Additional Data Promise Failed - continuing on without merging data');
        });
      });
    }
    function extendDataLayer(dataLayer, ...moreDataLayers) {
      publish({
        topic: 'framework.extendDataLayer',
        dataLayer,
        moreDataLayers,
        Framework
      });
      if (dataLayer.personalizations && !dataLayer.personalizations.length) {
        dataLayer.personalizations = Parsers.applyFilter(dataLayer.personalizations, {
          forceArray: ''
        });
      }
      moreDataLayers.forEach(nextDataLayer => {
        if (dataLayer.personalizations && nextDataLayer.personalizations) {
          mergeObjectsByKey('location', dataLayer.personalizations, nextDataLayer.personalizations, true);
          delete nextDataLayer.personalizations;
        }
        extend(true, dataLayer, nextDataLayer);
      });
      return dataLayer;
    }
    function processProductRules(productName, model) {
      var matchValue,
        rules,
        turnOff = false,
        productConfig,
        ruleValue;
      if (model.configuration && model.configuration[productName] && model.configuration[productName].rules) {
        productConfig = model.configuration[productName];
        rules = productConfig.rules;
        publish({
          topic: 'framework.processProductRules',
          model,
          productName,
          productConfig,
          rules,
          Framework
        });
        Object.keys(rules).forEach(rule => {
          if (!turnOff) {
            ruleValue = Parsers.parseDotNotation(model, rule);
            matchValue = rules[rule];

            // For the sake of keeping things simple, we'll only compare against simple strings
            if (typeof ruleValue === 'string') {
              if (typeof matchValue === 'string') {
                matchValue = matchValue.split(',');
              }
              if (Array.isArray(matchValue)) {
                turnOff = !matchValue.some(curVal => curVal.toLowerCase().includes(ruleValue.toLowerCase()));
              }
            } else if (typeof ruleValue === 'undefined' || ruleValue === null) {
              turnOff = true;
            }
          }
        });
      }
      if (turnOff) {
        // If any product utilizes any toggles then we need to update those toggles as well
        if (productConfig.dependantToggles) {
          objForEach(productConfig.dependantToggles, (depToggles, toggleType) => {
            if (model.toggleStatus && model.toggleStatus[toggleType]) {
              depToggles.forEach(depToggle => {
                if (model.toggleStatus[toggleType][depToggle]) {
                  model.toggleStatus[toggleType][depToggle] = false;
                }
              });
            }
          });
        }
        productConfig.turnOff = true;
      }
    }
    function productMap(product, productName, model, limitToModel) {
      var mappedModel, modelProductConfig, turnOff;
      publish({
        topic: 'framework.productMap',
        product,
        productName,
        model,
        Framework
      });
      if (product && model) {
        model.configuration = model.configuration || {};
        modelProductConfig = model.configuration[productName] || {};
        turnOff = iniBoolean(modelProductConfig.turnOff);

        // do not process if a particular product is turned off in the model
        if (!product.isOff && turnOff) {
          fnApply(product.turnOff, product);
          product.isOff = true;
          return;
        }
        if (product.isOff && turnOff === false) {
          fnApply(product.turnOn, product);
          product.isOff = false;
        }
        fnApply(product.validateEnabled, product, [model, modelProductConfig]);
        if (product.isOff) {
          return;
        }
        fnApply(product.init, product, [modelProductConfig]);
        if (product.adapter && product.mapping && (modelProductConfig.parseModel = iniBoolean(modelProductConfig.parseModel, true))) {
          mappedModel = Parsers.parseSemanticModel(model, product.mapping, limitToModel);
        }
      }
      return mappedModel || model;
    }
    function deprecated(msg) {
      return function () {
        netlog({
          app: 'JSAF',
          category: 'framework_deprecated_usage',
          action: msg,
          error: new Error(`Deprecated framework method usage: ${msg}`),
          sampling: 0.05
        });
      };
    }
  }, 'Analytics', 'Framework', 'Config', 'jQuery', 'Debug', 'Parsers', 'objForEach', 'store', 'resolve', 'normalize', 'convertPromise', 'mergeObjectsByKey', 'iniBoolean', 'fnApply', 'extend', 'clone', 'publish', 'asyncMethodQueue', 'namespace', 'isObject', 'ready', 'addScript', 'netlog', 'loadJson', 'fireEvent', 'querySelector', 'ref', 'flattenObj', v => v);
})(window, document, location);
//# sourceMappingURL=framework-bottom.js.map
